import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: any }> = { [K in keyof T]: T[K] };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  Hour: any;
  /** Image field */
  ImageField: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /** URL field */
  URL: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
};

/** The input values required to accept an open shift. */
export type AcceptOpenShiftInput = {
  /** The ID of the shift the core team member is accepting. */
  shiftId: Scalars['UUID'];
  /** The string date and time value for when the shift was last modified. */
  lastModifiedAt: Scalars['String'];
};

/** The output values from accepting an open shift. */
export type AcceptOpenShiftOutput = {
  __typename?: 'AcceptOpenShiftOutput';
  /** The attendance of the accepted shift. */
  attendance: ShiftAttendance;
};

/** TextChoices available for method by which a Stint can be accepted */
export enum AcceptanceMethod {
  MANUAL_ASSIGNMENT = 'MANUAL_ASSIGNMENT',
  MANUAL_OFFER = 'MANUAL_OFFER',
  STINT_MATCHER_OFFER = 'STINT_MATCHER_OFFER',
  WATERFALL_OFFER = 'WATERFALL_OFFER',
  STINT_MATCHER_TOP_UP_OFFER = 'STINT_MATCHER_TOP_UP_OFFER',
  REPEAT_STINTS_CAROUSEL = 'REPEAT_STINTS_CAROUSEL',
  REPEAT_STINTS_LIST = 'REPEAT_STINTS_LIST',
  ALL_STINTS_LIST = 'ALL_STINTS_LIST',
  ALL_STINTS_MAP = 'ALL_STINTS_MAP',
  TRAINED_STINTS_LIST = 'TRAINED_STINTS_LIST',
}

/** The actual hours breakdown for a labour metrics result week, extended with inline deviation fields for the Actual hours tab. */
export type ActualHoursBreakdown = {
  __typename?: 'ActualHoursBreakdown';
  /** The total hours across all shift categories for the week. */
  total: LabourMetricsWeekBreakdown;
  /** The hours attributable to service shifts for the week. */
  service: LabourMetricsWeekBreakdown;
  /** The deviation for rota service hours for the week. Values are signed: positive indicates over the baseline; negative indicates under. Planned rota (current scheduled) service hours - actual rota service hours. Always populated. Individual daily values are null when T&A records for the day are not all in an approved or rejected state. */
  serviceDeviation: LabourMetricsWeekBreakdown;
  /** The hours broken down by role configuration for the week. */
  roles: Array<RoleLabourMetricsBreakdown>;
  /** The per-role deviation values for the week. Values are signed: positive indicates over the baseline; negative indicates under. Planned rota (current scheduled) role hours - actual role hours. The client maps roleConfigurationId to operational area to aggregate FoH/BoH deviation rows. Always populated (may be empty when no roles are configured). */
  rolesDeviation: Array<RoleLabourMetricsBreakdown>;
  /** The hours attributable to external (training) shifts for the week. Null when allocating training cost to the primary site is disabled. */
  external?: Maybe<LabourMetricsWeekBreakdown>;
  /** The hours attributable to Stint shifts for the week. Null when workforce integration is disabled. */
  stint?: Maybe<LabourMetricsWeekBreakdown>;
  /** The deviation for Stint hours for the week. Values are signed: positive indicates over the baseline; negative indicates under. Planned rota (current scheduled) Stint hours - actual Stint hours. Null when workforce integration is disabled. Individual daily values are null when T&A records for the day are not all in an approved or rejected state. */
  stintDeviation?: Maybe<LabourMetricsWeekBreakdown>;
  /** The hours broken down by non-service shift type for the week. */
  nonServiceShifts: Array<NonServiceLabourMetricsBreakdown>;
};

/** Represents the count and display name of a particular item in the item breakdown of an ActualItem. */
export type ActualItemDetails = {
  __typename?: 'ActualItemDetails';
  /** The free text name of the item to be displayed in the UI. */
  itemType: Scalars['String'];
  /** The count of the item. */
  itemCount: Scalars['Int'];
};

/** The input values required from a client to add recommended site schedule shifts. */
export type AddRecommendedSiteScheduleShiftsInput = {
  /** The ID of the Site to associate with the shifts. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule to associate with the shifts. */
  siteScheduleId: Scalars['UUID'];
  /** The day of the week for the Schedule that the shifts are being added to. */
  dayOfWeek: WeekDay;
  /** The recommended Shifts to be added. */
  shifts: Array<ShiftInput>;
  /** The date and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** The output values returned to the client from the AddRecommendedSiteScheduleShifts mutation. */
export type AddRecommendedSiteScheduleShiftsOutput = {
  __typename?: 'AddRecommendedSiteScheduleShiftsOutput';
  /** The output values available to the client after adding shifts. */
  daySchedule: Schedule;
  /** The date and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** The input values required from a client to add a site schedule shift. */
export type AddSiteScheduleShiftInput = {
  /** The ID of the Site to associate with the shift. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule to associate with the shift. */
  siteScheduleId: Scalars['UUID'];
  /** The start time of the shift */
  startTime: Scalars['DateTime'];
  /** The end time of the shift. */
  endTime: Scalars['DateTime'];
  /** The PartnerMemberProfileId. Null if it's an open shift. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The optional role configuration ID for the shift. When provided, the shift will be associated with the specified role configuration. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** Flag indicating if this is a stint shift. */
  isStint: Scalars['Boolean'];
  /** The breaks scheduled for this shift. */
  shiftBreaks: Array<ShiftBreakInput>;
  /** Information on why the shift was added. */
  updateInfo?: Maybe<ScheduleShiftUpdateInfo>;
  /** The date and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
  /** The ID of the stint template (role) that this shift belongs to, if STINT type. */
  stintTemplateId?: Maybe<Scalars['UUID']>;
  /** The type of non-service shift. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** Whether the shift is being created using AI assistance. If null, assumed to be false. */
  aiAssisted?: Maybe<Scalars['Boolean']>;
  /** The optional instructions for the shift. */
  shiftInstructions?: Maybe<Scalars['String']>;
};

/** The output values returned to the client from the AddSiteScheduleShift mutation. */
export type AddSiteScheduleShiftOutput = {
  __typename?: 'AddSiteScheduleShiftOutput';
  /** The output values available to the client after adding a shift. */
  daySchedule: Schedule;
  /** The date and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
  /** The ID of the shift that was added. */
  shiftId: Scalars['UUID'];
};

/** The required input values for creating a StinterCommitment. */
export type AddStinterCommitmentInput = {
  /** The ID of the Stinter StintUser that will be associated to the created StinterCommitment. */
  stinterId: Scalars['UUID'];
  /**
   * The date on which this commitment starts.
   * The end date will be calculated by adding the numberOfWeeks to the startDate. This will result in a Sunday in X weeks
   * time.
   * This date must be a Monday!
   */
  startDate: Scalars['Date'];
  /**
   * The number of weeks that the commitment will cover.
   * This will be validated to ensure that it is greater than the min and less than the max required number of weeks.
   */
  numberOfWeeks: Scalars['Int'];
  /**
   * The number of Stints per week that the Stinter is committing to.
   * This will be validated to ensure that it is greater than the min and less than the max required number of Stints.
   */
  stintsPerWeek: Scalars['Int'];
  /**
   * The list of StintTemplate IDs to associate to this commitment via the StintTemplate's associated
   * StintTemplatePoolMember.
   * The primary list of StintTemplate IDs for which StintTemplatePoolMember will be visible as trial/regular Pool
   * member.
   * A Stinter cannot have more than 1 commitment per StintTemplate.
   * The commitment must be for at least one Role.
   * If the StintTemplate is not trained, this will be ignored from the list.
   */
  primaryStintTemplateIds: Array<Scalars['UUID']>;
  /**
   * The list of StintTemplate IDs to associate to this commitment via the StintTemplate's associated
   * StintTemplatePoolMember.
   * The secondary list of StintTemplate IDs for which StintTemplatePoolMember won't be visible as trial/regular Pool
   * member but still can accept Stints for the Pool.
   * A Stinter cannot have more than 1 commitment per StintTemplate.
   * If the StintTemplate is not trained, this will be ignored from the list.
   */
  secondaryStintTemplateIds?: Maybe<Array<Scalars['UUID']>>;
};

/**
 * The AddStintersToPartnerPoolInput class defines the input values that are required from the client in order to
 * add Stinters to a PartnerPool.
 */
export type AddStintersToPartnerPoolInput = {
  /** The ID of the PartnerPool to add Stinters to. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the PartnerPool belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The list of Stinter IDs to add to the PartnerPool. */
  stinterIds: Array<Scalars['UUID']>;
};

/**
 * The AddStintersToStintTemplatePoolInput class defines the input values that are required from the client for
 * adding Stinters to a StintTemplate object's Pool.
 */
export type AddStintersToStintTemplatePoolInput = {
  /** The ID of the StintTemplate whose Pool Stinters will be added to. */
  stintTemplateId: Scalars['UUID'];
  /** The ID of the PartnerNode that the StintTemplate belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The list of Stinter IDs to add to the StintTemplate's Pool. */
  stinterIds: Array<Scalars['UUID']>;
};

export type Address = {
  __typename?: 'Address';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  mapImage?: Maybe<Scalars['String']>;
  streetAndNumber?: Maybe<Scalars['String']>;
  streetAndNumber2?: Maybe<Scalars['String']>;
  isPrimaryContact: Scalars['Boolean'];
  isContact: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  cityFk?: Maybe<City>;
  countryFk?: Maybe<Country>;
  /** This field has been deprecated. */
  employerAddresses: Array<EmployerProfile>;
  /** The associated Stints. */
  stints: StintNodeTypeConnection;
  studentProfiles: Array<StudentProfile>;
  businessaddress: Array<Business>;
  /** Link to google map image for the address location. */
  mapUrl?: Maybe<Scalars['ImageField']>;
  /** Id of related City (auto-generated). */
  city_fk_id?: Maybe<Scalars['UUID']>;
  /** Id of related Country (auto-generated). */
  country_fk_id?: Maybe<Scalars['UUID']>;
};

export type AddressstintsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/**
 * Enum that contains the available error message codes that can be used to raise
 *     errors related to Address.
 */
export enum AddressError {
  INVALID_DISPLAY_NAME = 'INVALID_DISPLAY_NAME',
  INVALID_PLACE_ID = 'INVALID_PLACE_ID',
}

export type AddressFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** cityFk_id */
  cityFk_id?: Maybe<Scalars['UUID']>;
  /** cityFk_id_isnull */
  cityFk_id_isnull?: Maybe<Scalars['Boolean']>;
  /** countryFk_id */
  countryFk_id?: Maybe<Scalars['UUID']>;
  /** countryFk_id_isnull */
  countryFk_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  /** shortName_search */
  shortName_search?: Maybe<Scalars['String']>;
  /** shortName_gte */
  shortName_gte?: Maybe<Scalars['String']>;
  /** shortName_lte */
  shortName_lte?: Maybe<Scalars['String']>;
  /** shortName_istartswith */
  shortName_istartswith?: Maybe<Scalars['String']>;
  /** shortName_lt */
  shortName_lt?: Maybe<Scalars['String']>;
  /** shortName_gt */
  shortName_gt?: Maybe<Scalars['String']>;
  /** shortName_isnull */
  shortName_isnull?: Maybe<Scalars['Boolean']>;
  /** shortName_iendswith */
  shortName_iendswith?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  /** placeId_search */
  placeId_search?: Maybe<Scalars['String']>;
  /** placeId_gte */
  placeId_gte?: Maybe<Scalars['String']>;
  /** placeId_lte */
  placeId_lte?: Maybe<Scalars['String']>;
  /** placeId_istartswith */
  placeId_istartswith?: Maybe<Scalars['String']>;
  /** placeId_lt */
  placeId_lt?: Maybe<Scalars['String']>;
  /** placeId_gt */
  placeId_gt?: Maybe<Scalars['String']>;
  /** placeId_isnull */
  placeId_isnull?: Maybe<Scalars['Boolean']>;
  /** placeId_iendswith */
  placeId_iendswith?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  /** longitude_search */
  longitude_search?: Maybe<Scalars['String']>;
  /** longitude_gte */
  longitude_gte?: Maybe<Scalars['String']>;
  /** longitude_lte */
  longitude_lte?: Maybe<Scalars['String']>;
  /** longitude_istartswith */
  longitude_istartswith?: Maybe<Scalars['String']>;
  /** longitude_lt */
  longitude_lt?: Maybe<Scalars['String']>;
  /** longitude_gt */
  longitude_gt?: Maybe<Scalars['String']>;
  /** longitude_isnull */
  longitude_isnull?: Maybe<Scalars['Boolean']>;
  /** longitude_iendswith */
  longitude_iendswith?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  /** latitude_search */
  latitude_search?: Maybe<Scalars['String']>;
  /** latitude_gte */
  latitude_gte?: Maybe<Scalars['String']>;
  /** latitude_lte */
  latitude_lte?: Maybe<Scalars['String']>;
  /** latitude_istartswith */
  latitude_istartswith?: Maybe<Scalars['String']>;
  /** latitude_lt */
  latitude_lt?: Maybe<Scalars['String']>;
  /** latitude_gt */
  latitude_gt?: Maybe<Scalars['String']>;
  /** latitude_isnull */
  latitude_isnull?: Maybe<Scalars['Boolean']>;
  /** latitude_iendswith */
  latitude_iendswith?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  /** postalCode_search */
  postalCode_search?: Maybe<Scalars['String']>;
  /** postalCode_gte */
  postalCode_gte?: Maybe<Scalars['String']>;
  /** postalCode_lte */
  postalCode_lte?: Maybe<Scalars['String']>;
  /** postalCode_istartswith */
  postalCode_istartswith?: Maybe<Scalars['String']>;
  /** postalCode_lt */
  postalCode_lt?: Maybe<Scalars['String']>;
  /** postalCode_gt */
  postalCode_gt?: Maybe<Scalars['String']>;
  /** postalCode_isnull */
  postalCode_isnull?: Maybe<Scalars['Boolean']>;
  /** postalCode_iendswith */
  postalCode_iendswith?: Maybe<Scalars['String']>;
  streetAndNumber?: Maybe<Scalars['String']>;
  /** streetAndNumber_search */
  streetAndNumber_search?: Maybe<Scalars['String']>;
  /** streetAndNumber_gte */
  streetAndNumber_gte?: Maybe<Scalars['String']>;
  /** streetAndNumber_lte */
  streetAndNumber_lte?: Maybe<Scalars['String']>;
  /** streetAndNumber_istartswith */
  streetAndNumber_istartswith?: Maybe<Scalars['String']>;
  /** streetAndNumber_lt */
  streetAndNumber_lt?: Maybe<Scalars['String']>;
  /** streetAndNumber_gt */
  streetAndNumber_gt?: Maybe<Scalars['String']>;
  /** streetAndNumber_isnull */
  streetAndNumber_isnull?: Maybe<Scalars['Boolean']>;
  /** streetAndNumber_iendswith */
  streetAndNumber_iendswith?: Maybe<Scalars['String']>;
  streetAndNumber2?: Maybe<Scalars['String']>;
  /** streetAndNumber2_search */
  streetAndNumber2_search?: Maybe<Scalars['String']>;
  /** streetAndNumber2_gte */
  streetAndNumber2_gte?: Maybe<Scalars['String']>;
  /** streetAndNumber2_lte */
  streetAndNumber2_lte?: Maybe<Scalars['String']>;
  /** streetAndNumber2_istartswith */
  streetAndNumber2_istartswith?: Maybe<Scalars['String']>;
  /** streetAndNumber2_lt */
  streetAndNumber2_lt?: Maybe<Scalars['String']>;
  /** streetAndNumber2_gt */
  streetAndNumber2_gt?: Maybe<Scalars['String']>;
  /** streetAndNumber2_isnull */
  streetAndNumber2_isnull?: Maybe<Scalars['Boolean']>;
  /** streetAndNumber2_iendswith */
  streetAndNumber2_iendswith?: Maybe<Scalars['String']>;
  isPrimaryContact?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_gte */
  isPrimaryContact_gte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_lte */
  isPrimaryContact_lte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_istartswith */
  isPrimaryContact_istartswith?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_lt */
  isPrimaryContact_lt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_gt */
  isPrimaryContact_gt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_isnull */
  isPrimaryContact_isnull?: Maybe<Scalars['Boolean']>;
  /** isPrimaryContact_iendswith */
  isPrimaryContact_iendswith?: Maybe<Scalars['Boolean']>;
  isContact?: Maybe<Scalars['Boolean']>;
  /** isContact_gte */
  isContact_gte?: Maybe<Scalars['Boolean']>;
  /** isContact_lte */
  isContact_lte?: Maybe<Scalars['Boolean']>;
  /** isContact_istartswith */
  isContact_istartswith?: Maybe<Scalars['Boolean']>;
  /** isContact_lt */
  isContact_lt?: Maybe<Scalars['Boolean']>;
  /** isContact_gt */
  isContact_gt?: Maybe<Scalars['Boolean']>;
  /** isContact_isnull */
  isContact_isnull?: Maybe<Scalars['Boolean']>;
  /** isContact_iendswith */
  isContact_iendswith?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  /** city_search */
  city_search?: Maybe<Scalars['String']>;
  /** city_gte */
  city_gte?: Maybe<Scalars['String']>;
  /** city_lte */
  city_lte?: Maybe<Scalars['String']>;
  /** city_istartswith */
  city_istartswith?: Maybe<Scalars['String']>;
  /** city_lt */
  city_lt?: Maybe<Scalars['String']>;
  /** city_gt */
  city_gt?: Maybe<Scalars['String']>;
  /** city_isnull */
  city_isnull?: Maybe<Scalars['Boolean']>;
  /** city_iendswith */
  city_iendswith?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  /** country_search */
  country_search?: Maybe<Scalars['String']>;
  /** country_gte */
  country_gte?: Maybe<Scalars['String']>;
  /** country_lte */
  country_lte?: Maybe<Scalars['String']>;
  /** country_istartswith */
  country_istartswith?: Maybe<Scalars['String']>;
  /** country_lt */
  country_lt?: Maybe<Scalars['String']>;
  /** country_gt */
  country_gt?: Maybe<Scalars['String']>;
  /** country_isnull */
  country_isnull?: Maybe<Scalars['Boolean']>;
  /** country_iendswith */
  country_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  shortName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  placeId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  longitude_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  latitude_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  postalCode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  streetAndNumber_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  streetAndNumber2_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isPrimaryContact_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  isContact_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  city_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  country_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The AddressInput class defines the input values that are required from
 * the client in order to create or update a Address object.
 */
export type AddressInput = {
  /** The address display name provided by the user. */
  displayName: Scalars['String'];
  /** The Google place id for the Address object. */
  placeId: Scalars['String'];
};

/**
 * The AdminCreateAppealInput class defines the input values that are required from the
 * client in order to manually create an Appeal object from Admin.
 */
export type AdminCreateAppealInput = {
  /** The related Offence id for which the Appeal is being created. */
  offenceId: Scalars['UUID'];
  /** The AppealStatus value. */
  status: AppealStatus;
  /** The datetime value representing when the Appeal was made by the Stinter. */
  date: Scalars['DateTime'];
  /** Any notes related to the Appeal. */
  notes: Scalars['String'];
};

/**
 * The AgreementGraphqlType class defines the Graphene ObjectType class used to resolve the Agreement model
 * data for GraphQL queries.
 */
export type Agreement = {
  __typename?: 'Agreement';
  /** The ID of the Agreement. */
  id: Scalars['UUID'];
  /** The type of Agreement. */
  agreementType: AgreementType;
  /** Boolean to dictate whether or not to surface this Agreement to the relevant parties. */
  enabled: Scalars['Boolean'];
  /** The URL for a document related to the Agreement. This is nullable when the Agreement does not require an associated document. */
  documentUrl?: Maybe<Scalars['String']>;
  /** The ID of the related PartnerNode that the Agreement is directly assigned to. This is the PartnerNode that the Agreement is managed from. */
  primaryPartnerNodeId: Scalars['UUID'];
};

/**
 * Enum that contains the available error message codes that can be used to raise errors related to
 *     Agreement.
 */
export enum AgreementError {
  DUPLICATE_AGREEMENT_TYPE_PARTNER_NODE_ID = 'DUPLICATE_AGREEMENT_TYPE_PARTNER_NODE_ID',
  INVALID_NODE_TYPE = 'INVALID_NODE_TYPE',
}

/** The TextChoices for the Agreement.agreement_type field. */
export enum AgreementType {
  EMPLOYEE_DISCLAIMER = 'EMPLOYEE_DISCLAIMER',
  ON_SITE_TRAINING = 'ON_SITE_TRAINING',
}

export type AppLifecycleEvent = {
  __typename?: 'AppLifecycleEvent';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  createdBy?: Maybe<StintUser>;
  user: StintUser;
  business?: Maybe<Business>;
  eventType: AppLifecycleEventEventType;
  /** Id of related StintUser (auto-generated). */
  created_by_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  user_id?: Maybe<Scalars['UUID']>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
};

/** The TextChoices for the AppLifecycleEvent.event_type field. */
export enum AppLifecycleEventEventType {
  EVENT_APP_RESUME = 'EVENT_APP_RESUME',
  EVENT_APP_OPENED = 'EVENT_APP_OPENED',
  EVENT_APP_CLOSED = 'EVENT_APP_CLOSED',
  EVENT_APP_LOGIN = 'EVENT_APP_LOGIN',
  EVENT_APP_SWITCH_PROFILE = 'EVENT_APP_SWITCH_PROFILE',
}

/**
 * The TextChoices for the AppLifecycleEvent.event_type field.
 *
 *     This duplicate class is required to avoid a breaking change to the graph for the input types while doing the Django
 *     upgrade. Eventually these should be combined into one class again.
 */
export enum AppLifecycleEventEventTypes {
  EVENT_APP_RESUME = 'EVENT_APP_RESUME',
  EVENT_APP_OPENED = 'EVENT_APP_OPENED',
  EVENT_APP_CLOSED = 'EVENT_APP_CLOSED',
  EVENT_APP_LOGIN = 'EVENT_APP_LOGIN',
  EVENT_APP_SWITCH_PROFILE = 'EVENT_APP_SWITCH_PROFILE',
}

/**
 * The AppealType class defines the Graphene ObjectType class used to resolve the Appeal
 * model data for GraphQL queries.
 *
 * It has a UUIDNode interface so that list queries can use relay pagination.
 *
 * The id field is configured to return the Appeal.id value due to the fact that a UUIDNode by
 * default automatically generates it's own id value.
 */
export type Appeal = Node & {
  __typename?: 'Appeal';
  /** The ID of the Appeal. */
  id: Scalars['UUID'];
  /** The AppealStatus value that indicates the status for the Appeal. */
  status: AppealStatus;
  /** The date that the appeal is made by the Stinter. If the Appeal is not created by the Stinter in the app then the date is set by the internal user that captures the Appeal in admin while making the decision. */
  date: Scalars['DateTime'];
  /** Any notes supporting the decision of the Appeal. These can include supporting evidence from the Stinter or just a note from the internal user that made the decision. */
  notes?: Maybe<Scalars['String']>;
  /** The date that the decision was made about the Appeal. */
  decisionAt?: Maybe<Scalars['DateTime']>;
  /** The internal user that made the Appeal decision. */
  decisionBy?: Maybe<StintUser>;
};

/** The TextChoices for the Appeal.status field. */
export enum AppealStatus {
  PENDING = 'PENDING',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
  SUCCESSFUL = 'SUCCESSFUL',
}

/** The input values required from a client to apply a Schedule Labour Suggestion Option. */
export type ApplyScheduleLabourSuggestionOptionInput = {
  /** The ID of the Schedule Labour Suggestion to resolve. */
  scheduleLabourSuggestionId: Scalars['UUID'];
  /** The ID of the chosen Schedule Labour Suggestion Option to apply. */
  selectedOptionId: Scalars['UUID'];
  /** Used only for variant = ADD_OPEN_SHIFT; ignored for all other variants. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The role chosen by the GM in the role picker. Required by the BI service for ADD_ASSIGNED_SHIFT and ADD_OPEN_SHIFT variants; ignored for other variants (extend/trim/remove inherit the role from the existing target shift). */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
};

/** The output values returned to the client from the ApplyScheduleLabourSuggestionOption mutation. */
export type ApplyScheduleLabourSuggestionOptionOutput = {
  __typename?: 'ApplyScheduleLabourSuggestionOptionOutput';
  /** The updated day schedule reflecting the applied Schedule Labour Suggestion Option. */
  daySchedule: Schedule;
  /** The date and time the site schedule was last modified after the apply. */
  siteScheduleLastModifiedAt: Scalars['String'];
  /** Refreshed Schedule Labour Suggestions for one day across all operational areas, reflecting the new schedule state after the apply. */
  scheduleLabourSuggestions: Array<ScheduleLabourSuggestion>;
  /** Refreshed weekly Schedule Labour Suggestion counts reflecting the new schedule state after the apply. */
  scheduleLabourSuggestionCounts: WeeklyScheduleLabourSuggestionCounts;
};

/** The output values returned to the client from the ApplyScheduleLabourSuggestionOption mutation. */
export type ApplyScheduleLabourSuggestionOptionOutputscheduleLabourSuggestionsArgs = {
  siteScheduleId: Scalars['UUID'];
  date: Scalars['Date'];
};

/** The output values returned to the client from the ApplyScheduleLabourSuggestionOption mutation. */
export type ApplyScheduleLabourSuggestionOptionOutputscheduleLabourSuggestionCountsArgs = {
  siteScheduleId: Scalars['UUID'];
};

/** The input values required to approve an employee holiday request. */
export type ApproveEmployeeHolidayRequestInput = {
  /** The ID of the Partner Member Profile for whom the holiday is being approved. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the holiday request to approve. */
  holidayRequestId: Scalars['UUID'];
};

/** The output values from approving an employee holiday request. */
export type ApproveEmployeeHolidayRequestOutput = {
  __typename?: 'ApproveEmployeeHolidayRequestOutput';
  /** The holiday that was approved. */
  holiday: CoreTeamMemberHolidayRequest;
};

/** The input values required to approve an out-of-term request. */
export type ApproveOutOfTermRequestInput = {
  /** The ID of the out-of-term request to approve. */
  outOfTermRequestId: Scalars['UUID'];
};

/** The output type for the approveOutOfTermRequest mutation. */
export type ApproveOutOfTermRequestOutput = {
  __typename?: 'ApproveOutOfTermRequestOutput';
  /** The approved out-of-term request. */
  outOfTermRequest: OutOfTermRequest;
};

/** The input values required to approve a shift attendance. */
export type ApproveShiftAttendanceInput = {
  /** The ID of the Site where the shift took place. */
  siteId: Scalars['UUID'];
  /** The ID of the shift to approve attendance for. */
  shiftId: Scalars['UUID'];
};

/** The output values from approving a shift attendance. */
export type ApproveShiftAttendanceOutput = {
  __typename?: 'ApproveShiftAttendanceOutput';
  /** The approved shift attendance. */
  attendance: ShiftAttendance;
};

/**
 * This class defines the input values that are required from the client to approve Stinters
 * that are in a StintTemplates Pool.
 */
export type ApproveTrialStinterForStintTemplatePoolInput = {
  /** The ID of the PartnerNode that the StintTemplate belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The StintTemplatePoolMember ID of the Trial Stinter to approve for the StintTemplate's Pool. */
  stintTemplatePoolMemberId: Scalars['UUID'];
  /** The list of reason IDs for which the Trial Stinter is being approved for the StintTemplate's Pool. */
  reasons: Array<Scalars['UUID']>;
};

/** The input values required to approve a working preference request. */
export type ApproveWorkingPreferenceRequestInput = {
  /** The ID of the working preference request to approve. */
  workingPreferenceRequestId: Scalars['UUID'];
  /** The ID of the Partner Member Profile for whom the request is being approved. */
  partnerMemberProfileId: Scalars['UUID'];
};

/** The output values from approving a working preference request. */
export type ApproveWorkingPreferenceRequestOutput = {
  __typename?: 'ApproveWorkingPreferenceRequestOutput';
  /** The working preference request that was approved. */
  workingPreferenceRequest: WorkingPreferenceRequest;
  /** The dynamic working preference of the core team member that was approved. */
  coreTeamMemberDynamicWorkingPreferenceAtSite: CoreTeamMemberDynamicWorkingPreferenceAtSite;
};

/** The input values required to associate a holiday policy with a core team member. */
export type AssociateHolidayPolicyWithCoreTeamMemberInput = {
  /** The ID of the partner member profile for the core team member. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the holiday policy the core team member will be associated with. */
  employerHolidayPolicyId: Scalars['UUID'];
  /** The ID of the site node the user making the request has permission to set holiday policies at. */
  siteId?: Maybe<Scalars['UUID']>;
};

/** The output values from associating a holiday policy with a core team member. */
export type AssociateHolidayPolicyWithCoreTeamMemberOutput = {
  __typename?: 'AssociateHolidayPolicyWithCoreTeamMemberOutput';
  /** The holiday policy associated with the core team member. */
  policy: EmployerHolidayPolicy;
};

/** Output for authenticated on-demand pay access. */
export type AuthenticateOnDemandPayAccessOutput = {
  __typename?: 'AuthenticateOnDemandPayAccessOutput';
  /** The authenticated access token to initiate the on-demand pay flow. */
  accessToken: Scalars['String'];
};

/**
 * The AutoPostingInfo class defines the Graphene ObjectType class used to resolve information
 * about the auto-posting process and schedule.
 */
export type AutoPostingInfo = {
  __typename?: 'AutoPostingInfo';
  /** The date that Stints will next be auto-posted from. */
  nextAutoPostingDate?: Maybe<Scalars['Date']>;
  /** The number of weeks into the future that auto-posting is done. */
  numberOfWeeks?: Maybe<Scalars['Int']>;
};

/** A role in the Auto-Scheduler. */
export enum AutoScheduleRole {
  /** Represents a manager role in the Auto-Scheduler. */
  MANAGER = 'MANAGER',
  /** Represents a shift manager role in the Auto-Scheduler. */
  SHIFT_MANAGER = 'SHIFT_MANAGER',
  /** Represents a kitchen manager role in the Auto-Scheduler. */
  KITCHEN_MANAGER = 'KITCHEN_MANAGER',
  /** Represents a front of house team member role in the Auto-Scheduler. */
  FRONT_OF_HOUSE_TEAM_MEMBER = 'FRONT_OF_HOUSE_TEAM_MEMBER',
  /** Represents a back of house team member role in the Auto-Scheduler. */
  BACK_OF_HOUSE_TEAM_MEMBER = 'BACK_OF_HOUSE_TEAM_MEMBER',
  /** Represents a cleaner role in the Auto-Scheduler. */
  CLEANER = 'CLEANER',
  /** Represents a bar role in the Auto-Scheduler. */
  BAR = 'BAR',
  /** Represents a backliner role in the Auto-Scheduler. */
  BACKLINER = 'BACKLINER',
  /** Represents a broiler cook role in the Auto-Scheduler. */
  BROILER = 'BROILER',
  /** Represents a plancha cook role in the Auto-Scheduler. */
  PLANCHA = 'PLANCHA',
  /** Represents a fryer cook role in the Auto-Scheduler. */
  FRYER = 'FRYER',
  /** Represents a pit cook role in the Auto-Scheduler. */
  PIT = 'PIT',
  /** Represents a hot plate cook role in the Auto-Scheduler. */
  HOT_PLATE = 'HOT_PLATE',
  /** Represents a kitchen porter role in the Auto-Scheduler. */
  KITCHEN_PORTER = 'KITCHEN_PORTER',
  /** Represents an expo role in the Auto-Scheduler. */
  EXPO = 'EXPO',
  /** Represents a host role in the Auto-Scheduler. */
  HOST = 'HOST',
  /** Represents a cafe team member role in the Auto-Scheduler. */
  CAFE = 'CAFE',
  /** Represents a tandoor chef role in the Auto-Scheduler. */
  TANDOOR_CHEF = 'TANDOOR_CHEF',
  /** Represents a security role in the Auto-Scheduler. */
  SECURITY = 'SECURITY',
  /** Represents a bar back role in the Auto-Scheduler. */
  BAR_BACK = 'BAR_BACK',
  /** Represents a busser role in the Auto-Scheduler. */
  BUSSER = 'BUSSER',
  /** Represents a pizza chef role in the Auto-Scheduler. */
  PIZZA_CHEF = 'PIZZA_CHEF',
  /** Represents a support role in the Auto-Scheduler. */
  SUPPORT = 'SUPPORT',
  /** Represents a bar manager role in the Auto-Scheduler. */
  BAR_MANAGER = 'BAR_MANAGER',
  /** Represents a sandwich maker role in the Auto-Scheduler. */
  SANDWICH_MAKER = 'SANDWICH_MAKER',
}

/** Represents an auto scheduler custom rule for a Site and given week. */
export type AutoSchedulerCustomRule = {
  __typename?: 'AutoSchedulerCustomRule';
  /** The ID of the auto scheduler custom rule. */
  id: Scalars['UUID'];
  /** The ID of the site this custom rule belongs to. */
  siteId: Scalars['UUID'];
  /** The week commencing date this custom rule applies to. */
  weekCommencing: Scalars['Date'];
  /** The text content of the custom rule. */
  rule: Scalars['String'];
};

export type AvailabilityInput = {
  /** Date of availability. */
  date: Scalars['Date'];
  /** Selected hours student is available. */
  hours: Array<Maybe<Scalars['Hour']>>;
};

/** The availability status values for a PartnerMemberProfile. Indicates whether a member is available for work during a specific time period. */
export enum AvailabilityStatus {
  /** The PartnerMemberProfile is available for work. */
  AVAILABLE = 'AVAILABLE',
  /** The PartnerMemberProfile is on holiday. */
  ON_HOLIDAY = 'ON_HOLIDAY',
  /** The PartnerMemberProfile is absent. */
  ABSENT = 'ABSENT',
  /** The PartnerMemberProfile is currently on shift. */
  ON_SHIFT = 'ON_SHIFT',
}

/** The input values required to filter the list of available PartnerMemberProfiles. */
export type AvailablePartnerMemberProfilesFilterInput = {
  /**
   * Limit results to only those that fuzzy match the email.
   * If omitted, then all results will be returned.
   */
  email?: Maybe<Scalars['String']>;
  /**
   * Limit results to only those that fuzzy match the email.
   * If omitted, then all results will be returned.
   */
  fullname?: Maybe<Scalars['String']>;
};

/** The input values required to retrieve a list of available PartnerMemberProfiles. */
export type AvailablePartnerMemberProfilesInput = {
  /** The PartnerNode ID for which to request the list of available PartnerMemberProfiles. */
  partnerNodeId: Scalars['UUID'];
  /** The filtering criteria for the list of available PartnerMemberProfiles. */
  filterInput?: Maybe<AvailablePartnerMemberProfilesFilterInput>;
};

/** Represents a custom break rule for a partner account. */
export type BreakRule = {
  __typename?: 'BreakRule';
  /** The unique identifier for the break rule. */
  id: Scalars['UUID'];
  /** The locale this rule applies to. */
  localeCode: BreakRuleLocale;
  /** Whether this rule applies to young workers (under 18) rather than adults. */
  isYoungWorker: Scalars['Boolean'];
  /** The minimum shift duration, in minutes, at which the rule applies. Must be >= 0. */
  minimumShiftDurationMinutes: Scalars['Int'];
  /** The minimum break duration, in minutes, required for matching shifts. */
  minimumBreakDurationMinutes: Scalars['Int'];
};

/** The locale of a BreakRule. */
export enum BreakRuleLocale {
  /** The locale for the United Kingdom. */
  EN_GB = 'EN_GB',
  /** The locale for Jersey. */
  EN_JE = 'EN_JE',
  /** The locale for the Republic of Ireland. */
  EN_IE = 'EN_IE',
}

/** A BulkEmployeeUpload tracks a CSV upload of employees for bulk onboarding. */
export type BulkEmployeeUpload = {
  __typename?: 'BulkEmployeeUpload';
  id: Scalars['UUID'];
  /** The datetime value that is automatically captured when a new record is added to the database. */
  createdAt: Scalars['DateTime'];
  /** The console staff user who triggered the upload. */
  uploadedBy: StintUser;
  /** Original filename as provided by the client; displayed in Previous Uploads. */
  filename: Scalars['String'];
  /** The current status of the upload. */
  status: BulkEmployeeUploadStatus;
  /** Number of rows successfully created. Zero until status is SUCCESS or FAILED. */
  successCount: Scalars['Int'];
  /** Number of rows that failed creation. Zero until status is SUCCESS or FAILED. */
  failureCount: Scalars['Int'];
  /** A presigned URL for downloading the original uploaded CSV, valid for a limited time. */
  originalCsvPresignedUrl: Scalars['String'];
  /** A presigned URL for downloading the error CSV, valid for a limited time. Null when all rows succeeded. */
  errorCsvPresignedUrl?: Maybe<Scalars['String']>;
};

/**
 * The TextChoices for the BulkEmployeeUpload.status field.
 *
 *     PENDING -> PROCESSING -> SUCCESS | FAILED. SUCCESS and FAILED reflect whether the processing run
 *     completed, not whether every row succeeded - a completed run can still have a nonzero failure_count.
 *     FAILED is reserved for the processing run itself erroring out (e.g. unable to read the CSV).
 */
export enum BulkEmployeeUploadStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

/** GraphQL Type class for the Business. */
export type Business = {
  __typename?: 'Business';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  ltdName?: Maybe<Scalars['String']>;
  /** Defines which City the Business is active in and used to determine which base fee rates are used for calculating Stint costs. */
  city?: Maybe<City>;
  freeStints?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  isBlockedByFinance: Scalars['Boolean'];
  exemptFromPaymentDetails: Scalars['Boolean'];
  exemptFromPaymentDetailsAt?: Maybe<Scalars['DateTime']>;
  integrated: Scalars['Boolean'];
  unlockedLastMinuteStints: Scalars['Boolean'];
  /** Address of the business */
  address?: Maybe<Address>;
  owner?: Maybe<StintUser>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  branchCount?: Maybe<Scalars['Int']>;
  status: BusinessStatus;
  salesRepresentitive?: Maybe<StintUser>;
  accountManager?: Maybe<StintUser>;
  allowRampup: Scalars['Boolean'];
  businessType: BusinessBusinessType;
  qrCodeId: Scalars['UUID'];
  specialNotes?: Maybe<Scalars['String']>;
  internalRanking?: Maybe<Scalars['Int']>;
  onboardingRanking?: Maybe<Scalars['Int']>;
  preferredPaymentMethod: BusinessPreferredPaymentMethod;
  createdBy?: Maybe<BusinessCreatedBy>;
  controlCheck: Scalars['Boolean'];
  /** Whether or not the repeat Stinters feature is enabled for the business. */
  repeatStintersEnabled: Scalars['Boolean'];
  /** Deprecated. Use the related NodeType.SITE PartnerNode name field instead. This field is updated when the NodeType.SITE PartnerNode name value is updated and should no longer be updated in any other way. */
  name: Scalars['String'];
  creditControl: Array<BusinessCreditControlEvent>;
  /** Stints for the business. */
  stints?: Maybe<Array<Maybe<Stint>>>;
  /** Business logo url. */
  logo?: Maybe<Scalars['ImageField']>;
  /** The average rating of the business (ratings given to the business from the students). */
  averageRating?: Maybe<Scalars['Float']>;
  /**
   * Place id of an address related to business.
   * @deprecated Drop in favor of Address.placeId
   */
  placeId?: Maybe<Scalars['String']>;
  /**
   * Display name of an address related to business.
   * @deprecated Drop in favor of Address.name
   */
  displayAddress?: Maybe<Scalars['String']>;
  stintopedia?: Maybe<Stintopedia>;
  /** Returns true if payment details are blocked on business. */
  isPaymentDetailsBlocked?: Maybe<Scalars['Boolean']>;
  /** Query with date range to determine if the busines is allowed to post a Stint. */
  canPostStint?: Maybe<BusinessCanPostStintMessageType>;
  /** Stint week templates for the business. */
  stintWeekTemplates?: Maybe<Array<Maybe<StintWeekTemplate>>>;
  /** Stint templates for the business. */
  stintTemplates?: Maybe<Array<Maybe<StintTemplate>>>;
  /** Base rate override for the business. */
  rateOverride?: Maybe<RateOverride>;
  /** Effective current business rate. */
  rate?: Maybe<Scalars['Decimal']>;
  /** Returns true if the Business does not have a saved Address. */
  isAddressBlocked?: Maybe<Scalars['Boolean']>;
  /** Rates/Fees charged to the Business. */
  rates: BusinessRatesType;
  /** The auto-posting information associated with this Business. */
  autoPostingInfo?: Maybe<AutoPostingInfo>;
  /** Deprecated. Stubbed response. */
  permissionsGroup?: Maybe<Group>;
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
  /** Id of related Address (auto-generated). */
  address_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  owner_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  sales_representitive_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  account_manager_id?: Maybe<Scalars['UUID']>;
};

/** GraphQL Type class for the Business. */
export type BusinesscanPostStintArgs = {
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
};

export enum BusinessBusinessType {
  /** Business */
  BUSINESS = 'BUSINESS',
  /** Individual */
  INDIVIDUAL = 'INDIVIDUAL',
}

export type BusinessCanPostStintMessageType = {
  __typename?: 'BusinessCanPostStintMessageType';
  /** Whether the given business is allowed to post a Stint or not. */
  canPostStint?: Maybe<Scalars['Boolean']>;
  /** Type of error. */
  errorType?: Maybe<Scalars['String']>;
  /** Error title to be displayed in client. */
  title?: Maybe<Scalars['String']>;
  /** Error message to be displayed in client. */
  message?: Maybe<Scalars['String']>;
};

export enum BusinessCreatedBy {
  /** Business onboarding service */
  BUSINESS_ONBOARDING_API = 'BUSINESS_ONBOARDING_API',
}

export type BusinessCreditControlEvent = {
  __typename?: 'BusinessCreditControlEvent';
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  business?: Maybe<Business>;
  controlType?: Maybe<BusinessCreditControlEventControlType>;
  duration?: Maybe<Scalars['Int']>;
  dateBlocked?: Maybe<Scalars['String']>;
  dateUnblocked?: Maybe<Scalars['String']>;
  blockedBy?: Maybe<StintUser>;
  unblockedBy?: Maybe<StintUser>;
  /** Id of related StintUser (auto-generated). */
  created_by_id?: Maybe<Scalars['UUID']>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
};

export enum BusinessCreditControlEventControlType {
  /** Blocked */
  BLOCKED = 'BLOCKED',
  /** Unblocked */
  UNBLOCKED = 'UNBLOCKED',
}

export type BusinessCreditControlEventFilter = {
  controlType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** createdBy_id */
  createdBy_id?: Maybe<Scalars['UUID']>;
  /** createdBy_id_isnull */
  createdBy_id_isnull?: Maybe<Scalars['Boolean']>;
  /** eventPtr_id */
  eventPtr_id?: Maybe<Scalars['UUID']>;
  /** eventPtr_id_isnull */
  eventPtr_id_isnull?: Maybe<Scalars['Boolean']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** controlType_search */
  controlType_search?: Maybe<Scalars['String']>;
  /** controlType_gte */
  controlType_gte?: Maybe<Scalars['String']>;
  /** controlType_lte */
  controlType_lte?: Maybe<Scalars['String']>;
  /** controlType_istartswith */
  controlType_istartswith?: Maybe<Scalars['String']>;
  /** controlType_lt */
  controlType_lt?: Maybe<Scalars['String']>;
  /** controlType_gt */
  controlType_gt?: Maybe<Scalars['String']>;
  /** controlType_isnull */
  controlType_isnull?: Maybe<Scalars['Boolean']>;
  /** controlType_iendswith */
  controlType_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  controlType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Enum of a business discount badge */
export enum BusinessDiscountBadge {
  PIZZA_EXPRESS = 'PIZZA_EXPRESS',
}

/** Enum that contains the available error message codes that can be used to raise errors related to Business. */
export enum BusinessError {
  INVALID_NAME = 'INVALID_NAME',
  CITY_ERROR = 'CITY_ERROR',
}

export type BusinessFilter = {
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** q */
  q?: Maybe<Scalars['String']>;
  controlCheck?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** name_startswith */
  name_startswith?: Maybe<Scalars['String']>;
  /** search_phrase */
  search_phrase?: Maybe<Scalars['String']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  /** address_id */
  address_id?: Maybe<Scalars['UUID']>;
  /** address_id_isnull */
  address_id_isnull?: Maybe<Scalars['Boolean']>;
  /** owner_id */
  owner_id?: Maybe<Scalars['UUID']>;
  /** owner_id_isnull */
  owner_id_isnull?: Maybe<Scalars['Boolean']>;
  /** salesRepresentitive_id */
  salesRepresentitive_id?: Maybe<Scalars['UUID']>;
  /** salesRepresentitive_id_isnull */
  salesRepresentitive_id_isnull?: Maybe<Scalars['Boolean']>;
  /** accountManager_id */
  accountManager_id?: Maybe<Scalars['UUID']>;
  /** accountManager_id_isnull */
  accountManager_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  ltdName?: Maybe<Scalars['String']>;
  /** ltdName_search */
  ltdName_search?: Maybe<Scalars['String']>;
  /** ltdName_gte */
  ltdName_gte?: Maybe<Scalars['String']>;
  /** ltdName_lte */
  ltdName_lte?: Maybe<Scalars['String']>;
  /** ltdName_istartswith */
  ltdName_istartswith?: Maybe<Scalars['String']>;
  /** ltdName_lt */
  ltdName_lt?: Maybe<Scalars['String']>;
  /** ltdName_gt */
  ltdName_gt?: Maybe<Scalars['String']>;
  /** ltdName_isnull */
  ltdName_isnull?: Maybe<Scalars['Boolean']>;
  /** ltdName_iendswith */
  ltdName_iendswith?: Maybe<Scalars['String']>;
  freeStints?: Maybe<Scalars['Float']>;
  /** freeStints_gte */
  freeStints_gte?: Maybe<Scalars['Float']>;
  /** freeStints_lte */
  freeStints_lte?: Maybe<Scalars['Float']>;
  /** freeStints_istartswith */
  freeStints_istartswith?: Maybe<Scalars['Float']>;
  /** freeStints_lt */
  freeStints_lt?: Maybe<Scalars['Float']>;
  /** freeStints_gt */
  freeStints_gt?: Maybe<Scalars['Float']>;
  /** freeStints_isnull */
  freeStints_isnull?: Maybe<Scalars['Boolean']>;
  /** freeStints_iendswith */
  freeStints_iendswith?: Maybe<Scalars['Float']>;
  phoneNumber?: Maybe<Scalars['String']>;
  /** phoneNumber_search */
  phoneNumber_search?: Maybe<Scalars['String']>;
  /** phoneNumber_gte */
  phoneNumber_gte?: Maybe<Scalars['String']>;
  /** phoneNumber_lte */
  phoneNumber_lte?: Maybe<Scalars['String']>;
  /** phoneNumber_istartswith */
  phoneNumber_istartswith?: Maybe<Scalars['String']>;
  /** phoneNumber_lt */
  phoneNumber_lt?: Maybe<Scalars['String']>;
  /** phoneNumber_gt */
  phoneNumber_gt?: Maybe<Scalars['String']>;
  /** phoneNumber_isnull */
  phoneNumber_isnull?: Maybe<Scalars['Boolean']>;
  /** phoneNumber_iendswith */
  phoneNumber_iendswith?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  /** rating_gte */
  rating_gte?: Maybe<Scalars['Float']>;
  /** rating_lte */
  rating_lte?: Maybe<Scalars['Float']>;
  /** rating_istartswith */
  rating_istartswith?: Maybe<Scalars['Float']>;
  /** rating_lt */
  rating_lt?: Maybe<Scalars['Float']>;
  /** rating_gt */
  rating_gt?: Maybe<Scalars['Float']>;
  /** rating_isnull */
  rating_isnull?: Maybe<Scalars['Boolean']>;
  /** rating_iendswith */
  rating_iendswith?: Maybe<Scalars['Float']>;
  isBlockedByFinance?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_gte */
  isBlockedByFinance_gte?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_lte */
  isBlockedByFinance_lte?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_istartswith */
  isBlockedByFinance_istartswith?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_lt */
  isBlockedByFinance_lt?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_gt */
  isBlockedByFinance_gt?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_isnull */
  isBlockedByFinance_isnull?: Maybe<Scalars['Boolean']>;
  /** isBlockedByFinance_iendswith */
  isBlockedByFinance_iendswith?: Maybe<Scalars['Boolean']>;
  exemptFromPaymentDetails?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_gte */
  exemptFromPaymentDetails_gte?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_lte */
  exemptFromPaymentDetails_lte?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_istartswith */
  exemptFromPaymentDetails_istartswith?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_lt */
  exemptFromPaymentDetails_lt?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_gt */
  exemptFromPaymentDetails_gt?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_isnull */
  exemptFromPaymentDetails_isnull?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetails_iendswith */
  exemptFromPaymentDetails_iendswith?: Maybe<Scalars['Boolean']>;
  exemptFromPaymentDetailsAt?: Maybe<Scalars['DateTime']>;
  /** exemptFromPaymentDetailsAt_gte */
  exemptFromPaymentDetailsAt_gte?: Maybe<Scalars['DateTime']>;
  /** exemptFromPaymentDetailsAt_lte */
  exemptFromPaymentDetailsAt_lte?: Maybe<Scalars['DateTime']>;
  /** exemptFromPaymentDetailsAt_istartswith */
  exemptFromPaymentDetailsAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** exemptFromPaymentDetailsAt_lt */
  exemptFromPaymentDetailsAt_lt?: Maybe<Scalars['DateTime']>;
  /** exemptFromPaymentDetailsAt_gt */
  exemptFromPaymentDetailsAt_gt?: Maybe<Scalars['DateTime']>;
  /** exemptFromPaymentDetailsAt_isnull */
  exemptFromPaymentDetailsAt_isnull?: Maybe<Scalars['Boolean']>;
  /** exemptFromPaymentDetailsAt_iendswith */
  exemptFromPaymentDetailsAt_iendswith?: Maybe<Scalars['DateTime']>;
  integrated?: Maybe<Scalars['Boolean']>;
  /** integrated_gte */
  integrated_gte?: Maybe<Scalars['Boolean']>;
  /** integrated_lte */
  integrated_lte?: Maybe<Scalars['Boolean']>;
  /** integrated_istartswith */
  integrated_istartswith?: Maybe<Scalars['Boolean']>;
  /** integrated_lt */
  integrated_lt?: Maybe<Scalars['Boolean']>;
  /** integrated_gt */
  integrated_gt?: Maybe<Scalars['Boolean']>;
  /** integrated_isnull */
  integrated_isnull?: Maybe<Scalars['Boolean']>;
  /** integrated_iendswith */
  integrated_iendswith?: Maybe<Scalars['Boolean']>;
  unlockedLastMinuteStints?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_gte */
  unlockedLastMinuteStints_gte?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_lte */
  unlockedLastMinuteStints_lte?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_istartswith */
  unlockedLastMinuteStints_istartswith?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_lt */
  unlockedLastMinuteStints_lt?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_gt */
  unlockedLastMinuteStints_gt?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_isnull */
  unlockedLastMinuteStints_isnull?: Maybe<Scalars['Boolean']>;
  /** unlockedLastMinuteStints_iendswith */
  unlockedLastMinuteStints_iendswith?: Maybe<Scalars['Boolean']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  /** stripeCustomerId_search */
  stripeCustomerId_search?: Maybe<Scalars['String']>;
  /** stripeCustomerId_gte */
  stripeCustomerId_gte?: Maybe<Scalars['String']>;
  /** stripeCustomerId_lte */
  stripeCustomerId_lte?: Maybe<Scalars['String']>;
  /** stripeCustomerId_istartswith */
  stripeCustomerId_istartswith?: Maybe<Scalars['String']>;
  /** stripeCustomerId_lt */
  stripeCustomerId_lt?: Maybe<Scalars['String']>;
  /** stripeCustomerId_gt */
  stripeCustomerId_gt?: Maybe<Scalars['String']>;
  /** stripeCustomerId_isnull */
  stripeCustomerId_isnull?: Maybe<Scalars['Boolean']>;
  /** stripeCustomerId_iendswith */
  stripeCustomerId_iendswith?: Maybe<Scalars['String']>;
  branchCount?: Maybe<Scalars['Float']>;
  /** branchCount_gte */
  branchCount_gte?: Maybe<Scalars['Float']>;
  /** branchCount_lte */
  branchCount_lte?: Maybe<Scalars['Float']>;
  /** branchCount_istartswith */
  branchCount_istartswith?: Maybe<Scalars['Float']>;
  /** branchCount_lt */
  branchCount_lt?: Maybe<Scalars['Float']>;
  /** branchCount_gt */
  branchCount_gt?: Maybe<Scalars['Float']>;
  /** branchCount_isnull */
  branchCount_isnull?: Maybe<Scalars['Boolean']>;
  /** branchCount_iendswith */
  branchCount_iendswith?: Maybe<Scalars['Float']>;
  /** status_search */
  status_search?: Maybe<Scalars['String']>;
  /** status_gte */
  status_gte?: Maybe<Scalars['String']>;
  /** status_lte */
  status_lte?: Maybe<Scalars['String']>;
  /** status_istartswith */
  status_istartswith?: Maybe<Scalars['String']>;
  /** status_lt */
  status_lt?: Maybe<Scalars['String']>;
  /** status_gt */
  status_gt?: Maybe<Scalars['String']>;
  /** status_isnull */
  status_isnull?: Maybe<Scalars['Boolean']>;
  /** status_iendswith */
  status_iendswith?: Maybe<Scalars['String']>;
  allowRampup?: Maybe<Scalars['Boolean']>;
  /** allowRampup_gte */
  allowRampup_gte?: Maybe<Scalars['Boolean']>;
  /** allowRampup_lte */
  allowRampup_lte?: Maybe<Scalars['Boolean']>;
  /** allowRampup_istartswith */
  allowRampup_istartswith?: Maybe<Scalars['Boolean']>;
  /** allowRampup_lt */
  allowRampup_lt?: Maybe<Scalars['Boolean']>;
  /** allowRampup_gt */
  allowRampup_gt?: Maybe<Scalars['Boolean']>;
  /** allowRampup_isnull */
  allowRampup_isnull?: Maybe<Scalars['Boolean']>;
  /** allowRampup_iendswith */
  allowRampup_iendswith?: Maybe<Scalars['Boolean']>;
  businessType?: Maybe<Scalars['String']>;
  /** businessType_search */
  businessType_search?: Maybe<Scalars['String']>;
  /** businessType_gte */
  businessType_gte?: Maybe<Scalars['String']>;
  /** businessType_lte */
  businessType_lte?: Maybe<Scalars['String']>;
  /** businessType_istartswith */
  businessType_istartswith?: Maybe<Scalars['String']>;
  /** businessType_lt */
  businessType_lt?: Maybe<Scalars['String']>;
  /** businessType_gt */
  businessType_gt?: Maybe<Scalars['String']>;
  /** businessType_isnull */
  businessType_isnull?: Maybe<Scalars['Boolean']>;
  /** businessType_iendswith */
  businessType_iendswith?: Maybe<Scalars['String']>;
  qrCodeId?: Maybe<Scalars['UUID']>;
  /** qrCodeId_gte */
  qrCodeId_gte?: Maybe<Scalars['UUID']>;
  /** qrCodeId_lte */
  qrCodeId_lte?: Maybe<Scalars['UUID']>;
  /** qrCodeId_istartswith */
  qrCodeId_istartswith?: Maybe<Scalars['UUID']>;
  /** qrCodeId_lt */
  qrCodeId_lt?: Maybe<Scalars['UUID']>;
  /** qrCodeId_gt */
  qrCodeId_gt?: Maybe<Scalars['UUID']>;
  /** qrCodeId_isnull */
  qrCodeId_isnull?: Maybe<Scalars['Boolean']>;
  /** qrCodeId_iendswith */
  qrCodeId_iendswith?: Maybe<Scalars['UUID']>;
  specialNotes?: Maybe<Scalars['String']>;
  /** specialNotes_search */
  specialNotes_search?: Maybe<Scalars['String']>;
  /** specialNotes_gte */
  specialNotes_gte?: Maybe<Scalars['String']>;
  /** specialNotes_lte */
  specialNotes_lte?: Maybe<Scalars['String']>;
  /** specialNotes_istartswith */
  specialNotes_istartswith?: Maybe<Scalars['String']>;
  /** specialNotes_lt */
  specialNotes_lt?: Maybe<Scalars['String']>;
  /** specialNotes_gt */
  specialNotes_gt?: Maybe<Scalars['String']>;
  /** specialNotes_isnull */
  specialNotes_isnull?: Maybe<Scalars['Boolean']>;
  /** specialNotes_iendswith */
  specialNotes_iendswith?: Maybe<Scalars['String']>;
  internalRanking?: Maybe<Scalars['Float']>;
  /** internalRanking_gte */
  internalRanking_gte?: Maybe<Scalars['Float']>;
  /** internalRanking_lte */
  internalRanking_lte?: Maybe<Scalars['Float']>;
  /** internalRanking_istartswith */
  internalRanking_istartswith?: Maybe<Scalars['Float']>;
  /** internalRanking_lt */
  internalRanking_lt?: Maybe<Scalars['Float']>;
  /** internalRanking_gt */
  internalRanking_gt?: Maybe<Scalars['Float']>;
  /** internalRanking_isnull */
  internalRanking_isnull?: Maybe<Scalars['Boolean']>;
  /** internalRanking_iendswith */
  internalRanking_iendswith?: Maybe<Scalars['Float']>;
  onboardingRanking?: Maybe<Scalars['Float']>;
  /** onboardingRanking_gte */
  onboardingRanking_gte?: Maybe<Scalars['Float']>;
  /** onboardingRanking_lte */
  onboardingRanking_lte?: Maybe<Scalars['Float']>;
  /** onboardingRanking_istartswith */
  onboardingRanking_istartswith?: Maybe<Scalars['Float']>;
  /** onboardingRanking_lt */
  onboardingRanking_lt?: Maybe<Scalars['Float']>;
  /** onboardingRanking_gt */
  onboardingRanking_gt?: Maybe<Scalars['Float']>;
  /** onboardingRanking_isnull */
  onboardingRanking_isnull?: Maybe<Scalars['Boolean']>;
  /** onboardingRanking_iendswith */
  onboardingRanking_iendswith?: Maybe<Scalars['Float']>;
  firebaseRef?: Maybe<Scalars['String']>;
  /** firebaseRef_search */
  firebaseRef_search?: Maybe<Scalars['String']>;
  /** firebaseRef_gte */
  firebaseRef_gte?: Maybe<Scalars['String']>;
  /** firebaseRef_lte */
  firebaseRef_lte?: Maybe<Scalars['String']>;
  /** firebaseRef_istartswith */
  firebaseRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseRef_lt */
  firebaseRef_lt?: Maybe<Scalars['String']>;
  /** firebaseRef_gt */
  firebaseRef_gt?: Maybe<Scalars['String']>;
  /** firebaseRef_isnull */
  firebaseRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseRef_iendswith */
  firebaseRef_iendswith?: Maybe<Scalars['String']>;
  preferredPaymentMethod?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_search */
  preferredPaymentMethod_search?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_gte */
  preferredPaymentMethod_gte?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_lte */
  preferredPaymentMethod_lte?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_istartswith */
  preferredPaymentMethod_istartswith?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_lt */
  preferredPaymentMethod_lt?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_gt */
  preferredPaymentMethod_gt?: Maybe<Scalars['String']>;
  /** preferredPaymentMethod_isnull */
  preferredPaymentMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** preferredPaymentMethod_iendswith */
  preferredPaymentMethod_iendswith?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  /** createdBy_search */
  createdBy_search?: Maybe<Scalars['String']>;
  /** createdBy_gte */
  createdBy_gte?: Maybe<Scalars['String']>;
  /** createdBy_lte */
  createdBy_lte?: Maybe<Scalars['String']>;
  /** createdBy_istartswith */
  createdBy_istartswith?: Maybe<Scalars['String']>;
  /** createdBy_lt */
  createdBy_lt?: Maybe<Scalars['String']>;
  /** createdBy_gt */
  createdBy_gt?: Maybe<Scalars['String']>;
  /** createdBy_isnull */
  createdBy_isnull?: Maybe<Scalars['Boolean']>;
  /** createdBy_iendswith */
  createdBy_iendswith?: Maybe<Scalars['String']>;
  /** controlCheck_gte */
  controlCheck_gte?: Maybe<Scalars['Boolean']>;
  /** controlCheck_lte */
  controlCheck_lte?: Maybe<Scalars['Boolean']>;
  /** controlCheck_istartswith */
  controlCheck_istartswith?: Maybe<Scalars['Boolean']>;
  /** controlCheck_lt */
  controlCheck_lt?: Maybe<Scalars['Boolean']>;
  /** controlCheck_gt */
  controlCheck_gt?: Maybe<Scalars['Boolean']>;
  /** controlCheck_isnull */
  controlCheck_isnull?: Maybe<Scalars['Boolean']>;
  /** controlCheck_iendswith */
  controlCheck_iendswith?: Maybe<Scalars['Boolean']>;
  repeatStintersEnabled?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_gte */
  repeatStintersEnabled_gte?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_lte */
  repeatStintersEnabled_lte?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_istartswith */
  repeatStintersEnabled_istartswith?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_lt */
  repeatStintersEnabled_lt?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_gt */
  repeatStintersEnabled_gt?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_isnull */
  repeatStintersEnabled_isnull?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_iendswith */
  repeatStintersEnabled_iendswith?: Maybe<Scalars['Boolean']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use paymentMethods ids to filter Business by paymentMethods. */
  paymentMethods_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use cardPaymentMethods ids to filter Business by cardPaymentMethods. */
  cardPaymentMethods_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  ltdName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  freeStints_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  phoneNumber_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  rating_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  isBlockedByFinance_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  exemptFromPaymentDetails_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  exemptFromPaymentDetailsAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  integrated_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  unlockedLastMinuteStints_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  stripeCustomerId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  branchCount_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  status_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  allowRampup_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  businessType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  qrCodeId_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  specialNotes_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  internalRanking_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  onboardingRanking_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  firebaseRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  preferredPaymentMethod_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  createdBy_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  controlCheck_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  repeatStintersEnabled_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The type of BusinessIntelligenceSetting. */
export enum BusinessIntelligenceSetting {
  /** Provides access to all Business Intelligence features. */
  ON = 'ON',
  /**
   * Provides access to the Business Intelligence features that are available during the onboarding process:
   *                     - Operational events
   *                     - Core team management
   */
  ONBOARDING = 'ONBOARDING',
  /** Provides access to no Business Intelligence features. */
  OFF = 'OFF',
}

/** The business intelligence feature settings values for a Site. */
export type BusinessIntelligenceSettings = {
  __typename?: 'BusinessIntelligenceSettings';
  /** The setting that dictates whether a Site is able use the Stint labour optimization features. */
  labourOptimizationEnabled: Scalars['Boolean'];
  /** The setting that dictates whether a Site is able use the Stint core team management and autoscheduling features. */
  autoschedulingEnabled: Scalars['Boolean'];
  /** The setting that dictates which forecast type is in use by the Site. */
  forecastType: ForecastType;
};

/** GraphQL Type class for a list of BusinessType. */
export type BusinessListType = {
  __typename?: 'BusinessListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<Business>>>;
};

export enum BusinessPreferredPaymentMethod {
  /** Card */
  CARD = 'CARD',
  /** Direct Debit */
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export type BusinessRateOverrideInput = {
  /** Effective rate of the rate override. */
  rate?: Maybe<Scalars['Decimal']>;
};

/**
 * The BusinessRatesType class defines the Graphene ObjectType class used
 * to resolve the rates data that a Business will be charged for Stints used in GraphQL queries.
 *
 * BusinessRates represents the cost breakdown that make up the overall cost of a Stint for a Business.
 *
 * Consumers of this data can use this information to build up an overall cost breakdown
 * to the customer when they are planning their rota, using one off Stints, weeks of Stints,
 * etc.
 */
export type BusinessRatesType = {
  __typename?: 'BusinessRatesType';
  /** The hourly rate we pay the Stinter. */
  stinterHourlyRate?: Maybe<Scalars['Float']>;
  /** The hourly fee we charge the Business (excluding VAT). */
  businessHourlyFee?: Maybe<Scalars['Float']>;
  /** The fee Stint takes plus any pension/holiday (excluding VAT). */
  stintHourlyFee?: Maybe<Scalars['Float']>;
};

/**
 * The BusinessReviewType class defines the Graphene ObjectType class used to resolve the BusinessReview model
 * for GraphQL queries.
 */
export type BusinessReview = {
  __typename?: 'BusinessReview';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  reviewType?: Maybe<ReviewReviewType>;
  reviewDate?: Maybe<Scalars['DateTime']>;
  reviewer?: Maybe<StintUser>;
  rating?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  business: Business;
  /** The stint associated with this review. */
  stint: StintNode;
  tags: Array<Tag>;
  /** Indicates if the BusinessReview is visible to anyone other than the reviewer. BusinessReview records that are not visible are not included in the Business average rating calculation. */
  visible: Scalars['Boolean'];
  /** Id of related StintUser (auto-generated). */
  reviewer_id?: Maybe<Scalars['UUID']>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
  /** Id of related Stint (auto-generated). */
  stint_id?: Maybe<Scalars['UUID']>;
};

export enum BusinessStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Integrated */
  INTEGRATED = 'INTEGRATED',
  /** Dormant */
  DORMANT = 'DORMANT',
}

export enum BusinessStatusChoices {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Integrated */
  INTEGRATED = 'INTEGRATED',
  /** Dormant */
  DORMANT = 'DORMANT',
}

export type CalendarStint = {
  __typename?: 'CalendarStint';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Determines if the Stint is a trained Stint. */
  trained: Scalars['Boolean'];
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Int']>;
  /** The method used to post this Stint. */
  postMethod?: Maybe<PostMethod>;
  /** The role */
  role?: Maybe<Scalars['String']>;
  /**
   * Business assigned to Stint,
   * and returns NULL if there is no business associated with the Stint.
   */
  business?: Maybe<Business>;
  /**
   * Student assigned to Stint,
   * and returns NULL if there is no student associated with the Stint.
   * @deprecated Deprecated in favor of stinter
   */
  student?: Maybe<StintUser>;
  /** Stint from/to time in format '%-I:%M %p - %-I:%M %p'. Example: 1:52 PM - 1:53 PM */
  stintTimesNormalized: Scalars['String'];
  /** Stint from time in format '%Y-%m-%d'. Example: 2021-09-01 */
  dateFromPublic: Scalars['String'];
  /**
   * Resolved the rates & pay that the Stinter is eligible for when working this Stint.
   *
   * Errors:
   * - UNAUTHORIZED when a non Stinter user makes the request.
   * - MISSING_MONETARY_VALUE when a non nullable monetary value is somehow null in the database.
   */
  stinterPay: StinterPay;
  /** Rating that student gave to business that posted stint. */
  studentReviewRating?: Maybe<Scalars['Int']>;
  /** The review that the (student) user has set for the business */
  businessReview?: Maybe<BusinessReview>;
  /** The site that the Stint belongs to. */
  site: PartnerSiteProfile;
  /** The Stinter assigned to the Stint. Null if there is no Stinter assigned. */
  stinter?: Maybe<Stinter>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
  /** Id of related Address (auto-generated). */
  address_id?: Maybe<Scalars['UUID']>;
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
  /** Id of related PaymentMethod (auto-generated). */
  selected_payment_method_id?: Maybe<Scalars['UUID']>;
  /** Id of related CardPaymentMethod (auto-generated). */
  selected_card_payment_method_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessRole (auto-generated). */
  business_role_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessCategory (auto-generated). */
  business_category_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  cancelled_by_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  created_by_user_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintTemplate (auto-generated). */
  stint_template_id?: Maybe<Scalars['UUID']>;
};

export type CalendarStintListType = {
  __typename?: 'CalendarStintListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<CalendarStint>>>;
};

/** The input values required to cancel an employee holiday request. */
export type CancelEmployeeHolidayRequestInput = {
  /** The ID of the holiday request to cancel. */
  holidayRequestId: Scalars['UUID'];
  /** The ID of the partner member profile that the holiday request belongs to. Used to resolve the holiday info after a successful cancellation. */
  partnerMemberProfileId: Scalars['UUID'];
};

/** The output values from cancelling an employee holiday. */
export type CancelEmployeeHolidayRequestOutput = {
  __typename?: 'CancelEmployeeHolidayRequestOutput';
  /** The holiday info related to the emoployee whose holiday was cancelled including their remaining balance. */
  holidayInfo: CoreTeamMemberHolidayInfo;
  /** The holiday request that was cancelled. */
  holiday: CoreTeamMemberHolidayRequest;
};

/** The input values required to cancel an employee termination. */
export type CancelEmployeeTerminationInput = {
  /** The ID of the PartnerMemberProfile whose termination is being cancelled */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the termination to cancel */
  terminationId: Scalars['UUID'];
};

/** The output values from cancelling an employee termination. */
export type CancelEmployeeTerminationOutput = {
  __typename?: 'CancelEmployeeTerminationOutput';
  /** The employment status of the employee after the termination has been cancelled. */
  employmentStatus: EmployeeEmploymentStatus;
};

/** The input values required to cancel a RecurringShiftOccurrence. */
export type CancelRecurringShiftOccurrenceInput = {
  /** The ID of the Site that owns the RecurringShiftTemplate. */
  siteId: Scalars['UUID'];
  /** The ID of the RecurringShiftTemplate this occurrence belongs to. */
  id: Scalars['UUID'];
  /** The date of the occurrence to cancel. */
  occurrenceDate: Scalars['Date'];
};

/** The output returned after cancelling a RecurringShiftOccurrence. */
export type CancelRecurringShiftOccurrenceOutput = {
  __typename?: 'CancelRecurringShiftOccurrenceOutput';
  /** Whether the cancellation was successful. */
  success: Scalars['Boolean'];
};

/** The input values required to cancel generating a site schedule. */
export type CancelSiteScheduleGenerationInput = {
  /** The ID of the site. Used to validate permissions. */
  siteId: Scalars['UUID'];
  /** The ID of the site schedule being generated to cancel. */
  siteScheduleId: Scalars['UUID'];
};

/** The output values from cancelling the generation of a site schedule. */
export type CancelSiteScheduleGenerationOutput = {
  __typename?: 'CancelSiteScheduleGenerationOutput';
  /** Indicates whether the cancellation was successful. */
  success: Scalars['Boolean'];
};

/**
 * The CancelStintAsStinterInput class defines the input values that are required from
 * the client to cancel a Stint as a Stinter.
 */
export type CancelStintAsStinterInput = {
  /** The ID (ref) of the Stint that will be cancelled. */
  stintId: Scalars['UUID'];
};

/** CancelStints Mutation defines the GraphQL mutation for bulk-stint cancellations. */
export type CancelStints = {
  __typename?: 'CancelStints';
  entries?: Maybe<Array<Maybe<Stint>>>;
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  nameOnCard?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isPrimaryMethod: Scalars['Boolean'];
  lastFourDigits?: Maybe<Scalars['String']>;
  /** This field has been deprecated. */
  employerCardPaymentMethods: Array<EmployerProfile>;
  /** The associated Stints. */
  stints: StintNodeTypeConnection;
  businesses: Array<Business>;
};

export type CardPaymentMethodstintsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CardPaymentMethodFilter = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  nameOnCard?: Maybe<Scalars['String']>;
  /** nameOnCard_search */
  nameOnCard_search?: Maybe<Scalars['String']>;
  /** nameOnCard_gte */
  nameOnCard_gte?: Maybe<Scalars['String']>;
  /** nameOnCard_lte */
  nameOnCard_lte?: Maybe<Scalars['String']>;
  /** nameOnCard_istartswith */
  nameOnCard_istartswith?: Maybe<Scalars['String']>;
  /** nameOnCard_lt */
  nameOnCard_lt?: Maybe<Scalars['String']>;
  /** nameOnCard_gt */
  nameOnCard_gt?: Maybe<Scalars['String']>;
  /** nameOnCard_isnull */
  nameOnCard_isnull?: Maybe<Scalars['Boolean']>;
  /** nameOnCard_iendswith */
  nameOnCard_iendswith?: Maybe<Scalars['String']>;
  /** description_search */
  description_search?: Maybe<Scalars['String']>;
  /** description_gte */
  description_gte?: Maybe<Scalars['String']>;
  /** description_lte */
  description_lte?: Maybe<Scalars['String']>;
  /** description_istartswith */
  description_istartswith?: Maybe<Scalars['String']>;
  /** description_lt */
  description_lt?: Maybe<Scalars['String']>;
  /** description_gt */
  description_gt?: Maybe<Scalars['String']>;
  /** description_isnull */
  description_isnull?: Maybe<Scalars['Boolean']>;
  /** description_iendswith */
  description_iendswith?: Maybe<Scalars['String']>;
  isPrimaryMethod?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gte */
  isPrimaryMethod_gte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lte */
  isPrimaryMethod_lte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_istartswith */
  isPrimaryMethod_istartswith?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lt */
  isPrimaryMethod_lt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gt */
  isPrimaryMethod_gt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_isnull */
  isPrimaryMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_iendswith */
  isPrimaryMethod_iendswith?: Maybe<Scalars['Boolean']>;
  lastFourDigits?: Maybe<Scalars['String']>;
  /** lastFourDigits_search */
  lastFourDigits_search?: Maybe<Scalars['String']>;
  /** lastFourDigits_gte */
  lastFourDigits_gte?: Maybe<Scalars['String']>;
  /** lastFourDigits_lte */
  lastFourDigits_lte?: Maybe<Scalars['String']>;
  /** lastFourDigits_istartswith */
  lastFourDigits_istartswith?: Maybe<Scalars['String']>;
  /** lastFourDigits_lt */
  lastFourDigits_lt?: Maybe<Scalars['String']>;
  /** lastFourDigits_gt */
  lastFourDigits_gt?: Maybe<Scalars['String']>;
  /** lastFourDigits_isnull */
  lastFourDigits_isnull?: Maybe<Scalars['Boolean']>;
  /** lastFourDigits_iendswith */
  lastFourDigits_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  nameOnCard_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isPrimaryMethod_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  lastFourDigits_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Characteristic = {
  __typename?: 'Characteristic';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  name: Scalars['String'];
};

export type CharacteristicFilter = {
  name?: Maybe<Scalars['String']>;
  /** q */
  q?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Mutation to check if address with place id is in active city. */
export type CheckAddressAvailability = {
  __typename?: 'CheckAddressAvailability';
  /** True if address with provided place id is in active city. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** City related to the given address. */
  city?: Maybe<City>;
};

/** The input values required to check into a shift. */
export type CheckInShiftInput = {
  /** The ID of the Site where the shift is taking place. */
  siteId: Scalars['UUID'];
  /** The QR code used to check into the shift. */
  qrCode: Scalars['UUID'];
  /** The ID of the shift to check into. */
  shiftId: Scalars['UUID'];
};

/** The output values from checking into a shift */
export type CheckInShiftOutput = {
  __typename?: 'CheckInShiftOutput';
  /** The time the user checked into the shift. */
  checkedInAt: Scalars['DateTime'];
};

/** Mutation to check in a Stint for given ref and business qr code. */
export type CheckInStint = {
  __typename?: 'CheckInStint';
  /** The checked in stint. */
  stint?: Maybe<Stint>;
  /** The business for the checked in stint. */
  business?: Maybe<Business>;
};

/** The input values required to check out of a shift. */
export type CheckOutShiftInput = {
  /** The breaks that the core team member took during their shift. */
  shiftBreaks: Array<ShiftBreakInput>;
  /** The ID of the shift to check out. */
  shiftId: Scalars['UUID'];
};

/** The output values from checking out of a shift */
export type CheckOutShiftOutput = {
  __typename?: 'CheckOutShiftOutput';
  /** The time the user checked out of the shift. */
  checkedOutAt: Scalars['DateTime'];
};

export enum CheckOutType {
  /** The assignee manually checked themselves out of the shift. */
  MANUAL = 'MANUAL',
  /** The shift was automatically checked out of by our system. */
  AUTOMATIC = 'AUTOMATIC',
  /** The shift's check out time was set by a manager. */
  MANAGER_OVERRIDE = 'MANAGER_OVERRIDE',
}

/**
 * The CheckoutSession class defines the Graphene ObjectType class used to resolve the
 * data for a CheckoutSession created via the Stripe API.
 */
export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  /** ID of the CheckoutSession */
  id?: Maybe<Scalars['String']>;
  /** The type of the CheckoutSession */
  mode?: Maybe<Scalars['String']>;
  /** The Striped ID for this business */
  customerId?: Maybe<Scalars['String']>;
  /** Redirected here if the Checkout is successful */
  successUrl?: Maybe<Scalars['String']>;
  /** Redirected here if the Checkout was cancelled */
  cancelUrl?: Maybe<Scalars['String']>;
  /** Adapted mobile success url */
  adaptedSuccessUrl?: Maybe<Scalars['String']>;
};

export type City = {
  __typename?: 'City';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  region?: Maybe<Region>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAvailabilityEnabled: Scalars['Boolean'];
  shortCode?: Maybe<Scalars['String']>;
  sessionUrl?: Maybe<Scalars['String']>;
  /** The base fee used to calculate the business fee on a Stint within this city */
  baseFee: Scalars['Float'];
  /** The base fee used to calculate the student salary on a Stint within this city */
  baseFeeStudent: Scalars['Float'];
  /** Whether or not the repeat Stinters feature is enabled for the city. */
  repeatStintersEnabled: Scalars['Boolean'];
  /** List of postal codes of the city. */
  postalCodes?: Maybe<Array<Maybe<PostalCode>>>;
  /** List of postal codes IDs of the city. */
  postalCodeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** ID of city region. */
  regionId?: Maybe<Scalars['UUID']>;
  /** List of currently logged in student saved places for city. */
  studentSavedPlaces?: Maybe<Array<Maybe<StudentSavedPlace>>>;
  /** List of currently logged in stint user availabilities. */
  stintUserAvailabilities?: Maybe<Array<Maybe<StintUserAvailability>>>;
};

export type CityFilter = {
  /** q */
  q?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** name_startswith */
  name_startswith?: Maybe<Scalars['String']>;
  postalCodeId?: Maybe<Scalars['String']>;
  /** region_id */
  region_id?: Maybe<Scalars['UUID']>;
  /** region_id_isnull */
  region_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** state_search */
  state_search?: Maybe<Scalars['String']>;
  /** state_gte */
  state_gte?: Maybe<Scalars['String']>;
  /** state_lte */
  state_lte?: Maybe<Scalars['String']>;
  /** state_istartswith */
  state_istartswith?: Maybe<Scalars['String']>;
  /** state_lt */
  state_lt?: Maybe<Scalars['String']>;
  /** state_gt */
  state_gt?: Maybe<Scalars['String']>;
  /** state_isnull */
  state_isnull?: Maybe<Scalars['Boolean']>;
  /** state_iendswith */
  state_iendswith?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** isActive_gte */
  isActive_gte?: Maybe<Scalars['Boolean']>;
  /** isActive_lte */
  isActive_lte?: Maybe<Scalars['Boolean']>;
  /** isActive_istartswith */
  isActive_istartswith?: Maybe<Scalars['Boolean']>;
  /** isActive_lt */
  isActive_lt?: Maybe<Scalars['Boolean']>;
  /** isActive_gt */
  isActive_gt?: Maybe<Scalars['Boolean']>;
  /** isActive_isnull */
  isActive_isnull?: Maybe<Scalars['Boolean']>;
  /** isActive_iendswith */
  isActive_iendswith?: Maybe<Scalars['Boolean']>;
  isAvailabilityEnabled?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_gte */
  isAvailabilityEnabled_gte?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_lte */
  isAvailabilityEnabled_lte?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_istartswith */
  isAvailabilityEnabled_istartswith?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_lt */
  isAvailabilityEnabled_lt?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_gt */
  isAvailabilityEnabled_gt?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_isnull */
  isAvailabilityEnabled_isnull?: Maybe<Scalars['Boolean']>;
  /** isAvailabilityEnabled_iendswith */
  isAvailabilityEnabled_iendswith?: Maybe<Scalars['Boolean']>;
  shortCode?: Maybe<Scalars['String']>;
  /** shortCode_search */
  shortCode_search?: Maybe<Scalars['String']>;
  /** shortCode_gte */
  shortCode_gte?: Maybe<Scalars['String']>;
  /** shortCode_lte */
  shortCode_lte?: Maybe<Scalars['String']>;
  /** shortCode_istartswith */
  shortCode_istartswith?: Maybe<Scalars['String']>;
  /** shortCode_lt */
  shortCode_lt?: Maybe<Scalars['String']>;
  /** shortCode_gt */
  shortCode_gt?: Maybe<Scalars['String']>;
  /** shortCode_isnull */
  shortCode_isnull?: Maybe<Scalars['Boolean']>;
  /** shortCode_iendswith */
  shortCode_iendswith?: Maybe<Scalars['String']>;
  sessionUrl?: Maybe<Scalars['String']>;
  /** sessionUrl_search */
  sessionUrl_search?: Maybe<Scalars['String']>;
  /** sessionUrl_gte */
  sessionUrl_gte?: Maybe<Scalars['String']>;
  /** sessionUrl_lte */
  sessionUrl_lte?: Maybe<Scalars['String']>;
  /** sessionUrl_istartswith */
  sessionUrl_istartswith?: Maybe<Scalars['String']>;
  /** sessionUrl_lt */
  sessionUrl_lt?: Maybe<Scalars['String']>;
  /** sessionUrl_gt */
  sessionUrl_gt?: Maybe<Scalars['String']>;
  /** sessionUrl_isnull */
  sessionUrl_isnull?: Maybe<Scalars['Boolean']>;
  /** sessionUrl_iendswith */
  sessionUrl_iendswith?: Maybe<Scalars['String']>;
  baseFee?: Maybe<Scalars['Float']>;
  /** baseFee_gte */
  baseFee_gte?: Maybe<Scalars['Float']>;
  /** baseFee_lte */
  baseFee_lte?: Maybe<Scalars['Float']>;
  /** baseFee_istartswith */
  baseFee_istartswith?: Maybe<Scalars['Float']>;
  /** baseFee_lt */
  baseFee_lt?: Maybe<Scalars['Float']>;
  /** baseFee_gt */
  baseFee_gt?: Maybe<Scalars['Float']>;
  /** baseFee_isnull */
  baseFee_isnull?: Maybe<Scalars['Boolean']>;
  /** baseFee_iendswith */
  baseFee_iendswith?: Maybe<Scalars['Float']>;
  baseFeeStudent?: Maybe<Scalars['Float']>;
  /** baseFeeStudent_gte */
  baseFeeStudent_gte?: Maybe<Scalars['Float']>;
  /** baseFeeStudent_lte */
  baseFeeStudent_lte?: Maybe<Scalars['Float']>;
  /** baseFeeStudent_istartswith */
  baseFeeStudent_istartswith?: Maybe<Scalars['Float']>;
  /** baseFeeStudent_lt */
  baseFeeStudent_lt?: Maybe<Scalars['Float']>;
  /** baseFeeStudent_gt */
  baseFeeStudent_gt?: Maybe<Scalars['Float']>;
  /** baseFeeStudent_isnull */
  baseFeeStudent_isnull?: Maybe<Scalars['Boolean']>;
  /** baseFeeStudent_iendswith */
  baseFeeStudent_iendswith?: Maybe<Scalars['Float']>;
  repeatStintersEnabled?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_gte */
  repeatStintersEnabled_gte?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_lte */
  repeatStintersEnabled_lte?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_istartswith */
  repeatStintersEnabled_istartswith?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_lt */
  repeatStintersEnabled_lt?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_gt */
  repeatStintersEnabled_gt?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_isnull */
  repeatStintersEnabled_isnull?: Maybe<Scalars['Boolean']>;
  /** repeatStintersEnabled_iendswith */
  repeatStintersEnabled_iendswith?: Maybe<Scalars['Boolean']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  state_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isActive_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  isAvailabilityEnabled_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  shortCode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  sessionUrl_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  baseFee_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  baseFeeStudent_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  repeatStintersEnabled_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type CityListType = {
  __typename?: 'CityListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<City>>>;
};

/** The GraphQL input values for clearing the default StintWeekTemplate for a Business. */
export type ClearDefaultStintWeekTemplateInput = {
  /** The ID (ref) of the Business that the StintWeekTemplate belongs to. */
  businessId: Scalars['UUID'];
};

/** Represents a week of a Stinters Commitment. */
export type CommitmentWeek = {
  __typename?: 'CommitmentWeek';
  /** The date at the start of the week. */
  weekStart: Scalars['Date'];
  /** The date at the end of the week. */
  weekEnd: Scalars['Date'];
  /** The total number of Stints that the Stinter accepted for this week. */
  numAcceptedStints: Scalars['Int'];
};

/** Values used to filter the weeks associated with this StinterCommitment. */
export type CommitmentWeeksFilterInput = {
  /**
   * Limit results to only weeks that start after (and including) the specified date.
   * If omitted, then all results up until dateTo will be included.
   */
  dateFrom?: Maybe<Scalars['Date']>;
  /**
   * Limit results to only weeks that end before (and including) the specified date.
   * If omitted, then all results up until dateFrom will be included.
   */
  dateTo?: Maybe<Scalars['Date']>;
};

/** Values used to filter the weeks associated with this StinterCommitment */
export type CommitmentWeeksInput = {
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filter?: Maybe<CommitmentWeeksFilterInput>;
};

/**
 * The CompaniesHouseInformationType class defines the Graphene ObjectType class used
 * to resolve the CompaniesHouseInformation model data for GraphQL queries.
 */
export type CompaniesHouseInformation = {
  __typename?: 'CompaniesHouseInformation';
  /** The id of the CompaniesHouseInformation. */
  id: Scalars['UUID'];
  /** The Companies House number. */
  number: Scalars['String'];
  /** The name registered with Companies House. */
  name: Scalars['String'];
  /** The address registered with Companies House. */
  address: Scalars['String'];
};

/**
 * Enum that contains the available error message codes that can be used to raise errors related to
 *     CompaniesHouseInformation.
 */
export enum CompaniesHouseInformationError {
  DUPLICATE_NUMBER = 'DUPLICATE_NUMBER',
  DUPLICATE_PARTNER_NODE_ID = 'DUPLICATE_PARTNER_NODE_ID',
  INVALID_ADDRESS = 'INVALID_ADDRESS',
  INVALID_NAME = 'INVALID_NAME',
  INVALID_NUMBER = 'INVALID_NUMBER',
  PARTNER_NODE_ALREADY_HAS_COMPANIES_HOUSE_INFORMATION = 'PARTNER_NODE_ALREADY_HAS_COMPANIES_HOUSE_INFORMATION',
}

/**
 * The CompaniesHouseInformationInput class defines the input values that are required from
 * the client in order to create or update a CompaniesHouseInformation object.
 */
export type CompaniesHouseInformationInput = {
  /** The Companies House number. */
  number: Scalars['String'];
  /** The name registered with Companies House. */
  name: Scalars['String'];
  /** The address registered with Companies House. */
  address: Scalars['String'];
};

/** The input values required to resolve a relay paginated list of completed Shifts. */
export type CompletedShiftsInput = {
  pagination: PaginationInput;
};

/** The input values required from a client to configure a partner webhook. */
export type ConfigurePartnerWebhookInput = {
  /** The partner account the webhook is being set up for. */
  accountId: Scalars['UUID'];
  /** Whether the webhook is currently active for the partner account. Any events consumed while the webhook is inactive will be ignored. */
  active: Scalars['Boolean'];
  /** The endpoint that the webhook will send data to. */
  endpoint: Scalars['String'];
};

/** The output values returned to the client from the ConfigurePartnerWebhook mutation. */
export type ConfigurePartnerWebhookOutput = {
  __typename?: 'ConfigurePartnerWebhookOutput';
  /** A generated auth token to display to the user so they can use for authentication in their consumer. */
  authToken: Scalars['String'];
};

/**
 * The ConfirmEmployeeDisclaimerInput class defines the input values that are required from the
 * client in order to confirm an AgreementType.EMPLOYEE_DISCLAIMER agreement.
 */
export type ConfirmEmployeeDisclaimerInput = {
  /** The ID of the Agreement object that the StinterAgreementConfirmation belongs to. */
  agreementId: Scalars['UUID'];
  /** The ID (ref) of the StudentProfile object that the StinterAgreementConfirmation belongs to. */
  stinterProfileId: Scalars['UUID'];
};

/** Confirms a student has uploaded their right-to-work documents. */
export type ConfirmRightToWorkDocUpload = {
  __typename?: 'ConfirmRightToWorkDocUpload';
  /** Returns true when right-to-work document upload is successfully marked. */
  success?: Maybe<Scalars['Boolean']>;
};

/** The contract types available for a PartnerMember.  */
export enum ContractType {
  /** A flexible contract type for a PartnerMember. */
  FLEXIBLE = 'FLEXIBLE',
  /** A fixed contract type for a PartnerMember. */
  FIXED = 'FIXED',
}

/** The contracted hours constraint values available for employee employment. */
export enum ContractedHoursConstraint {
  /** The contracted hours constraint is a minimum value. */
  CONTRACTED_HOURS_CONSTRAINT_MINIMUM = 'CONTRACTED_HOURS_CONSTRAINT_MINIMUM',
  /** The contracted hours constraint is an exact value. */
  CONTRACTED_HOURS_CONSTRAINT_EXACT = 'CONTRACTED_HOURS_CONSTRAINT_EXACT',
}

/** The type of absence being recorded. */
export enum CoreTeamAbsenceType {
  /** Authorised absence from work */
  AUTHORISED_ABSENCE = 'AUTHORISED_ABSENCE',
  /** Compassionate leave */
  COMPASSIONATE_LEAVE = 'COMPASSIONATE_LEAVE',
  /** Scheduled day off */
  DAY_OFF = 'DAY_OFF',
  /** Outside of Statutory Sick Pay */
  SSP_FINISHED = 'SSP_FINISHED',
  /** Unauthorised absence from work */
  UNAUTHORISED_ABSENCE = 'UNAUTHORISED_ABSENCE',
  /** Employee did not show up for work */
  NO_SHOW = 'NO_SHOW',
  /** Sabbatical leave */
  SABBATICAL = 'SABBATICAL',
  /** Notice pay period */
  NOTICE_PAY = 'NOTICE_PAY',
  /** Suspension from work */
  SUSPENSION = 'SUSPENSION',
  /** Maternity leave */
  MATERNITY_LEAVE = 'MATERNITY_LEAVE',
  /** Paternity leave */
  PATERNITY_LEAVE = 'PATERNITY_LEAVE',
  /** Shared parental leave */
  SHARED_PARENTAL_LEAVE = 'SHARED_PARENTAL_LEAVE',
  /** Statutory Sick Pay */
  SSP = 'SSP',
  /** Other paid absence */
  OTHER_PAID = 'OTHER_PAID',
  /** Other unpaid absence */
  OTHER_UNPAID = 'OTHER_UNPAID',
  /** Sickness */
  SICKNESS = 'SICKNESS',
  /** Sickness (SSP and company sick pay, salaried) */
  SICKNESS_SSP_AND_COMPANY_SICK_PAY_SALARIED = 'SICKNESS_SSP_AND_COMPANY_SICK_PAY_SALARIED',
  /** Company paid absence (non-sickness, salaried) */
  COMPANY_PAID_ABSENCE_NON_SICKNESS_SALARIED = 'COMPANY_PAID_ABSENCE_NON_SICKNESS_SALARIED',
  /** Dependants care */
  DEPENDANTS_CARE = 'DEPENDANTS_CARE',
  /** Sickness and absence paid (salaried team only paid) */
  SICKNESS_AND_ABSENCE_PAID_SALARIED_TEAM_ONLY_PAID = 'SICKNESS_AND_ABSENCE_PAID_SALARIED_TEAM_ONLY_PAID',
  /** Antenatal (paid) */
  ANTENATAL_PAID = 'ANTENATAL_PAID',
  /** Career break */
  CAREER_BREAK = 'CAREER_BREAK',
  /** Carer's Leave - Hourly */
  CARERS_LEAVE_HOURLY = 'CARERS_LEAVE_HOURLY',
  /** Carer's Leave - Salaried */
  CARERS_LEAVE_SALARIED = 'CARERS_LEAVE_SALARIED',
  /** Fertility Leave - Hourly */
  FERTILITY_LEAVE_HOURLY = 'FERTILITY_LEAVE_HOURLY',
  /** Fertility Leave - Salaried */
  FERTILITY_LEAVE_SALARIED = 'FERTILITY_LEAVE_SALARIED',
  /** Fundraising - Other */
  FUNDRAISING_OTHER = 'FUNDRAISING_OTHER',
  /** Jury Service - Unpaid */
  JURY_SERVICE_UNPAID = 'JURY_SERVICE_UNPAID',
  /** Long Term Sickness - Accident at Work */
  LONG_TERM_SICKNESS_ACCIDENT_AT_WORK = 'LONG_TERM_SICKNESS_ACCIDENT_AT_WORK',
  /** Long Term Sickness - Paid */
  LONG_TERM_SICKNESS_PAID = 'LONG_TERM_SICKNESS_PAID',
  /** Long Term Sickness - Unpaid */
  LONG_TERM_SICKNESS_UNPAID = 'LONG_TERM_SICKNESS_UNPAID',
  /** Neonatal leave */
  NEONATAL_LEAVE = 'NEONATAL_LEAVE',
  /** Parental Leave - Unpaid */
  PARENTAL_LEAVE_UNPAID = 'PARENTAL_LEAVE_UNPAID',
  /** Rest day */
  REST_DAY = 'REST_DAY',
  /** Sickness - Accident at Work */
  SICKNESS_ACCIDENT_AT_WORK = 'SICKNESS_ACCIDENT_AT_WORK',
  /** Statutory adoption leave */
  STATUTORY_ADOPTION_LEAVE = 'STATUTORY_ADOPTION_LEAVE',
  /** Study Leave - Unpaid */
  STUDY_LEAVE_UNPAID = 'STUDY_LEAVE_UNPAID',
  /** Training Leave Paid - Development Programmes */
  TRAINING_LEAVE_PAID_DEVELOPMENT_PROGRAMMES = 'TRAINING_LEAVE_PAID_DEVELOPMENT_PROGRAMMES',
  /** Training Leave Paid - Offsite Brand Training */
  TRAINING_LEAVE_PAID_OFFSITE_BRAND_TRAINING = 'TRAINING_LEAVE_PAID_OFFSITE_BRAND_TRAINING',
  /** Unpaid - Family Commitments */
  UNPAID_FAMILY_COMMITMENTS = 'UNPAID_FAMILY_COMMITMENTS',
  /** Unpaid sickness */
  UNPAID_SICKNESS = 'UNPAID_SICKNESS',
  /** Unpaid Sickness - Accident at Work */
  UNPAID_SICKNESS_ACCIDENT_AT_WORK = 'UNPAID_SICKNESS_ACCIDENT_AT_WORK',
  /** Birthday */
  BIRTHDAY = 'BIRTHDAY',
  /** Special Days */
  SPECIAL_DAYS = 'SPECIAL_DAYS',
}

/** A CoreTeamMember represents the values for the core team member for a Site which can be assigned to a Shift in the schedule. */
export type CoreTeamMember = {
  __typename?: 'CoreTeamMember';
  /** The PartnerMemberProfile ID for the CoreTeamMember. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The fullname of the CoreTeamMember. */
  fullname: Scalars['String'];
  /** The PartnerMemberProfile associated with the CoreTeamMember. */
  employee: PartnerMemberProfile;
  /** The role configuration for the core team member. */
  roleV2: RoleConfiguration;
  /** The list of backup role configurations that the CoreTeamMember can be scheduled for. */
  secondaryRolesV2: Array<RoleConfiguration>;
  /** The job title of the CoreTeamMember. */
  jobTitle: Scalars['String'];
  /** The contract type for the CoreTeamMember when the schedule was generated. */
  contractType: ContractType;
  /**
   * The expected working hours that were used while generating the schedule for the CoreTeamMember.
   * @deprecated Replaced by decimal field expected_hours_v2
   */
  expectedHours?: Maybe<Scalars['Int']>;
  /** The expected working hours that were used while generating the schedule for the CoreTeamMember. */
  expectedHoursV2?: Maybe<Scalars['Decimal']>;
  /**
   * The original expected hours for the core team member before any override was applied for the week.
   * @deprecated Replaced by decimal field original_expected_hours_v2
   */
  originalExpectedHours?: Maybe<Scalars['Int']>;
  /** The original expected hours for the core team member before any override was applied for the week. */
  originalExpectedHoursV2?: Maybe<Scalars['Decimal']>;
  /** The minimum weekly hours for this core team member, snapshotted from the member's site scheduling configuration at the time of generating the schedule. Null when no minimum hours are configured for this member at this site, or when the member is not on a fully-flexible contract for the full scheduled week. */
  minHours?: Maybe<Scalars['Decimal']>;
  /** Whether or not the CoreTeamMember is classified as a young worker. */
  isYoungWorker: Scalars['Boolean'];
  /** The legal status of the CoreTeamMember. */
  legalStatus: LegalStatus;
  /** A boolean indicating whether the PartnerMember is undergoing a training process. */
  training: Scalars['Boolean'];
  /** A 0-to-5 integer representing the skill level of a PartnerMember. If the PartnerMember is in training, the skill level is always set to zero. */
  skillLevel: Scalars['Int'];
  /**
   * The WorkingPreferences that were used while generating the schedule for the CoreTeamMember.
   * @deprecated This field is deprecated and will be removed in the future. Use workingAvailability instead.
   */
  workingPreferences: WorkingPreferences;
  /** The WorkingAvailability that were used while generating the schedule for the CoreTeamMember. */
  workingAvailability?: Maybe<WorkingAvailabilityType>;
  /** Whether or not the expected hours and working preferences values were overridden for the week's schedule. */
  userOverride: Scalars['Boolean'];
  /** The working time rules that are violated for the CoreTeamMember for the schedule. */
  workingTimeRuleViolations: Array<WorkingTimeRule>;
  /** The Right to Work information for the CoreTeamMember. */
  rightToWork: EmployeeRTW;
  /** Whether or not the CoreTeamMember is external to the site. */
  isExternal: Scalars['Boolean'];
  /** The optional primary site ID for the CoreTeamMember. Nullable because not all members have a designated primary site — multi-site and flexible-contract employees may have no primary site assigned. Use this field if only the ID is needed, as it is more performant than requesting the full primarySite object. */
  primarySiteId?: Maybe<Scalars['UUID']>;
  /** The optional primary site for the CoreTeamMember. Nullable because not all members have a designated primary site — multi-site and flexible-contract employees may have no primary site assigned. */
  primarySite?: Maybe<PartnerNode>;
};

/** A core team member absence record. */
export type CoreTeamMemberAbsence = {
  __typename?: 'CoreTeamMemberAbsence';
  /** The unique identifier for the absence. */
  id: Scalars['UUID'];
  /** The Partner Member Profile ID of the Core Team Member that the absence is for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The start date of the absence. */
  startDate: Scalars['Date'];
  /** The end date of the absence. */
  endDate: Scalars['Date'];
  /** The type of absence. */
  type: CoreTeamAbsenceType;
  /**
   * The number of effective days for this absence.
   * @deprecated This field is no longer passed by the FE.
   */
  effectiveDays?: Maybe<Scalars['Decimal']>;
  /**
   * The number of effective hours for this absence.
   * @deprecated This field is no longer passed by the FE.
   */
  effectiveHours?: Maybe<Scalars['Decimal']>;
  /** Optional note about the absence. */
  note?: Maybe<Scalars['String']>;
  /** The supporting documents for this absence. The list of documents that are returned depends  on the user's permissions:  - the employee the absence belongs to sees only documents visible to employees,  - someone in the manager line for that employee sees all linked documents,    the manager line for that employee sees all linked documents - in any other case an empty list is returned. */
  supportingDocuments?: Maybe<Array<Maybe<EmployeeDocument>>>;
};

/** Contains the core team member who has an absence at the site, along with other required info. */
export type CoreTeamMemberAbsenceAtSite = {
  __typename?: 'CoreTeamMemberAbsenceAtSite';
  /** The core team member's absence */
  absence: CoreTeamMemberAbsence;
  /** The partner member who has this absence */
  partnerMember: PartnerMember;
};

/** The absence information for a core team member. */
export type CoreTeamMemberAbsenceInfo = {
  __typename?: 'CoreTeamMemberAbsenceInfo';
  /** The core team member's absences. */
  absences: Array<CoreTeamMemberAbsence>;
};

/** Allows filtering of dates when requesting all absences at a site. */
export type CoreTeamMemberAbsencesAtSiteInput = {
  /** Only absences with an end date greater than or equal to this date will be returned. If omitted, all absences before the lte filter will be returned. */
  gte?: Maybe<Scalars['Date']>;
  /** Only absences with a start date less than or equal to this date will be returned. If omitted, all absences after the gte filter will be returned. */
  lte?: Maybe<Scalars['Date']>;
};

/** Contains the dynamic working preference for a core team member at a site along with their partner member. */
export type CoreTeamMemberDynamicWorkingPreferenceAtSite = {
  __typename?: 'CoreTeamMemberDynamicWorkingPreferenceAtSite';
  /** The dynamic working preference */
  preference: DynamicWorkingPreference;
  /** The partner member */
  partnerMember: PartnerMember;
};

/** The input values required to retrieve dynamic working preferences at a site over a specific date range. */
export type CoreTeamMemberDynamicWorkingPreferencesInput = {
  /** The start date for the date range. */
  startDate: Scalars['Date'];
  /** The end date for the date range. */
  endDate: Scalars['Date'];
  /** A list of preference values to filter by. */
  preferenceIn: Array<Maybe<WorkingPreference>>;
};

/** CoreTeamMemberFeatures is used to define which features are available for an Employee. */
export enum CoreTeamMemberFeatures {
  /** Leave management e.g. holiday and absence requests is enabled for an Employee. */
  LEAVE_MANAGEMENT = 'LEAVE_MANAGEMENT',
  /** Managing of an Employee's documents is enabled. */
  DOCUMENTS = 'DOCUMENTS',
  /** Managing of an Employee's contact details is enabled. */
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  /** The managing of an Employee's payroll is enabled. */
  PAYROLL = 'PAYROLL',
  /** An Employee can access on-demand pay. */
  ON_DEMAND_PAY = 'ON_DEMAND_PAY',
  /** Managing of an Employee's integrations is enabled. */
  INTEGRATIONS = 'INTEGRATIONS',
}

/** A holiday adjustment for a core team member. This represents a change to the holiday allowanceof a core team member. */
export type CoreTeamMemberHolidayAdjustment = {
  __typename?: 'CoreTeamMemberHolidayAdjustment';
  /** The adjustment to the holiday days remaining for the core team member. */
  daysRemainingAdjustment: Scalars['Decimal'];
  /** The full name of the user who made the holiday adjustment for the core team member. */
  adjustedBy: Scalars['String'];
  /** The time at which this holiday adjustment was made. */
  adjustedAt: Scalars['DateTime'];
};

/** Contains the core team member who has booked holiday at the site, along with other required info. */
export type CoreTeamMemberHolidayAtSite = {
  __typename?: 'CoreTeamMemberHolidayAtSite';
  /** The core team members holiday request */
  holidayRequest: CoreTeamMemberHolidayRequest;
  /** The partner member who has requested this holiday */
  partnerMember: PartnerMember;
};

/** Contains the partner members for the core team member who has booked holiday at the site(s), along with other required info. */
export type CoreTeamMemberHolidayAtSites = {
  __typename?: 'CoreTeamMemberHolidayAtSites';
  /** The core team members holiday request */
  holidayRequest: CoreTeamMemberHolidayRequest;
  /** A list of partner members for a core team member's site(s) */
  partnerMembers: Array<PartnerMember>;
};

/** A single day within a core team member holiday request. */
export type CoreTeamMemberHolidayDay = {
  __typename?: 'CoreTeamMemberHolidayDay';
  /** The date of this holiday day. */
  date: Scalars['Date'];
  /** The type of holiday request for this day. */
  type: CoreTeamMemberHolidayDayType;
};

/** The input values required for a single day's holiday request. */
export type CoreTeamMemberHolidayDayInput = {
  /** The date for this holiday day request. */
  date: Scalars['Date'];
  /** The type of holiday request (ALL_DAY, EARLY, or LATE). */
  type: CoreTeamMemberHolidayDayType;
};

/** The type of holiday request being made. */
export enum CoreTeamMemberHolidayDayType {
  /** On holiday all day */
  ALL_DAY = 'ALL_DAY',
  /** On holiday during the early half of the day */
  EARLY = 'EARLY',
  /** On holiday during the late half of the day */
  LATE = 'LATE',
}

/** GraphQL type for representing core team member holiday information. */
export type CoreTeamMemberHolidayInfo = {
  __typename?: 'CoreTeamMemberHolidayInfo';
  /** The balances for the current active policy period. Null when the employee has no active policy. */
  currentBalancesPeriod?: Maybe<EmployeeHolidayBalancesPeriod>;
  /** A list of balances for each past holiday policy period the employee has belonged to. These supersede the individual balance fields on this type. */
  historicBalancesPeriods: Array<EmployeeHolidayBalancesPeriod>;
  /** The current holiday policy that the core team member is assigned to. Null when they are not assigned to a policy yet. */
  currentPolicy?: Maybe<EmployerHolidayPolicy>;
  /** All holiday requests that the core team member has made. */
  requests: Array<CoreTeamMemberHolidayRequest>;
  /** All manual holiday adjustments that have been made for the core team member in the current holiday period. */
  manualAdjustments: Array<CoreTeamMemberHolidayAdjustment>;
  /** The number of days remaining in the current holiday period. This does not include days that haven't been approved. */
  daysRemaining: Scalars['Decimal'];
  /** The number of paid holiday days taken in the current holiday period. */
  paidDaysTaken: Scalars['Decimal'];
  /** The number of unpaid holiday days taken in the current holiday period. */
  unpaidDaysTaken: Scalars['Decimal'];
  /** The number of days accrued in the current holiday period. */
  daysAccrued: Scalars['Decimal'];
  /** The working summary for the core team member. Null if the core team member does not exist in the HR service. */
  workingSummary?: Maybe<CoreTeamMemberWorkingSummary>;
  /** The number of holiday hours remaining in the policy period. */
  hoursRemaining: Scalars['Decimal'];
  /** The number of holiday days remaining in the policy period up to the current date, not including future holiday requests. */
  daysRemainingToDate: Scalars['Decimal'];
  /** The number of holiday hours remaining in the policy period up to the current date, not including future holiday requests. */
  hoursRemainingToDate: Scalars['Decimal'];
  /** The projected number of hours that the core team member will have remaining in the current policy period if all pending holiday requests are approved. */
  projectedHoursRemaining: Scalars['Decimal'];
  /** The projected number of days that the core team member will have remaining in the current policy period if all pending holiday requests are approved. */
  projectedDaysRemaining: Scalars['Decimal'];
};

/** A holiday request for a core team member. */
export type CoreTeamMemberHolidayRequest = {
  __typename?: 'CoreTeamMemberHolidayRequest';
  /** The id associated with this holiday request. */
  id: Scalars['UUID'];
  /** The day breakdown showing half days, etc. */
  days: Array<CoreTeamMemberHolidayDay>;
  /** The start date of the holiday period. */
  startDate: Scalars['Date'];
  /** The end date of the holiday period. */
  endDate: Scalars['Date'];
  /** Whether this is a paid holiday request. */
  paid: Scalars['Boolean'];
  /** The number of days that has been requested. */
  totalDays: Scalars['Decimal'];
  /** An optional note for the manager. */
  note?: Maybe<Scalars['String']>;
  /** The current status of the requested holiday.  */
  status: CoreTeamMemberHolidayRequestStatus;
  /** The time at which this holiday was requested. If this was added by a manager in an already approved state, this will be the time the manager added this. */
  requestedAt: Scalars['DateTime'];
  /** An optional note for extra information about the rejection. */
  rejectionNote?: Maybe<Scalars['String']>;
  /** The week breakdown of the holiday's effective days. */
  weekBreakdown: Array<HolidayRequestWeekBreakdown>;
  /** The activity log showing status changes for this holiday request. */
  activityLog: Array<HolidayRequestActivity>;
};

/** The input values required for a core team member to request a holiday. */
export type CoreTeamMemberHolidayRequestInput = {
  /** The start date of the holiday. */
  startDate: Scalars['Date'];
  /** The end date of the holiday. */
  endDate: Scalars['Date'];
  /** An optional note for the core team member. */
  note?: Maybe<Scalars['String']>;
  /** The days of the holiday. */
  days: Array<CoreTeamMemberHolidayDayInput>;
  /** The week breakdown of the holiday's effective days. */
  weekBreakdown?: Maybe<Array<HolidayRequestWeekBreakdownInput>>;
};

/** The output values from requesting a holiday as a core team member. */
export type CoreTeamMemberHolidayRequestOutput = {
  __typename?: 'CoreTeamMemberHolidayRequestOutput';
  /** The holiday request that was created. */
  holiday: CoreTeamMemberHolidayRequest;
};

/** The status of a core team member holiday request. */
export enum CoreTeamMemberHolidayRequestStatus {
  /** The holiday request is awaiting approval. */
  PENDING = 'PENDING',
  /** The holiday request has been approved. */
  APPROVED = 'APPROVED',
  /** The holiday request has been rejected. */
  REJECTED = 'REJECTED',
  /** The holiday request has been cancelled. */
  CANCELLED = 'CANCELLED',
}

/** Allows filtering of dates when requesting all holidays at a site. */
export type CoreTeamMemberHolidaysAtSiteInput = {
  /** Only holidays with an end date of the holiday request greater than or equal to this date will be returned. If omitted, all holiday before the lte filter will be returned. */
  gte?: Maybe<Scalars['Date']>;
  /** Only holidays with a start date of the holiday request less than or equal to this date will be returned. If omitted, all holiday after the gte filter will be returned. */
  lte?: Maybe<Scalars['Date']>;
  /** Only holidays with statuses in this list will be returned. If omitted, only PENDING and APPROVED holidays will be returned. */
  statusIn?: Maybe<Array<Maybe<CoreTeamMemberHolidayRequestStatus>>>;
  /** Only partner members at this site with the primary role configuration ID in this list will have their holidays returned. If omitted, all partner members at this site will have their holidays returned. */
  roleConfigurationIdIn?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/** A summary of the working hours for a core team member. */
export type CoreTeamMemberWorkingSummary = {
  __typename?: 'CoreTeamMemberWorkingSummary';
  /** The average total number of days that the core team member works per week. */
  workingDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** The average total number of hours that the core team member works per day. */
  workingHoursPerDay?: Maybe<Scalars['Decimal']>;
  /** The start date at partner. */
  startDateAtPartner: Scalars['Date'];
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  shortCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** List of regions, comma separated */
  regions?: Maybe<Scalars['String']>;
};

export type CountryFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  shortCode?: Maybe<Scalars['String']>;
  /** shortCode_search */
  shortCode_search?: Maybe<Scalars['String']>;
  /** shortCode_gte */
  shortCode_gte?: Maybe<Scalars['String']>;
  /** shortCode_lte */
  shortCode_lte?: Maybe<Scalars['String']>;
  /** shortCode_istartswith */
  shortCode_istartswith?: Maybe<Scalars['String']>;
  /** shortCode_lt */
  shortCode_lt?: Maybe<Scalars['String']>;
  /** shortCode_gt */
  shortCode_gt?: Maybe<Scalars['String']>;
  /** shortCode_isnull */
  shortCode_isnull?: Maybe<Scalars['Boolean']>;
  /** shortCode_iendswith */
  shortCode_iendswith?: Maybe<Scalars['String']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  shortCode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The CreateAccountNodeInput class defines the input values that are required from the client in order to create a
 * NodeType.ACCOUNT PartnerNode object.
 */
export type CreateAccountNodeInput = {
  /** The name of the NodeType.ACCOUNT PartnerNode. */
  name: Scalars['String'];
  /** The CompaniesHouseInformation input values to be used to create the related CompaniesHouseInformation object. */
  companiesHouseInformation: CompaniesHouseInformationInput;
  /** The optional PartnerBrand input values to be used to create the related PartnerBrand object. */
  partnerBrand?: Maybe<PartnerBrandInput>;
};

/**
 * The CreateAgreementInput class defines the input values that are required from the client in order to create an
 * Agreement object.
 */
export type CreateAgreementInput = {
  /** The ID of the primary PartnerNode that the Agreement belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** The ID of the Document object that contains the url setup during the upload intent process. */
  documentId: Scalars['UUID'];
  /** The type of Agreement. */
  agreementType: AgreementType;
  /** Boolean to dictate whether or not to surface this Agreement to the relevant parties. */
  enabled: Scalars['Boolean'];
};

/** Input for createAutoSchedulerCustomRule. */
export type CreateAutoSchedulerCustomRuleInput = {
  /** The ID of the site to create the rule for. */
  siteId: Scalars['UUID'];
  /** The week commencing date this rule applies to. */
  weekCommencing: Scalars['Date'];
  /** The rule text. */
  rule: Scalars['String'];
};

/** Response for createAutoSchedulerCustomRule. */
export type CreateAutoSchedulerCustomRuleOutput = {
  __typename?: 'CreateAutoSchedulerCustomRuleOutput';
  /** The newly created auto scheduler custom rule. */
  autoSchedulerCustomRule: AutoSchedulerCustomRule;
};

/** Input for creating a break rule. */
export type CreateBreakRuleInput = {
  /** The ID of the partner account to create the break rule for. */
  partnerAccountId: Scalars['UUID'];
  /** The locale this rule applies to. */
  localeCode: BreakRuleLocale;
  /** Whether this rule applies to young workers (under 18) rather than adults. */
  isYoungWorker: Scalars['Boolean'];
  /** The minimum shift duration, in minutes, at which the rule applies. Must be >= 0. */
  minimumShiftDurationMinutes: Scalars['Int'];
  /** The minimum break duration, in minutes, required for matching shifts. */
  minimumBreakDurationMinutes: Scalars['Int'];
};

/** Output for creating a break rule. */
export type CreateBreakRuleOutput = {
  __typename?: 'CreateBreakRuleOutput';
  /** The created break rule. */
  breakRule: BreakRule;
};

/** The input values required from a client to create a bulk employee upload. */
export type CreateBulkEmployeeUploadInput = {
  /** The partner account to upload the employees to. */
  accountId: Scalars['UUID'];
  /** The ID of the Document record created by the preceding initiateFileUpload call. */
  documentId: Scalars['UUID'];
  /** The original file name of the uploaded CSV. */
  filename: Scalars['String'];
};

/** The output values returned to the client from the CreateBulkEmployeeUpload mutation. */
export type CreateBulkEmployeeUploadOutput = {
  __typename?: 'CreateBulkEmployeeUploadOutput';
  /** The created bulk employee upload. */
  upload: BulkEmployeeUpload;
};

/**
 * The CreateCheckoutSessionInput class defines the input values that are required from the client
 * in order to create an CheckoutSession object.
 */
export type CreateCheckoutSessionInput = {
  /** The success path to be appended to the partner URL. */
  successPath: Scalars['String'];
  /** The cancel path to be appended to the partner URL. */
  cancelPath: Scalars['String'];
};

/**
 * The CreateCompaniesHouseInformationInput class defines the input values that are required from
 * the client in order to create a CompaniesHouseInformation object.
 */
export type CreateCompaniesHouseInformationInput = {
  /** The ID of the PartnerNode that the CompaniesHouseInformation will belong to. Used to determine if the user has the required permission to create the CompaniesHouseInformation. */
  partnerNodeId: Scalars['UUID'];
  /** The Companies House number. */
  number: Scalars['String'];
  /** The address registered with Companies House. */
  address: Scalars['String'];
  /** The name registered with Companies House. */
  name: Scalars['String'];
};

/** Input for createDemandForecastHeadcount. */
export type CreateDemandForecastHeadcountInput = {
  /** Site the demand forecast belongs to. */
  siteId: Scalars['UUID'];
  /** Date of the demand forecast being modified. */
  forecastDate: Scalars['Date'];
  /** True for a Stint-staffed headcount; false for a partner-staffed headcount. Mutually exclusive with roleConfigurationId: if isStint is false, roleConfigurationId is required. */
  isStint: Scalars['Boolean'];
  /** Scheduled start time for this headcount entry. Must be before endTime. */
  startTime: Scalars['DateTime'];
  /** Scheduled end time for this headcount entry. Must be after startTime. */
  endTime: Scalars['DateTime'];
  /** Role configuration for partner-staffed headcounts. Must belong to the given site. Must be null when isStint is true. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** Optional display name for the headcount entry. Must not exceed the short char field max length. */
  name?: Maybe<Scalars['String']>;
  /** Non-service type for non-service headcounts (e.g. training, admin). Null for service headcounts. When non-null, assignedPartnerMemberProfileId may also be provided. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** Optional partner member profile assigned to this non-service headcount. May only be set when nonServiceType is non-null. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** Optional reference to the recurring shift template this headcount was generated from. Must be null when isStint is true. If provided, must reference a template belonging to this site. */
  recurringShiftTemplateId?: Maybe<Scalars['UUID']>;
};

/** Response for createDemandForecastHeadcount. Returns the full updated headcount list so the client can refresh the shape of day graph, including any concurrent changes made by other users since the page was loaded. */
export type CreateDemandForecastHeadcountOutput = {
  __typename?: 'CreateDemandForecastHeadcountOutput';
  /** Full current list of headcounts for the forecast day after the create operation. */
  headcounts: Array<Headcount>;
};

/** The input values required from a client to create a DemandForecast. */
export type CreateDemandForecastInput = {
  /** The ID of the Site to create the DemandForecast for. */
  siteId: Scalars['UUID'];
  /** The date of the new forecast. */
  forecastDate: Scalars['Date'];
  /** The original forecast value before any updates. */
  expectedForecast: Scalars['Int'];
  /** The ID of the SiteSchedule for the week if it exists. Used to determine if the schedule has been updated since the forecast was loaded to prevent data from being updated if the schedule is out of date. */
  siteScheduleId?: Maybe<Scalars['UUID']>;
  /** The last modified at timestamp of the SiteSchedule if it exists. Used to determine if the schedule has been updated since it was loaded to prevent it from being updated if it is out of date. */
  siteScheduleLastModifiedAt?: Maybe<Scalars['String']>;
};

/** The input values required to create an absence request for an employee. */
export type CreateEmployeeAbsenceRequestInput = {
  /** The partner member profile ID of the member that the absence is for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The start date of the absence. */
  startDate: Scalars['Date'];
  /** The end date of the absence. */
  endDate: Scalars['Date'];
  /** The type of absence. */
  type: CoreTeamAbsenceType;
  /** Optional note about the absence. */
  note?: Maybe<Scalars['String']>;
  /** The number of effective days for this absence. */
  effectiveDays?: Maybe<Scalars['Decimal']>;
  /** The number of effective hours for this absence. */
  effectiveHours?: Maybe<Scalars['Decimal']>;
  /** The supporting documents associated with this absence request. */
  supportingDocumentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/** The output values from creating an employee absence request. */
export type CreateEmployeeAbsenceRequestOutput = {
  __typename?: 'CreateEmployeeAbsenceRequestOutput';
  /** The absence that was created. */
  absence: CoreTeamMemberAbsence;
};

/** The input values required from a client to create an employee document. */
export type CreateEmployeeDocumentInput = {
  /** The ID of the PartnerMemberProfile for the employee. */
  profileId: Scalars['UUID'];
  /** The ID of the Document that contains the S3 document details. */
  documentId: Scalars['UUID'];
  /** The display name of the employee document. */
  name: Scalars['String'];
  /** The original file name of the employee document. */
  filename: Scalars['String'];
  /** The category of the employee document. */
  category: EmployeeDocumentCategory;
  /** Whether the employee document is visible to the employee. */
  isVisibleToEmployee?: Maybe<Scalars['Boolean']>;
  /** Whether the employee document is visible only to managers. */
  visibleOnlyToManagers?: Maybe<Scalars['Boolean']>;
};

/** The output values returned to the client from the CreateEmployeeDocument mutation. */
export type CreateEmployeeDocumentOutput = {
  __typename?: 'CreateEmployeeDocumentOutput';
  /** The created employee document. */
  employeeDocument: EmployeeDocument;
};

/** The input values required to create a holiday request on behalf of an employee. */
export type CreateEmployeeHolidayRequestInput = {
  /** The partner member profile ID of the member that is requesting the holiday. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The start date of the holiday. */
  startDate: Scalars['Date'];
  /** The end date of the holiday. */
  endDate: Scalars['Date'];
  /** Whether the holiday is paid or not. */
  paid: Scalars['Boolean'];
  /** An optional note accompanying the request. */
  note?: Maybe<Scalars['String']>;
  /** The days breakdown of the holiday. */
  days: Array<CoreTeamMemberHolidayDayInput>;
  /** The week breakdown of the holiday. */
  weekBreakdown: Array<HolidayRequestWeekBreakdownInput>;
};

/** The output values from creating a holiday request on behalf of an employee. */
export type CreateEmployeeHolidayRequestOutput = {
  __typename?: 'CreateEmployeeHolidayRequestOutput';
  /** The holiday request that was created. */
  holiday: CoreTeamMemberHolidayRequest;
};

/** The input values required to create an employee. */
export type CreateEmployeeInput = {
  /** The ID of the Account Node the employee is being created for. */
  accountId: Scalars['UUID'];
  /** The full name of the employee. */
  fullname?: Maybe<Scalars['String']>;
  /** The given name of the employee. */
  givenName?: Maybe<Scalars['String']>;
  /** The middle names of the employee. */
  middleNames?: Maybe<Scalars['String']>;
  /** The family name of the employee. */
  familyName?: Maybe<Scalars['String']>;
  /** The date of birth of the employee. */
  dateOfBirth: Scalars['Date'];
  /** The national insurance number of the employee. */
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  /** The email address of the employee. */
  emailAddress: Scalars['String'];
  /** The date the employee will start / started at the partner. */
  startDate: Scalars['Date'];
  /** The legal status of the employee. It is required that the client provides a value. This field will remain nullable, because it will be quickly deprecated and removed. */
  legalStatus?: Maybe<LegalStatus>;
};

/** The output values from creating an employee. */
export type CreateEmployeeOutput = {
  __typename?: 'CreateEmployeeOutput';
  /** The id of the created profile. */
  partnerMemberProfileId: Scalars['UUID'];
};

/** The input values required to create an Employee performance note. */
export type CreateEmployeePerformanceNoteInput = {
  /** The PartnerMemberProfile ID of the Employee to submit the note for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The title of the performance note. */
  title: Scalars['String'];
  /** The description of the performance note. */
  description: Scalars['String'];
  /** The IDs of the Document objects to attach as supporting documents for the note. Each Document will be linked to an EmployeeDocument with employee document type PERFORMANCE_NOTE_SUPPORTING_DOCUMENT. */
  supportingDocumentIds?: Maybe<Array<Scalars['UUID']>>;
};

/** The output values returned after creating an Employee performance note. */
export type CreateEmployeePerformanceNoteOutput = {
  __typename?: 'CreateEmployeePerformanceNoteOutput';
  /** The created Employee performance note. */
  employeePerformanceNote: EmployeePerformanceNote;
};

/** The input values required from the employee user to create a RTWScreening. */
export type CreateEmployeeRightToWorkScreeningInput = {
  /** The ID of the partner member profile to which the employee belongs. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The document that corroborates the Employee's right to work */
  document?: Maybe<RTWFileInput>;
  /** The ISO 8601 timestamp (with timezone) at which this check expires. If omitted, the check has been deemed to have no expiry. */
  expiresAt?: Maybe<Scalars['DateTime']>;
};

/** Represents CreateEmployeeRightToWorkScreeningOutput for an Employee. */
export type CreateEmployeeRightToWorkScreeningOutput = {
  __typename?: 'CreateEmployeeRightToWorkScreeningOutput';
  /** The Right to Work information for the Employee. */
  employeeRtw: EmployeeRTW;
};

/** The input values required to create an employee termination. */
export type CreateEmployeeTerminationInput = {
  /** The ID of the PartnerMemberProfile who is having their employment terminated */
  partnerMemberProfileId: Scalars['UUID'];
  /** The employee's final working day at the partner organization. This represents their last day of active employment, not the day after. */
  employmentEndDate: Scalars['Date'];
  /** The reason the employee's employment ended at the partner. */
  reason: EmployeeEmploymentTerminationReason;
  /** Whether the employee termination was voluntary or not. */
  voluntary: Scalars['Boolean'];
  /** Whether the employee should be considered for rehire at the partner. */
  considerForRehire: Scalars['Boolean'];
  /** A note about the employee termination. This is optional and can be used to provide additional context about the termination. */
  note?: Maybe<Scalars['String']>;
};

/** The output values from creating an employee termination. */
export type CreateEmployeeTerminationOutput = {
  __typename?: 'CreateEmployeeTerminationOutput';
  /** The PartnerMemberProfile associated with the Employee. */
  employee: PartnerMemberProfile;
};

/** The input values required to create an Employee working contract. */
export type CreateEmployeeWorkingContractInput = {
  /** The PartnerMemberProfile ID of the Employee to create the contract for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The expected number of weekly working hours for the contract. */
  expectedHours?: Maybe<Scalars['Decimal']>;
  /** The employee's job title for the contract. */
  jobTitle: Scalars['String'];
  /** The ID of the PartnerJobTitle for the contract. */
  jobTitleId?: Maybe<Scalars['UUID']>;
  /** The employee's pay rate for the contract. */
  payRate: Scalars['Decimal'];
  /** The type of contract. */
  contractType: ContractType;
  /** The date the contract becomes active. Null for the first contract. */
  activeFrom?: Maybe<Scalars['Date']>;
  /** The constraint type for contracted hours. Null when no contracted hours arrangement is required. */
  contractedHoursConstraint?: Maybe<ContractedHoursConstraint>;
  /** The contracted hours value. Required when a contracted hours constraint is specified. */
  contractedHours?: Maybe<Scalars['Decimal']>;
  /** The contracted days per week. Required when the contracted hours constraint is MINIMUM. */
  contractedDays?: Maybe<Scalars['Decimal']>;
};

/** The output values returned after creating an Employee working contract. */
export type CreateEmployeeWorkingContractOutput = {
  __typename?: 'CreateEmployeeWorkingContractOutput';
  /** The created Employee working contract. */
  workingContract: EmployeeWorkingContract;
  /** The Employee the contract was created for. */
  employee: PartnerMemberProfile;
};

/**
 * The CreateGroupNodeInput class defines the input values that are required from the client in order to create a
 * NodeType.GROUP PartnerNode object.
 */
export type CreateGroupNodeInput = {
  /** The ID of the parent PartnerNode that the new NodeType.GROUP PartnerNode is to be created under. */
  parentNodeId: Scalars['UUID'];
  /** The name of the NodeType.GROUP PartnerNode. */
  name: Scalars['String'];
  /** The optional CompaniesHouseInformation input values to be used to create the related CompaniesHouseInformation object. */
  companiesHouseInformation?: Maybe<CompaniesHouseInformationInput>;
  /** The optional PartnerBrand input values to be used to create the related PartnerBrand object. */
  partnerBrand?: Maybe<PartnerBrandInput>;
};

/** GraphQL input type for creating a holiday policy. */
export type CreateHolidayPolicyInput = {
  /** The name of the holiday policy. */
  name: Scalars['String'];
  /** The day and monthin the year when the holiday allowance resets. */
  resets: MonthDayInput;
  /** Whether employees can request holiday they have not accrued yet. */
  requestUnaccruedHoliday: Scalars['Boolean'];
  /** Whether employees can request holiday that falls in the next accrual period. */
  allowHolidayRequestsInNextPeriod: Scalars['Boolean'];
  /** The way holiday is accrued for this policy. */
  accrualType: EmployerHolidayPolicyAccrualType;
  /** Contains the fixed accrual holiday policy configuration, only required if accrual_type is `FIXED`. */
  fixedAccrual?: Maybe<EmployerHolidayPolicyFixedAccrualInput>;
  /** Contains the hourly accrual holiday policy configuration, only required if accrual_type is `HOURLY`. */
  hourlyAccrual?: Maybe<EmployerHolidayPolicyHourlyAccrualInput>;
  /** Default days/week used to pro-rate allowance against contracted_days. */
  defaultDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** Default hours/week used to pro-rate allowance against contracted_hours. */
  defaultHoursPerWeek?: Maybe<Scalars['Decimal']>;
  /** The maximum number of unaccrued holiday days an employee can request. Null means no cap. */
  maxUnaccruedHolidayDaysRequestable?: Maybe<Scalars['Decimal']>;
  /** The ID of the account node for which the holiday policy is being created. */
  accountId: Scalars['UUID'];
};

/** GraphQL output type for creating a holiday policy. */
export type CreateHolidayPolicyOutput = {
  __typename?: 'CreateHolidayPolicyOutput';
  /** The holiday policy that was created. */
  policy: EmployerHolidayPolicy;
};

/** The input values required from the staff user to create a manual RTWScreening. */
export type CreateManualRightToWorkScreeningInput = {
  /** The ID of the Stinter (StintUser) who the manual check is on behalf of. */
  stinterId: Scalars['UUID'];
  /**
   * The image of the Stinter that has been verified to corroborate their likeness.
   *
   * This will be stored in S3 in the same way both IDSP and SHARE_CODE
   * store the likeness photo, so that the app can immediately fetch this.
   *
   * Any existing photo will be overwritten with this new content.
   */
  likenessPhoto: RTWFileInput;
  /**
   * The document that corroborates the Stinter's right to work.
   *
   * This will be stored in S3 in the same manner as the IDSP and SHARE_CODE
   * screenings.
   *
   * No automated checks will be run on this document. We are going to rely on
   * trust that the staff user who has added this manual screening has carried out
   * the appropriate due dilligence.
   */
  document: RTWFileInput;
  /** The ISO 8601 timestamp (with timezone) at which this check expires. If omitted, the check has been deemed to have no expiry. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** The number of hours the Stinter is limited to working during term times. If omitted, then no limit on the number of hours is assumed. */
  termTimeWeeklyCap?: Maybe<Scalars['Int']>;
};

/**
 * The CreateOffenceInput class defines the input values that are required from the client
 * in order to manually create an Offence object.
 */
export type CreateOffenceInput = {
  /** The related Stinter profile ID (StudentProfile.ref). */
  stinterProfileRef: Scalars['UUID'];
  /** The OffenceReason value. Only options from ValidOffenceReason can be used when creating a new Offence object. */
  reason: ValidOffenceReason;
  /** The related Stint ID (ref). This is only not required when you are adding a redemption Offence. */
  stintRef?: Maybe<Scalars['UUID']>;
};

/** The input values required from a client to create a OperationalEvent. */
export type CreateOperationalEventInput = {
  /** The Site ID for which an OperationalEvent should be created. */
  siteId: Scalars['UUID'];
  /** The name of the new operational event. */
  name: Scalars['String'];
  /** The day of the week for the OpearionalEvent being created. */
  dayOfWeek: WeekDay;
  /** The start time for the OperationalEvent being created. */
  startTime: Scalars['Time'];
  /** The end time for the OperationalEvent being created. */
  endTime: Scalars['Time'];
};

/** The input values required to create an out-of-term request. */
export type CreateOutOfTermRequestInput = {
  /** The ID of the Stinter the request is for. Allows the mutation to be reused for both Stinters creating their own request and staff users creating a request on behalf of a Stinter. */
  stinterId: Scalars['UUID'];
  /** The start date of the out-of-term period. */
  startDate: Scalars['Date'];
  /** The end date of the out-of-term period. */
  endDate: Scalars['Date'];
  /** The supporting document proving the Stinter is outside of term time. Required when the request is submitted by a Stinter. */
  document?: Maybe<DocumentInput>;
};

/** The output type for the createOutOfTermRequest mutation. */
export type CreateOutOfTermRequestOutput = {
  __typename?: 'CreateOutOfTermRequestOutput';
  /** The created out-of-term request. */
  outOfTermRequest: OutOfTermRequest;
};

/** The input values required to create a partner account API token. */
export type CreatePartnerAccountAPITokenInput = {
  /** The ID of the partner account this token belongs to. */
  accountId: Scalars['UUID'];
  /** A human-readable label for the token. */
  name: Scalars['String'];
  /** The list of scopes to grant to this token. */
  scopes: Array<PartnerAccountAPITokenScope>;
};

/** The output values returned from the createPartnerAccountAPIToken mutation. */
export type CreatePartnerAccountAPITokenOutput = {
  __typename?: 'CreatePartnerAccountAPITokenOutput';
  /** The plaintext token value. Only visible once at creation time. */
  tokenValue: Scalars['String'];
  /** The created token record. */
  token: PartnerAccountAPIToken;
};

/**
 * The CreatePartnerBrandInput class defines the input values that are required from the client in order to
 * create a PartnerBrand object.
 */
export type CreatePartnerBrandInput = {
  /** The ID of the primary PartnerNode that the PartnerBrand belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** The PartnerBrand logo image base64 value. */
  logoBase64: Scalars['String'];
};

/** The input values required to create a new partner department. */
export type CreatePartnerDepartmentInput = {
  /** The ID of the account to create the department for. */
  accountId: Scalars['UUID'];
  /** The name of the department. */
  name: Scalars['String'];
};

/** The output values returned after creating a partner department. */
export type CreatePartnerDepartmentOutput = {
  __typename?: 'CreatePartnerDepartmentOutput';
  /** The created partner department. */
  department: PartnerDepartmentType;
};

/** Input values required to create a new partner integration. */
export type CreatePartnerIntegrationInput = {
  /** The partner account to create this integration for. */
  accountId: Scalars['UUID'];
  /** The third-party provider to integrate with. */
  provider: PartnerIntegrationProvider;
  /** Whether the integration should be active immediately. */
  active: Scalars['Boolean'];
  /** Provider-hosted SSO URL. Null when the provider has no SSO or it is set later. */
  ssoUrl?: Maybe<Scalars['String']>;
  /** Provide exactly one auth* input, or none to configure auth later. */
  authOAuth?: Maybe<PartnerIntegrationAuthOAuthInput>;
  /** Provide exactly one auth* input, or none to configure auth later. When provided, Stint generates a public/private keypair — the public key is returned on read for installation on the SFTP server; the private key is stored securely and never returned. */
  authSftp?: Maybe<PartnerIntegrationAuthSftpInput>;
  /** Provide exactly one auth* input, or none to configure auth later. */
  authApiKey?: Maybe<PartnerIntegrationAuthApiKeyInput>;
  /** Provide exactly one auth* input, or none to configure auth later. */
  authBasic?: Maybe<PartnerIntegrationAuthBasicInput>;
  /** Provide exactly one auth* input, or none to configure auth later. */
  authPasswordExchange?: Maybe<PartnerIntegrationAuthPasswordExchangeInput>;
};

/** Input values required to create a job title mapping. */
export type CreatePartnerIntegrationJobTitleMappingInput = {
  /** The partner account that owns the integration. */
  partnerAccountId: Scalars['UUID'];
  /** The integration this job title mapping belongs to. */
  integrationId: Scalars['UUID'];
  /** The identifier the provider uses to identify the job title. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint job title to map to. Null creates an unresolved mapping. */
  jobTitleId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully creating a job title mapping. */
export type CreatePartnerIntegrationJobTitleMappingOutput = {
  __typename?: 'CreatePartnerIntegrationJobTitleMappingOutput';
  /** The newly created job title mapping. */
  jobTitleMapping: PartnerIntegrationJobTitleMapping;
};

/** Output returned after successfully creating a partner integration. */
export type CreatePartnerIntegrationOutput = {
  __typename?: 'CreatePartnerIntegrationOutput';
  /** The newly created integration. */
  integration: PartnerIntegration;
};

/** Input values required to create a profile mapping. */
export type CreatePartnerIntegrationProfileMappingInput = {
  /** The partner account that owns the integration. */
  partnerAccountId: Scalars['UUID'];
  /** The integration this profile mapping belongs to. */
  integrationId: Scalars['UUID'];
  /** The identifier the provider uses to identify the profile. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint profile to map to. Null creates an unresolved mapping. */
  profileId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully creating a profile mapping. */
export type CreatePartnerIntegrationProfileMappingOutput = {
  __typename?: 'CreatePartnerIntegrationProfileMappingOutput';
  /** The newly created profile mapping. */
  profileMapping: PartnerIntegrationProfileMapping;
};

/** Input values required to create a role mapping. */
export type CreatePartnerIntegrationRoleMappingInput = {
  /** The partner account that owns the integration. */
  partnerAccountId: Scalars['UUID'];
  /** The integration this role mapping belongs to. */
  integrationId: Scalars['UUID'];
  /** The identifier the provider uses to identify the role. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint role configuration to map to. Null creates an unresolved mapping. */
  roleId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully creating a role mapping. */
export type CreatePartnerIntegrationRoleMappingOutput = {
  __typename?: 'CreatePartnerIntegrationRoleMappingOutput';
  /** The newly created role mapping. */
  roleMapping: PartnerIntegrationRoleMapping;
};

/** Input values required to create a site mapping. */
export type CreatePartnerIntegrationSiteMappingInput = {
  /** The partner account that owns the integration. */
  partnerAccountId: Scalars['UUID'];
  /** The integration this site mapping belongs to. */
  integrationId: Scalars['UUID'];
  /** The identifier the provider uses to identify the site. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint site to map to. Null creates an unresolved mapping. */
  siteId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully creating a site mapping. */
export type CreatePartnerIntegrationSiteMappingOutput = {
  __typename?: 'CreatePartnerIntegrationSiteMappingOutput';
  /** The newly created site mapping. */
  siteMapping: PartnerIntegrationSiteMapping;
};

/** The input values required to create a new partner job title for a specified partner account. */
export type CreatePartnerJobTitleInput = {
  /** The ID of the partner account to create the job title under. */
  accountId: Scalars['UUID'];
  /** The name of the new job title. */
  name: Scalars['String'];
  /** The ID of the department to create the job title under. */
  departmentId?: Maybe<Scalars['UUID']>;
  /** The ID of the job title whose holders manage employees with this job title. Optional. */
  managerJobTitleId?: Maybe<Scalars['UUID']>;
};

/** The output values returned after creating a partner job title. */
export type CreatePartnerJobTitleOutput = {
  __typename?: 'CreatePartnerJobTitleOutput';
  /** The created partner job title. */
  jobTitle: PartnerJobTitleType;
};

/** The input values required to create a new partner job title pay rate. */
export type CreatePartnerJobTitlePayRateInput = {
  /** The ID of the partner job title configuration to create the pay rate for. */
  partnerJobTitleConfigurationId: Scalars['UUID'];
  /** The ID of the account node to create the pay rate for. */
  accountId: Scalars['UUID'];
  /** The date the pay rate becomes active. */
  activeFrom: Scalars['Date'];
  /** The minimum pay rate for employees younger than 18. */
  minimumUnder18PayRate?: Maybe<Scalars['Decimal']>;
  /** The minimum pay rate for employees aged 18-20. */
  minimumUnder21PayRate?: Maybe<Scalars['Decimal']>;
  /** The minimum default pay rate for the job. */
  minimumDefaultPayRate?: Maybe<Scalars['Decimal']>;
};

/** The output values returned after creating a partner job title pay rate. */
export type CreatePartnerJobTitlePayRateOutput = {
  __typename?: 'CreatePartnerJobTitlePayRateOutput';
  /** The created partner job title. */
  jobTitle: PartnerJobTitleType;
};

/** The input values required to create a PartnerMember and related data. */
export type CreatePartnerMemberInput = {
  /** The ID of the primary PartnerNode that the PartnerMember belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** The role for the PartnerMember. */
  role: PartnerRole;
  /** The optional ID of the role configuration in the BI service for scheduling purposes. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** The optional ID of an existing PartnerMemberProfile to create the PartnerMember for. Either profileId or profile must be provided. */
  profileId?: Maybe<Scalars['UUID']>;
  /** The optional PartnerMember values to create for the PartnerMember. Either profileId or profile must be provided. */
  profile?: Maybe<CreatePartnerMemberProfileInput>;
};

/** The input values required to create a PartnerMemberProfile. */
export type CreatePartnerMemberProfileInput = {
  /** The email for the PartnerMemberProfile. */
  email: Scalars['String'];
  /** The fullname for the PartnerMemberProfile. */
  fullname?: Maybe<Scalars['String']>;
  /** The given name for the PartnerMemberProfile. */
  givenName?: Maybe<Scalars['String']>;
  /** The middle names for the PartnerMemberProfile. */
  middleNames?: Maybe<Scalars['String']>;
  /** The family name for the PartnerMemberProfile. */
  familyName?: Maybe<Scalars['String']>;
  /** The date of birth for the PartnerMemberProfile. */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** The legal status for the PartnerMemberProfile. */
  legalStatus?: Maybe<LegalStatus>;
};

/**
 * The CreatePartnerPoolInput class defines the input values that are required from the client in order to
 * create a PartnerPool object.
 */
export type CreatePartnerPoolInput = {
  /** The ID of the PartnerNode that the PartnerPool belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The URL of the form. */
  formUrl: Scalars['String'];
  /** The perks of the PartnerPool. */
  perks?: Maybe<Scalars['String']>;
};

/** The required input values for creating a PoolMemberFeedback. */
export type CreatePoolMemberFeedbackInput = {
  /** The ID of the StintTemplatePoolMember that will be associated to the created PoolMemberFeedback. */
  memberId: Scalars['UUID'];
  /** The feedback comment submitted by the user. */
  comment: Scalars['String'];
};

/** The input values required to create a RecurringEmployeeShift. */
export type CreateRecurringEmployeeShiftInput = {
  /** The ID of the PartnerMemberProfile for which the RecurringEmployeeShift should be created. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the Site for which the RecurringEmployeeShift should be created. */
  siteId: Scalars['UUID'];
  /** The day of the week the shift recurs on. */
  dayOfWeek: WeekDay;
  /** The start time for the recurring employee shift. */
  startTime: Scalars['Time'];
  /** The end time for the recurring employee shift. */
  endTime: Scalars['Time'];
  /** The optional ID of the RoleConfiguration to assign to the recurring employee shift. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
};

/** The output returned after creating a RecurringEmployeeShift. */
export type CreateRecurringEmployeeShiftOutput = {
  __typename?: 'CreateRecurringEmployeeShiftOutput';
  /** The created recurring employee shift. */
  recurringEmployeeShift: RecurringEmployeeShift;
};

/** The input values required to create a RecurringShiftTemplate. */
export type CreateRecurringShiftTemplateInput = {
  /** The ID of the Site for which the RecurringShiftTemplate should be created. */
  siteId: Scalars['UUID'];
  /** The event type for the recurring shift template. */
  eventType?: Maybe<RecurringEventType>;
  /** The optional name of the recurring shift template. */
  name?: Maybe<Scalars['String']>;
  /** The non-service shift type for the recurring shift template. Required when eventType is SHIFT; null for DELIVERY. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The ID of the RoleConfiguration for the recurring shift template; null for RECURRING templates. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** The ID of the CoreTeamMember assigned to the recurring shift template. */
  assignedMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The day of the week the shift recurs on. Retained for backwards compatibility. */
  dayOfWeek?: Maybe<WeekDay>;
  /** The date of the first occurrence of a recurring shift template or the only occurrence of a one-off template. */
  startDate?: Maybe<Scalars['Date']>;
  /** The start time for the recurring shift template. */
  startTime: Scalars['Time'];
  /** The end time for the recurring shift template. */
  endTime: Scalars['Time'];
  /** The recurrence pattern for the recurring shift template. */
  recurrenceRule?: Maybe<RecurrenceRuleInput>;
};

/** The output returned after creating a RecurringShiftTemplate. */
export type CreateRecurringShiftTemplateOutput = {
  __typename?: 'CreateRecurringShiftTemplateOutput';
  /** The created RecurringShiftTemplate. */
  recurringShiftTemplate: RecurringShiftTemplate;
};

/** Input for creating a role configuration. */
export type CreateRoleConfigurationInput = {
  /** The ID of the partner account to create the role configuration for. */
  partnerAccountId: Scalars['UUID'];
  /** The auto schedule role that this role configuration maps to. */
  autoScheduleRole: AutoScheduleRole;
  /** The name of the role configuration. */
  name: Scalars['String'];
  /** The operational area for the role configuration. */
  operationalArea: OperationalArea;
  /** The order index for sorting role configurations. */
  orderIdx: Scalars['Int'];
  /** The minimum headcount duration in minutes. */
  minHeadcountDurationMinutes: Scalars['Int'];
  /** The maximum headcount duration in minutes. */
  maxHeadcountDurationMinutes: Scalars['Int'];
  /** The minimum shift duration in minutes. */
  minShiftDurationMinutes: Scalars['Int'];
  /** The maximum shift duration in minutes. */
  maxShiftDurationMinutes: Scalars['Int'];
  /** The maximum headcount count. Null if unlimited. */
  maxHeadcountCount?: Maybe<Scalars['Int']>;
  /** Whether the role configuration can be a shift or headcount. */
  canBeShiftOrHeadcount: Scalars['Boolean'];
  /** The item covers behaviour for the role configuration. */
  itemCoversBehaviour: ItemCoversBehaviour;
  /** The contract type for open shifts. */
  openShiftContractType: ContractType;
  /** The hourly pay rate for open shifts with this role configuration. */
  openShiftHourlyPayRate: Scalars['Decimal'];
  /** Whether to enforce expected hours for the role configuration. */
  enforceExpectedHours: Scalars['Boolean'];
  /** Whether to hide this role configuration's headcounts in the opportunities module. */
  hideInOpportunities: Scalars['Boolean'];
  /** IDs of dependent role configurations. */
  dependentRoleConfigurationIds: Array<Scalars['UUID']>;
  /** IDs of implicit secondary role configurations. */
  implicitSecondaryRoleConfigurationIds: Array<Scalars['UUID']>;
};

/** Output for creating a role configuration. */
export type CreateRoleConfigurationOutput = {
  __typename?: 'CreateRoleConfigurationOutput';
  /** The created role configuration. */
  roleConfiguration: RoleConfiguration;
};

/**
 * The CreateSiteNodeInput class defines the input values that are required from the client in order to create a
 * NodeType.SITE PartnerNode object.
 */
export type CreateSiteNodeInput = {
  /** The ID of the parent PartnerNode that the new NodeType.SITE PartnerNode is to be created under. */
  parentNodeId: Scalars['UUID'];
  /** The name of the NodeType.SITE PartnerNode. */
  name: Scalars['String'];
  /** An optional external ID that is used by the partner to identify the PartnerNode. */
  partnerUniqueId?: Maybe<Scalars['String']>;
  /** The Address input values to be used to create the related Address object. */
  address: AddressInput;
  /** The PartnerContact input values to be used to create the related PartnerContact object. */
  partnerContact: PartnerContactInput;
  /** The optional PartnerBrand input values to be used to create the related PartnerBrand object. */
  partnerBrand?: Maybe<PartnerBrandInput>;
};

/** The required values in order to create a StintTemplateGroup. */
export type CreateStintTemplateGroupInput = {
  /** The ID of the PartnerNode that the StintTemplateGroup belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The display name that will be given to the group. */
  name: Scalars['String'];
  /** The list of StintTemplate (Role) IDs to be included in the group. */
  stintTemplateIds: Array<Scalars['UUID']>;
};

/** The required values in order to create a StintTemplate (Role). */
export type CreateStintTemplateInput = {
  /** The ID of the Site PartnerNode that the StintTemplate belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The display name that will be given to the StintTemplate. */
  name: Scalars['String'];
  /** The optional notes for the StintTemplate. */
  notes?: Maybe<Scalars['String']>;
  /** The list of StintUniform values for the StintTemplate. */
  uniform: Array<StintUniform>;
  /** The list of primary StintTask values to be set on the StintTemplate. */
  primaryTasks: Array<StintTaskInput>;
  /** The optional list of secondary StintTask values to be set on the StintTemplate. */
  secondaryTasks?: Maybe<Array<StintTaskInput>>;
  /** The optional list of EmploymentException ID values to be set on the StintTemplate. */
  employmentExceptions?: Maybe<Array<Scalars['UUID']>>;
  /** Whether or not the StintTemplate and related Stints are trained. Defaults to False. */
  trained?: Maybe<Scalars['Boolean']>;
  /** The YouTube URL of prep video to help the Stinter be prepared for the Stint. */
  prepVideoUrl?: Maybe<Scalars['String']>;
  /** The ID of the StintTemplateGroup that the StintTemplate belongs to. */
  stintTemplateGroupId?: Maybe<Scalars['UUID']>;
};

/**
 * The CreateStintsInput class defines the input values that are required from
 * the client in order to create Stint objects.
 */
export type CreateStintsInput = {
  /** The ID of the Business that the StintTemplate belongs to. Used to determine if the user has the required permission to create the Stints. */
  businessId: Scalars['UUID'];
  /** The ID of the StintTemplate object to be used while creating the Stint objects. */
  stintTemplateId: Scalars['UUID'];
  /** The start datetime value for the Stints. */
  dateFrom: Scalars['DateTime'];
  /** The end datetime value for the Stints. */
  dateTo: Scalars['DateTime'];
  /** The number of Stints to be created. */
  quantity: Scalars['Int'];
};

/**
 * The CreateWorkExperienceInput class defines the input values that are required
 * from the client in order to create a WorkExperience object.
 */
export type CreateWorkExperienceInput = {
  /** The HospitalityWorkExperience value that the Stinter has provided as an answer to how much work experience they have in the hospitality industry. */
  hospitalityWorkExperience: HospitalityWorkExperience;
};

/** The input values required for creating a working preference request. */
export type CreateWorkingPreferenceRequestInput = {
  /** The IDs of the sites for which the working preference is being requested. */
  siteIds: Array<Maybe<Scalars['UUID']>>;
  /** The date for which the working preference is being requested. */
  date: Scalars['Date'];
  /** The working preference for the date being requested. */
  workingPreference: WorkingPreference;
  /** The reason for the working preference request. */
  reason?: Maybe<Scalars['String']>;
  /** The start time of the working preference request window. */
  startTime?: Maybe<Scalars['Time']>;
  /** The end time of the working preference request window. */
  endTime?: Maybe<Scalars['Time']>;
};

/** The output values that are returned when a working preference request is created. */
export type CreateWorkingPreferenceRequestOutput = {
  __typename?: 'CreateWorkingPreferenceRequestOutput';
  /** The working preference requests that were created. */
  workingPreferenceRequests: Array<Maybe<WorkingPreferenceRequest>>;
};

/** Input for resolving a PartnerMemberProfile's current working contract. */
export type CurrentWorkingContractInput = {
  /** If true, hides every field on the current working contract except expectedHours, jobTitle, jobTitleId, jobTitleV2, contractedHoursConstraint, contractedHours, and contractedDays, regardless of the requesting user's permissions. Defaults to false. */
  alwaysHideSensitiveFields?: Maybe<Scalars['Boolean']>;
};

/** Enum that contains the available error message codes that can be used to raise errors from the data layer. */
export enum DataError {
  BAD_REQUEST = 'BAD_REQUEST',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  FAILED_TO_UPDATE = 'FAILED_TO_UPDATE',
  UNKNOWN_INTEGRITY_ERROR = 'UNKNOWN_INTEGRITY_ERROR',
}

/**
 * DayOfWeek enum class representing the SQL day of week values.
 *
 *     Note that Python day of week values start with Monday as 0 and end with Sunday as 6.
 *     Do not use this enum when working with Python datetime weekday() values.
 */
export enum DayOfWeek {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
}

/** Working preference for a specific day with an optional custom time window. */
export type DayWorkingAvailabilityInput = {
  /** The working preference specified for that day. */
  workingPreference: WorkingPreference;
  /** The start time of the custom unavailability window. */
  startTime?: Maybe<Scalars['Time']>;
  /** The end time of the custom unavailability window. */
  endTime?: Maybe<Scalars['Time']>;
};

/** Working preference for a specific day with an optional custom time window. */
export type DayWorkingAvailabilityType = {
  __typename?: 'DayWorkingAvailabilityType';
  /** The working preference specified for that day. */
  workingPreference: WorkingPreference;
  /** The start time of the custom unavailability window. */
  startTime?: Maybe<Scalars['Time']>;
  /** The end time of the custom unavailability window. */
  endTime?: Maybe<Scalars['Time']>;
};

/** Input for deleteAutoSchedulerCustomRule. */
export type DeleteAutoSchedulerCustomRuleInput = {
  /** The ID of the site the rule belongs to. Used to validate ownership. */
  siteId: Scalars['UUID'];
  /** The ID of the rule to delete. */
  id: Scalars['UUID'];
};

/** Response for deleteAutoSchedulerCustomRule. */
export type DeleteAutoSchedulerCustomRuleOutput = {
  __typename?: 'DeleteAutoSchedulerCustomRuleOutput';
  /** True if the rule was successfully deleted. */
  success: Scalars['Boolean'];
};

/** Input for deleting a break rule. */
export type DeleteBreakRuleInput = {
  /** The ID of the break rule to delete. */
  id: Scalars['UUID'];
};

/** Output for deleting a break rule. */
export type DeleteBreakRuleOutput = {
  __typename?: 'DeleteBreakRuleOutput';
  /** True if the break rule was successfully deleted. */
  success: Scalars['Boolean'];
};

/** Input for deleteDemandForecastHeadcount. The operation is a no-op if the headcount entry is already absent (safe for concurrent deletes). */
export type DeleteDemandForecastHeadcountInput = {
  /** Site the demand forecast belongs to. */
  siteId: Scalars['UUID'];
  /** Date of the demand forecast being modified. */
  forecastDate: Scalars['Date'];
  /** ID of the headcount entry to remove. No error if not found. */
  id: Scalars['UUID'];
};

/** Response for deleteDemandForecastHeadcount. Returns the full updated headcount list so the client can refresh the shape of day graph. */
export type DeleteDemandForecastHeadcountOutput = {
  __typename?: 'DeleteDemandForecastHeadcountOutput';
  /** Full current list of headcounts for the forecast day after the delete operation. */
  headcounts: Array<Headcount>;
};

/**
 * This class defines the input values that are required to delete a dynamic working preference for an
 * employee.
 */
export type DeleteDynamicWorkingPreferenceInput = {
  /** The ID of the DynamicWorkingPreference to delete */
  dynamicWorkingPreferenceId: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile for which the dynamic working preference is being deleted. */
  partnerMemberProfileId: Scalars['UUID'];
};

/**
 * This class defines the output values that are returned after deleting a dynamic
 * working preference for a partner member profile.
 */
export type DeleteDynamicWorkingPreferenceOutput = {
  __typename?: 'DeleteDynamicWorkingPreferenceOutput';
  /** Whether the deletion was successful or not */
  success: Scalars['Boolean'];
};

/** The input values required to delete an employee absence. */
export type DeleteEmployeeAbsenceRequestInput = {
  /** The ID of the PartnerMemberProfile that is associated with the absence request. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the absence request to be deleted. */
  absenceRequestId: Scalars['UUID'];
};

/** The output values from deleting an employee absence. */
export type DeleteEmployeeAbsenceRequestOutput = {
  __typename?: 'DeleteEmployeeAbsenceRequestOutput';
  /** Indicates whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** The input values required from a client to delete an employee document. */
export type DeleteEmployeeDocumentInput = {
  /** The ID of the PartnerMemberProfile for the employee. */
  profileId: Scalars['UUID'];
  /** The ID of the EmployeeDocument that is being deleted. */
  employeeDocumentId: Scalars['UUID'];
};

/** The output values returned to the client from the DeleteEmployeeDocument mutation. */
export type DeleteEmployeeDocumentOutput = {
  __typename?: 'DeleteEmployeeDocumentOutput';
  /** Indicates whether the deletion of the employee document was successful. */
  success: Scalars['Boolean'];
};

/** The input values required to delete employee notifications. */
export type DeleteEmployeeNotificationsInput = {
  /** The list of IDs of the notifications to delete. */
  notificationIds: Array<Scalars['UUID']>;
};

/** The output values returned after deleting employee notifications. */
export type DeleteEmployeeNotificationsOutput = {
  __typename?: 'DeleteEmployeeNotificationsOutput';
  /** Whether the notifications were successfully deleted. */
  success: Scalars['Boolean'];
};

/** The input values required to delete an Employee working contract. */
export type DeleteEmployeeWorkingContractInput = {
  /** The PartnerMemberProfile ID of the Employee the contract belongs to. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the working contract to delete. */
  workingContractId: Scalars['UUID'];
};

/** The output values returned after deleting an Employee working contract. */
export type DeleteEmployeeWorkingContractOutput = {
  __typename?: 'DeleteEmployeeWorkingContractOutput';
  /** The Employee the contract was deleted for. */
  employee: PartnerMemberProfile;
};

/** The input values required from a client to delete a OperationalEvent. */
export type DeleteOperationalEventInput = {
  /** The Site ID for which an OperationalEvent should be deleted. */
  siteId: Scalars['UUID'];
  /** The ID of the OperationalEvent that should be deleted. */
  id: Scalars['UUID'];
};

/** The input values required to delete a partner department. */
export type DeletePartnerDepartmentInput = {
  /** The ID of the account the department belongs to. */
  accountId: Scalars['UUID'];
  /** The ID of the department to delete. */
  departmentId: Scalars['UUID'];
};

/** The output values returned after deleting a partner department. */
export type DeletePartnerDepartmentOutput = {
  __typename?: 'DeletePartnerDepartmentOutput';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** Input values required to delete a job title mapping. */
export type DeletePartnerIntegrationJobTitleMappingInput = {
  /** The partner account that owns the job title mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The job title mapping to delete. */
  id: Scalars['UUID'];
};

/** Output returned after successfully deleting a job title mapping. */
export type DeletePartnerIntegrationJobTitleMappingOutput = {
  __typename?: 'DeletePartnerIntegrationJobTitleMappingOutput';
  /** Whether the job title mapping was deleted. */
  success: Scalars['Boolean'];
};

/** Input values required to delete a profile mapping. */
export type DeletePartnerIntegrationProfileMappingInput = {
  /** The partner account that owns the profile mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The profile mapping to delete. */
  id: Scalars['UUID'];
};

/** Output returned after successfully deleting a profile mapping. */
export type DeletePartnerIntegrationProfileMappingOutput = {
  __typename?: 'DeletePartnerIntegrationProfileMappingOutput';
  /** Whether the profile mapping was deleted. */
  success: Scalars['Boolean'];
};

/** Input values required to delete a role mapping. */
export type DeletePartnerIntegrationRoleMappingInput = {
  /** The partner account that owns the role mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The role mapping to delete. */
  id: Scalars['UUID'];
};

/** Output returned after successfully deleting a role mapping. */
export type DeletePartnerIntegrationRoleMappingOutput = {
  __typename?: 'DeletePartnerIntegrationRoleMappingOutput';
  /** Whether the role mapping was deleted. */
  success: Scalars['Boolean'];
};

/** Input values required to delete a site mapping. */
export type DeletePartnerIntegrationSiteMappingInput = {
  /** The partner account that owns the site mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The site mapping to delete. */
  id: Scalars['UUID'];
};

/** Output returned after successfully deleting a site mapping. */
export type DeletePartnerIntegrationSiteMappingOutput = {
  __typename?: 'DeletePartnerIntegrationSiteMappingOutput';
  /** Whether the site mapping was deleted. */
  success: Scalars['Boolean'];
};

/** The input values required to delete a partner job title pay rate. */
export type DeletePartnerJobTitlePayRateInput = {
  /** The ID of the partner job title pay rate to delete. */
  partnerJobTitlePayRateId: Scalars['UUID'];
};

/** The output values returned after deleting a partner job title pay rate. */
export type DeletePartnerJobTitlePayRateOutput = {
  __typename?: 'DeletePartnerJobTitlePayRateOutput';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** The input values required to delete a PartnerMember. */
export type DeletePartnerMemberInput = {
  /** The ID of the PartnerMember to delete. */
  partnerMemberId: Scalars['UUID'];
  /** The ID of the parent PartnerNode that the PartnerMember belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
};

/**
 * The DeletePartnerMemberResponse class defines the response values received from the client in order to
 * delete a PartnerMember object.
 */
export type DeletePartnerMemberResponse = {
  __typename?: 'DeletePartnerMemberResponse';
  /** The ID of the PartnerMember object that has been deleted. */
  id: Scalars['UUID'];
};

/** The output values returned to the client from the DeleteProfilePhoto mutation. */
export type DeleteProfilePhotoOutput = {
  __typename?: 'DeleteProfilePhotoOutput';
  /** Indicates whether the deletion of the profile photo was successful or not. */
  success: Scalars['Boolean'];
};

/** The input values required to delete a RecurringEmployeeShift. */
export type DeleteRecurringEmployeeShiftInput = {
  /** The ID of the RecurringEmployeeShift to delete. */
  recurringShiftId: Scalars['UUID'];
  /** The ID of the Site used to validate the user's permissions. */
  siteId: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile used to validate the user is a manager of the employee. */
  partnerMemberProfileId: Scalars['UUID'];
};

/** The output returned after deleting a RecurringEmployeeShift. */
export type DeleteRecurringEmployeeShiftOutput = {
  __typename?: 'DeleteRecurringEmployeeShiftOutput';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** The input values required to delete a RecurringShiftTemplate from a given date onwards. */
export type DeleteRecurringShiftTemplateFromDateInput = {
  /** The ID of the Site that owns the RecurringShiftTemplate. */
  siteId: Scalars['UUID'];
  /** The ID of the RecurringShiftTemplate to delete. */
  id: Scalars['UUID'];
  /** The date from which the deletion should take effect. */
  fromDate: Scalars['Date'];
};

/** The output returned after deleting a RecurringShiftTemplate from a given date onwards. */
export type DeleteRecurringShiftTemplateFromDateOutput = {
  __typename?: 'DeleteRecurringShiftTemplateFromDateOutput';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** The input values required to delete a RecurringShiftTemplate. */
export type DeleteRecurringShiftTemplateInput = {
  /** The ID of the Site that owns the RecurringShiftTemplate. */
  siteId: Scalars['UUID'];
  /** The ID of the RecurringShiftTemplate to delete. */
  id: Scalars['UUID'];
};

/** The output returned after deleting a RecurringShiftTemplate. */
export type DeleteRecurringShiftTemplateOutput = {
  __typename?: 'DeleteRecurringShiftTemplateOutput';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** The input values required from a client to delete a site schedule shift. */
export type DeleteSiteScheduleShiftInput = {
  /** The ID of the shift to be deleted. */
  id: Scalars['UUID'];
  /** The ID of the Site that the shift belongs to. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule that the shift belongs to. */
  siteScheduleId: Scalars['UUID'];
  /** Information on why the shift was deleted. */
  updateInfo?: Maybe<ScheduleShiftUpdateInfo>;
  /** The date and time the shift was last modified. */
  lastModifiedAt: Scalars['String'];
  /** The date and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** The output values returned to the client from the DeleteSiteScheduleShift mutation. */
export type DeleteSiteScheduleShiftOutput = {
  __typename?: 'DeleteSiteScheduleShiftOutput';
  /** The output values available to the client after deleting a shift. */
  daySchedule: Schedule;
  /** The date and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** A DemandActual represents the actual demand for a day of the week for a Site and contains the actual items sold. */
export type DemandActual = {
  __typename?: 'DemandActual';
  /** The date of the DemandActual. */
  date: Scalars['Date'];
  /** The Site ID for the DemandActual. */
  siteId: Scalars['UUID'];
  /** The actual sales amount for the DemandActual. */
  salesAmount: Scalars['Decimal'];
  /** The HourlyActuals for the DemandActual. */
  hourlyActuals: Array<HourlyActual>;
  /** The forecast attributes associated with the DemandActual. null when there are no attributes to display. */
  attributes?: Maybe<SystemSalesForecastAttributes>;
};

/** A DemandForecast represents the forecasted demand for a day of the week for a Site which contains the shifts for the day as well as some metrics for the day. */
export type DemandForecast = {
  __typename?: 'DemandForecast';
  /** The Site ID for the DemandForecast. */
  siteId: Scalars['UUID'];
  /** The date of the DemandForecast. */
  forecastDate: Scalars['Date'];
  /** The forecasted sales for the Site and date. This does not include any adjustments from updates to the forecast. */
  expectedForecast: Scalars['Int'];
  /** The labour deployment for the DemandForecast given the sales forecast. */
  headcounts: Array<Headcount>;
  /** The optimal labour deployment for the Site on the given date based on the forecasted demand. */
  optimalHeadcounts: Array<Headcount>;
  /**
   * The updated labour percentage value for the day of the relevant DaySchedule if it exists after a demand forecast is updated. The percentage value is a value between 0 and 1.
   * @deprecated No longer used by the FE but older versions of the app are still querying this field.
   */
  labourPercentage?: Maybe<Scalars['Decimal']>;
  /** Contains the attributes that were used when generating the system sales forecast.This will be null when the forecast was not generated from a system salesforecast. I.e. was manually entered by the customer.The frontend can use this to display whether this is a 'Recommended forecast'as well as all the additional weather, holiday, etc data that was used as aninput into the system sales forecast. */
  systemSalesForecastAttributes?: Maybe<SystemSalesForecastAttributes>;
  /** This field will indicate if there is a new SystemSalesForecast for the DemandForecast. It will be null if there is no new SystemSalesForecast. */
  newRecommendedSystemSalesForecastAttributes?: Maybe<SystemSalesForecastAttributes>;
  /**
   * The sales budget for this forecast date at the Site. This will be null when no budget has been set for this date.
   * @deprecated Use budget.sales instead. See sc-90700 for cleanup.
   */
  salesBudget?: Maybe<Scalars['Decimal']>;
  /** The budget set by the partner for the day. */
  budget: PartnerBudget;
  /** Resolves the actual sales data for this time last year. The logic for calculating this time last year resides within the backend. This will be null when there are no actuals for last year. */
  lastYearActuals?: Maybe<DemandActual>;
  /** The sum of all adjustments made to the DemandForecast through updates. */
  totalAdjustment: Scalars['Int'];
  /** The list of updates made to the expectedForecast by users. */
  updates: Array<DemandForecastUpdate>;
  /** The metrics of the updates made to the DemandForecast for various reasons. Null when update metrics have not been calculated. */
  updateMetrics?: Maybe<Array<DemandForecastUpdateMetrics>>;
  /** The list of hourly forecast breakdowns for the DemandForecast. */
  hourlyForecasts: Array<HourlyForecast>;
  /** String timestamp of when either the sales forecast or shifts of the DemandForecast object have been last updated. If there have been no updates, this will reflect the time of creation. */
  modifiedAt: Scalars['String'];
  /** Kick-Point model metrics for this forecast day. Only null for historical forecasts that predate the existence of this field. */
  metrics?: Maybe<DemandForecastMetrics>;
  /**
   * The labour deployment for the DemandForecast given the sales forecast.
   * @deprecated This field is deprecated and will be removed in the future. Use headcounts instead.
   */
  shifts?: Maybe<Array<Headcount>>;
  /**
   * The optimal labour deployment for the Site on the given date based on the forecasted demand.
   * @deprecated This field is deprecated and will be removed in the future. Use optimal_headcounts instead.
   */
  optimalShifts?: Maybe<Array<Headcount>>;
};

/** The input values required from a client to interact with the demand forecast agent. */
export type DemandForecastAgentInput = {
  /** The prompt to the agent from the user. */
  prompt: Scalars['String'];
  /** The week commencing date for the week of demand forecasts being discussed. */
  weekCommencing: Scalars['Date'];
  /** The ID of the site for which the demand forecast is being discussed. */
  siteId: Scalars['UUID'];
  /** Additional context provided to the LLM that is not from the user's prompt. */
  context: Scalars['String'];
};

/** The output values returned to the client from the DemandForecastAgent mutation. */
export type DemandForecastAgentOutput = {
  __typename?: 'DemandForecastAgentOutput';
  /** The response generated by the LLM agent based on the user's prompt and additional context. */
  agentResponse: Scalars['String'];
};

/** Metrics produced by the Kick-Point model for a forecast day. Null fields indicate the model did not emit that value for this run. */
export type DemandForecastMetrics = {
  __typename?: 'DemandForecastMetrics';
  /** The predicted average spend per head for the forecast date, as emitted by the Kick-Point model. Null when the model did not return a summary or the forecast was manually entered. */
  averageSpendPerHead?: Maybe<Scalars['Decimal']>;
};

/** The reason for the updating the DemandForecast's Shifts. */
export enum DemandForecastShiftsUpdateReason {
  /** The DemandForecast's Shifts are updated to meet demand. */
  MEET_DEMAND = 'MEET_DEMAND',
  /** The DemandForecast's Shifts are updated to allow for preparation time. */
  NEED_PREP_TIME = 'NEED_PREP_TIME',
  /** The DemandForecast's Shifts are updated to allow for stock delivery. */
  STOCK_DELIVERY = 'STOCK_DELIVERY',
  /** The DemandForecast's Shifts are updated to allow for hours elsewhere. */
  NEED_HOURS_ELSEWHERE = 'NEED_HOURS_ELSEWHERE',
  /** The DemandForecast's Shifts are updated as hours are not needed. */
  DO_NOT_NEED_HOURS = 'DO_NOT_NEED_HOURS',
  /** The DemandForecast's Shifts are updated due to an event interaction. */
  EVENT = 'EVENT',
  /** The DemandForecast's Shifts are updated for another reason. */
  OTHER = 'OTHER',
}

/** A DemandForecastUpdate represents an adjustment made to a forecast for a full day or a portion of a day, for a Site. */
export type DemandForecastUpdate = {
  __typename?: 'DemandForecastUpdate';
  /** The time range that the forecast update applies to. If null, the update applies to the entire day. If not null, the update applies to the specified time range. */
  timeRange?: Maybe<TimeRange>;
  /** An increase or decrease in forecast that the user has set relative to the previous effectiveForecast. The value may be a positive or negative integer. */
  adjustment: Scalars['Int'];
  /** The reason for the adjustment. Takes a DemandForecastUpdateReason enum value. */
  reason: DemandForecastUpdateReason;
  /** An explanation for the forecast update as a free text field. */
  explanation: Scalars['String'];
  /** The time the forecast update was made. */
  updatedAt: Scalars['DateTime'];
  /** The ID of the user who made the forecast update. */
  updatedBy: Scalars['UUID'];
  /** The display name of the user who made the forecast update. */
  updatedByDisplayName: Scalars['String'];
};

/** The input values required from a client to create a DemandForecastUpdate. A single DemandForecastUpdate corresponds with a single occasion. */
export type DemandForecastUpdateInput = {
  /** The time range that the forecast update applies to. If null, the update applies to the entire day. If not null, the update applies to the specified time range. */
  timeRange?: Maybe<TimeRangeInput>;
  /** An increase or decrease in forecast that the user sets relative to the previous effectiveForecast. The value may be a positive or negative integer. */
  adjustment: Scalars['Int'];
  /** The reason for the adjustment. Takes a DemandForecastUpdateReason enum value. */
  reason: DemandForecastUpdateReason;
  /** An explanation for the forecast update as a free text field. */
  explanation?: Maybe<Scalars['String']>;
  /** The time the forecast update is being made. If null, this update represents a new record and the current time will be set. If not null, this update represents an existing record and the existing value will be used. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the user who is making the forecast update. If null, this update represents a new record and the current user will be set. If not null, this update represents an existing record and the existing value will be used. */
  updatedBy?: Maybe<Scalars['UUID']>;
  /** The display name of the user who is making the forecast update. If null, this update represents a new record and the current user's display name will be set. If not null, this update represents an existing record and the existing value will be used. */
  updatedByDisplayName?: Maybe<Scalars['String']>;
};

/** DemandForecastUpdateMetrics represents the metrics of the updates made to the DemandForecast for a given reason. */
export type DemandForecastUpdateMetrics = {
  __typename?: 'DemandForecastUpdateMetrics';
  /** The reason for the adjustment. */
  reason: DemandForecastUpdateReason;
  /** A 0 - 1 value representing the proportion of updates that are of this reason. */
  proportion: Scalars['Float'];
  /** The total adjustment value for the updates that are for the reason. */
  adjustment: Scalars['Int'];
};

/** The reason for the DemandForecastUpdate. */
export enum DemandForecastUpdateReason {
  /** The DemandForecastUpdate is made to meet demand. */
  MEET_DEMAND = 'MEET_DEMAND',
  /** The DemandForecastUpdate is made due to a booking. */
  BOOKING = 'BOOKING',
  /** The DemandForecastUpdate is made due to a promotion. */
  PROMOTION = 'PROMOTION',
  /** The DemandForecastUpdate is made due to a holiday. */
  LOCAL_HOLIDAY = 'LOCAL_HOLIDAY',
  /** The DemandForecastUpdate is made due to an event. */
  EVENT = 'EVENT',
  /** The DemandForecastUpdate is made due to a dine out event. */
  DINE_OUT = 'DINE_OUT',
  /** The DemandForecastUpdate is made due to weather conditions. */
  WEATHER = 'WEATHER',
  /** The DemandForecastUpdate is made for another reason. */
  OTHER = 'OTHER',
}

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  user: StintUser;
  uniqueId: Scalars['String'];
  platform: DeviceInfoPlatform;
  /** The current location setting for the user's device. */
  locationSetting?: Maybe<DeviceInfoLocationSetting>;
  locationSettingUpdatedAt?: Maybe<Scalars['DateTime']>;
  appVersion?: Maybe<Scalars['String']>;
  hasNotificationsEnabled: Scalars['Boolean'];
  hasNotificationsEnabledUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Id of related StintUser (auto-generated). */
  user_id?: Maybe<Scalars['UUID']>;
};

/** The TextChoices for the DeviceInfo.location_setting field. */
export enum DeviceInfoLocationSetting {
  NEVER = 'NEVER',
  ALWAYS = 'ALWAYS',
  USING = 'USING',
  UNDETERMINED = 'UNDETERMINED',
  DENIED = 'DENIED',
}

export enum DeviceInfoPlatform {
  /** iOS */
  IOS = 'IOS',
  /** android */
  ANDROID = 'ANDROID',
}

export type DeviceLocation = {
  __typename?: 'DeviceLocation';
  id: Scalars['ID'];
  heading?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  accuracy?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  batteryLevel?: Maybe<Scalars['Float']>;
  batteryIsCharging: Scalars['Boolean'];
  deviceId?: Maybe<Scalars['String']>;
  recordedAt?: Maybe<Scalars['String']>;
  isMoving: Scalars['Boolean'];
  /** Id of related StintUser (auto-generated). */
  user_id?: Maybe<Scalars['UUID']>;
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
};

export type DeviceLocationFilter = {
  user?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** user_id */
  user_id?: Maybe<Scalars['UUID']>;
  /** user_id_isnull */
  user_id_isnull?: Maybe<Scalars['Boolean']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['String']>;
  /** uuid_search */
  uuid_search?: Maybe<Scalars['String']>;
  /** uuid_gte */
  uuid_gte?: Maybe<Scalars['String']>;
  /** uuid_lte */
  uuid_lte?: Maybe<Scalars['String']>;
  /** uuid_istartswith */
  uuid_istartswith?: Maybe<Scalars['String']>;
  /** uuid_lt */
  uuid_lt?: Maybe<Scalars['String']>;
  /** uuid_gt */
  uuid_gt?: Maybe<Scalars['String']>;
  /** uuid_isnull */
  uuid_isnull?: Maybe<Scalars['Boolean']>;
  /** uuid_iendswith */
  uuid_iendswith?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['Float']>;
  /** heading_gte */
  heading_gte?: Maybe<Scalars['Float']>;
  /** heading_lte */
  heading_lte?: Maybe<Scalars['Float']>;
  /** heading_istartswith */
  heading_istartswith?: Maybe<Scalars['Float']>;
  /** heading_lt */
  heading_lt?: Maybe<Scalars['Float']>;
  /** heading_gt */
  heading_gt?: Maybe<Scalars['Float']>;
  /** heading_isnull */
  heading_isnull?: Maybe<Scalars['Boolean']>;
  /** heading_iendswith */
  heading_iendswith?: Maybe<Scalars['Float']>;
  speed?: Maybe<Scalars['Float']>;
  /** speed_gte */
  speed_gte?: Maybe<Scalars['Float']>;
  /** speed_lte */
  speed_lte?: Maybe<Scalars['Float']>;
  /** speed_istartswith */
  speed_istartswith?: Maybe<Scalars['Float']>;
  /** speed_lt */
  speed_lt?: Maybe<Scalars['Float']>;
  /** speed_gt */
  speed_gt?: Maybe<Scalars['Float']>;
  /** speed_isnull */
  speed_isnull?: Maybe<Scalars['Boolean']>;
  /** speed_iendswith */
  speed_iendswith?: Maybe<Scalars['Float']>;
  accuracy?: Maybe<Scalars['Float']>;
  /** accuracy_gte */
  accuracy_gte?: Maybe<Scalars['Float']>;
  /** accuracy_lte */
  accuracy_lte?: Maybe<Scalars['Float']>;
  /** accuracy_istartswith */
  accuracy_istartswith?: Maybe<Scalars['Float']>;
  /** accuracy_lt */
  accuracy_lt?: Maybe<Scalars['Float']>;
  /** accuracy_gt */
  accuracy_gt?: Maybe<Scalars['Float']>;
  /** accuracy_isnull */
  accuracy_isnull?: Maybe<Scalars['Boolean']>;
  /** accuracy_iendswith */
  accuracy_iendswith?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** longitude_gte */
  longitude_gte?: Maybe<Scalars['Float']>;
  /** longitude_lte */
  longitude_lte?: Maybe<Scalars['Float']>;
  /** longitude_istartswith */
  longitude_istartswith?: Maybe<Scalars['Float']>;
  /** longitude_lt */
  longitude_lt?: Maybe<Scalars['Float']>;
  /** longitude_gt */
  longitude_gt?: Maybe<Scalars['Float']>;
  /** longitude_isnull */
  longitude_isnull?: Maybe<Scalars['Boolean']>;
  /** longitude_iendswith */
  longitude_iendswith?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  /** latitude_gte */
  latitude_gte?: Maybe<Scalars['Float']>;
  /** latitude_lte */
  latitude_lte?: Maybe<Scalars['Float']>;
  /** latitude_istartswith */
  latitude_istartswith?: Maybe<Scalars['Float']>;
  /** latitude_lt */
  latitude_lt?: Maybe<Scalars['Float']>;
  /** latitude_gt */
  latitude_gt?: Maybe<Scalars['Float']>;
  /** latitude_isnull */
  latitude_isnull?: Maybe<Scalars['Boolean']>;
  /** latitude_iendswith */
  latitude_iendswith?: Maybe<Scalars['Float']>;
  altitude?: Maybe<Scalars['Float']>;
  /** altitude_gte */
  altitude_gte?: Maybe<Scalars['Float']>;
  /** altitude_lte */
  altitude_lte?: Maybe<Scalars['Float']>;
  /** altitude_istartswith */
  altitude_istartswith?: Maybe<Scalars['Float']>;
  /** altitude_lt */
  altitude_lt?: Maybe<Scalars['Float']>;
  /** altitude_gt */
  altitude_gt?: Maybe<Scalars['Float']>;
  /** altitude_isnull */
  altitude_isnull?: Maybe<Scalars['Boolean']>;
  /** altitude_iendswith */
  altitude_iendswith?: Maybe<Scalars['Float']>;
  batteryLevel?: Maybe<Scalars['Float']>;
  /** batteryLevel_gte */
  batteryLevel_gte?: Maybe<Scalars['Float']>;
  /** batteryLevel_lte */
  batteryLevel_lte?: Maybe<Scalars['Float']>;
  /** batteryLevel_istartswith */
  batteryLevel_istartswith?: Maybe<Scalars['Float']>;
  /** batteryLevel_lt */
  batteryLevel_lt?: Maybe<Scalars['Float']>;
  /** batteryLevel_gt */
  batteryLevel_gt?: Maybe<Scalars['Float']>;
  /** batteryLevel_isnull */
  batteryLevel_isnull?: Maybe<Scalars['Boolean']>;
  /** batteryLevel_iendswith */
  batteryLevel_iendswith?: Maybe<Scalars['Float']>;
  batteryIsCharging?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_gte */
  batteryIsCharging_gte?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_lte */
  batteryIsCharging_lte?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_istartswith */
  batteryIsCharging_istartswith?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_lt */
  batteryIsCharging_lt?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_gt */
  batteryIsCharging_gt?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_isnull */
  batteryIsCharging_isnull?: Maybe<Scalars['Boolean']>;
  /** batteryIsCharging_iendswith */
  batteryIsCharging_iendswith?: Maybe<Scalars['Boolean']>;
  activityConfidence?: Maybe<Scalars['Float']>;
  /** activityConfidence_gte */
  activityConfidence_gte?: Maybe<Scalars['Float']>;
  /** activityConfidence_lte */
  activityConfidence_lte?: Maybe<Scalars['Float']>;
  /** activityConfidence_istartswith */
  activityConfidence_istartswith?: Maybe<Scalars['Float']>;
  /** activityConfidence_lt */
  activityConfidence_lt?: Maybe<Scalars['Float']>;
  /** activityConfidence_gt */
  activityConfidence_gt?: Maybe<Scalars['Float']>;
  /** activityConfidence_isnull */
  activityConfidence_isnull?: Maybe<Scalars['Boolean']>;
  /** activityConfidence_iendswith */
  activityConfidence_iendswith?: Maybe<Scalars['Float']>;
  activityType?: Maybe<Scalars['String']>;
  /** activityType_search */
  activityType_search?: Maybe<Scalars['String']>;
  /** activityType_gte */
  activityType_gte?: Maybe<Scalars['String']>;
  /** activityType_lte */
  activityType_lte?: Maybe<Scalars['String']>;
  /** activityType_istartswith */
  activityType_istartswith?: Maybe<Scalars['String']>;
  /** activityType_lt */
  activityType_lt?: Maybe<Scalars['String']>;
  /** activityType_gt */
  activityType_gt?: Maybe<Scalars['String']>;
  /** activityType_isnull */
  activityType_isnull?: Maybe<Scalars['Boolean']>;
  /** activityType_iendswith */
  activityType_iendswith?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  /** odometer_search */
  odometer_search?: Maybe<Scalars['String']>;
  /** odometer_gte */
  odometer_gte?: Maybe<Scalars['String']>;
  /** odometer_lte */
  odometer_lte?: Maybe<Scalars['String']>;
  /** odometer_istartswith */
  odometer_istartswith?: Maybe<Scalars['String']>;
  /** odometer_lt */
  odometer_lt?: Maybe<Scalars['String']>;
  /** odometer_gt */
  odometer_gt?: Maybe<Scalars['String']>;
  /** odometer_isnull */
  odometer_isnull?: Maybe<Scalars['Boolean']>;
  /** odometer_iendswith */
  odometer_iendswith?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  /** deviceId_search */
  deviceId_search?: Maybe<Scalars['String']>;
  /** deviceId_gte */
  deviceId_gte?: Maybe<Scalars['String']>;
  /** deviceId_lte */
  deviceId_lte?: Maybe<Scalars['String']>;
  /** deviceId_istartswith */
  deviceId_istartswith?: Maybe<Scalars['String']>;
  /** deviceId_lt */
  deviceId_lt?: Maybe<Scalars['String']>;
  /** deviceId_gt */
  deviceId_gt?: Maybe<Scalars['String']>;
  /** deviceId_isnull */
  deviceId_isnull?: Maybe<Scalars['Boolean']>;
  /** deviceId_iendswith */
  deviceId_iendswith?: Maybe<Scalars['String']>;
  recordedAt?: Maybe<Scalars['String']>;
  /** recordedAt_search */
  recordedAt_search?: Maybe<Scalars['String']>;
  /** recordedAt_gte */
  recordedAt_gte?: Maybe<Scalars['String']>;
  /** recordedAt_lte */
  recordedAt_lte?: Maybe<Scalars['String']>;
  /** recordedAt_istartswith */
  recordedAt_istartswith?: Maybe<Scalars['String']>;
  /** recordedAt_lt */
  recordedAt_lt?: Maybe<Scalars['String']>;
  /** recordedAt_gt */
  recordedAt_gt?: Maybe<Scalars['String']>;
  /** recordedAt_isnull */
  recordedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** recordedAt_iendswith */
  recordedAt_iendswith?: Maybe<Scalars['String']>;
  isMoving?: Maybe<Scalars['Boolean']>;
  /** isMoving_gte */
  isMoving_gte?: Maybe<Scalars['Boolean']>;
  /** isMoving_lte */
  isMoving_lte?: Maybe<Scalars['Boolean']>;
  /** isMoving_istartswith */
  isMoving_istartswith?: Maybe<Scalars['Boolean']>;
  /** isMoving_lt */
  isMoving_lt?: Maybe<Scalars['Boolean']>;
  /** isMoving_gt */
  isMoving_gt?: Maybe<Scalars['Boolean']>;
  /** isMoving_isnull */
  isMoving_isnull?: Maybe<Scalars['Boolean']>;
  /** isMoving_iendswith */
  isMoving_iendswith?: Maybe<Scalars['Boolean']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  uuid_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  heading_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  speed_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  accuracy_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  longitude_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  latitude_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  altitude_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  batteryLevel_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  batteryIsCharging_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  activityConfidence_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  activityType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  odometer_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  deviceId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  recordedAt_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isMoving_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

/** Enum of a Stint's different start time reasons */
export enum DifferentStartTimeReason {
  DIFFERENT_START_TIME_EARLY = 'DIFFERENT_START_TIME_EARLY',
  DIFFERENT_START_TIME_LAST_MINUTE = 'DIFFERENT_START_TIME_LAST_MINUTE',
  DIFFERENT_START_TIME_LATE_ASSIGNMENT = 'DIFFERENT_START_TIME_LATE_ASSIGNMENT',
  DIFFERENT_START_TIME_LATE_TRANSPORT = 'DIFFERENT_START_TIME_LATE_TRANSPORT',
  DIFFERENT_START_TIME_LEFT_TO_LATE = 'DIFFERENT_START_TIME_LEFT_TO_LATE',
  DIFFERENT_START_TIME_WRONG_BUSINESS_ADDRESS = 'DIFFERENT_START_TIME_WRONG_BUSINESS_ADDRESS',
  DIFFERENT_START_TIME_OTHER = 'DIFFERENT_START_TIME_OTHER',
}

export type DirectDebitPaymentMethod = {
  __typename?: 'DirectDebitPaymentMethod';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  isPrimaryMethod: Scalars['Boolean'];
  accountNumber?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  /** This field has been deprecated. */
  employerPaymentMethods: Array<EmployerProfile>;
  /** The associated Stints. */
  stints: StintNodeTypeConnection;
  studentProfiles: Array<StudentProfile>;
  businesses: Array<Business>;
};

export type DirectDebitPaymentMethodstintsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename?: 'DjangoDebug';
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSQL>>>;
  /** Raise exceptions for this API query. */
  exceptions?: Maybe<Array<Maybe<DjangoDebugException>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename?: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String'];
  /** The message of the exception */
  message: Scalars['String'];
  /** The stack trace */
  stack: Scalars['String'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSQL = {
  __typename?: 'DjangoDebugSQL';
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']>;
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']>;
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']>;
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']>;
};

/** The input values for a supporting document. */
export type DocumentInput = {
  /** The base64 encoded content of the document. */
  base64Content: Scalars['String'];
  /** The MIME type of the document. */
  mime: Scalars['String'];
};

/** A dynamic working preference for a specific date. */
export type DynamicWorkingPreference = {
  __typename?: 'DynamicWorkingPreference';
  /** The ID of the dynamic working preference. */
  id: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The date for which the preference applies. */
  date: Scalars['Date'];
  /** The working preference for the date. */
  preference: WorkingPreference;
  /** The reason for the dynamic working preference. */
  reason?: Maybe<Scalars['String']>;
  /** The start of the custom unavailability window. */
  startTime?: Maybe<Scalars['Time']>;
  /** The end of the custom unavailability window. */
  endTime?: Maybe<Scalars['Time']>;
};

/**
 * For graphcool we have named the GQL name patterns as EditableSetting rather than the model name.
 *
 * To use this type, you will need to fetch parameters from SSM parameter store and then set it
 * to info.context so that the resolvers can get it out of context.
 */
export type EditableSetting = {
  __typename?: 'EditableSetting';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  /** Deprecated in favour of base_fee on City. */
  baseFee?: Maybe<Scalars['Float']>;
  /** Deprecated in favour of base_fee_student on City. */
  baseFeeStudent?: Maybe<Scalars['Float']>;
  /** Deprecated. */
  predictionLeadDays: Scalars['Int'];
  notificationBlockerWindowHours: Scalars['Float'];
  geoTrackingBufferTime: Scalars['Int'];
  advancedOperationalWindowStartTime: Scalars['Time'];
  advancedOperationalWindowEndTime: Scalars['Time'];
  /** Deprecated in favor of stintmatcher service */
  automatedMatchingEnabled: Scalars['Boolean'];
  /** Deprecated in favor of stintmatcher service */
  automatedOffersEnabled: Scalars['Boolean'];
  automatedTestingEnabled: Scalars['Boolean'];
  /** Deprecated in favor of stintmatcher service */
  automatedLastMinuteStints: Scalars['Boolean'];
  featureFlagGeotrackingV2Enabled: Scalars['Boolean'];
  featureFlagGeotrackingReactAdminEnabled: Scalars['Boolean'];
  /** Deprecated in favor of stintmatcher service */
  featureFlagMultipleStintOffersEnabled: Scalars['Boolean'];
  featureFlagEtdNotificationsEnabled: Scalars['Boolean'];
  serverDatetime?: Maybe<Scalars['DateTime']>;
  /** Deprecated in favor of stintmatcher service */
  featureFlagAvailabilityMatchingEnabled: Scalars['Boolean'];
  featureFlagStudentGoingToBeLateSmsEnabled: Scalars['Boolean'];
  availabilityMatchingBufferHours: Scalars['Int'];
  /** Deprecated in favor of availabilityMatchingMaxOffers<dayOfWeek> */
  availabilityMatchingMaxOffersPerDay: Scalars['Int'];
  availabilityMatchingMaxOffersMonday: Scalars['Int'];
  availabilityMatchingMaxOffersTuesday: Scalars['Int'];
  availabilityMatchingMaxOffersWednesday: Scalars['Int'];
  availabilityMatchingMaxOffersThursday: Scalars['Int'];
  availabilityMatchingMaxOffersFriday: Scalars['Int'];
  availabilityMatchingMaxOffersSaturday: Scalars['Int'];
  availabilityMatchingMaxOffersSunday: Scalars['Int'];
  availabilityMatchingNotificationForNoOffersEnabled: Scalars['Boolean'];
  matchingAlgoNoOfferMaxCountPerTimeWindow: Scalars['Int'];
  matchingAlgoNoOfferTimeWindowSpan: Scalars['Int'];
  matchingAlgoNoOfferTitle?: Maybe<Scalars['String']>;
  matchingAlgoNoOfferMessage?: Maybe<Scalars['String']>;
  matchingAlgoNotificationDelayInMinutes: Scalars['Int'];
  featureFlagStintSecondStartReminderEnabled: Scalars['Boolean'];
  etdCalculationBeforeMiddayOffsetInMinutes: Scalars['Int'];
  etdCalculationAfterMiddayOffsetInMinutes: Scalars['Int'];
  sendingStudentLeaveReminderAtRouteTimeEnabled: Scalars['Boolean'];
  stintOfferExpiryThresholdInHours: Scalars['Int'];
  notificationTopUpThresholdInHours: Scalars['Int'];
  serverTime?: Maybe<Scalars['DateTime']>;
  isTimeManipulationEnabled?: Maybe<Scalars['Boolean']>;
  studentCancellationOnHoldEmailEnabled: Scalars['Boolean'];
};

/** The Employee's bank details. */
export type EmployeeBankDetails = {
  __typename?: 'EmployeeBankDetails';
  /** The name of the Employee's bank. */
  bankName?: Maybe<Scalars['String']>;
  /** The name of the Employee as it appears on their bank account. */
  accountHolderName?: Maybe<Scalars['String']>;
  /** The number of the Employee's bank account. */
  accountNumber?: Maybe<Scalars['String']>;
  /** The sort code of the Employee's bank account without any hyphens. e.g. '608371'. */
  sortCode?: Maybe<Scalars['String']>;
};

/** The contact details for the Employee. */
export type EmployeeContactInfoType = {
  __typename?: 'EmployeeContactInfoType';
  /** The home address of the Employee. */
  homeAddress?: Maybe<EmployeeHomeAddressType>;
  /** The Employee's emergency contact details. */
  emergencyContact?: Maybe<EmployeeEmergencyContactType>;
};

/**
 * The EmployeeDisclaimerInfo class defines the Graphene ObjectType class used
 * to resolve information related to AgreementType.EMPLOYEE_DISCLAIMER and its
 * confirmation for GraphQL queries and mutations.
 */
export type EmployeeDisclaimerInfo = {
  __typename?: 'EmployeeDisclaimerInfo';
  /** The ID of the related AgreementType.EMPLOYEE_DISCLAIMER Agreement object. */
  agreementId: Scalars['UUID'];
  /** The url of the stored AgreementType.EMPLOYEE_DISCLAIMER Agreement document. */
  documentUrl: Scalars['String'];
  /** Whether or not the employee disclaimer agreement document has been read and confirmed by the Stinter. */
  confirmed: Scalars['Boolean'];
};

/** The AgeRange options for diversity and inclusion info. */
export enum EmployeeDiversityAgeRange {
  UNDER_18 = 'UNDER_18',
  BETWEEN_18_24 = 'BETWEEN_18_24',
  BETWEEN_25_34 = 'BETWEEN_25_34',
  BETWEEN_35_44 = 'BETWEEN_35_44',
  BETWEEN_45_54 = 'BETWEEN_45_54',
  BETWEEN_55_64 = 'BETWEEN_55_64',
  OVER_65 = 'OVER_65',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The diversity and inclusion information for an Employee. */
export type EmployeeDiversityAndInclusionInfoType = {
  __typename?: 'EmployeeDiversityAndInclusionInfoType';
  /** The gender identity of the employee. */
  genderIdentity?: Maybe<EmployeeDiversityGenderIdentity>;
  /** Free-text gender identity when OTHER is selected. */
  genderIdentityOther?: Maybe<Scalars['String']>;
  /** The sexual orientation of the employee. */
  sexuality?: Maybe<EmployeeDiversitySexuality>;
  /** Free-text sexual orientation when OTHER is selected. */
  sexualityOther?: Maybe<Scalars['String']>;
  /** The nationality of the employee. */
  nationality?: Maybe<EmployeeDiversityNationality>;
  /** The ethnicity of the employee. */
  ethnicity?: Maybe<EmployeeDiversityEthnicity>;
  /** Free-text ethnicity when OTHER is selected. */
  ethnicityOther?: Maybe<Scalars['String']>;
  /** The religion or belief system of the employee. */
  religiousBeliefs?: Maybe<EmployeeDiversityReligiousBelief>;
  /** Free-text religion when OTHER is selected. */
  religiousBeliefsOther?: Maybe<Scalars['String']>;
  /** The age range of the employee. */
  ageRange?: Maybe<EmployeeDiversityAgeRange>;
  /** The disability status of the employee. */
  disabilityStatus?: Maybe<EmployeeDiversityDisabilityStatus>;
  /** The specific disability types when disability_status is YES. */
  disabilityTypes?: Maybe<Array<EmployeeDiversityDisabilityType>>;
  /** Free-text disability type when OTHER is selected. */
  disabilityTypesOther?: Maybe<Scalars['String']>;
  /** The neurodiversity status of the employee. */
  neurodiversity?: Maybe<EmployeeDiversityNeurodiversityStatus>;
  /** The specific neurodiversity types when neurodiversity is YES. */
  neurodiversityTypes?: Maybe<Array<EmployeeDiversityNeurodiversityType>>;
  /** Free-text neurodiversity type when OTHER is selected. */
  neurodiversityTypesOther?: Maybe<Scalars['String']>;
};

/** The DisabilityStatus options for diversity and inclusion info. */
export enum EmployeeDiversityDisabilityStatus {
  YES = 'YES',
  NO = 'NO',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The DisabilityType options for diversity and inclusion info. */
export enum EmployeeDiversityDisabilityType {
  PHYSICAL_DISABILITY = 'PHYSICAL_DISABILITY',
  SENSORY_IMPAIRMENT = 'SENSORY_IMPAIRMENT',
  MENTAL_HEALTH_CONDITION = 'MENTAL_HEALTH_CONDITION',
  LONG_TERM_ILLNESS = 'LONG_TERM_ILLNESS',
  LEARNING_DISABILITY = 'LEARNING_DISABILITY',
  OTHER = 'OTHER',
}

/** The Ethnicity options for diversity and inclusion info. */
export enum EmployeeDiversityEthnicity {
  ASIAN_ASIAN_BRITISH = 'ASIAN_ASIAN_BRITISH',
  BLACK_AFRICAN_CARIBBEAN_BLACK_BRITISH = 'BLACK_AFRICAN_CARIBBEAN_BLACK_BRITISH',
  MIXED_OR_MULTIPLE_ETHNIC_GROUPS = 'MIXED_OR_MULTIPLE_ETHNIC_GROUPS',
  WHITE = 'WHITE',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The GenderIdentity options for diversity and inclusion info. */
export enum EmployeeDiversityGenderIdentity {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NON_BINARY = 'NON_BINARY',
  GENDERFLUID = 'GENDERFLUID',
  AGENDER = 'AGENDER',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The Nationality options for diversity and inclusion info. */
export enum EmployeeDiversityNationality {
  AFGHAN = 'AFGHAN',
  ALBANIAN = 'ALBANIAN',
  ALGERIAN = 'ALGERIAN',
  AMERICAN = 'AMERICAN',
  ANDORRAN = 'ANDORRAN',
  ANGOLAN = 'ANGOLAN',
  ANGUILLAN = 'ANGUILLAN',
  ARGENTINE = 'ARGENTINE',
  ARMENIAN = 'ARMENIAN',
  AUSTRALIAN = 'AUSTRALIAN',
  AUSTRIAN = 'AUSTRIAN',
  AZERBAIJANI = 'AZERBAIJANI',
  BAHAMIAN = 'BAHAMIAN',
  BAHRAINI = 'BAHRAINI',
  BANGLADESHI = 'BANGLADESHI',
  BARBADIAN = 'BARBADIAN',
  BELARUSIAN = 'BELARUSIAN',
  BELGIAN = 'BELGIAN',
  BELIZEAN = 'BELIZEAN',
  BENINESE = 'BENINESE',
  BERMUDIAN = 'BERMUDIAN',
  BHUTANESE = 'BHUTANESE',
  BOLIVIAN = 'BOLIVIAN',
  BOTSWANAN = 'BOTSWANAN',
  BRAZILIAN = 'BRAZILIAN',
  BRITISH = 'BRITISH',
  BRITISH_VIRGIN_ISLANDER = 'BRITISH_VIRGIN_ISLANDER',
  BRUNEIAN = 'BRUNEIAN',
  BULGARIAN = 'BULGARIAN',
  BURKINAN = 'BURKINAN',
  BURMESE = 'BURMESE',
  BURUNDIAN = 'BURUNDIAN',
  CAMBODIAN = 'CAMBODIAN',
  CAMEROONIAN = 'CAMEROONIAN',
  CANADIAN = 'CANADIAN',
  CAPE_VERDEAN = 'CAPE_VERDEAN',
  CAYMAN_ISLANDER = 'CAYMAN_ISLANDER',
  CENTRAL_AFRICAN = 'CENTRAL_AFRICAN',
  CHADIAN = 'CHADIAN',
  CHILEAN = 'CHILEAN',
  CHINESE = 'CHINESE',
  CITIZEN_OF_ANTIGUA_AND_BARBUDA = 'CITIZEN_OF_ANTIGUA_AND_BARBUDA',
  CITIZEN_OF_BOSNIA_AND_HERZEGOVINA = 'CITIZEN_OF_BOSNIA_AND_HERZEGOVINA',
  CITIZEN_OF_GUINEA_BISSAU = 'CITIZEN_OF_GUINEA_BISSAU',
  CITIZEN_OF_KIRIBATI = 'CITIZEN_OF_KIRIBATI',
  CITIZEN_OF_SEYCHELLES = 'CITIZEN_OF_SEYCHELLES',
  CITIZEN_OF_THE_DOMINICAN_REPUBLIC = 'CITIZEN_OF_THE_DOMINICAN_REPUBLIC',
  CITIZEN_OF_VANUATU = 'CITIZEN_OF_VANUATU',
  COLOMBIAN = 'COLOMBIAN',
  COMORAN = 'COMORAN',
  CONGOLESE_CONGO = 'CONGOLESE_CONGO',
  CONGOLESE_DRC = 'CONGOLESE_DRC',
  COOK_ISLANDER = 'COOK_ISLANDER',
  COSTA_RICAN = 'COSTA_RICAN',
  CROATIAN = 'CROATIAN',
  CUBAN = 'CUBAN',
  CYMRAES = 'CYMRAES',
  CYMRO = 'CYMRO',
  CYPRIOT = 'CYPRIOT',
  CZECH = 'CZECH',
  DANISH = 'DANISH',
  DJIBOUTIAN = 'DJIBOUTIAN',
  DOMINICAN = 'DOMINICAN',
  DUTCH = 'DUTCH',
  EAST_TIMORESE = 'EAST_TIMORESE',
  ECUADOREAN = 'ECUADOREAN',
  EGYPTIAN = 'EGYPTIAN',
  EMIRATI = 'EMIRATI',
  ENGLISH = 'ENGLISH',
  EQUATORIAL_GUINEAN = 'EQUATORIAL_GUINEAN',
  ERITREAN = 'ERITREAN',
  ESTONIAN = 'ESTONIAN',
  ETHIOPIAN = 'ETHIOPIAN',
  FAROESE = 'FAROESE',
  FIJIAN = 'FIJIAN',
  FILIPINO = 'FILIPINO',
  FINNISH = 'FINNISH',
  FRENCH = 'FRENCH',
  GABONESE = 'GABONESE',
  GAMBIAN = 'GAMBIAN',
  GEORGIAN = 'GEORGIAN',
  GERMAN = 'GERMAN',
  GHANAIAN = 'GHANAIAN',
  GIBRALTARIAN = 'GIBRALTARIAN',
  GREEK = 'GREEK',
  GREENLANDIC = 'GREENLANDIC',
  GRENADIAN = 'GRENADIAN',
  GUAMANIAN = 'GUAMANIAN',
  GUATEMALAN = 'GUATEMALAN',
  GUINEAN = 'GUINEAN',
  GUYANESE = 'GUYANESE',
  HAITIAN = 'HAITIAN',
  HONDURAN = 'HONDURAN',
  HONG_KONGER = 'HONG_KONGER',
  HUNGARIAN = 'HUNGARIAN',
  ICELANDIC = 'ICELANDIC',
  INDIAN = 'INDIAN',
  INDONESIAN = 'INDONESIAN',
  IRANIAN = 'IRANIAN',
  IRAQI = 'IRAQI',
  IRISH = 'IRISH',
  ISRAELI = 'ISRAELI',
  ITALIAN = 'ITALIAN',
  IVORIAN = 'IVORIAN',
  JAMAICAN = 'JAMAICAN',
  JAPANESE = 'JAPANESE',
  JORDANIAN = 'JORDANIAN',
  KAZAKH = 'KAZAKH',
  KENYAN = 'KENYAN',
  KITTITIAN = 'KITTITIAN',
  KOSOVAN = 'KOSOVAN',
  KUWAITI = 'KUWAITI',
  KYRGYZ = 'KYRGYZ',
  LAO = 'LAO',
  LATVIAN = 'LATVIAN',
  LEBANESE = 'LEBANESE',
  LIBERIAN = 'LIBERIAN',
  LIBYAN = 'LIBYAN',
  LIECHTENSTEIN_CITIZEN = 'LIECHTENSTEIN_CITIZEN',
  LITHUANIAN = 'LITHUANIAN',
  LUXEMBOURGER = 'LUXEMBOURGER',
  MACANESE = 'MACANESE',
  MACEDONIAN = 'MACEDONIAN',
  MALAGASY = 'MALAGASY',
  MALAWIAN = 'MALAWIAN',
  MALAYSIAN = 'MALAYSIAN',
  MALDIVIAN = 'MALDIVIAN',
  MALIAN = 'MALIAN',
  MALTESE = 'MALTESE',
  MARSHALLESE = 'MARSHALLESE',
  MARTINIQUAIS = 'MARTINIQUAIS',
  MAURITANIAN = 'MAURITANIAN',
  MAURITIAN = 'MAURITIAN',
  MEXICAN = 'MEXICAN',
  MICRONESIAN = 'MICRONESIAN',
  MOLDOVAN = 'MOLDOVAN',
  MONEGASQUE = 'MONEGASQUE',
  MONGOLIAN = 'MONGOLIAN',
  MONTENEGRIN = 'MONTENEGRIN',
  MONTSERRATIAN = 'MONTSERRATIAN',
  MOROCCAN = 'MOROCCAN',
  MOSOTHO = 'MOSOTHO',
  MOZAMBICAN = 'MOZAMBICAN',
  NAMIBIAN = 'NAMIBIAN',
  NAURUAN = 'NAURUAN',
  NEPALESE = 'NEPALESE',
  NEW_ZEALANDER = 'NEW_ZEALANDER',
  NICARAGUAN = 'NICARAGUAN',
  NIGERIAN = 'NIGERIAN',
  NIGERIEN = 'NIGERIEN',
  NIUEAN = 'NIUEAN',
  NORTH_KOREAN = 'NORTH_KOREAN',
  NORTHERN_IRISH = 'NORTHERN_IRISH',
  NORWEGIAN = 'NORWEGIAN',
  OMANI = 'OMANI',
  PAKISTANI = 'PAKISTANI',
  PALAUAN = 'PALAUAN',
  PALESTINIAN = 'PALESTINIAN',
  PANAMANIAN = 'PANAMANIAN',
  PAPUA_NEW_GUINEAN = 'PAPUA_NEW_GUINEAN',
  PARAGUAYAN = 'PARAGUAYAN',
  PERUVIAN = 'PERUVIAN',
  PITCAIRN_ISLANDER = 'PITCAIRN_ISLANDER',
  POLISH = 'POLISH',
  PORTUGUESE = 'PORTUGUESE',
  PRYDEINIG = 'PRYDEINIG',
  PUERTO_RICAN = 'PUERTO_RICAN',
  QATARI = 'QATARI',
  ROMANIAN = 'ROMANIAN',
  RUSSIAN = 'RUSSIAN',
  RWANDAN = 'RWANDAN',
  SALVADOREAN = 'SALVADOREAN',
  SAMMARINESE = 'SAMMARINESE',
  SAMOAN = 'SAMOAN',
  SAO_TOMEAN = 'SAO_TOMEAN',
  SAUDI_ARABIAN = 'SAUDI_ARABIAN',
  SCOTTISH = 'SCOTTISH',
  SENEGALESE = 'SENEGALESE',
  SERBIAN = 'SERBIAN',
  SIERRA_LEONEAN = 'SIERRA_LEONEAN',
  SINGAPOREAN = 'SINGAPOREAN',
  SLOVAK = 'SLOVAK',
  SLOVENIAN = 'SLOVENIAN',
  SOLOMON_ISLANDER = 'SOLOMON_ISLANDER',
  SOMALI = 'SOMALI',
  SOUTH_AFRICAN = 'SOUTH_AFRICAN',
  SOUTH_KOREAN = 'SOUTH_KOREAN',
  SOUTH_SUDANESE = 'SOUTH_SUDANESE',
  SPANISH = 'SPANISH',
  SRI_LANKAN = 'SRI_LANKAN',
  ST_HELENIAN = 'ST_HELENIAN',
  ST_LUCIAN = 'ST_LUCIAN',
  STATELESS = 'STATELESS',
  SUDANESE = 'SUDANESE',
  SURINAMESE = 'SURINAMESE',
  SWAZI = 'SWAZI',
  SWEDISH = 'SWEDISH',
  SWISS = 'SWISS',
  SYRIAN = 'SYRIAN',
  TAIWANESE = 'TAIWANESE',
  TAJIK = 'TAJIK',
  TANZANIAN = 'TANZANIAN',
  THAI = 'THAI',
  TOGOLESE = 'TOGOLESE',
  TONGAN = 'TONGAN',
  TRINIDADIAN = 'TRINIDADIAN',
  TRISTANIAN = 'TRISTANIAN',
  TUNISIAN = 'TUNISIAN',
  TURKISH = 'TURKISH',
  TURKMEN = 'TURKMEN',
  TURKS_AND_CAICOS_ISLANDER = 'TURKS_AND_CAICOS_ISLANDER',
  TUVALUAN = 'TUVALUAN',
  UGANDAN = 'UGANDAN',
  UKRAINIAN = 'UKRAINIAN',
  URUGUAYAN = 'URUGUAYAN',
  UZBEK = 'UZBEK',
  VATICAN_CITIZEN = 'VATICAN_CITIZEN',
  VENEZUELAN = 'VENEZUELAN',
  VIETNAMESE = 'VIETNAMESE',
  VINCENTIAN = 'VINCENTIAN',
  WALLISIAN = 'WALLISIAN',
  WELSH = 'WELSH',
  YEMENI = 'YEMENI',
  ZAMBIAN = 'ZAMBIAN',
  ZIMBABWEAN = 'ZIMBABWEAN',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The NeurodiversityStatus options for diversity and inclusion info. */
export enum EmployeeDiversityNeurodiversityStatus {
  YES = 'YES',
  NO = 'NO',
  UNSURE = 'UNSURE',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The NeurodiversityType options for diversity and inclusion info. */
export enum EmployeeDiversityNeurodiversityType {
  ADHD = 'ADHD',
  AUTISM = 'AUTISM',
  DYSLEXIA = 'DYSLEXIA',
  DYSPRAXIA = 'DYSPRAXIA',
  DYSCALCULIA = 'DYSCALCULIA',
  OTHER = 'OTHER',
}

/** The ReligiousBelief options for diversity and inclusion info. */
export enum EmployeeDiversityReligiousBelief {
  NO_RELIGION = 'NO_RELIGION',
  CHRISTIAN = 'CHRISTIAN',
  MUSLIM = 'MUSLIM',
  JEWISH = 'JEWISH',
  HINDU = 'HINDU',
  BUDDHIST = 'BUDDHIST',
  SIKH = 'SIKH',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** The Sexuality options for diversity and inclusion info. */
export enum EmployeeDiversitySexuality {
  HETEROSEXUAL_STRAIGHT = 'HETEROSEXUAL_STRAIGHT',
  GAY = 'GAY',
  LESBIAN = 'LESBIAN',
  BISEXUAL = 'BISEXUAL',
  PANSEXUAL = 'PANSEXUAL',
  ASEXUAL = 'ASEXUAL',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

/** An EmployeeDocument represents a document associated with an employee. */
export type EmployeeDocument = {
  __typename?: 'EmployeeDocument';
  /** The ID of the EmployeeDocument. */
  id: Scalars['UUID'];
  /** The display name of the EmployeeDocument. */
  name: Scalars['String'];
  /** The category of the EmployeeDocument. */
  category: EmployeeDocumentCategory;
  /** Whether the employee document is visible to the employee. */
  isVisibleToEmployee: Scalars['Boolean'];
  /** Whether the employee document is visible only to managers. */
  visibleOnlyToManagers: Scalars['Boolean'];
  /** The original filename of the EmployeeDocument. */
  filename: Scalars['String'];
  /** The pre-signed URL to access the document associated with the EmployeeDocument. */
  documentUrl: Scalars['String'];
};

/** The categories of Employee Documents. */
export enum EmployeeDocumentCategory {
  /** Documents that are related to the company, such as policies and procedures. */
  COMPANY_DOCUMENTS = 'COMPANY_DOCUMENTS',
  /** Documents related to disciplinary actions, such as warnings and appeals. */
  DISCIPLINARY = 'DISCIPLINARY',
  /** Documents that are specific to the employee, such as contracts and performance reviews. */
  EMPLOYEE_DOCUMENTS = 'EMPLOYEE_DOCUMENTS',
  /** Documents related to the exit and off-boarding process, such as exit interviews and final pay. */
  EXIT_AND_OFF_BOARDING = 'EXIT_AND_OFF_BOARDING',
  /** Documents related to the onboarding process, such as offer letters and tax forms. */
  ONBOARDING = 'ONBOARDING',
  /** Documents related to pay and benefits, such as payslips and benefit enrollment forms. */
  PAY_AND_BENEFITS = 'PAY_AND_BENEFITS',
  /** Documents related to performance notes, such as performance reviews and feedback. */
  PERFORMANCE_NOTE = 'PERFORMANCE_NOTE',
  /** Documents related to an absence, such as a doctor's note. */
  ABSENCE_DOCUMENT = 'ABSENCE_DOCUMENT',
}

/** The emergency contact details of the Employee. */
export type EmployeeEmergencyContactType = {
  __typename?: 'EmployeeEmergencyContactType';
  /** The first name of the Employee's emergency contact. */
  firstName: Scalars['String'];
  /** The last name of the Employee's emergency contact. */
  lastName: Scalars['String'];
  /** The phone number of the Employee's emergency contact. */
  phoneNumber: Scalars['String'];
  /** The email address of the Employee's emergency contact. */
  email: Scalars['String'];
};

/** The employment statuses available for employee employment. */
export enum EmployeeEmploymentStatus {
  /** Employee has a start date at the partner in the future. */
  JOINING = 'JOINING',
  /** Employee who currently works at the partner. */
  ACTIVE = 'ACTIVE',
  /** Employee who is leaving the partner in the next 30 days. */
  LEAVING = 'LEAVING',
  /** Employee no longer works at the partner. */
  ARCHIVED = 'ARCHIVED',
}

/** The reasons available for employee employment termination. */
export enum EmployeeEmploymentTerminationReason {
  /** Employee accepted other employment. */
  ACCEPTED_OTHER_EMPLOYMENT = 'ACCEPTED_OTHER_EMPLOYMENT',
  /** Employee is relocating. */
  RELOCATION = 'RELOCATION',
  /** Employee is leaving for personal reasons. */
  PERSONAL_REASONS = 'PERSONAL_REASONS',
  /** Employee is leaving due to job dissatisfaction. */
  JOB_DISSATISFACTION = 'JOB_DISSATISFACTION',
  /** Employee resigned with notice. */
  RESIGNATION_WITH_NOTICE = 'RESIGNATION_WITH_NOTICE',
  /** Employee resigned without notice. */
  RESIGNATION_WITHOUT_NOTICE = 'RESIGNATION_WITHOUT_NOTICE',
  /** Employee is returning to education. */
  RETURNING_TO_EDUCATION = 'RETURNING_TO_EDUCATION',
  /** Employee is leaving for medical reasons. */
  MEDICAL_REASONS = 'MEDICAL_REASONS',
  /** Employee is not returning from leave. */
  NOT_RETURNING_FROM_LEAVE = 'NOT_RETURNING_FROM_LEAVE',
  /** Employee is retiring. */
  RETIREMENT = 'RETIREMENT',
  /** Employee is leaving for extended travel. */
  EXTENDED_TRAVEL = 'EXTENDED_TRAVEL',
  /** Employment terminated due to unsatisfactory performance. */
  UNSATISFACTORY_PERFORMANCE = 'UNSATISFACTORY_PERFORMANCE',
  /** Employment terminated due to absenteeism. */
  ABSENTEEISM = 'ABSENTEEISM',
  /** Employment terminated due to violation of company policy. */
  VIOLATION_OF_COMPANY_POLICY = 'VIOLATION_OF_COMPANY_POLICY',
  /** Employment terminated due to expired work visa. */
  WORK_VISA_EXPIRED = 'WORK_VISA_EXPIRED',
  /** Employment terminated at end of contract. */
  END_OF_CONTRACT = 'END_OF_CONTRACT',
  /** Employment terminated due to job elimination. */
  JOB_ELIMINATION = 'JOB_ELIMINATION',
  /** Employment terminated due to gross misconduct. */
  GROSS_MISCONDUCT = 'GROSS_MISCONDUCT',
  /** Employment terminated due to redundancy. */
  REDUNDANCY = 'REDUNDANCY',
  /** Employment terminated for other reasons. */
  OTHER = 'OTHER',
  /** Employee is deceased. */
  DECEASED = 'DECEASED',
}

/** GraphQL type for representing an employee's balances on a fixed holiday policy. */
export type EmployeeFixedPolicyHolidayBalances = {
  __typename?: 'EmployeeFixedPolicyHolidayBalances';
  /** The number of days the employee has available to book assuming all pending holiday requests will be approved. */
  daysAvailableAssumingPendingApproved: Scalars['Decimal'];
  /** The total number of approved and pending paid days booked and taken. */
  totalApprovedAndPendingPaidDaysBookedAndTaken: Scalars['Decimal'];
  /** The number of approved paid holiday days for holidays that are in the past or ongoing. */
  pastOrOngoingPaidDaysTaken: Scalars['Decimal'];
  /** The number of approved paid holiday days for holidays that are in the future. */
  futureApprovedPaidDaysBooked: Scalars['Decimal'];
  /** The total number of pending paid holiday days in the current period. */
  totalPendingPaidDays: Scalars['Decimal'];
  /** The total number of manual days adjustments made in the current period. */
  manualDaysAdjustments: Scalars['Decimal'];
  /** The number of days the employee has left after all past or ongoing approved paid days. */
  daysBalance: Scalars['Decimal'];
};

/** GraphQL type for representing an employee's balances on a flexible (hourly accrual) holiday policy. */
export type EmployeeFlexiblePolicyHolidayBalances = {
  __typename?: 'EmployeeFlexiblePolicyHolidayBalances';
  /** The number of days the employee has left after all past or ongoing approved paid days. */
  daysBalance: Scalars['Decimal'];
  /** The number of hours the employee has left after all past or ongoing approved paid hours. */
  hoursBalance: Scalars['Decimal'];
  /** The number of days accrued, capped at the pro-rated policy maximum. */
  cappedDaysAccrued: Scalars['Decimal'];
  /** The number of hours accrued, capped at the pro-rated policy maximum. */
  cappedHoursAccrued: Scalars['Decimal'];
  /** The number of approved paid holiday days for holidays that are in the past or ongoing. */
  pastOrOngoingPaidDaysTaken: Scalars['Decimal'];
  /** The number of approved paid holiday hours for holidays that are in the past or ongoing. */
  pastOrOngoingPaidHoursTaken: Scalars['Decimal'];
  /** The number of days the employee has available to book assuming all pending holiday requests will be approved. */
  daysAvailableAssumingPendingApproved: Scalars['Decimal'];
  /** The number of hours the employee has available to book assuming all pending holiday requests will be approved. */
  hoursAvailableAssumingPendingApproved: Scalars['Decimal'];
  /** The number of approved paid holiday days for holidays that are in the future. */
  futureApprovedPaidDaysBooked: Scalars['Decimal'];
  /** The estimated number of approved paid holiday hours for holidays that are in the future. */
  futureApprovedPaidEstimatedHoursBooked: Scalars['Decimal'];
  /** The total number of pending paid holiday days. */
  totalPendingPaidDays: Scalars['Decimal'];
  /** The total number of pending paid holiday hours. */
  totalPendingPaidHours: Scalars['Decimal'];
  /** The total number of manual days adjustments made in the current period. */
  manualDaysAdjustments: Scalars['Decimal'];
  /** The total number of manual hours adjustments made in the current period. */
  manualHoursAdjustments: Scalars['Decimal'];
};

/** GraphQL type for representing an employee's holiday balances for a specific policy period. */
export type EmployeeHolidayBalancesPeriod = {
  __typename?: 'EmployeeHolidayBalancesPeriod';
  /** The holiday policy for this period. */
  policy: EmployerHolidayPolicy;
  /** The pro-rated entitlement for this period. Pro-rated based on the Employee's start date for fixed and flexible contracts, and their days per week for fixed contracts. Absent for hourly accrual policies with no cap. */
  proRatedEntitlement?: Maybe<Scalars['Decimal']>;
  /** The start date of this balance period. This can be the policy period start date, the employee's start date, or the date the employee was moved to this policy. */
  startDate: Scalars['Date'];
  /** The end date of this balance period. This can be the policy period end date, the employee's termination date, or the date the employee was moved to another policy. */
  endDate: Scalars['Date'];
  /** Balances for a fixed accrual policy. Present only when the policy accrual type is FIXED. */
  fixedBalances?: Maybe<EmployeeFixedPolicyHolidayBalances>;
  /** Balances for a flexible (hourly accrual) policy. Present only when the policy accrual type is HOURLY. */
  flexibleBalances?: Maybe<EmployeeFlexiblePolicyHolidayBalances>;
};

/** The home address of the employee. */
export type EmployeeHomeAddressType = {
  __typename?: 'EmployeeHomeAddressType';
  /** The first line of the employee's address. */
  addressLineOne: Scalars['String'];
  /** The post code of the employee's address. */
  postcode: Scalars['String'];
  /** The town of the employee's address. */
  town: Scalars['String'];
};

/** A notification for an employee. */
export type EmployeeNotification = {
  __typename?: 'EmployeeNotification';
  /** The unique identifier for the notification. */
  id: Scalars['UUID'];
  /** The partner member profile ID of the recipient. */
  recipientId: Scalars['UUID'];
  /** The notification headline. */
  headline: Scalars['String'];
  /** The notification body. */
  body: Scalars['String'];
  /** When the notification was created (UTC). */
  createdAt: Scalars['DateTime'];
  /** The type of notification. */
  notificationType: EmployeeNotificationType;
  /** Deep link paths associated with the notification. */
  deepLinkPaths: Array<Scalars['String']>;
  /** The site ID when the notification is scoped to a site. */
  siteId?: Maybe<Scalars['UUID']>;
  /** The sender ID when present. */
  senderId?: Maybe<Scalars['UUID']>;
  /** The sender's profile photo URL when resolved from the partner member profile. */
  senderProfilePhotoUrl?: Maybe<Scalars['String']>;
};

/** The notification settings for an employee. */
export type EmployeeNotificationSettings = {
  __typename?: 'EmployeeNotificationSettings';
  /** If notifications for site schedules and shifts are enabled. */
  siteSchedulesAndShiftsEnabled: Scalars['Boolean'];
  /** If notifications for holiday requests are enabled. */
  holidayRequestsEnabled: Scalars['Boolean'];
};

/** Defines notification types returned by the notifications gRPC API for core team members. */
export enum EmployeeNotificationType {
  UNSPECIFIED = 'UNSPECIFIED',
  OPEN_SHIFT_POSTED = 'OPEN_SHIFT_POSTED',
  SITE_SCHEDULE_SHIFTS_POSTED = 'SITE_SCHEDULE_SHIFTS_POSTED',
  HOLIDAY_REQUEST_APPROVED = 'HOLIDAY_REQUEST_APPROVED',
  HOLIDAY_REQUEST_REJECTED = 'HOLIDAY_REQUEST_REJECTED',
  HOLIDAY_REQUEST_SUBMITTED = 'HOLIDAY_REQUEST_SUBMITTED',
  SITE_SCHEDULE_APPROVED = 'SITE_SCHEDULE_APPROVED',
  SITE_SCHEDULE_REJECTED = 'SITE_SCHEDULE_REJECTED',
  SITE_SCHEDULE_SUBMITTED = 'SITE_SCHEDULE_SUBMITTED',
  SHIFT_UPDATED = 'SHIFT_UPDATED',
  SHIFT_ASSIGNED = 'SHIFT_ASSIGNED',
  SHIFT_CANCELLED_FOR_ASSIGNEE = 'SHIFT_CANCELLED_FOR_ASSIGNEE',
}

/** A paginated connection type that includes employee notifications and pagination metadata. */
export type EmployeeNotificationsConnection = {
  __typename?: 'EmployeeNotificationsConnection';
  /** Pagination metadata used to navigate through the list of results. */
  pageInfo: PageInfo;
  /** A list of notification nodes in the current page of results. */
  items: Array<EmployeeNotification>;
};

/** The input values required to resolve the notifications for an employee. */
export type EmployeeNotificationsInput = {
  /** Pagination parameters for the employee's notifications list. */
  pagination: PaginationInput;
  /** The date to start the notifications from. If not provided, no lower bound is applied. */
  dateGte?: Maybe<Scalars['Date']>;
  /** The date to end the notifications at. If not provided, no upper bound is applied. */
  dateLte?: Maybe<Scalars['Date']>;
};

/** The Employee's payroll information. */
export type EmployeePayrollInformation = {
  __typename?: 'EmployeePayrollInformation';
  /** The unique ID assigned to this employee in the external payroll system. */
  externalPayrollId?: Maybe<Scalars['String']>;
  /** The Employee's national insurance number. */
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  /** The Employee's employee statement. */
  employeeStatement?: Maybe<EmployeeStatement>;
  /** The Employee's student loan plan. */
  studentLoanPlan?: Maybe<StudentLoanPlan>;
};

/** A performance note for an Employee. */
export type EmployeePerformanceNote = {
  __typename?: 'EmployeePerformanceNote';
  /** The ID of the EmployeePerformanceNote. */
  id: Scalars['UUID'];
  /** The title of the performance note. */
  title: Scalars['String'];
  /** The description of the performance note. */
  description: Scalars['String'];
  /** The PartnerMemberProfile who created this note. */
  createdBy: PartnerMemberProfile;
  /** The date and time the note was created. */
  createdAt: Scalars['DateTime'];
  /** The EmployeeDocuments associated with this note. Resolve the EmployeeDocuments for the note based on the document ids. */
  supportingDocuments?: Maybe<Array<Maybe<EmployeeDocument>>>;
};

/** The Employee's RTW information. */
export type EmployeeRTW = {
  __typename?: 'EmployeeRTW';
  /** Source of truth for the Employee's RTW status. */
  status: RTWStatus;
  /** When the Employee's RTW expires. This will be null when there is no expiry or they have not completed a successful Screening. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** A list of an Employee's RTW screenings. */
  screenings?: Maybe<Array<RTWScreening>>;
  /** A single screening for the Employee. */
  screening: RTWScreening;
};

/** The Employee's RTW information. */
export type EmployeeRTWscreeningArgs = {
  screeningId: Scalars['UUID'];
};

/** A review submitted by an employee for one of their completed shifts. */
export type EmployeeShiftReview = {
  __typename?: 'EmployeeShiftReview';
  /** The unique identifier of the employee shift review. */
  id: Scalars['UUID'];
  /** The numeric rating for the shift. */
  rating: Scalars['Float'];
  /** Optional free-text comment about how the shift went. */
  comment?: Maybe<Scalars['String']>;
  /** Optional category tags for the shift review. */
  tags?: Maybe<Array<EmployeeShiftReviewTag>>;
};

/** A category tag for the shift review. */
export enum EmployeeShiftReviewTag {
  /** Feedback related to customers. */
  CUSTOMER = 'CUSTOMER',
  /** Feedback related to workload. */
  WORKLOAD = 'WORKLOAD',
  /** Feedback related to shift length. */
  SHIFT_LENGTH = 'SHIFT_LENGTH',
  /** Feedback related to management. */
  MANAGEMENT = 'MANAGEMENT',
  /** Feedback related to the team environment. */
  TEAM_ENVIRONMENT = 'TEAM_ENVIRONMENT',
}

/** The notification settings for an employee at a specific site. */
export type EmployeeSiteNotificationSettings = {
  __typename?: 'EmployeeSiteNotificationSettings';
  /** The unique ID of the site notification settings record. */
  id: Scalars['UUID'];
  /** If notifications for site schedules and shifts at this site are enabled. */
  siteSchedulesAndShiftsEnabled: Scalars['Boolean'];
};

/** The scheduling configuration set by a GM for a specific employee at a specific site. */
export type EmployeeSiteSchedulingConfigurationType = {
  __typename?: 'EmployeeSiteSchedulingConfigurationType';
  /** The ID of the scheduling configuration record. */
  id: Scalars['UUID'];
  /** The ID of the site this configuration is scoped to. */
  siteId: Scalars['UUID'];
  /** The ID of the partner member profile this configuration belongs to. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The minimum weekly hours floor set by a GM. Absent if never set or if the employee has a fixed contract. */
  minHours?: Maybe<Scalars['Decimal']>;
};

/** The TextChoices for the StudentProfile.employee_statement field. */
export enum EmployeeStatement {
  A = 'A',
  B = 'B',
  C = 'C',
}

/** An employee termination record. */
export type EmployeeTermination = {
  __typename?: 'EmployeeTermination';
  /** The unique identifier for the termination. */
  id: Scalars['UUID'];
  /** The date the employment ends. */
  employmentEndDate: Scalars['Date'];
  /** The reason for the termination. */
  reason: EmployeeEmploymentTerminationReason;
  /** Whether the termination was voluntary. */
  voluntary: Scalars['Boolean'];
  /** Whether the employee should be considered for rehire. */
  considerForRehire: Scalars['Boolean'];
  /** Optional note about the termination. */
  note?: Maybe<Scalars['String']>;
  /** The date and time when the termination was initiated. */
  initiatedAt: Scalars['DateTime'];
  /** The user who initiated this termination. */
  initiatedBy: StintUser;
  /** The date and time when the termination was cancelled. Null if not cancelled. */
  cancelledAt?: Maybe<Scalars['DateTime']>;
  /** The user who cancelled this termination. Null if not cancelled. */
  cancelledBy?: Maybe<StintUser>;
};

/** A working contract for an Employee. */
export type EmployeeWorkingContract = {
  __typename?: 'EmployeeWorkingContract';
  /** The ID of the EmployeeWorkingContract. */
  id: Scalars['UUID'];
  /** The date the contract becomes active. A null value indicates an open-started contract  */
  activeFrom?: Maybe<Scalars['Date']>;
  /** The date the contract ends. A null value indicates an open-ended contract  */
  activeTo?: Maybe<Scalars['Date']>;
  /** The expected hours for the contract. */
  expectedHours: Scalars['Decimal'];
  /**
   * The job title for the contract.
   * @deprecated Replaced by jobTitleV2 field.
   */
  jobTitle: Scalars['String'];
  /**
   * The ID of the PartnerJobTitle for the contract.
   * @deprecated Replaced by jobTitleV2 field.
   */
  jobTitleId?: Maybe<Scalars['UUID']>;
  /** The PartnerJobTitle for the contract. */
  jobTitleV2?: Maybe<PartnerJobTitleType>;
  /** The pay rate for the contract. Null in the case that the user in not authorised to see this information. */
  payRate?: Maybe<Scalars['Decimal']>;
  /** The type of contract. Null in the case that the user in not authorised to see this information. */
  contractType?: Maybe<ContractType>;
  /** The constraint applied to contracted hours. A null value indicates the contracted hours constraint is not specified. */
  contractedHoursConstraint?: Maybe<ContractedHoursConstraint>;
  /** The contracted hours for the contract. A null value indicates the contracted hours are not specified. */
  contractedHours?: Maybe<Scalars['Decimal']>;
  /** The contracted days per week for the contract. Only set when the contracted hours constraint is MINIMUM. */
  contractedDays?: Maybe<Scalars['Decimal']>;
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type Employer = {
  __typename?: 'Employer';
  /** The ID (Ref) of the StintUser object. */
  id: Scalars['UUID'];
  /** The first name of the Employer. */
  firstName: Scalars['String'];
  /** The last name of the Employer. */
  lastName: Scalars['String'];
  /** The phone number of the Employer. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The email of the Employer. */
  email: Scalars['String'];
  /**
   * Whether the Employer has notifications enabled. It could be null if the employer has not been
   *               asked for notification permissions
   */
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  /** The date the Employer was created. */
  createdAt: Scalars['DateTime'];
  /** The ID (ref) of the EmployerProfile object. */
  profileId: Scalars['UUID'];
  /**
   * The Account PartnerNode which is resolved for the given employer. This could be nullable
   *             because the employer might not be associated with partner account.
   */
  partnerAccount?: Maybe<PartnerAccountProfile>;
  /** Indicates which parts of the Partner app the Employer has access to. An empty list means that they have no membership for any Site and are still in onboarding. */
  employerAccess: Array<EmployerAccess>;
  /**
   * Retrieves a list of all SiteSchedule reviews that the Employer has access to for the provided date.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the READ_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when an Employer tries to access data for another Employer.
   */
  siteScheduleReviews: Array<SiteScheduleReview>;
  /** Resolves a flat list of upcoming shifts that the user is assigned to. These are all shifts that the user hasn't checked out of, EXCLUDING ones that were never checked-in to and their end time is now in the past (inelligible to check in). By default the list is sorted by start time asc.  */
  upcomingShifts: Array<Shift>;
  /** Resolves a single shift by its ID from the BI service. If no shift is found, a GraphQLError is raised. */
  shift: Shift;
  /** A relay paginated list of completed Shifts. */
  completedShifts?: Maybe<ShiftConnection>;
  /** A relay paginated list of open Shifts available to the employer. */
  openShifts?: Maybe<ShiftConnection>;
  /** The holiday information for the PartnerMemberProfile. */
  holidayInfo: CoreTeamMemberHolidayInfo;
  /** The core team member features that are available to the employer and that the requesting user has access to view. */
  coreTeamMemberFeaturesAvailable: Array<CoreTeamMemberFeatures>;
  /** The holiday requests for all the subordinates of the employer within the provided date range. This currently only implements the area manager view of the holiday requests, and will return an empty list if they do not have an area manager role. */
  subordinatesHolidays: Array<CoreTeamMemberHolidayAtSites>;
  /** The PartnerMemberProfile associated with the Employer. */
  employee: PartnerMemberProfile;
  /** The upcoming working preference requests for the Employer. */
  upcomingWorkingPreferenceRequests: Array<WorkingPreferenceRequest>;
  /** A relay paginated list of notifications for the Employer. */
  notifications: EmployeeNotificationsConnection;
  /** The notification settings for the employee. */
  notificationSettings: EmployeeNotificationSettings;
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type EmployersiteScheduleReviewsArgs = {
  weekCommencing: Scalars['Date'];
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type EmployershiftArgs = {
  id: Scalars['UUID'];
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type EmployercompletedShiftsArgs = {
  input: CompletedShiftsInput;
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type EmployeropenShiftsArgs = {
  input: OpenShiftsInput;
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type EmployersubordinatesHolidaysArgs = {
  input: SubordinatesHolidaysInput;
};

/** An Employer represents the data for a StintUser that is an Employer. An Employer is a StintUser that has access to the Partner app. */
export type EmployernotificationsArgs = {
  input: EmployeeNotificationsInput;
};

/** EmployerAccess is used to define which parts of the Partner app the Employer has access to. */
export enum EmployerAccess {
  /** This grants Account Admins the permission to view information for an entire account. They can update Account-level settings and policies. */
  ACCOUNT_ACCESS = 'ACCOUNT_ACCESS',
  /** This grants Area Managers access to a dedicated section within the application that displays all sites in their assigned area. It allows Area Managers to efficiently manage and review site-specific data while switching between their available Sites. */
  AREA_ACCESS = 'AREA_ACCESS',
  /** The Employer has access to the parts of the Partner app that handle features for a specific Site. This involves them viewing a single Site at a time and switching between their available Sites. */
  SITE_ACCESS = 'SITE_ACCESS',
  /** This grants Core Team Members access to a dedicated section within the application that displays member-specific information such as their assigned shifts */
  CORE_TEAM_ACCESS = 'CORE_TEAM_ACCESS',
}

/** GraphQL type for representing employer holiday policy data. */
export type EmployerHolidayPolicy = {
  __typename?: 'EmployerHolidayPolicy';
  /** The unique identifier of the employer holiday policy. */
  id: Scalars['ID'];
  /** The name of the holiday policy. */
  name: Scalars['String'];
  /** The day in the year when the holiday allowance resets. */
  resets: MonthDay;
  /** Whether employees can request holiday they have not accrued yet. */
  requestUnaccruedHoliday: Scalars['Boolean'];
  /** Whether employees can request holiday that falls in the next accrual period. */
  allowHolidayRequestsInNextPeriod: Scalars['Boolean'];
  /** The way holiday is accrued for this policy. */
  accrualType: EmployerHolidayPolicyAccrualType;
  /** Contains the fixed accrual holiday policy configuration, only present if accrual_type is `FIXED`. */
  fixedAccrual?: Maybe<EmployerHolidayPolicyFixedAccrual>;
  /** Contains the hourly accrual holiday policy configuration, only present if accrual_type is `HOURLY`. */
  hourlyAccrual?: Maybe<EmployerHolidayPolicyHourlyAccrual>;
  /** Default days/week used to pro-rate allowance against contracted_days. */
  defaultDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** Default hours/week used to pro-rate allowance against contracted_hours. */
  defaultHoursPerWeek?: Maybe<Scalars['Decimal']>;
  /** The maximum number of unaccrued holiday days an employee can request. Null means no cap. */
  maxUnaccruedHolidayDaysRequestable?: Maybe<Scalars['Decimal']>;
};

/** The type of accrual for the holiday policy. */
export enum EmployerHolidayPolicyAccrualType {
  /** The holiday is accrued in a fixed amount for each working week. */
  FIXED = 'FIXED',
  /** The holiday is accrued per hour worked. */
  HOURLY = 'HOURLY',
}

/** GraphQL type for representing fixed holiday accrual configuration. */
export type EmployerHolidayPolicyFixedAccrual = {
  __typename?: 'EmployerHolidayPolicyFixedAccrual';
  /** The yearly holiday day allowance for a 5 day per week worker. */
  allowance: Scalars['Decimal'];
  /** Whether public holidays count towards the allowance. */
  includesPublicHolidays: Scalars['Boolean'];
  /** Whether the allowance accrues pro rata i.e. if the employee works a fraction of a year, they are entitled to that fraction of the yearly allowance. */
  accruesProRata: Scalars['Boolean'];
};

/** GraphQL input type for representing fixed holiday accrual configuration. */
export type EmployerHolidayPolicyFixedAccrualInput = {
  /** The yearly allowance of holiday days this policy entitles to for 5 day working week workers. */
  allowance: Scalars['Decimal'];
  /** Whether the allowance accrues pro rata i.e. if the employee only works the last quarter of a year, they are entitled to a quarter of the yearly allowance only. */
  accruesProRata: Scalars['Boolean'];
};

/** GraphQL type for representing hourly holiday accrual configuration. */
export type EmployerHolidayPolicyHourlyAccrual = {
  __typename?: 'EmployerHolidayPolicyHourlyAccrual';
  /** The rate at which holiday hours accrue per hour worked. This is a percentage rate i.e. 0.15 = 15%, and e.g. an employee working 10 hours will accrue 1.5 hours of holiday. */
  rateOfAccrual: Scalars['Decimal'];
  /** Optional maximum cap in days on accrued holiday. */
  cap?: Maybe<Scalars['Decimal']>;
};

/** GraphQL input type for representing hourly holiday accrual configuration. */
export type EmployerHolidayPolicyHourlyAccrualInput = {
  /** The rate at which holiday hours accrue per hour worked. This is a percentage rate i.e. 0.15 = 15%, and e.g. an employee working 10 hours will accrue 1.5 hours of holiday. */
  rateOfAccrual: Scalars['Decimal'];
  /** Optional maximum cap in days on accrued holiday. */
  cap?: Maybe<Scalars['Decimal']>;
};

/** The user's employer profile. */
export type EmployerProfile = {
  __typename?: 'EmployerProfile';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  employer: StintUser;
  /** The selected business of the employer. */
  selectedBusiness?: Maybe<Business>;
  identityPhotoFile?: Maybe<Scalars['String']>;
  bookedOnboardingMeeting: Scalars['Boolean'];
  usingStintCorrectly: Scalars['Boolean'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  addresses: Array<Address>;
  paymentMethods: Array<DirectDebitPaymentMethod>;
  cardPaymentMethods: Array<CardPaymentMethod>;
  /** Id of related Business (auto-generated). */
  selected_business_id?: Maybe<Scalars['UUID']>;
};

export type EmploymentException = {
  __typename?: 'EmploymentException';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  name: Scalars['String'];
  category: EmploymentExceptionCategory;
  studentProfileExceptions: Array<StudentProfile>;
};

/** The TextChoices for the EmploymentException.category field. */
export enum EmploymentExceptionCategory {
  PREFERENCE = 'PREFERENCE',
  RELIGIOUS_AND_MEDICAL = 'RELIGIOUS_AND_MEDICAL',
}

/**
 * The TextChoices for the EmploymentException.category field.
 *
 *     This duplicate class is required to avoid a breaking change to the graph for the input types while doing the Django
 *     upgrade. Eventually these should be combined into one class again.
 */
export enum EmploymentExceptionCategoryInputType {
  PREFERENCE = 'PREFERENCE',
  RELIGIOUS_AND_MEDICAL = 'RELIGIOUS_AND_MEDICAL',
}

export type EmploymentExceptionFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** q */
  q?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  /** category_search */
  category_search?: Maybe<Scalars['String']>;
  /** category_gte */
  category_gte?: Maybe<Scalars['String']>;
  /** category_lte */
  category_lte?: Maybe<Scalars['String']>;
  /** category_istartswith */
  category_istartswith?: Maybe<Scalars['String']>;
  /** category_lt */
  category_lt?: Maybe<Scalars['String']>;
  /** category_gt */
  category_gt?: Maybe<Scalars['String']>;
  /** category_isnull */
  category_isnull?: Maybe<Scalars['Boolean']>;
  /** category_iendswith */
  category_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  category_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EmploymentExceptionListType = {
  __typename?: 'EmploymentExceptionListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<EmploymentException>>>;
};

/** An EmploymentInfo represents the employment details for a PartnerMember. */
export type EmploymentInfo = {
  __typename?: 'EmploymentInfo';
  /** The ID of the EmploymentInfo. */
  id: Scalars['UUID'];
  /**
   * The expected working hours for the PartnerMember.
   * @deprecated Replaced by decimal field expected_hours_v2
   */
  expectedHours?: Maybe<Scalars['Int']>;
  /**
   * The expected working hours for the PartnerMember.
   * @deprecated Replaced by WorkingContracts in HR service.
   */
  expectedHoursV2?: Maybe<Scalars['Decimal']>;
  /**
   * The job title for the PartnerMember.
   * @deprecated Replaced by WorkingContracts in HR service.
   */
  jobTitle?: Maybe<Scalars['String']>;
  /**
   * The pay rate for the PartnerMember. Only Staff users have permission to view this field. Any other user type will receive a null value.
   * @deprecated Replaced by WorkingContracts in HR service.
   */
  payRate?: Maybe<Scalars['Decimal']>;
  /**
   * The contract type for the PartnerMember. Either FLEXIBLE OR FIXED.
   * @deprecated Replaced by WorkingContracts in HR service.
   */
  contractType?: Maybe<ContractType>;
  /**
   * The date of birth for the PartnerMember.
   * @deprecated This field is deprecated because it is now stored on the PartnerMemberProfile.
   */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /**
   * A boolean indicating if the PartnerMember is a young worker.
   * @deprecated This field is deprecated because it is now inferred on PartnerMemberProfile.
   */
  isYoungWorker?: Maybe<Scalars['Boolean']>;
  /**
   * The legal status for the PartnerMember.
   * @deprecated This field is deprecated because it is now stored on the PartnerMemberProfile.
   */
  legalStatus?: Maybe<LegalStatus>;
  /** A boolean indicating whether the PartnerMember is undergoing a training process. */
  training: Scalars['Boolean'];
  /** A 0-to-5 integer representing the skill level of a PartnerMember. If the PartnerMember is in training, the skill level is always set to zero. */
  skillLevel: Scalars['Int'];
  /** The list of secondary role configurations that the PartnerMember can be scheduled for. */
  secondaryRolesV2: Array<RoleConfiguration>;
};

/**
 * This class defines the input values that are required from the client to fail the trial of
 * a Stinter in a StintTemplate's Pool.
 */
export type FailTrialStinterForStintTemplatePoolInput = {
  /** The StintTemplatePoolMember ID of the Trial Stinter to fail for the StintTemplate's Pool. */
  stintTemplatePoolMemberId: Scalars['UUID'];
  /** The list of reason IDs for which the Trial Stinter is being failed for the StintTemplate's Pool. */
  reasons: Array<Scalars['UUID']>;
  /** The more info for the failed trial. */
  moreInfo?: Maybe<Scalars['String']>;
};

/** Represents the data for a Stinter's failed trial that has not yet been acknowledged. */
export type FailedTrialPoolData = {
  __typename?: 'FailedTrialPoolData';
  /** The name of the business at which the trial was failed. */
  siteName: Scalars['String'];
  /** The ID of the StintTemplatePoolMember whose trial was failed. */
  stintTemplatePoolMemberId: Scalars['UUID'];
};

/** Represents a file upload. */
export type FileUpload = {
  __typename?: 'FileUpload';
  /** The ID of the Document for the initiated upload. This ID is required when storing the file upload in the database. */
  documentId: Scalars['UUID'];
  /** The presigned URL that can be used to upload the file. */
  presignedUrl: Scalars['String'];
};

/**
 * The FilterInput class defines the input values that are required for filtering a list of
 * objects with the provided search value from the client.
 *
 * This is required as an InputObject rather than just adding the String directly to the Query
 * Arguments because react-admin sends the filter values in a filter input magically and so our
 * schema needs to match it.
 */
export type FilterInput = {
  /** An optional search value to filter the returned list. */
  search?: Maybe<Scalars['String']>;
};

/** A time window with a start and end. */
export type FiniteTimeWindow = {
  __typename?: 'FiniteTimeWindow';
  /** The start of the time window. */
  start: Scalars['DateTime'];
  /** The end of the time window. */
  end: Scalars['DateTime'];
};

/** The input values required to fetch flexible-contract employees at a site for a given week. */
export type FlexibleEmployeesInput = {
  /** The start date of the week being configured. Used to determine flexible contract coverage. */
  weekCommencing: Scalars['Date'];
};

/** Represents the count and display name of a particular item in the item breakdown of an HourlyForecast. */
export type ForecastItemDetails = {
  __typename?: 'ForecastItemDetails';
  /** The free text name of the item to be displayed in the UI. */
  itemType: Scalars['String'];
  /** The count of the item. */
  itemCount: Scalars['Int'];
  /** The number of covers for the item forecast. This is nullable to be backwards compatible, and if not present, the covers should be calculated using the item count and the standard items per cover rate (2.5 casual dining and 1.5 for QSR). */
  covers?: Maybe<Scalars['Float']>;
};

/** The type of DemandForecast. */
export enum ForecastType {
  /** The Shifts for the Forecast are determined by the Demand Range the Forecasted Sales fall into. */
  STATIC = 'STATIC',
  /** The Shifts for the Forecast are determined directly by the Forecasted Sales. */
  DYNAMIC = 'DYNAMIC',
  /** The Shifts for the Forecast are determined by the Kickpoint algorithm. */
  KICKPOINT = 'KICKPOINT',
}

export type ForgotPassword = {
  __typename?: 'ForgotPassword';
  /** Returns true if forgot password email was sent successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/** The gender for a PartnerMember */
export enum Gender {
  /** The PartnerMember is a Female. */
  FEMALE = 'FEMALE',
  /** The PartnerMember is a Male. */
  MALE = 'MALE',
  /** The PartnerMember is Transgender. */
  TRANSGENDER = 'TRANSGENDER',
  /** The PartnerMember is Non-binary */
  NON_BINARY = 'NON_BINARY',
  /** The PartnerMember prefers not to respond */
  PREFER_NOT_RESPOND = 'PREFER_NOT_RESPOND',
  /** The PartnerMember's gender is Other */
  OTHER = 'OTHER',
}

/** The input values required from a client to fetch an employee document. */
export type GetEmployeeDocumentInput = {
  /** The ID of the PartnerMemberProfile for the employee. */
  profileId: Scalars['UUID'];
  /** The ID of the EmployeeDocument that is being fetched. */
  employeeDocumentId: Scalars['UUID'];
};

/** The input values required to get an employee shift review. */
export type GetEmployeeShiftReviewInput = {
  /** The ID of the partner member profile to get the employee shift review for. */
  partnerMemberProfileId: Scalars['UUID'];
};

/** The input values required to get a PartnerMember. */
export type GetPartnerMemberInput = {
  /** The ID of the PartnerMember being requested. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the PartnerMember is being requested through. Used to check permissions. */
  partnerNodeId: Scalars['UUID'];
};

/** Deprecated: The filtering criteria for a list of PartnerMember records. This input is no longer used and will be removed in a future release. */
export type GetPartnerMembersInput = {
  /**
   * Deprecated: This field is no longer used.
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filter?: Maybe<PartnerMembersFilterInput>;
};

/**
 * The PartnerPoolInviteType class defines the Graphene ObjectType class used
 * to resolve the PartnerPoolInvite model data for GraphQL queries.
 *
 * This type implements the Node interface, allowing it to be relay paginated.
 */
export type GetPartnerPoolInvitesInputType = {
  /** The ID of the PartnerPool to get invites for. */
  partnerPoolId: Scalars['UUID'];
  /** The UUID of the PartnerNode associated with the PartnerPool. */
  partnerNodeId: Scalars['UUID'];
};

/** The input values that are required to resolve an SSO IdP hint. */
export type GetSSOIdpHintInput = {
  /** The email address used to resolve the IdP hint. */
  email: Scalars['String'];
};

/** The output values that are returned when resolving an SSO IdP hint. */
export type GetSSOIdpHintOutput = {
  __typename?: 'GetSSOIdpHintOutput';
  /** The SSO IdP hint for the provided email. */
  idpHint: Scalars['String'];
};

/** The filtering and ordering criteria for a list of StintTemplate records. */
export type GetStintTemplatesInput = {
  /**
   * Allow specifying the order of the results.
   * If not specified, the results will be ordered by name ascending.
   */
  orderBy?: Maybe<StintTemplatesOrderInput>;
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filter?: Maybe<StintTemplatesFilterInput>;
};

/** The input values required to get the suggested week breakdown for a holiday. */
export type GetSuggestedWeekBreakdownInput = {
  /** The ID of the partner member profile that the holiday request is for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The start date of the holiday request. */
  startDate: Scalars['Date'];
  /** The end date of the holiday request. */
  endDate: Scalars['Date'];
  /** The days breakdown of the holiday request. */
  days: Array<CoreTeamMemberHolidayDayInput>;
};

/** The output values required to get the suggested week breakdown for a holiday. */
export type GetSuggestedWeekBreakdownOutput = {
  __typename?: 'GetSuggestedWeekBreakdownOutput';
  /** The week breakdown of the holiday request. */
  weekBreakdown: Array<HolidayRequestWeekBreakdown>;
};

/** Defines the input values required to retrieve upcoming Stints for a stinter. */
export type GetUpcomingStintsForStinterInput = {
  /** The ref UUID of the stinter. */
  stinterId: Scalars['UUID'];
  /** The ref UUID of the stint template. */
  stintTemplateId: Scalars['UUID'];
  /** The ref UUID of the site partner node. */
  partnerNodeId: Scalars['UUID'];
  /** The number of hours to look ahead. Defaults to 24. */
  withinHours?: Maybe<Scalars['Int']>;
};

/** The input values required to retrieve working preference requests at a site. */
export type GetWorkingPreferenceRequestsAtSiteInput = {
  /** The minimum date to filter requests by (inclusive). */
  dateGte?: Maybe<Scalars['Date']>;
  /** The maximum date to filter requests by (inclusive). */
  dateLte?: Maybe<Scalars['Date']>;
  /** A list of statuses to filter requests by. */
  statusIn?: Maybe<Array<Maybe<WorkingPreferenceRequestStatus>>>;
};

export type GooglePlaceType = {
  __typename?: 'GooglePlaceType';
  /** Human readable place description */
  displayAddress?: Maybe<Scalars['String']>;
  /** Google Places ID */
  placeId?: Maybe<Scalars['String']>;
};

export type GooglePlacesPredictionsType = {
  __typename?: 'GooglePlacesPredictionsType';
  predictions?: Maybe<Array<Maybe<GooglePlaceType>>>;
};

export enum GooglePlacesReturnType {
  ADDRESS = 'ADDRESS',
  CITY = 'CITY',
  PLACE = 'PLACE',
  POSTAL_CODE = 'POSTAL_CODE',
}

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  grantedByAdminsOnly: Scalars['Boolean'];
};

/** The HR partner account settings values for a Partner. */
export type HRPartnerAccountSettings = {
  __typename?: 'HRPartnerAccountSettings';
  /** The maximum number of holiday days a core team member can take in a single week. */
  maxHolidayDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** The minimum number of holiday days a core team member can take in a single week. */
  minHolidayDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** The absence request types that are enabled for this partner account. */
  enabledAbsenceRequestTypes: Array<CoreTeamAbsenceType>;
};

/** The values for updating the HR partner account settings for a PartnerAccountSettings. A null values for a field will result in the field being set to null. */
export type HRPartnerAccountSettingsInput = {
  /** The maximum number of holiday days a core team member can take in a single week. */
  maxHolidayDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** The minimum number of holiday days a core team member can take in a single week. */
  minHolidayDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** The absence request types that are enabled for this partner account. */
  enabledAbsenceRequestTypes: Array<CoreTeamAbsenceType>;
};

export type HasStintStartingSoon = {
  __typename?: 'HasStintStartingSoon';
  /** Returns true if user has a stint within 24 hours. */
  success?: Maybe<Scalars['Boolean']>;
};

/** A Headcount represents a headcount in a DemandForecast which contains the times and the type of shift. */
export type Headcount = {
  __typename?: 'Headcount';
  /** The unique identifier of the Headcount in the DemandForecast. */
  id: Scalars['UUID'];
  /** The ID of the recurring shift template that corresponds to this headcount. */
  recurringShiftTemplateId?: Maybe<Scalars['UUID']>;
  /** The optional name of the Headcount to be displayed. */
  name?: Maybe<Scalars['String']>;
  /** The start time of the headcount. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The end time of the headcount. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
  /** The assigned core team member profile ID when the headcount is a non service shift. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** For service headcounts, the value is null. For non-service headcounts, the value represents the type of non-service. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The last time the headcount was modified. This is a string because of potential discrepancy whenconverting between DateTime types. */
  modifiedAt?: Maybe<Scalars['String']>;
  /** The role configuration ID for this headcount. For Stint headcounts (isStint=true), this will be null. For historical records where role configuration data was not set, this will be null. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** Flag indicating if this is a Stint headcount. */
  isStint: Scalars['Boolean'];
  /** The role configuration for this headcount. Uses a dataloader to efficiently batch-load role configurations. Returns null for Stint headcounts or when roleConfigurationId is not set. */
  role?: Maybe<RoleConfiguration>;
  /**
   * The stint template (role) that this shift belongs to, if STINT type.
   * @deprecated This field is deprecated and will be removed in the future.
   */
  stintTemplate?: Maybe<StintTemplate>;
  /**
   * The breaks that the core team member will take during their shift.
   * @deprecated This field is deprecated and will be removed in the future.
   */
  shiftBreaks?: Maybe<Array<ShiftBreak>>;
  /**
   * Flag to indicate whether breaks are paid for this shift.
   * @deprecated This field is deprecated and will be removed in the future.
   */
  breaksPaid?: Maybe<Scalars['Boolean']>;
  /**
   * Flag to mark whether or not the headcount should be displayed on the UI.
   * @deprecated This field is deprecated and will be removed in the future.
   */
  hidden?: Maybe<Scalars['Boolean']>;
};

/** The projected labour cost for a site and week based on running the auto-scheduler. */
export type HeadcountCost = {
  __typename?: 'HeadcountCost';
  /** The labour figure as a monetary amount (GBP). */
  cost: Scalars['Decimal'];
  /** The labour figure as a percentage of forecast sales for the week, expressed as a ratio (e.g. 0.30 means 30%). */
  percentage: Scalars['Decimal'];
  /** The labour figure as total staffed hours across the week. */
  hours: Scalars['Decimal'];
};

/** Input values required to fetch headcount opportunities for a site and week. */
export type HeadcountOpportunitiesInput = {
  /** The week commencing date of the 7-day window to retrieve opportunities for. */
  weekCommencing: Scalars['Date'];
  /** When set, returns at most one opportunity matching this ID within the week_commencing window. The blocked-opportunity filter still applies. */
  opportunityId?: Maybe<Scalars['UUID']>;
};

/** A labour-saving opportunity for a specific time window, generated by Kick-Point. */
export type HeadcountOpportunity = {
  __typename?: 'HeadcountOpportunity';
  /** The unique identifier for the opportunity. */
  id: Scalars['UUID'];
  /** The start of the time window in which headcount could be reduced. */
  start: Scalars['DateTime'];
  /** The end of the time window in which headcount could be reduced. */
  end: Scalars['DateTime'];
  /** The ID of the headcount block this opportunity targets. Null for Invest opportunities, which create a new headcount rather than targeting an existing one. */
  headcountId?: Maybe<Scalars['UUID']>;
  /** Whether this opportunity saves labour by reducing headcount or invests by adding a new one. */
  opportunityType: HeadcountOpportunityType;
  /** The role configuration this opportunity applies to. */
  roleConfigurationId: Scalars['UUID'];
  /** The risk label for display. Lower risk = more confidently recommended. */
  riskStatus: HeadcountOpportunityRiskStatus;
  /** The monetary saving if accepted. */
  cost: Scalars['Decimal'];
  /** The current review state of this opportunity. */
  reviewStatus: HeadcountOpportunityStatus;
  /** Provided only if the opportunity is rejected. */
  rejectionReason?: Maybe<Scalars['String']>;
  /** True if this is among the recommended opportunities. */
  isRecommended: Scalars['Boolean'];
  /** ID of the opportunity that must be accepted before this one is actionable. Null if unblocked. */
  blockedById?: Maybe<Scalars['UUID']>;
  /** Start of the partner-adjusted acceptance window. Null unless the opportunity was accepted with a modified window. */
  modifiedStart?: Maybe<Scalars['DateTime']>;
  /** End of the partner-adjusted acceptance window. Null unless the opportunity was accepted with a modified window. */
  modifiedEnd?: Maybe<Scalars['DateTime']>;
  /** Historical evidence records backing this opportunity, ordered by importance. */
  evidences: Array<HeadcountOpportunityEvidence>;
  /** Summary occurrence counts for the evidence backing this opportunity. Unlike `evidences`, counts reflect all evidence — not filtered by accepted opportunities on the same day. */
  evidenceMetrics: HeadcountOpportunityEvidenceMetrics;
  /** The explanation of why this opportunity was raised, with metrics. Null for Subtract opportunities. */
  explanation?: Maybe<OpportunityExplanation>;
};

/** A comparable historical day from another site, used to back an opportunity. */
export type HeadcountOpportunityEvidence = {
  __typename?: 'HeadcountOpportunityEvidence';
  /** The unique identifier for this evidence record. */
  id: Scalars['UUID'];
  /** The ID of the site this evidence originates from. Null when the evidence has an external origin. */
  siteId?: Maybe<Scalars['UUID']>;
  /** The name of the site this evidence originates from. */
  siteName: Scalars['String'];
  /** The calendar date of this historical day. */
  date: Scalars['Date'];
  /** The total sales on this historical day. */
  sales: Scalars['Decimal'];
  /** The service quality metric for this historical day. */
  serviceMetric?: Maybe<Scalars['Decimal']>;
  /** The hourly item-count demand for this historical day. */
  hourlyDemand: Array<HeadcountOpportunityEvidenceHourlyDemand>;
  /** The headcount blocks active on this historical day. */
  headcounts: Array<FiniteTimeWindow>;
};

/** An hourly item-count demand entry from a historical evidence day. */
export type HeadcountOpportunityEvidenceHourlyDemand = {
  __typename?: 'HeadcountOpportunityEvidenceHourlyDemand';
  /** The timestamp for this hourly demand bucket. */
  timestamp: Scalars['DateTime'];
  /** The item-count demand for this hour. */
  itemCount: Scalars['Int'];
};

/** Flattened evidence occurrence counts split by site (same vs. other) and weekday (same vs. other) axes. */
export type HeadcountOpportunityEvidenceMetrics = {
  __typename?: 'HeadcountOpportunityEvidenceMetrics';
  /** Evidence days from the same site, matching the same day of the week as the opportunity. */
  sameSiteSameWeekdayOccurrences: Scalars['Int'];
  /** Evidence days from the same site, on a different day of the week to the opportunity. */
  sameSiteOtherWeekdayOccurrences: Scalars['Int'];
  /** Evidence days from other sites, matching the same day of the week as the opportunity. */
  otherSitesSameWeekdayOccurrences: Scalars['Int'];
  /** Evidence days from other sites, on a different day of the week to the opportunity. */
  otherSitesOtherWeekdayOccurrences: Scalars['Int'];
};

/** The risk status of a headcount opportunity. */
export enum HeadcountOpportunityRiskStatus {
  /** The risk status has not been set. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** Very high risk. */
  VERY_HIGH = 'VERY_HIGH',
  /** High risk. */
  HIGH = 'HIGH',
  /** Medium risk. */
  MEDIUM = 'MEDIUM',
  /** Low risk. */
  LOW = 'LOW',
  /** Very low risk. */
  VERY_LOW = 'VERY_LOW',
}

/** The review status of a headcount opportunity. */
export enum HeadcountOpportunityStatus {
  /** The review status has not been set. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** The opportunity has been accepted. */
  ACCEPTED = 'ACCEPTED',
  /** The opportunity has been rejected. */
  REJECTED = 'REJECTED',
  /** The opportunity has not yet been reviewed. */
  UNREVIEWED = 'UNREVIEWED',
}

/** The direction of a headcount opportunity. */
export enum HeadcountOpportunityType {
  /** The opportunity type has not been set. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** The opportunity reduces headcount to save labour cost. */
  SUBTRACT = 'SUBTRACT',
  /** The opportunity adds a new headcount to invest in service. */
  ADD = 'ADD',
}

/**
 * The HealthCheckType class defines the GraphQL type for the health check query.
 *
 * This type is used to represent the health status of the API in response to the health check query.
 */
export type HealthCheckType = {
  __typename?: 'HealthCheckType';
  /** Health check status. */
  success?: Maybe<Scalars['String']>;
};

/** An activity entry in a holiday request's activity log. */
export type HolidayRequestActivity = {
  __typename?: 'HolidayRequestActivity';
  /** The type of action that took place. */
  type: HolidayRequestActivityType;
  /** The datetime when the action took place. */
  activityAt: Scalars['DateTime'];
  /** The partner member profile who performed the action. This is nullable to avoid blocking issues if the user does not have permission to access the PartnerMemberProfile. */
  activityBy?: Maybe<PartnerMemberProfile>;
  /** An optional note associated with the activity, such as a rejection reason. */
  note?: Maybe<Scalars['String']>;
};

/** The type of activity on a holiday request. */
export enum HolidayRequestActivityType {
  /** The holiday request was submitted by a manager or by the employee. */
  REQUESTED = 'REQUESTED',
  /** The holiday request was approved by a manager. */
  APPROVED = 'APPROVED',
  /** The holiday request was cancelled by a manager or by the employee. */
  CANCELLED = 'CANCELLED',
  /** The holiday request was rejected by a manager. */
  REJECTED = 'REJECTED',
}

/** The week breakdown for a holiday request is the number of effective paid days for the week starting on the week_commencing_date. */
export type HolidayRequestWeekBreakdown = {
  __typename?: 'HolidayRequestWeekBreakdown';
  /** The date of the week commencing. */
  weekCommencingDate: Scalars['Date'];
  /** The number of effective days for the week. */
  effectiveDays: Scalars['Decimal'];
};

/** The week breakdown for a holiday request is the number of effective paid days for the week starting on the week_commencing_date. */
export type HolidayRequestWeekBreakdownInput = {
  /** The date of the week commencing. */
  weekCommencingDate: Scalars['Date'];
  /** The number of effective days for the week. */
  effectiveDays: Scalars['Decimal'];
};

/** The TextChoices for the WorkExperience.hospitality_work_experience field. */
export enum HospitalityWorkExperience {
  NO_EXPERIENCE = 'NO_EXPERIENCE',
  LESS_THAN_2_MONTHS = 'LESS_THAN_2_MONTHS',
  MORE_THAN_2_MONTHS = 'MORE_THAN_2_MONTHS',
}

export type Hotspot = {
  __typename?: 'Hotspot';
  id: Scalars['ID'];
  /** Start time of hotspot */
  startTime?: Maybe<Scalars['DateTime']>;
  /** End time of hotspot */
  endTime?: Maybe<Scalars['DateTime']>;
  /** The levels of busyness */
  hotspotBusynessLevel?: Maybe<Scalars['String']>;
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
};

export type HotspotTimeBusynessFilter = {
  cityId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  /** startTime_gte */
  startTime_gte?: Maybe<Scalars['DateTime']>;
  /** startTime_lte */
  startTime_lte?: Maybe<Scalars['DateTime']>;
  /** startTime_istartswith */
  startTime_istartswith?: Maybe<Scalars['DateTime']>;
  /** startTime_lt */
  startTime_lt?: Maybe<Scalars['DateTime']>;
  /** startTime_gt */
  startTime_gt?: Maybe<Scalars['DateTime']>;
  /** startTime_isnull */
  startTime_isnull?: Maybe<Scalars['Boolean']>;
  /** startTime_iendswith */
  startTime_iendswith?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  /** endTime_gte */
  endTime_gte?: Maybe<Scalars['DateTime']>;
  /** endTime_lte */
  endTime_lte?: Maybe<Scalars['DateTime']>;
  /** endTime_istartswith */
  endTime_istartswith?: Maybe<Scalars['DateTime']>;
  /** endTime_lt */
  endTime_lt?: Maybe<Scalars['DateTime']>;
  /** endTime_gt */
  endTime_gt?: Maybe<Scalars['DateTime']>;
  /** endTime_isnull */
  endTime_isnull?: Maybe<Scalars['Boolean']>;
  /** endTime_iendswith */
  endTime_iendswith?: Maybe<Scalars['DateTime']>;
  busynessLevel?: Maybe<Scalars['String']>;
  /** busynessLevel_search */
  busynessLevel_search?: Maybe<Scalars['String']>;
  /** busynessLevel_gte */
  busynessLevel_gte?: Maybe<Scalars['String']>;
  /** busynessLevel_lte */
  busynessLevel_lte?: Maybe<Scalars['String']>;
  /** busynessLevel_istartswith */
  busynessLevel_istartswith?: Maybe<Scalars['String']>;
  /** busynessLevel_lt */
  busynessLevel_lt?: Maybe<Scalars['String']>;
  /** busynessLevel_gt */
  busynessLevel_gt?: Maybe<Scalars['String']>;
  /** busynessLevel_isnull */
  busynessLevel_isnull?: Maybe<Scalars['Boolean']>;
  /** busynessLevel_iendswith */
  busynessLevel_iendswith?: Maybe<Scalars['String']>;
  busynessLevelOverride?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_search */
  busynessLevelOverride_search?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_gte */
  busynessLevelOverride_gte?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_lte */
  busynessLevelOverride_lte?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_istartswith */
  busynessLevelOverride_istartswith?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_lt */
  busynessLevelOverride_lt?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_gt */
  busynessLevelOverride_gt?: Maybe<Scalars['String']>;
  /** busynessLevelOverride_isnull */
  busynessLevelOverride_isnull?: Maybe<Scalars['Boolean']>;
  /** busynessLevelOverride_iendswith */
  busynessLevelOverride_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  startTime_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  endTime_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  busynessLevel_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  busynessLevelOverride_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Represents pairings of timestamps and sales data, such as item count of sold goods. This data can be used as a means of viewing the breakdown for the actual demand, rather than viewing a single aggregate value. NB: the timestamps are not actually restricted to hourly intervals. */
export type HourlyActual = {
  __typename?: 'HourlyActual';
  /** The timestamp of the sales data. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  timestamp: Scalars['DateTime'];
  /** The count of goods that were sold within the time period that the timestamp represents (i.e starters, pizzas, desserts, drinks, etc.). */
  itemCount: Scalars['Int'];
  /** The OperationalArea of the HourlyActual. */
  operationalArea: OperationalArea;
  /** The breakdown of items sold. */
  itemBreakdown: Array<ActualItemDetails>;
};

/** Represents pairings of timestamps and forecasted data, such as item count of sold goods. This data can be used as a means of viewing the breakdown for the demand forecast, rather than viewing a single aggregate value. NB: the timestamps are not actually restricted to hourly intervals. */
export type HourlyForecast = {
  __typename?: 'HourlyForecast';
  /** The timestamp of the forecasted data. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  timestamp: Scalars['DateTime'];
  /** The forecasted count of goods that will be sold within the time period that the timestamp represents (i.e starters, pizzas, desserts, drinks, etc.). */
  itemCount: Scalars['Int'];
  /** The breakdown of items forecasted to be sold. */
  itemBreakdown: Array<ForecastItemDetails>;
  /** The OperationalArea of the HourlyForecast. */
  operationalArea: OperationalArea;
};

/** Inputs required to initiate a file upload. */
export type InitiateFileUploadInput = {
  /** The name of the file that is going to be uploaded. This should include the extension of the file. For example: 'my_file.pdf'. This should not include any path information. This will be the name of the file that is returned to the user when they download the file. The filename must not exceed the maximum allowed length of: 100. */
  filename: Scalars['String'];
  /** The content type of the file that is going to be uploaded. This should be the MIME type of the file. */
  contentType: Scalars['String'];
};

/** Contains the response for initiating a file upload. */
export type InitiateFileUploadOutput = {
  __typename?: 'InitiateFileUploadOutput';
  /** Represents a file to be uploaded. */
  fileUpload: FileUpload;
};

/**
 * The InitiatePartnerFileUploadInput class defines the Graphene ObjectType class used to initiate the upload of a
 * Document.
 */
export type InitiatePartnerFileUploadInput = {
  /** The ID of the PartnerNode that the user is initiating a file upload on behalf of. */
  partnerNodeId: Scalars['UUID'];
  /** The type of file that is going to be uploaded. */
  uploadType: PartnerFileUploadType;
  /** The name of the file that is going to be uploaded. This should include the extension of the file. For example: 'my_file.pdf'. This should not include any path information. This will be the name of the file that is returned to the user when they download the file. The maximum length of this field is dictated by the MAX_FILE_LENGTH constant. */
  filename: Scalars['String'];
  /** The content type of the file that is going to be uploaded. This should be the MIME type of the file. */
  contentType: Scalars['String'];
  /** An optional ID value to be used when constructing the S3 object key. */
  s3ObjectKeyId?: Maybe<Scalars['String']>;
};

/** The required values in order to initiate a share code screening. */
export type InitiateShareCodeScreeningInput = {
  /** The ID of the Stinter to screen. */
  stinterId: Scalars['UUID'];
  /** The date of birth of the Stinter to be screened. */
  dateOfBirth: Scalars['Date'];
  /** The share code of the Stinter to be screened. */
  shareCode: Scalars['String'];
};

/**
 * Enum that contains the available error message codes that can be used to raise errors related to
 *     invalid input values.
 */
export enum InputError {
  INVALID_BASE64 = 'INVALID_BASE64',
  INVALID_CSV_FORMAT = 'INVALID_CSV_FORMAT',
  INVALID_CURSOR = 'INVALID_CURSOR',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_ID = 'INVALID_ID',
  INVALID_INPUTS = 'INVALID_INPUTS',
  INVALID_MATCH = 'INVALID_MATCH',
}

/** Item covers behaviour for a role configuration. */
export enum ItemCoversBehaviour {
  /** Always contributes towards item covers. */
  ALWAYS = 'ALWAYS',
  /** Only counts as a cover when it's the only one at a given time. */
  WHEN_ALONE = 'WHEN_ALONE',
  /** Never contributes towards item covers. */
  NEVER = 'NEVER',
}

/** A labour metric unit with metadata. */
export type LabourMetricUnit = {
  __typename?: 'LabourMetricUnit';
  /** The metric value. */
  amount: Scalars['Decimal'];
  /** True if all contributing shifts are APPROVED or REJECTED, else false. */
  isSettled: Scalars['Boolean'];
};

/** The breakdown of a labour metric across all shift categories for a week. */
export type LabourMetricsBreakdown = {
  __typename?: 'LabourMetricsBreakdown';
  /** The total across all shift categories for the week. */
  total: LabourMetricsWeekBreakdown;
  /** The value attributable to service shifts for the week. */
  service: LabourMetricsWeekBreakdown;
  /** The value broken down by role configuration for the week. */
  roles: Array<RoleLabourMetricsBreakdown>;
  /** The value attributable to external (training) shifts for the week. Null when allocating training cost to the primary site is disabled. */
  external?: Maybe<LabourMetricsWeekBreakdown>;
  /** The value attributable to Stint shifts for the week. Null when workforce integration is disabled. */
  stint?: Maybe<LabourMetricsWeekBreakdown>;
  /** The value broken down by non-service shift type for the week. */
  nonServiceShifts: Array<NonServiceLabourMetricsBreakdown>;
  /** Labour overhead added on top of this Site's shift costs for the week. Null on the hours breakdown, when the Site has no adjustment configured, or when the requested week starts before the adjustment took effect. */
  weeklyCostAdjustment?: Maybe<LabourMetricsWeekBreakdown>;
};

/** The per-day values of a labour metric for each day of the week. For actual metrics, values are null when T&A records for the day are not all in an approved or rejected state. For cost percentage metrics, values are additionally null when both the hour and cost values for the day are zero. */
export type LabourMetricsBreakdownByDay = {
  __typename?: 'LabourMetricsBreakdownByDay';
  /** The value for Monday. */
  monday?: Maybe<Scalars['Decimal']>;
  /** The value for Tuesday. */
  tuesday?: Maybe<Scalars['Decimal']>;
  /** The value for Wednesday. */
  wednesday?: Maybe<Scalars['Decimal']>;
  /** The value for Thursday. */
  thursday?: Maybe<Scalars['Decimal']>;
  /** The value for Friday. */
  friday?: Maybe<Scalars['Decimal']>;
  /** The value for Saturday. */
  saturday?: Maybe<Scalars['Decimal']>;
  /** The value for Sunday. */
  sunday?: Maybe<Scalars['Decimal']>;
};

/** The per-day values of a labour metric for each day of the week. */
export type LabourMetricsBreakdownByDayV2 = {
  __typename?: 'LabourMetricsBreakdownByDayV2';
  /** The value for Monday. */
  monday?: Maybe<LabourMetricUnit>;
  /** The value for Tuesday. */
  tuesday?: Maybe<LabourMetricUnit>;
  /** The value for Wednesday. */
  wednesday?: Maybe<LabourMetricUnit>;
  /** The value for Thursday. */
  thursday?: Maybe<LabourMetricUnit>;
  /** The value for Friday. */
  friday?: Maybe<LabourMetricUnit>;
  /** The value for Saturday. */
  saturday?: Maybe<LabourMetricUnit>;
  /** The value for Sunday. */
  sunday?: Maybe<LabourMetricUnit>;
};

/** The labour metrics breakdown for a site and week, covering projected and actual cost, cost percentage, and hours across all shift categories. */
export type LabourMetricsV2 = {
  __typename?: 'LabourMetricsV2';
  /** The projected labour cost breakdown for the week. Null when there is not a complete site schedule for the week. */
  projectedCostBreakdown?: Maybe<LabourMetricsBreakdown>;
  /** The projected labour cost as a percentage of forecast revenue, broken down for the week. Values are on a 0-100 scale (e.g. 30.0 represents 30%). Null when there is not a complete site schedule for the week. */
  projectedCostPercentageBreakdown?: Maybe<LabourMetricsBreakdown>;
  /** The projected labour hours breakdown for the week, including deviation fields. Always populated — headcount from the demand forecast is used when there is not a complete site schedule for the week. */
  projectedHoursBreakdown: ProjectedHoursBreakdown;
  /** The actual labour cost breakdown for the week. Null when there is not a complete site schedule for the week, the week is in the future, or hour approval is not enabled. Individual daily values within the breakdown are null when T&A records for the day are not all in an approved or rejected state. */
  actualCostBreakdown?: Maybe<LabourMetricsBreakdown>;
  /** The actual labour cost as a percentage of forecast revenue, broken down for the week. Values are on a 0-100 scale (e.g. 30.0 represents 30%). Null when there is not a complete site schedule for the week, the week is in the future, or hour approval is not enabled. Individual daily values within the breakdown are null when T&A records for the day are not all in an approved or rejected state, or when both the hour and cost values for the day are zero. */
  actualCostPercentageBreakdown?: Maybe<LabourMetricsBreakdown>;
  /** The actual labour hours breakdown for the week, including deviation fields. Null when there is not a complete site schedule for the week, the week is in the future, or hour approval is not enabled. Individual daily values within the breakdown are null when T&A records for the day are not all in an approved or rejected state. */
  actualHoursBreakdown?: Maybe<ActualHoursBreakdown>;
  /** Run-rate labour cost breakdown for the week, blending actual cost for settled shifts with projected cost for unsettled shifts. */
  runRateCostBreakdown: LabourMetricsBreakdown;
  /** Run-rate labour cost as a percentage of sales/forecast revenue for the week. Denominator per day is sales if available, else forecast. */
  runRateCostPercentageBreakdown: LabourMetricsBreakdown;
  /** Run-rate hours breakdown for the week, including deviations vs planned rota hours. */
  runRateHoursBreakdown: ActualHoursBreakdown;
};

/** A weekly breakdown of a single labour metric (cost, cost percentage, or hours), with an overall total and a per-day breakdown. */
export type LabourMetricsWeekBreakdown = {
  __typename?: 'LabourMetricsWeekBreakdown';
  /** The overall value for the week. Null when all daily values are null. */
  overall?: Maybe<Scalars['Decimal']>;
  /** The per-day values for the week. */
  byDay: LabourMetricsBreakdownByDay;
  /** The overall value for the week. Null when all daily values are null. */
  overallV2?: Maybe<LabourMetricUnit>;
  /** The per-day values for the week. */
  byDayV2: LabourMetricsBreakdownByDayV2;
};

/** The labour feature settings values for a Partner. */
export type LabourSettings = {
  __typename?: 'LabourSettings';
  /** The setting that dictates which contract types have paid breaks for the Partner. */
  contractTypesWithPaidBreaks: Array<ContractType>;
  /** Maximum number of time-specific forecast edits allowed. */
  maxTimeSpecificForecastEdits: Scalars['Int'];
  /** Maximum number of all-day forecast edits allowed. */
  maxAllDayForecastEdits: Scalars['Int'];
  /** Default time window in minutes before a shift starts that a worker can check in. */
  checkInWindowMinutes: Scalars['Int'];
  /** This is used in the calculation of the fixed contract base labour cost. When true, fixed contract base labour cost uses calendar days allocation, where an employee's daily labour cost is their yearly salary divided by 365 days. When false, uses the working days allocation method, where an employee's daily labour cost is their weekly salary as a proportion of their working days.  */
  useCalendarDaysFixedContractCostAllocation: Scalars['Boolean'];
  /** Whether training costs are allocated to the worker's primary site rather than the site where the shift took place. */
  allocateTrainingCostToPrimarySite: Scalars['Boolean'];
  /** The day of the week that the partner's scheduling week starts on. */
  scheduleWeekStartDay: WeekDay;
  /** The primary labour metric used by the Partner. */
  primaryLabourMetric: PrimaryLabourMetric;
  /** The on-cost component percentages for salaried (fixed contract) workers. */
  salariedOnCostComponents: OnCostComponents;
  /** The on-cost component percentages for flexible contract workers. */
  flexibleOnCostComponents: OnCostComponents;
};

/** The required values in order to update the labour values for a PartnerAccountSettings. */
export type LabourSettingsInput = {
  /** The setting that dictates which contract types have paid breaks for the Partner. */
  contractTypesWithPaidBreaks: Array<ContractType>;
  /** Maximum number of time-specific forecast edits allowed. */
  maxTimeSpecificForecastEdits: Scalars['Int'];
  /** Maximum number of all-day forecast edits allowed. */
  maxAllDayForecastEdits: Scalars['Int'];
  /** Default time window in minutes before a shift starts that a worker can check in. */
  checkInWindowMinutes: Scalars['Int'];
  /** When true, fixed contract base labour cost uses calendar days allocation; when false, uses working days. */
  useCalendarDaysFixedContractCostAllocation: Scalars['Boolean'];
  /** Whether training costs are allocated to the worker's primary site rather than the site where the shift took place. */
  allocateTrainingCostToPrimarySite: Scalars['Boolean'];
  /** The day of the week that the partner's scheduling week starts on. */
  scheduleWeekStartDay: WeekDay;
  /** The primary labour metric used by the Partner. */
  primaryLabourMetric: PrimaryLabourMetric;
  /** The on-cost component percentages for salaried (fixed contract) workers. */
  salariedOnCostComponents: OnCostComponentsInput;
  /** The on-cost component percentages for flexible contract workers. */
  flexibleOnCostComponents: OnCostComponentsInput;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  name: Scalars['String'];
};

export type LanguageFilter = {
  name?: Maybe<Scalars['String']>;
  /** q */
  q?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The legal statuses available for a PartnerMemberProfile. Used to determine the working restrictions for the member. */
export enum LegalStatus {
  /** The PartnerMemberProfile is an international worker. */
  INTERNATIONAL = 'INTERNATIONAL',
  /** The PartnerMemberProfile is a UK or Irish worker. */
  UK_IRISH = 'UK_IRISH',
}

export type ListMetadata = {
  __typename?: 'ListMetadata';
  count?: Maybe<Scalars['Int']>;
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrev?: Maybe<Scalars['Boolean']>;
  totalObjects?: Maybe<Scalars['Int']>;
};

/** The TextChoices for the PartnerSettings.locale field. */
export enum Locale {
  EN_GB = 'EN_GB',
  EN_IE = 'EN_IE',
  EN_JE = 'EN_JE',
}

/**
 * The TextChoices for the DeviceInfo.location_setting field.
 *
 *     This duplicate class is required to avoid a breaking change to the graph for the input types while doing the Django
 *     upgrade. Eventually these should be combined into one class again.
 */
export enum LocationSettings {
  NEVER = 'NEVER',
  ALWAYS = 'ALWAYS',
  USING = 'USING',
  UNDETERMINED = 'UNDETERMINED',
  DENIED = 'DENIED',
}

export type LoginAdmin = {
  __typename?: 'LoginAdmin';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type LoginEmployer = {
  __typename?: 'LoginEmployer';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type LoginMobileUser = {
  __typename?: 'LoginMobileUser';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type LoginStudent = {
  __typename?: 'LoginStudent';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

/** The input values required to manually adjust an employee's remaining holiday. */
export type ManuallyAdjustHolidayRemainingInput = {
  /** The ID of the partner member profile for the employee. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The number of days to adjust the remaining holiday by. */
  daysRemainingAdjustment: Scalars['Decimal'];
  /** The ID of the site node the user making the request has permission to manage holiday requests at. */
  siteId?: Maybe<Scalars['UUID']>;
};

/** The output values from manually adjusting a core team member's remaining holiday. */
export type ManuallyAdjustHolidayRemainingOutput = {
  __typename?: 'ManuallyAdjustHolidayRemainingOutput';
  /** The holiday info for the core team member after the manual adjustment. */
  holidayInfo: CoreTeamMemberHolidayInfo;
};

/** The input for marking a Failed Trial notification for a stinter as seen. */
export type MarkFailedTrialPoolAsSeenInput = {
  /** The ID of the StintTemplatePoolMember whose failed trial notification to mark as seen. */
  stintTemplatePoolMemberId: Scalars['UUID'];
};

/** The input values required to mark a PartnerPool as applied by a Stinter. */
export type MarkInviteAsAppliedInput = {
  /** The ID of the Stinter that applied to the Pool. */
  stinterId: Scalars['UUID'];
  /** The pool that the Stinter has applied to. */
  partnerPoolId: Scalars['UUID'];
};

/**
 * The MarkPartnerPoolInvitesAsSeenByStinterInput class defines the Graphene ObjectType class used
 * to mark PartnerPoolInvite objects as seen for a Stinter, for GraphQL queries.
 */
export type MarkPartnerPoolInvitesAsSeenByStinterInput = {
  /** The ID of the StudentProfile to mark PartnerPoolInvites as seen for. */
  stinterProfileId: Scalars['UUID'];
};

/** Input arguments for the MarkSiteScheduleAttendancesConfirmed mutation. */
export type MarkSiteScheduleAttendancesConfirmedInput = {
  /** The ID of the Site the SiteSchedule belongs to. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule to mark all shift attendances confirmed as true. */
  siteScheduleId: Scalars['UUID'];
};

/** Output fields for the MarkSiteScheduleAttendancesConfirmed mutation. */
export type MarkSiteScheduleAttendancesConfirmedOutput = {
  __typename?: 'MarkSiteScheduleAttendancesConfirmedOutput';
  /** The updated site schedule modified at timestamp. */
  modifiedAt: Scalars['String'];
};

/** Input for marking site schedule attendances as unconfirmed. */
export type MarkSiteScheduleAttendancesUnconfirmedInput = {
  /** The ID of the Site the SiteSchedule belongs to. */
  siteId: Scalars['UUID'];
  /** The week commencing date for the SiteSchedule. */
  weekCommencing: Scalars['Date'];
};

/** Output for marking site schedule attendances as unconfirmed. */
export type MarkSiteScheduleAttendancesUnconfirmedOutput = {
  __typename?: 'MarkSiteScheduleAttendancesUnconfirmedOutput';
  /** Whether the operation was successful. */
  success: Scalars['Boolean'];
};

/** The TextChoices for the StudentProfile.marketing_channel field. */
export enum MarketingChannel {
  WORD_OF_MOUTH = 'WORD_OF_MOUTH',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  WEB_SEARCH = 'WEB_SEARCH',
  STINT_FLYER = 'STINT_FLYER',
  BILLBOARD = 'BILLBOARD',
  JOB_BOARD = 'JOB_BOARD',
  STINT_BUSINESS = 'STINT_BUSINESS',
  UNIVERSITY_FAIR = 'UNIVERSITY_FAIR',
  STUDENT_UNION = 'STUDENT_UNION',
  EMAIL = 'EMAIL',
  OTHER = 'OTHER',
}

/** Represents a removal reason type for removing a Stinter from a Pool. */
export type MemberRemovalReason = {
  __typename?: 'MemberRemovalReason';
  id: Scalars['UUID'];
  /** Represent name of the removal reason which is displayed to a user who wants to remove Stinter from Pool */
  name: Scalars['String'];
  /** Represents additional context why a Stinter was removed from a Pool. It could be null as not all reasons require additional context. */
  description?: Maybe<Scalars['String']>;
  /** Whether or not an user has to provide additional context while a Stinter is being removing from a Pool. */
  moreInfoRequired: Scalars['Boolean'];
  /** Whether or not the removal reason is selectable by a user when removing the Stinter from a Pool. */
  isVisible: Scalars['Boolean'];
  /** Whether or not the removal reason relates to Stinters list of reasons. */
  isStinterReason: Scalars['Boolean'];
  /** Whether or not the removal reason relates to Stint HQ Stuff users list of reasons. */
  isStintHqReason: Scalars['Boolean'];
  /** Whether or not the removal reason relates to Employers list of reasons. */
  isSiteReason: Scalars['Boolean'];
};

/** The TextChoices for the MemberRemovalEvent.removed_by field. */
export enum MemberRemovalRemovedBy {
  STINT_HQ = 'STINT_HQ',
  SITE = 'SITE',
  STINTER = 'STINTER',
}

/** GraphQL type for representing a day in a month. */
export type MonthDay = {
  __typename?: 'MonthDay';
  /** The month of the year represented by an integer between 1 and 12. */
  month: Scalars['Int'];
  /** The day of the month. Limited to just 1-28 for now to avoid any issues with invalid dates. */
  day: Scalars['Int'];
};

/** GraphQL input type for representing a day in a month. */
export type MonthDayInput = {
  /** The month of the year represented by an integer between 1 and 12. */
  month: Scalars['Int'];
  /** The day of the month. Limited to just 1-28 for now to avoid any issues with invalid dates. */
  day: Scalars['Int'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Handles creating a University object. */
  createUniversity?: Maybe<University>;
  /** Handles updating a University object. */
  updateUniversity?: Maybe<University>;
  /** Creates a Tag */
  createTag?: Maybe<Tag>;
  /** Updates a Tag */
  updateTag?: Maybe<Tag>;
  /** Creates student saved place. */
  createStudentSavedPlace?: Maybe<StudentSavedPlace>;
  /** Updates student saved place. */
  updateStudentSavedPlace?: Maybe<StudentSavedPlace>;
  /** Deletes student saved place. */
  deleteStudentSavedPlace?: Maybe<StudentSavedPlace>;
  /** Create new student availability. */
  upsertStintUserAvailability?: Maybe<Array<Maybe<StintUserAvailability>>>;
  /** Delete stint user availability. */
  deleteStintUserAvailability?: Maybe<StintUserAvailability>;
  /**
   * Handles creating a StintTemplate (Role).
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INVALID_PREP_VIDEO_URL when an invalid prep video URL value has been provided.
   * - INVALID_UNIFORM_TOP_VALUES, INVALID_UNIFORM_TROUSER_VALUES or INVALID_UNIFORM_SHOE_VALUES when invalid uniform
   *     values have been provided.
   * - TOO_FEW_PRIMARY_TASKS or TOO_MANY_PRIMARY_TASKS when invalid primary task values have been provided.
   * - TOO_MANY_SECONDARY_TASKS when invalid secondary task values have been provided.
   * - DOES_NOT_EXIST when a StintTask, EmploymentException, Business or StintTemplateGroup record does not exist for any
   *     of the provided ID values.
   * - CANNOT_SET_STINT_TEMPLATE_GROUP_IF_NOT_TRAINED when the StintTemplate being created is not trained and has been
   *     provided a StintTemplateGroup ID.
   */
  createStintTemplate: StintTemplate;
  /**
   * Handles updating a StintTemplate (Role).
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission. This includes a case where the user might not
   *     have permission to update the controlled release value.
   * - INVALID_PREP_VIDEO_URL when an invalid prep video URL value has been provided.
   * - INVALID_UNIFORM_TOP_VALUES, INVALID_UNIFORM_TROUSER_VALUES or INVALID_UNIFORM_SHOE_VALUES when invalid uniform
   *     values have been provided.
   * - TOO_FEW_PRIMARY_TASKS or TOO_MANY_PRIMARY_TASKS when invalid primary task values have been provided.
   * - TOO_MANY_SECONDARY_TASKS when invalid secondary task values have been provided.
   * - DOES_NOT_EXIST when the StintTemplate or a StintTask, EmploymentException, Business or StintTemplateGroup record does
   *     not exist for any of the provided ID values.
   * - CANNOT_SET_STINT_TEMPLATE_GROUP_IF_NOT_TRAINED when the StintTemplate being updated is not trained and has been
   *     provided a StintTemplateGroup ID.
   */
  updateStintTemplate: StintTemplate;
  /**
   * Handles creating a StintTemplateGroup.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INVALID_NAME_LENGTH when an invalid name length has been provided.
   * - ONE_OR_MORE_STINT_TEMPLATES_ALREADY_IN_GROUP when one or more StintTemplate has been provided that is already
   *     in another group.
   */
  createStintTemplateGroup: StintTemplateGroup;
  /**
   * Handles updating a StintTemplateGroup.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - DOES_NOT_EXIST when the StintTemplateGroup does not exist.
   * - INVALID_NAME_LENGTH when an invalid name length has been provided.
   * - ONE_OR_MORE_STINT_TEMPLATES_ALREADY_IN_GROUP when one or more StintTemplate has been provided that is already
   *     in another group.
   */
  updateStintTemplateGroup: StintTemplateGroup;
  /** Mutation to verify if student has been verified */
  setStudentHasSeenDashboard?: Maybe<StintUser>;
  /** Confirms a student has uploaded their right to work document(s) */
  confirmRightToWorkDocUpload?: Maybe<ConfirmRightToWorkDocUpload>;
  /** Update Stinter marketing consent. */
  updateStinterMarketingConsent?: Maybe<StudentProfile>;
  /** Update Stinter marketing channel. */
  updateStinterMarketingChannel?: Maybe<Stinter>;
  /** Handles creating a StintTask object. */
  createStintTask?: Maybe<StintTask>;
  /** Handles updating a StintTask object. */
  updateStintTask?: Maybe<StintTask>;
  /** Handles deleting a StintTask object. */
  deleteStintTask?: Maybe<StintTask>;
  /** Handles creating Stint objects. Raises StintError. */
  createStints?: Maybe<Array<Maybe<Stint>>>;
  /** Handles an Employer updating the start and end times of a Stint object. Raises StintError. */
  updateStintTimes?: Maybe<Stint>;
  /**
   * Handles a Staff user updating the actual leave time of a Stint object.
   *
   * Errors:
   * - ACTUAL_LEAVE_TIME_BEFORE_START when a leave time value is provided that is earlier than the start time of the Stint.
   * - INVALID_ACTUAL_LEAVE_TIME_FROM_END when a leave time value is provided that fails the max time validation.
   */
  updateActualLeaveTime?: Maybe<Stint>;
  /** Handles a Stinter cancelling a Stint. */
  cancelStintAsStinter?: Maybe<Stint>;
  /** Handles a Stinter accepting a Stint with a StintOffer. */
  acceptStint?: Maybe<Stint>;
  /** Handles a Stinter accepting an available Stint without a StintOffer. */
  acceptAvailableStint?: Maybe<Stint>;
  /** Cancel a Stint that matches the provided ID as an Employer. */
  employerCancelStint?: Maybe<Stint>;
  /** Updates a Business's Stintopedia */
  updateStintopedia?: Maybe<Stintopedia>;
  /** record offer seen event */
  recordOfferSeenEvent?: Maybe<SuccessType>;
  /** Update a stint that matches provided id. */
  updateStint?: Maybe<Stint>;
  /** Delete a stint that matches provided id. */
  deleteStint?: Maybe<Stint>;
  /** Check in a stint that matches provided id. */
  checkInStint?: Maybe<CheckInStint>;
  /** Confirm the attendance to a Stint that matches the provided id. */
  confirmAttendStint?: Maybe<Stint>;
  /** Check if a student has a stint within 24 hours */
  hasStintStartingSoon?: Maybe<HasStintStartingSoon>;
  /** Update a stint user that matches provided id. */
  updateStintUser?: Maybe<StintUser>;
  /** Verify student user. */
  verifyStudentUser?: Maybe<SuccessType>;
  /** Update current user. */
  updateMe?: Maybe<StintUser>;
  /** Bulk cancel stints */
  cancelStints?: Maybe<CancelStints>;
  /** enable stint location tracking */
  enableGranularLocationTracking?: Maybe<StintJourney>;
  /** edit stint tracking details */
  updateStintJourney?: Maybe<StintJourney>;
  /** set do not remind about geotracking */
  setDoNotRemindAboutGeotracking?: Maybe<SuccessType>;
  /** Manually trigger geotracking status update of stint journey. */
  manualGeotrackingStatusUpdate?: Maybe<StintJourney>;
  /** Bulk mark as resolved stint journeys */
  resolveStintJourneys?: Maybe<Array<Maybe<StintJourney>>>;
  /** Handles upserting a VideoAssessmentInfo object. */
  upsertVideoAssessmentInfo: VideoAssessmentInfo;
  /** Handles creating a WorkExperience object. */
  createWorkExperience?: Maybe<WorkExperience>;
  /**
   * Handles marking a StinterCompetencyTask as passed.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  qualifyForTask: StinterCompetencyTask;
  /**
   * Searches for location predictions using Google Places autocomplete. Returns predictions of Google Places info for addresses, cities and postal codes.
   *
   *  Addresses returned in the format BUSINESS NAME, FIRST LINE ADDRESS, CITY, POST CODE, COUNTRY.
   *
   *  Cities returned in the format CITY, COUNTRY.
   *
   *  Postal codes returns as just postal codes.
   */
  searchGooglePlaces?: Maybe<GooglePlacesPredictionsType>;
  /** Create a stint week template. */
  createStintWeekTemplate?: Maybe<StintWeekTemplate>;
  /** Update a stint week template that matches provided id. */
  updateStintWeekTemplate?: Maybe<StintWeekTemplate>;
  /** Delete a stint week template that matches provided id. */
  deleteStintWeekTemplate?: Maybe<StintWeekTemplate>;
  /** Sets the StintWeekTemplate as the default template for a Business. The default templatedenotes the template that will be used for automatic posting. Raises StintWeekTemplateError. */
  setDefaultStintWeekTemplate: Array<StintWeekTemplate>;
  /** Clears the default StintWeekTemplate for a Business. The default template denotes the template that will be used for automatic posting. Raises StintWeekTemplateError. */
  clearDefaultStintWeekTemplate: Array<StintWeekTemplate>;
  /**
   * Handles initiating a Persona screening for the authenticated Stinter.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - UNKNOWN_ERROR, NON_RECOVERABLE_ERROR, RECOVERABLE_ERROR or HTTP_ERROR when an error occurs while making a
   *    request to the RTW service.
   */
  initiatePersonaScreening: PersonaInquiry;
  /**
   * Handles initiating a share code screening for the authenticated Stinter.
   * This involves validating a provided share code and date of birth with the governement records,
   * in an effort to confirm that the Stinter has a valid RTW. The action of validating is
   * asynchronous, and it wont be completed with the execution of this mutation.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - UNKNOWN_ERROR, NON_RECOVERABLE_ERROR, RECOVERABLE_ERROR or HTTP_ERROR when an error occurs while making a
   *    request to the RTW service and DOES_NOT_EXIST when an error occurs while retrieving the Stinter from the database.
   */
  initiateShareCodeScreening: Stinter;
  /** Handles creating a manual RTWScreening for a Stinter. */
  createManualRightToWorkScreening: RTWScreening;
  /** Handles creating a RTWScreening for an Employee. */
  createEmployeeRightToWorkScreening: CreateEmployeeRightToWorkScreeningOutput;
  /** Handles creating an out-of-term request for a Stinter. */
  createOutOfTermRequest: CreateOutOfTermRequestOutput;
  /** Handles approving an out-of-term request for a Stinter. */
  approveOutOfTermRequest: ApproveOutOfTermRequestOutput;
  /** Handles rejecting an out-of-term request for a Stinter. */
  rejectOutOfTermRequest: RejectOutOfTermRequestOutput;
  /** Create new region. */
  createRegion?: Maybe<Region>;
  /** Update a region that matches provided id. */
  updateRegion?: Maybe<Region>;
  /** Delete a region that matches provided id. */
  deleteRegion?: Maybe<Region>;
  /**
   * Handles updating a StintTemplate rate.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updateStintTemplateRate: StintTemplateRate;
  /** Create postal code. */
  createPostalCode?: Maybe<PostalCode>;
  /** Update postal code. */
  updatePostalCode?: Maybe<PostalCode>;
  /** Delete postal code. */
  deletePostalCode?: Maybe<PostalCode>;
  /**
   * Handles creating a PoolMemberFeedback object.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - UNKNOWN: When an unexpected error occurs.
   */
  createPoolMemberFeedback: PoolMemberFeedback;
  /**
   * Creates a StinterCommitment for a Stinter.
   *
   * Admin will be able to add a commitment for any Stinter.
   * Stinters cannot create commitments for themselves.
   * Partners cannot create commitments for any Stinters.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - UNKNOWN: When an unexpected error occurs.
   */
  addStinterCommitment: StinterCommitment;
  /**
   * Updates a StinterCommitment for a Stinter.
   *
   * Admin will be able to update a commitment for any Stinter.
   * Stinters cannot update commitments for themselves.
   * Partners cannot update commitments for any Stinters.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - UNKNOWN: When an unexpected error occurs.
   */
  updateStinterCommitment: StinterCommitment;
  /** Handles adding Stinters to a StintTemplate object's Pool. */
  addStintersToStintTemplatePool: StintTemplate;
  /**
   * Handles removing Stinters from a StintTemplate object's Pool.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - INVALID_PARTNER_NODE_ID: When a PartnerNode ID that does not match the PartnerNode ID associated with the
   *     StintTemplate is provided.
   * - UNKNOWN: When an unexpected error occurs.
   */
  removeStintersFromStintTemplatePool: StintTemplate;
  /**
   * Handles removing Stinter from a StintTemplate object's Pool.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - INVALID_PARTNER_NODE_ID: When a PartnerNode ID that does not match the PartnerNode ID associated with the
   *     StintTemplate is provided.
   * - UNKNOWN: When an unexpected error occurs.
   */
  removeStinterFromStintTemplatePool: StintTemplate;
  /**
   * Handles manually approving a Stinter that is in the trial period for a StintTemplate's Pool.
   *
   * If the Stinter is already approved, an additional approval reason will be added to the Stinter and the Stinter
   * will remain in an approved state.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - INVALID_PARTNER_NODE_ID: When a PartnerNode ID that does not match the PartnerNode ID associated with the
   *     StintTemplate is provided.
   * - NO_REASONS_PROVIDED: When an empty list of reasons is provided when approving the Stinter.
   * - UNKNOWN: When an unexpected error occurs.
   */
  approveTrialStinterForStintTemplatePool: StintTemplate;
  /**
   * Handles failing a Stinter that is in the trial period for a StintTemplate's Pool.
   *
   * Errors:
   * - UNAUTHORIZED: When the user does not have the permission to perform the action.
   * - NO_REASONS_PROVIDED: When an empty list of reasons is provided when failing the Stinter.
   * - UNKNOWN: When an unexpected error occurs.
   */
  failTrialStinterForStintTemplatePool: StintTemplate;
  /** Handles adding Stinters to a PartnerPool object. Raises PartnerPoolError or InputError. */
  addStintersToPartnerPool: PartnerPool;
  /** Handles creating a PartnerPool object. Raises PartnerPoolError or InputError. */
  createPartnerPool: PartnerPool;
  /** Handles removing Stinters from a PartnerPool object. Raises PartnerPoolError or InputError. */
  removeStintersFromPartnerPool: PartnerPool;
  /** Handles reset a PartnerPool object by removing all associated PartnerPoolInvites. Raises PartnerPoolError or InputError. */
  removeAllStintersFromPartnerPool: PartnerPool;
  /**
   * Handles updating a PartnerPool object.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INVALID_FORM_URL when an invalid url value is provided.
   */
  updatePartnerPool: PartnerPool;
  /** Handles marking all PartnerPoolInvites for a Stinter as seen. Raises PartnerPoolInviteError or InputError. */
  markPartnerPoolInvitesAsSeenByStinter: StinterProfile;
  /**
   * Handles marking a PartnerPoolInvite as applied by a Stinter
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - NO_INVITE_FOUND when no invite is found to update.
   */
  markInviteAsApplied?: Maybe<PartnerPoolInvite>;
  /**
   * Handles marking the failed trial notification for a stinter as seen. If the user is not a Stinter or
   * does not own the then it will raise an Unauthorized error. Unknown error for any other unexpected errors.
   */
  markFailedTrialPoolAsSeen: StinterProfile;
  /** Create a Stripe DirectDebit payment method for a Business. */
  createStripeDebit?: Maybe<StripeDebit>;
  /** Create a Stripe Card payment method for a Business. */
  createStripeCard?: Maybe<StripeCard>;
  /** Delete a StripeCard payment method. */
  deleteStripeCard?: Maybe<StripeCard>;
  /** Create a SetupIntent for a business to obtain a Stripe customer's secret for securely capturing card details. */
  createStripeSetupIntent?: Maybe<SetupIntent>;
  /** Create a Stripe Checkout Session to securely capture the customer's bank account information. */
  createStripeCheckoutSession?: Maybe<CheckoutSession>;
  /**
   * Updates the site payment provider details for a Partner Site.
   *
   * Returns:
   * - The updated site payment provider details.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  updateSitePaymentProvider: UpdateSitePaymentProviderOutput;
  /**
   * Authenticates on-demand pay access for the current user.
   *
   * Returns:
   * - The authenticated access token to initiate the on-demand pay flow.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  authenticateOnDemandPayAccess: AuthenticateOnDemandPayAccessOutput;
  /**
   * Sets up a webhook configuration for a partner account. If an existing webhook is already configured,
   * it will be overwritten with this new configuration and an auth token will be regenerated.
   *
   * Requires the user to have CONFIGURE_PARTNER_WEBHOOK permission on the account node.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  configurePartnerWebhook: ConfigurePartnerWebhookOutput;
  /**
   * Sends a test partner webhook to the configured endpoint for an account.
   *
   * Requires the user to have SEND_PARTNER_WEBHOOKS permission on the account node.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the SEND_TEST_PARTNER_WEBHOOK at the account node.
   * - WEBHOOK_NOT_CONFIGURED when the account does not have webhooks enabled or a webhook configured.
   * - WEBHOOK_ALREADY_EXISTS when a webhook with that event id already exists.
   */
  sendTestPartnerWebhook: SendTestPartnerWebhookOutput;
  /**
   * Resends a partner webhook to the configured endpoint for an account.
   *
   * Requires the user to have CONFIGURE_PARTNER_WEBHOOK permission on the account node.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have CONFIGURE_PARTNER_WEBHOOK at the account node.
   * - WEBHOOK_NOT_CONFIGURED when the account does not have webhooks enabled or a webhook configured.
   * - WEBHOOK_NOT_FOUND when the webhook with the given id was not found.
   */
  resendPartnerWebhook: ResendPartnerWebhookOutput;
  /** Updates the notification settings for an employee. Requires UPDATE_PARTNER_MEMBER permission. */
  updateEmployeeNotificationSettings?: Maybe<UpdateEmployeeNotificationSettingsOutput>;
  /** Updates the current user's notification settings for a specific site. */
  updateEmployeeSiteNotificationSettings?: Maybe<UpdateEmployeeSiteNotificationSettingsOutput>;
  /** Deletes employee notifications. Requires UPDATE_PARTNER_MEMBER permission. */
  deleteEmployeeNotifications?: Maybe<DeleteEmployeeNotificationsOutput>;
  /** Returns the SSO IdP hint for a given email address. An SSO IdP hint (Identity Provider hint) is a parameter sent with an SSO request to help the Identity Provider (IdP) quickly find or pre-fill login forms, streamlining the Single Sign-On process by guiding the user to their correct account or even logging them in directly if they have an active session, without needing to re-enter details. */
  getSsoIdpHint: GetSSOIdpHintOutput;
  /** Allows partner employees to update their own working preferences for a specific site. Validates that the user is an EMPLOYER with a core team role and has a PartnerMember record associated with the site. */
  updateOwnWorkingPreferences?: Maybe<UpdateOwnWorkingPreferencesOutput>;
  /** Allows partner employees to update their own working availability for a specific site. Validates that the user is an EMPLOYER with a core team role and has a PartnerMember record associated with the site. */
  updateOwnWorkingAvailability: UpdateOwnWorkingAvailabilityOutput;
  /**
   * Updates a PartnerMember's site working preferences.
   *
   * Requires UPDATE_PARTNER_MEMBER permission and the site_id must be a Site node.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   * - DOES_NOT_EXIST when the Site or PartnerMember does not exist.
   */
  updatePartnerMemberSiteWorkingPreferences: UpdatePartnerMemberSiteWorkingPreferencesOutput;
  /** Updates a PartnerMember's site working availability. Requires UPDATE_PARTNER_MEMBER permission and the site_id must be a Site node. */
  updatePartnerMemberSiteWorkingAvailability: UpdatePartnerMemberSiteWorkingAvailabilityOutput;
  /** Allows user to upsert a dynamic working preference for a partner member profile at a site for a given date. */
  upsertDynamicWorkingPreference?: Maybe<UpsertDynamicWorkingPreferenceOutput>;
  /** Allows user to delete a dynamic working preference for a partner member profile at a site for a given date. */
  deleteDynamicWorkingPreference?: Maybe<DeleteDynamicWorkingPreferenceOutput>;
  /** Allows partner employees to request a working preference for a date at specified sites. */
  createWorkingPreferenceRequest?: Maybe<CreateWorkingPreferenceRequestOutput>;
  /** Allows site managers to approve a working preference request for an employee. */
  approveWorkingPreferenceRequest: ApproveWorkingPreferenceRequestOutput;
  /** Allows user to reject a working preference request for a partner member profile at a site for a given date. */
  rejectWorkingPreferenceRequest: RejectWorkingPreferenceRequestOutput;
  /**
   * Upserts a partner node and all its descendants' operational areas.
   *
   * Requires that the user is a STAFF user.
   */
  upsertPartnerOperationalAreas: UpsertPartnerOperationalAreasOutput;
  /**
   * Handles updating a PartnerSettings.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - DOES_NOT_EXIST when the related Business does not exist.
   */
  updatePartnerSettings: PartnerSettings;
  /**
   * Creates an employee for a partner.
   *
   * Requires the CREATE_EMPLOYEE permission.
   */
  createEmployee: CreateEmployeeOutput;
  /**
   * Creates an employee termination for an employee.
   *
   * Requires the MANAGE_EMPLOYEE_TERMINATION permission.
   */
  createEmployeeTermination: CreateEmployeeTerminationOutput;
  /**
   * Cancels an employee termination.
   *
   * Requires the MANAGE_EMPLOYEE_TERMINATION permission.
   */
  cancelEmployeeTermination: CancelEmployeeTerminationOutput;
  /**
   * Updates an employee's contact details.
   *
   * Requires the UPDATE_EMPLOYEE_CONTACT_DETAILS permission.
   */
  updateEmployeeContactDetails: UpdateEmployeeContactDetailsOutput;
  /**
   * Updates an employee's information including personal details like name, title, pronoun, and date of birth.
   *
   * Requires the UPDATE_EMPLOYEE permission.
   */
  updateEmployeeInfo: UpdateEmployeeInfoOutput;
  /**
   * Updates the isEmployee flag on a PartnerMemberProfile. Used to mark a PartnerMemberProfile as an actual
   * employee in the system, as opposed to an internal Stint staff user, sys-admin, or 3rd party person.
   */
  updateEmployeeFlag: UpdateEmployeeFlagOutput;
  /**
   * Handles updating the primary site for an employee.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission (UPDATE_EMPLOYEE_PRIMARY_SITE).
   * - UNAUTHORIZED when the user is not a member of the site.
   */
  updateEmployeePrimarySite: UpdateEmployeePrimarySiteOutput;
  /**
   * Handles inserting or updating an employee's manager.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  upsertEmployeeManager: UpsertEmployeeManagerOutput;
  /**
   * Inserts or updates the managers for an employee.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  upsertEmployeeManagers: UpsertEmployeeManagersOutput;
  /**
   * Rehires an employee.
   *
   * Requires the MANAGE_EMPLOYEE_TERMINATION permission.
   */
  rehireEmployee: RehireEmployeeOutput;
  /**
   * Updates the manager for all employees that are direct reports of the previousManagerId.
   *
   * Permissions-wise, this operation should be doable by anyone who is above previousManagerId in the org chart.
   *
   * The previousManagerId and newManagerId need to be different.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  reassignDirectReports: ReassignDirectReportsOutput;
  /** Handles creating a NodeType.ACCOUNT PartnerNode object. Raises PartnerNodeError, PartnerBrandError or CompaniesHouseInformationError. */
  createAccountNode?: Maybe<PartnerAccountProfile>;
  /** Handles creating a NodeType.GROUP PartnerNode object. Raises PartnerNodeError, PartnerBrandError or CompaniesHouseInformationError. */
  createGroupNode?: Maybe<PartnerGroupProfile>;
  /** Handles creating a NodeType.SITE PartnerNode object. Raises PartnerNodeError, PartnerBrandError, PartnerContactError or AddressError. */
  createSiteNode?: Maybe<PartnerSiteProfile>;
  /** Handles updating a NodeType.ACCOUNT PartnerNode object. Raises PartnerNodeError or InputError. */
  updateAccountNode?: Maybe<PartnerAccountProfile>;
  /** Handles updating a NodeType.GROUP PartnerNode object. Raises PartnerNodeError or InputError. */
  updateGroupNode?: Maybe<PartnerGroupProfile>;
  /** Handles updating the parent PartnerNode for a PartnerNode object. Raises PartnerNodeError or InputError. */
  updatePartnerNodeParent?: Maybe<PartnerNode>;
  /** Handles updating a NodeType.SITE PartnerNode object. Raises PartnerNodeError or InputError. */
  updateSiteNode?: Maybe<PartnerSiteProfile>;
  /**
   * Handles regenerating the QR code for a Site.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a Staff user.
   * - DOES_NOT_EXIST when the Site does not exist.
   */
  regenerateSiteQRCode: PartnerSiteProfile;
  /**
   * Update the secondary roles for an Employee.
   *
   * Requires the UPDATE_EMPLOYEE_BASIC_EMPLOYMENT_INFORMATION permission
   */
  updateEmployeeSecondaryRoles: UpdateEmployeeSecondaryRolesOutput;
  /**
   * Upsert the experience level (training status, skill level, and secondary roles) for an Employee.
   *
   * Requires the UPSERT_EMPLOYEE_EXPERIENCE_LEVEL permission
   */
  upsertEmployeeExperienceLevel?: Maybe<UpsertEmployeeExperienceLevelOutput>;
  /**
   * Handles creating a PartnerMember object.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when the user does not have the CREATE_PARTNER_MEMBER permission.
   * - DOES_NOT_EXIST: When the PartnerNode or PartnerMemberProfile does not exist for the provided IDs.
   * - PROFILE_ALREADY_A_MEMBER_OF_PARTNER_NODE: When the PartnerMemberProfile is already a member of the PartnerNode.
   * - INVALID_PROFILE: When no profile values are provided. Either the ID for an existing PartnerMemberProfile or
   *     values to create a new one must be provided.
   * - PARTNER_MEMBER_PROFILE_LINKED_TO_DIFFERENT_ACCOUNT: When the PartnerMemberProfile is linked to a different
   *     Account Node.
   * - INVALID_SIDE_NODE_ID: When a non Site PartnerNode ID is provided while trying to upsert Site WorkingPreferences.
   * - INVALID_EMAIL: When the email provided is not a valid email.
   * - UNKNOWN: When an unexpected error occurs.
   */
  createPartnerMember: PartnerMember;
  /**
   * Handles updating a PartnerMember object.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when the user does not have the UPDATE_PARTNER_MEMBER permission.
   * - UNKNOWN: When an unexpected error occurs.
   */
  updatePartnerMember: PartnerMember;
  /**
   * Handles deleting a PartnerMember object.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when the user does not have the DELETE_PARTNER_MEMBER permission.
   * - NOT_PRIMARY_PARTNER_NODE: When the PartnerMember is not a direct member of the specified PartnerNode.
   * - UNKNOWN: When an unexpected error occurs.
   */
  deletePartnerMember: DeletePartnerMemberResponse;
  /** Handles updating PartnerContact object. Raises PartnerContactError or InputError. */
  updatePartnerContact?: Maybe<PartnerContact>;
  /** Handles creating a PartnerBrand object. Raises PartnerBrandError or InputError. */
  createPartnerBrand?: Maybe<PartnerBrand>;
  /** Handles updating a PartnerBrand object. Raises PartnerBrandError or InputError. */
  updatePartnerBrand?: Maybe<PartnerBrand>;
  /**
   * Updates partner account settings.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  updatePartnerAccountSettings: UpdatePartnerAccountSettingsOutput;
  /** Handles creating a CompaniesHouseInformation object. Raises CompaniesHouseInformationError or InputError. */
  createCompaniesHouseInformation?: Maybe<CompaniesHouseInformation>;
  /** Handles updating a CompaniesHouseInformation object. Raises CompaniesHouseInformationError or InputError. */
  updateCompaniesHouseInformation?: Maybe<CompaniesHouseInformation>;
  /** Creates a profile mapping linking a provider's external profile identifier to a Stint profile. Omit profileId to create an unresolved mapping. */
  createPartnerIntegrationProfileMapping: CreatePartnerIntegrationProfileMappingOutput;
  /** Deletes a profile mapping. */
  deletePartnerIntegrationProfileMapping: DeletePartnerIntegrationProfileMappingOutput;
  /** Updates a profile mapping's external identifier and mapped profile. Set profileId to null to clear the profile, reverting the mapping to unresolved. */
  updatePartnerIntegrationProfileMapping: UpdatePartnerIntegrationProfileMappingOutput;
  /** Creates a job title mapping linking a provider's external job title identifier to a Stint job title. Omit jobTitleId to create an unresolved mapping. */
  createPartnerIntegrationJobTitleMapping: CreatePartnerIntegrationJobTitleMappingOutput;
  /** Updates a job title mapping's external identifier and the Stint job title it maps to. Set jobTitleId to null to clear the mapping, reverting it to unresolved. */
  updatePartnerIntegrationJobTitleMapping: UpdatePartnerIntegrationJobTitleMappingOutput;
  /** Deletes a job title mapping. */
  deletePartnerIntegrationJobTitleMapping: DeletePartnerIntegrationJobTitleMappingOutput;
  /** Creates a role mapping linking a provider's external role identifier to a Stint role configuration. Omit roleId to create an unresolved mapping. */
  createPartnerIntegrationRoleMapping: CreatePartnerIntegrationRoleMappingOutput;
  /** Updates a role mapping's external identifier and mapped role configuration. Set roleId to null to clear the role, reverting the mapping to unresolved. */
  updatePartnerIntegrationRoleMapping: UpdatePartnerIntegrationRoleMappingOutput;
  /** Deletes a role mapping. */
  deletePartnerIntegrationRoleMapping: DeletePartnerIntegrationRoleMappingOutput;
  /** Creates a site mapping linking a provider's external site identifier to a Stint site. Omit siteId to create an unresolved mapping. */
  createPartnerIntegrationSiteMapping: CreatePartnerIntegrationSiteMappingOutput;
  /** Updates a site mapping's external identifier and mapped site. Set siteId to null to clear the site, reverting the mapping to unresolved. */
  updatePartnerIntegrationSiteMapping: UpdatePartnerIntegrationSiteMappingOutput;
  /** Deletes a site mapping. */
  deletePartnerIntegrationSiteMapping: DeletePartnerIntegrationSiteMappingOutput;
  /** Creates a new integration between a partner account and a third-party provider. Provide at most one auth* input; omit all to configure auth later via updatePartnerIntegration. */
  createPartnerIntegration: CreatePartnerIntegrationOutput;
  /** Updates an existing partner integration. Provide at most one auth* input to replace stored auth; omit all to leave auth unchanged. */
  updatePartnerIntegration: UpdatePartnerIntegrationOutput;
  /**
   * Creates a new API token for a partner account.
   *
   * Only Stint staff users may call this mutation. The plaintext token is returned once
   * in the response and is never stored.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a staff member.
   */
  createPartnerAccountApiToken: CreatePartnerAccountAPITokenOutput;
  /**
   * Revokes an existing API token for a partner account.
   *
   * Only Stint staff users may call this mutation. The token is marked as revoked
   * and can no longer be used for authentication.
   */
  revokePartnerAccountApiToken: RevokePartnerAccountAPITokenOutput;
  /**
   * Updates an existing API token for a partner account.
   *
   * Only Stint staff users may call this mutation. The token's name and/or scopes
   * can be updated. At least one field must be provided. Revoked tokens cannot be
   * updated.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a staff member.
   * - BAD_REQUEST when the token is revoked or no fields are provided.
   */
  updatePartnerAccountApiToken: UpdatePartnerAccountAPITokenOutput;
  /**
   * Validates the uploaded CSV synchronously and stores it as a BulkEmployeeUpload with status=PENDING.
   * Employee creation happens asynchronously in a later processing step.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   * - INVALID_CSV_FORMAT when the CSV is empty or unreadable.
   * - INVALID_INPUTS when a row fails structural validation.
   */
  createBulkEmployeeUpload: CreateBulkEmployeeUploadOutput;
  /** Create and send notifictations to students. */
  createNotification?: Maybe<Notification>;
  /**
   * Create an AppLifecycleEvent to indicate whether the mobile device was opened,
   * closed, or resumed from background
   */
  createAppLifecycleEvent?: Maybe<AppLifecycleEvent>;
  /** Acknowledge that the recipient received and opened a notification */
  acknowledgeNotificationOpened?: Maybe<NotificationRecipient>;
  /**
   * Processes a user's prompt through the site schedule agent and returns an AI-generated response.
   *
   * The agent helps users interact with site schedules by providing intelligent responses based on the user's prompt and
   * additional context. Each conversation is scoped to a specific week and site.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  siteScheduleAgent: SiteScheduleAgentOutput;
  /**
   * Processes a user's prompt through the demand forecast agent and returns an AI-generated response.
   *
   * The agent helps users interact with demand forecasts by providing intelligent responses based on the user's prompt and
   * additional context. Each conversation is scoped to a specific week and site.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  demandForecastAgent: DemandForecastAgentOutput;
  /**
   * Upsert the bank details for an employee.
   *
   * Requires the UPDATE_EMPLOYEE permission
   */
  upsertEmployeeBankDetails: UpsertEmployeeBankDetailsOutput;
  /**
   * Upsert the payroll information for an employee.
   *
   * Requires the UPDATE_EMPLOYEE permission
   */
  upsertEmployeePayrollInformation: UpsertEmployeePayrollInformationOutput;
  /** Creates a new partner job title pay rate for a given job title. */
  createPartnerJobTitlePayRate: CreatePartnerJobTitlePayRateOutput;
  /** Deletes a partner job title pay rate for a given job title. */
  deletePartnerJobTitlePayRate: DeletePartnerJobTitlePayRateOutput;
  /** Creates a new partner department for a given account. */
  createPartnerDepartment: CreatePartnerDepartmentOutput;
  /** Updates a partner department's name. */
  updatePartnerDepartment: UpdatePartnerDepartmentOutput;
  /** Deletes a partner department. */
  deletePartnerDepartment: DeletePartnerDepartmentOutput;
  /** Creates a holiday request for the user. */
  coreTeamMemberHolidayRequest: CoreTeamMemberHolidayRequestOutput;
  /**
   * Creates a holiday request on behalf of an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  createEmployeeHolidayRequest: CreateEmployeeHolidayRequestOutput;
  /**
   * Rejects a holiday request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  rejectEmployeeHolidayRequest: RejectEmployeeHolidayRequestOutput;
  /**
   * Approves a holiday request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  approveEmployeeHolidayRequest: ApproveEmployeeHolidayRequestOutput;
  /**
   * Cancels a holiday request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  cancelEmployeeHolidayRequest: CancelEmployeeHolidayRequestOutput;
  /**
   * Manually adjusts a core team member's remaining holiday.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  manuallyAdjustHolidayRemaining: ManuallyAdjustHolidayRemainingOutput;
  /**
   * Updates a holiday request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  updateEmployeeHolidayRequest: UpdateEmployeeHolidayRequestOutput;
  /**
   * Associate a holiday policy with a core team member.
   *
   * Requires the UPDATE_HOLIDAY_POLICY_FOR_CORE_TEAM_MEMBER permission
   */
  associateHolidayPolicyWithCoreTeamMember: AssociateHolidayPolicyWithCoreTeamMemberOutput;
  /**
   * Create a new holiday policy.
   *
   * Requires the CREATE_LEAVE_POLICY permission
   */
  createHolidayPolicy: CreateHolidayPolicyOutput;
  /**
   * Update an employee's holiday policy from hourly to fixed.
   *
   * Requires the UPDATE_HOLIDAY_POLICY_FOR_CORE_TEAM_MEMBER permission
   */
  updateEmployeeHolidayPolicy: UpdateEmployeeHolidayPolicyOutput;
  /**
   * Upserts a core team member in the HR service.
   *
   *     Requires the UPSERT_HR_CORE_TEAM_MEMBER permission.
   */
  upsertHrCoreTeamMember: UpsertHRCoreTeamMemberOutput;
  /**
   * Upserts the home address for an Employee's core team member record.
   *
   *     Requires the UPSERT_EMPLOYEE_HOME_ADDRESS permission.
   */
  upsertEmployeeHomeAddress: UpsertEmployeeHomeAddressOutput;
  /**
   * Upserts the diversity and inclusion info for an Employee's core team member record.
   *
   *     Requires the UPDATE_EMPLOYEE permission.
   */
  upsertEmployeeDiversityAndInclusionInfo: UpsertEmployeeDiversityAndInclusionInfoOutput;
  /**
   * Upserts the emergency contact for an Employee's core team member record.
   *
   *     Requires the UPDATE_EMPLOYEE_CONTACT_DETAILS permission.
   */
  upsertEmployeeEmergencyContact: UpsertEmployeeEmergencyContactOutput;
  /** Creates a performance note for an Employee. */
  createEmployeePerformanceNote: CreateEmployeePerformanceNoteOutput;
  /**
   * Creates a working contract for an Employee.
   *
   *     Requires the UPDATE_EMPLOYEE permission.
   */
  createEmployeeWorkingContract: CreateEmployeeWorkingContractOutput;
  /**
   * Deletes a working contract for an Employee.
   *
   *     Requires the UPDATE_EMPLOYEE permission.
   */
  deleteEmployeeWorkingContract: DeleteEmployeeWorkingContractOutput;
  /**
   * Creates a new partner job title for the specified account.
   *
   *     This operation is restricted to Stint staff users only.
   */
  createPartnerJobTitle: CreatePartnerJobTitleOutput;
  /**
   * Updates a partner job title — handles rename, archive, and restore in one call.
   *
   *     Requires the user to be a Stint staff user.
   */
  updatePartnerJobTitle: UpdatePartnerJobTitleOutput;
  /**
   * Updates a working contract for an Employee.
   *
   *     Requires the UPDATE_EMPLOYEE permission.
   */
  updateEmployeeWorkingContract: UpdateEmployeeWorkingContractOutput;
  /**
   * Creates an absence request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  createEmployeeAbsenceRequest: CreateEmployeeAbsenceRequestOutput;
  /**
   * Deletes an absence request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  deleteEmployeeAbsenceRequest: DeleteEmployeeAbsenceRequestOutput;
  /**
   * Updates an absence request for an employee.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  updateEmployeeAbsenceRequest: UpdateEmployeeAbsenceRequestOutput;
  /**
   * Uploads a supporting document to an employee absence request.
   *
   * Requires the MANAGE_CORE_TEAM_MEMBER_LEAVE permission.
   */
  uploadEmployeeAbsenceRequestDocument: UploadEmployeeAbsenceRequestDocumentOutput;
  /**
   * Creates an EmployeeDocument.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  createEmployeeDocument: CreateEmployeeDocumentOutput;
  /**
   * Deletes an EmployeeDocument.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  deleteEmployeeDocument: DeleteEmployeeDocumentOutput;
  /**
   * Updates an EmployeeDocument.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  updateEmployeeDocument: UpdateEmployeeDocumentOutput;
  /** Update the Stint global editable settings.No UUID is required as there is only one instance to update. */
  updateEditableSetting?: Maybe<EditableSetting>;
  /** Initiates a file upload for a partner account, allowing the user to upload a file to a presigned URL, sent back in the response. */
  initiatePartnerFileUpload: FileUpload;
  /** Initiates a file upload for any authenticated user, allowing the user to upload a file to a presigned URL, sent back in the response. */
  initiateFileUpload: InitiateFileUploadOutput;
  /** Handles manually creating an Offence object. */
  createOffence?: Maybe<Offence>;
  /** Handles manually creating an Appeal object from Admin. */
  adminCreateAppeal?: Maybe<Appeal>;
  /** Update or create device info for a mobile user that matches provided unique id for the device. */
  upsertDeviceInfo?: Maybe<UpsertDeviceInfo>;
  /** Create new country. */
  createCountry?: Maybe<Country>;
  /** Update a country that matches provided id. */
  updateCountry?: Maybe<Country>;
  /** Delete a country that matches provided id. */
  deleteCountry?: Maybe<Country>;
  /** Create city. */
  createCity?: Maybe<City>;
  /** Update city. */
  updateCity?: Maybe<City>;
  /** Delete city. */
  deleteCity?: Maybe<City>;
  /** Handles updating a Business object. */
  updateBusiness?: Maybe<Business>;
  /**
   * Applies the chosen Option of a Schedule Labour Suggestion to the site schedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a GM, or when BI rejects on the labour-model setting.
   * - Stale-record rejection (with rich-error extensions) when the Suggestion or Option has been
   *   cleared by a fresher recompute; the FE refreshes the panel.
   */
  applyScheduleLabourSuggestionOption: ApplyScheduleLabourSuggestionOptionOutput;
  /**
   * Handles updating a HeadcountOpportunity review status.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updateHeadcountOpportunityReviewStatus: UpdateHeadcountOpportunityReviewStatusOutput;
  /**
   * Updates the minimum weekly hours floor for an employee at a site.
   * Passing null clears the stored value.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INVALID_ARGUMENT when min_hours is outside the valid range (> 0 and < 168).
   * - BAD_REQUEST when the employee has a fixed contract.
   */
  updateEmployeeMinHours: UpdateEmployeeMinHoursOutput;
  /**
   * Creates a new auto scheduler custom rule for a site on the given week.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   * - UNAUTHORIZED when the Site does not have the AUTO_SCHEDULER_CUSTOM_RULES_ENABLED setting set to `true`.
   */
  createAutoSchedulerCustomRule: CreateAutoSchedulerCustomRuleOutput;
  /**
   * Deletes an auto scheduler custom rule. No-op if the rule does not exist.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   * - UNAUTHORIZED when the Site does not have the AUTO_SCHEDULER_CUSTOM_RULES_ENABLED setting set to `true`.
   */
  deleteAutoSchedulerCustomRule: DeleteAutoSchedulerCustomRuleOutput;
  /**
   * Handles creating a RecurringShiftTemplate.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  createRecurringShiftTemplate: CreateRecurringShiftTemplateOutput;
  /**
   * Handles updating a RecurringShiftTemplate.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updateRecurringShiftTemplate: UpdateRecurringShiftTemplateOutput;
  /**
   * Handles deleting a RecurringShiftTemplate.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  deleteRecurringShiftTemplate: DeleteRecurringShiftTemplateOutput;
  /**
   * Handles updating a RecurringShiftTemplate from a given date onwards.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updateRecurringShiftTemplateFromDate: UpdateRecurringShiftTemplateFromDateOutput;
  /**
   * Handles deleting a RecurringShiftTemplate from a given date onwards.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  deleteRecurringShiftTemplateFromDate: DeleteRecurringShiftTemplateFromDateOutput;
  /**
   * Updates a RecurringShiftOccurrence.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updateRecurringShiftOccurrence: UpdateRecurringShiftOccurrenceOutput;
  /**
   * Cancels a RecurringShiftOccurrence.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  cancelRecurringShiftOccurrence: CancelRecurringShiftOccurrenceOutput;
  /**
   * Handles creating a RecurringEmployeeShift.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  createRecurringEmployeeShift: CreateRecurringEmployeeShiftOutput;
  /**
   * Handles deleting a RecurringEmployeeShift.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  deleteRecurringEmployeeShift: DeleteRecurringEmployeeShiftOutput;
  /**
   * Handles updating the enabled non-service shift types for a partner account.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updatePartnerAccountNonServiceShiftTypes: UpdatePartnerAccountNonServiceShiftTypesOutput;
  /**
   * Handles creating a RoleConfiguration.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  createRoleConfiguration: CreateRoleConfigurationOutput;
  /**
   * Handles updating a RoleConfiguration.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - DOES_NOT_EXIST when the RoleConfiguration does not exist.
   */
  updateRoleConfiguration: UpdateRoleConfigurationOutput;
  /**
   * Adds a Shift to the SiteSchedule.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  addSiteScheduleShift: AddSiteScheduleShiftOutput;
  /**
   * Adds recommended Shifts to the SiteSchedule.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  addRecommendedSiteScheduleShifts: AddRecommendedSiteScheduleShiftsOutput;
  /**
   * Updates a Shift to the SiteSchedule.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateSiteScheduleShift: UpdateSiteScheduleShiftOutput;
  /**
   * Approves a shift attendance by transitioning the shift to APPROVED status.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  approveShiftAttendance: ApproveShiftAttendanceOutput;
  /**
   * Checks a CoreTeamMember into a Shift and sets the shift to CHECKED_IN status.
   *
   * Requires UPDATE_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS permission
   */
  checkInShift: CheckInShiftOutput;
  /**
   * Checks a CoreTeamMember out of a Shift and sets the shift to CHECKED_OUT status.
   *
   * Requires UPDATE_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS permission
   */
  checkOutShift: CheckOutShiftOutput;
  /**
   * Deletes a Shift from a SiteSchedule.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  deleteSiteScheduleShift: DeleteSiteScheduleShiftOutput;
  /**
   * Rejects a shift attendance by transitioning the shift to REJECTED status.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  rejectShiftAttendance: RejectShiftAttendanceOutput;
  /**
   * Update the shift attendance values and transition the shift to the appropriate status.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateShiftAttendance: UpdateShiftAttendanceOutput;
  /**
   * Accept an open shift as a core team member.
   *
   * Requires the UPDATE_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS permission
   */
  acceptOpenShift: AcceptOpenShiftOutput;
  /**
   * Swaps two Shifts in the SiteSchedule.
   *
   * Swapping shifts works like changing places of them: the shifts exchange their time slots and
   * positions in the schedule. For example, if shift 1 is on Monday 2pm - 4pm and shift 2 is on
   * Friday 1pm - 3pm, after swapping shift 2 will appear on Monday 1pm - 3pm and shift 1 will
   * appear on Friday 2pm - 4pm. Also depends on the shifts it could work differently in some scenarios:
   *
   * - If both shifts are assigned to employees, the shifts change places and the employees are
   *   exchanged between them.
   * - If one shift is assigned to an employee and the other is open (no employee assigned), after
   *   swapping the assigned shift becomes open and the open shift becomes assigned to that employee.
   * - If both shifts are open, after swapping both shifts remain open.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission and BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  swapSiteScheduleShifts: SwapSiteScheduleShiftsOutput;
  /**
   * Submits an employee review for a completed shift.
   *
   * Requires UPDATE_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS permission.
   */
  submitEmployeeShiftReview: SubmitEmployeeShiftReviewOutput;
  /**
   * Deletes the operational event with the given ID.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission.
   */
  deleteOperationalEvent: OperationalEvent;
  /**
   * Creates a new operational event with the given input.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission.
   */
  createOperationalEvent: OperationalEvent;
  /**
   * Updates the operational event with the given input.
   *
   * Requires MANAGE_BUSINESS_INTELLIGENCE permission.
   */
  updateOperationalEvent: OperationalEvent;
  /**
   * Handles resetting the SiteSchedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  resetSiteSchedule: SiteSchedule;
  /**
   * Captures a manager's feedback on a SiteSchedule that was in `READY` review state to put it into either an
   * `APPROVED` or `REJECTED` review state.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the REVIEW_SITE_SCHEDULE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  reviewSiteSchedule: ReviewSiteScheduleOutput;
  /**
   * Submits a SiteSchedule for review.
   *
   * This will move the SiteScheduleReview into a `READY` state from either `AWAITING`
   * or `REJECTED`.
   *
   * Once in `READY`, a user with approval rights will be able to review the SiteSchedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  submitSiteScheduleForReview: SubmitSiteScheduleForReviewOutput;
  /**
   * Handles triggering the AutoScheduler BI service to generate a SiteSchedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   * @deprecated Use triggerAutoschedulerV2: one-off overrides are dynamic preferences only; expected days/hours are computed in BI; logic lives in the BI TriggerAutoScheduler RPC.
   */
  triggerAutoscheduler: SiteSchedule;
  /**
   * Triggers the AutoScheduler (v2) in the BI service. Returns the updated SiteSchedule for the week.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  triggerAutoschedulerV2: TriggerAutoschedulerV2Output;
  /**
   * Marks a SiteSchedule as having all shift attendances confirmed.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  markSiteScheduleAttendancesConfirmed: MarkSiteScheduleAttendancesConfirmedOutput;
  /**
   * Marks a SiteSchedule as no longer having all shift attendances confirmed.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not Staff.
   */
  markSiteScheduleAttendancesUnconfirmed: MarkSiteScheduleAttendancesUnconfirmedOutput;
  /**
   * Updates the working preferences for a member in a site schedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateSiteScheduleWorkingPreferences: UpdateSiteScheduleWorkingPreferencesOutput;
  /**
   * Updates the working availability for a member in a site schedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateSiteScheduleWorkingAvailability: UpdateSiteScheduleWorkingAvailabilityOutput;
  /**
   * Cancels the generation of a SiteSchedule.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  cancelSiteScheduleGeneration: CancelSiteScheduleGenerationOutput;
  /**
   * Un-approves a site schedule for a given site and week, cancelling any posted Stint marketplace
   * shifts and returning the rota to Awaiting status so the GM can correct and resubmit.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not Staff.
   * - DOES_NOT_EXIST when no rota exists for the site and week.
   * - WEEK_NOT_FUTURE when weekCommencing is the current week or in the past.
   * - INVALID_WEEK_START_DAY when weekCommencing does not match the partner's scheduleWeekStartDay.
   * - NOT_APPROVED when the rota exists but is not in Approved status.
   * - STINT_CANCELLATION_FAILED when one or more Stints could not be cancelled.
   * - REVIEW_UPDATE_FAILED when Stint cancellation succeeded but the review update failed.
   */
  unapproveSiteSchedule: UnapproveSiteScheduleOutput;
  /**
   * Handles creating a DemandForecast for a Site.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  createDemandForecast: DemandForecast;
  /**
   * Handles updating a DemandForecast for a Site.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateDemandForecast: UpdateDemandForecastOutput;
  /**
   * Handles updating a DemandForecast's recommended forecast for a Site, by accepting a new recommendation.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateDemandForecastRecommended: PartnerSiteProfile;
  /**
   * Handles updating a DemandForecast's Shifts for a Site.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   * @deprecated Deprecated: To be replaced by new mutations - createDemandForecastHeadcount, updateDemandForecastHeadcount, deleteDemandForecastHeadcount. (See sc-87939)
   */
  updateDemandForecastShifts: DemandForecast;
  /**
   * Adds a single new headcount entry to the demand forecast shape of day for the given site and date.
   * Generates a new UUID for the entry, appends it to the stored array, validates the full
   * post-operation array, and writes back with a historical snapshot.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  createDemandForecastHeadcount: CreateDemandForecastHeadcountOutput;
  /**
   * Updates a single existing headcount entry in the demand forecast shape of day, identified by ID.
   * Finds the entry by ID (returns an error if not found), replaces it in the array, validates the
   * full post-operation array, and writes back with a historical snapshot.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  updateDemandForecastHeadcount: UpdateDemandForecastHeadcountOutput;
  /**
   * Removes a single headcount entry from the demand forecast shape of day by ID.
   * No-op if the entry is already absent (safe for concurrent deletes). Validates the full
   * post-operation array and writes back with a historical snapshot.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  deleteDemandForecastHeadcount: DeleteDemandForecastHeadcountOutput;
  /**
   * Handles creating a BreakRule.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  createBreakRule: CreateBreakRuleOutput;
  /**
   * Handles updating a BreakRule.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  updateBreakRule: UpdateBreakRuleOutput;
  /**
   * Handles deleting a BreakRule.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  deleteBreakRule: DeleteBreakRuleOutput;
  /** Handles creating a TopTip object. */
  createTopTip?: Maybe<TopTip>;
  /** Handles updating a TopTip object. */
  updateTopTip?: Maybe<TopTip>;
  /** Handles deleting a TopTip object. */
  deleteTopTip?: Maybe<TopTip>;
  /** Handles creating an EmploymentException object. */
  createEmploymentException?: Maybe<EmploymentException>;
  /** Handles updating an EmploymentException object. */
  updateEmploymentException?: Maybe<EmploymentException>;
  /** Handles deleting an EmploymentException object. */
  deleteEmploymentException?: Maybe<EmploymentException>;
  /** Mutation to set password user */
  setPassword?: Maybe<SetPassword>;
  /** Mutation to request an OTP for user's email */
  sendOtpEmail?: Maybe<SendOTPEmail>;
  /** Mutation to request an OTP for user's phonenumber */
  sendOtpSms?: Maybe<SendOTPSMS>;
  /** Mutation to request an OTP via a user's ID */
  sendOtpSmsV2?: Maybe<SendOTPSMSV2>;
  /** Mutation to verify an OTP for a user's email */
  verifyEmail?: Maybe<VerifyEmail>;
  /** Mutation to verify an OTP for a user's phonenumber */
  verifyPhonenumber?: Maybe<VerifyPhonenumber>;
  /** Mutation to send forgot password email */
  forgotPassword?: Maybe<ForgotPassword>;
  /** Mutation to authenticate an Admin user */
  loginAdmin?: Maybe<LoginAdmin>;
  /** Mutation to authenticate an Employer user */
  loginEmployer?: Maybe<LoginEmployer>;
  /** Mutation to authenticate a Student user */
  loginStudent?: Maybe<LoginStudent>;
  /**
   * Mutation to authenticate a Mobile user
   * @deprecated Replaced in favor of loginStudent, loginEmployer
   */
  loginMobileUser?: Maybe<LoginMobileUser>;
  /**
   * Mutation to authenticate a user and obtain a JWT access and refresh token
   * @deprecated Replaced in favor of loginAdmin, loginStudent, loginEmployer
   */
  tokenAuth?: Maybe<ObtainJSONWebToken>;
  /** Mutation to verify a JWT access or refresh token */
  verifyToken?: Maybe<Verify>;
  /** Mutation to refresh an expired/soon to be expired JWT token */
  refreshToken?: Maybe<Refresh>;
  /** Mutation to reset password */
  resetPassword?: Maybe<ResetPassword>;
  /** Handles confirming an AgreementType.EMPLOYEE_DISCLAIMER agreement. */
  confirmEmployeeDisclaimer: EmployeeDisclaimerInfo;
  /** Handles creating an Agreement object. Raises AgreementError or InputError. */
  createAgreement: Agreement;
  /** Handles updating an Agreement object. Raises AgreementError or InputError. */
  updateAgreement: Agreement;
  /** Checks if address is available (in active city). */
  checkAddressAvailability?: Maybe<CheckAddressAvailability>;
  /** Deletes the authenticated employer's profile photo. */
  deleteProfilePhoto: DeleteProfilePhotoOutput;
  /** Handles updating the list of partner account IDs a stinter is excluded from. */
  updateStinterPartnerExclusions: UpdateStinterPartnerExclusionsOutput;
  /**
   * Handles updating a user's username (email).
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a Staff member.
   * - ALREADY_EXISTS when the new email already exists for another user.
   */
  updateUsername: UpdateUsernameOutput;
  /** Upserts the authenticated employer's profile photo. */
  upsertProfilePhoto: UpsertProfilePhotoOutput;
  /** Handles a Right To Be Forgotten request. */
  requestToBeForgotten?: Maybe<RequestToBeForgottenResult>;
  /** Update logged in user's profile */
  newUpdateMyProfile?: Maybe<UpdateMyProfile>;
  updateMyProfilePicture?: Maybe<UpdateMyProfilePicture>;
  /** Manages the bulk update of StintUser can_see_surge value for any student refs in the provided file */
  bulkUpdateCanSeeSurge?: Maybe<SuccessType>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateUniversityArgs = {
  cityId?: Maybe<Scalars['UUID']>;
  domain: Scalars['String'];
  group?: Maybe<Scalars['String']>;
  imageOneX?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateUniversityArgs = {
  cityId?: Maybe<Scalars['UUID']>;
  domain?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  imageOneX?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateTagArgs = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateTagArgs = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStudentSavedPlaceArgs = {
  displayAddress: Scalars['String'];
  name: Scalars['String'];
  placeId: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStudentSavedPlaceArgs = {
  displayAddress: Scalars['String'];
  name: Scalars['String'];
  placeId: Scalars['String'];
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteStudentSavedPlaceArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertStintUserAvailabilityArgs = {
  cityId: Scalars['UUID'];
  dayAvailability: Array<Maybe<AvailabilityInput>>;
  inputType?: Maybe<StudentAvailabilityInputType>;
  override?: Maybe<Scalars['Boolean']>;
  studentSavedPlacesIds: Array<Maybe<Scalars['UUID']>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteStintUserAvailabilityArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStintTemplateArgs = {
  input?: Maybe<CreateStintTemplateInput>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintTemplateArgs = {
  input?: Maybe<UpdateStintTemplateInput>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStintTemplateGroupArgs = {
  input: CreateStintTemplateGroupInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintTemplateGroupArgs = {
  input: UpdateStintTemplateGroupInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationconfirmRightToWorkDocUploadArgs = {
  userId: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStinterMarketingConsentArgs = {
  updateInputs: UpdateStinterMarketingConsentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStinterMarketingChannelArgs = {
  input: UpdateStinterMarketingChannelInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStintTaskArgs = {
  businessCategoryId?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['UUID']>;
  taskType?: Maybe<Scalars['String']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintTaskArgs = {
  name?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  taskType?: Maybe<Scalars['String']>;
  topTips?: Maybe<Array<Maybe<TaskTopTipInput>>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteStintTaskArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStintsArgs = {
  createInputs: CreateStintsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintTimesArgs = {
  updateInputs: UpdateStintTimesInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateActualLeaveTimeArgs = {
  updateInputs: UpdateActualLeaveTimeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcancelStintAsStinterArgs = {
  input: CancelStintAsStinterInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationacceptStintArgs = {
  lastModifiedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationacceptAvailableStintArgs = {
  acceptanceMethod?: Maybe<AcceptanceMethod>;
  lastModifiedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationemployerCancelStintArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintopediaArgs = {
  aboutUs?: Maybe<Scalars['String']>;
  accessToAnnualPlAccounts?: Maybe<Scalars['Boolean']>;
  accessToRotaExamples?: Maybe<Scalars['Boolean']>;
  accessToTransactionSalesData?: Maybe<Scalars['Boolean']>;
  agreedTakePartInMarketingInitiatives?: Maybe<Scalars['Boolean']>;
  agreedToContinuePostingIfWeSeeDesireResults?: Maybe<Scalars['Boolean']>;
  agreedToOperateStaffingRota?: Maybe<Scalars['Boolean']>;
  agreedToReferFriendsIfFinancialMetricsImproved?: Maybe<Scalars['Boolean']>;
  bookedOnboardingMeeting?: Maybe<Scalars['Boolean']>;
  businessId: Scalars['UUID'];
  businessLogo?: Maybe<Scalars['String']>;
  characteristicIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  donts?: Maybe<Array<Maybe<Scalars['String']>>>;
  dos?: Maybe<Array<Maybe<Scalars['String']>>>;
  emoji?: Maybe<Scalars['String']>;
  exceptionIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  facebook?: Maybe<Scalars['String']>;
  generalPhoto1?: Maybe<Scalars['String']>;
  generalPhoto2?: Maybe<Scalars['String']>;
  generalPhoto3?: Maybe<Scalars['String']>;
  generalPhoto4?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  onboardingComplete?: Maybe<Scalars['Boolean']>;
  photoOfEntrance?: Maybe<Scalars['String']>;
  preferredLanguageIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  prepVideoUrl?: Maybe<Scalars['String']>;
  qrCodeLocation?: Maybe<Scalars['String']>;
  teamStructure?: Maybe<Scalars['String']>;
  usingStintCorrectly?: Maybe<Scalars['Boolean']>;
  website?: Maybe<Scalars['String']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrecordOfferSeenEventArgs = {
  eventType: OfferSeenType;
  ids: Array<Maybe<Scalars['UUID']>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintArgs = {
  cancellationFee?: Maybe<Scalars['Float']>;
  cancellationFeeOverride?: Maybe<Scalars['Boolean']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  controlCheck?: Maybe<Scalars['Boolean']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  displayAddress?: Maybe<Scalars['String']>;
  exceptions?: Maybe<Array<Maybe<StintTemplateExceptionInput>>>;
  isBestEffort?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  overrideBaseFee?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['String']>;
  primaryTasks?: Maybe<Array<Maybe<StintTemplateTaskInput>>>;
  secondaryTasks?: Maybe<Array<Maybe<StintTemplateTaskInput>>>;
  status?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  studentBaseFeeOverrideGrossAmount?: Maybe<Scalars['Float']>;
  student_id?: Maybe<Scalars['UUID']>;
  studentSurgeBaseFeeGrossAmount?: Maybe<Scalars['Float']>;
  studentUnassignedReasons?: Maybe<Array<Maybe<StudentUnassignedReasons>>>;
  topTips?: Maybe<Array<Maybe<StintTemplateTopTipInput>>>;
  uniform?: Maybe<Array<Maybe<StintUniform>>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteStintArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcheckInStintArgs = {
  qrCodeId: Scalars['UUID'];
  stintId: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationconfirmAttendStintArgs = {
  stintId: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintUserArgs = {
  dateOfBirth?: Maybe<Scalars['Date']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  exceptions?: Maybe<Array<Maybe<StintTemplateExceptionInput>>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodInput>;
  permanentDeactivated?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  studentProfile?: Maybe<StudentProfileInput>;
  universityId?: Maybe<Scalars['UUID']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationverifyStudentUserArgs = {
  studentUserIds: Array<Maybe<Scalars['UUID']>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateMeArgs = {
  currentCityId?: Maybe<Scalars['UUID']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcancelStintsArgs = {
  stintRefs: Array<Maybe<Scalars['UUID']>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintJourneyArgs = {
  checkInDate?: Maybe<Scalars['DateTime']>;
  differentStartTimeReasons?: Maybe<Array<Maybe<DifferentStartTimeReason>>>;
  estimatedTimeOfArrival?: Maybe<Scalars['DateTime']>;
  estimatedTimeOfDeparture?: Maybe<Scalars['DateTime']>;
  internalNotes?: Maybe<Scalars['String']>;
  lateNote?: Maybe<Scalars['String']>;
  statusResolved?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsetDoNotRemindAboutGeotrackingArgs = {
  stintId: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmanualGeotrackingStatusUpdateArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationresolveStintJourneysArgs = {
  stintJourneyIds: Array<Scalars['UUID']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertVideoAssessmentInfoArgs = {
  input: UpsertVideoAssessmentInfoInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateWorkExperienceArgs = {
  createInputs: CreateWorkExperienceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationqualifyForTaskArgs = {
  input: QualifyForTaskInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsearchGooglePlacesArgs = {
  returnType?: Maybe<GooglePlacesReturnType>;
  searchTerm: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStintWeekTemplateArgs = {
  businessId: Scalars['UUID'];
  name: Scalars['String'];
  sessions: Array<Maybe<StintWeekTemplateSessionInput>>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintWeekTemplateArgs = {
  name: Scalars['String'];
  sessions: Array<Maybe<StintWeekTemplateSessionInput>>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteStintWeekTemplateArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsetDefaultStintWeekTemplateArgs = {
  input: SetDefaultStintWeekTemplateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationclearDefaultStintWeekTemplateArgs = {
  updateInputs: ClearDefaultStintWeekTemplateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationinitiateShareCodeScreeningArgs = {
  input: InitiateShareCodeScreeningInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateManualRightToWorkScreeningArgs = {
  input: CreateManualRightToWorkScreeningInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeRightToWorkScreeningArgs = {
  input: CreateEmployeeRightToWorkScreeningInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateOutOfTermRequestArgs = {
  input: CreateOutOfTermRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationapproveOutOfTermRequestArgs = {
  input: ApproveOutOfTermRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrejectOutOfTermRequestArgs = {
  input: RejectOutOfTermRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateRegionArgs = {
  countryId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateRegionArgs = {
  countryId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteRegionArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStintTemplateRateArgs = {
  input: UpdateStintTemplateRateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePostalCodeArgs = {
  city_id: Scalars['UUID'];
  postalCode: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePostalCodeArgs = {
  city_id?: Maybe<Scalars['UUID']>;
  postalCode?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePostalCodeArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePoolMemberFeedbackArgs = {
  input: CreatePoolMemberFeedbackInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationaddStinterCommitmentArgs = {
  input: AddStinterCommitmentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStinterCommitmentArgs = {
  input: UpdateStinterCommitmentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationaddStintersToStintTemplatePoolArgs = {
  input: AddStintersToStintTemplatePoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationremoveStintersFromStintTemplatePoolArgs = {
  input: RemoveStintersFromStintTemplatePoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationremoveStinterFromStintTemplatePoolArgs = {
  input: RemoveStinterFromStintTemplatePoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationapproveTrialStinterForStintTemplatePoolArgs = {
  input: ApproveTrialStinterForStintTemplatePoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationfailTrialStinterForStintTemplatePoolArgs = {
  input: FailTrialStinterForStintTemplatePoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationaddStintersToPartnerPoolArgs = {
  input: AddStintersToPartnerPoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerPoolArgs = {
  input: CreatePartnerPoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationremoveStintersFromPartnerPoolArgs = {
  input: RemoveStintersFromPartnerPoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationremoveAllStintersFromPartnerPoolArgs = {
  input: RemoveAllStintersFromPartnerPoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerPoolArgs = {
  input: UpdatePartnerPoolInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmarkPartnerPoolInvitesAsSeenByStinterArgs = {
  input: MarkPartnerPoolInvitesAsSeenByStinterInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmarkInviteAsAppliedArgs = {
  input: MarkInviteAsAppliedInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmarkFailedTrialPoolAsSeenArgs = {
  input: MarkFailedTrialPoolAsSeenInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStripeDebitArgs = {
  businessId: Scalars['UUID'];
  isPrimaryMethod: Scalars['Boolean'];
  sessionId: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStripeCardArgs = {
  businessId: Scalars['UUID'];
  intentId: Scalars['String'];
  isPrimaryMethod: Scalars['Boolean'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteStripeCardArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStripeSetupIntentArgs = {
  businessId?: Maybe<Scalars['UUID']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateStripeCheckoutSessionArgs = {
  businessId: Scalars['UUID'];
  createInputs?: Maybe<CreateCheckoutSessionInput>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateSitePaymentProviderArgs = {
  input: UpdateSitePaymentProviderInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationconfigurePartnerWebhookArgs = {
  input: ConfigurePartnerWebhookInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsendTestPartnerWebhookArgs = {
  input: SendTestPartnerWebhookInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationresendPartnerWebhookArgs = {
  input: ResendPartnerWebhookInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeNotificationSettingsArgs = {
  input: UpdateEmployeeNotificationSettingsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeSiteNotificationSettingsArgs = {
  input: UpdateEmployeeSiteNotificationSettingsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteEmployeeNotificationsArgs = {
  input: DeleteEmployeeNotificationsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationgetSsoIdpHintArgs = {
  input: GetSSOIdpHintInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateOwnWorkingPreferencesArgs = {
  input: UpdateOwnWorkingPreferencesInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateOwnWorkingAvailabilityArgs = {
  input: UpdateOwnWorkingAvailabilityInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerMemberSiteWorkingPreferencesArgs = {
  input: UpdatePartnerMemberSiteWorkingPreferencesInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerMemberSiteWorkingAvailabilityArgs = {
  input: UpdatePartnerMemberSiteWorkingAvailabilityInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertDynamicWorkingPreferenceArgs = {
  input: UpsertDynamicWorkingPreferenceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteDynamicWorkingPreferenceArgs = {
  input: DeleteDynamicWorkingPreferenceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateWorkingPreferenceRequestArgs = {
  input: CreateWorkingPreferenceRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationapproveWorkingPreferenceRequestArgs = {
  input: ApproveWorkingPreferenceRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrejectWorkingPreferenceRequestArgs = {
  input: RejectWorkingPreferenceRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertPartnerOperationalAreasArgs = {
  input: UpsertPartnerOperationalAreasInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerSettingsArgs = {
  input: UpdatePartnerSettingsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeArgs = {
  input: CreateEmployeeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeTerminationArgs = {
  input: CreateEmployeeTerminationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcancelEmployeeTerminationArgs = {
  input: CancelEmployeeTerminationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeContactDetailsArgs = {
  input: UpdateEmployeeContactDetailsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeInfoArgs = {
  input: UpdateEmployeeInfoInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeFlagArgs = {
  input: UpdateEmployeeFlagInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeePrimarySiteArgs = {
  input: UpdateEmployeePrimarySiteInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeManagerArgs = {
  input: UpsertEmployeeManagerInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeManagersArgs = {
  input: UpsertEmployeeManagersInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrehireEmployeeArgs = {
  input: RehireEmployeeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationreassignDirectReportsArgs = {
  input: ReassignDirectReportsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateAccountNodeArgs = {
  createInputs: CreateAccountNodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateGroupNodeArgs = {
  createInputs: CreateGroupNodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateSiteNodeArgs = {
  createInputs: CreateSiteNodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateAccountNodeArgs = {
  updateInputs: UpdateAccountNodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateGroupNodeArgs = {
  updateInputs: UpdateGroupNodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerNodeParentArgs = {
  updateInputs: UpdatePartnerNodeParentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateSiteNodeArgs = {
  updateInputs: UpdateSiteNodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationregenerateSiteQRCodeArgs = {
  input: RegenerateSiteQRCodeInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeSecondaryRolesArgs = {
  input: UpdateEmployeeSecondaryRolesInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeExperienceLevelArgs = {
  input: UpsertEmployeeExperienceLevelInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerMemberArgs = {
  input: CreatePartnerMemberInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerMemberArgs = {
  input: UpdatePartnerMemberInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerMemberArgs = {
  deleteInputs: DeletePartnerMemberInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerContactArgs = {
  updateInputs: UpdatePartnerContactInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerBrandArgs = {
  createInputs: CreatePartnerBrandInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerBrandArgs = {
  updateInputs: UpdatePartnerBrandInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerAccountSettingsArgs = {
  input: UpdatePartnerAccountSettingsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateCompaniesHouseInformationArgs = {
  createInputs: CreateCompaniesHouseInformationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateCompaniesHouseInformationArgs = {
  updateInputs: UpdateCompaniesHouseInformationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerIntegrationProfileMappingArgs = {
  input: CreatePartnerIntegrationProfileMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerIntegrationProfileMappingArgs = {
  input: DeletePartnerIntegrationProfileMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerIntegrationProfileMappingArgs = {
  input: UpdatePartnerIntegrationProfileMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerIntegrationJobTitleMappingArgs = {
  input: CreatePartnerIntegrationJobTitleMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerIntegrationJobTitleMappingArgs = {
  input: UpdatePartnerIntegrationJobTitleMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerIntegrationJobTitleMappingArgs = {
  input: DeletePartnerIntegrationJobTitleMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerIntegrationRoleMappingArgs = {
  input: CreatePartnerIntegrationRoleMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerIntegrationRoleMappingArgs = {
  input: UpdatePartnerIntegrationRoleMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerIntegrationRoleMappingArgs = {
  input: DeletePartnerIntegrationRoleMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerIntegrationSiteMappingArgs = {
  input: CreatePartnerIntegrationSiteMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerIntegrationSiteMappingArgs = {
  input: UpdatePartnerIntegrationSiteMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerIntegrationSiteMappingArgs = {
  input: DeletePartnerIntegrationSiteMappingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerIntegrationArgs = {
  input: CreatePartnerIntegrationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerIntegrationArgs = {
  input: UpdatePartnerIntegrationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerAccountApiTokenArgs = {
  input: CreatePartnerAccountAPITokenInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrevokePartnerAccountApiTokenArgs = {
  input: RevokePartnerAccountAPITokenInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerAccountApiTokenArgs = {
  input: UpdatePartnerAccountAPITokenInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateBulkEmployeeUploadArgs = {
  input: CreateBulkEmployeeUploadInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateNotificationArgs = {
  message: Scalars['String'];
  sendPushNotification?: Maybe<Scalars['Boolean']>;
  stint_id?: Maybe<Scalars['UUID']>;
  student_ids: Array<Maybe<Scalars['String']>>;
  title: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateAppLifecycleEventArgs = {
  businessId?: Maybe<Scalars['UUID']>;
  eventType: AppLifecycleEventEventTypes;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationacknowledgeNotificationOpenedArgs = {
  notificationId: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsiteScheduleAgentArgs = {
  input: SiteScheduleAgentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdemandForecastAgentArgs = {
  input: DemandForecastAgentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeBankDetailsArgs = {
  input: UpsertEmployeeBankDetailsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeePayrollInformationArgs = {
  input: UpsertEmployeePayrollInformationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerJobTitlePayRateArgs = {
  input: CreatePartnerJobTitlePayRateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerJobTitlePayRateArgs = {
  input: DeletePartnerJobTitlePayRateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerDepartmentArgs = {
  input: CreatePartnerDepartmentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerDepartmentArgs = {
  input: UpdatePartnerDepartmentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeletePartnerDepartmentArgs = {
  input: DeletePartnerDepartmentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcoreTeamMemberHolidayRequestArgs = {
  input: CoreTeamMemberHolidayRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeHolidayRequestArgs = {
  input: CreateEmployeeHolidayRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrejectEmployeeHolidayRequestArgs = {
  input: RejectEmployeeHolidayRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationapproveEmployeeHolidayRequestArgs = {
  input: ApproveEmployeeHolidayRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcancelEmployeeHolidayRequestArgs = {
  input: CancelEmployeeHolidayRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmanuallyAdjustHolidayRemainingArgs = {
  input: ManuallyAdjustHolidayRemainingInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeHolidayRequestArgs = {
  input: UpdateEmployeeHolidayRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationassociateHolidayPolicyWithCoreTeamMemberArgs = {
  input: AssociateHolidayPolicyWithCoreTeamMemberInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateHolidayPolicyArgs = {
  input: CreateHolidayPolicyInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeHolidayPolicyArgs = {
  input: UpdateEmployeeHolidayPolicyInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertHrCoreTeamMemberArgs = {
  input: UpsertHRCoreTeamMemberInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeHomeAddressArgs = {
  input: UpsertEmployeeHomeAddressInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeDiversityAndInclusionInfoArgs = {
  input: UpsertEmployeeDiversityAndInclusionInfoInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertEmployeeEmergencyContactArgs = {
  input: UpsertEmployeeEmergencyContactInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeePerformanceNoteArgs = {
  input: CreateEmployeePerformanceNoteInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeWorkingContractArgs = {
  input: CreateEmployeeWorkingContractInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteEmployeeWorkingContractArgs = {
  input: DeleteEmployeeWorkingContractInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreatePartnerJobTitleArgs = {
  input: CreatePartnerJobTitleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerJobTitleArgs = {
  input: UpdatePartnerJobTitleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeWorkingContractArgs = {
  input: UpdateEmployeeWorkingContractInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeAbsenceRequestArgs = {
  input: CreateEmployeeAbsenceRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteEmployeeAbsenceRequestArgs = {
  input: DeleteEmployeeAbsenceRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeAbsenceRequestArgs = {
  input: UpdateEmployeeAbsenceRequestInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationuploadEmployeeAbsenceRequestDocumentArgs = {
  input: UploadEmployeeAbsenceRequestDocumentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmployeeDocumentArgs = {
  input: CreateEmployeeDocumentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteEmployeeDocumentArgs = {
  input: DeleteEmployeeDocumentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeDocumentArgs = {
  input: UpdateEmployeeDocumentInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEditableSettingArgs = {
  advancedOperationalWindowEndTime?: Maybe<Scalars['Time']>;
  advancedOperationalWindowStartTime?: Maybe<Scalars['Time']>;
  automatedTestingEnabled?: Maybe<Scalars['Boolean']>;
  availabilityMatchingBufferHours?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersFriday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersMonday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersPerDay?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersSaturday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersSunday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersThursday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersTuesday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersWednesday?: Maybe<Scalars['Int']>;
  availabilityMatchingNotificationForNoOffersEnabled?: Maybe<
    Scalars['Boolean']
  >;
  baseFee?: Maybe<Scalars['Float']>;
  baseFeeStudent?: Maybe<Scalars['Float']>;
  etdCalculationAfterMiddayOffsetInMinutes?: Maybe<Scalars['Int']>;
  etdCalculationBeforeMiddayOffsetInMinutes?: Maybe<Scalars['Int']>;
  featureFlagEtdNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  featureFlagStintSecondStartReminderEnabled?: Maybe<Scalars['Boolean']>;
  featureFlagStudentGoingToBeLateSmsEnabled?: Maybe<Scalars['Boolean']>;
  geoTrackingBufferTime?: Maybe<Scalars['Int']>;
  matchingAlgoNoOfferMaxCountPerTimeWindow?: Maybe<Scalars['Int']>;
  matchingAlgoNoOfferMessage?: Maybe<Scalars['String']>;
  matchingAlgoNoOfferTimeWindowSpan?: Maybe<Scalars['Int']>;
  matchingAlgoNoOfferTitle?: Maybe<Scalars['String']>;
  matchingAlgoNotificationDelayInMinutes?: Maybe<Scalars['Int']>;
  notificationBlockerWindowHours?: Maybe<Scalars['Float']>;
  notificationTopUpThresholdInHours?: Maybe<Scalars['Int']>;
  predictionLeadDays?: Maybe<Scalars['Int']>;
  sendingStudentLeaveReminderAtRouteTimeEnabled?: Maybe<Scalars['Boolean']>;
  serverDatetime?: Maybe<Scalars['DateTime']>;
  stintOfferExpiryThresholdInHours?: Maybe<Scalars['Int']>;
  studentCancellationOnHoldEmailEnabled?: Maybe<Scalars['Boolean']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationinitiatePartnerFileUploadArgs = {
  input: InitiatePartnerFileUploadInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationinitiateFileUploadArgs = {
  input: InitiateFileUploadInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateOffenceArgs = {
  createInputs: CreateOffenceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationadminCreateAppealArgs = {
  createInputs: AdminCreateAppealInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertDeviceInfoArgs = {
  appVersion?: Maybe<Scalars['String']>;
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  locationSetting?: Maybe<LocationSettings>;
  platform?: Maybe<Scalars['String']>;
  uniqueId: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateCountryArgs = {
  name: Scalars['String'];
  regions: Scalars['String'];
  shortCode: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateCountryArgs = {
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  regions?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteCountryArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateCityArgs = {
  baseFee: Scalars['Float'];
  baseFeeStudent: Scalars['Float'];
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailabilityEnabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  regionId: Scalars['UUID'];
  repeatStintersEnabled?: Maybe<Scalars['Boolean']>;
  sessionUrl?: Maybe<Scalars['URL']>;
  shortCode: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateCityArgs = {
  baseFee?: Maybe<Scalars['Float']>;
  baseFeeStudent?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailabilityEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  postalCodeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  regionId?: Maybe<Scalars['UUID']>;
  repeatStintersEnabled?: Maybe<Scalars['Boolean']>;
  sessionUrl?: Maybe<Scalars['URL']>;
  shortCode?: Maybe<Scalars['String']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteCityArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateBusinessArgs = {
  id: Scalars['UUID'];
  businessLogo?: Maybe<Scalars['String']>;
  controlCheck?: Maybe<Scalars['Boolean']>;
  displayAddress?: Maybe<Scalars['String']>;
  exemptFromPaymentDetails?: Maybe<Scalars['Boolean']>;
  integrated?: Maybe<Scalars['Boolean']>;
  internalRanking?: Maybe<Scalars['Int']>;
  isBlockedByFinance?: Maybe<Scalars['Boolean']>;
  ltdName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboardingRanking?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  rateOverride?: Maybe<BusinessRateOverrideInput>;
  repeatStintersEnabled?: Maybe<Scalars['Boolean']>;
  status?: Maybe<BusinessStatusChoices>;
  stintopedia?: Maybe<StintopediaInput>;
  unlockedLastMinuteStints?: Maybe<Scalars['Boolean']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationapplyScheduleLabourSuggestionOptionArgs = {
  input: ApplyScheduleLabourSuggestionOptionInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateHeadcountOpportunityReviewStatusArgs = {
  input: UpdateHeadcountOpportunityReviewStatusInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmployeeMinHoursArgs = {
  input: UpdateEmployeeMinHoursInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateAutoSchedulerCustomRuleArgs = {
  input: CreateAutoSchedulerCustomRuleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteAutoSchedulerCustomRuleArgs = {
  input: DeleteAutoSchedulerCustomRuleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateRecurringShiftTemplateArgs = {
  input: CreateRecurringShiftTemplateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateRecurringShiftTemplateArgs = {
  input: UpdateRecurringShiftTemplateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteRecurringShiftTemplateArgs = {
  input: DeleteRecurringShiftTemplateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateRecurringShiftTemplateFromDateArgs = {
  input: UpdateRecurringShiftTemplateFromDateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteRecurringShiftTemplateFromDateArgs = {
  input: DeleteRecurringShiftTemplateFromDateInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateRecurringShiftOccurrenceArgs = {
  input: UpdateRecurringShiftOccurrenceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcancelRecurringShiftOccurrenceArgs = {
  input: CancelRecurringShiftOccurrenceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateRecurringEmployeeShiftArgs = {
  input: CreateRecurringEmployeeShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteRecurringEmployeeShiftArgs = {
  input: DeleteRecurringEmployeeShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdatePartnerAccountNonServiceShiftTypesArgs = {
  input: UpdatePartnerAccountNonServiceShiftTypesInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateRoleConfigurationArgs = {
  input: CreateRoleConfigurationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateRoleConfigurationArgs = {
  input: UpdateRoleConfigurationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationaddSiteScheduleShiftArgs = {
  input: AddSiteScheduleShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationaddRecommendedSiteScheduleShiftsArgs = {
  input: AddRecommendedSiteScheduleShiftsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateSiteScheduleShiftArgs = {
  input: UpdateSiteScheduleShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationapproveShiftAttendanceArgs = {
  input: ApproveShiftAttendanceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcheckInShiftArgs = {
  input: CheckInShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcheckOutShiftArgs = {
  input: CheckOutShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteSiteScheduleShiftArgs = {
  input: DeleteSiteScheduleShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrejectShiftAttendanceArgs = {
  input: RejectShiftAttendanceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateShiftAttendanceArgs = {
  input: UpdateShiftAttendanceInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationacceptOpenShiftArgs = {
  input: AcceptOpenShiftInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationswapSiteScheduleShiftsArgs = {
  input: SwapSiteScheduleShiftsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsubmitEmployeeShiftReviewArgs = {
  input: SubmitEmployeeShiftReviewInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteOperationalEventArgs = {
  input: DeleteOperationalEventInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateOperationalEventArgs = {
  input: CreateOperationalEventInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateOperationalEventArgs = {
  input: UpdateOperationalEventInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationresetSiteScheduleArgs = {
  input: ResetSiteScheduleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationreviewSiteScheduleArgs = {
  input: ReviewSiteScheduleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsubmitSiteScheduleForReviewArgs = {
  input: SubmitSiteScheduleForReviewInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationtriggerAutoschedulerArgs = {
  input: TriggerAutoschedulerInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationtriggerAutoschedulerV2Args = {
  input: TriggerAutoschedulerV2Input;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmarkSiteScheduleAttendancesConfirmedArgs = {
  input: MarkSiteScheduleAttendancesConfirmedInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationmarkSiteScheduleAttendancesUnconfirmedArgs = {
  input: MarkSiteScheduleAttendancesUnconfirmedInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateSiteScheduleWorkingPreferencesArgs = {
  input: UpdateSiteScheduleWorkingPreferencesInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateSiteScheduleWorkingAvailabilityArgs = {
  input: UpdateSiteScheduleWorkingAvailabilityInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcancelSiteScheduleGenerationArgs = {
  input: CancelSiteScheduleGenerationInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationunapproveSiteScheduleArgs = {
  input: UnapproveSiteScheduleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateDemandForecastArgs = {
  input: CreateDemandForecastInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateDemandForecastArgs = {
  input: UpdateDemandForecastInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateDemandForecastRecommendedArgs = {
  input: UpdateDemandForecastRecommendedInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateDemandForecastShiftsArgs = {
  input: UpdateDemandForecastShiftsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateDemandForecastHeadcountArgs = {
  input: CreateDemandForecastHeadcountInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateDemandForecastHeadcountArgs = {
  input: UpdateDemandForecastHeadcountInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteDemandForecastHeadcountArgs = {
  input: DeleteDemandForecastHeadcountInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateBreakRuleArgs = {
  input: CreateBreakRuleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateBreakRuleArgs = {
  input: UpdateBreakRuleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteBreakRuleArgs = {
  input: DeleteBreakRuleInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateTopTipArgs = {
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  taskId?: Maybe<Scalars['UUID']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateTopTipArgs = {
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taskId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteTopTipArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateEmploymentExceptionArgs = {
  category?: Maybe<EmploymentExceptionCategoryInputType>;
  name: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateEmploymentExceptionArgs = {
  category?: Maybe<EmploymentExceptionCategoryInputType>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationdeleteEmploymentExceptionArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsetPasswordArgs = {
  password: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsendOtpEmailArgs = {
  email: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsendOtpSmsArgs = {
  phoneNumber: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationsendOtpSmsV2Args = {
  userId: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationverifyEmailArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationverifyPhonenumberArgs = {
  otp: Scalars['String'];
  phoneNumber: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationforgotPasswordArgs = {
  email: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationloginAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationloginEmployerArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationloginStudentArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationloginMobileUserArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationtokenAuthArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationverifyTokenArgs = {
  token?: Maybe<Scalars['String']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrefreshTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationresetPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationconfirmEmployeeDisclaimerArgs = {
  input: ConfirmEmployeeDisclaimerInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcreateAgreementArgs = {
  input: CreateAgreementInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateAgreementArgs = {
  input: UpdateAgreementInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationcheckAddressAvailabilityArgs = {
  displayAddress?: Maybe<Scalars['String']>;
  placeId: Scalars['String'];
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateStinterPartnerExclusionsArgs = {
  input: UpdateStinterPartnerExclusionsInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateUsernameArgs = {
  input: UpdateUsernameInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupsertProfilePhotoArgs = {
  input: UpsertProfilePhotoInput;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationrequestToBeForgottenArgs = {
  deactivateIfUnforgettable?: Maybe<Scalars['Boolean']>;
  input?: Maybe<RequestToBeForgottenInput>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationnewUpdateMyProfileArgs = {
  currentPassword?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['Upload']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationupdateMyProfilePictureArgs = {
  photo?: Maybe<Scalars['Upload']>;
};

/** This class contains all Mutation classes on the combined Stint API GraphQL schema. */
export type MutationbulkUpdateCanSeeSurgeArgs = {
  canSeeSurge: Scalars['Boolean'];
  userFile: Scalars['String'];
};

/**
 * The MyEmployerProfileType class is used to expose the EmployerProfile object of the authenticated Employer making
 * the request.
 * DEPRECATED: Use Employer instead.
 */
export type MyEmployerProfile = {
  __typename?: 'MyEmployerProfile';
  /** The ID of the EmployerProfile. */
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  /** The selected Business of the Employer. Will eventually be replaced with a selected_site which returns a NodeType.SITE PartnerNode. */
  selectedBusiness?: Maybe<Business>;
  /** The NodeType.ACCOUNT PartnerNode object that the Employer is a member of, which is used to return the permissions an Employer has for the NodeType.ACCOUNT PartnerNode. */
  myPartnerAccount?: Maybe<MyPartnerAccount>;
  /** The selected NodeType.SITE PartnerNode object of the Employer. Raises PartnerNodeError. */
  selectedSite?: Maybe<PartnerSiteProfile>;
};

/**
 * The MyPartnerAccountType class is used to expose the details for a NodeType.ACCOUNT PartnerNode object that an
 * authenticated Employer is a member of.
 */
export type MyPartnerAccount = {
  __typename?: 'MyPartnerAccount';
  /** The ID of the NodeType.ACCOUNT PartnerNode object that an authenticated Employer is a member of. */
  id: Scalars['UUID'];
  /** The display name that is given to the node. */
  name: Scalars['String'];
  /** The list of PartnerPermission values that the Employer has for the NodeType.ACCOUNT PartnerNode. */
  partnerPermissions: Array<Maybe<PartnerPermission>>;
};

/** The UUIDNode class extends the relay Node class in order to override the global_id_type. */
export type Node = {
  /** The ID of the object */
  id: Scalars['UUID'];
};

/** The TextChoices for the PartnerNode.node_type field. */
export enum NodeType {
  ACCOUNT = 'ACCOUNT',
  GROUP = 'GROUP',
  SITE = 'SITE',
}

/** The labour metrics breakdown for a specific non-service shift type across the week. */
export type NonServiceLabourMetricsBreakdown = {
  __typename?: 'NonServiceLabourMetricsBreakdown';
  /** The type of non-service shift. */
  type: NonServiceShiftType;
  /** The labour metrics breakdown across the week for this non-service shift type. */
  breakdown: LabourMetricsWeekBreakdown;
};

/** The type of non-service shift. */
export enum NonServiceShiftType {
  /** A prep related non-service shift. */
  PREP = 'PREP',
  /** A stock related non-service shift. */
  STOCK = 'STOCK',
  /** A maintenance related non-service shift. */
  MAINTENANCE = 'MAINTENANCE',
  /** An off-site non-service shift. */
  OFF_SITE = 'OFF_SITE',
  /** An admin related non-service shift. */
  ADMIN = 'ADMIN',
  /** A training related non-service shift. */
  TRAINING = 'TRAINING',
  /** Other non-service shift type. */
  OTHER = 'OTHER',
}

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  title: Scalars['String'];
  message: Scalars['String'];
  /** To be deprecated after notifications refactor */
  sendPushNotification: Scalars['Boolean'];
  /** To be deprecated after notifications refactor */
  sendTextMessage: Scalars['Boolean'];
  status: NotificationStatus;
  subscribeSuccessCount?: Maybe<Scalars['Int']>;
  subscribeFailureCount?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** Notification type */
  notificationType?: Maybe<Scalars['String']>;
  isSilent: Scalars['Boolean'];
  /** To be deprecated after notifications refactor */
  extraData?: Maybe<Scalars['JSONString']>;
  sendType: NotificationSendType;
  /**
   * Used to store related objects:
   * `stint_ref`
   * `business_ref`
   * Can return NULL if no related objects are set.
   */
  relatedObjects?: Maybe<Scalars['JSONString']>;
  recipients: Array<NotificationRecipient>;
  stint?: Maybe<Stint>;
  business?: Maybe<Business>;
  /** How many recipients received notification. */
  recipientsCount?: Maybe<Scalars['Int']>;
  /** How many recipients have opened notification. */
  openedCount?: Maybe<Scalars['Int']>;
};

export type NotificationFilter = {
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** recipient_id */
  recipient_id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** title_search */
  title_search?: Maybe<Scalars['String']>;
  /** title_gte */
  title_gte?: Maybe<Scalars['String']>;
  /** title_lte */
  title_lte?: Maybe<Scalars['String']>;
  /** title_istartswith */
  title_istartswith?: Maybe<Scalars['String']>;
  /** title_lt */
  title_lt?: Maybe<Scalars['String']>;
  /** title_gt */
  title_gt?: Maybe<Scalars['String']>;
  /** title_isnull */
  title_isnull?: Maybe<Scalars['Boolean']>;
  /** title_iendswith */
  title_iendswith?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  /** message_search */
  message_search?: Maybe<Scalars['String']>;
  /** message_gte */
  message_gte?: Maybe<Scalars['String']>;
  /** message_lte */
  message_lte?: Maybe<Scalars['String']>;
  /** message_istartswith */
  message_istartswith?: Maybe<Scalars['String']>;
  /** message_lt */
  message_lt?: Maybe<Scalars['String']>;
  /** message_gt */
  message_gt?: Maybe<Scalars['String']>;
  /** message_isnull */
  message_isnull?: Maybe<Scalars['Boolean']>;
  /** message_iendswith */
  message_iendswith?: Maybe<Scalars['String']>;
  sendPushNotification?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_gte */
  sendPushNotification_gte?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_lte */
  sendPushNotification_lte?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_istartswith */
  sendPushNotification_istartswith?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_lt */
  sendPushNotification_lt?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_gt */
  sendPushNotification_gt?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_isnull */
  sendPushNotification_isnull?: Maybe<Scalars['Boolean']>;
  /** sendPushNotification_iendswith */
  sendPushNotification_iendswith?: Maybe<Scalars['Boolean']>;
  sendTextMessage?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_gte */
  sendTextMessage_gte?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_lte */
  sendTextMessage_lte?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_istartswith */
  sendTextMessage_istartswith?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_lt */
  sendTextMessage_lt?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_gt */
  sendTextMessage_gt?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_isnull */
  sendTextMessage_isnull?: Maybe<Scalars['Boolean']>;
  /** sendTextMessage_iendswith */
  sendTextMessage_iendswith?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  /** status_search */
  status_search?: Maybe<Scalars['String']>;
  /** status_gte */
  status_gte?: Maybe<Scalars['String']>;
  /** status_lte */
  status_lte?: Maybe<Scalars['String']>;
  /** status_istartswith */
  status_istartswith?: Maybe<Scalars['String']>;
  /** status_lt */
  status_lt?: Maybe<Scalars['String']>;
  /** status_gt */
  status_gt?: Maybe<Scalars['String']>;
  /** status_isnull */
  status_isnull?: Maybe<Scalars['Boolean']>;
  /** status_iendswith */
  status_iendswith?: Maybe<Scalars['String']>;
  subscribeSuccessCount?: Maybe<Scalars['Float']>;
  /** subscribeSuccessCount_gte */
  subscribeSuccessCount_gte?: Maybe<Scalars['Float']>;
  /** subscribeSuccessCount_lte */
  subscribeSuccessCount_lte?: Maybe<Scalars['Float']>;
  /** subscribeSuccessCount_istartswith */
  subscribeSuccessCount_istartswith?: Maybe<Scalars['Float']>;
  /** subscribeSuccessCount_lt */
  subscribeSuccessCount_lt?: Maybe<Scalars['Float']>;
  /** subscribeSuccessCount_gt */
  subscribeSuccessCount_gt?: Maybe<Scalars['Float']>;
  /** subscribeSuccessCount_isnull */
  subscribeSuccessCount_isnull?: Maybe<Scalars['Boolean']>;
  /** subscribeSuccessCount_iendswith */
  subscribeSuccessCount_iendswith?: Maybe<Scalars['Float']>;
  subscribeFailureCount?: Maybe<Scalars['Float']>;
  /** subscribeFailureCount_gte */
  subscribeFailureCount_gte?: Maybe<Scalars['Float']>;
  /** subscribeFailureCount_lte */
  subscribeFailureCount_lte?: Maybe<Scalars['Float']>;
  /** subscribeFailureCount_istartswith */
  subscribeFailureCount_istartswith?: Maybe<Scalars['Float']>;
  /** subscribeFailureCount_lt */
  subscribeFailureCount_lt?: Maybe<Scalars['Float']>;
  /** subscribeFailureCount_gt */
  subscribeFailureCount_gt?: Maybe<Scalars['Float']>;
  /** subscribeFailureCount_isnull */
  subscribeFailureCount_isnull?: Maybe<Scalars['Boolean']>;
  /** subscribeFailureCount_iendswith */
  subscribeFailureCount_iendswith?: Maybe<Scalars['Float']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** errorMessage_search */
  errorMessage_search?: Maybe<Scalars['String']>;
  /** errorMessage_gte */
  errorMessage_gte?: Maybe<Scalars['String']>;
  /** errorMessage_lte */
  errorMessage_lte?: Maybe<Scalars['String']>;
  /** errorMessage_istartswith */
  errorMessage_istartswith?: Maybe<Scalars['String']>;
  /** errorMessage_lt */
  errorMessage_lt?: Maybe<Scalars['String']>;
  /** errorMessage_gt */
  errorMessage_gt?: Maybe<Scalars['String']>;
  /** errorMessage_isnull */
  errorMessage_isnull?: Maybe<Scalars['Boolean']>;
  /** errorMessage_iendswith */
  errorMessage_iendswith?: Maybe<Scalars['String']>;
  notificationType?: Maybe<Scalars['String']>;
  /** notificationType_search */
  notificationType_search?: Maybe<Scalars['String']>;
  /** notificationType_gte */
  notificationType_gte?: Maybe<Scalars['String']>;
  /** notificationType_lte */
  notificationType_lte?: Maybe<Scalars['String']>;
  /** notificationType_istartswith */
  notificationType_istartswith?: Maybe<Scalars['String']>;
  /** notificationType_lt */
  notificationType_lt?: Maybe<Scalars['String']>;
  /** notificationType_gt */
  notificationType_gt?: Maybe<Scalars['String']>;
  /** notificationType_isnull */
  notificationType_isnull?: Maybe<Scalars['Boolean']>;
  /** notificationType_iendswith */
  notificationType_iendswith?: Maybe<Scalars['String']>;
  isSilent?: Maybe<Scalars['Boolean']>;
  /** isSilent_gte */
  isSilent_gte?: Maybe<Scalars['Boolean']>;
  /** isSilent_lte */
  isSilent_lte?: Maybe<Scalars['Boolean']>;
  /** isSilent_istartswith */
  isSilent_istartswith?: Maybe<Scalars['Boolean']>;
  /** isSilent_lt */
  isSilent_lt?: Maybe<Scalars['Boolean']>;
  /** isSilent_gt */
  isSilent_gt?: Maybe<Scalars['Boolean']>;
  /** isSilent_isnull */
  isSilent_isnull?: Maybe<Scalars['Boolean']>;
  /** isSilent_iendswith */
  isSilent_iendswith?: Maybe<Scalars['Boolean']>;
  sendType?: Maybe<Scalars['String']>;
  /** sendType_search */
  sendType_search?: Maybe<Scalars['String']>;
  /** sendType_gte */
  sendType_gte?: Maybe<Scalars['String']>;
  /** sendType_lte */
  sendType_lte?: Maybe<Scalars['String']>;
  /** sendType_istartswith */
  sendType_istartswith?: Maybe<Scalars['String']>;
  /** sendType_lt */
  sendType_lt?: Maybe<Scalars['String']>;
  /** sendType_gt */
  sendType_gt?: Maybe<Scalars['String']>;
  /** sendType_isnull */
  sendType_isnull?: Maybe<Scalars['Boolean']>;
  /** sendType_iendswith */
  sendType_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use tokens ids to filter Notification by tokens. */
  tokens_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  message_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  sendPushNotification_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  sendTextMessage_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  status_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  subscribeSuccessCount_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  subscribeFailureCount_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  errorMessage_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  notificationType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isSilent_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  sendType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NotificationRecipient = {
  __typename?: 'NotificationRecipient';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  recipient?: Maybe<StintUser>;
  notification?: Maybe<Notification>;
  sentAt?: Maybe<Scalars['DateTime']>;
  openedAt?: Maybe<Scalars['Date']>;
  /** ID of the related notification */
  notification_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  recipient_id?: Maybe<Scalars['UUID']>;
};

export enum NotificationSendType {
  /** Send Push Notification */
  SEND_PUSH_NOTIFICATION = 'SEND_PUSH_NOTIFICATION',
  /** Send Text Message */
  SEND_TEXT_MESSAGE = 'SEND_TEXT_MESSAGE',
}

export enum NotificationStatus {
  /** Pending */
  PENDING = 'PENDING',
  /** Failed */
  FAILED = 'FAILED',
  /** Partially Sent */
  PARTIALLY_SENT = 'PARTIALLY_SENT',
  /** Sent */
  SENT = 'SENT',
}

/** Obtain JSON Web Token mutation */
export type ObtainJSONWebToken = {
  __typename?: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

/**
 * The OffenceType class defines the Graphene ObjectType class used to resolve the Offence
 * model data for GraphQL queries that are only accessible by Staff users.
 *
 * It inherits the common fields from BaseOffenceType and then adds additional
 * fields that only Staff users are allowed to access.
 *
 * It has a UUIDNode interface so that list queries can use relay pagination.
 */
export type Offence = Node & {
  __typename?: 'Offence';
  /** The ID of the Offence. */
  id: Scalars['UUID'];
  /** The datetime value that is automatically captured when a new record is added to the database. */
  createdAt: Scalars['DateTime'];
  /** The OffenceReason value that indicates the reason for the Offence. The reason value can include legacy OffenceReason values that cannot be used when creating a new Offence object. */
  reason: OffenceReason;
  /** The number of strikes that the Offence adds to or the redemption removes from the Stinter profile. */
  strikesAwarded: Scalars['Int'];
  /** The related Stint object. */
  stint?: Maybe<Stint>;
  /** The internal user that manually created the Offence. */
  createdBy?: Maybe<StintUser>;
  /** The OffenceAppealStatus value that indicates the current appeal status for the Offence. */
  appealStatus: OffenceAppealStatus;
  /** The related Business object. */
  business?: Maybe<Business>;
  /** Whether or not the Offence is a redemption. */
  isRedemption: Scalars['Boolean'];
  /** The list of related Appeal objects. */
  appeals: Array<Appeal>;
};

/** The TextChoices for the Offence.appeal_status field. */
export enum OffenceAppealStatus {
  NOT_APPEALED = 'NOT_APPEALED',
  PENDING = 'PENDING',
  UNSUCCESSFUL = 'UNSUCCESSFUL',
  SUCCESSFUL = 'SUCCESSFUL',
}

/**
 * The TextChoices for the Offence.reason field that includes the legacy OffenceReason choices along with the
 *     current valid OffenceReason choices.
 *
 *     The additional legacy OffenceReason choices are only used for the initial migrated data and are not valid choices
 *     for newly created Offence objects.
 */
export enum OffenceReason {
  LEAVING_EARLY = 'LEAVING_EARLY',
  LATENESS = 'LATENESS',
  UNIFORM = 'UNIFORM',
  CANCELLATION_THRESHOLD_1_V2 = 'CANCELLATION_THRESHOLD_1_V2',
  CANCELLATION_THRESHOLD_2_V2 = 'CANCELLATION_THRESHOLD_2_V2',
  CANCELLATION_THRESHOLD_3_V2 = 'CANCELLATION_THRESHOLD_3_V2',
  TEAM_CANCELATION_THREE_STRIKES = 'TEAM_CANCELATION_THREE_STRIKES',
  NO_SHOW = 'NO_SHOW',
  NO_CONFIRMATION = 'NO_CONFIRMATION',
  UNRESPONSIVE_STANDBY = 'UNRESPONSIVE_STANDBY',
  GROSS_MISCONDUCT = 'GROSS_MISCONDUCT',
  PERFORMANCE = 'PERFORMANCE',
  PERFORMANCE_SENT_HOME = 'PERFORMANCE_SENT_HOME',
  UNAUTHORISED_DEPARTURE = 'UNAUTHORISED_DEPARTURE',
  ONE_STRIKE_REDEEMED = 'ONE_STRIKE_REDEEMED',
  TWO_STRIKE_REDEEMED = 'TWO_STRIKE_REDEEMED',
  THREE_STRIKE_REDEEMED = 'THREE_STRIKE_REDEEMED',
  ONE_LEGACY_STRIKE = 'ONE_LEGACY_STRIKE',
  TWO_LEGACY_STRIKES = 'TWO_LEGACY_STRIKES',
  THREE_LEGACY_STRIKES = 'THREE_LEGACY_STRIKES',
  LEGACY_CANCELLATION = 'LEGACY_CANCELLATION',
  CANCELLATION_THRESHOLD_1 = 'CANCELLATION_THRESHOLD_1',
  CANCELLATION_THRESHOLD_2 = 'CANCELLATION_THRESHOLD_2',
  CANCELLATION_THRESHOLD_3 = 'CANCELLATION_THRESHOLD_3',
}

export type OffenceTypeConnection = {
  __typename?: 'OffenceTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<OffenceTypeEdge>;
};

export type OffenceTypeEdge = {
  __typename?: 'OffenceTypeEdge';
  /** The item at the end of the edge */
  node: Offence;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum OfferSeenType {
  STINT_OFFER_SCREEN_OFFER_SEEN = 'STINT_OFFER_SCREEN_OFFER_SEEN',
  STINT_DASHBOARD_OFFER_SEEN = 'STINT_DASHBOARD_OFFER_SEEN',
  STINT_OFFER_SCREEN_OFFER_VIEWED = 'STINT_OFFER_SCREEN_OFFER_VIEWED',
  STINT_DASHBOARD_OFFER_VIEWED = 'STINT_DASHBOARD_OFFER_VIEWED',
}

/** The on-cost component percentage values for a pay type. */
export type OnCostComponents = {
  __typename?: 'OnCostComponents';
  /** The national insurance contribution as a decimal fraction in the range [0, 1]. For example, 0.138 represents 13.8%. */
  nationalInsurancePercentage: Scalars['Decimal'];
  /** The holiday pay contribution as a decimal fraction in the range [0, 1]. For example, 0.1079 represents 10.79%. */
  holidayPercentage: Scalars['Decimal'];
  /** The pension contribution as a decimal fraction in the range [0, 1]. For example, 0.03 represents 3%. */
  pensionPercentage: Scalars['Decimal'];
  /** Miscellaneous employment cost contribution as a decimal fraction in the range [0, 1]. For example, 0.005 represents 0.5%. */
  otherPercentage: Scalars['Decimal'];
};

/** The required on-cost component percentage values for a pay type. Each field is a decimal fraction in the range [0, 1], and the sum of all four fields must not exceed 1. */
export type OnCostComponentsInput = {
  /** The national insurance contribution as a decimal fraction in the range [0, 1]. For example, 0.138 represents 13.8%. */
  nationalInsurancePercentage: Scalars['Decimal'];
  /** The holiday pay contribution as a decimal fraction in the range [0, 1]. For example, 0.1079 represents 10.79%. */
  holidayPercentage: Scalars['Decimal'];
  /** The pension contribution as a decimal fraction in the range [0, 1]. For example, 0.03 represents 3%. */
  pensionPercentage: Scalars['Decimal'];
  /** Miscellaneous employment cost contribution as a decimal fraction in the range [0, 1]. For example, 0.005 represents 0.5%. */
  otherPercentage: Scalars['Decimal'];
};

/** The types of on-demand pay providers available for partner account settings. */
export enum OnDemandPayProviderType {
  /** Level on-demand pay provider integration. */
  LEVEL = 'LEVEL',
}

/** Configuration settings for on-demand pay integrations. */
export type OnDemandPaySettings = {
  __typename?: 'OnDemandPaySettings';
  /** The type of on-demand pay provider. */
  providerType: OnDemandPayProviderType;
  /** The client's identifier for a specific company. */
  companyId: Scalars['String'];
  /** The api key for the specific company and their on-demand pay provider. */
  apiKey: Scalars['String'];
  /** The secret key for the specific company and their on-demand pay provider. */
  secretKey: Scalars['String'];
};

/** Input for configuring on-demand pay settings. */
export type OnDemandPaySettingsInput = {
  /** The type of on-demand pay provider. */
  providerType: OnDemandPayProviderType;
  /** The client's identifier for a specific company. */
  companyId: Scalars['String'];
  /** The api key for the specific company and their on-demand pay provider. */
  apiKey: Scalars['String'];
  /** The secret key for the specific company and their on-demand pay provider. */
  secretKey: Scalars['String'];
};

/** The input values required to resolve a relay paginated list of open Shifts. */
export type OpenShiftsInput = {
  pagination: PaginationInput;
};

/** The operational area of a PartnerOperationalArea. */
export enum OperationalArea {
  /** The back of house operational area. */
  BACK_OF_HOUSE = 'BACK_OF_HOUSE',
  /** The front of house operational area. */
  FRONT_OF_HOUSE = 'FRONT_OF_HOUSE',
  /** The operational area of a PartnerOperationalArea. */
  BAR = 'BAR',
}

/** Represents that a recurring operational event is required for the Site. */
export type OperationalEvent = {
  __typename?: 'OperationalEvent';
  /** The ID of the operational event. */
  id: Scalars['UUID'];
  /** The name of the operational event. */
  name: Scalars['String'];
  /** The day of the week that this event is expected to occur on. */
  dayOfWeek: WeekDay;
  /** The time of day the operational event starts, represented by ISO 8601 format (HH:MM:SS). Timezone will be ignored. */
  startTime: Scalars['String'];
  /** The time of day the operational event ends, represented by ISO 8601 format (HH:MM:SS). Timezone will be ignored. */
  endTime: Scalars['String'];
};

/** The bulk acceptance action to apply to headcount opportunities. */
export enum OpportunitiesAccepted {
  /** Run the auto-scheduler with exactly the recommended headcount opportunities accepted. */
  RECOMMENDED = 'RECOMMENDED',
  /** Run the auto-scheduler after resetting all accepted headcount opportunities. */
  CLEAR = 'CLEAR',
}

/** The explanation of why an Invest opportunity was raised, with its service signals. */
export type OpportunityExplanation = {
  __typename?: 'OpportunityExplanation';
  /** The workload per head for the opportunity window, as a decimal string. */
  workloadPerHead: Scalars['String'];
  /** The baseline workload per head, as a decimal string. */
  baselinePerHead: Scalars['String'];
  /** How far the workload per head exceeds the baseline, as a decimal percentage string. */
  percentOverBaseline: Scalars['String'];
  /** The service signals metric backing this explanation. */
  serviceSignals: Array<ServiceSignal>;
};

/** A OtherShiftsToday represents a shift in a SiteSchedule that occurs on the same day as a shift.Alongside with info about the partner member who is assigned to the shift. */
export type OtherShiftToday = {
  __typename?: 'OtherShiftToday';
  /** The unique identifier of the Shift in the SiteSchedule. */
  id: Scalars['UUID'];
  /** The start time of the shift. */
  startTime: Scalars['DateTime'];
  /** The end time of the shift. */
  endTime: Scalars['DateTime'];
  /** The full name of the partner member that is assigned to the shift. */
  partnerMemberFullName: Scalars['String'];
  /** The preferred name of the partner member that is assigned to the shift. */
  partnerMemberPreferredName?: Maybe<Scalars['String']>;
  /** The role configuration for the shift. */
  role: RoleConfiguration;
};

/** Represents an out-of-term request made by or on behalf of a Stinter. */
export type OutOfTermRequest = {
  __typename?: 'OutOfTermRequest';
  /** The ID of the out-of-term request. */
  id: Scalars['UUID'];
  /** The start date of the out-of-term period. */
  startDate: Scalars['Date'];
  /** The end date of the out-of-term period. */
  endDate: Scalars['Date'];
  /** The current status of the out-of-term request. */
  status: OutOfTermRequestStatus;
  /** The ID of the supporting document for the out-of-term request. The ID refers to the unique identifier of the monolith Document object that holds the S3 key. */
  supportingDocumentId?: Maybe<Scalars['UUID']>;
};

/** Enum for the status of an out-of-term request. */
export enum OutOfTermRequestStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

export type PageInfoType = {
  __typename?: 'PageInfoType';
  page?: Maybe<Scalars['Int']>;
  pages?: Maybe<Scalars['Int']>;
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrev?: Maybe<Scalars['Boolean']>;
  totalObjects?: Maybe<Scalars['Int']>;
};

/**
 * The PaginatedPartnerNodeType class is used to expose the PartnerNodeType object as a
 * paginated list.
 *
 * This type class is exposed to the GraphQL graph via a PaginatedField on a Query class.
 */
export type PaginatedPartnerNode = {
  __typename?: 'PaginatedPartnerNode';
  /** Pagination information for the response. */
  paginationInfo: PaginationInfo;
  /** Contains the objects for the current page. */
  objects?: Maybe<Array<Maybe<PartnerNode>>>;
};

/** The PaginationInfo class is used to expose the pagination data for a list query. */
export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  /** The current page included in the objects. */
  page: Scalars['Int'];
  /** The total number of pages available. */
  pages: Scalars['Int'];
  /** Whether or not there is a next page to request. */
  hasNext: Scalars['Boolean'];
  /** Whether or not there is a previous page to request. */
  hasPrev: Scalars['Boolean'];
  /** The total number of objects across all the pages. If this is requested then an additional count will be performed on the database. This should be avoided if not needed. */
  totalObjects?: Maybe<Scalars['Int']>;
};

/** Input fields for relay-style pagination. */
export type PaginationInput = {
  /** Number of items to return. Defaults to 10 if not specified. */
  first?: Maybe<Scalars['Int']>;
  /** Cursor to start pagination from. Defaults to the start if not specified. */
  after?: Maybe<Scalars['String']>;
};

/** An API token scoped to a partner account for programmatic access. */
export type PartnerAccountAPIToken = {
  __typename?: 'PartnerAccountAPIToken';
  /** The ID of the token. */
  id: Scalars['UUID'];
  /** When the token was created. */
  createdAt: Scalars['DateTime'];
  /** A human-readable label for the token. */
  name: Scalars['String'];
  /** The list of scopes granted to this token. */
  scopes: Array<PartnerAccountAPITokenScope>;
  /** The last 6 characters of the plaintext token, used for identification. */
  tokenSuffix: Scalars['String'];
  /** The staff user who created the token. */
  createdBy: StintUser;
  /** When the token was revoked. Null means active. */
  revokedAt?: Maybe<Scalars['DateTime']>;
  /** The staff user who revoked the token. */
  revokedBy?: Maybe<StintUser>;
};

/** Scopes that can be granted to a partner account API token. */
export enum PartnerAccountAPITokenScope {
  READ_SITES = 'READ_SITES',
  READ_ROLES = 'READ_ROLES',
  READ_SHIFTS = 'READ_SHIFTS',
  READ_SHIFT_EMPLOYEES = 'READ_SHIFT_EMPLOYEES',
  READ_STINTERS = 'READ_STINTERS',
  READ_STINTS = 'READ_STINTS',
  CREATE_EMPLOYEES = 'CREATE_EMPLOYEES',
  READ_EMPLOYEES = 'READ_EMPLOYEES',
  READ_JOB_TITLES = 'READ_JOB_TITLES',
}

/**
 * The PartnerAccountEmployeesFilterInput type defines the input values for
 * filtering a list of employees for the Partner Account.
 */
export type PartnerAccountEmployeesFilterInput = {
  /** The exact email address to filter by. */
  emailExact?: Maybe<Scalars['String']>;
  /** The exact National Insurance number to filter by. */
  nationalInsuranceExact?: Maybe<Scalars['String']>;
  /** A search term to filter the results by. If not specified, all results will be returned. Cannot be used in conjunction with other filters. */
  searchTerm?: Maybe<Scalars['String']>;
  /** The ID of the site to get employees from. If not specified, employees from the whole account will be returned. */
  siteId?: Maybe<Scalars['UUID']>;
  /** Whether to include members who are not assigned to any partner nodes. If not specified, the default behavior will be used based on user role and permissions. */
  includeUnassignedMembers?: Maybe<Scalars['Boolean']>;
  /** Whether to include people who do a role that does not appear on a rota. Defaults to true, which filters for employees of all roles. */
  includeNonRotableMembers?: Maybe<Scalars['Boolean']>;
  /** A filter that only includes employees with the specified employment statuses i.e. it is an `AND` operation, not an `OR` operation like the other filters in the input. If not given, employee's of all employment statuses will be returned. */
  employmentStatusIn?: Maybe<Array<Maybe<EmployeeEmploymentStatus>>>;
  /** Filters employees whose primary site matches any of the provided PartnerNode IDs. This filter is applied in conjunction with other filters (AND logic). */
  primarySiteIdIn?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Filters employees whose role matches any of the provided role IDs. This filter is applied in conjunction with other filters (AND logic). */
  roleIdIn?: Maybe<Array<Scalars['UUID']>>;
  /** Filters employees with a partner member that works within any of the operational areas provided in the list. This filter is applied in conjunction with other filters (AND logic). */
  operationalAreaIn?: Maybe<Array<Maybe<OperationalArea>>>;
};

/**
 * The PartnerAccountEmployeesInput type defines the input values that are required
 * from the client for fetching a list of employees for the Partner Account.
 */
export type PartnerAccountEmployeesInput = {
  /** The ID of the Partner Account to which the employees belong. */
  partnerAccountId: Scalars['UUID'];
  /** The filtering criteria for the list of PartnerMemberProfiles. If exact filters are provided, the employees will be included if they match at least one of the filters. */
  filterInput?: Maybe<PartnerAccountEmployeesFilterInput>;
};

/** A PartnerAccountProfile represents the top level Account PartnerNode for a Partner tree. */
export type PartnerAccountProfile = {
  __typename?: 'PartnerAccountProfile';
  /** The ID of the PartnerNode. */
  id: Scalars['UUID'];
  /** The display name that is given to the node. */
  name: Scalars['String'];
  /** The NodeType value that indicates the type of PartnerNode that is being returned. */
  nodeType: NodeType;
  /** The related PartnerBrand object if it exists. */
  partnerBrand?: Maybe<PartnerBrand>;
  /** The list of PartnerMember objects that are members of the PartnerNode. */
  partnerMembers: Array<PartnerMember>;
  /** The EMPLOYEE_DISCLAIMER Agreement for this Node. This can be null, as the Agreement may have not been created. */
  employeeDisclaimer?: Maybe<Agreement>;
  /**
   * Retrieves a relay paginated list of StintTemplate objects for the PartnerNode and all its descendants,
   * filtered and ordered by the specified criteria.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a Staff user.
   */
  stintTemplates: StintTemplateTypeConnection;
  /** The related CompaniesHouseInformation object. */
  companiesHouseInformation: CompaniesHouseInformation;
  /** The partner account settings for this account. */
  settings: PartnerAccountSettings;
  /** The list of non-service shift types enabled for this partner account. */
  nonServiceShiftTypes: Array<NonServiceShiftType>;
  /**
   * Retrieves the list of StintTemplateGroup objects for the PartnerNode.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a Staff user.
   */
  stintTemplateGroups: Array<StintTemplateGroup>;
  /**
   * The list of PartnerPermission values that the Employer has for the NodeType.ACCOUNT PartnerNode.
   *             If it is resolved from STAFF side it will return the full list of permissions.
   */
  partnerPermissions: Array<Maybe<PartnerPermission>>;
  /** A list of holiday policies attached to the account. */
  holidayPolicies: Array<EmployerHolidayPolicy>;
  /**
   * Reporting data for an account to be used within the reporting app.
   * At the time of implementing, this is a simple proxy to data stored in an S3
   * bucket that adds authorization around the request.
   * The response is a string of json data which is expected to be unpacked by the reporting app
   * and used however they like.
   * The reason for this is that it means that the shape of the data can be changed, and providing
   * it is stored under the expected object keys, no changes to this api will be required.
   */
  reportingData: ReportingDataOutput;
  /** The selectable partner roles for this partner account node. */
  partnerRoles: Array<PartnerRole>;
  /** The list of role configurations for this partner account. */
  roleConfigurations: Array<RoleConfiguration>;
  /** The list of custom break rules for this partner account. */
  breakRules: Array<BreakRule>;
  /** The API tokens issued for this partner account. */
  apiTokens: Array<PartnerAccountAPIToken>;
  /** The third-party provider integrations configured for this partner account. */
  integrations: Array<PartnerIntegration>;
  /** A single third-party provider integration for this partner account, by id. */
  integration: PartnerIntegration;
  /** The webhook integration data for this partner account. */
  webhooks: PartnerAccountWebhooks;
  /** The list of job titles for this partner account. */
  partnerJobTitles: Array<PartnerJobTitleType>;
  /** The list of departments for this partner account. */
  departments: Array<PartnerDepartmentType>;
  /** The list of bulk employee uploads for this partner account, newest first. Only STAFF users are authorised to resolve this field. */
  bulkEmployeeUploads: Array<BulkEmployeeUpload>;
};

/** A PartnerAccountProfile represents the top level Account PartnerNode for a Partner tree. */
export type PartnerAccountProfilepartnerMembersArgs = {
  input?: Maybe<GetPartnerMembersInput>;
};

/** A PartnerAccountProfile represents the top level Account PartnerNode for a Partner tree. */
export type PartnerAccountProfilestintTemplatesArgs = {
  input: GetStintTemplatesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A PartnerAccountProfile represents the top level Account PartnerNode for a Partner tree. */
export type PartnerAccountProfilereportingDataArgs = {
  input: ReportingDataInput;
};

/** A PartnerAccountProfile represents the top level Account PartnerNode for a Partner tree. */
export type PartnerAccountProfileintegrationArgs = {
  id: Scalars['UUID'];
};

/** A PartnerAccountProfile represents the top level Account PartnerNode for a Partner tree. */
export type PartnerAccountProfilepartnerJobTitlesArgs = {
  includeArchived?: Maybe<Scalars['Boolean']>;
};

/** Configuration settings for a partner account. */
export type PartnerAccountSettings = {
  __typename?: 'PartnerAccountSettings';
  /** The ID of the PartnerAccountSettings. */
  id: Scalars['UUID'];
  /** Indicates whether payroll functionality is enabled for this account. */
  payrollEnabled: Scalars['Boolean'];
  /** Whether or not the account has core team management as read only. */
  coreTeamManagementReadOnly: Scalars['Boolean'];
  /** Whether or not the cleaner role is an available role for this partner account. */
  displayCleanerRole: Scalars['Boolean'];
  /** Whether or not the partner account has the performance notes feature enabled. */
  performanceNotesEnabled: Scalars['Boolean'];
  /** Whether or not managers outside of an employee's reporting line can view their profile. */
  restrictProfileVisibilityToReports: Scalars['Boolean'];
  /** Whether managers can view the Employment tab for employees in their management line. */
  managerCanSeeEmploymentTabInformation: Scalars['Boolean'];
  /** Whether or not the partner account has the employee shift reviews feature enabled. */
  employeeShiftReviewsEnabled: Scalars['Boolean'];
  /** The ID of the account node associated with these settings. */
  accountNodeId: Scalars['UUID'];
  /** The labour feature settings values for a Partner. */
  labourSettings: LabourSettings;
  /** The payment provider configuration settings (optional). */
  paymentProviderSettings?: Maybe<PaymentProviderSettings>;
  /** The on-demand pay configuration settings (optional). */
  onDemandPaySettings?: Maybe<OnDemandPaySettings>;
  /** Whether the webhooks are enabled for this partner account. */
  webhooksEnabled: Scalars['Boolean'];
  /** The HR partner account settings values for a Partner. */
  hrPartnerAccountSettings?: Maybe<HRPartnerAccountSettings>;
  /** The right-to-work settings for the partner account, which dictate the availability of right-to-work functionality for the partner. */
  rightToWorkSettings: RightToWorkSettings;
};

/** A paginated connection for webhook records for a partner account. */
export type PartnerAccountWebhookRecordsConnection = {
  __typename?: 'PartnerAccountWebhookRecordsConnection';
  /** Pagination metadata used to navigate through the list of webhook records. */
  pageInfo: PageInfo;
  /** A list of webhook records in the current page, ordered newest first. */
  items: Array<PartnerWebhookType>;
};

/** Input fields for querying webhook records with pagination. */
export type PartnerAccountWebhookRecordsInput = {
  /** Pagination parameters for the webhook records list. */
  pagination: PaginationInput;
};

/** The webhook integration data for a partner account. */
export type PartnerAccountWebhooks = {
  __typename?: 'PartnerAccountWebhooks';
  /** The webhook configuration for the partner account. If no configuration is set, the field will be null. */
  config?: Maybe<PartnerAccountWebhooksConfig>;
  /** Paginated list of sent webhook records, sorted by newest first */
  records: PartnerAccountWebhookRecordsConnection;
  /** Retrieves a single webhook record by id. Returns null if the webhook was not found. */
  record?: Maybe<PartnerWebhookType>;
};

/** The webhook integration data for a partner account. */
export type PartnerAccountWebhooksrecordsArgs = {
  input: PartnerAccountWebhookRecordsInput;
};

/** The webhook integration data for a partner account. */
export type PartnerAccountWebhooksrecordArgs = {
  id: Scalars['UUID'];
};

/** The webhook configuration settings for a partner account. */
export type PartnerAccountWebhooksConfig = {
  __typename?: 'PartnerAccountWebhooksConfig';
  /** Whether the webhook is currently active for the partner account. Any events consumed while the webhook is inactive will be ignored. */
  active: Scalars['Boolean'];
  /** The endpoint that the webhook will send data to. */
  endpoint: Scalars['String'];
  /** The generated auth token for the webhook configuration. Displayed to the user so they can use for authentication in their consumer application. */
  authToken: Scalars['String'];
};

/**
 * The PartnerBrandType class defines the Graphene ObjectType class used to resolve the PartnerBrand model data for
 * GraphQL queries.
 */
export type PartnerBrand = {
  __typename?: 'PartnerBrand';
  /** The ID of the PartnerBrand. */
  id: Scalars['UUID'];
  /** The url value to be used to retrieve the PartnerBrand logo image. */
  logoUrl: Scalars['String'];
  /** The ID of the related primary PartnerNode that the ParnterBrand directly belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
};

/** Enum that contains the available error message codes that can be used to raise errors related to PartnerBrand. */
export enum PartnerBrandError {
  DUPLICATE_PARTNER_NODE_ID = 'DUPLICATE_PARTNER_NODE_ID',
  PARTNER_NODE_ALREADY_HAS_PARTNER_BRAND = 'PARTNER_NODE_ALREADY_HAS_PARTNER_BRAND',
}

/**
 * The PartnerBrandInput class defines the input values that are required from
 * the client in order to create a PartnerBrand object.
 */
export type PartnerBrandInput = {
  /** The PartnerBrand logo image base64 value. */
  logoBase64: Scalars['String'];
};

/** The budget set by the partner for a given forecast date. */
export type PartnerBudget = {
  __typename?: 'PartnerBudget';
  /** The sales budget for this forecast date at the Site. This will be null when no budget has been set for this date. */
  sales?: Maybe<Scalars['Decimal']>;
  /** The budgeted labour hours for the day. Null if no labour hours were ingested. */
  labourHours?: Maybe<Scalars['Decimal']>;
  /** The budgeted labour as a percentage of the budgeted sales. Null if no percentage was ingested. */
  labourPercentage?: Maybe<Scalars['Decimal']>;
  /** The budgeted labour cost for the day. Null if no cost was ingested. */
  labourCost?: Maybe<Scalars['Decimal']>;
};

/**
 * The PartnerContactType class defines the Graphene ObjectType class used to resolve the
 * PartnerContact model data for GraphQL queries.
 */
export type PartnerContact = {
  __typename?: 'PartnerContact';
  /** The id of the PartnerContact. */
  id: Scalars['UUID'];
  /** The primary phone number to be used for contacting the PartnerNode. */
  primaryPhoneNumber: Scalars['String'];
  /** An optional list of secondary phone numbers to be used for contacting the PartnerNode. */
  secondaryPhoneNumbers: Array<Scalars['String']>;
  /** An optional list of email addresses to be used for contacting the PartnerNode. */
  emailAddresses: Array<Scalars['String']>;
};

/**
 * Enum that contains the available error message codes that can be used to raise errors related to
 *     PartnerContact.
 */
export enum PartnerContactError {
  DUPLICATE_PARTNER_NODE_ID = 'DUPLICATE_PARTNER_NODE_ID',
  INVALID_EMAIL_ADDRESSES = 'INVALID_EMAIL_ADDRESSES',
  INVALID_PRIMARY_PHONE_NUMBER = 'INVALID_PRIMARY_PHONE_NUMBER',
  INVALID_SECONDARY_PHONE_NUMBERS = 'INVALID_SECONDARY_PHONE_NUMBERS',
}

/**
 * The PartnerContactInput class defines the input values that are required from
 * the client in order to create a PartnerContact object.
 */
export type PartnerContactInput = {
  /** The primary phone number to be used for contacting the PartnerNode. */
  primaryPhoneNumber: Scalars['String'];
  /** An optional list of secondary phone numbers to be used for contacting the PartnerNode. */
  secondaryPhoneNumbers: Array<Scalars['String']>;
  /** An optional list of email addresses to be used for contacting the PartnerNode. */
  emailAddresses: Array<Scalars['String']>;
};

/** GraphQL type for representing a partner department. */
export type PartnerDepartmentType = {
  __typename?: 'PartnerDepartmentType';
  /** The unique identifier of the department. */
  id: Scalars['ID'];
  /** The name of the department. */
  name: Scalars['String'];
};

/**
 * The PartnerFileUploadType defines the Enum values representing the types of files that can be uploaded
 *     by a partner.
 *
 *     When initiating a document upload, the frontend is expected to pass one of these values in, so that
 *     the backend is aware what type of document this constitutes.
 *
 *     At present, the intention is to allow for better organisation of the documents, however in future,
 *     this implementation allows for the flexibility for us to build additional business logic around the
 *     type of document being uploaded.
 */
export enum PartnerFileUploadType {
  EMPLOYEE_DISCLAIMER = 'EMPLOYEE_DISCLAIMER',
  EMPLOYEE_DOCUMENT = 'EMPLOYEE_DOCUMENT',
}

/**
 * The PartnerFinanceDetails class defines the Graphene ObjectType class used to resolve information
 * about a Site's finance details.
 */
export type PartnerFinanceDetails = {
  __typename?: 'PartnerFinanceDetails';
  /** The current payment method that the Site is using. */
  paymentMethod?: Maybe<PaymentMethod>;
  /** Whether or not the Site has been blocked by finance. */
  isBlockedByFinance: Scalars['Boolean'];
  /** The rates that a Site will pay for Stints. */
  rates: SiteRates;
  /** The active StripeCard if the Site has one. */
  activeCard?: Maybe<StripeCard>;
  /** The active StripeDebit if the Site has one. */
  activeDebit?: Maybe<StripeDebit>;
};

/** A PartnerGroupProfile represents a Group PartnerNode in a Partner tree. */
export type PartnerGroupProfile = {
  __typename?: 'PartnerGroupProfile';
  /** The ID of the PartnerNode. */
  id: Scalars['UUID'];
  /** The display name that is given to the node. */
  name: Scalars['String'];
  /** The NodeType value that indicates the type of PartnerNode that is being returned. */
  nodeType: NodeType;
  /** The related PartnerBrand object if it exists. */
  partnerBrand?: Maybe<PartnerBrand>;
  /** The list of PartnerMember objects that are members of the PartnerNode. */
  partnerMembers: Array<PartnerMember>;
  /** The EMPLOYEE_DISCLAIMER Agreement for this Node. This can be null, as the Agreement may have not been created. */
  employeeDisclaimer?: Maybe<Agreement>;
  /**
   * Retrieves a relay paginated list of StintTemplate objects for the PartnerNode and all its descendants,
   * filtered and ordered by the specified criteria.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a Staff user.
   */
  stintTemplates: StintTemplateTypeConnection;
  /** The ID of the parent PartnerNode. */
  parentId: Scalars['UUID'];
  /** The related CompaniesHouseInformation object if it exists. */
  companiesHouseInformation?: Maybe<CompaniesHouseInformation>;
  /** The ID of the Account PartnerNode associated with this Group PartnerNode. */
  accountNodeId: Scalars['UUID'];
};

/** A PartnerGroupProfile represents a Group PartnerNode in a Partner tree. */
export type PartnerGroupProfilepartnerMembersArgs = {
  input?: Maybe<GetPartnerMembersInput>;
};

/** A PartnerGroupProfile represents a Group PartnerNode in a Partner tree. */
export type PartnerGroupProfilestintTemplatesArgs = {
  input: GetStintTemplatesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** An integration between a partner account and a third-party provider. */
export type PartnerIntegration = {
  __typename?: 'PartnerIntegration';
  /** The unique identifier for this integration. */
  id: Scalars['UUID'];
  /** The third-party provider this integration connects to. */
  provider: PartnerIntegrationProvider;
  /** Whether this integration is currently active. */
  active: Scalars['Boolean'];
  /** Provider-hosted URL the partner uses to sign employees in to the third-party UI. Null when the provider does not offer SSO or it has not been configured yet. */
  ssoUrl?: Maybe<Scalars['String']>;
  /** OAuth2 auth configuration. Null when auth is not configured or a different scheme is in use. */
  authOAuth?: Maybe<PartnerIntegrationAuthOAuth>;
  /** SFTP auth configuration. Null when auth is not configured or a different scheme is in use. */
  authSftp?: Maybe<PartnerIntegrationAuthSftp>;
  /** API key auth configuration. Null when auth is not configured or a different scheme is in use. */
  authApiKey?: Maybe<PartnerIntegrationAuthApiKey>;
  /** HTTP Basic auth configuration. Null when auth is not configured or a different scheme is in use. */
  authBasic?: Maybe<PartnerIntegrationAuthBasic>;
  /** Password-exchange auth configuration. Null when auth is not configured or a different scheme is in use. */
  authPasswordExchange?: Maybe<PartnerIntegrationAuthPasswordExchange>;
  /** External site identifiers mapped to Stint sites. */
  siteMappings: PartnerIntegrationSiteMappingConnection;
  /** External role identifiers mapped to Stint role configurations. */
  roleMappings: PartnerIntegrationRoleMappingConnection;
  /** External job title identifiers mapped to Stint job titles. */
  jobTitleMappings: PartnerIntegrationJobTitleMappingConnection;
  /** External profile identifiers mapped to Stint partner member profiles. */
  profileMappings: PartnerIntegrationProfileMappingConnection;
};

/** An integration between a partner account and a third-party provider. */
export type PartnerIntegrationsiteMappingsArgs = {
  input: PartnerIntegrationSiteMappingsInput;
};

/** An integration between a partner account and a third-party provider. */
export type PartnerIntegrationroleMappingsArgs = {
  input: PartnerIntegrationRoleMappingsInput;
};

/** An integration between a partner account and a third-party provider. */
export type PartnerIntegrationjobTitleMappingsArgs = {
  input: PartnerIntegrationJobTitleMappingsInput;
};

/** An integration between a partner account and a third-party provider. */
export type PartnerIntegrationprofileMappingsArgs = {
  input: PartnerIntegrationProfileMappingsInput;
};

/** API key auth configuration for a partner integration. */
export type PartnerIntegrationAuthApiKey = {
  __typename?: 'PartnerIntegrationAuthApiKey';
  /** The API key is write-only and never returned. This field signals that API key auth is configured. */
  configured: Scalars['Boolean'];
};

/** API key credentials sent as a static HTTP header on every request. */
export type PartnerIntegrationAuthApiKeyInput = {
  /** Encrypted on write, never returned. */
  apiKey: Scalars['String'];
};

/** HTTP Basic auth configuration for a partner integration. Password is never returned. */
export type PartnerIntegrationAuthBasic = {
  __typename?: 'PartnerIntegrationAuthBasic';
  /** Username sent in the Basic auth header. */
  username: Scalars['String'];
};

/** HTTP Basic Auth credentials sent on every request. */
export type PartnerIntegrationAuthBasicInput = {
  /** Username to send in the Basic auth header. */
  username: Scalars['String'];
  /** Encrypted on write, never returned. */
  password: Scalars['String'];
};

/** OAuth2 client-credentials auth configuration for a partner integration. Secrets are never returned. */
export type PartnerIntegrationAuthOAuth = {
  __typename?: 'PartnerIntegrationAuthOAuth';
  /** OAuth2 token endpoint URL. */
  tokenUrl: Scalars['String'];
  /** OAuth2 scopes to request, space-delimited per RFC 6749 §3.3. */
  scopes: Scalars['String'];
  /** Public client identifier issued by the provider. */
  clientId: Scalars['String'];
};

/** OAuth2 client credentials for backend-to-provider API authentication. */
export type PartnerIntegrationAuthOAuthInput = {
  /** OAuth2 token endpoint. */
  tokenUrl: Scalars['String'];
  /** OAuth2 scopes to request, space-delimited per RFC 6749. */
  scopes: Scalars['String'];
  /** Public client identifier issued by the provider. */
  clientId: Scalars['String'];
  /** Encrypted on write, never returned. */
  clientSecret: Scalars['String'];
};

/** Password-exchange auth configuration for a partner integration. Password is never returned. */
export type PartnerIntegrationAuthPasswordExchange = {
  __typename?: 'PartnerIntegrationAuthPasswordExchange';
  /** Login endpoint that exchanges username/password for an access token. */
  loginUrl: Scalars['String'];
  /** Username to authenticate with. */
  username: Scalars['String'];
};

/** Credentials for a login-URL and username/password token exchange. */
export type PartnerIntegrationAuthPasswordExchangeInput = {
  /** Login endpoint that exchanges username/password for an access token. */
  loginUrl: Scalars['String'];
  /** Username to authenticate with. */
  username: Scalars['String'];
  /** Encrypted on write, never returned. */
  password: Scalars['String'];
};

/** SFTP auth configuration for a partner integration. Private key is never returned. */
export type PartnerIntegrationAuthSftp = {
  __typename?: 'PartnerIntegrationAuthSftp';
  /** SFTP server hostname. */
  host: Scalars['String'];
  /** SFTP server TCP port. */
  port: Scalars['Int'];
  /** Username to authenticate with on the SFTP server. */
  username: Scalars['String'];
  /** Directory on the SFTP host where Stint uploads files, e.g. /uploads/stint. */
  remotePath: Scalars['String'];
  /** Backend-generated public key. Hand this to the customer to install on their SFTP server so the backend can authenticate with key-pair auth. */
  publicKey: Scalars['String'];
  /** The SFTP server's own public key — its cryptographic identity. We pin it and verify the server presents it on every connect, preventing a man-in-the-middle from impersonating the server. */
  hostKey: Scalars['String'];
};

/** SFTP credentials for providers that exchange files over SFTP. */
export type PartnerIntegrationAuthSftpInput = {
  /** Hostname or IP address of the SFTP server. */
  host: Scalars['String'];
  /** TCP port of the SFTP server. */
  port: Scalars['Int'];
  /** Username to authenticate with on the SFTP server. */
  username: Scalars['String'];
  /** Remote working directory on the SFTP host. */
  remotePath: Scalars['String'];
  /** The SFTP server's own public key — its cryptographic identity, provided by the operator. We pin it and verify the server presents it on every connect, preventing a man-in-the-middle from impersonating the server. The client key pair is backend-generated; no private key is supplied here. */
  hostKey: Scalars['String'];
};

/** A mapping between a provider's external job title identifier and a Stint job title. */
export type PartnerIntegrationJobTitleMapping = {
  __typename?: 'PartnerIntegrationJobTitleMapping';
  /** The unique identifier for this job title mapping. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the job title. */
  externalId: Scalars['String'];
  /** The mapped Stint job title. Null when the mapping is unresolved. */
  jobTitle?: Maybe<PartnerJobTitleType>;
  /** When this job title mapping was created. */
  createdAt: Scalars['DateTime'];
  /** When this job title mapping was last modified. */
  modifiedAt: Scalars['DateTime'];
};

/** A paginated connection of job title mappings for a partner integration. */
export type PartnerIntegrationJobTitleMappingConnection = {
  __typename?: 'PartnerIntegrationJobTitleMappingConnection';
  /** Pagination metadata used to navigate through the list of job title mappings. */
  pageInfo: PageInfo;
  /** The job title mappings in the current page. */
  items: Array<PartnerIntegrationJobTitleMapping>;
};

/** Input fields for querying an integration's job title mappings with pagination. */
export type PartnerIntegrationJobTitleMappingsInput = {
  /** Pagination parameters for the job title mappings list. */
  pagination: PaginationInput;
};

/** A mapping between a provider's external profile identifier and a Stint profile. */
export type PartnerIntegrationProfileMapping = {
  __typename?: 'PartnerIntegrationProfileMapping';
  /** The unique identifier for this profile mapping. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the profile. */
  externalId: Scalars['String'];
  /** The mapped partner member profile. Null when the mapping is unresolved. */
  profile?: Maybe<PartnerMemberProfile>;
  /** When this profile mapping was created. */
  createdAt: Scalars['DateTime'];
  /** When this profile mapping was last modified. */
  modifiedAt: Scalars['DateTime'];
};

/** A paginated connection of profile mappings for a partner integration. */
export type PartnerIntegrationProfileMappingConnection = {
  __typename?: 'PartnerIntegrationProfileMappingConnection';
  /** Pagination metadata used to navigate through the list of profile mappings. */
  pageInfo: PageInfo;
  /** The profile mappings in the current page. */
  items: Array<PartnerIntegrationProfileMapping>;
};

/** Input fields for querying an integration's profile mappings with pagination. */
export type PartnerIntegrationProfileMappingsInput = {
  /** Pagination parameters for the profile mappings list. */
  pagination: PaginationInput;
};

/** A supported third-party provider. */
export enum PartnerIntegrationProvider {
  /** Mapal OS — hospitality workforce management platform. */
  MAPAL = 'MAPAL',
  /** Each Person — employee recognition and rewards platform. */
  EACHPERSON = 'EACHPERSON',
  /** WorkVivo — employee experience and engagement platform. */
  WORKVIVO = 'WORKVIVO',
  /** Talent Funnel — recruitment and hiring platform. */
  TALENT_FUNNEL = 'TALENT_FUNNEL',
}

/** A mapping between a provider's external role identifier and a Stint role configuration. */
export type PartnerIntegrationRoleMapping = {
  __typename?: 'PartnerIntegrationRoleMapping';
  /** The unique identifier for this role mapping. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the role. */
  externalId: Scalars['String'];
  /** The mapped Stint role configuration. Null when the mapping is unresolved. */
  role?: Maybe<RoleConfiguration>;
  /** When this role mapping was created. */
  createdAt: Scalars['DateTime'];
  /** When this role mapping was last modified. */
  modifiedAt: Scalars['DateTime'];
};

/** A paginated connection of role mappings for a partner integration. */
export type PartnerIntegrationRoleMappingConnection = {
  __typename?: 'PartnerIntegrationRoleMappingConnection';
  /** Pagination metadata used to navigate through the list of role mappings. */
  pageInfo: PageInfo;
  /** The role mappings in the current page. */
  items: Array<PartnerIntegrationRoleMapping>;
};

/** Input fields for querying an integration's role mappings with pagination. */
export type PartnerIntegrationRoleMappingsInput = {
  /** Pagination parameters for the role mappings list. */
  pagination: PaginationInput;
};

/** A mapping between a provider's external site identifier and a Stint site. */
export type PartnerIntegrationSiteMapping = {
  __typename?: 'PartnerIntegrationSiteMapping';
  /** The unique identifier for this site mapping. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the site. */
  externalId: Scalars['String'];
  /** The mapped Stint site. Null when the mapping is unresolved. */
  site?: Maybe<PartnerNode>;
  /** When this site mapping was created. */
  createdAt: Scalars['DateTime'];
  /** When this site mapping was last modified. */
  modifiedAt: Scalars['DateTime'];
};

/** A paginated connection of site mappings for a partner integration. */
export type PartnerIntegrationSiteMappingConnection = {
  __typename?: 'PartnerIntegrationSiteMappingConnection';
  /** Pagination metadata used to navigate through the list of site mappings. */
  pageInfo: PageInfo;
  /** The site mappings in the current page. */
  items: Array<PartnerIntegrationSiteMapping>;
};

/** Input fields for querying an integration's site mappings with pagination. */
export type PartnerIntegrationSiteMappingsInput = {
  /** Pagination parameters for the site mappings list. */
  pagination: PaginationInput;
};

/** GraphQL type for representing a partner job title configuration. */
export type PartnerJobTitleConfigurationType = {
  __typename?: 'PartnerJobTitleConfigurationType';
  /** The unique identifier of the configuration. */
  id: Scalars['UUID'];
  /** The contract type for this configuration. */
  contractType: ContractType;
  /** The current pay rate for the configuration. Null until at least one pay rate has been configured. */
  currentPayRate?: Maybe<PartnerJobTitlePayRateType>;
  /** The pay rates associated with the configuration. */
  payRates: Array<PartnerJobTitlePayRateType>;
  /** The employees who have pay rates that are currently higher than the current pay rate for the job title. */
  increasedPayRateEmployees: Array<PartnerMemberProfile>;
};

/** A partner job title pay rate record. */
export type PartnerJobTitlePayRateType = {
  __typename?: 'PartnerJobTitlePayRateType';
  /** The ID of the job title pay rate. */
  id: Scalars['UUID'];
  /** The date the job title pay rate becomes active. */
  activeFrom: Scalars['Date'];
  /** The minimum pay rate for employees younger than 18. */
  minimumUnder18PayRate?: Maybe<Scalars['Decimal']>;
  /** The minimum pay rate for employees aged 18-20. */
  minimumUnder21PayRate?: Maybe<Scalars['Decimal']>;
  /** The minimum default pay rate for the job. */
  minimumDefaultPayRate?: Maybe<Scalars['Decimal']>;
};

/** GraphQL type for representing a partner job title. */
export type PartnerJobTitleType = {
  __typename?: 'PartnerJobTitleType';
  /** The unique identifier of the job title. */
  id: Scalars['ID'];
  /** The name of the job title. */
  name: Scalars['String'];
  /** Whether the job title has been archived. */
  isArchived: Scalars['Boolean'];
  /** The number of employees with an active contract referencing this job title. */
  activeEmployeeCount: Scalars['Int'];
  /** The department the job title belongs to. */
  department?: Maybe<PartnerDepartmentType>;
  /** The configurations associated with the job title, grouped by contract type. */
  configurations: Array<PartnerJobTitleConfigurationType>;
  /** The ID of the job title to assign as this job title's default manager. */
  managerJobTitleId?: Maybe<Scalars['UUID']>;
  /** The job title to assign as this job title's default manager. */
  managerJobTitle?: Maybe<PartnerJobTitleType>;
};

/** A PartnerMember represents an Employer's membership relationship to the PartnerNode data structure. */
export type PartnerMember = {
  __typename?: 'PartnerMember';
  /** The ID of the PartnerMember. */
  id: Scalars['UUID'];
  /** The primary partner node for the PartnerMember. */
  primaryPartnerNode: PartnerNode;
  /** The role for the member. */
  role: PartnerRole;
  /** The related PartnerMemberProfile for the member. */
  profile: PartnerMemberProfile;
  /** The ID of the related primary PartnerNode that the member directly belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** Whether the primary partner node is the primary site of the PartnerMemberProfile. */
  isPrimary: Scalars['Boolean'];
  /** The role configuration for the member. Nullable for members who cannot be assigned to rotas. */
  roleV2?: Maybe<RoleConfiguration>;
  /** The ID for the related Employer when one exists. */
  employerId?: Maybe<Scalars['UUID']>;
  /**
   * The WorkingPreferences for the PartnerMember.
   * @deprecated This field is deprecated and will be removed in the future. Use workingAvailability instead.
   */
  workingPreferences?: Maybe<WorkingPreferences>;
  /** The WorkingAvailability for the PartnerMember. */
  workingAvailability?: Maybe<WorkingAvailabilityType>;
  /**
   * The WorkingPreferences for the PartnerMember and a Site.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when the user does not have the READ_PARTNER_MEMBER permission.
   * @deprecated Deprecated in favour of working_preferences field.
   */
  siteWorkingPreferences?: Maybe<SiteWorkingPreferences>;
  /** The recurring shifts for this employee at their primary site. */
  recurringEmployeeShifts: Array<RecurringEmployeeShift>;
};

/** A PartnerMember represents an Employer's membership relationship to the PartnerNode data structure. */
export type PartnerMembersiteWorkingPreferencesArgs = {
  siteId: Scalars['UUID'];
};

/**
 * Enum that contains the available error message codes that can be used to raise errors
 *     related to the PartnerMember package.
 */
export enum PartnerMemberError {
  DUPLICATE_PARTNER_MEMBER = 'DUPLICATE_PARTNER_MEMBER',
  INVALID_PROFILE = 'INVALID_PROFILE',
  NOT_PRIMARY_PARTNER_NODE = 'NOT_PRIMARY_PARTNER_NODE',
  PROFILE_ALREADY_A_MEMBER_OF_PARTNER_NODE = 'PROFILE_ALREADY_A_MEMBER_OF_PARTNER_NODE',
  SITE_DOES_NOT_HAVE_BUSINESS = 'SITE_DOES_NOT_HAVE_BUSINESS',
  UNKNOWN_PARTNER_ROLE = 'UNKNOWN_PARTNER_ROLE',
  UNKNOWN_STINT_GROUP_NAME = 'UNKNOWN_STINT_GROUP_NAME',
  PARTNER_MEMBER_PROFILE_LINKED_TO_DIFFERENT_ACCOUNT = 'PARTNER_MEMBER_PROFILE_LINKED_TO_DIFFERENT_ACCOUNT',
  HAS_UPCOMING_SHIFTS_AT_SITE = 'HAS_UPCOMING_SHIFTS_AT_SITE',
}

/** The input values required to override a PartnerMember's expected hours and working preferences which are to be used while generating a SiteSchedule. */
export type PartnerMemberOverrideInput = {
  /** The ID of the PartnerMemberProfile associated to the PartnerMember. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The overridden expected hours to be used while generating the SiteSchedule. */
  expectedHours?: Maybe<Scalars['Int']>;
  /** The overridden expected hours to be used while generating the SiteSchedule. */
  expectedHoursV2?: Maybe<Scalars['Decimal']>;
  /** The suggested number of working days for this partner member in the schedule, based on their overriden availability. */
  expectedDays: Scalars['Decimal'];
  /** The overridden working preferences to be used while generating the SiteSchedule. */
  workingPreferences?: Maybe<WorkingPreferencesInput>;
  /** The overridden working availability to be used while generating the SiteSchedule. */
  workingAvailability?: Maybe<WorkingAvailabilityInput>;
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfile = Node & {
  __typename?: 'PartnerMemberProfile';
  /** The ID of the PartnerMemberProfile. */
  id: Scalars['UUID'];
  /** The email of the PartnerMemberProfile. */
  email: Scalars['String'];
  /** The phone number of the PartnerMemberProfile. */
  phoneNumber?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  middleNames?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  /** Marks the PartnerMemberProfile as an actual employee in the system. False for internal Stint staff users or any internal sys-admins or 3rd party people. */
  isEmployee: Scalars['Boolean'];
  /** The legal status of the PartnerMemberProfile. */
  legalStatus?: Maybe<LegalStatus>;
  /** The date of birth of the PartnerMemberProfile. */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** The gender of the PartnerMemberProfile */
  gender?: Maybe<Gender>;
  /** The title of the PartnerMemberProfile. */
  title?: Maybe<Scalars['String']>;
  /** The preferred name of the PartnerMemberProfile. */
  preferredName?: Maybe<Scalars['String']>;
  /** The pronoun of the PartnerMemberProfile. */
  pronoun?: Maybe<Scalars['String']>;
  /**
   * The fullname of the PartnerMemberProfile.
   * @deprecated Use givenName, middleNames, and familyName instead. This field will be removed in a future release.
   */
  fullname?: Maybe<Scalars['String']>;
  /** The ID for the related Employer when one exists. */
  employerId?: Maybe<Scalars['UUID']>;
  /** Whether the PartnerMemberProfile is a young worker. */
  isYoungWorker?: Maybe<Scalars['Boolean']>;
  /** Profile photo URL of the PartnerMemberProfile. */
  profilePhotoUrl?: Maybe<Scalars['ImageField']>;
  /** The job title of the PartnerMemberProfile that is retrieved from the EmploymentInfo if it exists. This will be available to anyone who belongs to the same Partner tree as the PartnerMemberProfile. */
  jobTitle?: Maybe<Scalars['String']>;
  /** The expected hours for this employee on the given date, derived from their active working contract on that date via the HR service. Returns null if no active working contract exists for the date. Requires READ_EMPLOYEE permission. */
  expectedHoursOnDate?: Maybe<Scalars['Decimal']>;
  /**
   * The EmploymentInfo for the PartnerMemberProfile and a Partner.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   */
  employmentInfo?: Maybe<EmploymentInfo>;
  /** The holiday information for the PartnerMemberProfile. */
  holidayInfo: CoreTeamMemberHolidayInfo;
  /** The absence information for the PartnerMemberProfile. */
  absenceInfo: CoreTeamMemberAbsenceInfo;
  /** The upcoming shift metrics for the PartnerMemberProfile within date range. */
  upcomingShiftMetricsInDateRange: UpcomingShiftMetrics;
  /** The employee documents associated with this PartnerMemberProfile. */
  employeeDocuments: Array<Maybe<EmployeeDocument>>;
  /** The Right to Work information for the PartnerMemberProfile. */
  rightToWork: EmployeeRTW;
  /** The payroll information for the PartnerMemberProfile.null when the employee has not added any bank details yet. */
  payroll?: Maybe<Payroll>;
  /** The PartnerMembers for the PartnerMemberProfile. */
  partnerMembers: Array<Maybe<PartnerMember>>;
  /** The contact info for the PartnerMemberProfile. */
  contactInfo: EmployeeContactInfoType;
  /** The diversity and inclusion info for the PartnerMemberProfile. */
  diversityAndInclusionInfo?: Maybe<EmployeeDiversityAndInclusionInfoType>;
  /** The core team member features that are available to the PartnerMemberProfile and that the requesting user has access to view. */
  featuresAvailable: Array<CoreTeamMemberFeatures>;
  /** The start date of the PartnerMemberProfile at the Partner. */
  startDateAtPartner?: Maybe<Scalars['Date']>;
  /** The end date of the PartnerMemberProfile at the Partner. */
  endDateAtPartner?: Maybe<Scalars['Date']>;
  /** The optional primary site for the PartnerMemberProfile. */
  primarySite?: Maybe<PartnerSiteProfile>;
  /** The employment status of the PartnerMemberProfile inferred from the start and end date at the partner in the HR service. */
  employmentStatus: EmployeeEmploymentStatus;
  /** The availability status of the PartnerMemberProfile for the specified time period, as defined in the AvailabilityStatus enum. */
  availabilityStatus: AvailabilityStatus;
  /** List of all employment terminations for the PartnerMemberProfile, ordered by the date they were created, most recent first. A PartnerMemberProfile may have multiple terminations due to cancelled terminations. */
  terminations: Array<EmployeeTermination>;
  /**
   * The manager PartnerMemberProfile for this employee. An Employee's manager is the Employee who sits directly above them in the org-chart. None if the Employee has no manager.
   * @deprecated Use managers instead. This field will be removed in a future release.
   */
  manager?: Maybe<PartnerMemberProfile>;
  /** All employees who have their manager set to this employee. This resolves immediate direct reports only and does not include employees more that one level below this employee. */
  directReports: Array<PartnerMemberProfile>;
  /** The count of direct reports for this employee. This counts immediate direct reports only, and does not include employees more that one level below this employee. */
  directReportsCount: Scalars['Int'];
  /** The permissions that the user has over the employee. */
  permissionOverEmployee: Array<PartnerPermission>;
  /** The notes related to the Employee. */
  performanceNotes: Array<Maybe<EmployeePerformanceNote>>;
  /** Metrics of the employee's last 12 months of shifts. */
  pastShiftMetrics: PastShiftMetrics;
  /** The employee's working contracts. */
  workingContracts: Array<Maybe<EmployeeWorkingContract>>;
  /** The employee's current working contract. None if the employee has no current working contract. */
  currentWorkingContract?: Maybe<EmployeeWorkingContract>;
  /** The list of PartnerMemberProfiles for the managers of this employee. An Employee's manager is the Employee who sits directly above them in the org-chart. Empty list if the Employee has no manager. */
  managers: Array<Maybe<PartnerMemberProfile>>;
  /** Site-scoped scheduling configuration for this employee, set by a GM. Contains preferences such as minimum weekly hours used by the auto-scheduler. Non-nullable — performs a get-or-create in the BI service. Returns a record with all fields null for employees on a fixed contract. Requires READ_EMPLOYEE permission. */
  schedulingConfiguration: EmployeeSiteSchedulingConfigurationType;
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfileexpectedHoursOnDateArgs = {
  date: Scalars['Date'];
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfileemploymentInfoArgs = {
  partnerNodeId?: Maybe<Scalars['UUID']>;
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfileupcomingShiftMetricsInDateRangeArgs = {
  input: UpcomingShiftMetricsInput;
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfileavailabilityStatusArgs = {
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfilecurrentWorkingContractArgs = {
  input?: Maybe<CurrentWorkingContractInput>;
};

/** A PartnerMemberProfile represents the personal details for a PartnerMember. */
export type PartnerMemberProfileschedulingConfigurationArgs = {
  input: SchedulingConfigurationInput;
};

export type PartnerMemberProfileTypeConnection = {
  __typename?: 'PartnerMemberProfileTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<PartnerMemberProfileTypeEdge>;
};

export type PartnerMemberProfileTypeEdge = {
  __typename?: 'PartnerMemberProfileTypeEdge';
  /** The item at the end of the edge */
  node: PartnerMemberProfile;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Deprecated: The filtering criteria for a list of PartnerMember records. This input is no longer used and will be removed in a future release. */
export type PartnerMembersFilterInput = {
  /** Deprecated: This field is no longer used. */
  email?: Maybe<Scalars['String']>;
  /** Deprecated: This field is no longer used. */
  roles?: Maybe<Array<PartnerRole>>;
};

/**
 * The PartnerNodeType class is used to expose the generic shared values of all the possible node_type nodes and
 * will be used to query lists of PartnerNode objects.
 *
 * Each node_type PartnerNode has its own type class defined to expose all the required data for the given node_type
 * which should not be used to query lists.
 *
 * It has a Node interface so that list queries can use relay pagination.
 */
export type PartnerNode = Node & {
  __typename?: 'PartnerNode';
  /** The ID of the PartnerNode. */
  id: Scalars['UUID'];
  /** The display name that is given to the node. */
  name: Scalars['String'];
  /** The NodeType value that indicates the type of PartnerNode that is being returned. */
  nodeType: NodeType;
  /** The ID of the parent PartnerNode. */
  parentId?: Maybe<Scalars['UUID']>;
  /** The related PartnerBrand object if it exists. */
  partnerBrand?: Maybe<PartnerBrand>;
  /** The operational areas assigned to this partner node. */
  operationalAreas: Array<OperationalArea>;
  /** The selectable partner roles for this partner node. */
  partnerRoles: Array<PartnerRole>;
};

/** Enum that contains the available error message codes that can be used to raise errors related to PartnerNode. */
export enum PartnerNodeError {
  ADDRESS_ERROR = 'ADDRESS_ERROR',
  CITY_ERROR = 'CITY_ERROR',
  ALREADY_PARENT = 'ALREADY_PARENT',
  DUPLICATE_BUSINESS_REF = 'DUPLICATE_BUSINESS_REF',
  EMPLOYER_ALREADY_MEMBER = 'EMPLOYER_ALREADY_MEMBER',
  INCORRECT_NODE_TYPE = 'INCORRECT_NODE_TYPE',
  INVALID_NAME = 'INVALID_NAME',
  INVALID_NODE_TYPE = 'INVALID_NODE_TYPE',
  PARENT_ALREADY_HAS_PARTNER_BRAND = 'PARENT_ALREADY_HAS_PARTNER_BRAND',
  SITE_NODE_CANNOT_BE_PARENT = 'SITE_NODE_CANNOT_BE_PARENT',
}

/**
 * Enum that contains the allowed field values that can be used to order a QuerySet of PartnerNode objects.
 *
 *     Note that this Enum does not follow the regular pattern of uppercare values due to the fact
 *     that react-admin sends lower case strings magically and these enums need to match the values
 *     passed.
 *
 *     This is deprecated in favour of PartnerNodesOrderField.
 */
export enum PartnerNodeOrderField {
  id = 'id',
  name = 'name',
}

export type PartnerNodeTypeConnection = {
  __typename?: 'PartnerNodeTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<PartnerNodeTypeEdge>;
};

export type PartnerNodeTypeEdge = {
  __typename?: 'PartnerNodeTypeEdge';
  /** The item at the end of the edge */
  node: PartnerNode;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * The PartnerNodesFilterInput class defines the Graphene input values used to provide the requested filter
 * values from the client for a list of PartnerNode objects.
 */
export type PartnerNodesFilterInput = {
  /**
   * Limit results to only those under and including the specified PartnerNode.
   * If omitted, all nodes the user has access to will be returned (with permission filtering applied).
   * If specified, all nodes below that node will be returned (permission filtering is skipped).
   */
  rootNodeId?: Maybe<Scalars['UUID']>;
  /**
   * Limit results to only the one that has the ID of the specified PartnerNode.
   * This can be used to quickly retrieve a single PartnerNode.
   * If omitted, then all results will be returned.
   */
  id?: Maybe<Scalars['UUID']>;
  /**
   * Limit results to only those that fuzzy match the name.
   * If omitted, then all results will be returned.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Limit results to only those that match the specified NodeType values.
   * If omitted, or an empty array is provided, then all results will be returned.
   */
  nodeTypes?: Maybe<Array<NodeType>>;
};

/**
 * The PartnerPoolInviteType class defines the Graphene input values used to resolve a filtered and ordered list
 * of PartnerNode objects.
 */
export type PartnerNodesInput = {
  /**
   * Allow specifying the order of the results.
   * If not specified, the results will be ordered by name ascending.
   */
  orderBy?: Maybe<PartnerNodesOrderInput>;
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results the user has access to will be returned.
   */
  filter?: Maybe<PartnerNodesFilterInput>;
};

/** Enum that contains the allowed field values that can be used to order a QuerySet of PartnerNode objects. */
export enum PartnerNodesOrderField {
  NAME = 'NAME',
}

/**
 * The PartnerNodesOrderInput class defines the Graphene input values used to provide the requested order by
 * values from the client for a list of PartnerNode objects.
 *
 * It contains the allowed fields to order by and the ascending or descending order that is requested.
 */
export type PartnerNodesOrderInput = {
  /** The field to order the list of PartnerNode objects by. */
  field: PartnerNodesOrderField;
  /** The requested order to be used when ordering the list of PartnerNode objects. */
  order: SortOrder;
};

/**
 * Enum that contains all the permissions that are required in order to perform CRUD actions for a partner account.
 *
 *     Before allowing an Employer to perform a CRUD action for any object that belongs to a partner account the required
 *     PartnerPermission instance must be passed to the relevant Manager or QuerySet method which will then use the
 *     PartnerPermission.required_roles_for_permission or PartnerPermission.required_groups_for_permission method to get a
 *     list of roles that the Employer must have in order to perform the action.
 */
export enum PartnerPermission {
  CREATE_PARTNER_NODE = 'CREATE_PARTNER_NODE',
  READ_PARTNER_NODE = 'READ_PARTNER_NODE',
  UPDATE_PARTNER_NODE = 'UPDATE_PARTNER_NODE',
  CREATE_PARTNER_MEMBER = 'CREATE_PARTNER_MEMBER',
  DELETE_PARTNER_MEMBER = 'DELETE_PARTNER_MEMBER',
  READ_PARTNER_MEMBER = 'READ_PARTNER_MEMBER',
  UPDATE_PARTNER_MEMBER = 'UPDATE_PARTNER_MEMBER',
  CREATE_PARTNER_BRAND = 'CREATE_PARTNER_BRAND',
  UPDATE_PARTNER_BRAND = 'UPDATE_PARTNER_BRAND',
  UPDATE_PARTNER_CONTACT = 'UPDATE_PARTNER_CONTACT',
  CREATE_COMPANIES_HOUSE_INFORMATION = 'CREATE_COMPANIES_HOUSE_INFORMATION',
  UPDATE_COMPANIES_HOUSE_INFORMATION = 'UPDATE_COMPANIES_HOUSE_INFORMATION',
  CREATE_STINT = 'CREATE_STINT',
  READ_STINT = 'READ_STINT',
  UPDATE_STINT = 'UPDATE_STINT',
  CREATE_STINT_TEMPLATE = 'CREATE_STINT_TEMPLATE',
  READ_STINT_TEMPLATE = 'READ_STINT_TEMPLATE',
  UPDATE_STINT_TEMPLATE = 'UPDATE_STINT_TEMPLATE',
  CREATE_STINT_WEEK_TEMPLATE = 'CREATE_STINT_WEEK_TEMPLATE',
  READ_STINT_WEEK_TEMPLATE = 'READ_STINT_WEEK_TEMPLATE',
  UPDATE_STINT_WEEK_TEMPLATE = 'UPDATE_STINT_WEEK_TEMPLATE',
  DELETE_STINT_WEEK_TEMPLATE = 'DELETE_STINT_WEEK_TEMPLATE',
  CLEAR_DEFAULT_STINT_WEEK_TEMPLATE = 'CLEAR_DEFAULT_STINT_WEEK_TEMPLATE',
  SET_DEFAULT_STINT_WEEK_TEMPLATE = 'SET_DEFAULT_STINT_WEEK_TEMPLATE',
  SET_TRAINED_STINTERS = 'SET_TRAINED_STINTERS',
  CREATE_PARTNER_POOL = 'CREATE_PARTNER_POOL',
  READ_PARTNER_POOL = 'READ_PARTNER_POOL',
  UPDATE_PARTNER_POOL = 'UPDATE_PARTNER_POOL',
  CREATE_AGREEMENT = 'CREATE_AGREEMENT',
  UPDATE_AGREEMENT = 'UPDATE_AGREEMENT',
  READ_AGREEMENT = 'READ_AGREEMENT',
  INITIATE_PARTNER_FILE_UPLOAD = 'INITIATE_PARTNER_FILE_UPLOAD',
  CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
  READ_PAYMENT_METHOD = 'READ_PAYMENT_METHOD',
  READ_PARTNER_TO_STINTER_REVIEWS = 'READ_PARTNER_TO_STINTER_REVIEWS',
  CREATE_POOL_MEMBER_FEEDBACK = 'CREATE_POOL_MEMBER_FEEDBACK',
  READ_POOL_MEMBER_FEEDBACK = 'READ_POOL_MEMBER_FEEDBACK',
  READ_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS = 'READ_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS',
  UPDATE_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS = 'UPDATE_ASSIGNED_CORE_TEAM_MEMBER_SHIFTS',
  USE_BUSINESS_INTELLIGENCE = 'USE_BUSINESS_INTELLIGENCE',
  READ_BUSINESS_INTELLIGENCE = 'READ_BUSINESS_INTELLIGENCE',
  MANAGE_BUSINESS_INTELLIGENCE = 'MANAGE_BUSINESS_INTELLIGENCE',
  REVIEW_SITE_SCHEDULE = 'REVIEW_SITE_SCHEDULE',
  HAS_PARTNER_ACCESS = 'HAS_PARTNER_ACCESS',
  CREATE_LEAVE_POLICY = 'CREATE_LEAVE_POLICY',
  READ_HOLIDAY_POLICY = 'READ_HOLIDAY_POLICY',
  UPDATE_HOLIDAY_POLICY_FOR_CORE_TEAM_MEMBER = 'UPDATE_HOLIDAY_POLICY_FOR_CORE_TEAM_MEMBER',
  READ_CORE_TEAM_MEMBER_LEAVE = 'READ_CORE_TEAM_MEMBER_LEAVE',
  MANAGE_CORE_TEAM_MEMBER_LEAVE = 'MANAGE_CORE_TEAM_MEMBER_LEAVE',
  READ_CORE_TEAM_MEMBER_WORKING_SUMMARY = 'READ_CORE_TEAM_MEMBER_WORKING_SUMMARY',
  READ_CORE_TEAM_MEMBER_HOLIDAY_BALANCES = 'READ_CORE_TEAM_MEMBER_HOLIDAY_BALANCES',
  READ_CORE_TEAM_MEMBER_ABSENCE_REQUESTS = 'READ_CORE_TEAM_MEMBER_ABSENCE_REQUESTS',
  UPSERT_HR_CORE_TEAM_MEMBER = 'UPSERT_HR_CORE_TEAM_MEMBER',
  READ_REPORTING_DATA = 'READ_REPORTING_DATA',
  READ_PII_REPORTING_DATA = 'READ_PII_REPORTING_DATA',
  MANAGE_SKILL_LEVEL = 'MANAGE_SKILL_LEVEL',
  CREATE_EMPLOYEE_DOCUMENT = 'CREATE_EMPLOYEE_DOCUMENT',
  DELETE_EMPLOYEE_DOCUMENT = 'DELETE_EMPLOYEE_DOCUMENT',
  READ_EMPLOYEE_DOCUMENT = 'READ_EMPLOYEE_DOCUMENT',
  UPDATE_EMPLOYEE_DOCUMENT = 'UPDATE_EMPLOYEE_DOCUMENT',
  CREATE_EMPLOYEE = 'CREATE_EMPLOYEE',
  READ_EMPLOYEE = 'READ_EMPLOYEE',
  UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE',
  UPDATE_EMPLOYEE_BASIC_EMPLOYMENT_INFORMATION = 'UPDATE_EMPLOYEE_BASIC_EMPLOYMENT_INFORMATION',
  UPSERT_EMPLOYEE_EXPERIENCE_LEVEL = 'UPSERT_EMPLOYEE_EXPERIENCE_LEVEL',
  CREATE_OR_UPDATE_JOB_TITLE = 'CREATE_OR_UPDATE_JOB_TITLE',
  UPDATE_EMPLOYEE_EMAIL = 'UPDATE_EMPLOYEE_EMAIL',
  READ_EMPLOYEE_MANAGER = 'READ_EMPLOYEE_MANAGER',
  SET_EMPLOYEE_MANAGER = 'SET_EMPLOYEE_MANAGER',
  UPDATE_EMPLOYEE_CONTACT_DETAILS = 'UPDATE_EMPLOYEE_CONTACT_DETAILS',
  LIST_EMPLOYEES = 'LIST_EMPLOYEES',
  READ_EMPLOYEE_PAYROLL_INFORMATION = 'READ_EMPLOYEE_PAYROLL_INFORMATION',
  READ_EMPLOYEE_CONTACT_INFO = 'READ_EMPLOYEE_CONTACT_INFO',
  READ_EMPLOYEE_DIVERSITY_AND_INCLUSION_INFO = 'READ_EMPLOYEE_DIVERSITY_AND_INCLUSION_INFO',
  READ_EMPLOYEE_RTW_STATUS = 'READ_EMPLOYEE_RTW_STATUS',
  CREATE_EMPLOYEE_RTW_SCREENING = 'CREATE_EMPLOYEE_RTW_SCREENING',
  READ_CORE_TEAM_MEMBER_FEATURES_AVAILABLE = 'READ_CORE_TEAM_MEMBER_FEATURES_AVAILABLE',
  UPDATE_EMPLOYEE_PRIMARY_SITE = 'UPDATE_EMPLOYEE_PRIMARY_SITE',
  READ_EMPLOYEE_HOME_ADDRESS = 'READ_EMPLOYEE_HOME_ADDRESS',
  READ_EMPLOYEE_PAY_RATE = 'READ_EMPLOYEE_PAY_RATE',
  READ_EMPLOYEE_TERMINATION = 'READ_EMPLOYEE_TERMINATION',
  MANAGE_EMPLOYEE_TERMINATION = 'MANAGE_EMPLOYEE_TERMINATION',
  MANAGE_EMPLOYEE_INTEGRATIONS = 'MANAGE_EMPLOYEE_INTEGRATIONS',
  CONFIGURE_PARTNER_WEBHOOK = 'CONFIGURE_PARTNER_WEBHOOK',
  SEND_TEST_PARTNER_WEBHOOK = 'SEND_TEST_PARTNER_WEBHOOK',
  READ_PARTNER_WEBHOOK_RECORDS = 'READ_PARTNER_WEBHOOK_RECORDS',
  MANAGER_OF_EMPLOYEE = 'MANAGER_OF_EMPLOYEE',
  READ_EMPLOYEE_PERFORMANCE_NOTES = 'READ_EMPLOYEE_PERFORMANCE_NOTES',
  MANAGE_EMPLOYEE_PERFORMANCE_NOTES = 'MANAGE_EMPLOYEE_PERFORMANCE_NOTES',
  MANAGE_EMPLOYMENT_INFORMATION = 'MANAGE_EMPLOYMENT_INFORMATION',
  READ_EMPLOYMENT_INFORMATION = 'READ_EMPLOYMENT_INFORMATION',
  MANAGE_PARTNER_JOB_PAY_RATES = 'MANAGE_PARTNER_JOB_PAY_RATES',
}

/**
 * The PartnerPoolType class defines the Graphene ObjectType class used to resolve the PartnerPool model data for
 * GraphQL queries.
 */
export type PartnerPool = Node & {
  __typename?: 'PartnerPool';
  /** The ID of the PartnerPool. */
  id: Scalars['UUID'];
  /** The URL of the form. */
  formUrl: Scalars['String'];
  /** The perks to display to the Stinter for a specific Pool. */
  perks?: Maybe<Scalars['String']>;
  /** The related PartnerNode object. */
  partnerNode: PartnerNode;
  /** The Stinters that have been added to this PartnerPool. Only Admins and the Employer with READ_PARTNER_POOL permission will be able to access this field. An empty array indicates that the pool is empty. */
  invites: PartnerPoolInviteTypeConnection;
  /**
   * Returns true if the Stinter has already applied to this invite by completing the relevant form.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not a Stinter.
   */
  hasApplied: Scalars['Boolean'];
};

/**
 * The PartnerPoolType class defines the Graphene ObjectType class used to resolve the PartnerPool model data for
 * GraphQL queries.
 */
export type PartnerPoolinvitesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/**
 * The PartnerPoolInviteType class defines the Graphene ObjectType class used
 * to resolve the PartnerPoolInvite model data for GraphQL queries.
 *
 * This type implements the UUIDNode interface, allowing it to be relay paginated.
 */
export type PartnerPoolInvite = Node & {
  __typename?: 'PartnerPoolInvite';
  /** The ID of the PartnerPoolInvite. */
  id: Scalars['UUID'];
  /** The timestamp UTC that this invite was created at. */
  createdAt: Scalars['DateTime'];
  /** Whether or not the PartnerPoolInvite has been seen by the Stinter. */
  hasBeenSeen: Scalars['Boolean'];
  /** The profile of the stinter that was invited into the pool. */
  stinter: StinterProfile;
  /** Whether or not the stinter has applied to the pool. */
  hasApplied: Scalars['Boolean'];
};

export type PartnerPoolInviteTypeConnection = {
  __typename?: 'PartnerPoolInviteTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<PartnerPoolInviteTypeEdge>;
};

export type PartnerPoolInviteTypeEdge = {
  __typename?: 'PartnerPoolInviteTypeEdge';
  /** The item at the end of the edge */
  node: PartnerPoolInvite;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The roles available for a PartnerMember. Used to determine a member's permissions in an organisation. */
export enum PartnerRole {
  /** The Super Admin. They have elevated permissions above Account Admin, including the ability to manage employment information for core team members. */
  SUPER_ADMIN = 'SUPER_ADMIN',
  /** The Account Admin. They can update Account-level settings and policies. They do not manage individual sites with this permission. */
  ACCOUNT_ADMIN = 'ACCOUNT_ADMIN',
  /** The owner of the Partner Account. Has every permission. */
  OWNER = 'OWNER',
  /** A member in the organisation with admin permissions in the Partner app. Typically a head office role. */
  ADMIN = 'ADMIN',
  /** A member in the organisation with limited permissions in the Partner app. */
  MEMBER = 'MEMBER',
  /** A member in the organisation with view only permissions in the Partner app. */
  VIEWER = 'VIEWER',
  /** A member responsible for overseeing multiple sites within an assigned area. */
  AREA_MANAGER = 'AREA_MANAGER',
  /** A core team member with basic employee-level permissions. The actual job title is determined by the role_configuration_id. */
  EMPLOYEE = 'EMPLOYEE',
  /** A core team member who is a Site manager only with permissions to use the BI features in the Partner app. */
  MANAGER = 'MANAGER',
  /** A core team member who manages shifts at the site level. */
  SHIFT_MANAGER = 'SHIFT_MANAGER',
}

/** A PartnerSettings represents the configuration details for a Site. */
export type PartnerSettings = {
  __typename?: 'PartnerSettings';
  /** The ID of the PartnerSettings. */
  id: Scalars['UUID'];
  /** Whether or not the Site has control check enabled. */
  controlCheckEnabled: Scalars['Boolean'];
  /** Whether or not the Site has repeat Stinters enabled. */
  repeatStintersEnabled: Scalars['Boolean'];
  /** The group that the waterfall (matching) algorithm uses to decide how to match Stinters with Stints. The default group will start as UNSPECIFIED, which means that the Site will not be included in the waterfall bot process. */
  waterfallBotGroup: WaterfallBotGroup;
  /** The availability of Business Intelligence features. */
  businessIntelligenceSetting: BusinessIntelligenceSetting;
  /** Whether or not Stint Workforce is enabled. */
  workforceEnabled: Scalars['Boolean'];
  /** Whether or not the Site has the integrated workforce feature enabled where they see Stints in their rota. */
  workforceIntegrated: Scalars['Boolean'];
  /** Whether or not the Site has leave management enabled. */
  leaveManagementEnabled: Scalars['Boolean'];
  /** Whether or not the Site has rota approval enabled. */
  rotaApprovalEnabled: Scalars['Boolean'];
  /** The locale of the Site. This is used to determine the time zone, currency and other locale-based settings. */
  locale: Locale;
  /** Whether or not the Site has hour approval enabled. */
  hourApprovalEnabled: Scalars['Boolean'];
  /**
   * Whether or not the Site has operational area enabled.
   * @deprecated This setting is deprecated. Use the partner operational areas instead.
   */
  operationalAreaEnabled?: Maybe<Scalars['Boolean']>;
  /** The venue type of the Site. */
  venueType: VenueType;
  /** Whether or not the Site has skill level enabled. */
  skillLevelEnabled: Scalars['Boolean'];
  /** The percentage used to calculate the non-service shift budget for the Site. This is a range between 0 and 100. */
  nonServiceBudgetPercentage?: Maybe<Scalars['Decimal']>;
  /** The hourly pay rate adjustment applied to FLEXIBLE contract employees at this Site when triggering the autoscheduler. Range: 0 to 10. Defaults to 0. */
  hourlyPayRateAdjustment: Scalars['Decimal'];
  /** The minimum number of minutes before a Stint start time that external users must post. Internal users can override this restriction. Range: 30 to 40320 minutes (672 hours). */
  stintPostingCutoffMinutes: Scalars['Int'];
  /** The ID of the Site that the PartnerSettings belongs to. */
  partnerNodeId: Scalars['UUID'];
  /**
   * The business intelligence feature settings values for a Site.
   * @deprecated Use businessIntelligenceSetting instead.
   */
  businessIntelligenceSettings?: Maybe<BusinessIntelligenceSettings>;
  /**
   * Was previously deprecated with businessIntelligenceSettings.labourOptimizationEnabled.
   * @deprecated Use businessIntelligenceSetting instead.
   */
  labourToolsEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not the Site has core team management as read only.
   * @deprecated Use core_team_management_read_only on PartnerAccountSettings instead.
   */
  coreTeamManagementReadOnly: Scalars['Boolean'];
  /**
   * The absolute pay rate adjustment applied to FLEXIBLE contract employees at this Site when triggering the autoscheduler. Range: 0 to 10. Deprecated in favor of hourly_pay_rate_adjustment.
   * @deprecated Use hourly_pay_rate_adjustment instead.
   */
  payModifier?: Maybe<Scalars['Decimal']>;
  /**
   * Whether or not the Site has the LLM agent enabled.
   * @deprecated Use siteBiSettings.willowAiAgentEnabled instead. This field will be removed in sc-90178.
   */
  llmAgentEnabled: Scalars['Boolean'];
  /** The BI service site-level feature flag settings for this site. */
  siteBiSettings: SiteBISettings;
  /**
   * Whether or not the Site has custom rules enabled.
   * @deprecated Use siteBiSettings.rotaCustomRulesEnabled instead. This field will be removed in sc-90178.
   */
  rotaCustomRulesEnabled: Scalars['Boolean'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfile = {
  __typename?: 'PartnerSiteProfile';
  /** The ID of the PartnerNode. */
  id: Scalars['UUID'];
  /** The name of the Site PartnerNode. */
  name: Scalars['String'];
  /** The ID of the parent PartnerNode. */
  parentId: Scalars['UUID'];
  /** An optional external ID that is used by the partner to identify the PartnerNode. */
  partnerUniqueId?: Maybe<Scalars['String']>;
  /** The NodeType value that indicates the type of PartnerNode that is being returned. */
  nodeType: NodeType;
  /** The ID of the related Business object. */
  businessId: Scalars['UUID'];
  /** The related PartnerBrand object if it exists. */
  partnerBrand?: Maybe<PartnerBrand>;
  /** The list of PartnerMember objects that are members of the PartnerNode. */
  partnerMembers: Array<PartnerMember>;
  /** The EMPLOYEE_DISCLAIMER Agreement for this Site. This can be null, as the Agreement may have not been created. */
  employeeDisclaimer?: Maybe<Agreement>;
  /** The related PartnerContact object. */
  partnerContact: PartnerContact;
  /** The related Address object. */
  address: Address;
  /** The logo url from the related Business object. Will be replaced by PartnerBrand logo. */
  businessLogoUrl: Scalars['String'];
  /** The list of PartnerPermission values that the Employer has for the Site PartnerNode. */
  partnerPermissions: Array<Maybe<PartnerPermission>>;
  /** The partner pool associated with the Partner Site. This can be null, as the pool may have not yet been created. */
  partnerPool?: Maybe<PartnerPool>;
  /** The ID of the Account PartnerNode associated with this Site PartnerNode. */
  accountNodeId: Scalars['UUID'];
  /** The auto-posting information associated with this Site. */
  autoPostingInfo?: Maybe<AutoPostingInfo>;
  /** The average rating given by Stinters to the Site rounded to two decimal places. */
  averageRating?: Maybe<Scalars['Float']>;
  /** The training video ID for the Site. */
  trainingVideoId?: Maybe<Scalars['String']>;
  /** The finance details for the Site. */
  partnerFinance: PartnerFinanceDetails;
  /** The configuration details for the Site. */
  settings: PartnerSettings;
  /** The payment provider site mapping associated with this Site, if configured. */
  paymentProviderConfig?: Maybe<SitePaymentProvider>;
  /** The check in details for the Site. */
  checkInDetails: SiteCheckInDetails;
  /** A list of StintTemplatePoolMember objects related to this Site PartnerNode. */
  trialPoolMembers: StintTemplatePoolMemberTypeConnection;
  /** Retrieves a relay paginated list of StintTemplate objects for the given PartnerNode and all its descendants, filtered and ordered by the specified criteria. */
  stintTemplates: StintTemplateTypeConnection;
  /**
   * Retrieves a list of DemandActuals for the Site for a given week.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   */
  demandActuals: Array<DemandActual>;
  /**
   * Retrieves a list of DemandForecasts for the Site for a given week.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   */
  demandForecasts: Array<DemandForecast>;
  /**
   * Retrieves a single DemandForecasts for the Site for a given date.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   */
  demandForecast: DemandForecast;
  /**
   * Retrieves the SiteSchedule for the Site for a given week.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   */
  siteSchedule?: Maybe<SiteSchedule>;
  /**
   * Retrieves the labour metrics breakdown for the Site for a given week.
   *
   * Returns null when no demand forecast exists for the requested week.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   * - INVALID_ARGUMENT when weekCommencing does not match the partner's configured scheduleWeekStartDay.
   */
  labourMetrics?: Maybe<LabourMetricsV2>;
  /**
   * Loads persisted week state, runs the auto-scheduler synchronously, and returns the projected labour cost
   * for the site and week as cost, percentage of forecast sales, and total staffed hours. Nothing is persisted.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer.
   * - UNAUTHORIZED when the user does not have the MANAGE_BUSINESS_INTELLIGENCE permission.
   * - UNAUTHORIZED when the Site does not have the BUSINESS_INTELLIGENCE_SETTING set to ON.
   */
  weekHeadcountCost: HeadcountCost;
  /** Retrieves a relay paginated list of PartnerToStinterReview objects related to this Site PartnerNode. */
  partnerToStinterReviews: PartnerToStinterReviewConnection;
  /** The list of OperationalEvents for the Site. */
  operationalEvents: Array<OperationalEvent>;
  /** The list of recurring shift templates for the Site. */
  recurringShiftTemplates: Array<RecurringShiftTemplate>;
  /**
   * Returns one RecurringEventOccurrence per resolved slot in the requested date range.
   *
   * For weeks where the ScheduleStatus is COMPLETE the occurrences are sourced from the generated schedule and returned with
   * readOnly = true.
   *
   * For all other weeks the occurrences are projected from RecurringShiftTemplate records with overrides applied and
   * cancellations excluded, and returned with readOnly = false.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   */
  calendarEventOccurrences: Array<RecurringEventOccurrence>;
  /** The list of auto scheduler custom rules for the site for the given week. */
  autoSchedulerCustomRules: Array<AutoSchedulerCustomRule>;
  /** The list of break rules applicable to this site, filtered by the site's locale. */
  breakRules: Array<BreakRule>;
  /** Willow labour optimisation data for this site. */
  willow: Willow;
  /** Retrieves a list of Shifts for partner members at other sites for a given date range. */
  shiftsAtOtherSites: Array<Shift>;
  /**
   * Retrieves a list of DemandForecasts for the Site for a given week.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission or when the Site does not have the feature enabled.
   */
  recommendedShifts: Array<Shift>;
  /** Current Schedule Labour Suggestions for one day across all operational areas. Raises an error on sites where WillowLabourModel != REPLICA. */
  scheduleLabourSuggestions: Array<ScheduleLabourSuggestion>;
  /** Per-day Schedule Labour Suggestion counts for the week across all operational areas. */
  scheduleLabourSuggestionCounts: WeeklyScheduleLabourSuggestionCounts;
  /** returns all holidays at a site within a given time period. */
  coreTeamMemberHolidays: Array<CoreTeamMemberHolidayAtSite>;
  /** Returns all absences at a site filtered by the given parameters. */
  coreTeamMemberAbsences: Array<CoreTeamMemberAbsenceAtSite>;
  /** Returns PartnerMemberProfiles for members of this site who have a flexible contract for the entire week starting on the provided date. Filtering is performed server-side via the HR service. Requires READ_EMPLOYEE permission. */
  flexibleEmployees: Array<PartnerMemberProfile>;
  /** The list of OperationalAreas for the Site. */
  operationalAreas: Array<OperationalArea>;
  /** The list of selectable PartnerRoles for the Site. */
  partnerRoles: Array<PartnerRole>;
  coreTeamMemberDynamicWorkingPreferences: Array<CoreTeamMemberDynamicWorkingPreferenceAtSite>;
  /** Returns all working preference requests at a site, optionally filtered by date range and status. */
  workingPreferenceRequests: Array<WorkingPreferenceRequestAtSite>;
  /** A relay paginated list of notifications for the employee at this site. */
  notifications: EmployeeNotificationsConnection;
  /** The notification settings for the employee at this site. */
  notificationSettings: EmployeeSiteNotificationSettings;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilepartnerMembersArgs = {
  input?: Maybe<GetPartnerMembersInput>;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfiletrialPoolMembersArgs = {
  input?: Maybe<StintTemplateTrialPoolMembersInput>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilestintTemplatesArgs = {
  input: GetStintTemplatesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfiledemandActualsArgs = {
  weekCommencing: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfiledemandForecastsArgs = {
  weekCommencing: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfiledemandForecastArgs = {
  date: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilesiteScheduleArgs = {
  weekCommencing: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilelabourMetricsArgs = {
  weekCommencing: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfileweekHeadcountCostArgs = {
  weekCommencing: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilepartnerToStinterReviewsArgs = {
  input?: Maybe<PartnerToStinterReviewsInput>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilecalendarEventOccurrencesArgs = {
  from: Scalars['Date'];
  to: Scalars['Date'];
  eventType?: Maybe<Array<RecurringEventType>>;
  nonServiceType?: Maybe<Array<NonServiceShiftType>>;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfileautoSchedulerCustomRulesArgs = {
  weekCommencing: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfileshiftsAtOtherSitesArgs = {
  input: ShiftsAtOtherSitesInput;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilerecommendedShiftsArgs = {
  scheduleDate: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilescheduleLabourSuggestionsArgs = {
  siteScheduleId: Scalars['UUID'];
  date: Scalars['Date'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilescheduleLabourSuggestionCountsArgs = {
  siteScheduleId: Scalars['UUID'];
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilecoreTeamMemberHolidaysArgs = {
  input: CoreTeamMemberHolidaysAtSiteInput;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilecoreTeamMemberAbsencesArgs = {
  input: CoreTeamMemberAbsencesAtSiteInput;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfileflexibleEmployeesArgs = {
  input: FlexibleEmployeesInput;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilecoreTeamMemberDynamicWorkingPreferencesArgs = {
  input: CoreTeamMemberDynamicWorkingPreferencesInput;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfileworkingPreferenceRequestsArgs = {
  input: GetWorkingPreferenceRequestsAtSiteInput;
};

/** A PartnerSiteProfile represents a Site PartnerNode in a Partner tree. */
export type PartnerSiteProfilenotificationsArgs = {
  input: EmployeeNotificationsInput;
};

/** Represents stints for pending review. */
export type PartnerToStinterReview = Node & {
  __typename?: 'PartnerToStinterReview';
  /** The stint ID */
  id: Scalars['UUID'];
  /** The related Stinter object. */
  stinter: StintUser;
  /** The related Stint object. */
  stint: Stint;
};

export type PartnerToStinterReviewConnection = {
  __typename?: 'PartnerToStinterReviewConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<PartnerToStinterReviewEdge>;
};

export type PartnerToStinterReviewEdge = {
  __typename?: 'PartnerToStinterReviewEdge';
  /** The item at the end of the edge */
  node: PartnerToStinterReview;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Input values to fetch a list of PartnerToStinterReview. */
export type PartnerToStinterReviewsInput = {
  /** Whether to show reviews for Stints that were completed by Stinters whowere part of the Team for that Stint.Default if not provided: true */
  showTeamStinters?: Maybe<Scalars['Boolean']>;
};

/** The possible partner webhook event types. */
export enum PartnerWebhookEventType {
  /** Webhook event for stint-related data. */
  STINT = 'STINT',
}

/** Describes a single attempt to send a partner webhook. */
export type PartnerWebhookSendingAttemptType = {
  __typename?: 'PartnerWebhookSendingAttemptType';
  /** The endpoint that this webhook was attempted to be sent to. */
  endpoint: Scalars['String'];
  /** The timestamp we recorded that the attempt was made. */
  attemptedAt: Scalars['DateTime'];
  /** The time in milliseconds that it took to make the http call to send the webhook. Null if the webhook sending failed before we could make the http call. */
  latencyMs?: Maybe<Scalars['Int']>;
  /** The http status code we received from the webhook endpoint. Null if the webhook sending failed before we could make the http call. */
  httpStatusCode?: Maybe<Scalars['Int']>;
  /** Any recorded reason for an unsuccessful sending of the webhook. Null if the webhook sending was successful. */
  failureReason?: Maybe<Scalars['String']>;
};

/** The possible statuses for a partner webhook sending attempt. */
export enum PartnerWebhookSendingStatus {
  /** The webhook record has been created and is pending to be sent. */
  PENDING = 'PENDING',
  /** The webhook is currently being sent to the endpoint. */
  SENDING = 'SENDING',
  /** The webhook was successfully sent to the endpoint. */
  SUCCESS = 'SUCCESS',
  /** The webhook failed to send after all retries were exhausted. */
  FAILED = 'FAILED',
}

/** A partner webhook record with details about sending attempts. */
export type PartnerWebhookType = {
  __typename?: 'PartnerWebhookType';
  /** The UUID for the webhook record in the partner webhooks service. This will not be sent to the webhook endpoint. */
  id: Scalars['UUID'];
  /** The current status of the webhook. */
  status: PartnerWebhookSendingStatus;
  /** Unique ID for the webhook event computed from the hash of the account id, event type and payload. This will be sent to the webhook endpoint. */
  eventId: Scalars['String'];
  /** The type of event that was or will be sent to the webhook endpoint. */
  eventType: PartnerWebhookEventType;
  /** The payload with the details of the event that was or will be sent to the webhook endpoint. */
  payload: Scalars['String'];
  /** The timestamp when the webhook was created. */
  createdAt: Scalars['DateTime'];
  /** A list of sending attempts for the webhook. Ordered by newest attempt first. */
  attempts: Array<Maybe<PartnerWebhookSendingAttemptType>>;
  /** The number of sending attempts for the webhook. */
  attemptsCount: Scalars['Int'];
};

/** PastShiftMetrics contains data about the employee's number of shifts, number of lateness', and number of no shows, in the past 12 months. */
export type PastShiftMetrics = {
  __typename?: 'PastShiftMetrics';
  /** The number of shifts in the last 12 months. */
  shiftCount: Scalars['Int'];
  /** The number of latenesses in the last 12 months. */
  latenessCount: Scalars['Int'];
  /** The number of no-shows in the last 12 months. */
  noShowCount: Scalars['Int'];
  /** The employee's shifts of the past 12 months. */
  shifts: Array<Shift>;
};

/** Enum that contains the values that represent the type of payment method that a Site is using. */
export enum PaymentMethod {
  CARD = 'CARD',
  CREDIT = 'CREDIT',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export type PaymentMethodFilter = {
  accountName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  isPrimaryMethod?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gte */
  isPrimaryMethod_gte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lte */
  isPrimaryMethod_lte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_istartswith */
  isPrimaryMethod_istartswith?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lt */
  isPrimaryMethod_lt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gt */
  isPrimaryMethod_gt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_isnull */
  isPrimaryMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_iendswith */
  isPrimaryMethod_iendswith?: Maybe<Scalars['Boolean']>;
  accountNumber?: Maybe<Scalars['String']>;
  /** accountNumber_search */
  accountNumber_search?: Maybe<Scalars['String']>;
  /** accountNumber_gte */
  accountNumber_gte?: Maybe<Scalars['String']>;
  /** accountNumber_lte */
  accountNumber_lte?: Maybe<Scalars['String']>;
  /** accountNumber_istartswith */
  accountNumber_istartswith?: Maybe<Scalars['String']>;
  /** accountNumber_lt */
  accountNumber_lt?: Maybe<Scalars['String']>;
  /** accountNumber_gt */
  accountNumber_gt?: Maybe<Scalars['String']>;
  /** accountNumber_isnull */
  accountNumber_isnull?: Maybe<Scalars['Boolean']>;
  /** accountNumber_iendswith */
  accountNumber_iendswith?: Maybe<Scalars['String']>;
  /** accountName_search */
  accountName_search?: Maybe<Scalars['String']>;
  /** accountName_gte */
  accountName_gte?: Maybe<Scalars['String']>;
  /** accountName_lte */
  accountName_lte?: Maybe<Scalars['String']>;
  /** accountName_istartswith */
  accountName_istartswith?: Maybe<Scalars['String']>;
  /** accountName_lt */
  accountName_lt?: Maybe<Scalars['String']>;
  /** accountName_gt */
  accountName_gt?: Maybe<Scalars['String']>;
  /** accountName_isnull */
  accountName_isnull?: Maybe<Scalars['Boolean']>;
  /** accountName_iendswith */
  accountName_iendswith?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  /** sortCode_search */
  sortCode_search?: Maybe<Scalars['String']>;
  /** sortCode_gte */
  sortCode_gte?: Maybe<Scalars['String']>;
  /** sortCode_lte */
  sortCode_lte?: Maybe<Scalars['String']>;
  /** sortCode_istartswith */
  sortCode_istartswith?: Maybe<Scalars['String']>;
  /** sortCode_lt */
  sortCode_lt?: Maybe<Scalars['String']>;
  /** sortCode_gt */
  sortCode_gt?: Maybe<Scalars['String']>;
  /** sortCode_isnull */
  sortCode_isnull?: Maybe<Scalars['Boolean']>;
  /** sortCode_iendswith */
  sortCode_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  isPrimaryMethod_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  accountNumber_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  accountName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  sortCode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PaymentMethodInput = {
  /** Account name on card for student */
  accountName?: Maybe<Scalars['String']>;
  /** Account number on card for student */
  accountNumber?: Maybe<Scalars['String']>;
  /** Sort code on card for student */
  sortCode?: Maybe<Scalars['String']>;
};

/** Configuration settings for payment provider integrations. */
export type PaymentProviderSettings = {
  __typename?: 'PaymentProviderSettings';
  /** The type of payment provider. */
  providerType: PaymentProviderType;
  /** The authentication secret for the payment provider. */
  authSecret: Scalars['String'];
  /** The client ID for the payment provider. */
  clientId?: Maybe<Scalars['String']>;
  /** The company ID for the payment provider. */
  companyId?: Maybe<Scalars['String']>;
  /** The API endpoint URL for the payment provider. */
  endpoint: Scalars['String'];
  /** Controls whether this payment provider is active or not. */
  active: Scalars['Boolean'];
};

/** Input for configuring payment provider settings. */
export type PaymentProviderSettingsInput = {
  /** The type of payment provider. */
  providerType: PaymentProviderType;
  /** The authentication secret for the payment provider. */
  authSecret: Scalars['String'];
  /** The client ID for the payment provider. */
  clientId?: Maybe<Scalars['String']>;
  /** The company ID for the payment provider. */
  companyId?: Maybe<Scalars['String']>;
  /** The API endpoint URL for the payment provider. */
  endpoint: Scalars['String'];
  /** Controls whether this payment provider is active or not. */
  active: Scalars['Boolean'];
};

/** The types of payment providers available for partner account settings. */
export enum PaymentProviderType {
  /** PayCaptain payment provider integration for payroll processing. */
  PAYCAPTAIN = 'PAYCAPTAIN',
  /** Shape payment provider integration for payroll processing. */
  SHAPE = 'SHAPE',
}

/** The payroll information for the PartnerMemberProfile. */
export type Payroll = {
  __typename?: 'Payroll';
  /** The payroll information for the PartnerMemberProfile. */
  payrollInformation?: Maybe<EmployeePayrollInformation>;
  /** The bank details for the PartnerMemberProfile. */
  bankDetails?: Maybe<EmployeeBankDetails>;
};

export type PeriodicTask = {
  __typename?: 'PeriodicTask';
  id: Scalars['ID'];
  /** Short Description For This Task */
  name: Scalars['String'];
  /** The Name of the Celery Task that Should be Run.  (Example: "proj.tasks.import_contacts") */
  task: Scalars['String'];
  /** JSON encoded positional arguments (Example: ["arg1", "arg2"]) */
  args: Scalars['String'];
  /** JSON encoded keyword arguments (Example: {"argument": "value"}) */
  kwargs: Scalars['String'];
  /** Queue defined in CELERY_TASK_QUEUES. Leave None for default queuing. */
  queue?: Maybe<Scalars['String']>;
  /** Override Exchange for low-level AMQP routing */
  exchange?: Maybe<Scalars['String']>;
  /** Override Routing Key for low-level AMQP routing */
  routingKey?: Maybe<Scalars['String']>;
  /** JSON encoded message headers for the AMQP message. */
  headers: Scalars['String'];
  /** Priority Number between 0 and 255. Supported by: RabbitMQ, Redis (priority reversed, 0 is highest). */
  priority?: Maybe<Scalars['Int']>;
  /** Datetime after which the schedule will no longer trigger the task to run */
  expires?: Maybe<Scalars['DateTime']>;
  /** Timedelta with seconds which the schedule will no longer trigger the task to run */
  expireSeconds?: Maybe<Scalars['Int']>;
  /** If True, the schedule will only run the task a single time */
  oneOff: Scalars['Boolean'];
  /** Datetime when the schedule should begin triggering the task to run */
  startTime?: Maybe<Scalars['DateTime']>;
  /** Set to False to disable the schedule */
  enabled: Scalars['Boolean'];
  /** Datetime that the schedule last triggered the task to run. Reset to None if enabled is set to False. */
  lastRunAt?: Maybe<Scalars['DateTime']>;
  /** Running count of how many times the schedule has triggered the task */
  totalRunCount: Scalars['Int'];
  /** Datetime that this PeriodicTask was last modified */
  dateChanged: Scalars['DateTime'];
  /** Detailed description about the details of this Periodic Task */
  description: Scalars['String'];
};

/**
 * The PersonaInquiry class defines the Graphene ObjectType class used to resolve the response from the
 * RTW Service.
 */
export type PersonaInquiry = {
  __typename?: 'PersonaInquiry';
  /** The ID of the Persona inquiry. This is used by Persona to identify an existing inquiry. */
  id: Scalars['String'];
  /**
   * The session token of an existing Persona Inquiry. This will be null unless the inquiry is in a Pending state.
   * This is a JWT representations of an inquiry session that is used to access pending inquiries. If a user closes a pending
   * inquiry and reopens it in a separate window, they will lose their session token and will need to generate a new one.
   */
  sessionToken?: Maybe<Scalars['String']>;
};

/** Represents PoolMemberFeedbackType. */
export type PoolMemberFeedback = Node & {
  __typename?: 'PoolMemberFeedback';
  /** The ID of the object */
  id: Scalars['UUID'];
  /** The datetime value that is automatically captured when a new record is added to the database. */
  createdAt: Scalars['DateTime'];
  /** The StintTemplatePoolMember associated to this feedback. */
  member: StintTemplatePoolMember;
  /** The StintUser that submitted this feedback. */
  submittedBy: StintUser;
  /** The feedback comment submitted by the user. */
  comment: Scalars['String'];
};

export type PoolMemberFeedbackTypeConnection = {
  __typename?: 'PoolMemberFeedbackTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<PoolMemberFeedbackTypeEdge>;
};

export type PoolMemberFeedbackTypeEdge = {
  __typename?: 'PoolMemberFeedbackTypeEdge';
  /** The item at the end of the edge */
  node: PoolMemberFeedback;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The TextChoices for the Stint.post_method field. */
export enum PostMethod {
  ONE_OFF = 'ONE_OFF',
  FROM_WEEK_TEMPLATE = 'FROM_WEEK_TEMPLATE',
}

export type PostalCode = {
  __typename?: 'PostalCode';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  city?: Maybe<City>;
  postalCode: Scalars['String'];
  /** ID of city related to postal code. */
  city_id?: Maybe<Scalars['UUID']>;
};

export type PostalCodeFilter = {
  q?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  postalCode?: Maybe<Scalars['String']>;
  /** postalCode_search */
  postalCode_search?: Maybe<Scalars['String']>;
  /** postalCode_gte */
  postalCode_gte?: Maybe<Scalars['String']>;
  /** postalCode_lte */
  postalCode_lte?: Maybe<Scalars['String']>;
  /** postalCode_istartswith */
  postalCode_istartswith?: Maybe<Scalars['String']>;
  /** postalCode_lt */
  postalCode_lt?: Maybe<Scalars['String']>;
  /** postalCode_gt */
  postalCode_gt?: Maybe<Scalars['String']>;
  /** postalCode_isnull */
  postalCode_isnull?: Maybe<Scalars['Boolean']>;
  /** postalCode_iendswith */
  postalCode_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  postalCode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The primary labour metric for the Partner. */
export enum PrimaryLabourMetric {
  /** The primary labour metric is labour cost. */
  LABOUR_COST = 'LABOUR_COST',
  /** The primary labour metric is labour cost as a percentage. */
  LABOUR_COST_PERCENTAGE = 'LABOUR_COST_PERCENTAGE',
  /** The primary labour metric is hours worked. */
  HOURS = 'HOURS',
  /** The primary labour metric is sales per labour hour, used to derive target hours from forecast sales. */
  SALES_PER_LABOUR_HOUR = 'SALES_PER_LABOUR_HOUR',
}

/** The projected hours breakdown for a labour metrics result week, extended with inline deviation fields for the Projected hours tab and summary counts for open shifts, Stint shifts, non-service shifts and break durations. */
export type ProjectedHoursBreakdown = {
  __typename?: 'ProjectedHoursBreakdown';
  /** The total hours across all shift categories for the week. */
  total: LabourMetricsWeekBreakdown;
  /** The hours attributable to service shifts for the week. */
  service: LabourMetricsWeekBreakdown;
  /** The deviation for rota service hours for the week. Values are signed: positive indicates over the baseline; negative indicates under. Recommended service hours - scheduled rota service hours. Always populated from schedule/headcount data. */
  serviceDeviation: LabourMetricsWeekBreakdown;
  /** The hours broken down by role configuration for the week. */
  roles: Array<RoleLabourMetricsBreakdown>;
  /** The per-role deviation values for the week. Values are signed: positive indicates over the baseline; negative indicates under. Recommended role hours - scheduled role hours. The client maps roleConfigurationId to operational area to aggregate FoH/BoH deviation rows. Always populated (may be empty when no roles are configured). */
  rolesDeviation: Array<RoleLabourMetricsBreakdown>;
  /** The hours attributable to external (training) shifts for the week. Null when allocating training cost to the primary site is disabled. */
  external?: Maybe<LabourMetricsWeekBreakdown>;
  /** The hours attributable to Stint shifts for the week. Null when workforce integration is disabled. */
  stint?: Maybe<LabourMetricsWeekBreakdown>;
  /** The deviation for Stint hours for the week. Values are signed: positive indicates over the baseline; negative indicates under. Recommended Stint hours - scheduled Stint hours. Null when workforce integration is disabled; otherwise always populated from schedule/headcount data. */
  stintDeviation?: Maybe<LabourMetricsWeekBreakdown>;
  /** The hours broken down by non-service shift type for the week. */
  nonServiceShifts: Array<NonServiceLabourMetricsBreakdown>;
  /** The total duration of open shifts for the week, in minutes. */
  openShiftDurationMinutes: Scalars['Int'];
  /** The number of open shifts for the week. */
  openShiftCount: Scalars['Int'];
  /** The number of Stint shifts for the week. */
  stintCount: Scalars['Int'];
  /** The number of non-service shifts for the week. */
  nonServiceShiftCount: Scalars['Int'];
  /** The total scheduled break duration for the week, in minutes. */
  breakDurationMinutes: Scalars['Int'];
  /** The total outstanding (unpaid) break duration for the week, in minutes. */
  breakDurationOutstandingMinutes: Scalars['Int'];
};

/** The pronouns available for a PartnerMemberProfile. Used to determine the pronoun of the member. */
export enum Pronoun {
  /** The PartnerMemberProfile prefers to be referred to as he. */
  HE = 'HE',
  /** The PartnerMemberProfile prefers to be referred to as she. */
  SHE = 'SHE',
  /** The PartnerMemberProfile prefers to be referred to as they. */
  THEY = 'THEY',
  /** The PartnerMemberProfile prefers to be referred to as something else. */
  OTHER = 'OTHER',
}

/** The required values in order to mark a StinterCompetencyTask as passed. */
export type QualifyForTaskInput = {
  /** The ID of the task for which the pool member is getting qualified. */
  taskId: Scalars['UUID'];
  /** The ID of the stint user who is being qualified for the task. */
  stinterId: Scalars['UUID'];
  /** The ID of the stint template to which the member was added. */
  stintTemplateId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query = {
  __typename?: 'Query';
  studentUser?: Maybe<UserRepresentationType>;
  allStudentUsers?: Maybe<Array<Maybe<UserRepresentationType>>>;
  _allStudentUserMeta?: Maybe<ListMetadata>;
  employerUser?: Maybe<UserRepresentationType>;
  allEmployerUsers?: Maybe<Array<Maybe<UserRepresentationType>>>;
  _allEmployerUserMeta?: Maybe<ListMetadata>;
  adminUser?: Maybe<UserRepresentationType>;
  allAdminUsers?: Maybe<Array<Maybe<UserRepresentationType>>>;
  _allAdminUserMeta?: Maybe<ListMetadata>;
  /** Retrieves a relay paginated list of University objects, filtered and ordered by the specified criteria. */
  universities: UniversityTypeConnection;
  /** All reasons for approving a Trial Stinter from a Pool. */
  trialMemberApprovedReasons: Array<TrialMemberApprovedReason>;
  tag?: Maybe<Tag>;
  studentSavedPlaces?: Maybe<StudentSavedPlaceListType>;
  /** Retrieves a single StintUser object by ID. */
  stintUser?: Maybe<StintUser>;
  /** Retrieves a single StintUser object for the user making the request. Employer users should use the new myEmployerProfile query. */
  me?: Maybe<StintUser>;
  /** The total number of Stinter users that can see surge pricing. */
  countStudentsCanSeeSurge?: Maybe<Scalars['Int']>;
  stintUserAvailabilities?: Maybe<StintUserAvailabilityListType>;
  stintTemplates?: Maybe<StintTemplateTypeListType>;
  stintTemplate?: Maybe<StintTemplate>;
  /**
   * Retrieves a StintTemplateGroup by ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - DOES_NOT_EXIST when the StintTemplateGroup does not exist.
   */
  stintTemplateGroup: StintTemplateGroup;
  /** Returns accepted Stints for a given stinter and stint template starting within the specified number of hours. */
  upcomingStints?: Maybe<Array<Maybe<Stint>>>;
  /** Retrieves a single Stint by its ID. Used for Stint Badge. */
  stint?: Maybe<Stint>;
  /** Retrieves all Stint objects within the Stinter's current City. Used for displaying Stint objects while the Stinter is on the waitlist. */
  availableStints?: Maybe<StintListType>;
  /** A list of Trained Stints that the Stinter, making the request, is Trained for. */
  trainedStints?: Maybe<StintNodeTypeConnection>;
  /** Returns a list of Stint approved StintTask objects. */
  stintTaskApproved?: Maybe<StintTaskListType>;
  /** The StudentProfile object as a StinterProfileType for the Stinter making the request. */
  myStinterProfile: StinterProfile;
  calendarStints?: Maybe<CalendarStintListType>;
  repeatStints: StintNodeTypeConnection;
  allAvailableStints: StintNodeTypeConnection;
  /** The open Stint offers available to the logged in student ordered with the oldest first. */
  stintOffers?: Maybe<StintOfferListType>;
  /** The WorkExperience object for the Stinter user making the request. */
  stinterWorkExperience?: Maybe<WorkExperience>;
  /** Get stint journey confirmation screen. */
  stintToConfirmByStudent?: Maybe<Stint>;
  stintWeekTemplates?: Maybe<StintWeekTemplateListType>;
  /** Retrieves a single StintWeekTemplate by ID. */
  stintWeekTemplate?: Maybe<StintWeekTemplate>;
  /** Returns the jotform URL for the out-of-term request form. */
  outOfTermRequestJotFormUrl?: Maybe<Scalars['String']>;
  /** Retrieves a presigned S3 URL for the given out of term document. */
  outOfTermDocumentPresignedUrl?: Maybe<Scalars['String']>;
  /** Returns a Region object for the given ID. */
  region?: Maybe<Region>;
  /** Returns a PostalCode object for the given ID. */
  postalCode?: Maybe<PostalCode>;
  /** The Stinters that have been added to this PartnerPool. Only Admins and the Employer with READ_PARTNER_POOL permission will be able to access this field. An empty array indicates that the pool is empty. */
  partnerPoolInvites: PartnerPoolInviteTypeConnection;
  /** All reasons for removing a Stinter from a Pool. */
  poolMemberRemovalReasons: Array<MemberRemovalReason>;
  /** A list of employees for the Partner Account. */
  employees?: Maybe<PartnerMemberProfileTypeConnection>;
  employee: PartnerMemberProfile;
  /**
   * Retrieves a Site by ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INCORRECT_NODE_TYPE when the ID is for a non Site PartnerNode.
   * - DOES_NOT_EXIST when the related Business does not exist for the Site.
   */
  siteProfile: PartnerSiteProfile;
  /** Retrieves reporting data for a PartnerNode. */
  reportingData: ReportingDataOutput;
  /** A list containing a PartnerNode object and its descendants. */
  partnerTree?: Maybe<PartnerNodeTypeConnection>;
  /** Retrieves a relay paginated list of PartnerNode objects, filtered and ordered by the specified criteria. */
  partnerNodes: PartnerNodeTypeConnection;
  /** Retrieves a PartnerNode object. User must have the READ_PARTNER_NODE permission at the requested PartnerNode. */
  partnerNode: PartnerNode;
  /**
   * Retrieves a PartnerMember by it's ID and related PartnerNode ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when the user does not have the READ_PARTNER_MEMBER permission.
   * - DOES_NOT_EXIST when the PartnerMember does not exist.
   */
  partnerMember: PartnerMember;
  /**
   * Retrieves a Group PartnerNode by ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INCORRECT_NODE_TYPE when the ID is for a non Account PartnerNode.
   */
  groupProfile: PartnerGroupProfile;
  /**
   * Retrieves the available PartnerMemberProfiles for a PartnerNode.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when the user does not have the READ_PARTNER_MEMBER permission.
   */
  availablePartnerMemberProfiles: PartnerMemberProfileTypeConnection;
  /**
   * Retrieves an Account PartnerNode by ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   * - INCORRECT_NODE_TYPE when the ID is for a non Account PartnerNode.
   */
  accountProfile: PartnerAccountProfile;
  /** A paginated list of NodeType.ACCOUNT PartnerNode objects. */
  accountNodes?: Maybe<PaginatedPartnerNode>;
  jobTitle: PartnerJobTitleType;
  /** The suggested week breakdown for a holiday request. */
  suggestedWeekBreakdown?: Maybe<GetSuggestedWeekBreakdownOutput>;
  /** Check the health of the API. */
  healthCheck?: Maybe<HealthCheckType>;
  /**
   * Retrieves an employee document by its ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permissions.
   */
  employeeDocument: EmployeeDocument;
  /** A list of Offence objects for a Stinter retrieved by the Stinter profile id. */
  stinterOffences?: Maybe<OffenceTypeConnection>;
  /** A single Offence object retrieved by id. */
  offence?: Maybe<Offence>;
  /** A list of Offence objects for the requesting Stinter */
  myOffences?: Maybe<StinterOffenceTypeConnection>;
  cities?: Maybe<CityListType>;
  city?: Maybe<City>;
  /** Retrieves a single Business object by ID. */
  business?: Maybe<Business>;
  /** Retrieves a list of Business objects that the authenticated user is allowed to view. */
  businesses?: Maybe<BusinessListType>;
  /**
   * The EmployerProfile object for the authenticated Employer making the request.
   * @deprecated Use employer query instead.
   */
  myEmployerProfile?: Maybe<MyEmployerProfile>;
  employmentExceptions?: Maybe<EmploymentExceptionListType>;
  employmentException?: Maybe<EmploymentException>;
  /**
   * Retrieves an Employer by ID.
   *
   * Errors:
   * - UNAUTHORIZED when the user is not an Employer or Staff user.
   * - UNAUTHORIZED when an Employer tries to access data for another Employer.
   * - DOES_NOT_EXIST when the Employer does not exist.
   */
  employer: Employer;
  /** Resolves a Stinter */
  stinter?: Maybe<Stinter>;
  /** Retrieves a relay paginated list of StintUser objects, filtered and ordered by the specified criteria. */
  users: StintUserTypeConnection;
  _debug?: Maybe<DjangoDebug>;
  Address?: Maybe<Address>;
  allAddresses?: Maybe<Array<Maybe<Address>>>;
  _allAddressesMeta?: Maybe<ListMetadata>;
  Business?: Maybe<Business>;
  allBusinesses?: Maybe<Array<Maybe<Business>>>;
  _allBusinessesMeta?: Maybe<ListMetadata>;
  BusinessCreditControlEvent?: Maybe<BusinessCreditControlEvent>;
  allBusinessCreditControlEvents?: Maybe<
    Array<Maybe<BusinessCreditControlEvent>>
  >;
  _allBusinessCreditControlEventsMeta?: Maybe<ListMetadata>;
  CardPaymentMethod?: Maybe<CardPaymentMethod>;
  allCardPaymentMethods?: Maybe<Array<Maybe<CardPaymentMethod>>>;
  _allCardPaymentMethodsMeta?: Maybe<ListMetadata>;
  Characteristic?: Maybe<Characteristic>;
  allCharacteristics?: Maybe<Array<Maybe<Characteristic>>>;
  _allCharacteristicsMeta?: Maybe<ListMetadata>;
  City?: Maybe<City>;
  allCities?: Maybe<Array<Maybe<City>>>;
  _allCitiesMeta?: Maybe<ListMetadata>;
  Country?: Maybe<Country>;
  allCountries?: Maybe<Array<Maybe<Country>>>;
  _allCountriesMeta?: Maybe<ListMetadata>;
  DeviceLocation?: Maybe<DeviceLocation>;
  allDeviceLocations?: Maybe<Array<Maybe<DeviceLocation>>>;
  _allDeviceLocationsMeta?: Maybe<ListMetadata>;
  DirectDebitPaymentMethod?: Maybe<DirectDebitPaymentMethod>;
  allDirectDebitPaymentMethods?: Maybe<Array<Maybe<DirectDebitPaymentMethod>>>;
  _allDirectDebitPaymentMethodsMeta?: Maybe<ListMetadata>;
  EditableSetting?: Maybe<EditableSetting>;
  allEditableSettings?: Maybe<Array<Maybe<EditableSetting>>>;
  _allEditableSettingsMeta?: Maybe<ListMetadata>;
  Employer?: Maybe<StintUser>;
  allEmployers?: Maybe<Array<Maybe<StintUser>>>;
  _allEmployersMeta?: Maybe<ListMetadata>;
  EmploymentException?: Maybe<EmploymentException>;
  allEmploymentExceptions?: Maybe<Array<Maybe<EmploymentException>>>;
  _allEmploymentExceptionsMeta?: Maybe<ListMetadata>;
  Hotspot?: Maybe<Hotspot>;
  allHotspots?: Maybe<Array<Maybe<Hotspot>>>;
  _allHotspotsMeta?: Maybe<ListMetadata>;
  Language?: Maybe<Language>;
  allLanguages?: Maybe<Array<Maybe<Language>>>;
  _allLanguagesMeta?: Maybe<ListMetadata>;
  Notification?: Maybe<Notification>;
  allNotifications?: Maybe<Array<Maybe<Notification>>>;
  _allNotificationsMeta?: Maybe<ListMetadata>;
  PeriodicTask?: Maybe<PeriodicTask>;
  allPeriodicTasks?: Maybe<Array<Maybe<PeriodicTask>>>;
  _allPeriodicTasksMeta?: Maybe<ListMetadata>;
  PostalCode?: Maybe<PostalCode>;
  allPostalCodes?: Maybe<Array<Maybe<PostalCode>>>;
  _allPostalCodesMeta?: Maybe<ListMetadata>;
  Region?: Maybe<Region>;
  allRegions?: Maybe<Array<Maybe<Region>>>;
  _allRegionsMeta?: Maybe<ListMetadata>;
  Stint?: Maybe<Stint>;
  allStints?: Maybe<Array<Maybe<Stint>>>;
  _allStintsMeta?: Maybe<ListMetadata>;
  StintJourney?: Maybe<StintJourney>;
  allStintJourneys?: Maybe<Array<Maybe<StintJourney>>>;
  _allStintJourneysMeta?: Maybe<ListMetadata>;
  StintOffer?: Maybe<StintOffer>;
  allStintOffers?: Maybe<Array<Maybe<StintOffer>>>;
  _allStintOffersMeta?: Maybe<ListMetadata>;
  StintTask?: Maybe<StintTask>;
  allStintTasks?: Maybe<Array<Maybe<StintTask>>>;
  _allStintTasksMeta?: Maybe<ListMetadata>;
  StintTemplate?: Maybe<StintTemplate>;
  allStintTemplates?: Maybe<Array<Maybe<StintTemplate>>>;
  _allStintTemplatesMeta?: Maybe<ListMetadata>;
  StintUser?: Maybe<StintUser>;
  allStintUsers?: Maybe<Array<Maybe<StintUser>>>;
  _allStintUsersMeta?: Maybe<ListMetadata>;
  StintWeekTemplate?: Maybe<StintWeekTemplate>;
  allStintWeekTemplates?: Maybe<Array<Maybe<StintWeekTemplate>>>;
  _allStintWeekTemplatesMeta?: Maybe<ListMetadata>;
  Stintopedia?: Maybe<Stintopedia>;
  allStintopedias?: Maybe<Array<Maybe<Stintopedia>>>;
  _allStintopediasMeta?: Maybe<ListMetadata>;
  StripeCard?: Maybe<StripeCard>;
  allStripeCards?: Maybe<Array<Maybe<StripeCard>>>;
  _allStripeCardsMeta?: Maybe<ListMetadata>;
  StripeDebit?: Maybe<StripeDebit>;
  allStripeDebits?: Maybe<Array<Maybe<StripeDebit>>>;
  _allStripeDebitsMeta?: Maybe<ListMetadata>;
  StudentOrEmployerUser?: Maybe<StintUser>;
  allStudentOrEmployerUsers?: Maybe<Array<Maybe<StintUser>>>;
  _allStudentOrEmployerUsersMeta?: Maybe<ListMetadata>;
  StudentReview?: Maybe<StudentReview>;
  allStudentReviews?: Maybe<Array<Maybe<StudentReview>>>;
  _allStudentReviewsMeta?: Maybe<ListMetadata>;
  Tag?: Maybe<Tag>;
  allTags?: Maybe<Array<Maybe<Tag>>>;
  _allTagsMeta?: Maybe<ListMetadata>;
  TopTip?: Maybe<TopTip>;
  allTopTips?: Maybe<Array<Maybe<TopTip>>>;
  _allTopTipsMeta?: Maybe<ListMetadata>;
  University?: Maybe<University>;
  allUniversities?: Maybe<Array<Maybe<University>>>;
  _allUniversitiesMeta?: Maybe<ListMetadata>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystudentUserArgs = {
  userId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStudentUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['String']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStudentUserMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemployerUserArgs = {
  userId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallEmployerUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['String']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allEmployerUserMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryadminUserArgs = {
  userId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallAdminUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['String']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allAdminUserMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryuniversitiesArgs = {
  input: UniversitiesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerytagArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystudentSavedPlacesArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['UUID']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintUserArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintUserAvailabilitiesArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  cityId?: Maybe<Scalars['UUID']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintTemplatesArgs = {
  businessId?: Maybe<Scalars['UUID']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintTemplateArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintTemplateGroupArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryupcomingStintsArgs = {
  input: GetUpcomingStintsForStinterInput;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryavailableStintsArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerytrainedStintsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintTaskApprovedArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerycalendarStintsArgs = {
  siteId?: Maybe<Scalars['UUID']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  status_In?: Maybe<Scalars['String']>;
  startDateFrom?: Maybe<Scalars['DateTime']>;
  startDateTo?: Maybe<Scalars['DateTime']>;
  endDateFrom?: Maybe<Scalars['DateTime']>;
  endDateTo?: Maybe<Scalars['DateTime']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryrepeatStintsArgs = {
  filterInputs?: Maybe<StintFilterInput>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallAvailableStintsArgs = {
  filterInputs?: Maybe<StintFilterInput>;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintOffersArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintWeekTemplatesArgs = {
  businessId: Scalars['UUID'];
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystintWeekTemplateArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryoutOfTermDocumentPresignedUrlArgs = {
  documentId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryregionArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerypostalCodeArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerypartnerPoolInvitesArgs = {
  input: GetPartnerPoolInvitesInputType;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemployeesArgs = {
  input: PartnerAccountEmployeesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemployeeArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerysiteProfileArgs = {
  partnerNodeId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryreportingDataArgs = {
  input: ReportingDataInputV2;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerypartnerTreeArgs = {
  partnerNodeId: Scalars['UUID'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerypartnerNodesArgs = {
  input: PartnerNodesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerypartnerNodeArgs = {
  partnerNodeId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerypartnerMemberArgs = {
  input: GetPartnerMemberInput;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerygroupProfileArgs = {
  partnerNodeId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryavailablePartnerMemberProfilesArgs = {
  input: AvailablePartnerMemberProfilesInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryaccountProfileArgs = {
  partnerNodeId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryaccountNodesArgs = {
  filter?: Maybe<FilterInput>;
  sortField?: Maybe<PartnerNodeOrderField>;
  sortOrder?: Maybe<SortOrder>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryjobTitleArgs = {
  id: Scalars['UUID'];
  accountId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerysuggestedWeekBreakdownArgs = {
  input: GetSuggestedWeekBreakdownInput;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemployeeDocumentArgs = {
  input: GetEmployeeDocumentInput;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystinterOffencesArgs = {
  stinterProfileId: Scalars['UUID'];
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryoffenceArgs = {
  offenceId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerymyOffencesArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerycitiesArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailabilityEnabled?: Maybe<Scalars['Boolean']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerycityArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerybusinessArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerybusinessesArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemploymentExceptionsArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemploymentExceptionArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryemployerArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QuerystinterArgs = {
  stinterId: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryusersArgs = {
  input: UsersInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryAddressArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallAddressesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<AddressFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allAddressesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<AddressFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryBusinessArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallBusinessesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<BusinessFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allBusinessesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<BusinessFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryBusinessCreditControlEventArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallBusinessCreditControlEventsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<BusinessCreditControlEventFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allBusinessCreditControlEventsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<BusinessCreditControlEventFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryCardPaymentMethodArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallCardPaymentMethodsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CardPaymentMethodFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allCardPaymentMethodsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CardPaymentMethodFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryCharacteristicArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallCharacteristicsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CharacteristicFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allCharacteristicsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CharacteristicFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryCityArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallCitiesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CityFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allCitiesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CityFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryCountryArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallCountriesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CountryFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allCountriesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CountryFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryDeviceLocationArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallDeviceLocationsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<DeviceLocationFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allDeviceLocationsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<DeviceLocationFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryDirectDebitPaymentMethodArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallDirectDebitPaymentMethodsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<PaymentMethodFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allDirectDebitPaymentMethodsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<PaymentMethodFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryEditableSettingArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallEditableSettingsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allEditableSettingsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryEmployerArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallEmployersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allEmployersMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryEmploymentExceptionArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallEmploymentExceptionsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<EmploymentExceptionFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allEmploymentExceptionsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<EmploymentExceptionFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryHotspotArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallHotspotsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<HotspotTimeBusynessFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allHotspotsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<HotspotTimeBusynessFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryLanguageArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallLanguagesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<LanguageFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allLanguagesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<LanguageFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryNotificationArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallNotificationsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<NotificationFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allNotificationsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<NotificationFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryPeriodicTaskArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallPeriodicTasksArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allPeriodicTasksMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryPostalCodeArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallPostalCodesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<PostalCodeFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allPostalCodesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<PostalCodeFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryRegionArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallRegionsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<RegionFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allRegionsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<RegionFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintJourneyArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintJourneysArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintJourneyFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintJourneysMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintJourneyFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintOfferArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintOffersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintOfferToStudentFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintOffersMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintOfferToStudentFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintTaskArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintTasksArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintTaskFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintTasksMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintTaskFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintTemplateArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintTemplatesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintTemplateFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintTemplatesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintTemplateFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintUserArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintUsersMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintWeekTemplateArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintWeekTemplatesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintWeekTemplateFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintWeekTemplatesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintWeekTemplateFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStintopediaArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStintopediasArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintopediaFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStintopediasMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintopediaFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStripeCardArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStripeCardsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StripeCardFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStripeCardsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StripeCardFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStripeDebitArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStripeDebitsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StripeDebitFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStripeDebitsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StripeDebitFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStudentOrEmployerUserArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStudentOrEmployerUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStudentOrEmployerUsersMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryStudentReviewArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallStudentReviewsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StudentReviewFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allStudentReviewsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StudentReviewFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryTagArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallTagsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<TagFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allTagsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<TagFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryTopTipArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallTopTipsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<TopTipFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allTopTipsMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<TopTipFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryUniversityArgs = {
  id: Scalars['UUID'];
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type QueryallUniversitiesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<UniversityFilter>;
};

/** This class contains all Query classes on the combined Stint API GraphQL schema. */
export type Query_allUniversitiesMetaArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<UniversityFilter>;
};

/** The Stinters RTW information. */
export type RTW = {
  __typename?: 'RTW';
  /** Source of truth for the Stinter's RTW status. */
  status: RTWStatus;
  /** When the Stinters RTW expires. This will be null when there is no expiry or they have not completed a successful Screening. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** If the Stinter has a likeness photo. This should be true if the Stinter has an approved screening. Otherwise will be false if they either have not started a screening, or do not yet have an approved screening. */
  hasLikenessPhoto: Scalars['Boolean'];
  /** The presigned URL of the Stinters likeness photo in S3. The URL will expire after 5 minutes. If the Stinter does not have a likeness photo, this will be null. */
  likenessPhotoUrl?: Maybe<Scalars['String']>;
  /** A list of all Stinters RTW screenings. */
  screenings: Array<RTWScreening>;
  /** A single screening for the Employee. */
  screening: RTWScreening;
};

/** The Stinters RTW information. */
export type RTWscreeningArgs = {
  screeningId: Scalars['UUID'];
};

/** The input values required from a client to store a Stinter's RTW documents. */
export type RTWFileInput = {
  /** The base64 encoded content of this file. */
  base64Content: Scalars['String'];
  /** The mime type of the file. */
  mimeType: Scalars['String'];
};

/** Represents a RTW screening. */
export type RTWScreening = {
  __typename?: 'RTWScreening';
  /** The ID of the right to work Screening. */
  screeningId: Scalars['String'];
  /** The datetime the RTW screening was submitted at. */
  submittedAt: Scalars['DateTime'];
  /** The status of the screening. */
  status: RTWStatus;
  /** The type of screening. */
  screeningType: RTWScreeningType;
  /** Whether the screening has right to work documents. */
  hasRtwDocument: Scalars['Boolean'];
  /** The presigned URL of the RTW document in S3. The URL will expire after 5 minutes. */
  rtwDocumentUrl: Scalars['String'];
  /** The share code submitted with the screening if applicable. */
  shareCode?: Maybe<Scalars['String']>;
  /** The dob submitted with the screening if applicable. */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** The date the share code expires if applicable. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** The Employee or Stinter's weekly cap in term time if applicable. */
  termTimeWeeklyCap?: Maybe<Scalars['Int']>;
};

/** Enum for RTW Screening Type. */
export enum RTWScreeningType {
  IDSP = 'IDSP',
  SHARE_CODE = 'SHARE_CODE',
  MANUAL = 'MANUAL',
}

/** Enum for RTW status. */
export enum RTWStatus {
  MISSING = 'MISSING',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
}

export type RateOverride = {
  __typename?: 'RateOverride';
  id: Scalars['ID'];
  rate?: Maybe<Scalars['Float']>;
};

/** The input values required to reassign direct reports from one manager to another. */
export type ReassignDirectReportsInput = {
  /** The ID of the PartnerMemberProfile (the manager) whose direct reports are being reassigned. */
  previousManagerId: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile of the manager to assign as the new manager. */
  newManagerId: Scalars['UUID'];
};

/** The output values returned to the client from the ReassignDirectReports mutation. */
export type ReassignDirectReportsOutput = {
  __typename?: 'ReassignDirectReportsOutput';
  /** Whether the direct reports reassignment was successful. */
  success: Scalars['Boolean'];
};

/** A single day of the week a recurrence rule falls on. */
export type RecurrenceByDay = {
  __typename?: 'RecurrenceByDay';
  /** The day of the week this entry falls on. */
  day: WeekDay;
};

/** The input values for a single recurrence by-day entry. */
export type RecurrenceByDayInput = {
  /** The day of the week this entry falls on. */
  day: WeekDay;
};

/** The frequency at which a recurrence rule repeats. */
export enum RecurrenceFrequency {
  /** The recurrence repeats every N weeks, per the interval. */
  WEEKLY = 'WEEKLY',
}

/** Represents the recurrence pattern for a recurring shift template. */
export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  /** The ID of the recurrence rule. */
  id: Scalars['UUID'];
  /** The frequency at which the rule repeats. */
  frequency: RecurrenceFrequency;
  /** The number of frequency units between each occurrence. */
  interval: Scalars['Int'];
  /** The days of the week the recurrence falls on. */
  byDay: Array<RecurrenceByDay>;
  /** The inclusive date after which no further occurrences are generated. Null if the recurrence has no end date. */
  until?: Maybe<Scalars['Date']>;
};

/** The input values required to create a RecurrenceRule. */
export type RecurrenceRuleInput = {
  /** The frequency at which the rule repeats. */
  frequency: RecurrenceFrequency;
  /** The number of frequency units between each occurrence. Must be >= 1. */
  interval: Scalars['Int'];
  /** The days of the week the recurrence falls on. */
  byDay: Array<RecurrenceByDayInput>;
  /** The inclusive date after which no further occurrences are generated. Omit for an open-ended recurrence. */
  until?: Maybe<Scalars['Date']>;
};

/** Represents a fixed weekly shift an employee always works. Unless overridden by a specific availability request or other unavailability. */
export type RecurringEmployeeShift = {
  __typename?: 'RecurringEmployeeShift';
  /** The ID of the recurring employee shift. */
  id: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile for this recurring employee shift. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the Site for this recurring employee shift. */
  siteId: Scalars['UUID'];
  /** The day of the week this shift recurs on. */
  dayOfWeek: WeekDay;
  /** The time of day the shift starts. */
  startTime: Scalars['Time'];
  /** The time of day the shift ends. */
  endTime: Scalars['Time'];
  /** The optional RoleConfiguration the employee is scheduled as for this recurring shift. */
  role?: Maybe<RoleConfiguration>;
};

/** Represents a single resolved occurrence of a recurring non-service shift or delivery for a Site. */
export type RecurringEventOccurrence = {
  __typename?: 'RecurringEventOccurrence';
  /** The date this occurrence falls on. */
  occurrenceDate: Scalars['Date'];
  /** The template active on this date. Absent for one-off entries and for occurrences sourced from a completed read-only schedule. */
  template?: Maybe<RecurringShiftTemplate>;
  /** The event type this occurrence represents. */
  eventType: RecurringEventType;
  /** The resolved non-service shift type for this occurrence. Null for DELIVERY occurrences. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The resolved name of the occurrence. */
  name?: Maybe<Scalars['String']>;
  /** The timezone-aware date and time the occurrence starts. */
  startDateTime: Scalars['DateTime'];
  /** The timezone-aware date and time the occurrence ends. */
  endDateTime: Scalars['DateTime'];
  /** The PartnerMember assigned to this occurrence. Null for DELIVERY occurrences and for occurrences with no assignment. */
  assignedMember?: Maybe<PartnerMember>;
  /** The resolved role configuration for this occurrence, if one is set. */
  role?: Maybe<RoleConfiguration>;
  /** True when the occurrence is sourced from a completed schedule and cannot be mutated via this API. Edit via the rota instead. */
  readOnly: Scalars['Boolean'];
};

/** The event type a recurring shift template represents. */
export enum RecurringEventType {
  /** A shift, such as prep, stock, or admin work. */
  SHIFT = 'SHIFT',
  /** A delivery. */
  DELIVERY = 'DELIVERY',
}

/** Represents a recurring non-service shift or delivery template for a Site. */
export type RecurringShiftTemplate = {
  __typename?: 'RecurringShiftTemplate';
  /** The ID of the recurring shift template. */
  id: Scalars['UUID'];
  /** The event type this template represents. */
  eventType: RecurringEventType;
  /** The optional name of the recurring shift template. */
  name?: Maybe<Scalars['String']>;
  /** The non-service shift type for this recurring shift template. Null for DELIVERY templates. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The role configuration for this recurring shift template, if one is set. Null for DELIVERY templates. */
  role?: Maybe<RoleConfiguration>;
  /** The date of the first occurrence. NOTE: This will be non-nullable after migration. */
  startDate?: Maybe<Scalars['Date']>;
  /**
   * The day of the week this shift recurs on. Retained for backwards compatibility.
   * @deprecated Use 'recurrence_rule' instead
   */
  dayOfWeek?: Maybe<WeekDay>;
  /** The time of day the shift starts. */
  startTime: Scalars['Time'];
  /** The time of day the shift ends. */
  endTime: Scalars['Time'];
  /** The recurrence rule governing this template's occurrences. Null for one-off templates. */
  recurrenceRule?: Maybe<RecurrenceRule>;
};

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: Scalars['String'];
  refreshToken: Scalars['String'];
};

/** The required values in order to regenerate the QR code for a Site. */
export type RegenerateSiteQRCodeInput = {
  /** The ID of the Site for which to regenerate the QR code. */
  siteId: Scalars['UUID'];
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  country?: Maybe<Country>;
  name?: Maybe<Scalars['String']>;
  /** Related country ID. */
  countryId?: Maybe<Scalars['UUID']>;
};

export type RegionFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** country_id */
  country_id?: Maybe<Scalars['UUID']>;
  /** country_id_isnull */
  country_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** The input values required to rehire an employee. */
export type RehireEmployeeInput = {
  /** The ID of the employee to rehire. */
  employeeId: Scalars['UUID'];
  /** The expected hours for the employee. */
  expectedHours: Scalars['Decimal'];
  /** The ID of the job title for the employee. */
  jobTitleId: Scalars['UUID'];
  /** The pay rate for the employee. */
  payRate: Scalars['Decimal'];
  /** The contract type for the employee. */
  contractType: ContractType;
  /** The optional contracted hours constraint for the employee. */
  contractedHoursConstraint?: Maybe<ContractedHoursConstraint>;
  /** The contracted hours for the employee. Null if the contracted hours constraint is unspecified. */
  contractedHours?: Maybe<Scalars['Decimal']>;
  /** The contracted days for the employee. Null if the contracted hours constraint is unspecified. */
  contractedDays?: Maybe<Scalars['Decimal']>;
  /** The date the employee is being rehired. This is used as the rehire date and the active_from date of the new working contract. */
  rehireDate: Scalars['Date'];
};

/** The output values from rehiring an employee. */
export type RehireEmployeeOutput = {
  __typename?: 'RehireEmployeeOutput';
  /** The PartnerMemberProfile associated with the rehired employee. */
  employee: PartnerMemberProfile;
};

/** The input values required to reject an employee holiday request. */
export type RejectEmployeeHolidayRequestInput = {
  /** The ID of the PartnerMemberProfile the holiday request belongs to. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the holiday request to reject. */
  holidayRequestId: Scalars['UUID'];
  /** The note to add to the holiday request rejection. */
  note?: Maybe<Scalars['String']>;
};

/** The output values from rejecting an employee holiday request. */
export type RejectEmployeeHolidayRequestOutput = {
  __typename?: 'RejectEmployeeHolidayRequestOutput';
  /** The holiday that was rejected. */
  holiday: CoreTeamMemberHolidayRequest;
};

/** The input values required to reject an out-of-term request. */
export type RejectOutOfTermRequestInput = {
  /** The ID of the out-of-term request to reject. */
  outOfTermRequestId: Scalars['UUID'];
};

/** The output type for the rejectOutOfTermRequest mutation. */
export type RejectOutOfTermRequestOutput = {
  __typename?: 'RejectOutOfTermRequestOutput';
  /** The rejected out-of-term request. */
  outOfTermRequest: OutOfTermRequest;
};

/** The input values required to reject a shift attendance. */
export type RejectShiftAttendanceInput = {
  /** The ID of the Site where the shift took place. */
  siteId: Scalars['UUID'];
  /** The ID of the shift to reject attendance for. */
  shiftId: Scalars['UUID'];
};

/** The output values from rejecting a shift attendance. */
export type RejectShiftAttendanceOutput = {
  __typename?: 'RejectShiftAttendanceOutput';
  /** The rejected shift attendance. */
  attendance: ShiftAttendance;
};

/** This class defines the input values that are required to reject a working preference request. */
export type RejectWorkingPreferenceRequestInput = {
  /** The ID of the WorkingPreferenceRequest to reject. */
  workingPreferenceRequestId: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile that is rejecting the working preference request. */
  rejectedById: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile the working preference request belongs to. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The reason for rejecting the working preference request. */
  reason?: Maybe<Scalars['String']>;
};

/** The output values that are returned after rejecting a working preference request. */
export type RejectWorkingPreferenceRequestOutput = {
  __typename?: 'RejectWorkingPreferenceRequestOutput';
  /** The working preference request that was rejected. */
  workingPreferenceRequest: WorkingPreferenceRequest;
};

/**
 * The RemoveAllStintersFromPartnerPoolInput class defines the input values that are required from the client in order
 * to reset a PartnerPool.
 */
export type RemoveAllStintersFromPartnerPoolInput = {
  /** The ID of the PartnerPool to reset. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the PartnerPool belongs to. */
  partnerNodeId: Scalars['UUID'];
};

/**
 * The RemoveStinterFromStintTemplatePoolInput type defines the input values that are required from the client for
 * removing Stinters from a StintTemplate object's Pool.
 */
export type RemoveStinterFromStintTemplatePoolInput = {
  /** The ID of the StintTemplate to remove the Stinter from. */
  stintTemplateId: Scalars['UUID'];
  /** The ID of the PartnerNode that the StintTemplate belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The StintTemplatePoolMember ID to remove from the StintTemplate's Pool. */
  stintTemplatePoolMemberId: Scalars['UUID'];
  /** The list of reason IDs for which a stinter is being removed from a StintTemplate's Pool */
  reasons: Array<Scalars['UUID']>;
  /** The user type who is requesting the stinter removal from a StintTemplate's Pool. */
  removedBy: MemberRemovalRemovedBy;
  /**
   * The Additional free text reason that the user can enter to accompany the selected reasons
   *
   * This is an optional field and is only required when a reason that requires more info is submitted.
   */
  moreInfo?: Maybe<Scalars['String']>;
};

/**
 * The RemoveStintersFromPartnerPoolInput class defines the input values that are required from the client in order
 * to remove Stinters from a PartnerPool.
 */
export type RemoveStintersFromPartnerPoolInput = {
  /** The ID of the PartnerPool to remove Stinters from. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the PartnerPool belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The list of PartnerPoolInvite IDs to remove from the PartnerPool. */
  partnerPoolInviteIds: Array<Scalars['UUID']>;
};

/**
 * The RemoveStintersFromStintTemplatePoolInput class defines the input values that are required from the client for
 * removing Stinters from a StintTemplate object's Pool.
 */
export type RemoveStintersFromStintTemplatePoolInput = {
  /** The ID of the StintTemplate whose Pool Stinters will be removed from. */
  stintTemplateId: Scalars['UUID'];
  /** The ID of the PartnerNode that the StintTemplate belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The list of StintTemplatePoolMember IDs to remove from the StintTemplate's Pool. */
  stintTemplatePoolMemberIds: Array<Scalars['UUID']>;
};

/** The required values in order to retrieve reporting data for an Account PartnerNode. */
export type ReportingDataInput = {
  /** The type of report to load */
  type: ReportingDataType;
  /** The type of report timeframe to load */
  timeframe: ReportingDataTimeframe;
  /** The commencing date to load data. start of year for years, start of quarter for quarters, start of month for months, start of week for weeks */
  commencingDate: Scalars['Date'];
};

/** The required values in order to retrieve reporting data for a PartnerNode. */
export type ReportingDataInputV2 = {
  /** The type of report to load */
  type: ReportingDataType;
  /** The type of report timeframe to load */
  timeframe: ReportingDataTimeframe;
  /** The commencing date to load data. start of year for years, start of quarter for quarters, start of month for months, start of week for weeks */
  commencingDate: Scalars['Date'];
  /** The PartnerNode ID used as the S3 folder when loading reporting data. */
  partnerNodeId: Scalars['UUID'];
};

/** The response to the reporting data query. */
export type ReportingDataOutput = {
  __typename?: 'ReportingDataOutput';
  /** Contains a stringified json containing the data loaded for the requested type/timeframe. This will be null when there is no data present for the specified filters. */
  data?: Maybe<Scalars['String']>;
};

/** Enum that contains the available options for selecting a reporting timeframe. */
export enum ReportingDataTimeframe {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
}

/** Enum that contains the available options for selecting a report. */
export enum ReportingDataType {
  SALES_PERFORMANCE = 'SALES_PERFORMANCE',
  SCHEDULE_COMPLIANCE = 'SCHEDULE_COMPLIANCE',
  WTD = 'WTD',
  EXPECTED_HOURS = 'EXPECTED_HOURS',
  SALES_PERFORMANCE_V2 = 'SALES_PERFORMANCE_V2',
  SCHEDULE_COMPLIANCE_V2 = 'SCHEDULE_COMPLIANCE_V2',
  WTD_V2 = 'WTD_V2',
  EXPECTED_HOURS_V2 = 'EXPECTED_HOURS_V2',
  UNDER_STAFFING = 'UNDER_STAFFING',
  OVER_STAFFING = 'OVER_STAFFING',
  TEAM_MEMBER_EXPERIENCE = 'TEAM_MEMBER_EXPERIENCE',
  TEAM_DATA = 'TEAM_DATA',
  NON_SERVICE_SHIFTS = 'NON_SERVICE_SHIFTS',
  TEAM_SENTIMENT = 'TEAM_SENTIMENT',
  HOLIDAY_USAGE = 'HOLIDAY_USAGE',
  FORECAST_CHANGES = 'FORECAST_CHANGES',
  BREAK_COMPLIANCE = 'BREAK_COMPLIANCE',
  OVERTIME = 'OVERTIME',
  STINT_FORECASTING = 'STINT_FORECASTING',
  TURNOVER_REASONS = 'TURNOVER_REASONS',
  EMPLOYEE_STATUS = 'EMPLOYEE_STATUS',
  ABSENCE = 'ABSENCE',
  LATENESS = 'LATENESS',
  CLOCK_IN_CLOCK_OUT = 'CLOCK_IN_CLOCK_OUT',
  CUSTOMER_REVIEWS = 'CUSTOMER_REVIEWS',
  CUSTOMER_DISCOUNTS = 'CUSTOMER_DISCOUNTS',
  SALES_PERFORMANCE_V3 = 'SALES_PERFORMANCE_V3',
  SCHEDULE_COMPLIANCE_V3 = 'SCHEDULE_COMPLIANCE_V3',
  PROFIT_OPPORTUNITY = 'PROFIT_OPPORTUNITY',
  EMPLOYEE_INFO_MASTER_REPORT = 'EMPLOYEE_INFO_MASTER_REPORT',
  HEADCOUNT = 'HEADCOUNT',
}

/** Enum for request to be forgotten failure reasons. */
export enum RequestToBeForgottenFailureReason {
  PERFORMED_STINT = 'PERFORMED_STINT',
  EMPLOYER_STATUS = 'EMPLOYER_STATUS',
}

/** The input type accepted by the requestToBeForgotten mutation. */
export type RequestToBeForgottenInput = {
  /** The ID of the user who is requesting to be forgotten. This allows staff users to request on behalf of others. */
  userId: Scalars['UUID'];
  /**
   * The date on which the action to forgot the user will be made.
   * If omitted, the action will take place using the configured `NUMBER_OF_DAYS_UNTIL_FORGOTTEN_ACTIONED` days.
   * If the date is provided in the past, the action will be taken the next time the scheduled task runs.
   * The scheduled task runs only once per day.
   */
  actionDate?: Maybe<Scalars['DateTime']>;
  /** Instruction from the user to deactivate their account if it is unable to be forgotten. Default=False. */
  deactivateIfUnforgettable?: Maybe<Scalars['Boolean']>;
};

/** The result of a request to be forgotten. */
export type RequestToBeForgottenResult = {
  __typename?: 'RequestToBeForgottenResult';
  /** Indicates if the request was successful. */
  success: Scalars['Boolean'];
  /** The reason that the user was unable to be forgotten. */
  failureReason?: Maybe<RequestToBeForgottenFailureReason>;
  /** The datetime that the user will be forgotten. */
  scheduledAt?: Maybe<Scalars['DateTime']>;
};

/** The input values required from a client to resend a partner webhook. The webhook will be queued to be sent again to the configured endpoint. */
export type ResendPartnerWebhookInput = {
  /** The ID of the partner account that the webhook belongs to. */
  accountId: Scalars['UUID'];
  /** The ID of the webhook record to resend. */
  webhookId: Scalars['UUID'];
};

/** The output values returned after resending a partner webhook. */
export type ResendPartnerWebhookOutput = {
  __typename?: 'ResendPartnerWebhookOutput';
  /** The details of the webhook that was queued to be sent again. */
  webhook: PartnerWebhookType;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  /** User obtain a JWT access and refresh token */
  token?: Maybe<Scalars['String']>;
  /** User obtain a JWT access and refresh token */
  refreshToken?: Maybe<Scalars['String']>;
};

/** The input values required to reset a SiteSchedule. */
export type ResetSiteScheduleInput = {
  /** The ID of the Site that the SiteSchedule belongs to. */
  siteId: Scalars['UUID'];
  /** The date on which the SiteSchedule starts. */
  weekCommencing: Scalars['Date'];
  /** The string date and time value for when the SiteSchedule was last modified. */
  modifiedAt: Scalars['String'];
};

export enum ReviewReviewType {
  /** Business */
  BUSINESS = 'BUSINESS',
  /** Student */
  STUDENT = 'STUDENT',
  /** Internal */
  INTERNAL = 'INTERNAL',
  /** Phantom */
  PHANTOM = 'PHANTOM',
}

/** The input values required to review a SiteSchedule. */
export type ReviewSiteScheduleInput = {
  /** The ID of the Site for which the SiteSchedule is being reviewed. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule being reviewed. */
  siteScheduleId: Scalars['UUID'];
  /** Whether or not the SiteSchedule is being approved. True means that it is approved and False means that it is rejected. */
  approved: Scalars['Boolean'];
  /** The rejection data for the SiteSchedule review if it is being rejected. This field is required if the SiteSchedule is being rejected. */
  rejectionData?: Maybe<SiteScheduleReviewRejectionDataInput>;
  /** The last modified at timestamp of the SiteSchedule used to determine if the schedule has been updated since the review was initiated to prevent a review being left for an out of date schedule. */
  lastModifiedAt: Scalars['String'];
};

/** The output values available to the client after reviewing a SiteSchedule. */
export type ReviewSiteScheduleOutput = {
  __typename?: 'ReviewSiteScheduleOutput';
  /** The review data for the SiteSchedule. */
  review: SiteScheduleReview;
};

/** The input values required to revoke a partner account API token. */
export type RevokePartnerAccountAPITokenInput = {
  /** The ID of the token to revoke. */
  tokenId: Scalars['UUID'];
};

/** The output values returned from the revokePartnerAccountAPIToken mutation. */
export type RevokePartnerAccountAPITokenOutput = {
  __typename?: 'RevokePartnerAccountAPITokenOutput';
  /** The revoked token record. */
  token: PartnerAccountAPIToken;
};

/** The right-to-work settings for a partner account. */
export type RightToWorkSettings = {
  __typename?: 'RightToWorkSettings';
  /** Whether right-to-work functionality is available for the partner account. Defaults to true. */
  employeeRtwEnabled: Scalars['Boolean'];
  /** Whether an employee must have a verified right-to-work document to accept or assign a shift. Defaults to true. */
  employeeRtwDocumentRequired: Scalars['Boolean'];
};

/** Input for updating the right-to-work settings for a partner account. */
export type RightToWorkSettingsInput = {
  /** Whether right-to-work functionality is available for the partner account. */
  employeeRtwEnabled: Scalars['Boolean'];
  /** Whether an employee must have a verified right-to-work document to accept or assign a shift. */
  employeeRtwDocumentRequired?: Maybe<Scalars['Boolean']>;
};

/** Configuration for a partner-specific role that maps to an auto schedule role and operational area. */
export type RoleConfiguration = {
  __typename?: 'RoleConfiguration';
  /** The ID of the RoleConfiguration. */
  id: Scalars['UUID'];
  /** The name of the role configuration. */
  name: Scalars['String'];
  /** The auto schedule role that this role configuration maps to. */
  autoScheduleRole: AutoScheduleRole;
  /** The operational area that this role configuration is associated with. */
  operationalArea: OperationalArea;
  /** The display order of this role configuration. */
  orderIdx: Scalars['Int'];
  /** The rules that define constraints for this role configuration. */
  rules: RoleConfigurationRules;
  /** The partner account that this role configuration belongs to. */
  partnerAccount: PartnerAccountProfile;
};

/** Rules that define constraints for a RoleConfiguration. */
export type RoleConfigurationRules = {
  __typename?: 'RoleConfigurationRules';
  /** The minimum headcount duration in minutes for this role configuration. */
  minHeadcountDurationMinutes: Scalars['Int'];
  /** The maximum headcount duration in minutes for this role configuration. */
  maxHeadcountDurationMinutes: Scalars['Int'];
  /** The minimum shift duration in minutes for this role configuration. */
  minShiftDurationMinutes: Scalars['Int'];
  /** The maximum shift duration in minutes for this role configuration. */
  maxShiftDurationMinutes: Scalars['Int'];
  /** Determines the maximum amount of headcounts that can exist for the underlying auto-schedule role. When null, there is no limit. For MANAGER this is 1, for SHIFT_MANAGER this is 0, otherwise null. */
  maxHeadcountCount?: Maybe<Scalars['Int']>;
  /** Whether the role configuration can be used on a shift or headcount. False for SHIFT_MANAGER. */
  canBeShiftOrHeadcount: Scalars['Boolean'];
  /** Determines whether or not shifts or headcounts with the role configuration cover forecasted item demand, which the front-end uses to calculate item coverage per shift or headcount. For MANAGER this is WHEN_ALONE, for CLEANER this is NEVER, else ALWAYS. */
  itemCoversBehaviour: ItemCoversBehaviour;
  /** The assumed secondary role configurations for anyone with this role configuration. SHIFT_MANAGER has implicit secondary roles MANAGER and TEAM_MEMBER_FRONT_OF_HOUSE. */
  implicitSecondaryRoles: Array<RoleConfiguration>;
  /** The role configurations that this role configuration must be present for in the context of headcount. */
  dependents: Array<RoleConfiguration>;
  /** The contract type used when creating open shifts for this role configuration. */
  openShiftContractType: ContractType;
  /** The hourly pay rate for open shifts with this role configuration. */
  openShiftHourlyPayRate: Scalars['Decimal'];
  /** Whether expected hours should be enforced for this role configuration. */
  enforceExpectedHours: Scalars['Boolean'];
  /** Whether this role configuration's headcounts should be hidden in the opportunities module. */
  hideInOpportunities: Scalars['Boolean'];
};

/** The labour metrics breakdown for a specific role configuration across the week. */
export type RoleLabourMetricsBreakdown = {
  __typename?: 'RoleLabourMetricsBreakdown';
  /** The ID of the role configuration. */
  roleConfigurationId: Scalars['UUID'];
  /** The role configuration for this labour metrics breakdown. */
  role: RoleConfiguration;
  /** The labour metrics breakdown across the week for this role configuration. */
  breakdown: LabourMetricsWeekBreakdown;
};

/** A Schedule represents a day of the week for a SiteSchedule which contains the shifts for the day as well as some metrics for the day. */
export type Schedule = {
  __typename?: 'Schedule';
  /** The shifts scheduled for the day. */
  shifts: Array<Shift>;
  /** The optimal labour deployment for the Site on the given date based on the forecasted demand. */
  optimalHeadcounts: Array<Headcount>;
  /**
   * The labour percentage value for the day. The percentage value is a value between 0 and 1.
   * @deprecated No longer used by the FE but older versions of the app are still querying this field.
   */
  labourPercentage?: Maybe<Scalars['Decimal']>;
  /** The expected forecast for the day. This is a copy of the effective forecast from the DemandForecast for the day. */
  expectedForecast: Scalars['Int'];
  /** Whether the day has a new recommended SystemSalesForecast. */
  hasNewRecommendedSystemSalesForecast?: Maybe<Scalars['Boolean']>;
  /**
   * The optimal shifts for the Site on the given date based on the forecasted demand.
   * @deprecated This field is deprecated and will be removed in the future. Use optimal_headcounts instead.
   */
  optimalShifts?: Maybe<Array<Headcount>>;
};

/** A drift between the schedule and Stint's recommendations for one operational area over one time region. */
export type ScheduleLabourSuggestion = {
  __typename?: 'ScheduleLabourSuggestion';
  /** The unique identifier for the Schedule Labour Suggestion. */
  id: Scalars['UUID'];
  /** Drift category — Understaffing, Overstaffing, or Opportunity. */
  category: ScheduleLabourSuggestionCategory;
  /** The operational area this Schedule Labour Suggestion applies to. */
  operationalArea: OperationalArea;
  /** Start of the schedule interval this Schedule Labour Suggestion applies to (30-min aligned). */
  start: Scalars['DateTime'];
  /** End of the schedule interval this Schedule Labour Suggestion applies to (30-min aligned). */
  end: Scalars['DateTime'];
  /** Source HeadcountOpportunity. Populated only when category = OPPORTUNITY. */
  opportunity?: Maybe<HeadcountOpportunity>;
  /** All eligible options. Empty list when no option could be generated for this region. */
  options: Array<ScheduleLabourSuggestionOption>;
  /** True when this suggestion's saving window is already fully or partially covered by the current rota state. Read-only — set by the BI suggestion generator, not by GM actions. */
  appliedToSiteSchedule: Scalars['Boolean'];
};

/** The drift category of a Schedule Labour Suggestion. */
export enum ScheduleLabourSuggestionCategory {
  /** Schedule's labour deployment falls below the Lower Limit (Replica minus saving opportunities, floored at zero). */
  UNDERSTAFFING = 'UNDERSTAFFING',
  /** Schedule's labour deployment exceeds the Upper Limit (Replica plus investment opportunities). */
  OVERSTAFFING = 'OVERSTAFFING',
  /** Schedule's labour deployment sits between the Lower Limit and the Upper Limit, exclusive of a Replica match. Covers both Save (HeadcountOpportunityType.SUBTRACT) and Invest (HeadcountOpportunityType.ADD) opportunity bands; the opportunity's own type field distinguishes them. */
  OPPORTUNITY = 'OPPORTUNITY',
}

/** One specific way the GM can resolve a Schedule Labour Suggestion. */
export type ScheduleLabourSuggestionOption = {
  __typename?: 'ScheduleLabourSuggestionOption';
  /** The unique identifier for the Schedule Labour Suggestion Option. */
  id: Scalars['UUID'];
  /** The variant — what the Option does to the schedule if applied. */
  variant: ScheduleLabourSuggestionOptionVariant;
  /** Start of the shift interval this Option targets after apply (30-min aligned). Null for variant = REMOVE_SHIFT — the FE uses targetShift's interval instead. */
  start?: Maybe<Scalars['DateTime']>;
  /** End of the shift interval this Option targets after apply (30-min aligned). Null for variant = REMOVE_SHIFT. */
  end?: Maybe<Scalars['DateTime']>;
  /** The existing Shift this Option mutates. Null for variant in (ADD_ASSIGNED_SHIFT, ADD_OPEN_SHIFT). */
  targetShift?: Maybe<Shift>;
  /** Stint's recommended core team member. Set only for variant = ADD_ASSIGNED_SHIFT. */
  recommendedEmployee?: Maybe<CoreTeamMember>;
};

/** The variant of a Schedule Labour Suggestion Option. */
export enum ScheduleLabourSuggestionOptionVariant {
  /** Extend the start of an existing shift earlier. */
  EXTEND_SHIFT_START = 'EXTEND_SHIFT_START',
  /** Extend the end of an existing shift later. */
  EXTEND_SHIFT_END = 'EXTEND_SHIFT_END',
  /** Trim the start of an existing shift later. */
  TRIM_SHIFT_START = 'TRIM_SHIFT_START',
  /** Trim the end of an existing shift earlier. */
  TRIM_SHIFT_END = 'TRIM_SHIFT_END',
  /** Add a new shift with a recommended assigned core team member. */
  ADD_ASSIGNED_SHIFT = 'ADD_ASSIGNED_SHIFT',
  /** Add a new open shift; the GM optionally picks an assignee before applying. */
  ADD_OPEN_SHIFT = 'ADD_OPEN_SHIFT',
  /** Remove an existing shift. */
  REMOVE_SHIFT = 'REMOVE_SHIFT',
}

/** This type contains the input values required to update a site schedule shift. */
export type ScheduleShiftUpdateInfo = {
  /** The reason for the shift update. */
  reason: ScheduleShiftUpdateReason;
  /** The explanation for the shift update. */
  explanation?: Maybe<Scalars['String']>;
};

/** The reason for the shift update. */
export enum ScheduleShiftUpdateReason {
  /** The shift update is made to meet demand. */
  MEET_DEMAND = 'MEET_DEMAND',
  /** The shift update is made due to a stock delivery. */
  STOCK_DELIVERY = 'STOCK_DELIVERY',
  /** The shift update is made due to an event. */
  EVENT = 'EVENT',
  /** The shift update is made based on historical working patterns. */
  HISTORICAL = 'HISTORICAL',
  /** Working preferences were pointed as the reason for the shift update. */
  WORKING_PREFERENCES = 'WORKING_PREFERENCES',
  /** More staff were needed as the reason for the shift update. */
  NEED_MORE_STAFF = 'NEED_MORE_STAFF',
  /** Experience level was pointed as the reason for the shift update. */
  EXPERIENCE_LEVEL = 'EXPERIENCE_LEVEL',
  /** Expected hours were pointed as the reason for the shift update. */
  EXPECTED_HOURS = 'EXPECTED_HOURS',
  /** Legal requirements were pointed as the reason for the shift update. */
  LEGAL_REQUIREMENT = 'LEGAL_REQUIREMENT',
  /** The shift update is made due to a non-service reason. */
  NON_SERVICE = 'NON_SERVICE',
  /** The recommended shift was ignored. */
  RECOMMENDED_SHIFT_IGNORED = 'RECOMMENDED_SHIFT_IGNORED',
  /** An open shift was assigned. */
  ASSIGNING_OPEN_SHIFT = 'ASSIGNING_OPEN_SHIFT',
  /** A trainee shift was added or edited. */
  TRAINEE = 'TRAINEE',
  /** An offsite shift was added or edited. */
  OFFSITE = 'OFFSITE',
  /** Other was mentioned as the reason for the shift update. */
  OTHER = 'OTHER',
  /** The shift was automatically changed to absent. */
  ABSENT = 'ABSENT',
  /** The shift was automatically changed due to a termination. */
  TERMINATION = 'TERMINATION',
}

/** The status values of a SiteSchedule. */
export enum ScheduleStatus {
  /** The SiteSchedule is currently being generated. */
  GENERATING = 'GENERATING',
  /** The SiteSchedule is generated and ready to be viewed. */
  COMPLETE = 'COMPLETE',
  /** The SiteSchedule has been reset. */
  RESET = 'RESET',
  /** An error occurred while generating the SiteSchedule. */
  ERROR = 'ERROR',
}

/** Input for resolving the scheduling configuration for an employee at a specific site. */
export type SchedulingConfigurationInput = {
  /** The site for which the employee's scheduling configuration is being requested. */
  siteId: Scalars['UUID'];
};

export type SendOTPEmail = {
  __typename?: 'SendOTPEmail';
  /** Returns true if set password was successful. */
  success?: Maybe<Scalars['Boolean']>;
};

export type SendOTPSMS = {
  __typename?: 'SendOTPSMS';
  /** Returns true if the OTP was sent successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * This mutation allows React Admin users to send a one-time password (OTP) to a student's phone number.
 * Unless like the previous SendOTPSMS, it takes a user ID instead of a phone number.
 *
 * It is only used by the React Admin. The mutation 'SendOTPSMSV2' is still being used on the mobile to
 * avoid breaking changes. (A mobile has no knowledge of its user ID when attempting to retrieve a OTP)
 */
export type SendOTPSMSV2 = {
  __typename?: 'SendOTPSMSV2';
  /** Returns true if the OTP was sent successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/** The input values required from a client to send a test partner webhook. A standardized test payload will be automatically generated based on the event type in the partner webhooks service. */
export type SendTestPartnerWebhookInput = {
  /** The ID of the partner account that we are sending webhooks for. */
  accountId: Scalars['UUID'];
  /** The type of event being sent. This determines the structure of the auto-generated test payload. */
  eventType: PartnerWebhookEventType;
};

/** The output values returned after sending a test partner webhook. */
export type SendTestPartnerWebhookOutput = {
  __typename?: 'SendTestPartnerWebhookOutput';
  /** The details of the test webhook that was created and queued to be sent. */
  webhook: PartnerWebhookType;
};

/** Enum that contains the available error message codes that can be used to raise errors from the service layer. */
export enum ServiceError {
  BAD_REQUEST = 'BAD_REQUEST',
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNEXPECTED_RESPONSE = 'UNEXPECTED_RESPONSE',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
}

/** A service KPI performing below its usual level (e.g. table turnover, ASPH), backing an Invest opportunity as evidence that extra cover is needed to protect service. */
export type ServiceSignal = {
  __typename?: 'ServiceSignal';
  /** The service signal being represented. */
  serviceSignalType: ServiceSignalType;
  /** The measured value for this service signal, as a decimal string. */
  value: Scalars['String'];
  /** How far the measured value falls under the baseline, as a decimal percentage string. */
  percentUnderBaseline: Scalars['String'];
};

/** The service metric a signal is measured against. */
export enum ServiceSignalType {
  /** The service signal type has not been set. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** The signal is measured against table turnover. */
  TABLE_TURN_OVER = 'TABLE_TURN_OVER',
  /** The signal is measured against average spend per head. */
  AVERAGE_SPEND_PER_HEAD = 'AVERAGE_SPEND_PER_HEAD',
  /** The signal is measured against delivery prep time. */
  DELIVERY_PREP_TIME = 'DELIVERY_PREP_TIME',
}

/** The GraphQL input values for setting a StintWeekTemplate as default. */
export type SetDefaultStintWeekTemplateInput = {
  /** The ID (ref) of the StintWeekTemplate that will be set as default for a Business. */
  templateId: Scalars['UUID'];
  /** The ID (ref) of the Business that the StintWeekTemplate belongs to. */
  businessId: Scalars['UUID'];
};

export type SetPassword = {
  __typename?: 'SetPassword';
  /** Returns true if set password was successful. */
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * The SetupIntent class defines the Graphene ObjectType class used to resolve the
 * data for a SetupIntent created via the Stripe API.
 */
export type SetupIntent = {
  __typename?: 'SetupIntent';
  /** ID of the SetupIntent */
  id?: Maybe<Scalars['String']>;
  /** The client secret used for securely capturing card details. */
  clientSecret?: Maybe<Scalars['String']>;
  /** The Striped ID for this business */
  customerId?: Maybe<Scalars['String']>;
};

/** A Shift represents a shift in a SiteSchedule which contains the times, type of shift and an optional assigned core team member profile ID. */
export type Shift = {
  __typename?: 'Shift';
  /** The unique identifier of the Shift in the SiteSchedule. */
  id: Scalars['UUID'];
  /** The optional name of the Shift to be displayed. */
  name?: Maybe<Scalars['String']>;
  /** The role configuration ID for this shift. For Stint shifts, this will be null. For non-Stint shifts, this identifies the role configuration used. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** The role configuration for the shift. */
  role?: Maybe<RoleConfiguration>;
  /** Flag indicating whether this is a Stint shift. When true, the shift is a Stint shift and role_configuration_id will be null. When false, the shift uses a role configuration. */
  isStint: Scalars['Boolean'];
  /** The start time of the shift. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The end time of the shift. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
  /** The last time the shift was modified. This is a string because of potential discrepancy whenconverting between DateTime types. */
  modifiedAt?: Maybe<Scalars['String']>;
  /** The assigned core team member profile ID when the shift is a core team type in a SiteSchedule. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The other shifts that are happening on the same day as this shift at the same site. */
  otherShiftsToday: Array<OtherShiftToday>;
  /** The breaks that the core team member will take during their shift. */
  shiftBreaks: Array<ShiftBreak>;
  /** Flag to mark whether or not the shift should be displayed on the UI. */
  hidden: Scalars['Boolean'];
  /** The site that the Shift belongs to. */
  partnerSite: PartnerSiteProfile;
  /** The name of the PartnerSite that the Shift belongs to. This value is retrieved from the Monolith and appended to the Shift object. Used when the shift is at a different site to the one that is being requested for. */
  partnerSiteName: Scalars['String'];
  /** Holds time and attendance data about a shift. */
  attendance?: Maybe<ShiftAttendance>;
  /** Flag to mark whether all shift attendances for the related SiteSchedule have been confirmed. */
  siteScheduleAllShiftAttendancesConfirmed: Scalars['Boolean'];
  /** The ID of the stint template (role) that this shift belongs to, if STINT type. */
  stintTemplateId?: Maybe<Scalars['UUID']>;
  /** The stint template (role) that this shift belongs to, if STINT type. */
  stintTemplate?: Maybe<StintTemplate>;
  /** For service shifts, the value is null. For non-service shifts, the value represents the type of non-service. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** Flag to indicate whether breaks are paid for this shift. */
  breaksPaid: Scalars['Boolean'];
  /** Whether this shift has ever been created or updated using AI assistance. */
  aiAssisted: Scalars['Boolean'];
  /** The optional instructions for the shift. */
  shiftInstructions?: Maybe<Scalars['String']>;
  /** The review of this shift by the employee. */
  employeeShiftReview?: Maybe<EmployeeShiftReview>;
};

/** A Shift represents a shift in a SiteSchedule which contains the times, type of shift and an optional assigned core team member profile ID. */
export type ShiftemployeeShiftReviewArgs = {
  input: GetEmployeeShiftReviewInput;
};

/** A ShiftAttendance represents the attendance of a core team member during a shift. */
export type ShiftAttendance = {
  __typename?: 'ShiftAttendance';
  /** The time the core team member checked in to the shift. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  checkedInAt?: Maybe<Scalars['DateTime']>;
  /** The time the core team member checked out of the shift. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  checkedOutAt?: Maybe<Scalars['DateTime']>;
  /** How the shift was checked out of, if it has been checked out. */
  checkOutType?: Maybe<CheckOutType>;
  /** The status of the assigned shift. */
  status: ShiftAttendanceStatus;
  /** The breaks the core team member took during the shift, if any breaks have been added. */
  breaks?: Maybe<Array<ShiftBreak>>;
  /** The activity log of actions taken on this ShiftAttendance. */
  activityLog: Array<ShiftAttendanceActivityLog>;
};

/** An entry in the activity log of a ShiftAttendance. */
export type ShiftAttendanceActivityLog = {
  __typename?: 'ShiftAttendanceActivityLog';
  /** The type of action that took place. */
  type: Scalars['String'];
  /** The method by which the action was taken. */
  method: Scalars['String'];
  /** The time the action took effect. */
  effectiveTime: Scalars['DateTime'];
  /** The time the action took effect prior to this action, if any. */
  previousEffectiveTime?: Maybe<Scalars['DateTime']>;
  /** The datetime when the action took place. */
  activityAt: Scalars['DateTime'];
  /** The partner member profile who performed the action. */
  activityBy?: Maybe<PartnerMemberProfile>;
};

export enum ShiftAttendanceStatus {
  /** The shift is scheduled to be worked. */
  SCHEDULED = 'SCHEDULED',
  /** The shift attendance values have been approved by a manager. */
  APPROVED = 'APPROVED',
  /** The shift attendance values have been rejected by a manager. */
  REJECTED = 'REJECTED',
  /** The shift has been checked in to. */
  CHECKED_IN = 'CHECKED_IN',
  /** The shift has been checked out of. */
  CHECKED_OUT = 'CHECKED_OUT',
}

/** A ShiftBreak represents the start and end time of a core team member's break during their shift. */
export type ShiftBreak = {
  __typename?: 'ShiftBreak';
  /** The start time of the break. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The end time of the break. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
};

/** The input values required from the client in order to create or update a ShiftBreak. */
export type ShiftBreakInput = {
  /** The start time of the break. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The end time of the break. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
};

/** A paginated connection type that includes Shift edges and pagination info. */
export type ShiftConnection = {
  __typename?: 'ShiftConnection';
  /** Pagination metadata used to navigate through the list of results. */
  pageInfo: PageInfo;
  /** A list of Shift nodes in the current page of results. */
  shifts: Array<Shift>;
};

/** The input values required from the client in order to create or update a Shift. */
export type ShiftInput = {
  /** The unique identifier of the Shift in the SiteSchedule. This is currently optional in order to preserve backwards compatibility. Once the app has been updated to always provide the ID, this field will be required. */
  id?: Maybe<Scalars['UUID']>;
  /** The optional recurring shift template ID that corresponds to this shift. */
  recurringShiftTemplateId?: Maybe<Scalars['UUID']>;
  /** The optional name of the Shift to be inputted. */
  name?: Maybe<Scalars['String']>;
  /** The optional role configuration ID for the shift. When provided, the shift will be associated with the specified role configuration. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** Flag indicating if this is a stint shift. */
  isStint: Scalars['Boolean'];
  /** For service shifts, the value is null. For non-service shifts, the value is set to the type of non-service. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The Start Time of the Shift. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The End Time of the Shift. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
  /** The assigned core team member profile ID when the shift is a core team type in a SiteSchedule. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The breaks that the core team member will take during their shift. */
  shiftBreaks?: Maybe<Array<ShiftBreakInput>>;
  /** Flag to mark whether or not the shift should be displayed on the UI. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** The ID of the stint template (role) that this shift belongs to, if STINT type. */
  stintTemplateId?: Maybe<Scalars['UUID']>;
};

/** The input values required to resolve a relay paginated list of Shifts for partner members at other sites. */
export type ShiftsAtOtherSitesInput = {
  /** The date to fetch shifts that start on or after. */
  startFromDate: Scalars['Date'];
  /** The date to fetch shifts that start on or before. */
  startToDate: Scalars['Date'];
};

/** The BI service site-level feature flag settings for a Site. */
export type SiteBISettings = {
  __typename?: 'SiteBISettings';
  /** Whether or not custom rules are enabled for the rota at this site. */
  rotaCustomRulesEnabled: Scalars['Boolean'];
  /** Whether the site operates on the Covers concept. */
  coversEnabled: Scalars['Boolean'];
  /** Whether or not the Willow AI Agent feature is enabled for this site. */
  willowAiAgentEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Considerations feature is enabled for this site. */
  willowConsiderationsEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Budgets comparison feature is enabled for this site. */
  willowBudgetsEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Opportunities feature is enabled for this site. */
  willowOpportunitiesEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Over & Under Usual feature is enabled for this site. */
  willowOverUnderUsualEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Hours Prioritisation feature is enabled for this site. */
  willowHoursPrioritisationEnabled: Scalars['Boolean'];
  /** The Willow labour model configured for this site. Defaults to OPTIMAL. */
  willowLabourModel: WillowLabourModel;
  /** The Site's weekly cost adjustment. Null when the Site has no adjustment configured. */
  weeklyCostAdjustment?: Maybe<SiteWeeklyCostAdjustment>;
};

/** The BI service site-level feature flag settings to apply when updating a Site's settings. */
export type SiteBISettingsInput = {
  /** Whether or not custom rules are enabled for the rota at this site. */
  rotaCustomRulesEnabled: Scalars['Boolean'];
  /** Whether the site operates on the Covers concept. */
  coversEnabled: Scalars['Boolean'];
  /** Whether or not the Willow AI Agent feature is enabled for this site. */
  willowAiAgentEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Considerations feature is enabled for this site. */
  willowConsiderationsEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Budgets comparison feature is enabled for this site. Can only be enabled when the labour model is Replica. */
  willowBudgetsEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Opportunities feature is enabled for this site. Can only be enabled when the labour model is Replica. */
  willowOpportunitiesEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Over & Under Usual feature is enabled for this site. Can only be enabled when the labour model is Replica. */
  willowOverUnderUsualEnabled: Scalars['Boolean'];
  /** Whether or not the Willow Hours Prioritisation feature is enabled for this site. */
  willowHoursPrioritisationEnabled: Scalars['Boolean'];
  /** The Willow labour model to set for this site. */
  willowLabourModel: WillowLabourModel;
  /** Set the Site's weekly cost adjustment. Omit to leave the Site without an adjustment. */
  weeklyCostAdjustment?: Maybe<SiteWeeklyCostAdjustmentInput>;
};

/**
 * The SiteCheckInDetails class defines the Graphene ObjectType class used to resolve information
 * about a Site's check in process (Previously business.stintopedia).
 */
export type SiteCheckInDetails = {
  __typename?: 'SiteCheckInDetails';
  /** The ID of the Stinopedia for the Site. */
  id: Scalars['UUID'];
  /** Stinters need to scan a QR code which encodes this UUID in order to check in to a Stint (previously business.qrCodeId). */
  qrCodeId: Scalars['UUID'];
  /** Stores misc data around where the QR code is located at a Site (i.e find the QR code behind the bar top next to the POS terminal.) */
  qrCodeLocation?: Maybe<Scalars['String']>;
  /** Helps visualise the entrace of the business. This is surfaced to stinters in their app, to help guide them when finding the business. */
  photoOfEntranceUrl?: Maybe<Scalars['String']>;
};

/** Details of the payment provider site mapping for a Partner Site. */
export type SitePaymentProvider = {
  __typename?: 'SitePaymentProvider';
  /** The ID of the provider site record. */
  providerSiteId: Scalars['UUID'];
  /** The ID of the Partner Site this record corresponds to. */
  siteId: Scalars['UUID'];
  /** The ID of the payment provider configuration associated with this site. */
  partnerProviderId: Scalars['UUID'];
  /** The external identifier used by the payment provider for this site. */
  externalSiteId: Scalars['String'];
  /** Indicates whether this provider site mapping is active. */
  isActive: Scalars['Boolean'];
};

/**
 * The SiteRates class defines the Graphene ObjectType class used to resolve the rates data that a Site will be
 * charged for Stints.
 */
export type SiteRates = {
  __typename?: 'SiteRates';
  /** The hourly rate we pay the Stinter. */
  stinterHourlyRate: Scalars['Float'];
  /** The hourly fee we charge the Site (excluding VAT). */
  siteHourlyFee: Scalars['Float'];
  /** The fee Stint takes plus any pension/holiday (excluding VAT). */
  stintHourlyFee: Scalars['Float'];
};

/** A SiteSchedule represents the rota for a Site on a given week which the BI service auto scheduler has produced. */
export type SiteSchedule = {
  __typename?: 'SiteSchedule';
  /** The ID of the SiteSchedule. */
  id: Scalars['UUID'];
  /** The Site ID for the SiteSchedule. */
  siteId: Scalars['UUID'];
  /** The date on which the SiteSchedule starts. */
  weekCommencing: Scalars['Date'];
  /** The generated week schedule for the Site. Null when the values are yet to be generated. */
  weekSchedule?: Maybe<WeekSchedule>;
  /** The core team members used during the generation of the SiteSchedule. */
  coreTeam: Array<CoreTeamMember>;
  /** The status of the SiteSchedule. */
  status: ScheduleStatus;
  /** The review data for the SiteSchedule. */
  review: SiteScheduleReview;
  /** String timestamp of when the SiteSchedule has been last updated. If there have been no updates, this will reflect the time of creation. */
  modifiedAt: Scalars['String'];
  /** Whether all attendances for the shifts in the schedule have been confirmed as correct. */
  allShiftAttendancesConfirmed: Scalars['Boolean'];
  /** The list of custom rules and their compliance levels for this SiteSchedule. */
  customRules: Array<SiteScheduleCustomRule>;
};

/** The input values required from a client to interact with the site schedule agent. */
export type SiteScheduleAgentInput = {
  /** The prompt to the agent from the user. */
  prompt: Scalars['String'];
  /** Additional context provided to the LLM that is not from the user's prompt. */
  context: Scalars['String'];
  /** The week commencing date of the site schedule where the conversation is taking place. */
  weekCommencing: Scalars['Date'];
  /** The ID of the site for which the site schedule is being discussed. */
  siteId: Scalars['UUID'];
  /** The timestamp of when the site schedule was last modified. Used to verify that the user has the most recent version of the schedule. This is intentionally kept as a string to avoid any addition/reduction of timestamp precision by conversions in the respective languages. This should be passed through to any actions taken by the LLM to ensure that the LLM is not working on an outdated version of the schedule. */
  siteScheduleModifiedAt: Scalars['String'];
};

/** The output values returned to the client from the SiteScheduleAgent mutation. */
export type SiteScheduleAgentOutput = {
  __typename?: 'SiteScheduleAgentOutput';
  /** The response generated by the LLM agent based on the user's prompt and additional context. */
  agentResponse: Scalars['String'];
  /** String timestamp of when the SiteSchedule has been last updated. If there have been no updates, this will reflect the time of creation. This will be requested on every chat interaction so that the frontend will know whether it needs to re-fetch the schedule. I.e. if the chat made any edits to the rota. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** A SiteScheduleCustomRule represents a custom rule that a SiteSchedule must comply with during rota generation. */
export type SiteScheduleCustomRule = {
  __typename?: 'SiteScheduleCustomRule';
  /** The ID of the SiteScheduleCustomRule. */
  id: Scalars['UUID'];
  /** The text of the custom rule. */
  rule: Scalars['String'];
  /** How well the SiteSchedule satisfied the custom rule. */
  complianceLevel: SiteScheduleCustomRuleComplianceLevel;
  /** Optional additional details about changes made to the rota to satisfy the custom rule. */
  details?: Maybe<Scalars['String']>;
  /** The source of this custom rule. */
  source: SiteScheduleCustomRuleSource;
};

/** The compliance level of a SiteScheduleCustomRule. */
export enum SiteScheduleCustomRuleComplianceLevel {
  /** The SiteSchedule is fully compliant with the custom rule. */
  FULL = 'FULL',
  /** The SiteSchedule is partially compliant with the custom rule. */
  PARTIAL = 'PARTIAL',
  /** The SiteSchedule is not compliant with the custom rule. */
  NONE = 'NONE',
}

/** The source of a SiteScheduleCustomRule. */
export enum SiteScheduleCustomRuleSource {
  /** The rule was manually created as a one-off. */
  MANUAL_ONE_OFF = 'MANUAL_ONE_OFF',
  /** The rule was generated by the rota pattern analyser. */
  ROTA_PATTERN_ANALYZER = 'ROTA_PATTERN_ANALYZER',
}

/** A SiteScheduleReview represents the review information for a SiteSchedule. This includes the status of the review and the Site details. */
export type SiteScheduleReview = {
  __typename?: 'SiteScheduleReview';
  /**
   * The ID of the Site.
   * @deprecated Use site.id instead.
   */
  siteId: Scalars['UUID'];
  /**
   * The name of the Site.
   * @deprecated Use site.name instead.
   */
  siteName: Scalars['String'];
  /** The Site that the SiteSchedule belongs to. */
  site: PartnerSiteProfile;
  /** The review status of the SiteSchedule. */
  reviewStatus: SiteScheduleReviewStatus;
  /** The rejection data for the SiteSchedule review if it has been rejected. */
  rejectionData?: Maybe<SiteScheduleReviewRejectionData>;
};

/** The reasons why a SiteSchedule review was rejected. */
export type SiteScheduleReviewRejectionData = {
  __typename?: 'SiteScheduleReviewRejectionData';
  /** Any days of the week where forecast edits have been rejected. */
  forecastEditsRejections: Array<WeekDay>;
  /** Any days of the week where hour deviations have been rejected. */
  hourDeviationsRejections: Array<WeekDay>;
  /** Any days of the week where opportunities have been rejected. */
  opportunitiesRejections: Array<WeekDay>;
  /** Whether or not the scheduled training has been rejected. */
  trainingRejected: Scalars['Boolean'];
  /** Whether or not the offsite events were rejected. */
  offsiteEventsRejected: Scalars['Boolean'];
  /** Whether or not the working time directive has been rejected. */
  workingTimeDirectiveRejected: Scalars['Boolean'];
  /** An optional explanation for the review rejection. */
  explanation: Scalars['String'];
};

/** The input values required to provide rejection reason data for a SiteSchedule review. */
export type SiteScheduleReviewRejectionDataInput = {
  /** Any days of the week where forecast edits have been rejected. */
  forecastEditsRejections: Array<WeekDay>;
  /** Any days of the week where hour deviations have been rejected. */
  hourDeviationsRejections: Array<WeekDay>;
  /** Any days of the week where opportunities have been rejected. */
  opportunitiesRejections?: Maybe<Array<WeekDay>>;
  /** Whether or not the scheduled training has been rejected. */
  trainingRejected: Scalars['Boolean'];
  /** Whether or not the offsite events were rejected. */
  offsiteEventsRejected: Scalars['Boolean'];
  /** Whether or not the working time directive was rejected. */
  workingTimeDirectiveRejected: Scalars['Boolean'];
  /** An optional explanation for the review rejection. */
  explanation: Scalars['String'];
};

/** The review status for a SiteSchedule. */
export enum SiteScheduleReviewStatus {
  /** The SiteSchedule is awaiting submission for review. */
  AWAITING = 'AWAITING',
  /** The SiteSchedule is ready for review. */
  READY = 'READY',
  /** The SiteSchedule has been approved. */
  APPROVED = 'APPROVED',
  /** The SiteSchedule has been rejected. */
  REJECTED = 'REJECTED',
}

/** A weekly cost adjustment added to a Site's labour cost from a given effective date onwards. Captures labour overhead that is not associated with any shifts in the schedule. */
export type SiteWeeklyCostAdjustment = {
  __typename?: 'SiteWeeklyCostAdjustment';
  /** The weekly amount. Non-zero, positive or negative, up to two decimal places. */
  amount: Scalars['Decimal'];
  /** The week-commencing date from which the adjustment applies, inclusive. */
  effectiveDate: Scalars['Date'];
};

/** Input for a weekly cost adjustment to add to a Site's labour cost from a given effective date onwards. Captures labour overhead that is not associated with any shifts in the schedule. */
export type SiteWeeklyCostAdjustmentInput = {
  /** The weekly amount. Non-zero, positive or negative, up to two decimal places. */
  amount: Scalars['Decimal'];
  /** The week-commencing date from which the adjustment applies, inclusive. */
  effectiveDate: Scalars['Date'];
};

/** A SiteWorkingPreferencesType represents the working preferences of a PartnerMemberProfile for a Site. */
export type SiteWorkingPreferences = {
  __typename?: 'SiteWorkingPreferences';
  /** The ID of the WorkingPreferences object. */
  id: Scalars['UUID'];
  /** The selected WorkingPreferences of the PartnerMemberProfile for a Site. */
  workingPreferences: WorkingPreferences;
  /** The ID of the related PartnerMemberProfile of the WorkingPreferences. */
  profileId: Scalars['UUID'];
  /** The ID of the related Site of the WorkingPreferences. */
  siteId: Scalars['UUID'];
};

/**
 * Enum that contains the allowed options that indicate the sort order to be used when ordering
 *     a QuerySet by a field.
 */
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** A Stint represents a shift for a given Site. */
export type Stint = {
  __typename?: 'Stint';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Determines if the Stint is a trained Stint. */
  trained: Scalars['Boolean'];
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Int']>;
  /** The method used to post this Stint. */
  postMethod?: Maybe<PostMethod>;
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  primaryTasks?: Maybe<Array<Maybe<StintTask>>>;
  secondaryTasks?: Maybe<Array<Maybe<StintTask>>>;
  exceptions?: Maybe<Array<Maybe<EmploymentException>>>;
  /** Top tips list fort sting badge. */
  topTips?: Maybe<Array<Maybe<TopTip>>>;
  /** The business of this Stint. */
  business?: Maybe<Business>;
  uniform?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Additional info of the stint */
  notes?: Maybe<Scalars['String']>;
  dateAccepted?: Maybe<Scalars['DateTime']>;
  dateToProposed?: Maybe<Scalars['DateTime']>;
  lastModified?: Maybe<Scalars['DateTime']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  checkOutDate?: Maybe<Scalars['DateTime']>;
  manualCheckInReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  qrCodeCheckInDate?: Maybe<Scalars['DateTime']>;
  /** The Stint address. */
  address?: Maybe<Address>;
  /** The city that the University is in. */
  city?: Maybe<City>;
  /**
   * Duplicate field of Address.short_name. Stored as NULL in the
   * database until an address has been added.
   */
  locationAddress?: Maybe<Scalars['String']>;
  /** The name of the location. */
  locationName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  invoiceStatus?: Maybe<StintInvoiceStatus>;
  isDirectDebit: Scalars['Boolean'];
  isFreeStint: Scalars['Boolean'];
  paymentReference?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['Int']>;
  preAuthorizedAmount?: Maybe<Scalars['Int']>;
  selectedPaymentMethod?: Maybe<DirectDebitPaymentMethod>;
  selectedCardPaymentMethod?: Maybe<CardPaymentMethod>;
  /** The total fee (float) charged to the Site excluding VAT. This value is calculated using the base hourly fee (effective_base_fee) stored on the Stint. */
  employerCostWithoutVat?: Maybe<Scalars['Float']>;
  /** The cancellation fee (float) charged to the Site when they cancelled the Stint. */
  cancellationFee?: Maybe<Scalars['Float']>;
  /** @deprecated Deprecated in favor of stinter */
  student?: Maybe<StintUser>;
  studentIsLate: Scalars['Boolean'];
  studentRunningLateHalfwayCheck: Scalars['Boolean'];
  eta?: Maybe<Scalars['Float']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelledBy?: Maybe<StintUser>;
  nextAutomationBatchAt?: Maybe<Scalars['DateTime']>;
  isAutomationComplete: Scalars['Boolean'];
  automationLastTriggeredAt?: Maybe<Scalars['DateTime']>;
  automationAttempts?: Maybe<Scalars['Int']>;
  /** Uniform of the stint */
  uniformInstructions?: Maybe<Scalars['String']>;
  trainingInstructions?: Maybe<Scalars['String']>;
  healthAndSafety?: Maybe<Scalars['String']>;
  opsNotifiedUnassigned: Scalars['Boolean'];
  opsNotifiedLocationOff: Scalars['Boolean'];
  quantityStudentsForDraftStint?: Maybe<Scalars['Int']>;
  quantityRepeatDaysForDraftStint?: Maybe<Scalars['Int']>;
  repeatDaysForDraftStint?: Maybe<Array<Maybe<Scalars['Date']>>>;
  averageOwnerRating?: Maybe<Scalars['Float']>;
  /** If True, the Stint will not be automatically matched with students to allow the ops team to manually assign students */
  controlCheck: Scalars['Boolean'];
  /**
   * Stored as NULL in the database if the user who created the Stint
   * is not associated with the Stint.
   */
  createdByUser?: Maybe<StintUser>;
  differentStartTimeReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  pspReference?: Maybe<Scalars['String']>;
  stintCategory?: Maybe<Scalars['String']>;
  /** Stored as NULL in the database if the stint does not have a template */
  stintTemplate?: Maybe<StintTemplate>;
  isBestEffort: Scalars['Boolean'];
  acceptanceMethod?: Maybe<StintAcceptanceMethod>;
  /** The time at which the Stinter actually completed the Stint. Used to track Overtime or Early Leavers. */
  actualLeaveTime?: Maybe<Scalars['DateTime']>;
  /** The ref of the Staff user that logged the actual leave time. */
  actualLeaveTimeLoggedByUserRef?: Maybe<Scalars['UUID']>;
  /** The time at which the Staff user logged the actual leave time. */
  actualLeaveTimeLastModifiedAt?: Maybe<Scalars['DateTime']>;
  stintOffersToStudent: Array<StintOffer>;
  /** The role */
  role?: Maybe<Scalars['String']>;
  /**
   * Resolved the rates & pay that the Stinter is eligible for when working this Stint.
   *
   * Errors:
   * - UNAUTHORIZED when a non Stinter user makes the request.
   * - MISSING_MONETARY_VALUE when a non nullable monetary value is somehow null in the database.
   */
  stinterPay: StinterPay;
  /**
   * Resolves the monetary values for the Stint.
   *
   * Errors:
   * - UNAUTHORIZED when a non Staff user makes the request.
   * - MISSING_MONETARY_VALUE when a non nullable monetary value is somehow null in the database.
   */
  stintRates: StintRates;
  /** The number of stints the business has 'completed' (Status 3 or 4) */
  businessStintCount?: Maybe<Scalars['String']>;
  postedAt?: Maybe<Scalars['String']>;
  /** Student journey checkpoints. */
  stintJourney?: Maybe<StintJourney>;
  /** Rating that student gave to business that posted stint. */
  studentReviewRating?: Maybe<Scalars['Int']>;
  /** Rating that business gave to student when they reviewed them. */
  ownerReviewRating?: Maybe<Scalars['Float']>;
  /** The events recording information around a student being unassigned from a Stint by an admin. */
  studentUnassignedEvents?: Maybe<StudentUnassignedEventListType>;
  /** Flag that marks if stint was posted automatically. */
  automated?: Maybe<Scalars['Boolean']>;
  /** The place id of address. */
  placeId?: Maybe<Scalars['String']>;
  /** The display name of address. */
  displayAddress?: Maybe<Scalars['String']>;
  /** The amount of time before the stint start time that the business cancelled. */
  cancelledTimeAhead?: Maybe<Scalars['String']>;
  /**
   * DEPRECATED: The frontend will calculate the distance. This will now always return null.
   *
   * Birds-eye distance between the user's last recorded location and address of the Stint
   * (in miles, to the nearest decimal place e.g. 0.9, 1.1, 2.0)
   */
  distanceToStintAddress?: Maybe<Scalars['Float']>;
  /** This is the footer type status that allows the mobile to display different CTA screens such as the check-in CTA. */
  footerStatus?: Maybe<StintFooterTypeStatus>;
  /** The prep video URL on the Stint type (template) level. If this does not exist, it will return the business's Stintopedia video URL. */
  prepVideoUrl?: Maybe<Scalars['String']>;
  /** The prep video ID on the Stint type (template) level. If this does not exist, it will return the business's Stintopedia video ID. */
  prepVideoId?: Maybe<Scalars['String']>;
  /** The review that the (student) user has set for the business */
  businessReview?: Maybe<BusinessReview>;
  /** The formatted date and times display in locale time. */
  stintTimesDisplay?: Maybe<Scalars['String']>;
  /** The employee disclaimer agreement document and whether or not it has been confirmed by the Stinter. This field will only be returned if the Partner has an agreement setup. */
  employeeDisclaimerInfo?: Maybe<EmployeeDisclaimerInfo>;
  /** The actual amount charged to the Site excluding VAT: null if the Stint is not yet checked out; the cancellation fee excluding VAT if the Stint is cancelled; otherwise the effective base fee multiplied by worked duration (check-in-aware, minute truncation). May differ from employerCostWithoutVat when check-in is late or worked time differs from the scheduled window. */
  actualEmployerCostWithoutVat?: Maybe<Scalars['Decimal']>;
  /** The site that the Stint belongs to. */
  site: PartnerSiteProfile;
  /**
   * Resolved the assigned Stinter's experience information for the Stint's Pool.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  stinterExperience?: Maybe<StinterExperience>;
  /**
   * Resolved the assigned Stinter's experience information for the Stint's Pool.
   *
   * Errors:
   * - UNAUTHORIZED when the user does not have the required permission.
   */
  stinterPoolExperience?: Maybe<StinterExperience>;
  studentReview?: Maybe<StudentReview>;
  internalReview?: Maybe<StudentReview>;
  /** Use this to determine if stint was checked in successfully or not */
  checkedIn?: Maybe<Scalars['Boolean']>;
  /** Use this to determine if stint has a student review or not */
  hasStudentReview?: Maybe<Scalars['Boolean']>;
  /** Use this to determine if stint has a business review or not */
  hasBusinessReview?: Maybe<Scalars['Boolean']>;
  /** The Stinter assigned to the Stint. */
  stinter?: Maybe<Stinter>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
  /** Id of related Address (auto-generated). */
  address_id?: Maybe<Scalars['UUID']>;
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
  /** Id of related PaymentMethod (auto-generated). */
  selected_payment_method_id?: Maybe<Scalars['UUID']>;
  /** Id of related CardPaymentMethod (auto-generated). */
  selected_card_payment_method_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessRole (auto-generated). */
  business_role_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessCategory (auto-generated). */
  business_category_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  cancelled_by_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  created_by_user_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintTemplate (auto-generated). */
  stint_template_id?: Maybe<Scalars['UUID']>;
};

/** A Stint represents a shift for a given Site. */
export type StintstudentUnassignedEventsArgs = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};

/** A Stint represents a shift for a given Site. */
export type StintstudentReviewArgs = {
  reviewType?: Maybe<Scalars['String']>;
};

export enum StintAcceptanceMethod {
  /** Manual Assignment */
  MANUAL_ASSIGNMENT = 'MANUAL_ASSIGNMENT',
  /** Manual Offer */
  MANUAL_OFFER = 'MANUAL_OFFER',
  /** Stint Matcher Offer */
  STINT_MATCHER_OFFER = 'STINT_MATCHER_OFFER',
  /** Waterfall Offer */
  WATERFALL_OFFER = 'WATERFALL_OFFER',
  /** Stint Matcher Top Up Offer */
  STINT_MATCHER_TOP_UP_OFFER = 'STINT_MATCHER_TOP_UP_OFFER',
  /** Repeat Stints Carousel */
  REPEAT_STINTS_CAROUSEL = 'REPEAT_STINTS_CAROUSEL',
  /** Repeat Stints List */
  REPEAT_STINTS_LIST = 'REPEAT_STINTS_LIST',
  /** All Stints List */
  ALL_STINTS_LIST = 'ALL_STINTS_LIST',
  /** All Stints Map */
  ALL_STINTS_MAP = 'ALL_STINTS_MAP',
  /** Trained Stints List */
  TRAINED_STINTS_LIST = 'TRAINED_STINTS_LIST',
}

export type StintDurationInput = {
  /** The number of hours that the Stint duration should be greater than or equal to */
  gte: Scalars['Int'];
  /** The number of hours that the Stint duration should be less than or equal to */
  lte: Scalars['Int'];
};

/**
 * Enum that contains the available error message codes that can be used to raise
 *     errors related to the Stint domain.
 */
export enum StintError {
  ACTUAL_LEAVE_TIME_BEFORE_START = 'ACTUAL_LEAVE_TIME_BEFORE_START',
  AFTER_CANCELLATION_CUTOFF_TIME = 'AFTER_CANCELLATION_CUTOFF_TIME',
  ALREADY_CANCELLED = 'ALREADY_CANCELLED',
  ALREADY_COMPLETED = 'ALREADY_COMPLETED',
  ALREADY_STARTED = 'ALREADY_STARTED',
  CANNOT_UPDATE_TIMES_FOR_ASSIGNED_STINT = 'CANNOT_UPDATE_TIMES_FOR_ASSIGNED_STINT',
  FROM_WEEK_TEMPLATE_MUST_HAVE_REF = 'FROM_WEEK_TEMPLATE_MUST_HAVE_REF',
  FROM_WEEK_TEMPLATE_MUST_HAVE_VERSION = 'FROM_WEEK_TEMPLATE_MUST_HAVE_VERSION',
  INVALID_ACTUAL_LEAVE_TIME = 'INVALID_ACTUAL_LEAVE_TIME',
  INVALID_ACTUAL_LEAVE_TIME_FROM_END = 'INVALID_ACTUAL_LEAVE_TIME_FROM_END',
  INVALID_BUSINESS_ID = 'INVALID_BUSINESS_ID',
  INVALID_DATE_FROM = 'INVALID_DATE_FROM',
  INVALID_DATE_TO = 'INVALID_DATE_TO',
  INVALID_ID = 'INVALID_ID',
  INVALID_QUANTITY = 'INVALID_QUANTITY',
  INVALID_STINT_END_TIME = 'INVALID_STINT_END_TIME',
  INVALID_STINT_MAX_LENGTH = 'INVALID_STINT_MAX_LENGTH',
  INVALID_STINT_MIN_LENGTH = 'INVALID_STINT_MIN_LENGTH',
  INVALID_STINT_START_TIME = 'INVALID_STINT_START_TIME',
  INVALID_STINT_TEMPLATE_ID = 'INVALID_STINT_TEMPLATE_ID',
  MISSING_MONETARY_VALUE = 'MISSING_MONETARY_VALUE',
  ONE_OFF_MUST_NOT_HAVE_REF = 'ONE_OFF_MUST_NOT_HAVE_REF',
  ONE_OFF_MUST_NOT_HAVE_VERSION = 'ONE_OFF_MUST_NOT_HAVE_VERSION',
  STINT_IS_LOCKED_FOR_UPDATE = 'STINT_IS_LOCKED_FOR_UPDATE',
  STINTER_ACCEPTED_OVER_COMMITMENT = 'STINTER_ACCEPTED_OVER_COMMITMENT',
  STINTER_DOES_NOT_HAVE_A_COMMITMENT = 'STINTER_DOES_NOT_HAVE_A_COMMITMENT',
  UNABLE_TO_UNASSIGN_STINTER_FROM_STINT = 'UNABLE_TO_UNASSIGN_STINTER_FROM_STINT',
  UNKNOWN_VALUE_ERROR = 'UNKNOWN_VALUE_ERROR',
  CANNOT_SET_MONETARY_VALUE_IF_STINTER_ASSIGNED = 'CANNOT_SET_MONETARY_VALUE_IF_STINTER_ASSIGNED',
  STINTER_IS_DEACTIVATED = 'STINTER_IS_DEACTIVATED',
  OVERLAPPING_STINTS_EXIST = 'OVERLAPPING_STINTS_EXIST',
  STINT_NO_LONGER_AVAILABLE = 'STINT_NO_LONGER_AVAILABLE',
  STINT_MODIFIED_SINCE_VIEWING = 'STINT_MODIFIED_SINCE_VIEWING',
  STINTER_PARTNER_EXCLUDED = 'STINTER_PARTNER_EXCLUDED',
  STINTER_WORKING_CAP_EXCEEDED = 'STINTER_WORKING_CAP_EXCEEDED',
  UNVERIFIED_USER = 'UNVERIFIED_USER',
}

export type StintFilter = {
  name?: Maybe<Scalars['String']>;
  controlCheck?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** startFrom */
  startFrom?: Maybe<Scalars['Date']>;
  /** only_stints_with_no_student_reviews */
  only_stints_with_no_student_reviews?: Maybe<Scalars['Boolean']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  /** address_id */
  address_id?: Maybe<Scalars['UUID']>;
  /** address_id_isnull */
  address_id_isnull?: Maybe<Scalars['Boolean']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  /** selectedPaymentMethod_id */
  selectedPaymentMethod_id?: Maybe<Scalars['UUID']>;
  /** selectedPaymentMethod_id_isnull */
  selectedPaymentMethod_id_isnull?: Maybe<Scalars['Boolean']>;
  /** selectedCardPaymentMethod_id */
  selectedCardPaymentMethod_id?: Maybe<Scalars['UUID']>;
  /** selectedCardPaymentMethod_id_isnull */
  selectedCardPaymentMethod_id_isnull?: Maybe<Scalars['Boolean']>;
  /** student_id */
  student_id?: Maybe<Scalars['UUID']>;
  /** student_id_isnull */
  student_id_isnull?: Maybe<Scalars['Boolean']>;
  /** businessRole_id */
  businessRole_id?: Maybe<Scalars['UUID']>;
  /** businessRole_id_isnull */
  businessRole_id_isnull?: Maybe<Scalars['Boolean']>;
  /** businessCategory_id */
  businessCategory_id?: Maybe<Scalars['UUID']>;
  /** businessCategory_id_isnull */
  businessCategory_id_isnull?: Maybe<Scalars['Boolean']>;
  /** cancelledBy_id */
  cancelledBy_id?: Maybe<Scalars['UUID']>;
  /** cancelledBy_id_isnull */
  cancelledBy_id_isnull?: Maybe<Scalars['Boolean']>;
  /** createdByUser_id */
  createdByUser_id?: Maybe<Scalars['UUID']>;
  /** createdByUser_id_isnull */
  createdByUser_id_isnull?: Maybe<Scalars['Boolean']>;
  /** stintTemplate_id */
  stintTemplate_id?: Maybe<Scalars['UUID']>;
  /** stintTemplate_id_isnull */
  stintTemplate_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** notes_search */
  notes_search?: Maybe<Scalars['String']>;
  /** notes_gte */
  notes_gte?: Maybe<Scalars['String']>;
  /** notes_lte */
  notes_lte?: Maybe<Scalars['String']>;
  /** notes_istartswith */
  notes_istartswith?: Maybe<Scalars['String']>;
  /** notes_lt */
  notes_lt?: Maybe<Scalars['String']>;
  /** notes_gt */
  notes_gt?: Maybe<Scalars['String']>;
  /** notes_isnull */
  notes_isnull?: Maybe<Scalars['Boolean']>;
  /** notes_iendswith */
  notes_iendswith?: Maybe<Scalars['String']>;
  trained?: Maybe<Scalars['Boolean']>;
  /** trained_gte */
  trained_gte?: Maybe<Scalars['Boolean']>;
  /** trained_lte */
  trained_lte?: Maybe<Scalars['Boolean']>;
  /** trained_istartswith */
  trained_istartswith?: Maybe<Scalars['Boolean']>;
  /** trained_lt */
  trained_lt?: Maybe<Scalars['Boolean']>;
  /** trained_gt */
  trained_gt?: Maybe<Scalars['Boolean']>;
  /** trained_isnull */
  trained_isnull?: Maybe<Scalars['Boolean']>;
  /** trained_iendswith */
  trained_iendswith?: Maybe<Scalars['Boolean']>;
  dateAccepted?: Maybe<Scalars['DateTime']>;
  /** dateAccepted_gte */
  dateAccepted_gte?: Maybe<Scalars['DateTime']>;
  /** dateAccepted_lte */
  dateAccepted_lte?: Maybe<Scalars['DateTime']>;
  /** dateAccepted_istartswith */
  dateAccepted_istartswith?: Maybe<Scalars['DateTime']>;
  /** dateAccepted_lt */
  dateAccepted_lt?: Maybe<Scalars['DateTime']>;
  /** dateAccepted_gt */
  dateAccepted_gt?: Maybe<Scalars['DateTime']>;
  /** dateAccepted_isnull */
  dateAccepted_isnull?: Maybe<Scalars['Boolean']>;
  /** dateAccepted_iendswith */
  dateAccepted_iendswith?: Maybe<Scalars['DateTime']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  /** dateFrom_gte */
  dateFrom_gte?: Maybe<Scalars['DateTime']>;
  /** dateFrom_lte */
  dateFrom_lte?: Maybe<Scalars['DateTime']>;
  /** dateFrom_istartswith */
  dateFrom_istartswith?: Maybe<Scalars['DateTime']>;
  /** dateFrom_lt */
  dateFrom_lt?: Maybe<Scalars['DateTime']>;
  /** dateFrom_gt */
  dateFrom_gt?: Maybe<Scalars['DateTime']>;
  /** dateFrom_isnull */
  dateFrom_isnull?: Maybe<Scalars['Boolean']>;
  /** dateFrom_iendswith */
  dateFrom_iendswith?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  /** dateTo_gte */
  dateTo_gte?: Maybe<Scalars['DateTime']>;
  /** dateTo_lte */
  dateTo_lte?: Maybe<Scalars['DateTime']>;
  /** dateTo_istartswith */
  dateTo_istartswith?: Maybe<Scalars['DateTime']>;
  /** dateTo_lt */
  dateTo_lt?: Maybe<Scalars['DateTime']>;
  /** dateTo_gt */
  dateTo_gt?: Maybe<Scalars['DateTime']>;
  /** dateTo_isnull */
  dateTo_isnull?: Maybe<Scalars['Boolean']>;
  /** dateTo_iendswith */
  dateTo_iendswith?: Maybe<Scalars['DateTime']>;
  dateToProposed?: Maybe<Scalars['DateTime']>;
  /** dateToProposed_gte */
  dateToProposed_gte?: Maybe<Scalars['DateTime']>;
  /** dateToProposed_lte */
  dateToProposed_lte?: Maybe<Scalars['DateTime']>;
  /** dateToProposed_istartswith */
  dateToProposed_istartswith?: Maybe<Scalars['DateTime']>;
  /** dateToProposed_lt */
  dateToProposed_lt?: Maybe<Scalars['DateTime']>;
  /** dateToProposed_gt */
  dateToProposed_gt?: Maybe<Scalars['DateTime']>;
  /** dateToProposed_isnull */
  dateToProposed_isnull?: Maybe<Scalars['Boolean']>;
  /** dateToProposed_iendswith */
  dateToProposed_iendswith?: Maybe<Scalars['DateTime']>;
  lastModified?: Maybe<Scalars['DateTime']>;
  /** lastModified_gte */
  lastModified_gte?: Maybe<Scalars['DateTime']>;
  /** lastModified_lte */
  lastModified_lte?: Maybe<Scalars['DateTime']>;
  /** lastModified_istartswith */
  lastModified_istartswith?: Maybe<Scalars['DateTime']>;
  /** lastModified_lt */
  lastModified_lt?: Maybe<Scalars['DateTime']>;
  /** lastModified_gt */
  lastModified_gt?: Maybe<Scalars['DateTime']>;
  /** lastModified_isnull */
  lastModified_isnull?: Maybe<Scalars['Boolean']>;
  /** lastModified_iendswith */
  lastModified_iendswith?: Maybe<Scalars['DateTime']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  /** checkInDate_gte */
  checkInDate_gte?: Maybe<Scalars['DateTime']>;
  /** checkInDate_lte */
  checkInDate_lte?: Maybe<Scalars['DateTime']>;
  /** checkInDate_istartswith */
  checkInDate_istartswith?: Maybe<Scalars['DateTime']>;
  /** checkInDate_lt */
  checkInDate_lt?: Maybe<Scalars['DateTime']>;
  /** checkInDate_gt */
  checkInDate_gt?: Maybe<Scalars['DateTime']>;
  /** checkInDate_isnull */
  checkInDate_isnull?: Maybe<Scalars['Boolean']>;
  /** checkInDate_iendswith */
  checkInDate_iendswith?: Maybe<Scalars['DateTime']>;
  checkOutDate?: Maybe<Scalars['DateTime']>;
  /** checkOutDate_gte */
  checkOutDate_gte?: Maybe<Scalars['DateTime']>;
  /** checkOutDate_lte */
  checkOutDate_lte?: Maybe<Scalars['DateTime']>;
  /** checkOutDate_istartswith */
  checkOutDate_istartswith?: Maybe<Scalars['DateTime']>;
  /** checkOutDate_lt */
  checkOutDate_lt?: Maybe<Scalars['DateTime']>;
  /** checkOutDate_gt */
  checkOutDate_gt?: Maybe<Scalars['DateTime']>;
  /** checkOutDate_isnull */
  checkOutDate_isnull?: Maybe<Scalars['Boolean']>;
  /** checkOutDate_iendswith */
  checkOutDate_iendswith?: Maybe<Scalars['DateTime']>;
  qrCodeCheckInDate?: Maybe<Scalars['DateTime']>;
  /** qrCodeCheckInDate_gte */
  qrCodeCheckInDate_gte?: Maybe<Scalars['DateTime']>;
  /** qrCodeCheckInDate_lte */
  qrCodeCheckInDate_lte?: Maybe<Scalars['DateTime']>;
  /** qrCodeCheckInDate_istartswith */
  qrCodeCheckInDate_istartswith?: Maybe<Scalars['DateTime']>;
  /** qrCodeCheckInDate_lt */
  qrCodeCheckInDate_lt?: Maybe<Scalars['DateTime']>;
  /** qrCodeCheckInDate_gt */
  qrCodeCheckInDate_gt?: Maybe<Scalars['DateTime']>;
  /** qrCodeCheckInDate_isnull */
  qrCodeCheckInDate_isnull?: Maybe<Scalars['Boolean']>;
  /** qrCodeCheckInDate_iendswith */
  qrCodeCheckInDate_iendswith?: Maybe<Scalars['DateTime']>;
  locationAddress?: Maybe<Scalars['String']>;
  /** locationAddress_search */
  locationAddress_search?: Maybe<Scalars['String']>;
  /** locationAddress_gte */
  locationAddress_gte?: Maybe<Scalars['String']>;
  /** locationAddress_lte */
  locationAddress_lte?: Maybe<Scalars['String']>;
  /** locationAddress_istartswith */
  locationAddress_istartswith?: Maybe<Scalars['String']>;
  /** locationAddress_lt */
  locationAddress_lt?: Maybe<Scalars['String']>;
  /** locationAddress_gt */
  locationAddress_gt?: Maybe<Scalars['String']>;
  /** locationAddress_isnull */
  locationAddress_isnull?: Maybe<Scalars['Boolean']>;
  /** locationAddress_iendswith */
  locationAddress_iendswith?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  /** locationName_search */
  locationName_search?: Maybe<Scalars['String']>;
  /** locationName_gte */
  locationName_gte?: Maybe<Scalars['String']>;
  /** locationName_lte */
  locationName_lte?: Maybe<Scalars['String']>;
  /** locationName_istartswith */
  locationName_istartswith?: Maybe<Scalars['String']>;
  /** locationName_lt */
  locationName_lt?: Maybe<Scalars['String']>;
  /** locationName_gt */
  locationName_gt?: Maybe<Scalars['String']>;
  /** locationName_isnull */
  locationName_isnull?: Maybe<Scalars['Boolean']>;
  /** locationName_iendswith */
  locationName_iendswith?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  /** longitude_search */
  longitude_search?: Maybe<Scalars['String']>;
  /** longitude_gte */
  longitude_gte?: Maybe<Scalars['String']>;
  /** longitude_lte */
  longitude_lte?: Maybe<Scalars['String']>;
  /** longitude_istartswith */
  longitude_istartswith?: Maybe<Scalars['String']>;
  /** longitude_lt */
  longitude_lt?: Maybe<Scalars['String']>;
  /** longitude_gt */
  longitude_gt?: Maybe<Scalars['String']>;
  /** longitude_isnull */
  longitude_isnull?: Maybe<Scalars['Boolean']>;
  /** longitude_iendswith */
  longitude_iendswith?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  /** latitude_search */
  latitude_search?: Maybe<Scalars['String']>;
  /** latitude_gte */
  latitude_gte?: Maybe<Scalars['String']>;
  /** latitude_lte */
  latitude_lte?: Maybe<Scalars['String']>;
  /** latitude_istartswith */
  latitude_istartswith?: Maybe<Scalars['String']>;
  /** latitude_lt */
  latitude_lt?: Maybe<Scalars['String']>;
  /** latitude_gt */
  latitude_gt?: Maybe<Scalars['String']>;
  /** latitude_isnull */
  latitude_isnull?: Maybe<Scalars['Boolean']>;
  /** latitude_iendswith */
  latitude_iendswith?: Maybe<Scalars['String']>;
  invoiceStatus?: Maybe<Scalars['String']>;
  /** invoiceStatus_search */
  invoiceStatus_search?: Maybe<Scalars['String']>;
  /** invoiceStatus_gte */
  invoiceStatus_gte?: Maybe<Scalars['String']>;
  /** invoiceStatus_lte */
  invoiceStatus_lte?: Maybe<Scalars['String']>;
  /** invoiceStatus_istartswith */
  invoiceStatus_istartswith?: Maybe<Scalars['String']>;
  /** invoiceStatus_lt */
  invoiceStatus_lt?: Maybe<Scalars['String']>;
  /** invoiceStatus_gt */
  invoiceStatus_gt?: Maybe<Scalars['String']>;
  /** invoiceStatus_isnull */
  invoiceStatus_isnull?: Maybe<Scalars['Boolean']>;
  /** invoiceStatus_iendswith */
  invoiceStatus_iendswith?: Maybe<Scalars['String']>;
  isDirectDebit?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_gte */
  isDirectDebit_gte?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_lte */
  isDirectDebit_lte?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_istartswith */
  isDirectDebit_istartswith?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_lt */
  isDirectDebit_lt?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_gt */
  isDirectDebit_gt?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_isnull */
  isDirectDebit_isnull?: Maybe<Scalars['Boolean']>;
  /** isDirectDebit_iendswith */
  isDirectDebit_iendswith?: Maybe<Scalars['Boolean']>;
  isFreeStint?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_gte */
  isFreeStint_gte?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_lte */
  isFreeStint_lte?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_istartswith */
  isFreeStint_istartswith?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_lt */
  isFreeStint_lt?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_gt */
  isFreeStint_gt?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_isnull */
  isFreeStint_isnull?: Maybe<Scalars['Boolean']>;
  /** isFreeStint_iendswith */
  isFreeStint_iendswith?: Maybe<Scalars['Boolean']>;
  paymentReference?: Maybe<Scalars['String']>;
  /** paymentReference_search */
  paymentReference_search?: Maybe<Scalars['String']>;
  /** paymentReference_gte */
  paymentReference_gte?: Maybe<Scalars['String']>;
  /** paymentReference_lte */
  paymentReference_lte?: Maybe<Scalars['String']>;
  /** paymentReference_istartswith */
  paymentReference_istartswith?: Maybe<Scalars['String']>;
  /** paymentReference_lt */
  paymentReference_lt?: Maybe<Scalars['String']>;
  /** paymentReference_gt */
  paymentReference_gt?: Maybe<Scalars['String']>;
  /** paymentReference_isnull */
  paymentReference_isnull?: Maybe<Scalars['Boolean']>;
  /** paymentReference_iendswith */
  paymentReference_iendswith?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['Float']>;
  /** paymentStatus_gte */
  paymentStatus_gte?: Maybe<Scalars['Float']>;
  /** paymentStatus_lte */
  paymentStatus_lte?: Maybe<Scalars['Float']>;
  /** paymentStatus_istartswith */
  paymentStatus_istartswith?: Maybe<Scalars['Float']>;
  /** paymentStatus_lt */
  paymentStatus_lt?: Maybe<Scalars['Float']>;
  /** paymentStatus_gt */
  paymentStatus_gt?: Maybe<Scalars['Float']>;
  /** paymentStatus_isnull */
  paymentStatus_isnull?: Maybe<Scalars['Boolean']>;
  /** paymentStatus_iendswith */
  paymentStatus_iendswith?: Maybe<Scalars['Float']>;
  preAuthorizedAmount?: Maybe<Scalars['Float']>;
  /** preAuthorizedAmount_gte */
  preAuthorizedAmount_gte?: Maybe<Scalars['Float']>;
  /** preAuthorizedAmount_lte */
  preAuthorizedAmount_lte?: Maybe<Scalars['Float']>;
  /** preAuthorizedAmount_istartswith */
  preAuthorizedAmount_istartswith?: Maybe<Scalars['Float']>;
  /** preAuthorizedAmount_lt */
  preAuthorizedAmount_lt?: Maybe<Scalars['Float']>;
  /** preAuthorizedAmount_gt */
  preAuthorizedAmount_gt?: Maybe<Scalars['Float']>;
  /** preAuthorizedAmount_isnull */
  preAuthorizedAmount_isnull?: Maybe<Scalars['Boolean']>;
  /** preAuthorizedAmount_iendswith */
  preAuthorizedAmount_iendswith?: Maybe<Scalars['Float']>;
  bonusRate?: Maybe<Scalars['Float']>;
  /** bonusRate_gte */
  bonusRate_gte?: Maybe<Scalars['Float']>;
  /** bonusRate_lte */
  bonusRate_lte?: Maybe<Scalars['Float']>;
  /** bonusRate_istartswith */
  bonusRate_istartswith?: Maybe<Scalars['Float']>;
  /** bonusRate_lt */
  bonusRate_lt?: Maybe<Scalars['Float']>;
  /** bonusRate_gt */
  bonusRate_gt?: Maybe<Scalars['Float']>;
  /** bonusRate_isnull */
  bonusRate_isnull?: Maybe<Scalars['Boolean']>;
  /** bonusRate_iendswith */
  bonusRate_iendswith?: Maybe<Scalars['Float']>;
  bonusPay?: Maybe<Scalars['Float']>;
  /** bonusPay_gte */
  bonusPay_gte?: Maybe<Scalars['Float']>;
  /** bonusPay_lte */
  bonusPay_lte?: Maybe<Scalars['Float']>;
  /** bonusPay_istartswith */
  bonusPay_istartswith?: Maybe<Scalars['Float']>;
  /** bonusPay_lt */
  bonusPay_lt?: Maybe<Scalars['Float']>;
  /** bonusPay_gt */
  bonusPay_gt?: Maybe<Scalars['Float']>;
  /** bonusPay_isnull */
  bonusPay_isnull?: Maybe<Scalars['Boolean']>;
  /** bonusPay_iendswith */
  bonusPay_iendswith?: Maybe<Scalars['Float']>;
  bonusApplied?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_gte */
  bonusApplied_gte?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_lte */
  bonusApplied_lte?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_istartswith */
  bonusApplied_istartswith?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_lt */
  bonusApplied_lt?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_gt */
  bonusApplied_gt?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_isnull */
  bonusApplied_isnull?: Maybe<Scalars['Boolean']>;
  /** bonusApplied_iendswith */
  bonusApplied_iendswith?: Maybe<Scalars['Boolean']>;
  firebaseRef?: Maybe<Scalars['String']>;
  /** firebaseRef_search */
  firebaseRef_search?: Maybe<Scalars['String']>;
  /** firebaseRef_gte */
  firebaseRef_gte?: Maybe<Scalars['String']>;
  /** firebaseRef_lte */
  firebaseRef_lte?: Maybe<Scalars['String']>;
  /** firebaseRef_istartswith */
  firebaseRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseRef_lt */
  firebaseRef_lt?: Maybe<Scalars['String']>;
  /** firebaseRef_gt */
  firebaseRef_gt?: Maybe<Scalars['String']>;
  /** firebaseRef_isnull */
  firebaseRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseRef_iendswith */
  firebaseRef_iendswith?: Maybe<Scalars['String']>;
  firebaseCreatedByBusinessRef?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_search */
  firebaseCreatedByBusinessRef_search?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_gte */
  firebaseCreatedByBusinessRef_gte?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_lte */
  firebaseCreatedByBusinessRef_lte?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_istartswith */
  firebaseCreatedByBusinessRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_lt */
  firebaseCreatedByBusinessRef_lt?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_gt */
  firebaseCreatedByBusinessRef_gt?: Maybe<Scalars['String']>;
  /** firebaseCreatedByBusinessRef_isnull */
  firebaseCreatedByBusinessRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseCreatedByBusinessRef_iendswith */
  firebaseCreatedByBusinessRef_iendswith?: Maybe<Scalars['String']>;
  firebaseContactPersonRef?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_search */
  firebaseContactPersonRef_search?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_gte */
  firebaseContactPersonRef_gte?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_lte */
  firebaseContactPersonRef_lte?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_istartswith */
  firebaseContactPersonRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_lt */
  firebaseContactPersonRef_lt?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_gt */
  firebaseContactPersonRef_gt?: Maybe<Scalars['String']>;
  /** firebaseContactPersonRef_isnull */
  firebaseContactPersonRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseContactPersonRef_iendswith */
  firebaseContactPersonRef_iendswith?: Maybe<Scalars['String']>;
  firebaseStudentRef?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_search */
  firebaseStudentRef_search?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_gte */
  firebaseStudentRef_gte?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_lte */
  firebaseStudentRef_lte?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_istartswith */
  firebaseStudentRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_lt */
  firebaseStudentRef_lt?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_gt */
  firebaseStudentRef_gt?: Maybe<Scalars['String']>;
  /** firebaseStudentRef_isnull */
  firebaseStudentRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseStudentRef_iendswith */
  firebaseStudentRef_iendswith?: Maybe<Scalars['String']>;
  studentIsLate?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_gte */
  studentIsLate_gte?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_lte */
  studentIsLate_lte?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_istartswith */
  studentIsLate_istartswith?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_lt */
  studentIsLate_lt?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_gt */
  studentIsLate_gt?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_isnull */
  studentIsLate_isnull?: Maybe<Scalars['Boolean']>;
  /** studentIsLate_iendswith */
  studentIsLate_iendswith?: Maybe<Scalars['Boolean']>;
  studentRunningLateHalfwayCheck?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_gte */
  studentRunningLateHalfwayCheck_gte?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_lte */
  studentRunningLateHalfwayCheck_lte?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_istartswith */
  studentRunningLateHalfwayCheck_istartswith?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_lt */
  studentRunningLateHalfwayCheck_lt?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_gt */
  studentRunningLateHalfwayCheck_gt?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_isnull */
  studentRunningLateHalfwayCheck_isnull?: Maybe<Scalars['Boolean']>;
  /** studentRunningLateHalfwayCheck_iendswith */
  studentRunningLateHalfwayCheck_iendswith?: Maybe<Scalars['Boolean']>;
  eta?: Maybe<Scalars['Float']>;
  /** eta_gte */
  eta_gte?: Maybe<Scalars['Float']>;
  /** eta_lte */
  eta_lte?: Maybe<Scalars['Float']>;
  /** eta_istartswith */
  eta_istartswith?: Maybe<Scalars['Float']>;
  /** eta_lt */
  eta_lt?: Maybe<Scalars['Float']>;
  /** eta_gt */
  eta_gt?: Maybe<Scalars['Float']>;
  /** eta_isnull */
  eta_isnull?: Maybe<Scalars['Boolean']>;
  /** eta_iendswith */
  eta_iendswith?: Maybe<Scalars['Float']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  /** cancelledAt_gte */
  cancelledAt_gte?: Maybe<Scalars['DateTime']>;
  /** cancelledAt_lte */
  cancelledAt_lte?: Maybe<Scalars['DateTime']>;
  /** cancelledAt_istartswith */
  cancelledAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** cancelledAt_lt */
  cancelledAt_lt?: Maybe<Scalars['DateTime']>;
  /** cancelledAt_gt */
  cancelledAt_gt?: Maybe<Scalars['DateTime']>;
  /** cancelledAt_isnull */
  cancelledAt_isnull?: Maybe<Scalars['Boolean']>;
  /** cancelledAt_iendswith */
  cancelledAt_iendswith?: Maybe<Scalars['DateTime']>;
  nextAutomationBatchAt?: Maybe<Scalars['DateTime']>;
  /** nextAutomationBatchAt_gte */
  nextAutomationBatchAt_gte?: Maybe<Scalars['DateTime']>;
  /** nextAutomationBatchAt_lte */
  nextAutomationBatchAt_lte?: Maybe<Scalars['DateTime']>;
  /** nextAutomationBatchAt_istartswith */
  nextAutomationBatchAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** nextAutomationBatchAt_lt */
  nextAutomationBatchAt_lt?: Maybe<Scalars['DateTime']>;
  /** nextAutomationBatchAt_gt */
  nextAutomationBatchAt_gt?: Maybe<Scalars['DateTime']>;
  /** nextAutomationBatchAt_isnull */
  nextAutomationBatchAt_isnull?: Maybe<Scalars['Boolean']>;
  /** nextAutomationBatchAt_iendswith */
  nextAutomationBatchAt_iendswith?: Maybe<Scalars['DateTime']>;
  isAutomationComplete?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_gte */
  isAutomationComplete_gte?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_lte */
  isAutomationComplete_lte?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_istartswith */
  isAutomationComplete_istartswith?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_lt */
  isAutomationComplete_lt?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_gt */
  isAutomationComplete_gt?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_isnull */
  isAutomationComplete_isnull?: Maybe<Scalars['Boolean']>;
  /** isAutomationComplete_iendswith */
  isAutomationComplete_iendswith?: Maybe<Scalars['Boolean']>;
  automationLastTriggeredAt?: Maybe<Scalars['DateTime']>;
  /** automationLastTriggeredAt_gte */
  automationLastTriggeredAt_gte?: Maybe<Scalars['DateTime']>;
  /** automationLastTriggeredAt_lte */
  automationLastTriggeredAt_lte?: Maybe<Scalars['DateTime']>;
  /** automationLastTriggeredAt_istartswith */
  automationLastTriggeredAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** automationLastTriggeredAt_lt */
  automationLastTriggeredAt_lt?: Maybe<Scalars['DateTime']>;
  /** automationLastTriggeredAt_gt */
  automationLastTriggeredAt_gt?: Maybe<Scalars['DateTime']>;
  /** automationLastTriggeredAt_isnull */
  automationLastTriggeredAt_isnull?: Maybe<Scalars['Boolean']>;
  /** automationLastTriggeredAt_iendswith */
  automationLastTriggeredAt_iendswith?: Maybe<Scalars['DateTime']>;
  automationAttempts?: Maybe<Scalars['Float']>;
  /** automationAttempts_gte */
  automationAttempts_gte?: Maybe<Scalars['Float']>;
  /** automationAttempts_lte */
  automationAttempts_lte?: Maybe<Scalars['Float']>;
  /** automationAttempts_istartswith */
  automationAttempts_istartswith?: Maybe<Scalars['Float']>;
  /** automationAttempts_lt */
  automationAttempts_lt?: Maybe<Scalars['Float']>;
  /** automationAttempts_gt */
  automationAttempts_gt?: Maybe<Scalars['Float']>;
  /** automationAttempts_isnull */
  automationAttempts_isnull?: Maybe<Scalars['Boolean']>;
  /** automationAttempts_iendswith */
  automationAttempts_iendswith?: Maybe<Scalars['Float']>;
  uniformInstructions?: Maybe<Scalars['String']>;
  /** uniformInstructions_search */
  uniformInstructions_search?: Maybe<Scalars['String']>;
  /** uniformInstructions_gte */
  uniformInstructions_gte?: Maybe<Scalars['String']>;
  /** uniformInstructions_lte */
  uniformInstructions_lte?: Maybe<Scalars['String']>;
  /** uniformInstructions_istartswith */
  uniformInstructions_istartswith?: Maybe<Scalars['String']>;
  /** uniformInstructions_lt */
  uniformInstructions_lt?: Maybe<Scalars['String']>;
  /** uniformInstructions_gt */
  uniformInstructions_gt?: Maybe<Scalars['String']>;
  /** uniformInstructions_isnull */
  uniformInstructions_isnull?: Maybe<Scalars['Boolean']>;
  /** uniformInstructions_iendswith */
  uniformInstructions_iendswith?: Maybe<Scalars['String']>;
  trainingInstructions?: Maybe<Scalars['String']>;
  /** trainingInstructions_search */
  trainingInstructions_search?: Maybe<Scalars['String']>;
  /** trainingInstructions_gte */
  trainingInstructions_gte?: Maybe<Scalars['String']>;
  /** trainingInstructions_lte */
  trainingInstructions_lte?: Maybe<Scalars['String']>;
  /** trainingInstructions_istartswith */
  trainingInstructions_istartswith?: Maybe<Scalars['String']>;
  /** trainingInstructions_lt */
  trainingInstructions_lt?: Maybe<Scalars['String']>;
  /** trainingInstructions_gt */
  trainingInstructions_gt?: Maybe<Scalars['String']>;
  /** trainingInstructions_isnull */
  trainingInstructions_isnull?: Maybe<Scalars['Boolean']>;
  /** trainingInstructions_iendswith */
  trainingInstructions_iendswith?: Maybe<Scalars['String']>;
  healthAndSafety?: Maybe<Scalars['String']>;
  /** healthAndSafety_search */
  healthAndSafety_search?: Maybe<Scalars['String']>;
  /** healthAndSafety_gte */
  healthAndSafety_gte?: Maybe<Scalars['String']>;
  /** healthAndSafety_lte */
  healthAndSafety_lte?: Maybe<Scalars['String']>;
  /** healthAndSafety_istartswith */
  healthAndSafety_istartswith?: Maybe<Scalars['String']>;
  /** healthAndSafety_lt */
  healthAndSafety_lt?: Maybe<Scalars['String']>;
  /** healthAndSafety_gt */
  healthAndSafety_gt?: Maybe<Scalars['String']>;
  /** healthAndSafety_isnull */
  healthAndSafety_isnull?: Maybe<Scalars['Boolean']>;
  /** healthAndSafety_iendswith */
  healthAndSafety_iendswith?: Maybe<Scalars['String']>;
  opsNotifiedUnassigned?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_gte */
  opsNotifiedUnassigned_gte?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_lte */
  opsNotifiedUnassigned_lte?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_istartswith */
  opsNotifiedUnassigned_istartswith?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_lt */
  opsNotifiedUnassigned_lt?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_gt */
  opsNotifiedUnassigned_gt?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_isnull */
  opsNotifiedUnassigned_isnull?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedUnassigned_iendswith */
  opsNotifiedUnassigned_iendswith?: Maybe<Scalars['Boolean']>;
  opsNotifiedLocationOff?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_gte */
  opsNotifiedLocationOff_gte?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_lte */
  opsNotifiedLocationOff_lte?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_istartswith */
  opsNotifiedLocationOff_istartswith?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_lt */
  opsNotifiedLocationOff_lt?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_gt */
  opsNotifiedLocationOff_gt?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_isnull */
  opsNotifiedLocationOff_isnull?: Maybe<Scalars['Boolean']>;
  /** opsNotifiedLocationOff_iendswith */
  opsNotifiedLocationOff_iendswith?: Maybe<Scalars['Boolean']>;
  quantityStudentsForDraftStint?: Maybe<Scalars['Float']>;
  /** quantityStudentsForDraftStint_gte */
  quantityStudentsForDraftStint_gte?: Maybe<Scalars['Float']>;
  /** quantityStudentsForDraftStint_lte */
  quantityStudentsForDraftStint_lte?: Maybe<Scalars['Float']>;
  /** quantityStudentsForDraftStint_istartswith */
  quantityStudentsForDraftStint_istartswith?: Maybe<Scalars['Float']>;
  /** quantityStudentsForDraftStint_lt */
  quantityStudentsForDraftStint_lt?: Maybe<Scalars['Float']>;
  /** quantityStudentsForDraftStint_gt */
  quantityStudentsForDraftStint_gt?: Maybe<Scalars['Float']>;
  /** quantityStudentsForDraftStint_isnull */
  quantityStudentsForDraftStint_isnull?: Maybe<Scalars['Boolean']>;
  /** quantityStudentsForDraftStint_iendswith */
  quantityStudentsForDraftStint_iendswith?: Maybe<Scalars['Float']>;
  quantityRepeatDaysForDraftStint?: Maybe<Scalars['Float']>;
  /** quantityRepeatDaysForDraftStint_gte */
  quantityRepeatDaysForDraftStint_gte?: Maybe<Scalars['Float']>;
  /** quantityRepeatDaysForDraftStint_lte */
  quantityRepeatDaysForDraftStint_lte?: Maybe<Scalars['Float']>;
  /** quantityRepeatDaysForDraftStint_istartswith */
  quantityRepeatDaysForDraftStint_istartswith?: Maybe<Scalars['Float']>;
  /** quantityRepeatDaysForDraftStint_lt */
  quantityRepeatDaysForDraftStint_lt?: Maybe<Scalars['Float']>;
  /** quantityRepeatDaysForDraftStint_gt */
  quantityRepeatDaysForDraftStint_gt?: Maybe<Scalars['Float']>;
  /** quantityRepeatDaysForDraftStint_isnull */
  quantityRepeatDaysForDraftStint_isnull?: Maybe<Scalars['Boolean']>;
  /** quantityRepeatDaysForDraftStint_iendswith */
  quantityRepeatDaysForDraftStint_iendswith?: Maybe<Scalars['Float']>;
  averageOwnerRating?: Maybe<Scalars['Float']>;
  /** averageOwnerRating_gte */
  averageOwnerRating_gte?: Maybe<Scalars['Float']>;
  /** averageOwnerRating_lte */
  averageOwnerRating_lte?: Maybe<Scalars['Float']>;
  /** averageOwnerRating_istartswith */
  averageOwnerRating_istartswith?: Maybe<Scalars['Float']>;
  /** averageOwnerRating_lt */
  averageOwnerRating_lt?: Maybe<Scalars['Float']>;
  /** averageOwnerRating_gt */
  averageOwnerRating_gt?: Maybe<Scalars['Float']>;
  /** averageOwnerRating_isnull */
  averageOwnerRating_isnull?: Maybe<Scalars['Boolean']>;
  /** averageOwnerRating_iendswith */
  averageOwnerRating_iendswith?: Maybe<Scalars['Float']>;
  /** controlCheck_gte */
  controlCheck_gte?: Maybe<Scalars['Boolean']>;
  /** controlCheck_lte */
  controlCheck_lte?: Maybe<Scalars['Boolean']>;
  /** controlCheck_istartswith */
  controlCheck_istartswith?: Maybe<Scalars['Boolean']>;
  /** controlCheck_lt */
  controlCheck_lt?: Maybe<Scalars['Boolean']>;
  /** controlCheck_gt */
  controlCheck_gt?: Maybe<Scalars['Boolean']>;
  /** controlCheck_isnull */
  controlCheck_isnull?: Maybe<Scalars['Boolean']>;
  /** controlCheck_iendswith */
  controlCheck_iendswith?: Maybe<Scalars['Boolean']>;
  pspReference?: Maybe<Scalars['String']>;
  /** pspReference_search */
  pspReference_search?: Maybe<Scalars['String']>;
  /** pspReference_gte */
  pspReference_gte?: Maybe<Scalars['String']>;
  /** pspReference_lte */
  pspReference_lte?: Maybe<Scalars['String']>;
  /** pspReference_istartswith */
  pspReference_istartswith?: Maybe<Scalars['String']>;
  /** pspReference_lt */
  pspReference_lt?: Maybe<Scalars['String']>;
  /** pspReference_gt */
  pspReference_gt?: Maybe<Scalars['String']>;
  /** pspReference_isnull */
  pspReference_isnull?: Maybe<Scalars['Boolean']>;
  /** pspReference_iendswith */
  pspReference_iendswith?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Float']>;
  /** status_gte */
  status_gte?: Maybe<Scalars['Float']>;
  /** status_lte */
  status_lte?: Maybe<Scalars['Float']>;
  /** status_istartswith */
  status_istartswith?: Maybe<Scalars['Float']>;
  /** status_lt */
  status_lt?: Maybe<Scalars['Float']>;
  /** status_gt */
  status_gt?: Maybe<Scalars['Float']>;
  /** status_isnull */
  status_isnull?: Maybe<Scalars['Boolean']>;
  /** status_iendswith */
  status_iendswith?: Maybe<Scalars['Float']>;
  stintCategory?: Maybe<Scalars['String']>;
  /** stintCategory_search */
  stintCategory_search?: Maybe<Scalars['String']>;
  /** stintCategory_gte */
  stintCategory_gte?: Maybe<Scalars['String']>;
  /** stintCategory_lte */
  stintCategory_lte?: Maybe<Scalars['String']>;
  /** stintCategory_istartswith */
  stintCategory_istartswith?: Maybe<Scalars['String']>;
  /** stintCategory_lt */
  stintCategory_lt?: Maybe<Scalars['String']>;
  /** stintCategory_gt */
  stintCategory_gt?: Maybe<Scalars['String']>;
  /** stintCategory_isnull */
  stintCategory_isnull?: Maybe<Scalars['Boolean']>;
  /** stintCategory_iendswith */
  stintCategory_iendswith?: Maybe<Scalars['String']>;
  isBestEffort?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_gte */
  isBestEffort_gte?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_lte */
  isBestEffort_lte?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_istartswith */
  isBestEffort_istartswith?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_lt */
  isBestEffort_lt?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_gt */
  isBestEffort_gt?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_isnull */
  isBestEffort_isnull?: Maybe<Scalars['Boolean']>;
  /** isBestEffort_iendswith */
  isBestEffort_iendswith?: Maybe<Scalars['Boolean']>;
  acceptanceMethod?: Maybe<Scalars['String']>;
  /** acceptanceMethod_search */
  acceptanceMethod_search?: Maybe<Scalars['String']>;
  /** acceptanceMethod_gte */
  acceptanceMethod_gte?: Maybe<Scalars['String']>;
  /** acceptanceMethod_lte */
  acceptanceMethod_lte?: Maybe<Scalars['String']>;
  /** acceptanceMethod_istartswith */
  acceptanceMethod_istartswith?: Maybe<Scalars['String']>;
  /** acceptanceMethod_lt */
  acceptanceMethod_lt?: Maybe<Scalars['String']>;
  /** acceptanceMethod_gt */
  acceptanceMethod_gt?: Maybe<Scalars['String']>;
  /** acceptanceMethod_isnull */
  acceptanceMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** acceptanceMethod_iendswith */
  acceptanceMethod_iendswith?: Maybe<Scalars['String']>;
  postMethod?: Maybe<Scalars['String']>;
  /** postMethod_search */
  postMethod_search?: Maybe<Scalars['String']>;
  /** postMethod_gte */
  postMethod_gte?: Maybe<Scalars['String']>;
  /** postMethod_lte */
  postMethod_lte?: Maybe<Scalars['String']>;
  /** postMethod_istartswith */
  postMethod_istartswith?: Maybe<Scalars['String']>;
  /** postMethod_lt */
  postMethod_lt?: Maybe<Scalars['String']>;
  /** postMethod_gt */
  postMethod_gt?: Maybe<Scalars['String']>;
  /** postMethod_isnull */
  postMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** postMethod_iendswith */
  postMethod_iendswith?: Maybe<Scalars['String']>;
  stintWeekTemplateRef?: Maybe<Scalars['UUID']>;
  /** stintWeekTemplateRef_gte */
  stintWeekTemplateRef_gte?: Maybe<Scalars['UUID']>;
  /** stintWeekTemplateRef_lte */
  stintWeekTemplateRef_lte?: Maybe<Scalars['UUID']>;
  /** stintWeekTemplateRef_istartswith */
  stintWeekTemplateRef_istartswith?: Maybe<Scalars['UUID']>;
  /** stintWeekTemplateRef_lt */
  stintWeekTemplateRef_lt?: Maybe<Scalars['UUID']>;
  /** stintWeekTemplateRef_gt */
  stintWeekTemplateRef_gt?: Maybe<Scalars['UUID']>;
  /** stintWeekTemplateRef_isnull */
  stintWeekTemplateRef_isnull?: Maybe<Scalars['Boolean']>;
  /** stintWeekTemplateRef_iendswith */
  stintWeekTemplateRef_iendswith?: Maybe<Scalars['UUID']>;
  stintWeekTemplateVersion?: Maybe<Scalars['Float']>;
  /** stintWeekTemplateVersion_gte */
  stintWeekTemplateVersion_gte?: Maybe<Scalars['Float']>;
  /** stintWeekTemplateVersion_lte */
  stintWeekTemplateVersion_lte?: Maybe<Scalars['Float']>;
  /** stintWeekTemplateVersion_istartswith */
  stintWeekTemplateVersion_istartswith?: Maybe<Scalars['Float']>;
  /** stintWeekTemplateVersion_lt */
  stintWeekTemplateVersion_lt?: Maybe<Scalars['Float']>;
  /** stintWeekTemplateVersion_gt */
  stintWeekTemplateVersion_gt?: Maybe<Scalars['Float']>;
  /** stintWeekTemplateVersion_isnull */
  stintWeekTemplateVersion_isnull?: Maybe<Scalars['Boolean']>;
  /** stintWeekTemplateVersion_iendswith */
  stintWeekTemplateVersion_iendswith?: Maybe<Scalars['Float']>;
  actualLeaveTime?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTime_gte */
  actualLeaveTime_gte?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTime_lte */
  actualLeaveTime_lte?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTime_istartswith */
  actualLeaveTime_istartswith?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTime_lt */
  actualLeaveTime_lt?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTime_gt */
  actualLeaveTime_gt?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTime_isnull */
  actualLeaveTime_isnull?: Maybe<Scalars['Boolean']>;
  /** actualLeaveTime_iendswith */
  actualLeaveTime_iendswith?: Maybe<Scalars['DateTime']>;
  actualLeaveTimeLoggedByUserRef?: Maybe<Scalars['UUID']>;
  /** actualLeaveTimeLoggedByUserRef_gte */
  actualLeaveTimeLoggedByUserRef_gte?: Maybe<Scalars['UUID']>;
  /** actualLeaveTimeLoggedByUserRef_lte */
  actualLeaveTimeLoggedByUserRef_lte?: Maybe<Scalars['UUID']>;
  /** actualLeaveTimeLoggedByUserRef_istartswith */
  actualLeaveTimeLoggedByUserRef_istartswith?: Maybe<Scalars['UUID']>;
  /** actualLeaveTimeLoggedByUserRef_lt */
  actualLeaveTimeLoggedByUserRef_lt?: Maybe<Scalars['UUID']>;
  /** actualLeaveTimeLoggedByUserRef_gt */
  actualLeaveTimeLoggedByUserRef_gt?: Maybe<Scalars['UUID']>;
  /** actualLeaveTimeLoggedByUserRef_isnull */
  actualLeaveTimeLoggedByUserRef_isnull?: Maybe<Scalars['Boolean']>;
  /** actualLeaveTimeLoggedByUserRef_iendswith */
  actualLeaveTimeLoggedByUserRef_iendswith?: Maybe<Scalars['UUID']>;
  actualLeaveTimeLastModifiedAt?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTimeLastModifiedAt_gte */
  actualLeaveTimeLastModifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTimeLastModifiedAt_lte */
  actualLeaveTimeLastModifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTimeLastModifiedAt_istartswith */
  actualLeaveTimeLastModifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTimeLastModifiedAt_lt */
  actualLeaveTimeLastModifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTimeLastModifiedAt_gt */
  actualLeaveTimeLastModifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** actualLeaveTimeLastModifiedAt_isnull */
  actualLeaveTimeLastModifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** actualLeaveTimeLastModifiedAt_iendswith */
  actualLeaveTimeLastModifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use primaryTasks ids to filter Stint by primaryTasks. */
  primaryTasks_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use secondaryTasks ids to filter Stint by secondaryTasks. */
  secondaryTasks_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use exceptions ids to filter Stint by exceptions. */
  exceptions_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use topTips ids to filter Stint by topTips. */
  topTips_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use students ids to filter Stint by students. */
  students_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use automationBatches ids to filter Stint by automationBatches. */
  automationBatches_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  notes_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  trained_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  dateAccepted_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  dateFrom_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  dateTo_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  dateToProposed_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  lastModified_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  checkInDate_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  checkOutDate_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  qrCodeCheckInDate_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  locationAddress_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  locationName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  longitude_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  latitude_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  invoiceStatus_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isDirectDebit_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  isFreeStint_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  paymentReference_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  paymentStatus_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  preAuthorizedAmount_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  bonusRate_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  bonusPay_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  bonusApplied_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  firebaseRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firebaseCreatedByBusinessRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firebaseContactPersonRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firebaseStudentRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  studentIsLate_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  studentRunningLateHalfwayCheck_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  eta_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  cancelledAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  nextAutomationBatchAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  isAutomationComplete_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  automationLastTriggeredAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  automationAttempts_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  uniformInstructions_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  trainingInstructions_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  healthAndSafety_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  opsNotifiedUnassigned_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  opsNotifiedLocationOff_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  quantityStudentsForDraftStint_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  quantityRepeatDaysForDraftStint_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  averageOwnerRating_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  controlCheck_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  pspReference_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  status_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  stintCategory_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isBestEffort_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  acceptanceMethod_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  postMethod_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  stintWeekTemplateRef_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  stintWeekTemplateVersion_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  actualLeaveTime_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  actualLeaveTimeLoggedByUserRef_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  actualLeaveTimeLastModifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

/**
 * The InputObjectType that represents all available filter inputs for filtering Stints.
 *
 * This is the Graphene InputObjectType that matches the StintFilters object that is used to
 * pass the filter args to StintQuerySet.apply_stint_filters.
 */
export type StintFilterInput = {
  /** A list of the days of the week that the user wishes to filter their list of Stints by. */
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  duration?: Maybe<StintDurationInput>;
};

/** An enumeration. */
export enum StintFooterTypeStatus {
  STINT_COMPLETED_NOT_REVIEWED = 'STINT_COMPLETED_NOT_REVIEWED',
  STINT_COMPLETED_AND_REVIEWED = 'STINT_COMPLETED_AND_REVIEWED',
  STINT_CANCELLED = 'STINT_CANCELLED',
  STINT_CHECKED_IN = 'STINT_CHECKED_IN',
  STINT_ACCEPTED_AND_CANCEL_ALLOWED = 'STINT_ACCEPTED_AND_CANCEL_ALLOWED',
  STINT_ACCEPTED_AND_CHECKIN_ALLOWED = 'STINT_ACCEPTED_AND_CHECKIN_ALLOWED',
}

export enum StintInvoiceStatus {
  /** Draft */
  DRAFT = 'DRAFT',
  /** Open */
  OPEN = 'OPEN',
  /** Paid */
  PAID = 'PAID',
  /** Void */
  VOID = 'VOID',
  /** Uncollectible */
  UNCOLLECTIBLE = 'UNCOLLECTIBLE',
}

export type StintJourney = {
  __typename?: 'StintJourney';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  status: StintJourneyStatus;
  statusResolved: Scalars['Boolean'];
  stint?: Maybe<Stint>;
  student: StintUser;
  studentInitialLocation?: Maybe<DeviceLocation>;
  /** Location used to calcualte estimated time of arrival. */
  etaCalcLocation?: Maybe<DeviceLocation>;
  stintNotificationReminder24hoursSent: Scalars['Boolean'];
  stintNotificationReminder12hoursSent: Scalars['Boolean'];
  confirmStintNotificationSentAt?: Maybe<Scalars['DateTime']>;
  stintConfirmationNotificationSent: Scalars['Boolean'];
  lastChanceToConfirmStintNotificationSentAt?: Maybe<Scalars['DateTime']>;
  stintConfirmationScreenViewed: Scalars['Boolean'];
  stintConfirmationScreenViewedAt?: Maybe<Scalars['DateTime']>;
  fastestRouteTimeCalculated: Scalars['Boolean'];
  enableGranularTrackingNotificationSent: Scalars['Boolean'];
  lastChanceToEnableGranularTrackingNotificationSent?: Maybe<
    Scalars['DateTime']
  >;
  studentArrivedAt?: Maybe<Scalars['DateTime']>;
  lastChanceToEnableGranularTrackingNotificationAt?: Maybe<Scalars['DateTime']>;
  estimatedTimeOfDeparture?: Maybe<Scalars['DateTime']>;
  leaveCheckDurationLate?: Maybe<Scalars['Float']>;
  halfwayCheckDurationLate?: Maybe<Scalars['Float']>;
  isGranularLocationTrackingEnabled: Scalars['Boolean'];
  estimatedTimeOfArrival?: Maybe<Scalars['DateTime']>;
  lateNote?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  doNotRemindAboutGeotracking: Scalars['Boolean'];
  statusModifiedAt?: Maybe<Scalars['DateTime']>;
  /** True if user is submitting locations trough new location services */
  usingNewLocationMicroservices?: Maybe<Scalars['Boolean']>;
  latestLocationLongitude?: Maybe<Scalars['Float']>;
  latestLocationLatitude?: Maybe<Scalars['Float']>;
  latestLocationRecordedAt?: Maybe<Scalars['DateTime']>;
  business?: Maybe<Business>;
  confirmationScreenAccepted?: Maybe<Scalars['Boolean']>;
  /** True if user eta is based on most recent location */
  isEtaBasedOnLatestLocation?: Maybe<Scalars['Boolean']>;
  /** Id of related Stint (auto-generated). */
  stint_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
  /** Id of related DeviceLocation (auto-generated). */
  student_initial_location_id?: Maybe<Scalars['UUID']>;
  /** Id of related DeviceLocation (auto-generated). */
  eta_calc_location_id?: Maybe<Scalars['UUID']>;
};

export type StintJourneyFilter = {
  /** startDate */
  startDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** startTimeFrom */
  startTimeFrom?: Maybe<Scalars['Time']>;
  /** startTimeTo */
  startTimeTo?: Maybe<Scalars['Time']>;
  /** Multiple values may be separated by commas. */
  status_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** statusGroup */
  statusGroup?: Maybe<Scalars['String']>;
  /** stint_id */
  stint_id?: Maybe<Scalars['UUID']>;
  /** stint_id_isnull */
  stint_id_isnull?: Maybe<Scalars['Boolean']>;
  /** student_id */
  student_id?: Maybe<Scalars['UUID']>;
  /** student_id_isnull */
  student_id_isnull?: Maybe<Scalars['Boolean']>;
  /** studentInitialLocation_id */
  studentInitialLocation_id?: Maybe<Scalars['UUID']>;
  /** studentInitialLocation_id_isnull */
  studentInitialLocation_id_isnull?: Maybe<Scalars['Boolean']>;
  /** etaCalcLocation_id */
  etaCalcLocation_id?: Maybe<Scalars['UUID']>;
  /** etaCalcLocation_id_isnull */
  etaCalcLocation_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  /** status_search */
  status_search?: Maybe<Scalars['String']>;
  /** status_gte */
  status_gte?: Maybe<Scalars['String']>;
  /** status_lte */
  status_lte?: Maybe<Scalars['String']>;
  /** status_istartswith */
  status_istartswith?: Maybe<Scalars['String']>;
  /** status_lt */
  status_lt?: Maybe<Scalars['String']>;
  /** status_gt */
  status_gt?: Maybe<Scalars['String']>;
  /** status_isnull */
  status_isnull?: Maybe<Scalars['Boolean']>;
  /** status_iendswith */
  status_iendswith?: Maybe<Scalars['String']>;
  statusResolved?: Maybe<Scalars['Boolean']>;
  /** statusResolved_gte */
  statusResolved_gte?: Maybe<Scalars['Boolean']>;
  /** statusResolved_lte */
  statusResolved_lte?: Maybe<Scalars['Boolean']>;
  /** statusResolved_istartswith */
  statusResolved_istartswith?: Maybe<Scalars['Boolean']>;
  /** statusResolved_lt */
  statusResolved_lt?: Maybe<Scalars['Boolean']>;
  /** statusResolved_gt */
  statusResolved_gt?: Maybe<Scalars['Boolean']>;
  /** statusResolved_isnull */
  statusResolved_isnull?: Maybe<Scalars['Boolean']>;
  /** statusResolved_iendswith */
  statusResolved_iendswith?: Maybe<Scalars['Boolean']>;
  stintNotificationReminder24HoursSent?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_gte */
  stintNotificationReminder24HoursSent_gte?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_lte */
  stintNotificationReminder24HoursSent_lte?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_istartswith */
  stintNotificationReminder24HoursSent_istartswith?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_lt */
  stintNotificationReminder24HoursSent_lt?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_gt */
  stintNotificationReminder24HoursSent_gt?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_isnull */
  stintNotificationReminder24HoursSent_isnull?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder24HoursSent_iendswith */
  stintNotificationReminder24HoursSent_iendswith?: Maybe<Scalars['Boolean']>;
  stintNotificationReminder12HoursSent?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_gte */
  stintNotificationReminder12HoursSent_gte?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_lte */
  stintNotificationReminder12HoursSent_lte?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_istartswith */
  stintNotificationReminder12HoursSent_istartswith?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_lt */
  stintNotificationReminder12HoursSent_lt?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_gt */
  stintNotificationReminder12HoursSent_gt?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_isnull */
  stintNotificationReminder12HoursSent_isnull?: Maybe<Scalars['Boolean']>;
  /** stintNotificationReminder12HoursSent_iendswith */
  stintNotificationReminder12HoursSent_iendswith?: Maybe<Scalars['Boolean']>;
  confirmStintNotificationSentAt?: Maybe<Scalars['DateTime']>;
  /** confirmStintNotificationSentAt_gte */
  confirmStintNotificationSentAt_gte?: Maybe<Scalars['DateTime']>;
  /** confirmStintNotificationSentAt_lte */
  confirmStintNotificationSentAt_lte?: Maybe<Scalars['DateTime']>;
  /** confirmStintNotificationSentAt_istartswith */
  confirmStintNotificationSentAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** confirmStintNotificationSentAt_lt */
  confirmStintNotificationSentAt_lt?: Maybe<Scalars['DateTime']>;
  /** confirmStintNotificationSentAt_gt */
  confirmStintNotificationSentAt_gt?: Maybe<Scalars['DateTime']>;
  /** confirmStintNotificationSentAt_isnull */
  confirmStintNotificationSentAt_isnull?: Maybe<Scalars['Boolean']>;
  /** confirmStintNotificationSentAt_iendswith */
  confirmStintNotificationSentAt_iendswith?: Maybe<Scalars['DateTime']>;
  stintConfirmationNotificationSent?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_gte */
  stintConfirmationNotificationSent_gte?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_lte */
  stintConfirmationNotificationSent_lte?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_istartswith */
  stintConfirmationNotificationSent_istartswith?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_lt */
  stintConfirmationNotificationSent_lt?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_gt */
  stintConfirmationNotificationSent_gt?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_isnull */
  stintConfirmationNotificationSent_isnull?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationNotificationSent_iendswith */
  stintConfirmationNotificationSent_iendswith?: Maybe<Scalars['Boolean']>;
  lastChanceToConfirmStintNotificationSentAt?: Maybe<Scalars['DateTime']>;
  /** lastChanceToConfirmStintNotificationSentAt_gte */
  lastChanceToConfirmStintNotificationSentAt_gte?: Maybe<Scalars['DateTime']>;
  /** lastChanceToConfirmStintNotificationSentAt_lte */
  lastChanceToConfirmStintNotificationSentAt_lte?: Maybe<Scalars['DateTime']>;
  /** lastChanceToConfirmStintNotificationSentAt_istartswith */
  lastChanceToConfirmStintNotificationSentAt_istartswith?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToConfirmStintNotificationSentAt_lt */
  lastChanceToConfirmStintNotificationSentAt_lt?: Maybe<Scalars['DateTime']>;
  /** lastChanceToConfirmStintNotificationSentAt_gt */
  lastChanceToConfirmStintNotificationSentAt_gt?: Maybe<Scalars['DateTime']>;
  /** lastChanceToConfirmStintNotificationSentAt_isnull */
  lastChanceToConfirmStintNotificationSentAt_isnull?: Maybe<Scalars['Boolean']>;
  /** lastChanceToConfirmStintNotificationSentAt_iendswith */
  lastChanceToConfirmStintNotificationSentAt_iendswith?: Maybe<
    Scalars['DateTime']
  >;
  stintConfirmationScreenViewed?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_gte */
  stintConfirmationScreenViewed_gte?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_lte */
  stintConfirmationScreenViewed_lte?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_istartswith */
  stintConfirmationScreenViewed_istartswith?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_lt */
  stintConfirmationScreenViewed_lt?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_gt */
  stintConfirmationScreenViewed_gt?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_isnull */
  stintConfirmationScreenViewed_isnull?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewed_iendswith */
  stintConfirmationScreenViewed_iendswith?: Maybe<Scalars['Boolean']>;
  stintConfirmationScreenViewedAt?: Maybe<Scalars['DateTime']>;
  /** stintConfirmationScreenViewedAt_gte */
  stintConfirmationScreenViewedAt_gte?: Maybe<Scalars['DateTime']>;
  /** stintConfirmationScreenViewedAt_lte */
  stintConfirmationScreenViewedAt_lte?: Maybe<Scalars['DateTime']>;
  /** stintConfirmationScreenViewedAt_istartswith */
  stintConfirmationScreenViewedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** stintConfirmationScreenViewedAt_lt */
  stintConfirmationScreenViewedAt_lt?: Maybe<Scalars['DateTime']>;
  /** stintConfirmationScreenViewedAt_gt */
  stintConfirmationScreenViewedAt_gt?: Maybe<Scalars['DateTime']>;
  /** stintConfirmationScreenViewedAt_isnull */
  stintConfirmationScreenViewedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** stintConfirmationScreenViewedAt_iendswith */
  stintConfirmationScreenViewedAt_iendswith?: Maybe<Scalars['DateTime']>;
  fastestRouteTimeCalculated?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_gte */
  fastestRouteTimeCalculated_gte?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_lte */
  fastestRouteTimeCalculated_lte?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_istartswith */
  fastestRouteTimeCalculated_istartswith?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_lt */
  fastestRouteTimeCalculated_lt?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_gt */
  fastestRouteTimeCalculated_gt?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_isnull */
  fastestRouteTimeCalculated_isnull?: Maybe<Scalars['Boolean']>;
  /** fastestRouteTimeCalculated_iendswith */
  fastestRouteTimeCalculated_iendswith?: Maybe<Scalars['Boolean']>;
  enableGranularTrackingNotificationSent?: Maybe<Scalars['Boolean']>;
  /** enableGranularTrackingNotificationSent_gte */
  enableGranularTrackingNotificationSent_gte?: Maybe<Scalars['Boolean']>;
  /** enableGranularTrackingNotificationSent_lte */
  enableGranularTrackingNotificationSent_lte?: Maybe<Scalars['Boolean']>;
  /** enableGranularTrackingNotificationSent_istartswith */
  enableGranularTrackingNotificationSent_istartswith?: Maybe<
    Scalars['Boolean']
  >;
  /** enableGranularTrackingNotificationSent_lt */
  enableGranularTrackingNotificationSent_lt?: Maybe<Scalars['Boolean']>;
  /** enableGranularTrackingNotificationSent_gt */
  enableGranularTrackingNotificationSent_gt?: Maybe<Scalars['Boolean']>;
  /** enableGranularTrackingNotificationSent_isnull */
  enableGranularTrackingNotificationSent_isnull?: Maybe<Scalars['Boolean']>;
  /** enableGranularTrackingNotificationSent_iendswith */
  enableGranularTrackingNotificationSent_iendswith?: Maybe<Scalars['Boolean']>;
  lastChanceToEnableGranularTrackingNotificationSent?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_gte */
  lastChanceToEnableGranularTrackingNotificationSent_gte?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_lte */
  lastChanceToEnableGranularTrackingNotificationSent_lte?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_istartswith */
  lastChanceToEnableGranularTrackingNotificationSent_istartswith?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_lt */
  lastChanceToEnableGranularTrackingNotificationSent_lt?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_gt */
  lastChanceToEnableGranularTrackingNotificationSent_gt?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_isnull */
  lastChanceToEnableGranularTrackingNotificationSent_isnull?: Maybe<
    Scalars['Boolean']
  >;
  /** lastChanceToEnableGranularTrackingNotificationSent_iendswith */
  lastChanceToEnableGranularTrackingNotificationSent_iendswith?: Maybe<
    Scalars['DateTime']
  >;
  studentArrivedAt?: Maybe<Scalars['DateTime']>;
  /** studentArrivedAt_gte */
  studentArrivedAt_gte?: Maybe<Scalars['DateTime']>;
  /** studentArrivedAt_lte */
  studentArrivedAt_lte?: Maybe<Scalars['DateTime']>;
  /** studentArrivedAt_istartswith */
  studentArrivedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** studentArrivedAt_lt */
  studentArrivedAt_lt?: Maybe<Scalars['DateTime']>;
  /** studentArrivedAt_gt */
  studentArrivedAt_gt?: Maybe<Scalars['DateTime']>;
  /** studentArrivedAt_isnull */
  studentArrivedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** studentArrivedAt_iendswith */
  studentArrivedAt_iendswith?: Maybe<Scalars['DateTime']>;
  lastChanceToEnableGranularTrackingNotificationAt?: Maybe<Scalars['DateTime']>;
  /** lastChanceToEnableGranularTrackingNotificationAt_gte */
  lastChanceToEnableGranularTrackingNotificationAt_gte?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationAt_lte */
  lastChanceToEnableGranularTrackingNotificationAt_lte?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationAt_istartswith */
  lastChanceToEnableGranularTrackingNotificationAt_istartswith?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationAt_lt */
  lastChanceToEnableGranularTrackingNotificationAt_lt?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationAt_gt */
  lastChanceToEnableGranularTrackingNotificationAt_gt?: Maybe<
    Scalars['DateTime']
  >;
  /** lastChanceToEnableGranularTrackingNotificationAt_isnull */
  lastChanceToEnableGranularTrackingNotificationAt_isnull?: Maybe<
    Scalars['Boolean']
  >;
  /** lastChanceToEnableGranularTrackingNotificationAt_iendswith */
  lastChanceToEnableGranularTrackingNotificationAt_iendswith?: Maybe<
    Scalars['DateTime']
  >;
  estimatedTimeOfDeparture?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfDeparture_gte */
  estimatedTimeOfDeparture_gte?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfDeparture_lte */
  estimatedTimeOfDeparture_lte?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfDeparture_istartswith */
  estimatedTimeOfDeparture_istartswith?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfDeparture_lt */
  estimatedTimeOfDeparture_lt?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfDeparture_gt */
  estimatedTimeOfDeparture_gt?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfDeparture_isnull */
  estimatedTimeOfDeparture_isnull?: Maybe<Scalars['Boolean']>;
  /** estimatedTimeOfDeparture_iendswith */
  estimatedTimeOfDeparture_iendswith?: Maybe<Scalars['DateTime']>;
  leaveCheckDurationLate?: Maybe<Scalars['String']>;
  /** leaveCheckDurationLate_gte */
  leaveCheckDurationLate_gte?: Maybe<Scalars['String']>;
  /** leaveCheckDurationLate_lte */
  leaveCheckDurationLate_lte?: Maybe<Scalars['String']>;
  /** leaveCheckDurationLate_istartswith */
  leaveCheckDurationLate_istartswith?: Maybe<Scalars['String']>;
  /** leaveCheckDurationLate_lt */
  leaveCheckDurationLate_lt?: Maybe<Scalars['String']>;
  /** leaveCheckDurationLate_gt */
  leaveCheckDurationLate_gt?: Maybe<Scalars['String']>;
  /** leaveCheckDurationLate_isnull */
  leaveCheckDurationLate_isnull?: Maybe<Scalars['Boolean']>;
  /** leaveCheckDurationLate_iendswith */
  leaveCheckDurationLate_iendswith?: Maybe<Scalars['String']>;
  halfwayCheckDurationLate?: Maybe<Scalars['String']>;
  /** halfwayCheckDurationLate_gte */
  halfwayCheckDurationLate_gte?: Maybe<Scalars['String']>;
  /** halfwayCheckDurationLate_lte */
  halfwayCheckDurationLate_lte?: Maybe<Scalars['String']>;
  /** halfwayCheckDurationLate_istartswith */
  halfwayCheckDurationLate_istartswith?: Maybe<Scalars['String']>;
  /** halfwayCheckDurationLate_lt */
  halfwayCheckDurationLate_lt?: Maybe<Scalars['String']>;
  /** halfwayCheckDurationLate_gt */
  halfwayCheckDurationLate_gt?: Maybe<Scalars['String']>;
  /** halfwayCheckDurationLate_isnull */
  halfwayCheckDurationLate_isnull?: Maybe<Scalars['Boolean']>;
  /** halfwayCheckDurationLate_iendswith */
  halfwayCheckDurationLate_iendswith?: Maybe<Scalars['String']>;
  isGranularLocationTrackingEnabled?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_gte */
  isGranularLocationTrackingEnabled_gte?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_lte */
  isGranularLocationTrackingEnabled_lte?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_istartswith */
  isGranularLocationTrackingEnabled_istartswith?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_lt */
  isGranularLocationTrackingEnabled_lt?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_gt */
  isGranularLocationTrackingEnabled_gt?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_isnull */
  isGranularLocationTrackingEnabled_isnull?: Maybe<Scalars['Boolean']>;
  /** isGranularLocationTrackingEnabled_iendswith */
  isGranularLocationTrackingEnabled_iendswith?: Maybe<Scalars['Boolean']>;
  estimatedTimeOfArrival?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfArrival_gte */
  estimatedTimeOfArrival_gte?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfArrival_lte */
  estimatedTimeOfArrival_lte?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfArrival_istartswith */
  estimatedTimeOfArrival_istartswith?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfArrival_lt */
  estimatedTimeOfArrival_lt?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfArrival_gt */
  estimatedTimeOfArrival_gt?: Maybe<Scalars['DateTime']>;
  /** estimatedTimeOfArrival_isnull */
  estimatedTimeOfArrival_isnull?: Maybe<Scalars['Boolean']>;
  /** estimatedTimeOfArrival_iendswith */
  estimatedTimeOfArrival_iendswith?: Maybe<Scalars['DateTime']>;
  lateNote?: Maybe<Scalars['String']>;
  /** lateNote_search */
  lateNote_search?: Maybe<Scalars['String']>;
  /** lateNote_gte */
  lateNote_gte?: Maybe<Scalars['String']>;
  /** lateNote_lte */
  lateNote_lte?: Maybe<Scalars['String']>;
  /** lateNote_istartswith */
  lateNote_istartswith?: Maybe<Scalars['String']>;
  /** lateNote_lt */
  lateNote_lt?: Maybe<Scalars['String']>;
  /** lateNote_gt */
  lateNote_gt?: Maybe<Scalars['String']>;
  /** lateNote_isnull */
  lateNote_isnull?: Maybe<Scalars['Boolean']>;
  /** lateNote_iendswith */
  lateNote_iendswith?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  /** internalNotes_search */
  internalNotes_search?: Maybe<Scalars['String']>;
  /** internalNotes_gte */
  internalNotes_gte?: Maybe<Scalars['String']>;
  /** internalNotes_lte */
  internalNotes_lte?: Maybe<Scalars['String']>;
  /** internalNotes_istartswith */
  internalNotes_istartswith?: Maybe<Scalars['String']>;
  /** internalNotes_lt */
  internalNotes_lt?: Maybe<Scalars['String']>;
  /** internalNotes_gt */
  internalNotes_gt?: Maybe<Scalars['String']>;
  /** internalNotes_isnull */
  internalNotes_isnull?: Maybe<Scalars['Boolean']>;
  /** internalNotes_iendswith */
  internalNotes_iendswith?: Maybe<Scalars['String']>;
  doNotRemindAboutGeotracking?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_gte */
  doNotRemindAboutGeotracking_gte?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_lte */
  doNotRemindAboutGeotracking_lte?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_istartswith */
  doNotRemindAboutGeotracking_istartswith?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_lt */
  doNotRemindAboutGeotracking_lt?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_gt */
  doNotRemindAboutGeotracking_gt?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_isnull */
  doNotRemindAboutGeotracking_isnull?: Maybe<Scalars['Boolean']>;
  /** doNotRemindAboutGeotracking_iendswith */
  doNotRemindAboutGeotracking_iendswith?: Maybe<Scalars['Boolean']>;
  statusModifiedAt?: Maybe<Scalars['DateTime']>;
  /** statusModifiedAt_gte */
  statusModifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** statusModifiedAt_lte */
  statusModifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** statusModifiedAt_istartswith */
  statusModifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** statusModifiedAt_lt */
  statusModifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** statusModifiedAt_gt */
  statusModifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** statusModifiedAt_isnull */
  statusModifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** statusModifiedAt_iendswith */
  statusModifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  usingNewLocationMicroservices?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_gte */
  usingNewLocationMicroservices_gte?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_lte */
  usingNewLocationMicroservices_lte?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_istartswith */
  usingNewLocationMicroservices_istartswith?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_lt */
  usingNewLocationMicroservices_lt?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_gt */
  usingNewLocationMicroservices_gt?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_isnull */
  usingNewLocationMicroservices_isnull?: Maybe<Scalars['Boolean']>;
  /** usingNewLocationMicroservices_iendswith */
  usingNewLocationMicroservices_iendswith?: Maybe<Scalars['Boolean']>;
  latestLocationLongitude?: Maybe<Scalars['Float']>;
  /** latestLocationLongitude_gte */
  latestLocationLongitude_gte?: Maybe<Scalars['Float']>;
  /** latestLocationLongitude_lte */
  latestLocationLongitude_lte?: Maybe<Scalars['Float']>;
  /** latestLocationLongitude_istartswith */
  latestLocationLongitude_istartswith?: Maybe<Scalars['Float']>;
  /** latestLocationLongitude_lt */
  latestLocationLongitude_lt?: Maybe<Scalars['Float']>;
  /** latestLocationLongitude_gt */
  latestLocationLongitude_gt?: Maybe<Scalars['Float']>;
  /** latestLocationLongitude_isnull */
  latestLocationLongitude_isnull?: Maybe<Scalars['Boolean']>;
  /** latestLocationLongitude_iendswith */
  latestLocationLongitude_iendswith?: Maybe<Scalars['Float']>;
  latestLocationLatitude?: Maybe<Scalars['Float']>;
  /** latestLocationLatitude_gte */
  latestLocationLatitude_gte?: Maybe<Scalars['Float']>;
  /** latestLocationLatitude_lte */
  latestLocationLatitude_lte?: Maybe<Scalars['Float']>;
  /** latestLocationLatitude_istartswith */
  latestLocationLatitude_istartswith?: Maybe<Scalars['Float']>;
  /** latestLocationLatitude_lt */
  latestLocationLatitude_lt?: Maybe<Scalars['Float']>;
  /** latestLocationLatitude_gt */
  latestLocationLatitude_gt?: Maybe<Scalars['Float']>;
  /** latestLocationLatitude_isnull */
  latestLocationLatitude_isnull?: Maybe<Scalars['Boolean']>;
  /** latestLocationLatitude_iendswith */
  latestLocationLatitude_iendswith?: Maybe<Scalars['Float']>;
  latestLocationRecordedAt?: Maybe<Scalars['DateTime']>;
  /** latestLocationRecordedAt_gte */
  latestLocationRecordedAt_gte?: Maybe<Scalars['DateTime']>;
  /** latestLocationRecordedAt_lte */
  latestLocationRecordedAt_lte?: Maybe<Scalars['DateTime']>;
  /** latestLocationRecordedAt_istartswith */
  latestLocationRecordedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** latestLocationRecordedAt_lt */
  latestLocationRecordedAt_lt?: Maybe<Scalars['DateTime']>;
  /** latestLocationRecordedAt_gt */
  latestLocationRecordedAt_gt?: Maybe<Scalars['DateTime']>;
  /** latestLocationRecordedAt_isnull */
  latestLocationRecordedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** latestLocationRecordedAt_iendswith */
  latestLocationRecordedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  city_id_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  business_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  student_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  statusResolved_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  stintNotificationReminder24HoursSent_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  stintNotificationReminder12HoursSent_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  confirmStintNotificationSentAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  stintConfirmationNotificationSent_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  lastChanceToConfirmStintNotificationSentAt_in?: Maybe<
    Array<Maybe<Scalars['DateTime']>>
  >;
  /** Multiple values may be separated by commas. */
  stintConfirmationScreenViewed_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  stintConfirmationScreenViewedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  fastestRouteTimeCalculated_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  enableGranularTrackingNotificationSent_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  lastChanceToEnableGranularTrackingNotificationSent_in?: Maybe<
    Array<Maybe<Scalars['DateTime']>>
  >;
  /** Multiple values may be separated by commas. */
  studentArrivedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  lastChanceToEnableGranularTrackingNotificationAt_in?: Maybe<
    Array<Maybe<Scalars['DateTime']>>
  >;
  /** Multiple values may be separated by commas. */
  estimatedTimeOfDeparture_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  leaveCheckDurationLate_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  halfwayCheckDurationLate_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isGranularLocationTrackingEnabled_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  estimatedTimeOfArrival_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  lateNote_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  internalNotes_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  doNotRemindAboutGeotracking_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  statusModifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  usingNewLocationMicroservices_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  latestLocationLongitude_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  latestLocationLatitude_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  latestLocationRecordedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

export enum StintJourneyStatus {
  /** No Confirmation */
  NO_CONFIRMATION = 'NO_CONFIRMATION',
  /** Tracking Off */
  TRACKING_OFF = 'TRACKING_OFF',
  /** Hasn't Left */
  HAS_NOT_LEFT = 'HAS_NOT_LEFT',
  /** Hasn't Arrived */
  HAS_NOT_ARRIVED = 'HAS_NOT_ARRIVED',
  /** Going to be late */
  GOING_TO_BE_LATE = 'GOING_TO_BE_LATE',
  /** Arrived */
  ARRIVED = 'ARRIVED',
  /** Checked-in */
  CHECKED_IN = 'CHECKED_IN',
  /** On Track */
  ON_TRACK = 'ON_TRACK',
}

export type StintListType = {
  __typename?: 'StintListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<Stint>>>;
};

/**
 * StintNodeType used by queries that use relay pagination.
 *
 * A query would use the FilterConnectionField and the StintNodeType as the object type.
 */
export type StintNode = Node & {
  __typename?: 'StintNode';
  /** The ID of the Stint. */
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** Determines if the Stint is a trained Stint. */
  trained: Scalars['Boolean'];
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  primaryTasks: Array<StintTask>;
  secondaryTasks: Array<StintTask>;
  exceptions: Array<EmploymentException>;
  topTips: Array<TopTip>;
  business?: Maybe<Business>;
  uniform?: Maybe<Array<Maybe<Scalars['String']>>>;
  notes?: Maybe<Scalars['String']>;
  dateAccepted?: Maybe<Scalars['DateTime']>;
  dateToProposed?: Maybe<Scalars['DateTime']>;
  lastModified?: Maybe<Scalars['DateTime']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  checkOutDate?: Maybe<Scalars['DateTime']>;
  manualCheckInReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  qrCodeCheckInDate?: Maybe<Scalars['DateTime']>;
  /** The address of the Stint */
  address?: Maybe<Address>;
  city?: Maybe<City>;
  /**
   * Duplicate field of Address.short_name. Stored as NULL in the
   * database until an address has been added.
   */
  locationAddress?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  invoiceStatus?: Maybe<StintInvoiceStatus>;
  isDirectDebit: Scalars['Boolean'];
  isFreeStint: Scalars['Boolean'];
  paymentReference?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['Int']>;
  preAuthorizedAmount?: Maybe<Scalars['Int']>;
  selectedPaymentMethod?: Maybe<DirectDebitPaymentMethod>;
  selectedCardPaymentMethod?: Maybe<CardPaymentMethod>;
  student?: Maybe<StintUser>;
  studentIsLate: Scalars['Boolean'];
  studentRunningLateHalfwayCheck: Scalars['Boolean'];
  eta?: Maybe<Scalars['Float']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelledBy?: Maybe<StintUser>;
  nextAutomationBatchAt?: Maybe<Scalars['DateTime']>;
  isAutomationComplete: Scalars['Boolean'];
  automationLastTriggeredAt?: Maybe<Scalars['DateTime']>;
  automationAttempts?: Maybe<Scalars['Int']>;
  uniformInstructions?: Maybe<Scalars['String']>;
  trainingInstructions?: Maybe<Scalars['String']>;
  healthAndSafety?: Maybe<Scalars['String']>;
  opsNotifiedUnassigned: Scalars['Boolean'];
  opsNotifiedLocationOff: Scalars['Boolean'];
  quantityStudentsForDraftStint?: Maybe<Scalars['Int']>;
  quantityRepeatDaysForDraftStint?: Maybe<Scalars['Int']>;
  repeatDaysForDraftStint?: Maybe<Array<Maybe<Scalars['Date']>>>;
  averageOwnerRating?: Maybe<Scalars['Float']>;
  /** If True, the Stint will not be automatically matched with students to allow the ops team to manually assign students */
  controlCheck: Scalars['Boolean'];
  /**
   * Stored as NULL in the database if the user who created the Stint
   * is not associated with the Stint.
   */
  createdByUser?: Maybe<StintUser>;
  differentStartTimeReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  pspReference?: Maybe<Scalars['String']>;
  stintCategory?: Maybe<Scalars['String']>;
  /** Stored as NULL in the database if the stint does not have a template */
  stintTemplate?: Maybe<StintTemplate>;
  isBestEffort: Scalars['Boolean'];
  acceptanceMethod?: Maybe<StintAcceptanceMethod>;
  stintOffersToStudent: Array<StintOffer>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  businessreviewSet: Array<BusinessReview>;
  stintjourneySet: Array<StintJourney>;
  studentreviewSet: Array<StudentReview>;
  studentunassignedeventSet: Array<StudentUnassignedEvent>;
  /** The Stint for which the Stinter was issued an Offence. Nullable for the really old records migrated from the old spreadsheet and for redemption type Offence records. */
  offenceSet: StinterOffenceTypeConnection;
  /** The role */
  role?: Maybe<Scalars['String']>;
  /**
   * DEPRECATED: The frontend will calculate the distance. This will now always return null.
   *
   * Birds-eye distance between the user's last recorded location and address of the Stint
   * (in miles, to the nearest decimal place e.g. 0.9, 1.1, 2.0)
   */
  distanceToStintAddress?: Maybe<Scalars['Float']>;
  /**
   * Resolved the rates & pay that the Stinter is eligible for when working this Stint.
   *
   * Errors:
   * - UNAUTHORIZED when a non Stinter user makes the request.
   * - MISSING_MONETARY_VALUE when a non nullable monetary value is somehow null in the database.
   */
  stinterPay: StinterPay;
  /** The site that the Stint belongs to. */
  site: PartnerSiteProfile;
};

/**
 * StintNodeType used by queries that use relay pagination.
 *
 * A query would use the FilterConnectionField and the StintNodeType as the object type.
 */
export type StintNodeoffenceSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type StintNodeTypeConnection = {
  __typename?: 'StintNodeTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<StintNodeTypeEdge>;
};

export type StintNodeTypeEdge = {
  __typename?: 'StintNodeTypeEdge';
  /** The item at the end of the edge */
  node: StintNode;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type StintOffer = {
  __typename?: 'StintOffer';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  student?: Maybe<StintUser>;
  stint?: Maybe<Stint>;
  status: StintOfferToStudentStatus;
  offerMadeAt: Scalars['DateTime'];
  offerAcceptedAt?: Maybe<Scalars['DateTime']>;
  offerReadAt?: Maybe<Scalars['DateTime']>;
  offerType: StintOfferToStudentOfferType;
  offerStintCancelledAt?: Maybe<Scalars['DateTime']>;
  offerSeenAt?: Maybe<Scalars['DateTime']>;
  modifiedAt: Scalars['DateTime'];
  business?: Maybe<Business>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
  /** Id of related Stint (auto-generated). */
  stint_id?: Maybe<Scalars['UUID']>;
};

export type StintOfferListType = {
  __typename?: 'StintOfferListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StintOffer>>>;
};

export type StintOfferToStudentFilter = {
  status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** student_id */
  student_id?: Maybe<Scalars['UUID']>;
  /** student_id_isnull */
  student_id_isnull?: Maybe<Scalars['Boolean']>;
  /** stint_id */
  stint_id?: Maybe<Scalars['UUID']>;
  /** stint_id_isnull */
  stint_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** status_search */
  status_search?: Maybe<Scalars['String']>;
  /** status_gte */
  status_gte?: Maybe<Scalars['String']>;
  /** status_lte */
  status_lte?: Maybe<Scalars['String']>;
  /** status_istartswith */
  status_istartswith?: Maybe<Scalars['String']>;
  /** status_lt */
  status_lt?: Maybe<Scalars['String']>;
  /** status_gt */
  status_gt?: Maybe<Scalars['String']>;
  /** status_isnull */
  status_isnull?: Maybe<Scalars['Boolean']>;
  /** status_iendswith */
  status_iendswith?: Maybe<Scalars['String']>;
  offerMadeAt?: Maybe<Scalars['DateTime']>;
  /** offerMadeAt_gte */
  offerMadeAt_gte?: Maybe<Scalars['DateTime']>;
  /** offerMadeAt_lte */
  offerMadeAt_lte?: Maybe<Scalars['DateTime']>;
  /** offerMadeAt_istartswith */
  offerMadeAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** offerMadeAt_lt */
  offerMadeAt_lt?: Maybe<Scalars['DateTime']>;
  /** offerMadeAt_gt */
  offerMadeAt_gt?: Maybe<Scalars['DateTime']>;
  /** offerMadeAt_isnull */
  offerMadeAt_isnull?: Maybe<Scalars['Boolean']>;
  /** offerMadeAt_iendswith */
  offerMadeAt_iendswith?: Maybe<Scalars['DateTime']>;
  offerAcceptedAt?: Maybe<Scalars['DateTime']>;
  /** offerAcceptedAt_gte */
  offerAcceptedAt_gte?: Maybe<Scalars['DateTime']>;
  /** offerAcceptedAt_lte */
  offerAcceptedAt_lte?: Maybe<Scalars['DateTime']>;
  /** offerAcceptedAt_istartswith */
  offerAcceptedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** offerAcceptedAt_lt */
  offerAcceptedAt_lt?: Maybe<Scalars['DateTime']>;
  /** offerAcceptedAt_gt */
  offerAcceptedAt_gt?: Maybe<Scalars['DateTime']>;
  /** offerAcceptedAt_isnull */
  offerAcceptedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** offerAcceptedAt_iendswith */
  offerAcceptedAt_iendswith?: Maybe<Scalars['DateTime']>;
  offerReadAt?: Maybe<Scalars['DateTime']>;
  /** offerReadAt_gte */
  offerReadAt_gte?: Maybe<Scalars['DateTime']>;
  /** offerReadAt_lte */
  offerReadAt_lte?: Maybe<Scalars['DateTime']>;
  /** offerReadAt_istartswith */
  offerReadAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** offerReadAt_lt */
  offerReadAt_lt?: Maybe<Scalars['DateTime']>;
  /** offerReadAt_gt */
  offerReadAt_gt?: Maybe<Scalars['DateTime']>;
  /** offerReadAt_isnull */
  offerReadAt_isnull?: Maybe<Scalars['Boolean']>;
  /** offerReadAt_iendswith */
  offerReadAt_iendswith?: Maybe<Scalars['DateTime']>;
  offerType?: Maybe<Scalars['String']>;
  /** offerType_search */
  offerType_search?: Maybe<Scalars['String']>;
  /** offerType_gte */
  offerType_gte?: Maybe<Scalars['String']>;
  /** offerType_lte */
  offerType_lte?: Maybe<Scalars['String']>;
  /** offerType_istartswith */
  offerType_istartswith?: Maybe<Scalars['String']>;
  /** offerType_lt */
  offerType_lt?: Maybe<Scalars['String']>;
  /** offerType_gt */
  offerType_gt?: Maybe<Scalars['String']>;
  /** offerType_isnull */
  offerType_isnull?: Maybe<Scalars['Boolean']>;
  /** offerType_iendswith */
  offerType_iendswith?: Maybe<Scalars['String']>;
  offerStintCancelledAt?: Maybe<Scalars['DateTime']>;
  /** offerStintCancelledAt_gte */
  offerStintCancelledAt_gte?: Maybe<Scalars['DateTime']>;
  /** offerStintCancelledAt_lte */
  offerStintCancelledAt_lte?: Maybe<Scalars['DateTime']>;
  /** offerStintCancelledAt_istartswith */
  offerStintCancelledAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** offerStintCancelledAt_lt */
  offerStintCancelledAt_lt?: Maybe<Scalars['DateTime']>;
  /** offerStintCancelledAt_gt */
  offerStintCancelledAt_gt?: Maybe<Scalars['DateTime']>;
  /** offerStintCancelledAt_isnull */
  offerStintCancelledAt_isnull?: Maybe<Scalars['Boolean']>;
  /** offerStintCancelledAt_iendswith */
  offerStintCancelledAt_iendswith?: Maybe<Scalars['DateTime']>;
  offerSeenAt?: Maybe<Scalars['DateTime']>;
  /** offerSeenAt_gte */
  offerSeenAt_gte?: Maybe<Scalars['DateTime']>;
  /** offerSeenAt_lte */
  offerSeenAt_lte?: Maybe<Scalars['DateTime']>;
  /** offerSeenAt_istartswith */
  offerSeenAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** offerSeenAt_lt */
  offerSeenAt_lt?: Maybe<Scalars['DateTime']>;
  /** offerSeenAt_gt */
  offerSeenAt_gt?: Maybe<Scalars['DateTime']>;
  /** offerSeenAt_isnull */
  offerSeenAt_isnull?: Maybe<Scalars['Boolean']>;
  /** offerSeenAt_iendswith */
  offerSeenAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  status_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  offerMadeAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  offerAcceptedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  offerReadAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  offerType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  offerStintCancelledAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  offerSeenAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

export enum StintOfferToStudentOfferType {
  /** Stintmatcher */
  STINTMATCHER = 'STINTMATCHER',
  /** Stintmatcher Top Up */
  STINTMATCHER_TOP_UP = 'STINTMATCHER_TOP_UP',
  /** Waterfall */
  WATERFALL = 'WATERFALL',
  /** Pushnotif */
  PUSHNOTIF = 'PUSHNOTIF',
  /** Availability matching. Deprecated: Use OFFER_TYPE_STINTMATCHER instead */
  AVAILABILITY_MATCHING = 'AVAILABILITY_MATCHING',
  /** Automation. Deprecated: Use STINTMACHER or STINT MATCHER TOP UP */
  AUTOMATION = 'AUTOMATION',
}

export enum StintOfferToStudentStatus {
  /** Open */
  OPEN = 'OPEN',
  /** Read */
  READ = 'READ',
  /** Accepted */
  ACCEPTED = 'ACCEPTED',
  /** Unaccepted */
  UNACCEPTED = 'UNACCEPTED',
  /** Replaced */
  REPLACED = 'REPLACED',
  /** Expired */
  EXPIRED = 'EXPIRED',
  /** Missed */
  MISSED = 'MISSED',
  /** Cancelled */
  CANCELLED = 'CANCELLED',
  /** Unaccepted Stint */
  STUDENT_CANCELLED_STINT = 'STUDENT_CANCELLED_STINT',
  /** Cancelled on student deactivation */
  CANCELLED_ON_STUDENT_DEACTIVATION = 'CANCELLED_ON_STUDENT_DEACTIVATION',
}

/** The StintRates type represents the monetary values for a Stint. */
export type StintRates = {
  __typename?: 'StintRates';
  /** The optional override value for the base hourly fee charged to the Site. */
  baseFeeOverride?: Maybe<Scalars['Decimal']>;
  /** The total amount to be charged to the Site including VAT. */
  totalFeeWithVat?: Maybe<Scalars['Decimal']>;
  /** The value that the Site will be charged if they cancelled the Stint. */
  cancellationFee?: Maybe<Scalars['Decimal']>;
  /** Whether or not the cancellation fee is overridden. If True then the Site will not be charged the cancellation fee. */
  cancellationFeeApplied?: Maybe<Scalars['Boolean']>;
  /** The optional override value for the base hourly rate paid to the Stinter. */
  baseRateOverride?: Maybe<Scalars['Decimal']>;
  /** The total base pay that is paid to the Stinter. */
  basePay?: Maybe<Scalars['Decimal']>;
  /** The optional value for the surge hourly rate paid to the Stinter. */
  surgeRate?: Maybe<Scalars['Decimal']>;
  /** The total surge pay that is paid to the Stinter. */
  surgePay?: Maybe<Scalars['Decimal']>;
  /** Whether or not the surge pay is applied for the assigned Stinter. Null when no Stinter is assigned. */
  surgeApplied?: Maybe<Scalars['Boolean']>;
  /** The optional value for the bonus hourly rate paid to the Stinter. */
  bonusRate?: Maybe<Scalars['Decimal']>;
  /** The total bonus pay that is paid to the Stinter. */
  bonusPay?: Maybe<Scalars['Decimal']>;
  /** Whether or not the bonus pay is applied for the assigned Stinter. Null when no Stinter is assigned. */
  bonusApplied?: Maybe<Scalars['Boolean']>;
};

/** StintSessionDay */
export enum StintSessionDay {
  DAY_MONDAY = 'DAY_MONDAY',
  DAY_TUESDAY = 'DAY_TUESDAY',
  DAY_WEDNESDAY = 'DAY_WEDNESDAY',
  DAY_THURSDAY = 'DAY_THURSDAY',
  DAY_FRIDAY = 'DAY_FRIDAY',
  DAY_SATURDAY = 'DAY_SATURDAY',
  DAY_SUNDAY = 'DAY_SUNDAY',
}

export type StintSessionTemplate = {
  __typename?: 'StintSessionTemplate';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  peekTime?: Maybe<Scalars['String']>;
  startTime: Scalars['Time'];
  endTime: Scalars['Time'];
  day: StintSessionTemplateDay;
  stintTemplateStudents: Array<StintTemplateStudents>;
  isActive: Scalars['Boolean'];
  /** Stint template associated with student count for that template. */
  studentsPerStintTemplate?: Maybe<Array<Maybe<StintTemplateStudents>>>;
  /** Is this custom session or predefined one. */
  isCustom?: Maybe<Scalars['Boolean']>;
};

export enum StintSessionTemplateDay {
  /** Monday */
  DAY_MONDAY = 'DAY_MONDAY',
  /** Tuesday */
  DAY_TUESDAY = 'DAY_TUESDAY',
  /** Wednesday */
  DAY_WEDNESDAY = 'DAY_WEDNESDAY',
  /** Thursday */
  DAY_THURSDAY = 'DAY_THURSDAY',
  /** Friday */
  DAY_FRIDAY = 'DAY_FRIDAY',
  /** Saturday */
  DAY_SATURDAY = 'DAY_SATURDAY',
  /** Sunday */
  DAY_SUNDAY = 'DAY_SUNDAY',
}

export type StintTask = {
  __typename?: 'StintTask';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  /** Informs about object order in list of objects. Edit only using perform_reordering method from the Reordering class. */
  sortOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  alternativeName: Scalars['String'];
  taskType: StintTaskTaskType;
  /** The total number of stints that have been posted that task */
  totalNumberPostedTask?: Maybe<Scalars['Int']>;
  /** The total number of businesses that have posted that task */
  totalNumberBusinessesPosted?: Maybe<Scalars['Int']>;
  /** Average student to business rating for the stints posted with that task */
  averageStudentRatingPosted?: Maybe<Scalars['Float']>;
  /** Average business to student rating for the stints posted with that task */
  averageBusinessRatingPosted?: Maybe<Scalars['Float']>;
  isDefault: Scalars['Boolean'];
  /** List of top tips associated with task */
  topTips?: Maybe<Array<Maybe<TopTip>>>;
  /** Id of related BusinessRole (auto-generated). */
  role_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessCategory (auto-generated). */
  business_category_id?: Maybe<Scalars['UUID']>;
};

export type StintTaskFilter = {
  search?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  /** role_id */
  role_id?: Maybe<Scalars['UUID']>;
  /** role_id_isnull */
  role_id_isnull?: Maybe<Scalars['Boolean']>;
  /** businessCategory_id */
  businessCategory_id?: Maybe<Scalars['UUID']>;
  /** businessCategory_id_isnull */
  businessCategory_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  sortOrder?: Maybe<Scalars['Float']>;
  /** sortOrder_gte */
  sortOrder_gte?: Maybe<Scalars['Float']>;
  /** sortOrder_lte */
  sortOrder_lte?: Maybe<Scalars['Float']>;
  /** sortOrder_istartswith */
  sortOrder_istartswith?: Maybe<Scalars['Float']>;
  /** sortOrder_lt */
  sortOrder_lt?: Maybe<Scalars['Float']>;
  /** sortOrder_gt */
  sortOrder_gt?: Maybe<Scalars['Float']>;
  /** sortOrder_isnull */
  sortOrder_isnull?: Maybe<Scalars['Boolean']>;
  /** sortOrder_iendswith */
  sortOrder_iendswith?: Maybe<Scalars['Float']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  alternativeName?: Maybe<Scalars['String']>;
  /** alternativeName_search */
  alternativeName_search?: Maybe<Scalars['String']>;
  /** alternativeName_gte */
  alternativeName_gte?: Maybe<Scalars['String']>;
  /** alternativeName_lte */
  alternativeName_lte?: Maybe<Scalars['String']>;
  /** alternativeName_istartswith */
  alternativeName_istartswith?: Maybe<Scalars['String']>;
  /** alternativeName_lt */
  alternativeName_lt?: Maybe<Scalars['String']>;
  /** alternativeName_gt */
  alternativeName_gt?: Maybe<Scalars['String']>;
  /** alternativeName_isnull */
  alternativeName_isnull?: Maybe<Scalars['Boolean']>;
  /** alternativeName_iendswith */
  alternativeName_iendswith?: Maybe<Scalars['String']>;
  taskType?: Maybe<Scalars['String']>;
  /** taskType_search */
  taskType_search?: Maybe<Scalars['String']>;
  /** taskType_gte */
  taskType_gte?: Maybe<Scalars['String']>;
  /** taskType_lte */
  taskType_lte?: Maybe<Scalars['String']>;
  /** taskType_istartswith */
  taskType_istartswith?: Maybe<Scalars['String']>;
  /** taskType_lt */
  taskType_lt?: Maybe<Scalars['String']>;
  /** taskType_gt */
  taskType_gt?: Maybe<Scalars['String']>;
  /** taskType_isnull */
  taskType_isnull?: Maybe<Scalars['Boolean']>;
  /** taskType_iendswith */
  taskType_iendswith?: Maybe<Scalars['String']>;
  totalNumberPostedTask?: Maybe<Scalars['Float']>;
  /** totalNumberPostedTask_gte */
  totalNumberPostedTask_gte?: Maybe<Scalars['Float']>;
  /** totalNumberPostedTask_lte */
  totalNumberPostedTask_lte?: Maybe<Scalars['Float']>;
  /** totalNumberPostedTask_istartswith */
  totalNumberPostedTask_istartswith?: Maybe<Scalars['Float']>;
  /** totalNumberPostedTask_lt */
  totalNumberPostedTask_lt?: Maybe<Scalars['Float']>;
  /** totalNumberPostedTask_gt */
  totalNumberPostedTask_gt?: Maybe<Scalars['Float']>;
  /** totalNumberPostedTask_isnull */
  totalNumberPostedTask_isnull?: Maybe<Scalars['Boolean']>;
  /** totalNumberPostedTask_iendswith */
  totalNumberPostedTask_iendswith?: Maybe<Scalars['Float']>;
  totalNumberBusinessesPosted?: Maybe<Scalars['Float']>;
  /** totalNumberBusinessesPosted_gte */
  totalNumberBusinessesPosted_gte?: Maybe<Scalars['Float']>;
  /** totalNumberBusinessesPosted_lte */
  totalNumberBusinessesPosted_lte?: Maybe<Scalars['Float']>;
  /** totalNumberBusinessesPosted_istartswith */
  totalNumberBusinessesPosted_istartswith?: Maybe<Scalars['Float']>;
  /** totalNumberBusinessesPosted_lt */
  totalNumberBusinessesPosted_lt?: Maybe<Scalars['Float']>;
  /** totalNumberBusinessesPosted_gt */
  totalNumberBusinessesPosted_gt?: Maybe<Scalars['Float']>;
  /** totalNumberBusinessesPosted_isnull */
  totalNumberBusinessesPosted_isnull?: Maybe<Scalars['Boolean']>;
  /** totalNumberBusinessesPosted_iendswith */
  totalNumberBusinessesPosted_iendswith?: Maybe<Scalars['Float']>;
  averageStudentRatingPosted?: Maybe<Scalars['Float']>;
  /** averageStudentRatingPosted_gte */
  averageStudentRatingPosted_gte?: Maybe<Scalars['Float']>;
  /** averageStudentRatingPosted_lte */
  averageStudentRatingPosted_lte?: Maybe<Scalars['Float']>;
  /** averageStudentRatingPosted_istartswith */
  averageStudentRatingPosted_istartswith?: Maybe<Scalars['Float']>;
  /** averageStudentRatingPosted_lt */
  averageStudentRatingPosted_lt?: Maybe<Scalars['Float']>;
  /** averageStudentRatingPosted_gt */
  averageStudentRatingPosted_gt?: Maybe<Scalars['Float']>;
  /** averageStudentRatingPosted_isnull */
  averageStudentRatingPosted_isnull?: Maybe<Scalars['Boolean']>;
  /** averageStudentRatingPosted_iendswith */
  averageStudentRatingPosted_iendswith?: Maybe<Scalars['Float']>;
  averageBusinessRatingPosted?: Maybe<Scalars['Float']>;
  /** averageBusinessRatingPosted_gte */
  averageBusinessRatingPosted_gte?: Maybe<Scalars['Float']>;
  /** averageBusinessRatingPosted_lte */
  averageBusinessRatingPosted_lte?: Maybe<Scalars['Float']>;
  /** averageBusinessRatingPosted_istartswith */
  averageBusinessRatingPosted_istartswith?: Maybe<Scalars['Float']>;
  /** averageBusinessRatingPosted_lt */
  averageBusinessRatingPosted_lt?: Maybe<Scalars['Float']>;
  /** averageBusinessRatingPosted_gt */
  averageBusinessRatingPosted_gt?: Maybe<Scalars['Float']>;
  /** averageBusinessRatingPosted_isnull */
  averageBusinessRatingPosted_isnull?: Maybe<Scalars['Boolean']>;
  /** averageBusinessRatingPosted_iendswith */
  averageBusinessRatingPosted_iendswith?: Maybe<Scalars['Float']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  /** isDefault_gte */
  isDefault_gte?: Maybe<Scalars['Boolean']>;
  /** isDefault_lte */
  isDefault_lte?: Maybe<Scalars['Boolean']>;
  /** isDefault_istartswith */
  isDefault_istartswith?: Maybe<Scalars['Boolean']>;
  /** isDefault_lt */
  isDefault_lt?: Maybe<Scalars['Boolean']>;
  /** isDefault_gt */
  isDefault_gt?: Maybe<Scalars['Boolean']>;
  /** isDefault_isnull */
  isDefault_isnull?: Maybe<Scalars['Boolean']>;
  /** isDefault_iendswith */
  isDefault_iendswith?: Maybe<Scalars['Boolean']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  sortOrder_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  alternativeName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  taskType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  totalNumberPostedTask_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  totalNumberBusinessesPosted_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  averageStudentRatingPosted_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  averageBusinessRatingPosted_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  isDefault_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

/**
 * The StintTaskInput class defines the Graphene ObjectType class used to set the related StintTask objects
 * on a StintTemplate or Stint.
 *
 * It provides the means to get or create StintTask data while creating or updating a StintTemplate or updating a
 * Stint.
 */
export type StintTaskInput = {
  /** The name of the StintTask. Used to create if no ID is provided. */
  name: Scalars['String'];
  /** The ID of the StintTask if it already exists. If null then a StintTask will be created. */
  id?: Maybe<Scalars['UUID']>;
};

export type StintTaskListType = {
  __typename?: 'StintTaskListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StintTask>>>;
};

export enum StintTaskTaskType {
  /** Stint Approved */
  STINT_APPROVED = 'STINT_APPROVED',
  /** Custom */
  CUSTOM = 'CUSTOM',
}

/** A StintTemplate (Role) represents a template of values used to later create Stint records from. */
export type StintTemplate = Node & {
  __typename?: 'StintTemplate';
  /** The ID of the object */
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  name: Scalars['String'];
  primaryTasks?: Maybe<Array<Maybe<StintTask>>>;
  secondaryTasks?: Maybe<Array<Maybe<StintTask>>>;
  exceptions?: Maybe<Array<Maybe<EmploymentException>>>;
  topTips?: Maybe<Array<Maybe<TopTip>>>;
  business?: Maybe<Business>;
  uniform?: Maybe<Array<Maybe<Scalars['String']>>>;
  notes?: Maybe<Scalars['String']>;
  /** Determines if the Stint is a trained Stint. */
  trained: Scalars['Boolean'];
  uniformReminderEnabled: Scalars['Boolean'];
  /** The YouTube URL of the business prep video at the Stint type level */
  prepVideoUrl?: Maybe<Scalars['String']>;
  /** The Youtube video ID (required by the mobile app) */
  prepVideoId?: Maybe<Scalars['String']>;
  /** Dictates whether Controlled Release is enable or disabled for the StintTemplate. */
  controlledRelease: Scalars['Boolean'];
  /** The day of the week that Stints posted from this StintTemplate are released when controlled_release is enabled. */
  releaseDay: WeekDay;
  /** Bonus rate amount. Rate paid to the Stinter if there is a bonus_rate for the StintTemplate. */
  bonusRate?: Maybe<Scalars['Decimal']>;
  /** The boost adjustment applied to the hourly rate for this StintTemplate. Returns None if no boost adjustment exists. */
  boostAdjustment?: Maybe<Scalars['Decimal']>;
  /**
   * Get a single StintTemplatePoolMember for this StintTemplate.
   * The StintTemplatePoolMember must be associated with this StintTemplate.
   *
   * Errors:
   * - UNAUTHORIZED: if the user is not a staff user.
   * - UNAUTHORIZED: if the user does not have READ_PARTNER_POOL permission.
   * - DOES_NOT_EXIST: if the pool member does not exist.
   * - DOES_NOT_EXIST: if the pool member is not associated with this template.
   */
  poolMember: StintTemplatePoolMember;
  /** A list of StintTemplatePoolMember records related to the current StintTemplateType. */
  poolMembers: StintTemplatePoolMemberTypeConnection;
  /** The ID of the StintTemplateGroup that this StintTemplate belongs to. */
  stintTemplateGroupId?: Maybe<Scalars['UUID']>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
};

/** A StintTemplate (Role) represents a template of values used to later create Stint records from. */
export type StintTemplatepoolMemberArgs = {
  id: Scalars['UUID'];
};

/** A StintTemplate (Role) represents a template of values used to later create Stint records from. */
export type StintTemplatepoolMembersArgs = {
  input: StintTemplatePoolMembersInput;
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/**
 * Enum that contains the available error message codes that can be used to raise errors
 *     related to the StintTemplate package.
 */
export enum StintTemplateError {
  INVALID_NAME = 'INVALID_NAME',
  CANNOT_SET_STINT_TEMPLATE_GROUP_IF_NOT_TRAINED = 'CANNOT_SET_STINT_TEMPLATE_GROUP_IF_NOT_TRAINED',
}

/**
 * The StintTemplateExceptionInput class defines the Graphene ObjectType class used to set the related
 * EmploymentException objects on a StintTemplate or a Stinter profile.
 *
 * It provides the means to get or create EmploymentException data while creating or updating a StintTemplate,
 * updating a Stint or setting the objects on a Stinter profile.
 *
 * This is deprecated.
 */
export type StintTemplateExceptionInput = {
  /** The name of the EmploymentException. */
  name?: Maybe<Scalars['String']>;
  /** The ID of the EmploymentException if it already exists. If left blank then an EmploymentException will be created. */
  id?: Maybe<Scalars['UUID']>;
};

export type StintTemplateFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** notes_search */
  notes_search?: Maybe<Scalars['String']>;
  /** notes_gte */
  notes_gte?: Maybe<Scalars['String']>;
  /** notes_lte */
  notes_lte?: Maybe<Scalars['String']>;
  /** notes_istartswith */
  notes_istartswith?: Maybe<Scalars['String']>;
  /** notes_lt */
  notes_lt?: Maybe<Scalars['String']>;
  /** notes_gt */
  notes_gt?: Maybe<Scalars['String']>;
  /** notes_isnull */
  notes_isnull?: Maybe<Scalars['Boolean']>;
  /** notes_iendswith */
  notes_iendswith?: Maybe<Scalars['String']>;
  trained?: Maybe<Scalars['Boolean']>;
  /** trained_gte */
  trained_gte?: Maybe<Scalars['Boolean']>;
  /** trained_lte */
  trained_lte?: Maybe<Scalars['Boolean']>;
  /** trained_istartswith */
  trained_istartswith?: Maybe<Scalars['Boolean']>;
  /** trained_lt */
  trained_lt?: Maybe<Scalars['Boolean']>;
  /** trained_gt */
  trained_gt?: Maybe<Scalars['Boolean']>;
  /** trained_isnull */
  trained_isnull?: Maybe<Scalars['Boolean']>;
  /** trained_iendswith */
  trained_iendswith?: Maybe<Scalars['Boolean']>;
  uniformReminderEnabled?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_gte */
  uniformReminderEnabled_gte?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_lte */
  uniformReminderEnabled_lte?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_istartswith */
  uniformReminderEnabled_istartswith?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_lt */
  uniformReminderEnabled_lt?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_gt */
  uniformReminderEnabled_gt?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_isnull */
  uniformReminderEnabled_isnull?: Maybe<Scalars['Boolean']>;
  /** uniformReminderEnabled_iendswith */
  uniformReminderEnabled_iendswith?: Maybe<Scalars['Boolean']>;
  prepVideoUrl?: Maybe<Scalars['String']>;
  /** prepVideoUrl_search */
  prepVideoUrl_search?: Maybe<Scalars['String']>;
  /** prepVideoUrl_gte */
  prepVideoUrl_gte?: Maybe<Scalars['String']>;
  /** prepVideoUrl_lte */
  prepVideoUrl_lte?: Maybe<Scalars['String']>;
  /** prepVideoUrl_istartswith */
  prepVideoUrl_istartswith?: Maybe<Scalars['String']>;
  /** prepVideoUrl_lt */
  prepVideoUrl_lt?: Maybe<Scalars['String']>;
  /** prepVideoUrl_gt */
  prepVideoUrl_gt?: Maybe<Scalars['String']>;
  /** prepVideoUrl_isnull */
  prepVideoUrl_isnull?: Maybe<Scalars['Boolean']>;
  /** prepVideoUrl_iendswith */
  prepVideoUrl_iendswith?: Maybe<Scalars['String']>;
  prepVideoId?: Maybe<Scalars['String']>;
  /** prepVideoId_search */
  prepVideoId_search?: Maybe<Scalars['String']>;
  /** prepVideoId_gte */
  prepVideoId_gte?: Maybe<Scalars['String']>;
  /** prepVideoId_lte */
  prepVideoId_lte?: Maybe<Scalars['String']>;
  /** prepVideoId_istartswith */
  prepVideoId_istartswith?: Maybe<Scalars['String']>;
  /** prepVideoId_lt */
  prepVideoId_lt?: Maybe<Scalars['String']>;
  /** prepVideoId_gt */
  prepVideoId_gt?: Maybe<Scalars['String']>;
  /** prepVideoId_isnull */
  prepVideoId_isnull?: Maybe<Scalars['Boolean']>;
  /** prepVideoId_iendswith */
  prepVideoId_iendswith?: Maybe<Scalars['String']>;
  controlledRelease?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_gte */
  controlledRelease_gte?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_lte */
  controlledRelease_lte?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_istartswith */
  controlledRelease_istartswith?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_lt */
  controlledRelease_lt?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_gt */
  controlledRelease_gt?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_isnull */
  controlledRelease_isnull?: Maybe<Scalars['Boolean']>;
  /** controlledRelease_iendswith */
  controlledRelease_iendswith?: Maybe<Scalars['Boolean']>;
  releaseDay?: Maybe<Scalars['String']>;
  /** releaseDay_search */
  releaseDay_search?: Maybe<Scalars['String']>;
  /** releaseDay_gte */
  releaseDay_gte?: Maybe<Scalars['String']>;
  /** releaseDay_lte */
  releaseDay_lte?: Maybe<Scalars['String']>;
  /** releaseDay_istartswith */
  releaseDay_istartswith?: Maybe<Scalars['String']>;
  /** releaseDay_lt */
  releaseDay_lt?: Maybe<Scalars['String']>;
  /** releaseDay_gt */
  releaseDay_gt?: Maybe<Scalars['String']>;
  /** releaseDay_isnull */
  releaseDay_isnull?: Maybe<Scalars['Boolean']>;
  /** releaseDay_iendswith */
  releaseDay_iendswith?: Maybe<Scalars['String']>;
  bonusRate?: Maybe<Scalars['Float']>;
  /** bonusRate_gte */
  bonusRate_gte?: Maybe<Scalars['Float']>;
  /** bonusRate_lte */
  bonusRate_lte?: Maybe<Scalars['Float']>;
  /** bonusRate_istartswith */
  bonusRate_istartswith?: Maybe<Scalars['Float']>;
  /** bonusRate_lt */
  bonusRate_lt?: Maybe<Scalars['Float']>;
  /** bonusRate_gt */
  bonusRate_gt?: Maybe<Scalars['Float']>;
  /** bonusRate_isnull */
  bonusRate_isnull?: Maybe<Scalars['Boolean']>;
  /** bonusRate_iendswith */
  bonusRate_iendswith?: Maybe<Scalars['Float']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use primaryTasks ids to filter StintTemplate by primaryTasks. */
  primaryTasks_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use secondaryTasks ids to filter StintTemplate by secondaryTasks. */
  secondaryTasks_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use exceptions ids to filter StintTemplate by exceptions. */
  exceptions_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use topTips ids to filter StintTemplate by topTips. */
  topTips_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  notes_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  trained_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  uniformReminderEnabled_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  prepVideoUrl_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  prepVideoId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  controlledRelease_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  releaseDay_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  bonusRate_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

/** A StintTemplateGroup represents a grouping of StintTemplate records (also known a role by the business and FE) for a given partner. */
export type StintTemplateGroup = Node & {
  __typename?: 'StintTemplateGroup';
  /** The ID of the StintTemplateGroup. */
  id: Scalars['UUID'];
  /** The display name that is given to the group. */
  name: Scalars['String'];
  /** The list of related StintTemplate objects included in the group. */
  stintTemplates: Array<StintTemplate>;
  /** The ID of the PartnerNode that the StintTemplateGroup belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The list of ID values for the related StintTemplate objects included in the group. */
  stintTemplateIds: Array<Scalars['UUID']>;
  /** The count of the related StintTemplate objects included in the group. */
  stintTemplateCount: Scalars['Int'];
};

/** The StintTemplatePool class defines the GraphQL type for the StintTemplatePool model. */
export type StintTemplatePool = {
  __typename?: 'StintTemplatePool';
  stintTemplate: StintTemplate;
};

/** The StintTemplatePoolMemberType class defines the GraphQL type for the StintTemplatePoolMember model. */
export type StintTemplatePoolMember = Node & {
  __typename?: 'StintTemplatePoolMember';
  /** The ID of the StintTemplatePoolMember. */
  id: Scalars['UUID'];
  /** The related StintTemplate that the Stinter is assigned to. */
  stintTemplate: StintTemplate;
  /** The StintTemplatePoolMember Stinter profile. */
  stinter: StinterProfile;
  /** Whether or not the StintTemplatePoolMember is active. This dictates whether or not to display the Stinter in the Pool. */
  active: Scalars['Boolean'];
  /** Whether or not the StintTemplatePoolMember is in their trial period. */
  trial: Scalars['Boolean'];
  /** Whether or not the StintTemplatePoolMember is a primary member of the related StintTemplate */
  primary: Scalars['Boolean'];
  /** The total number of stints the stinter (poolMember) has completed */
  completedStintsCount: Scalars['Int'];
  /** A list of PoolMemberFeedback records related to the current StintTemplatePoolMemberType. */
  feedback: PoolMemberFeedbackTypeConnection;
};

/** The StintTemplatePoolMemberType class defines the GraphQL type for the StintTemplatePoolMember model. */
export type StintTemplatePoolMemberfeedbackArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/**
 * The StintTemplatePoolMemberCommitmentType class defines the Graphene ObjectType class used to resolve the
 * StinterCommitment model data for GraphQL queries.
 */
export type StintTemplatePoolMemberCommitment = Node & {
  __typename?: 'StintTemplatePoolMemberCommitment';
  /** The ID of the StinterCommitment. */
  id: Scalars['UUID'];
  /** The number of Stints a Stinter is committing to complete per week. */
  stintsPerWeek: Scalars['Int'];
  /** The date that the Stinter's commitment will start. */
  startDate: Scalars['Date'];
  /** The date that the Stinter's commitment will end. */
  endDate: Scalars['Date'];
  /** The number of weeks that the Stinter provided for their commitment. */
  numberOfWeeks: Scalars['Int'];
  /** The StintTemplate associated with the StinterCommitment. */
  stintTemplate: StintTemplate;
  /** The count of StinterCommitment Stints a Stinter has accepted for next week. Null if the StinterCommitment ends/ended before next week */
  nextWeekAcceptedStintsCount?: Maybe<Scalars['Int']>;
};

/**
 * Enum that contains the available error message codes that can be used to raise errors related to
 *     StintTemplatePoolMember.
 */
export enum StintTemplatePoolMemberError {
  DUPLICATE_STINT_TEMPLATE_POOL_MEMBER = 'DUPLICATE_STINT_TEMPLATE_POOL_MEMBER',
  INVALID_PARTNER_NODE_ID = 'INVALID_PARTNER_NODE_ID',
  NO_REASONS_PROVIDED = 'NO_REASONS_PROVIDED',
  MORE_INFO_REQUIRED = 'MORE_INFO_REQUIRED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

/**
 * The StintTemplatePoolMemberFilterInput class defines the Graphene input values used to provide the requested
 * filter values from the client for a list of StintTemplatePoolMember objects.
 */
export type StintTemplatePoolMemberFilterInput = {
  /**
   * Limit results to only those that the name.
   * If omitted, then all results will be returned.
   */
  stinterName?: Maybe<Scalars['String']>;
  /**
   * Limit results based on the value of the `primary` field in the DB.
   * If omitted, all results will be returned.
   */
  primary?: Maybe<Scalars['Boolean']>;
  /**
   * If specified; when true will limit results to only trial members,
   * when false will limit results to only non-trial members.
   * If omitted, trial and non-trial members will be included.
   */
  trial?: Maybe<Scalars['Boolean']>;
};

export type StintTemplatePoolMemberTypeConnection = {
  __typename?: 'StintTemplatePoolMemberTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<StintTemplatePoolMemberTypeEdge>;
};

export type StintTemplatePoolMemberTypeEdge = {
  __typename?: 'StintTemplatePoolMemberTypeEdge';
  /** The item at the end of the edge */
  node: StintTemplatePoolMember;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * The StintTemplatePoolMembersInput class defines the input values that are required from the client for fetching
 * Pool members for a StintTemplate object.
 */
export type StintTemplatePoolMembersInput = {
  /**
   * Allow specifying the order of the results.
   * If not specified, the results will be ordered by name ascending.
   */
  orderBy?: Maybe<StintTemplatePoolMembersOrderInput>;
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filterBy?: Maybe<StintTemplatePoolMemberFilterInput>;
};

/** Enum dictating the fields that can be used to order the Pool members values. */
export enum StintTemplatePoolMembersOrderField {
  DAYS_LEFT = 'DAYS_LEFT',
  PRIMARY = 'PRIMARY',
}

/** Defines the input type for ordering and filtering StintTemplatePoolMember objects. */
export type StintTemplatePoolMembersOrderInput = {
  /** The field to order the StintTemplatePoolMember objects by. */
  field: StintTemplatePoolMembersOrderField;
  /** The requested order to be used when ordering the list of StintTemplatePoolMember objects. */
  order: SortOrder;
};

/** StintTemplateRate represents the rates related to a particular StintTemplate. */
export type StintTemplateRate = {
  __typename?: 'StintTemplateRate';
  /** The ID of the related StintTemplate. */
  stintTemplateId: Scalars['UUID'];
  /** The bonus rate to apply to the Stint. */
  bonusRate?: Maybe<Scalars['Decimal']>;
  /** The boost adjustment to apply to the Stint. */
  boostAdjustment?: Maybe<Scalars['Decimal']>;
};

export type StintTemplateStudents = {
  __typename?: 'StintTemplateStudents';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  /** Stint template used to create stints. */
  stintTemplate?: Maybe<StintTemplate>;
  /** Count of students needed for stints created out of related stint template. */
  studentsCount?: Maybe<Scalars['Int']>;
  /** Id of related StintTemplate (auto-generated). */
  stint_template_id?: Maybe<Scalars['UUID']>;
};

/**
 * The StintTemplateTaskInput class defines the Graphene ObjectType class used to set the related StintTask objects
 * on a StintTemplate.
 *
 * It provides the means to get or create StintTask data while creating or updating a StintTemplate or updating a
 * Stint.
 *
 * This is deprecated.
 */
export type StintTemplateTaskInput = {
  /** The name of the StintTask. */
  name?: Maybe<Scalars['String']>;
  /** The ID of the StintTask if it already exists. If left blank then a StintTask will be created. */
  id?: Maybe<Scalars['UUID']>;
};

/**
 * The StintTemplateTopTipInput class defines the Graphene ObjectType class used to set the related TopTip objects
 * on a StintTemplate.
 *
 * It provides the means to get or create TopTip data while creating or updating a StintTemplate or updating a Stint.
 *
 * This is deprecated.
 */
export type StintTemplateTopTipInput = {
  /** The name of the TopTip. */
  name: Scalars['String'];
  /** The ID of the TopTip if it already exists. If left blank then an TopTip will be created. */
  id?: Maybe<Scalars['UUID']>;
};

/**
 * The StintTemplateTrialPoolMemberFilterInput class defines the Graphene
 * input values used to provide the requested filter values from the client for a list
 * of trial StintTemplatePoolMember objects.
 */
export type StintTemplateTrialPoolMemberFilterInput = {
  /**
   * Limit results to only those that are in the provided stint_template.
   * If omitted, all results will be returned.
   */
  stintTemplateId?: Maybe<Scalars['UUID']>;
  /**
   * Limit results based on the value of the `primary` field in the DB.
   * If omitted, all results will be returned.
   */
  primary?: Maybe<Scalars['Boolean']>;
};

/**
 * The StintTemplateTrialPoolMembersInput class defines the input values that are required
 * from the client for fetching a list of trial StintTemplatePoolMember objects.
 */
export type StintTemplateTrialPoolMembersInput = {
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filterBy?: Maybe<StintTemplateTrialPoolMemberFilterInput>;
};

export type StintTemplateTypeConnection = {
  __typename?: 'StintTemplateTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<StintTemplateTypeEdge>;
};

export type StintTemplateTypeEdge = {
  __typename?: 'StintTemplateTypeEdge';
  /** The item at the end of the edge */
  node: StintTemplate;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** GraphQL list type representing a list of StintTemplateType objects. */
export type StintTemplateTypeListType = {
  __typename?: 'StintTemplateTypeListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StintTemplate>>>;
};

/** The input values available for filtering a list of StintTemplates (Roles). */
export type StintTemplatesFilterInput = {
  /**
   * Limit results to only those that fuzzy match the StintTemplate name.
   * If omitted, then all results will be returned.
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Limit results to only those that match the trained value.
   * If omitted, then all results will be returned.
   */
  trained?: Maybe<Scalars['Boolean']>;
};

/** This class defines the allowed field values that can be used to order a list of StintTemplate records. */
export enum StintTemplatesOrderField {
  NAME = 'NAME',
}

/** The input values available for ordering a list of StintTemplates (Roles). */
export type StintTemplatesOrderInput = {
  /** The field to order the list of StintTemplate records by. */
  field: StintTemplatesOrderField;
  /** The requested order to be used when ordering the list of StintTemplate records. */
  order: SortOrder;
};

/** Enum of uniform values for a StintTemplate or Stint. */
export enum StintUniform {
  WHITE_FORMAL_SHIRT = 'WHITE_FORMAL_SHIRT',
  BLACK_FORMAL_SHIRT = 'BLACK_FORMAL_SHIRT',
  BLACK_T_SHIRT = 'BLACK_T_SHIRT',
  WHITE_T_SHIRT = 'WHITE_T_SHIRT',
  BLACK_FORMAL_TROUSERS = 'BLACK_FORMAL_TROUSERS',
  BLACK_JEANS = 'BLACK_JEANS',
  DARK_TRAINERS = 'DARK_TRAINERS',
  BLACK_FORMAL_SHOES = 'BLACK_FORMAL_SHOES',
  BLACK_FORMAL_SOCKS = 'BLACK_FORMAL_SOCKS',
}

/** GraphQL type representing the StintUser model. */
export type StintUser = Node & {
  __typename?: 'StintUser';
  /** The ID of the StintUser. */
  id: Scalars['UUID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  /** User email address */
  email?: Maybe<Scalars['String']>;
  userType?: Maybe<StintUserUserType>;
  /** Set to true if user is staff member. */
  isStaff?: Maybe<Scalars['String']>;
  accountStatus: StintUserAccountStatus;
  isActive: Scalars['Boolean'];
  deactivated: Scalars['Boolean'];
  permanentDeactivated: Scalars['Boolean'];
  hasValidPassword: Scalars['Boolean'];
  isEmailVerified: Scalars['Boolean'];
  isVerifiedByStint: Scalars['Boolean'];
  verifiedByStintAt?: Maybe<Scalars['DateTime']>;
  isOnWaitingList: Scalars['Boolean'];
  hasSeenDashboard?: Maybe<Scalars['DateTime']>;
  /**
   * Mobile App Version of user.
   * @deprecated Drop in favor of DeviceInfo.appVersion
   */
  appVersion?: Maybe<Scalars['String']>;
  acceptedUserAgreementAt?: Maybe<Scalars['DateTime']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  fullname?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  gender?: Maybe<StintUserGender>;
  profilePhoto: Scalars['String'];
  profilePhotoFile?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  /** Determines if the user is allowed to see surged Stints. */
  canSeeSurge?: Maybe<Scalars['Boolean']>;
  /** Indicates if the student has ever added availability. */
  hasNeverAddedAvailability?: Maybe<Scalars['Boolean']>;
  city?: Maybe<City>;
  /** Current city of user or last user availability city or default city. */
  currentCity?: Maybe<City>;
  studentReviews: Array<StudentReview>;
  employerProfile?: Maybe<EmployerProfile>;
  notifications: Array<NotificationRecipient>;
  /** The associated Stints. */
  stints: StintNodeTypeConnection;
  /** The cancelled Stints of the user. */
  stintCancellations: StintNodeTypeConnection;
  /** The Stints created by the user. */
  stintCreatedByUser: StintNodeTypeConnection;
  studentProfile?: Maybe<StudentProfile>;
  availability: Array<StintUserAvailability>;
  stintOffersToStudent: Array<StintOffer>;
  businessSalesRep: Array<Business>;
  businessAccountManager: Array<Business>;
  userProfile?: Maybe<UserProfile>;
  /** Set to true if user is currently logged in user. */
  isMe?: Maybe<Scalars['Boolean']>;
  /** Set to true if user is a student. */
  isStudent?: Maybe<Scalars['Boolean']>;
  /** Set to true if user is an employer. */
  isEmployer?: Maybe<Scalars['Boolean']>;
  /** Profile photo URL of the user. */
  profilePhotoUrl?: Maybe<Scalars['ImageField']>;
  /**
   * Indicates if the app version can be forcefully updated
   * @deprecated Handled by LaunchDarkly Instead
   */
  canForceUpdate?: Maybe<Scalars['Boolean']>;
  /** Indicates if the user can see the dashboard */
  canSeeDashboard?: Maybe<Scalars['Boolean']>;
  /** The current location setting for the user's device. */
  locationSetting?: Maybe<LocationSettings>;
  /** Whether the user has notifications enabled */
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Used to retrieve the initial value for the city field on a student's availability form.
   * @deprecated Please use currentCity instead.
   */
  latestAvailabilityCity?: Maybe<City>;
  studentSavedPlaces?: Maybe<Array<Maybe<StudentSavedPlace>>>;
  /** Total amount earned by user for completed stints. */
  totalAmountEarned?: Maybe<Scalars['Float']>;
  /** User OTP */
  otp?: Maybe<Scalars['String']>;
  /** Current city of user. */
  userCurrentCity?: Maybe<City>;
  exceptions?: Maybe<Array<Maybe<EmploymentException>>>;
  /** Display value for field rating */
  publicRating: Scalars['String'];
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
  /** Id of related City (auto-generated). */
  current_city_id?: Maybe<Scalars['UUID']>;
};

/** GraphQL type representing the StintUser model. */
export type StintUserstintsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** GraphQL type representing the StintUser model. */
export type StintUserstintCancellationsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** GraphQL type representing the StintUser model. */
export type StintUserstintCreatedByUserArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum StintUserAccountStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Deleted */
  DELETED = 'DELETED',
  /** Suspended */
  SUSPENDED = 'SUSPENDED',
}

export type StintUserAvailability = {
  __typename?: 'StintUserAvailability';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  /** Should be required, but there is old data in prod with null cities. */
  city?: Maybe<City>;
  /** Saved places related to student availability. */
  studentSavedPlaces?: Maybe<Array<Maybe<StudentSavedPlace>>>;
  firebaseRef?: Maybe<Scalars['String']>;
  user: StintUser;
  address?: Maybe<Scalars['String']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  disabled: Scalars['Boolean'];
  repeat?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  inputType?: Maybe<StintUserAvailabilityInputType>;
  /** Id of related City (auto-generated). */
  city_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  user_id?: Maybe<Scalars['UUID']>;
};

export enum StintUserAvailabilityInputType {
  /** Created with best times console */
  CREATED_WITH_BEST_TIMES_CONSOLE = 'CREATED_WITH_BEST_TIMES_CONSOLE',
  /** Created with my availablity */
  CREATED_WITH_MY_AVAILABILITY = 'CREATED_WITH_MY_AVAILABILITY',
}

export type StintUserAvailabilityListType = {
  __typename?: 'StintUserAvailabilityListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StintUserAvailability>>>;
};

export type StintUserFilter = {
  q?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  allUserEmails?: Maybe<Scalars['String']>;
  /** user_fullname_search */
  user_fullname_search?: Maybe<Scalars['String']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  /** currentCity_id */
  currentCity_id?: Maybe<Scalars['UUID']>;
  /** currentCity_id_isnull */
  currentCity_id_isnull?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** lastLogin_gte */
  lastLogin_gte?: Maybe<Scalars['DateTime']>;
  /** lastLogin_lte */
  lastLogin_lte?: Maybe<Scalars['DateTime']>;
  /** lastLogin_istartswith */
  lastLogin_istartswith?: Maybe<Scalars['DateTime']>;
  /** lastLogin_lt */
  lastLogin_lt?: Maybe<Scalars['DateTime']>;
  /** lastLogin_gt */
  lastLogin_gt?: Maybe<Scalars['DateTime']>;
  /** lastLogin_isnull */
  lastLogin_isnull?: Maybe<Scalars['Boolean']>;
  /** lastLogin_iendswith */
  lastLogin_iendswith?: Maybe<Scalars['DateTime']>;
  isSuperuser?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_gte */
  isSuperuser_gte?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_lte */
  isSuperuser_lte?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_istartswith */
  isSuperuser_istartswith?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_lt */
  isSuperuser_lt?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_gt */
  isSuperuser_gt?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_isnull */
  isSuperuser_isnull?: Maybe<Scalars['Boolean']>;
  /** isSuperuser_iendswith */
  isSuperuser_iendswith?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  /** email_search */
  email_search?: Maybe<Scalars['String']>;
  /** email_gte */
  email_gte?: Maybe<Scalars['String']>;
  /** email_lte */
  email_lte?: Maybe<Scalars['String']>;
  /** email_istartswith */
  email_istartswith?: Maybe<Scalars['String']>;
  /** email_lt */
  email_lt?: Maybe<Scalars['String']>;
  /** email_gt */
  email_gt?: Maybe<Scalars['String']>;
  /** email_isnull */
  email_isnull?: Maybe<Scalars['Boolean']>;
  /** email_iendswith */
  email_iendswith?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  /** userType_search */
  userType_search?: Maybe<Scalars['String']>;
  /** userType_gte */
  userType_gte?: Maybe<Scalars['String']>;
  /** userType_lte */
  userType_lte?: Maybe<Scalars['String']>;
  /** userType_istartswith */
  userType_istartswith?: Maybe<Scalars['String']>;
  /** userType_lt */
  userType_lt?: Maybe<Scalars['String']>;
  /** userType_gt */
  userType_gt?: Maybe<Scalars['String']>;
  /** userType_isnull */
  userType_isnull?: Maybe<Scalars['Boolean']>;
  /** userType_iendswith */
  userType_iendswith?: Maybe<Scalars['String']>;
  isStaff?: Maybe<Scalars['Boolean']>;
  /** isStaff_gte */
  isStaff_gte?: Maybe<Scalars['Boolean']>;
  /** isStaff_lte */
  isStaff_lte?: Maybe<Scalars['Boolean']>;
  /** isStaff_istartswith */
  isStaff_istartswith?: Maybe<Scalars['Boolean']>;
  /** isStaff_lt */
  isStaff_lt?: Maybe<Scalars['Boolean']>;
  /** isStaff_gt */
  isStaff_gt?: Maybe<Scalars['Boolean']>;
  /** isStaff_isnull */
  isStaff_isnull?: Maybe<Scalars['Boolean']>;
  /** isStaff_iendswith */
  isStaff_iendswith?: Maybe<Scalars['Boolean']>;
  accountStatus?: Maybe<Scalars['String']>;
  /** accountStatus_search */
  accountStatus_search?: Maybe<Scalars['String']>;
  /** accountStatus_gte */
  accountStatus_gte?: Maybe<Scalars['String']>;
  /** accountStatus_lte */
  accountStatus_lte?: Maybe<Scalars['String']>;
  /** accountStatus_istartswith */
  accountStatus_istartswith?: Maybe<Scalars['String']>;
  /** accountStatus_lt */
  accountStatus_lt?: Maybe<Scalars['String']>;
  /** accountStatus_gt */
  accountStatus_gt?: Maybe<Scalars['String']>;
  /** accountStatus_isnull */
  accountStatus_isnull?: Maybe<Scalars['Boolean']>;
  /** accountStatus_iendswith */
  accountStatus_iendswith?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** isActive_gte */
  isActive_gte?: Maybe<Scalars['Boolean']>;
  /** isActive_lte */
  isActive_lte?: Maybe<Scalars['Boolean']>;
  /** isActive_istartswith */
  isActive_istartswith?: Maybe<Scalars['Boolean']>;
  /** isActive_lt */
  isActive_lt?: Maybe<Scalars['Boolean']>;
  /** isActive_gt */
  isActive_gt?: Maybe<Scalars['Boolean']>;
  /** isActive_isnull */
  isActive_isnull?: Maybe<Scalars['Boolean']>;
  /** isActive_iendswith */
  isActive_iendswith?: Maybe<Scalars['Boolean']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  /** deactivated_gte */
  deactivated_gte?: Maybe<Scalars['Boolean']>;
  /** deactivated_lte */
  deactivated_lte?: Maybe<Scalars['Boolean']>;
  /** deactivated_istartswith */
  deactivated_istartswith?: Maybe<Scalars['Boolean']>;
  /** deactivated_lt */
  deactivated_lt?: Maybe<Scalars['Boolean']>;
  /** deactivated_gt */
  deactivated_gt?: Maybe<Scalars['Boolean']>;
  /** deactivated_isnull */
  deactivated_isnull?: Maybe<Scalars['Boolean']>;
  /** deactivated_iendswith */
  deactivated_iendswith?: Maybe<Scalars['Boolean']>;
  permanentDeactivated?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_gte */
  permanentDeactivated_gte?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_lte */
  permanentDeactivated_lte?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_istartswith */
  permanentDeactivated_istartswith?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_lt */
  permanentDeactivated_lt?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_gt */
  permanentDeactivated_gt?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_isnull */
  permanentDeactivated_isnull?: Maybe<Scalars['Boolean']>;
  /** permanentDeactivated_iendswith */
  permanentDeactivated_iendswith?: Maybe<Scalars['Boolean']>;
  hasValidPassword?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_gte */
  hasValidPassword_gte?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_lte */
  hasValidPassword_lte?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_istartswith */
  hasValidPassword_istartswith?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_lt */
  hasValidPassword_lt?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_gt */
  hasValidPassword_gt?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_isnull */
  hasValidPassword_isnull?: Maybe<Scalars['Boolean']>;
  /** hasValidPassword_iendswith */
  hasValidPassword_iendswith?: Maybe<Scalars['Boolean']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_gte */
  isEmailVerified_gte?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_lte */
  isEmailVerified_lte?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_istartswith */
  isEmailVerified_istartswith?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_lt */
  isEmailVerified_lt?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_gt */
  isEmailVerified_gt?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_isnull */
  isEmailVerified_isnull?: Maybe<Scalars['Boolean']>;
  /** isEmailVerified_iendswith */
  isEmailVerified_iendswith?: Maybe<Scalars['Boolean']>;
  isVerifiedByStint?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_gte */
  isVerifiedByStint_gte?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_lte */
  isVerifiedByStint_lte?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_istartswith */
  isVerifiedByStint_istartswith?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_lt */
  isVerifiedByStint_lt?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_gt */
  isVerifiedByStint_gt?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_isnull */
  isVerifiedByStint_isnull?: Maybe<Scalars['Boolean']>;
  /** isVerifiedByStint_iendswith */
  isVerifiedByStint_iendswith?: Maybe<Scalars['Boolean']>;
  verifiedByStintAt?: Maybe<Scalars['DateTime']>;
  /** verifiedByStintAt_gte */
  verifiedByStintAt_gte?: Maybe<Scalars['DateTime']>;
  /** verifiedByStintAt_lte */
  verifiedByStintAt_lte?: Maybe<Scalars['DateTime']>;
  /** verifiedByStintAt_istartswith */
  verifiedByStintAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** verifiedByStintAt_lt */
  verifiedByStintAt_lt?: Maybe<Scalars['DateTime']>;
  /** verifiedByStintAt_gt */
  verifiedByStintAt_gt?: Maybe<Scalars['DateTime']>;
  /** verifiedByStintAt_isnull */
  verifiedByStintAt_isnull?: Maybe<Scalars['Boolean']>;
  /** verifiedByStintAt_iendswith */
  verifiedByStintAt_iendswith?: Maybe<Scalars['DateTime']>;
  isOnWaitingList?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_gte */
  isOnWaitingList_gte?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_lte */
  isOnWaitingList_lte?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_istartswith */
  isOnWaitingList_istartswith?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_lt */
  isOnWaitingList_lt?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_gt */
  isOnWaitingList_gt?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_isnull */
  isOnWaitingList_isnull?: Maybe<Scalars['Boolean']>;
  /** isOnWaitingList_iendswith */
  isOnWaitingList_iendswith?: Maybe<Scalars['Boolean']>;
  hasSeenDashboard?: Maybe<Scalars['DateTime']>;
  /** hasSeenDashboard_gte */
  hasSeenDashboard_gte?: Maybe<Scalars['DateTime']>;
  /** hasSeenDashboard_lte */
  hasSeenDashboard_lte?: Maybe<Scalars['DateTime']>;
  /** hasSeenDashboard_istartswith */
  hasSeenDashboard_istartswith?: Maybe<Scalars['DateTime']>;
  /** hasSeenDashboard_lt */
  hasSeenDashboard_lt?: Maybe<Scalars['DateTime']>;
  /** hasSeenDashboard_gt */
  hasSeenDashboard_gt?: Maybe<Scalars['DateTime']>;
  /** hasSeenDashboard_isnull */
  hasSeenDashboard_isnull?: Maybe<Scalars['Boolean']>;
  /** hasSeenDashboard_iendswith */
  hasSeenDashboard_iendswith?: Maybe<Scalars['DateTime']>;
  appVersion?: Maybe<Scalars['String']>;
  /** appVersion_search */
  appVersion_search?: Maybe<Scalars['String']>;
  /** appVersion_gte */
  appVersion_gte?: Maybe<Scalars['String']>;
  /** appVersion_lte */
  appVersion_lte?: Maybe<Scalars['String']>;
  /** appVersion_istartswith */
  appVersion_istartswith?: Maybe<Scalars['String']>;
  /** appVersion_lt */
  appVersion_lt?: Maybe<Scalars['String']>;
  /** appVersion_gt */
  appVersion_gt?: Maybe<Scalars['String']>;
  /** appVersion_isnull */
  appVersion_isnull?: Maybe<Scalars['Boolean']>;
  /** appVersion_iendswith */
  appVersion_iendswith?: Maybe<Scalars['String']>;
  acceptedUserAgreementAt?: Maybe<Scalars['DateTime']>;
  /** acceptedUserAgreementAt_gte */
  acceptedUserAgreementAt_gte?: Maybe<Scalars['DateTime']>;
  /** acceptedUserAgreementAt_lte */
  acceptedUserAgreementAt_lte?: Maybe<Scalars['DateTime']>;
  /** acceptedUserAgreementAt_istartswith */
  acceptedUserAgreementAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** acceptedUserAgreementAt_lt */
  acceptedUserAgreementAt_lt?: Maybe<Scalars['DateTime']>;
  /** acceptedUserAgreementAt_gt */
  acceptedUserAgreementAt_gt?: Maybe<Scalars['DateTime']>;
  /** acceptedUserAgreementAt_isnull */
  acceptedUserAgreementAt_isnull?: Maybe<Scalars['Boolean']>;
  /** acceptedUserAgreementAt_iendswith */
  acceptedUserAgreementAt_iendswith?: Maybe<Scalars['DateTime']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  /** secondaryEmail_search */
  secondaryEmail_search?: Maybe<Scalars['String']>;
  /** secondaryEmail_gte */
  secondaryEmail_gte?: Maybe<Scalars['String']>;
  /** secondaryEmail_lte */
  secondaryEmail_lte?: Maybe<Scalars['String']>;
  /** secondaryEmail_istartswith */
  secondaryEmail_istartswith?: Maybe<Scalars['String']>;
  /** secondaryEmail_lt */
  secondaryEmail_lt?: Maybe<Scalars['String']>;
  /** secondaryEmail_gt */
  secondaryEmail_gt?: Maybe<Scalars['String']>;
  /** secondaryEmail_isnull */
  secondaryEmail_isnull?: Maybe<Scalars['Boolean']>;
  /** secondaryEmail_iendswith */
  secondaryEmail_iendswith?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** title_search */
  title_search?: Maybe<Scalars['String']>;
  /** title_gte */
  title_gte?: Maybe<Scalars['String']>;
  /** title_lte */
  title_lte?: Maybe<Scalars['String']>;
  /** title_istartswith */
  title_istartswith?: Maybe<Scalars['String']>;
  /** title_lt */
  title_lt?: Maybe<Scalars['String']>;
  /** title_gt */
  title_gt?: Maybe<Scalars['String']>;
  /** title_isnull */
  title_isnull?: Maybe<Scalars['Boolean']>;
  /** title_iendswith */
  title_iendswith?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** firstName_search */
  firstName_search?: Maybe<Scalars['String']>;
  /** firstName_gte */
  firstName_gte?: Maybe<Scalars['String']>;
  /** firstName_lte */
  firstName_lte?: Maybe<Scalars['String']>;
  /** firstName_istartswith */
  firstName_istartswith?: Maybe<Scalars['String']>;
  /** firstName_lt */
  firstName_lt?: Maybe<Scalars['String']>;
  /** firstName_gt */
  firstName_gt?: Maybe<Scalars['String']>;
  /** firstName_isnull */
  firstName_isnull?: Maybe<Scalars['Boolean']>;
  /** firstName_iendswith */
  firstName_iendswith?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** lastName_search */
  lastName_search?: Maybe<Scalars['String']>;
  /** lastName_gte */
  lastName_gte?: Maybe<Scalars['String']>;
  /** lastName_lte */
  lastName_lte?: Maybe<Scalars['String']>;
  /** lastName_istartswith */
  lastName_istartswith?: Maybe<Scalars['String']>;
  /** lastName_lt */
  lastName_lt?: Maybe<Scalars['String']>;
  /** lastName_gt */
  lastName_gt?: Maybe<Scalars['String']>;
  /** lastName_isnull */
  lastName_isnull?: Maybe<Scalars['Boolean']>;
  /** lastName_iendswith */
  lastName_iendswith?: Maybe<Scalars['String']>;
  /** fullname_search */
  fullname_search?: Maybe<Scalars['String']>;
  /** fullname_gte */
  fullname_gte?: Maybe<Scalars['String']>;
  /** fullname_lte */
  fullname_lte?: Maybe<Scalars['String']>;
  /** fullname_istartswith */
  fullname_istartswith?: Maybe<Scalars['String']>;
  /** fullname_lt */
  fullname_lt?: Maybe<Scalars['String']>;
  /** fullname_gt */
  fullname_gt?: Maybe<Scalars['String']>;
  /** fullname_isnull */
  fullname_isnull?: Maybe<Scalars['Boolean']>;
  /** fullname_iendswith */
  fullname_iendswith?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  /** phoneNumber_search */
  phoneNumber_search?: Maybe<Scalars['String']>;
  /** phoneNumber_gte */
  phoneNumber_gte?: Maybe<Scalars['String']>;
  /** phoneNumber_lte */
  phoneNumber_lte?: Maybe<Scalars['String']>;
  /** phoneNumber_istartswith */
  phoneNumber_istartswith?: Maybe<Scalars['String']>;
  /** phoneNumber_lt */
  phoneNumber_lt?: Maybe<Scalars['String']>;
  /** phoneNumber_gt */
  phoneNumber_gt?: Maybe<Scalars['String']>;
  /** phoneNumber_isnull */
  phoneNumber_isnull?: Maybe<Scalars['Boolean']>;
  /** phoneNumber_iendswith */
  phoneNumber_iendswith?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** dateOfBirth_gte */
  dateOfBirth_gte?: Maybe<Scalars['Date']>;
  /** dateOfBirth_lte */
  dateOfBirth_lte?: Maybe<Scalars['Date']>;
  /** dateOfBirth_istartswith */
  dateOfBirth_istartswith?: Maybe<Scalars['Date']>;
  /** dateOfBirth_lt */
  dateOfBirth_lt?: Maybe<Scalars['Date']>;
  /** dateOfBirth_gt */
  dateOfBirth_gt?: Maybe<Scalars['Date']>;
  /** dateOfBirth_isnull */
  dateOfBirth_isnull?: Maybe<Scalars['Boolean']>;
  /** dateOfBirth_iendswith */
  dateOfBirth_iendswith?: Maybe<Scalars['Date']>;
  gender?: Maybe<Scalars['String']>;
  /** gender_search */
  gender_search?: Maybe<Scalars['String']>;
  /** gender_gte */
  gender_gte?: Maybe<Scalars['String']>;
  /** gender_lte */
  gender_lte?: Maybe<Scalars['String']>;
  /** gender_istartswith */
  gender_istartswith?: Maybe<Scalars['String']>;
  /** gender_lt */
  gender_lt?: Maybe<Scalars['String']>;
  /** gender_gt */
  gender_gt?: Maybe<Scalars['String']>;
  /** gender_isnull */
  gender_isnull?: Maybe<Scalars['Boolean']>;
  /** gender_iendswith */
  gender_iendswith?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<Scalars['String']>;
  /** profilePhoto_search */
  profilePhoto_search?: Maybe<Scalars['String']>;
  /** profilePhoto_gte */
  profilePhoto_gte?: Maybe<Scalars['String']>;
  /** profilePhoto_lte */
  profilePhoto_lte?: Maybe<Scalars['String']>;
  /** profilePhoto_istartswith */
  profilePhoto_istartswith?: Maybe<Scalars['String']>;
  /** profilePhoto_lt */
  profilePhoto_lt?: Maybe<Scalars['String']>;
  /** profilePhoto_gt */
  profilePhoto_gt?: Maybe<Scalars['String']>;
  /** profilePhoto_isnull */
  profilePhoto_isnull?: Maybe<Scalars['Boolean']>;
  /** profilePhoto_iendswith */
  profilePhoto_iendswith?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  /** rating_gte */
  rating_gte?: Maybe<Scalars['Float']>;
  /** rating_lte */
  rating_lte?: Maybe<Scalars['Float']>;
  /** rating_istartswith */
  rating_istartswith?: Maybe<Scalars['Float']>;
  /** rating_lt */
  rating_lt?: Maybe<Scalars['Float']>;
  /** rating_gt */
  rating_gt?: Maybe<Scalars['Float']>;
  /** rating_isnull */
  rating_isnull?: Maybe<Scalars['Boolean']>;
  /** rating_iendswith */
  rating_iendswith?: Maybe<Scalars['Float']>;
  canSeeSurge?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_gte */
  canSeeSurge_gte?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_lte */
  canSeeSurge_lte?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_istartswith */
  canSeeSurge_istartswith?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_lt */
  canSeeSurge_lt?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_gt */
  canSeeSurge_gt?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_isnull */
  canSeeSurge_isnull?: Maybe<Scalars['Boolean']>;
  /** canSeeSurge_iendswith */
  canSeeSurge_iendswith?: Maybe<Scalars['Boolean']>;
  hasNeverAddedAvailability?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_gte */
  hasNeverAddedAvailability_gte?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_lte */
  hasNeverAddedAvailability_lte?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_istartswith */
  hasNeverAddedAvailability_istartswith?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_lt */
  hasNeverAddedAvailability_lt?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_gt */
  hasNeverAddedAvailability_gt?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_isnull */
  hasNeverAddedAvailability_isnull?: Maybe<Scalars['Boolean']>;
  /** hasNeverAddedAvailability_iendswith */
  hasNeverAddedAvailability_iendswith?: Maybe<Scalars['Boolean']>;
  firebaseRef?: Maybe<Scalars['String']>;
  /** firebaseRef_search */
  firebaseRef_search?: Maybe<Scalars['String']>;
  /** firebaseRef_gte */
  firebaseRef_gte?: Maybe<Scalars['String']>;
  /** firebaseRef_lte */
  firebaseRef_lte?: Maybe<Scalars['String']>;
  /** firebaseRef_istartswith */
  firebaseRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseRef_lt */
  firebaseRef_lt?: Maybe<Scalars['String']>;
  /** firebaseRef_gt */
  firebaseRef_gt?: Maybe<Scalars['String']>;
  /** firebaseRef_isnull */
  firebaseRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseRef_iendswith */
  firebaseRef_iendswith?: Maybe<Scalars['String']>;
  firebaseUserRef?: Maybe<Scalars['String']>;
  /** firebaseUserRef_search */
  firebaseUserRef_search?: Maybe<Scalars['String']>;
  /** firebaseUserRef_gte */
  firebaseUserRef_gte?: Maybe<Scalars['String']>;
  /** firebaseUserRef_lte */
  firebaseUserRef_lte?: Maybe<Scalars['String']>;
  /** firebaseUserRef_istartswith */
  firebaseUserRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseUserRef_lt */
  firebaseUserRef_lt?: Maybe<Scalars['String']>;
  /** firebaseUserRef_gt */
  firebaseUserRef_gt?: Maybe<Scalars['String']>;
  /** firebaseUserRef_isnull */
  firebaseUserRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseUserRef_iendswith */
  firebaseUserRef_iendswith?: Maybe<Scalars['String']>;
  firebaseSelectedBusinessRef?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_search */
  firebaseSelectedBusinessRef_search?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_gte */
  firebaseSelectedBusinessRef_gte?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_lte */
  firebaseSelectedBusinessRef_lte?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_istartswith */
  firebaseSelectedBusinessRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_lt */
  firebaseSelectedBusinessRef_lt?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_gt */
  firebaseSelectedBusinessRef_gt?: Maybe<Scalars['String']>;
  /** firebaseSelectedBusinessRef_isnull */
  firebaseSelectedBusinessRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseSelectedBusinessRef_iendswith */
  firebaseSelectedBusinessRef_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use groups ids to filter StintUser by groups. */
  groups_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use userPermissions ids to filter StintUser by userPermissions. */
  userPermissions_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use studentReviews ids to filter StintUser by studentReviews. */
  studentReviews_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use studentEndorsements ids to filter StintUser by studentEndorsements. */
  studentEndorsements_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  lastLogin_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  isSuperuser_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  email_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  userType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isStaff_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  accountStatus_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isActive_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  deactivated_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  permanentDeactivated_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  hasValidPassword_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  isEmailVerified_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  isVerifiedByStint_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  verifiedByStintAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  isOnWaitingList_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  hasSeenDashboard_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  appVersion_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  acceptedUserAgreementAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  secondaryEmail_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  title_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firstName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  lastName_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  fullname_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  phoneNumber_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  dateOfBirth_in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  /** Multiple values may be separated by commas. */
  gender_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  profilePhoto_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  rating_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  canSeeSurge_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  hasNeverAddedAvailability_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  firebaseRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firebaseUserRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firebaseSelectedBusinessRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum StintUserGender {
  /** Female */
  FEMALE = 'FEMALE',
  /** Male */
  MALE = 'MALE',
  /** Transgender */
  TRANSGENDER = 'TRANSGENDER',
  /** Non-binary/non-conforming */
  NON_BINARY = 'NON_BINARY',
  /** Prefer not to respond */
  PREFER_NOT_RESPOND = 'PREFER_NOT_RESPOND',
  /** Other */
  OTHER = 'OTHER',
}

export type StintUserTypeConnection = {
  __typename?: 'StintUserTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<StintUserTypeEdge>;
};

export type StintUserTypeEdge = {
  __typename?: 'StintUserTypeEdge';
  /** The item at the end of the edge */
  node: StintUser;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export enum StintUserUserType {
  /** Student */
  STUDENT = 'STUDENT',
  /** Employer */
  EMPLOYER = 'EMPLOYER',
  /** Stint Owner */
  OWNER = 'OWNER',
  /** Stint Admin */
  ADMIN = 'ADMIN',
  /** Stint Staff */
  STAFF = 'STAFF',
  /** Stint Superadmin */
  SUPERADMIN = 'SUPERADMIN',
}

export type StintWeekTemplate = {
  __typename?: 'StintWeekTemplate';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  days?: Maybe<Array<Maybe<StintSessionTemplate>>>;
  /** The business of this StintWeekTemplate. */
  business?: Maybe<Business>;
  address?: Maybe<Address>;
  /** The timezone of this StintWeekTemplate */
  timezone?: Maybe<Scalars['String']>;
  automaticPosting: Scalars['Boolean'];
  automaticPostingLastUpdatedBy?: Maybe<StintUser>;
  /** Whether this Week Template is default or not.This information is used to perform scheduling and Stint auto posting. */
  isDefault: Scalars['Boolean'];
  /** The place id of address. */
  placeId?: Maybe<Scalars['String']>;
  /** The display name of address. */
  displayAddress?: Maybe<Scalars['String']>;
  /** The Stints created off the StintWeekTemplate. */
  stints?: Maybe<Array<Maybe<Stint>>>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
  /** Id of related Address (auto-generated). */
  address_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  automatic_posting_last_updated_by_id?: Maybe<Scalars['UUID']>;
};

/**
 * Enum that contains the available error message codes that can be used to raise
 *     errors related to StintWeekTemplate.
 */
export enum StintWeekTemplateError {
  INVALID_START_TIME = 'INVALID_START_TIME',
  INVALID_END_TIME = 'INVALID_END_TIME',
  INVALID_SESSION_MIN_LENGTH = 'INVALID_SESSION_MIN_LENGTH',
  INVALID_SESSION_MAX_LENGTH = 'INVALID_SESSION_MAX_LENGTH',
}

export type StintWeekTemplateFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  /** address_id */
  address_id?: Maybe<Scalars['UUID']>;
  /** address_id_isnull */
  address_id_isnull?: Maybe<Scalars['Boolean']>;
  /** automaticPostingLastUpdatedBy_id */
  automaticPostingLastUpdatedBy_id?: Maybe<Scalars['UUID']>;
  /** automaticPostingLastUpdatedBy_id_isnull */
  automaticPostingLastUpdatedBy_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
  /** visible_gte */
  visible_gte?: Maybe<Scalars['Boolean']>;
  /** visible_lte */
  visible_lte?: Maybe<Scalars['Boolean']>;
  /** visible_istartswith */
  visible_istartswith?: Maybe<Scalars['Boolean']>;
  /** visible_lt */
  visible_lt?: Maybe<Scalars['Boolean']>;
  /** visible_gt */
  visible_gt?: Maybe<Scalars['Boolean']>;
  /** visible_isnull */
  visible_isnull?: Maybe<Scalars['Boolean']>;
  /** visible_iendswith */
  visible_iendswith?: Maybe<Scalars['Boolean']>;
  automaticPosting?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_gte */
  automaticPosting_gte?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_lte */
  automaticPosting_lte?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_istartswith */
  automaticPosting_istartswith?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_lt */
  automaticPosting_lt?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_gt */
  automaticPosting_gt?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_isnull */
  automaticPosting_isnull?: Maybe<Scalars['Boolean']>;
  /** automaticPosting_iendswith */
  automaticPosting_iendswith?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  /** isDefault_gte */
  isDefault_gte?: Maybe<Scalars['Boolean']>;
  /** isDefault_lte */
  isDefault_lte?: Maybe<Scalars['Boolean']>;
  /** isDefault_istartswith */
  isDefault_istartswith?: Maybe<Scalars['Boolean']>;
  /** isDefault_lt */
  isDefault_lt?: Maybe<Scalars['Boolean']>;
  /** isDefault_gt */
  isDefault_gt?: Maybe<Scalars['Boolean']>;
  /** isDefault_isnull */
  isDefault_isnull?: Maybe<Scalars['Boolean']>;
  /** isDefault_iendswith */
  isDefault_iendswith?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Float']>;
  /** version_gte */
  version_gte?: Maybe<Scalars['Float']>;
  /** version_lte */
  version_lte?: Maybe<Scalars['Float']>;
  /** version_istartswith */
  version_istartswith?: Maybe<Scalars['Float']>;
  /** version_lt */
  version_lt?: Maybe<Scalars['Float']>;
  /** version_gt */
  version_gt?: Maybe<Scalars['Float']>;
  /** version_isnull */
  version_isnull?: Maybe<Scalars['Boolean']>;
  /** version_iendswith */
  version_iendswith?: Maybe<Scalars['Float']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use days ids to filter StintWeekTemplate by days. */
  days_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  visible_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  automaticPosting_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  isDefault_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  version_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type StintWeekTemplateListType = {
  __typename?: 'StintWeekTemplateListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StintWeekTemplate>>>;
};

export type StintWeekTemplateSessionInput = {
  /** Start time. */
  startTime?: Maybe<Scalars['Time']>;
  /** End time. */
  endTime?: Maybe<Scalars['Time']>;
  /** Stint session day. */
  day: StintSessionDay;
  /** Should session be active or not. */
  isActive: Scalars['Boolean'];
  /** List of stint templates with counts of students needed. */
  stintTemplates?: Maybe<Array<Maybe<StintWeekTemplateStintTypeInput>>>;
};

export type StintWeekTemplateStintTypeInput = {
  /** Students count for given stint template. */
  studentsCount: Scalars['Int'];
  /** Stint template Id. */
  stintTemplateId: Scalars['UUID'];
};

/**
 * The StinterType class is used to expose the fields required for a Stinter from the StintUser and StudentProfile
 * models. These fields have been flattened to a single level.
 */
export type Stinter = {
  __typename?: 'Stinter';
  /** The ID (Ref) of the StintUser object. */
  id: Scalars['UUID'];
  /** Whether or not the Stinter has been deactivated. */
  deactivated: Scalars['Boolean'];
  /** Whether or not the Stinter has been verified by Stint. */
  isVerifiedByStint: Scalars['Boolean'];
  /** The first name of the Stinter. */
  firstName: Scalars['String'];
  /** The last name of the Stinter. */
  lastName: Scalars['String'];
  /** The phone number of the Stinter. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The Date of Birth of the Stinter. */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** The email of the Stinter. */
  email: Scalars['String'];
  /** Whether or not the Stinter has ever added availability. */
  hasNeverAddedAvailability: Scalars['Boolean'];
  /** Whether the Stinter has notifications enabled */
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  /** Profile photo URL of the Stinter. */
  profilePhotoUrl?: Maybe<Scalars['ImageField']>;
  /** The current location setting for the Stinter's device. */
  locationSetting?: Maybe<LocationSettings>;
  /** The public rating of the Stinter. */
  publicRating: Scalars['String'];
  /** The total amount earned by the Stinter. */
  totalAmountEarned: Scalars['Float'];
  /** The Stinter's current city. */
  userCurrentCity?: Maybe<City>;
  /** The date the Stinter was created. */
  createdAt: Scalars['DateTime'];
  /** The ID (ref) of the StudentProfile object. */
  profileId: Scalars['UUID'];
  /** The Gender of the Stinter. */
  gender?: Maybe<StudentProfileGender>;
  /** The EmployeeStatement of the Stinter. Statement A, B or C. */
  employeeStatement?: Maybe<EmployeeStatement>;
  /** Whether or not the student has given consent to marketing (during registration). */
  marketingConsentAccepted?: Maybe<Scalars['Boolean']>;
  /** The Student Loan plan value. */
  studentLoanPlan: StudentProfileStudentLoanPlan;
  /** The primary payment method for the Stinter. */
  primaryPaymentMethod?: Maybe<DirectDebitPaymentMethod>;
  /** The Stinter's Addresses. */
  addresses: Array<Address>;
  /** The total number of Stints completed by a Stinter. */
  stintCount: Scalars['Int'];
  /** The National Insurance Number of the Stinter. */
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  /** The name of the Stinter's emergency contact. */
  emergencyContactName?: Maybe<Scalars['String']>;
  /** The phone number of the Stinter's emergency contact. */
  emergencyContactNumber?: Maybe<Scalars['String']>;
  /** The relation of the Stinter to their emergency contact. */
  emergencyContactRelation?: Maybe<Scalars['String']>;
  /** The Stinter's EmploymentExceptions. */
  employmentExceptions: Array<EmploymentException>;
  /** The MarketingChannel where the Stinter discovered the app. */
  marketingChannel?: Maybe<MarketingChannel>;
  /** The number of strikes a Stinter has received. */
  strikesAwarded: Scalars['Int'];
  /** Whether or not the Stinter is trained for any Stint Roles. */
  trained: Scalars['Boolean'];
  /** Information on whether or not the Stinter has any PartnerPool invites and a paginated list of their invites. */
  partnerPoolData: StinterPartnerPoolData;
  /** The assessment information on the video that the Stinter submitted to be assessed for Stint teams if it exists. */
  videoAssessmentInfo?: Maybe<VideoAssessmentInfo>;
  /** Resolves all past & future commitments for this Stinter. */
  commitments: Array<StinterCommitment>;
  /** The Stinter's Right to Work information. */
  rightToWork: RTW;
  /** A list of all out-of-term requests made by or on behalf of this Stinter. */
  outOfTermRequests: Array<OutOfTermRequest>;
  /** The Stinter's average rating. */
  rating?: Maybe<Scalars['Float']>;
  /** The list of partner account IDs this Stinter has been excluded from. */
  partnerExclusions: Array<Scalars['UUID']>;
};

/**
 * The StinterType class is used to expose the fields required for a Stinter from the StintUser and StudentProfile
 * models. These fields have been flattened to a single level.
 */
export type StintercommitmentsArgs = {
  input?: Maybe<StinterCommitmentsInput>;
};

/** Represents a Stinter's commitment across multiple roles. */
export type StinterCommitment = Node & {
  __typename?: 'StinterCommitment';
  /** The ID of the StinterCommitment. */
  id: Scalars['UUID'];
  /** The number of Stints a Stinter is committing to complete per week. */
  stintsPerWeek: Scalars['Int'];
  /** The date that the Stinter's commitment will start. */
  startDate: Scalars['Date'];
  /** The date that the Stinter's commitment will end. */
  endDate: Scalars['Date'];
  /** The number of weeks that the Stinter provided for their commitment. */
  numberOfWeeks: Scalars['Int'];
  /** The StintTemplatePoolMember objects associated with this StinterCommitment. */
  poolMemberships: Array<StintTemplatePoolMember>;
  /** The breakdown of weeks (Monday - Sunday) of this commitment. */
  weeks: Array<CommitmentWeek>;
};

/** Represents a Stinter's commitment across multiple roles. */
export type StinterCommitmentweeksArgs = {
  input: CommitmentWeeksInput;
};

/**
 * Enum that contains the available error message codes that can be used to raise errors related to
 *     StinterCommitment.
 */
export enum StinterCommitmentError {
  INACTIVE_STINT_TEMPLATE_POOL_MEMBER = 'INACTIVE_STINT_TEMPLATE_POOL_MEMBER',
  INVALID_NUMBER_OF_WEEKS = 'INVALID_NUMBER_OF_WEEKS',
  INVALID_START_DATE_WEEKDAY = 'INVALID_START_DATE_WEEKDAY',
  INVALID_STINTS_PER_WEEK = 'INVALID_STINTS_PER_WEEK',
  INVALID_STINT_TEMPLATE = 'INVALID_STINT_TEMPLATE',
  OVERLAPPING_COMMITMENT = 'OVERLAPPING_COMMITMENT',
  COMMITMENT_ALREADY_ENDED = 'COMMITMENT_ALREADY_ENDED',
  DUPLICATE_STINT_TEMPLATE_REFS = 'DUPLICATE_STINT_TEMPLATE_REFS',
}

/** Values used to filter the StinterCommitment to show to the user. */
export type StinterCommitmentsInput = {
  /**
   * Limit StinterCommitments to only those that are active after (and including) the specified date.
   * If omitted, then all results up until dateTo will be included.
   */
  dateFrom?: Maybe<Scalars['Date']>;
  /**
   * Limit StinterCommitments to only those that are active before (and including) the specified date.
   * If omitted, then all results up until dateFrom will be included.
   */
  dateTo?: Maybe<Scalars['Date']>;
};

/** A StinterCompetencyTask represents a task of values which are used on client side */
export type StinterCompetencyTask = {
  __typename?: 'StinterCompetencyTask';
  /** The ID of the task. */
  id: Scalars['UUID'];
  /** The name of the task. */
  name: Scalars['String'];
  /** If the stinter has been passed at the task. */
  passed: Scalars['Boolean'];
};

/** StinterExperience represents the assigned Stinter's experience information for the Stint. */
export type StinterExperience = {
  __typename?: 'StinterExperience';
  /** The experience level the assigned Stinter has for the Pool related to the Stint. */
  experienceLevel: StinterExperienceLevel;
  /** The number of Stints the assigned Stinter has completed at all StintTemplates within the PartnerAccount. */
  completedStintCountWithinPartnerAccount?: Maybe<Scalars['Int']>;
  /** The number of Stints the assigned Stinter has completed at all StintTemplates within the same StintTemplateGroup that this Stint was posted from. If StintTemplate that this Stint was posted from has not been assigned to a StintTemplateGroup, the count of the Stints completed at this StintTemplate will be returned. */
  completedStintCountWithinStintTemplateGroup?: Maybe<Scalars['Int']>;
  /** The names of the Sites within the same StintTemplateGroup where the Stinter is currently in a Pool. */
  siteNamesWhereStinterInPool: Array<Scalars['String']>;
  /** The tasks the Stinter must complete to be considered fully competent at the Stint. */
  tasks: Array<StinterCompetencyTask>;
};

/** The experience level that the assigned Stinter has for a Stint's related Pool. */
export enum StinterExperienceLevel {
  /** The Stinter is a trial member of the Pool that the Stint belongs to. */
  POOL_TRIAL = 'POOL_TRIAL',
  /** The Stinter is a full time member of the Pool that the Stint belongs to. */
  POOL_MEMBER = 'POOL_MEMBER',
  /** The Stinter is a member of other Pools which are in the same StintTemplateGroup as the Stint's StintTemplate. */
  OTHER_POOL_EXPERIENCE = 'OTHER_POOL_EXPERIENCE',
  /** The experience level that the assigned Stinter has for a Stint's related Pool. */
  PARTNER_EXPERIENCE = 'PARTNER_EXPERIENCE',
  /** The Stinter is not a member of any relevant Pools but does have experience at other Sites for the same Partner. */
  NO_PARTNER_EXPERIENCE = 'NO_PARTNER_EXPERIENCE',
}

/**
 * The StinterOffenceType class defines the Graphene ObjectType class used to resolve the Offence
 * model data for GraphQL queries. It inherits base fields and resolvers from the BaseOffenceType class.
 *
 * Only the fields that should be accessible by a Stinter are included in the Meta.fields attribute.
 *
 * It has a UUIDNode interface so that list queries can use relay pagination.
 */
export type StinterOffence = Node & {
  __typename?: 'StinterOffence';
  /** The ID of the Offence. */
  id: Scalars['UUID'];
  /** The datetime value that is automatically captured when a new record is added to the database. */
  createdAt: Scalars['DateTime'];
  /** The OffenceReason value that indicates the reason for the Offence. The reason value can include legacy OffenceReason values that cannot be used when creating a new Offence object. */
  reason: OffenceReason;
  /** The number of strikes that the Offence adds to or the redemption removes from the Stinter profile. */
  strikesAwarded: Scalars['Int'];
  /** The related Stint object. */
  stint?: Maybe<Stint>;
  /** The OffenceAppealStatus value that indicates the current appeal status for the Offence. */
  appealStatus: OffenceAppealStatus;
  /** The related Business object. */
  business?: Maybe<Business>;
  /** Whether or not the Offence is a redemption. */
  isRedemption: Scalars['Boolean'];
};

export type StinterOffenceTypeConnection = {
  __typename?: 'StinterOffenceTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<StinterOffenceTypeEdge>;
};

export type StinterOffenceTypeEdge = {
  __typename?: 'StinterOffenceTypeEdge';
  /** The item at the end of the edge */
  node: StinterOffence;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/**
 * The StinterPartnerPoolDataType class is used to expose the list of PartnerPool records that a Stinter has a
 * PartnerPoolInvite for and information on whether or not there are invites.
 */
export type StinterPartnerPoolData = {
  __typename?: 'StinterPartnerPoolData';
  /** Whether or not the Stinter has any invites for any PartnerPool objects. */
  hasPartnerPoolInvites: Scalars['Boolean'];
  /** Whether or not the Stinter has any new invites for any PartnerPool objects. */
  hasNewPartnerPoolInvites: Scalars['Boolean'];
  partnerPools: Array<PartnerPool>;
  /**
   * A list of StinterCommitments that will be ongoing next week.
   * @deprecated Deprecated in favor of new Commitments design
   */
  nextWeekCommitments: Array<StintTemplatePoolMemberCommitment>;
  /** A list of StintTemplatePool objects where the Stinter is a member. */
  stintTemplatePools: Array<StintTemplatePool>;
  /** Whether or not the Stinter is member of any Pools with a bonus rate set. */
  hasPoolWithBonus: Scalars['Boolean'];
  /** Non-null when the Stinter has a failed trial they have not yet acknowledged. Null otherwise. */
  failedTrialPoolData?: Maybe<FailedTrialPoolData>;
};

/** The StinterPay type represents the rates and pay that a Stinter is eligible to earn when working a Stint. */
export type StinterPay = {
  __typename?: 'StinterPay';
  /**
   * The legacy hourly rate of the Stint, applicable to the Stinter that is viewing it. This rate will be adjusted to account for surge prices, but it wont be reflective of any bonus rates set at a pool level.
   * @deprecated It includes the surge rate, which is legacy behavior. Use base_rate_v2 instead.
   */
  baseRate?: Maybe<Scalars['Decimal']>;
  /** The hourly rate of the Stint before adjustment, applicable to the Stinter that is viewing it. */
  baseRateV2: Scalars['Decimal'];
  /** The total base pay for the Stint, applicable to the Stinter that is viewing it. This rate will be adjusted to account for surge prices, but it wont be reflective of any bonus rates set at a pool level. */
  basePay?: Maybe<Scalars['Decimal']>;
  /** The bonus hourly rate that a Stinter will receive for this Stint if a bonus is applied. */
  bonusRate?: Maybe<Scalars['Decimal']>;
  /** Provides the Boost adjustment applied to the hourly rate as part of the totalRate paid to the Stinter. It returns 0 if there is no Boost adjustment for this Stint. */
  boostAdjustment: Scalars['Decimal'];
  /** The total bonus pay that a Stinter will receive for this Stint if a bonus is applied. */
  bonusPay?: Maybe<Scalars['Decimal']>;
  /** Provides the Surge adjustment applied to the hourly rate as part of the totalRate that the Stinter receives. It returns 0 if there is no Surge adjustment for this Stint. */
  surgeAdjustment: Scalars['Decimal'];
  /** Provides the hourly rate the Stinter will receive, inclusive of any applicable adjustments such as Surge or Boost adjustments. */
  totalRate: Scalars['Decimal'];
  /** Calculates the Stinter’s final pay as totalRate * duration, reflecting the total compensation for the Stint. This amount will automatically update if the Stint's start and end times are modified. */
  totalPay: Scalars['Decimal'];
  /** The total base pay for the Stint calculated as the base rate multiplied by the duration worked, before any surge or boost adjustments are applied. */
  totalBasePay?: Maybe<Scalars['Decimal']>;
};

/**
 * The StinterProfileType class is used to expose the fields required by a Stinter from the StudentProfile and
 * StintUser models. These fields have been flattened to a single level.
 */
export type StinterProfile = {
  __typename?: 'StinterProfile';
  /** The ID (ref) of the StudentProfile object. */
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  /** The Gender of the Stinter. */
  gender?: Maybe<StudentProfileGender>;
  /** The total number of Stints completed by a Stinter. */
  stintCount?: Maybe<Scalars['Int']>;
  nationalInsuranceNumber: Scalars['String'];
  /** The addresses associated with the Stinter. */
  addresses: Array<Address>;
  /** The EmployeeStatement of the Stinter. Statement A, B or C. */
  employeeStatement?: Maybe<EmployeeStatement>;
  studentLoanPlan: StudentProfileStudentLoanPlan;
  /** The EmploymentExceptions associated with the Stinter. */
  employmentExceptions: Array<EmploymentException>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactNumber?: Maybe<Scalars['String']>;
  emergencyContactRelation?: Maybe<Scalars['String']>;
  /** Whether or not the student has given consent to marketing (during registration). */
  marketingConsentAccepted?: Maybe<Scalars['Boolean']>;
  /** The MarketingChannel where the Stinter discovered the app. */
  marketingChannel?: Maybe<MarketingChannel>;
  /** The number of strikes a Stinter has received. */
  strikesAwarded?: Maybe<Scalars['Int']>;
  /** Information on whether or not the Stinter has any PartnerPool invites and a paginated list of their invites. */
  partnerPoolData: StinterPartnerPoolData;
  /** The primary payment method for the Stinter. */
  primaryPaymentMethod?: Maybe<DirectDebitPaymentMethod>;
  /** The ID (Ref) of the StintUser object the Stinter profile is associated with. */
  stinterId: Scalars['UUID'];
  /** Whether or not the Stinter has been deactivated. */
  deactivated: Scalars['Boolean'];
  /** Whether or not the Stinter has been verified by Stint. */
  isVerifiedByStint: Scalars['Boolean'];
  /** The first name of the Stinter. */
  firstName: Scalars['String'];
  /** The last name of the Stinter. */
  lastName: Scalars['String'];
  /** The phone number of the Stinter. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The Date of Birth of the Stinter. */
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** The email of the Stinter. */
  email?: Maybe<Scalars['String']>;
  /** The total amount earned by the Stinter. */
  totalAmountEarned?: Maybe<Scalars['Float']>;
  /** The Stinter's current city. */
  userCurrentCity?: Maybe<City>;
  /** Whether or not the Stinter has ever added availability. */
  hasNeverAddedAvailability?: Maybe<Scalars['Boolean']>;
  /** Whether the Stinter has notifications enabled */
  hasNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  /** Profile photo URL of the Stinter. */
  profilePhotoUrl?: Maybe<Scalars['ImageField']>;
  /** The current location setting for the Stinter's device. */
  locationSetting?: Maybe<LocationSettings>;
  /** The public rating of the Stinter. */
  publicRating: Scalars['String'];
  /** Whether or not the Stinter is trained for any Stint Roles. */
  trained: Scalars['Boolean'];
};

export type Stintopedia = StintopediaInterface & {
  __typename?: 'Stintopedia';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  /** The business of this Stintopedia. */
  business?: Maybe<Business>;
  website?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  aboutUs?: Maybe<Scalars['String']>;
  dos: Array<Maybe<Scalars['String']>>;
  donts: Array<Maybe<Scalars['String']>>;
  internalNotes?: Maybe<Scalars['String']>;
  bookedOnboardingMeeting?: Maybe<Scalars['Boolean']>;
  usingStintCorrectly?: Maybe<Scalars['Boolean']>;
  emoji?: Maybe<Scalars['String']>;
  characteristics: Array<Characteristic>;
  employmentExceptions: Array<EmploymentException>;
  teamStructure?: Maybe<Scalars['String']>;
  qrCodeLocation?: Maybe<Scalars['String']>;
  /** The image of the business entrance */
  photoOfEntrance?: Maybe<Scalars['ImageField']>;
  /** General photo 1 */
  generalPhoto1?: Maybe<Scalars['ImageField']>;
  /** General photo 2 */
  generalPhoto2?: Maybe<Scalars['ImageField']>;
  /** General photo 3 */
  generalPhoto3?: Maybe<Scalars['ImageField']>;
  /** General photo 4 */
  generalPhoto4?: Maybe<Scalars['ImageField']>;
  lastEditBy?: Maybe<StintUser>;
  lastEditTime?: Maybe<Scalars['DateTime']>;
  agreedTakePartInMarketingInitiatives: Scalars['Boolean'];
  agreedToReferFriendsIfFinancialMetricsImproved: Scalars['Boolean'];
  agreedToOperateStaffingRota: Scalars['Boolean'];
  accessToTransactionSalesData: Scalars['Boolean'];
  accessToRotaExamples: Scalars['Boolean'];
  accessToAnnualPlAccounts: Scalars['Boolean'];
  agreedToContinuePostingIfWeSeeDesireResults: Scalars['Boolean'];
  onboardingComplete: Scalars['Boolean'];
  stintopediaPreferredLanguages?: Maybe<Scalars['String']>;
  preferredLanguages: Array<Language>;
  prepVideoUrl?: Maybe<Scalars['String']>;
  prepVideoId?: Maybe<Scalars['String']>;
  /** General photo 1 */
  businessLogo?: Maybe<Scalars['ImageField']>;
  /** Characteristics ids */
  characteristicIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Exceptions ids */
  exceptionIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Characteristics ids */
  preferredLanguageIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Id of related StintUser (auto-generated). */
  last_edit_by_id?: Maybe<Scalars['UUID']>;
};

export type StintopediaFilter = {
  website?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  /** lastEditBy_id */
  lastEditBy_id?: Maybe<Scalars['UUID']>;
  /** lastEditBy_id_isnull */
  lastEditBy_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** website_search */
  website_search?: Maybe<Scalars['String']>;
  /** website_gte */
  website_gte?: Maybe<Scalars['String']>;
  /** website_lte */
  website_lte?: Maybe<Scalars['String']>;
  /** website_istartswith */
  website_istartswith?: Maybe<Scalars['String']>;
  /** website_lt */
  website_lt?: Maybe<Scalars['String']>;
  /** website_gt */
  website_gt?: Maybe<Scalars['String']>;
  /** website_isnull */
  website_isnull?: Maybe<Scalars['Boolean']>;
  /** website_iendswith */
  website_iendswith?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  /** instagram_search */
  instagram_search?: Maybe<Scalars['String']>;
  /** instagram_gte */
  instagram_gte?: Maybe<Scalars['String']>;
  /** instagram_lte */
  instagram_lte?: Maybe<Scalars['String']>;
  /** instagram_istartswith */
  instagram_istartswith?: Maybe<Scalars['String']>;
  /** instagram_lt */
  instagram_lt?: Maybe<Scalars['String']>;
  /** instagram_gt */
  instagram_gt?: Maybe<Scalars['String']>;
  /** instagram_isnull */
  instagram_isnull?: Maybe<Scalars['Boolean']>;
  /** instagram_iendswith */
  instagram_iendswith?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  /** facebook_search */
  facebook_search?: Maybe<Scalars['String']>;
  /** facebook_gte */
  facebook_gte?: Maybe<Scalars['String']>;
  /** facebook_lte */
  facebook_lte?: Maybe<Scalars['String']>;
  /** facebook_istartswith */
  facebook_istartswith?: Maybe<Scalars['String']>;
  /** facebook_lt */
  facebook_lt?: Maybe<Scalars['String']>;
  /** facebook_gt */
  facebook_gt?: Maybe<Scalars['String']>;
  /** facebook_isnull */
  facebook_isnull?: Maybe<Scalars['Boolean']>;
  /** facebook_iendswith */
  facebook_iendswith?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  /** linkedin_search */
  linkedin_search?: Maybe<Scalars['String']>;
  /** linkedin_gte */
  linkedin_gte?: Maybe<Scalars['String']>;
  /** linkedin_lte */
  linkedin_lte?: Maybe<Scalars['String']>;
  /** linkedin_istartswith */
  linkedin_istartswith?: Maybe<Scalars['String']>;
  /** linkedin_lt */
  linkedin_lt?: Maybe<Scalars['String']>;
  /** linkedin_gt */
  linkedin_gt?: Maybe<Scalars['String']>;
  /** linkedin_isnull */
  linkedin_isnull?: Maybe<Scalars['Boolean']>;
  /** linkedin_iendswith */
  linkedin_iendswith?: Maybe<Scalars['String']>;
  aboutUs?: Maybe<Scalars['String']>;
  /** aboutUs_search */
  aboutUs_search?: Maybe<Scalars['String']>;
  /** aboutUs_gte */
  aboutUs_gte?: Maybe<Scalars['String']>;
  /** aboutUs_lte */
  aboutUs_lte?: Maybe<Scalars['String']>;
  /** aboutUs_istartswith */
  aboutUs_istartswith?: Maybe<Scalars['String']>;
  /** aboutUs_lt */
  aboutUs_lt?: Maybe<Scalars['String']>;
  /** aboutUs_gt */
  aboutUs_gt?: Maybe<Scalars['String']>;
  /** aboutUs_isnull */
  aboutUs_isnull?: Maybe<Scalars['Boolean']>;
  /** aboutUs_iendswith */
  aboutUs_iendswith?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  /** internalNotes_search */
  internalNotes_search?: Maybe<Scalars['String']>;
  /** internalNotes_gte */
  internalNotes_gte?: Maybe<Scalars['String']>;
  /** internalNotes_lte */
  internalNotes_lte?: Maybe<Scalars['String']>;
  /** internalNotes_istartswith */
  internalNotes_istartswith?: Maybe<Scalars['String']>;
  /** internalNotes_lt */
  internalNotes_lt?: Maybe<Scalars['String']>;
  /** internalNotes_gt */
  internalNotes_gt?: Maybe<Scalars['String']>;
  /** internalNotes_isnull */
  internalNotes_isnull?: Maybe<Scalars['Boolean']>;
  /** internalNotes_iendswith */
  internalNotes_iendswith?: Maybe<Scalars['String']>;
  bookedOnboardingMeeting?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_gte */
  bookedOnboardingMeeting_gte?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_lte */
  bookedOnboardingMeeting_lte?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_istartswith */
  bookedOnboardingMeeting_istartswith?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_lt */
  bookedOnboardingMeeting_lt?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_gt */
  bookedOnboardingMeeting_gt?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_isnull */
  bookedOnboardingMeeting_isnull?: Maybe<Scalars['Boolean']>;
  /** bookedOnboardingMeeting_iendswith */
  bookedOnboardingMeeting_iendswith?: Maybe<Scalars['Boolean']>;
  usingStintCorrectly?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_gte */
  usingStintCorrectly_gte?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_lte */
  usingStintCorrectly_lte?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_istartswith */
  usingStintCorrectly_istartswith?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_lt */
  usingStintCorrectly_lt?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_gt */
  usingStintCorrectly_gt?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_isnull */
  usingStintCorrectly_isnull?: Maybe<Scalars['Boolean']>;
  /** usingStintCorrectly_iendswith */
  usingStintCorrectly_iendswith?: Maybe<Scalars['Boolean']>;
  emoji?: Maybe<Scalars['String']>;
  /** emoji_search */
  emoji_search?: Maybe<Scalars['String']>;
  /** emoji_gte */
  emoji_gte?: Maybe<Scalars['String']>;
  /** emoji_lte */
  emoji_lte?: Maybe<Scalars['String']>;
  /** emoji_istartswith */
  emoji_istartswith?: Maybe<Scalars['String']>;
  /** emoji_lt */
  emoji_lt?: Maybe<Scalars['String']>;
  /** emoji_gt */
  emoji_gt?: Maybe<Scalars['String']>;
  /** emoji_isnull */
  emoji_isnull?: Maybe<Scalars['Boolean']>;
  /** emoji_iendswith */
  emoji_iendswith?: Maybe<Scalars['String']>;
  teamStructure?: Maybe<Scalars['String']>;
  /** teamStructure_search */
  teamStructure_search?: Maybe<Scalars['String']>;
  /** teamStructure_gte */
  teamStructure_gte?: Maybe<Scalars['String']>;
  /** teamStructure_lte */
  teamStructure_lte?: Maybe<Scalars['String']>;
  /** teamStructure_istartswith */
  teamStructure_istartswith?: Maybe<Scalars['String']>;
  /** teamStructure_lt */
  teamStructure_lt?: Maybe<Scalars['String']>;
  /** teamStructure_gt */
  teamStructure_gt?: Maybe<Scalars['String']>;
  /** teamStructure_isnull */
  teamStructure_isnull?: Maybe<Scalars['Boolean']>;
  /** teamStructure_iendswith */
  teamStructure_iendswith?: Maybe<Scalars['String']>;
  qrCodeLocation?: Maybe<Scalars['String']>;
  /** qrCodeLocation_search */
  qrCodeLocation_search?: Maybe<Scalars['String']>;
  /** qrCodeLocation_gte */
  qrCodeLocation_gte?: Maybe<Scalars['String']>;
  /** qrCodeLocation_lte */
  qrCodeLocation_lte?: Maybe<Scalars['String']>;
  /** qrCodeLocation_istartswith */
  qrCodeLocation_istartswith?: Maybe<Scalars['String']>;
  /** qrCodeLocation_lt */
  qrCodeLocation_lt?: Maybe<Scalars['String']>;
  /** qrCodeLocation_gt */
  qrCodeLocation_gt?: Maybe<Scalars['String']>;
  /** qrCodeLocation_isnull */
  qrCodeLocation_isnull?: Maybe<Scalars['Boolean']>;
  /** qrCodeLocation_iendswith */
  qrCodeLocation_iendswith?: Maybe<Scalars['String']>;
  lastEditTime?: Maybe<Scalars['DateTime']>;
  /** lastEditTime_gte */
  lastEditTime_gte?: Maybe<Scalars['DateTime']>;
  /** lastEditTime_lte */
  lastEditTime_lte?: Maybe<Scalars['DateTime']>;
  /** lastEditTime_istartswith */
  lastEditTime_istartswith?: Maybe<Scalars['DateTime']>;
  /** lastEditTime_lt */
  lastEditTime_lt?: Maybe<Scalars['DateTime']>;
  /** lastEditTime_gt */
  lastEditTime_gt?: Maybe<Scalars['DateTime']>;
  /** lastEditTime_isnull */
  lastEditTime_isnull?: Maybe<Scalars['Boolean']>;
  /** lastEditTime_iendswith */
  lastEditTime_iendswith?: Maybe<Scalars['DateTime']>;
  agreedTakePartInMarketingInitiatives?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_gte */
  agreedTakePartInMarketingInitiatives_gte?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_lte */
  agreedTakePartInMarketingInitiatives_lte?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_istartswith */
  agreedTakePartInMarketingInitiatives_istartswith?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_lt */
  agreedTakePartInMarketingInitiatives_lt?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_gt */
  agreedTakePartInMarketingInitiatives_gt?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_isnull */
  agreedTakePartInMarketingInitiatives_isnull?: Maybe<Scalars['Boolean']>;
  /** agreedTakePartInMarketingInitiatives_iendswith */
  agreedTakePartInMarketingInitiatives_iendswith?: Maybe<Scalars['Boolean']>;
  agreedToReferFriendsIfFinancialMetricsImproved?: Maybe<Scalars['Boolean']>;
  /** agreedToReferFriendsIfFinancialMetricsImproved_gte */
  agreedToReferFriendsIfFinancialMetricsImproved_gte?: Maybe<
    Scalars['Boolean']
  >;
  /** agreedToReferFriendsIfFinancialMetricsImproved_lte */
  agreedToReferFriendsIfFinancialMetricsImproved_lte?: Maybe<
    Scalars['Boolean']
  >;
  /** agreedToReferFriendsIfFinancialMetricsImproved_istartswith */
  agreedToReferFriendsIfFinancialMetricsImproved_istartswith?: Maybe<
    Scalars['Boolean']
  >;
  /** agreedToReferFriendsIfFinancialMetricsImproved_lt */
  agreedToReferFriendsIfFinancialMetricsImproved_lt?: Maybe<Scalars['Boolean']>;
  /** agreedToReferFriendsIfFinancialMetricsImproved_gt */
  agreedToReferFriendsIfFinancialMetricsImproved_gt?: Maybe<Scalars['Boolean']>;
  /** agreedToReferFriendsIfFinancialMetricsImproved_isnull */
  agreedToReferFriendsIfFinancialMetricsImproved_isnull?: Maybe<
    Scalars['Boolean']
  >;
  /** agreedToReferFriendsIfFinancialMetricsImproved_iendswith */
  agreedToReferFriendsIfFinancialMetricsImproved_iendswith?: Maybe<
    Scalars['Boolean']
  >;
  agreedToOperateStaffingRota?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_gte */
  agreedToOperateStaffingRota_gte?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_lte */
  agreedToOperateStaffingRota_lte?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_istartswith */
  agreedToOperateStaffingRota_istartswith?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_lt */
  agreedToOperateStaffingRota_lt?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_gt */
  agreedToOperateStaffingRota_gt?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_isnull */
  agreedToOperateStaffingRota_isnull?: Maybe<Scalars['Boolean']>;
  /** agreedToOperateStaffingRota_iendswith */
  agreedToOperateStaffingRota_iendswith?: Maybe<Scalars['Boolean']>;
  accessToTransactionSalesData?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_gte */
  accessToTransactionSalesData_gte?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_lte */
  accessToTransactionSalesData_lte?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_istartswith */
  accessToTransactionSalesData_istartswith?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_lt */
  accessToTransactionSalesData_lt?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_gt */
  accessToTransactionSalesData_gt?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_isnull */
  accessToTransactionSalesData_isnull?: Maybe<Scalars['Boolean']>;
  /** accessToTransactionSalesData_iendswith */
  accessToTransactionSalesData_iendswith?: Maybe<Scalars['Boolean']>;
  accessToRotaExamples?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_gte */
  accessToRotaExamples_gte?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_lte */
  accessToRotaExamples_lte?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_istartswith */
  accessToRotaExamples_istartswith?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_lt */
  accessToRotaExamples_lt?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_gt */
  accessToRotaExamples_gt?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_isnull */
  accessToRotaExamples_isnull?: Maybe<Scalars['Boolean']>;
  /** accessToRotaExamples_iendswith */
  accessToRotaExamples_iendswith?: Maybe<Scalars['Boolean']>;
  accessToAnnualPlAccounts?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_gte */
  accessToAnnualPlAccounts_gte?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_lte */
  accessToAnnualPlAccounts_lte?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_istartswith */
  accessToAnnualPlAccounts_istartswith?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_lt */
  accessToAnnualPlAccounts_lt?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_gt */
  accessToAnnualPlAccounts_gt?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_isnull */
  accessToAnnualPlAccounts_isnull?: Maybe<Scalars['Boolean']>;
  /** accessToAnnualPlAccounts_iendswith */
  accessToAnnualPlAccounts_iendswith?: Maybe<Scalars['Boolean']>;
  agreedToContinuePostingIfWeSeeDesireResults?: Maybe<Scalars['Boolean']>;
  /** agreedToContinuePostingIfWeSeeDesireResults_gte */
  agreedToContinuePostingIfWeSeeDesireResults_gte?: Maybe<Scalars['Boolean']>;
  /** agreedToContinuePostingIfWeSeeDesireResults_lte */
  agreedToContinuePostingIfWeSeeDesireResults_lte?: Maybe<Scalars['Boolean']>;
  /** agreedToContinuePostingIfWeSeeDesireResults_istartswith */
  agreedToContinuePostingIfWeSeeDesireResults_istartswith?: Maybe<
    Scalars['Boolean']
  >;
  /** agreedToContinuePostingIfWeSeeDesireResults_lt */
  agreedToContinuePostingIfWeSeeDesireResults_lt?: Maybe<Scalars['Boolean']>;
  /** agreedToContinuePostingIfWeSeeDesireResults_gt */
  agreedToContinuePostingIfWeSeeDesireResults_gt?: Maybe<Scalars['Boolean']>;
  /** agreedToContinuePostingIfWeSeeDesireResults_isnull */
  agreedToContinuePostingIfWeSeeDesireResults_isnull?: Maybe<
    Scalars['Boolean']
  >;
  /** agreedToContinuePostingIfWeSeeDesireResults_iendswith */
  agreedToContinuePostingIfWeSeeDesireResults_iendswith?: Maybe<
    Scalars['Boolean']
  >;
  onboardingComplete?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_gte */
  onboardingComplete_gte?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_lte */
  onboardingComplete_lte?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_istartswith */
  onboardingComplete_istartswith?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_lt */
  onboardingComplete_lt?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_gt */
  onboardingComplete_gt?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_isnull */
  onboardingComplete_isnull?: Maybe<Scalars['Boolean']>;
  /** onboardingComplete_iendswith */
  onboardingComplete_iendswith?: Maybe<Scalars['Boolean']>;
  stintopediaPreferredLanguages?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_search */
  stintopediaPreferredLanguages_search?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_gte */
  stintopediaPreferredLanguages_gte?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_lte */
  stintopediaPreferredLanguages_lte?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_istartswith */
  stintopediaPreferredLanguages_istartswith?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_lt */
  stintopediaPreferredLanguages_lt?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_gt */
  stintopediaPreferredLanguages_gt?: Maybe<Scalars['String']>;
  /** stintopediaPreferredLanguages_isnull */
  stintopediaPreferredLanguages_isnull?: Maybe<Scalars['Boolean']>;
  /** stintopediaPreferredLanguages_iendswith */
  stintopediaPreferredLanguages_iendswith?: Maybe<Scalars['String']>;
  prepVideoUrl?: Maybe<Scalars['String']>;
  /** prepVideoUrl_search */
  prepVideoUrl_search?: Maybe<Scalars['String']>;
  /** prepVideoUrl_gte */
  prepVideoUrl_gte?: Maybe<Scalars['String']>;
  /** prepVideoUrl_lte */
  prepVideoUrl_lte?: Maybe<Scalars['String']>;
  /** prepVideoUrl_istartswith */
  prepVideoUrl_istartswith?: Maybe<Scalars['String']>;
  /** prepVideoUrl_lt */
  prepVideoUrl_lt?: Maybe<Scalars['String']>;
  /** prepVideoUrl_gt */
  prepVideoUrl_gt?: Maybe<Scalars['String']>;
  /** prepVideoUrl_isnull */
  prepVideoUrl_isnull?: Maybe<Scalars['Boolean']>;
  /** prepVideoUrl_iendswith */
  prepVideoUrl_iendswith?: Maybe<Scalars['String']>;
  prepVideoId?: Maybe<Scalars['String']>;
  /** prepVideoId_search */
  prepVideoId_search?: Maybe<Scalars['String']>;
  /** prepVideoId_gte */
  prepVideoId_gte?: Maybe<Scalars['String']>;
  /** prepVideoId_lte */
  prepVideoId_lte?: Maybe<Scalars['String']>;
  /** prepVideoId_istartswith */
  prepVideoId_istartswith?: Maybe<Scalars['String']>;
  /** prepVideoId_lt */
  prepVideoId_lt?: Maybe<Scalars['String']>;
  /** prepVideoId_gt */
  prepVideoId_gt?: Maybe<Scalars['String']>;
  /** prepVideoId_isnull */
  prepVideoId_isnull?: Maybe<Scalars['Boolean']>;
  /** prepVideoId_iendswith */
  prepVideoId_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use characteristics ids to filter Stintopedia by characteristics. */
  characteristics_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use employmentExceptions ids to filter Stintopedia by employmentExceptions. */
  employmentExceptions_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use studentExceptions ids to filter Stintopedia by studentExceptions. */
  studentExceptions_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use preferredLanguages ids to filter Stintopedia by preferredLanguages. */
  preferredLanguages_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  website_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  instagram_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  facebook_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  linkedin_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  aboutUs_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  internalNotes_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  bookedOnboardingMeeting_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  usingStintCorrectly_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  emoji_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  teamStructure_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  qrCodeLocation_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  lastEditTime_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  agreedTakePartInMarketingInitiatives_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  agreedToReferFriendsIfFinancialMetricsImproved_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  agreedToOperateStaffingRota_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  accessToTransactionSalesData_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  accessToRotaExamples_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  accessToAnnualPlAccounts_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  agreedToContinuePostingIfWeSeeDesireResults_in?: Maybe<
    Array<Maybe<Scalars['Boolean']>>
  >;
  /** Multiple values may be separated by commas. */
  onboardingComplete_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  stintopediaPreferredLanguages_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  prepVideoUrl_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  prepVideoId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StintopediaInput = {
  bookedOnboardingMeeting?: Maybe<Scalars['Boolean']>;
  usingStintCorrectly?: Maybe<Scalars['Boolean']>;
};

export type StintopediaInterface = {
  /** General photo 1 */
  businessLogo?: Maybe<Scalars['ImageField']>;
  /** Characteristics ids */
  characteristicIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Exceptions ids */
  exceptionIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** General photo 1 */
  generalPhoto1?: Maybe<Scalars['ImageField']>;
  /** General photo 2 */
  generalPhoto2?: Maybe<Scalars['ImageField']>;
  /** General photo 3 */
  generalPhoto3?: Maybe<Scalars['ImageField']>;
  /** General photo 4 */
  generalPhoto4?: Maybe<Scalars['ImageField']>;
  /** The image of the business entrance */
  photoOfEntrance?: Maybe<Scalars['ImageField']>;
  /** Characteristics ids */
  preferredLanguageIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/**
 * The StripeCardType class defines the Graphene ObjectType class used to resolve the StripeCard
 * model data for GraphQL queries.
 *
 * It inherits the common fields from BaseObjectType.
 */
export type StripeCard = {
  __typename?: 'StripeCard';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  isPrimaryMethod: Scalars['Boolean'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['DateTime'];
  nameOnCard?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  lastFourDigits?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  business?: Maybe<Business>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
};

export type StripeCardFilter = {
  businessId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** stripebasePtr_id */
  stripebasePtr_id?: Maybe<Scalars['UUID']>;
  /** stripebasePtr_id_isnull */
  stripebasePtr_id_isnull?: Maybe<Scalars['Boolean']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  isPrimaryMethod?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gte */
  isPrimaryMethod_gte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lte */
  isPrimaryMethod_lte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_istartswith */
  isPrimaryMethod_istartswith?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lt */
  isPrimaryMethod_lt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gt */
  isPrimaryMethod_gt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_isnull */
  isPrimaryMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_iendswith */
  isPrimaryMethod_iendswith?: Maybe<Scalars['Boolean']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_search */
  stripePaymentMethodId_search?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_gte */
  stripePaymentMethodId_gte?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_lte */
  stripePaymentMethodId_lte?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_istartswith */
  stripePaymentMethodId_istartswith?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_lt */
  stripePaymentMethodId_lt?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_gt */
  stripePaymentMethodId_gt?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_isnull */
  stripePaymentMethodId_isnull?: Maybe<Scalars['Boolean']>;
  /** stripePaymentMethodId_iendswith */
  stripePaymentMethodId_iendswith?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  nameOnCard?: Maybe<Scalars['String']>;
  /** nameOnCard_search */
  nameOnCard_search?: Maybe<Scalars['String']>;
  /** nameOnCard_gte */
  nameOnCard_gte?: Maybe<Scalars['String']>;
  /** nameOnCard_lte */
  nameOnCard_lte?: Maybe<Scalars['String']>;
  /** nameOnCard_istartswith */
  nameOnCard_istartswith?: Maybe<Scalars['String']>;
  /** nameOnCard_lt */
  nameOnCard_lt?: Maybe<Scalars['String']>;
  /** nameOnCard_gt */
  nameOnCard_gt?: Maybe<Scalars['String']>;
  /** nameOnCard_isnull */
  nameOnCard_isnull?: Maybe<Scalars['Boolean']>;
  /** nameOnCard_iendswith */
  nameOnCard_iendswith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** description_search */
  description_search?: Maybe<Scalars['String']>;
  /** description_gte */
  description_gte?: Maybe<Scalars['String']>;
  /** description_lte */
  description_lte?: Maybe<Scalars['String']>;
  /** description_istartswith */
  description_istartswith?: Maybe<Scalars['String']>;
  /** description_lt */
  description_lt?: Maybe<Scalars['String']>;
  /** description_gt */
  description_gt?: Maybe<Scalars['String']>;
  /** description_isnull */
  description_isnull?: Maybe<Scalars['Boolean']>;
  /** description_iendswith */
  description_iendswith?: Maybe<Scalars['String']>;
  lastFourDigits?: Maybe<Scalars['String']>;
  /** lastFourDigits_search */
  lastFourDigits_search?: Maybe<Scalars['String']>;
  /** lastFourDigits_gte */
  lastFourDigits_gte?: Maybe<Scalars['String']>;
  /** lastFourDigits_lte */
  lastFourDigits_lte?: Maybe<Scalars['String']>;
  /** lastFourDigits_istartswith */
  lastFourDigits_istartswith?: Maybe<Scalars['String']>;
  /** lastFourDigits_lt */
  lastFourDigits_lt?: Maybe<Scalars['String']>;
  /** lastFourDigits_gt */
  lastFourDigits_gt?: Maybe<Scalars['String']>;
  /** lastFourDigits_isnull */
  lastFourDigits_isnull?: Maybe<Scalars['Boolean']>;
  /** lastFourDigits_iendswith */
  lastFourDigits_iendswith?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  /** brand_search */
  brand_search?: Maybe<Scalars['String']>;
  /** brand_gte */
  brand_gte?: Maybe<Scalars['String']>;
  /** brand_lte */
  brand_lte?: Maybe<Scalars['String']>;
  /** brand_istartswith */
  brand_istartswith?: Maybe<Scalars['String']>;
  /** brand_lt */
  brand_lt?: Maybe<Scalars['String']>;
  /** brand_gt */
  brand_gt?: Maybe<Scalars['String']>;
  /** brand_isnull */
  brand_isnull?: Maybe<Scalars['Boolean']>;
  /** brand_iendswith */
  brand_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  isPrimaryMethod_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  stripePaymentMethodId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  nameOnCard_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  lastFourDigits_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  brand_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The StripeDebitType class defines the Graphene ObjectType class used to resolve the StripeDebit
 * model data for GraphQL queries.
 *
 * It inherits the common fields from BaseObjectType.
 */
export type StripeDebit = {
  __typename?: 'StripeDebit';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  isPrimaryMethod: Scalars['Boolean'];
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  modifiedAt: Scalars['DateTime'];
  accountNumber?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  business?: Maybe<Business>;
  /** Id of related Business (auto-generated). */
  business_id?: Maybe<Scalars['UUID']>;
};

export type StripeDebitFilter = {
  businessId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** stripebasePtr_id */
  stripebasePtr_id?: Maybe<Scalars['UUID']>;
  /** stripebasePtr_id_isnull */
  stripebasePtr_id_isnull?: Maybe<Scalars['Boolean']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** business_id_isnull */
  business_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  isPrimaryMethod?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gte */
  isPrimaryMethod_gte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lte */
  isPrimaryMethod_lte?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_istartswith */
  isPrimaryMethod_istartswith?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_lt */
  isPrimaryMethod_lt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_gt */
  isPrimaryMethod_gt?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_isnull */
  isPrimaryMethod_isnull?: Maybe<Scalars['Boolean']>;
  /** isPrimaryMethod_iendswith */
  isPrimaryMethod_iendswith?: Maybe<Scalars['Boolean']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_search */
  stripePaymentMethodId_search?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_gte */
  stripePaymentMethodId_gte?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_lte */
  stripePaymentMethodId_lte?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_istartswith */
  stripePaymentMethodId_istartswith?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_lt */
  stripePaymentMethodId_lt?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_gt */
  stripePaymentMethodId_gt?: Maybe<Scalars['String']>;
  /** stripePaymentMethodId_isnull */
  stripePaymentMethodId_isnull?: Maybe<Scalars['Boolean']>;
  /** stripePaymentMethodId_iendswith */
  stripePaymentMethodId_iendswith?: Maybe<Scalars['String']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  accountNumber?: Maybe<Scalars['String']>;
  /** accountNumber_search */
  accountNumber_search?: Maybe<Scalars['String']>;
  /** accountNumber_gte */
  accountNumber_gte?: Maybe<Scalars['String']>;
  /** accountNumber_lte */
  accountNumber_lte?: Maybe<Scalars['String']>;
  /** accountNumber_istartswith */
  accountNumber_istartswith?: Maybe<Scalars['String']>;
  /** accountNumber_lt */
  accountNumber_lt?: Maybe<Scalars['String']>;
  /** accountNumber_gt */
  accountNumber_gt?: Maybe<Scalars['String']>;
  /** accountNumber_isnull */
  accountNumber_isnull?: Maybe<Scalars['Boolean']>;
  /** accountNumber_iendswith */
  accountNumber_iendswith?: Maybe<Scalars['String']>;
  sortCode?: Maybe<Scalars['String']>;
  /** sortCode_search */
  sortCode_search?: Maybe<Scalars['String']>;
  /** sortCode_gte */
  sortCode_gte?: Maybe<Scalars['String']>;
  /** sortCode_lte */
  sortCode_lte?: Maybe<Scalars['String']>;
  /** sortCode_istartswith */
  sortCode_istartswith?: Maybe<Scalars['String']>;
  /** sortCode_lt */
  sortCode_lt?: Maybe<Scalars['String']>;
  /** sortCode_gt */
  sortCode_gt?: Maybe<Scalars['String']>;
  /** sortCode_isnull */
  sortCode_isnull?: Maybe<Scalars['Boolean']>;
  /** sortCode_iendswith */
  sortCode_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  isPrimaryMethod_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Multiple values may be separated by commas. */
  stripePaymentMethodId_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  accountNumber_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  sortCode_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** StudentAvailabilityInputType */
export enum StudentAvailabilityInputType {
  CREATED_WITH_BEST_TIMES_CONSOLE = 'CREATED_WITH_BEST_TIMES_CONSOLE',
  CREATED_WITH_MY_AVAILABILITY = 'CREATED_WITH_MY_AVAILABILITY',
}

export enum StudentLoanPlan {
  /** No Plan */
  NO_PLAN = 'NO_PLAN',
  /** Plan One */
  PLAN_ONE = 'PLAN_ONE',
  /** Plan Two */
  PLAN_TWO = 'PLAN_TWO',
}

export type StudentProfile = {
  __typename?: 'StudentProfile';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  /** The Gender of the Stinter. */
  gender?: Maybe<StudentProfileGender>;
  /** The total number of Stints completed by a (student) user */
  stintCount?: Maybe<Scalars['Int']>;
  nationalInsuranceNumber: Scalars['String'];
  addresses: Array<Address>;
  /** the employee statement of the student (a,b or c) */
  employeeStatement?: Maybe<EmployeeStatement>;
  studentLoanPlan: StudentProfileStudentLoanPlan;
  employmentExceptions: Array<EmploymentException>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactNumber?: Maybe<Scalars['String']>;
  emergencyContactRelation?: Maybe<Scalars['String']>;
  /** True if the student has given consent to marketing (during registration) */
  marketingConsentAccepted?: Maybe<Scalars['Boolean']>;
  modifiedAt: Scalars['DateTime'];
  student: StintUser;
  stintCancelledCount?: Maybe<Scalars['Int']>;
  latestStintAt?: Maybe<Scalars['DateTime']>;
  university?: Maybe<University>;
  degree?: Maybe<Scalars['String']>;
  universityStartYear?: Maybe<Scalars['Int']>;
  universityEndYear?: Maybe<Scalars['Int']>;
  homeTown?: Maybe<City>;
  homeTownVisits?: Maybe<StudentProfileHomeTownVisits>;
  reference?: Maybe<Scalars['String']>;
  passportNumber: Scalars['String'];
  /** List of student payment methods, sorted in descending order (latest is first) */
  paymentMethods?: Maybe<Array<Maybe<DirectDebitPaymentMethod>>>;
  hasAllergies: Scalars['Boolean'];
  medicalNotes?: Maybe<Scalars['String']>;
  allergyNotes?: Maybe<Scalars['String']>;
  workExperience?: Maybe<Scalars['String']>;
  onDemandUntil?: Maybe<Scalars['DateTime']>;
  hygienic: Scalars['Boolean'];
  articulate?: Maybe<Scalars['Int']>;
  polite?: Maybe<Scalars['Int']>;
  outgoing?: Maybe<Scalars['Int']>;
  energetic: Scalars['Boolean'];
  canGetHandsDirty: Scalars['Boolean'];
  looseAvailability: Scalars['Boolean'];
  preferredBusinessAvailability: Scalars['Boolean'];
  nearbyAvailability: Scalars['Boolean'];
  nearbyAvailabilityPostcode?: Maybe<Scalars['String']>;
  requestedBusinessAvailability: Scalars['Boolean'];
  /** Deprecated */
  optInGuaranteedStints: Scalars['Boolean'];
  preferredStintLength?: Maybe<Scalars['String']>;
  preferredStintFrequency?: Maybe<Scalars['String']>;
  muteStintsUntil?: Maybe<Scalars['DateTime']>;
  /** True if the student has uploaded right to work documents */
  rtwUploaded?: Maybe<Scalars['Boolean']>;
  rtwUploadedAt?: Maybe<Scalars['DateTime']>;
  marketingConsentCollectedAt?: Maybe<Scalars['DateTime']>;
  /** Returns the primary payment method for the user as a single payment method */
  primaryPaymentMethod?: Maybe<DirectDebitPaymentMethod>;
  /** Whether the student user has completed their student profile. */
  hasCompletedStudentProfile?: Maybe<Scalars['Boolean']>;
  /** The list of business discount badges that a (student) user has earned from businesses */
  businessDiscountBadges?: Maybe<Array<Maybe<BusinessDiscountBadge>>>;
  /** The total strikes awarded for all the Stinter's Offences excluding those with a Successful appeal status. */
  strikesAwarded?: Maybe<Scalars['Int']>;
  /** Id of related University (auto-generated). */
  university_id?: Maybe<Scalars['UUID']>;
  /** Id of related City (auto-generated). */
  home_town_id?: Maybe<Scalars['UUID']>;
};

/** The TextChoices for the StudentProfile.gender field. */
export enum StudentProfileGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  PREFER_NOT_SAY = 'PREFER_NOT_SAY',
  OTHER = 'OTHER',
}

export enum StudentProfileHomeTownVisits {
  /** Weekends */
  WEEKENDS = 'WEEKENDS',
  /** Outside Term Time */
  OUTSIDE_TERM_TIME = 'OUTSIDE_TERM_TIME',
  /** Summer */
  SUMMER = 'SUMMER',
  /** Occasionally */
  OCCASIONALLY = 'OCCASIONALLY',
  /** Most Of The Time */
  MOST_OF_THE_TIME = 'MOST_OF_THE_TIME',
}

/** Input object type for creating or updating a StudentProfile object. */
export type StudentProfileInput = {
  /** Student emergency contact name, will raise an error for other users */
  emergencyContactName?: Maybe<Scalars['String']>;
  /** Student emergency contact number, will raise an error for other users */
  emergencyContactNumber?: Maybe<Scalars['String']>;
  /** Student emergency contact relation, will raise an error for other users */
  emergencyContactRelation?: Maybe<Scalars['String']>;
  /** Student employee statement, will raise an error for other users */
  employeeStatement?: Maybe<EmployeeStatement>;
  /** Student loan plan, will raise an error for other users */
  studentLoanPlan?: Maybe<StudentLoanPlan>;
  /** University for the student, will raise an error for other users */
  universityId?: Maybe<Scalars['UUID']>;
};

export enum StudentProfileStudentLoanPlan {
  /** No Plan */
  NO_PLAN = 'NO_PLAN',
  /** Plan One */
  PLAN_ONE = 'PLAN_ONE',
  /** Plan Two */
  PLAN_TWO = 'PLAN_TWO',
}

export type StudentReview = {
  __typename?: 'StudentReview';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  reviewType?: Maybe<ReviewReviewType>;
  reviewDate?: Maybe<Scalars['DateTime']>;
  reviewer?: Maybe<StintUser>;
  rating?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  /** Student related to review */
  student?: Maybe<StintUser>;
  /** Stint related to review */
  stint?: Maybe<Stint>;
  tags: Array<Tag>;
  studentreview: Array<StintUser>;
  /** Deprecated. */
  isStintGuarantee?: Maybe<Scalars['Boolean']>;
  /** Is internal review. */
  isInternalReview?: Maybe<Scalars['Boolean']>;
  /** Id of related StintUser (auto-generated). */
  reviewer_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
  /** Id of related Stint (auto-generated). */
  stint_id?: Maybe<Scalars['UUID']>;
};

export type StudentReviewFilter = {
  rating?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** business_id */
  business_id?: Maybe<Scalars['UUID']>;
  /** only_internal_reviews */
  only_internal_reviews?: Maybe<Scalars['Boolean']>;
  /** start_from */
  start_from?: Maybe<Scalars['Date']>;
  /** stint_status */
  stint_status?: Maybe<Scalars['Float']>;
  /** reviewer_id */
  reviewer_id?: Maybe<Scalars['UUID']>;
  /** reviewer_id_isnull */
  reviewer_id_isnull?: Maybe<Scalars['Boolean']>;
  /** reviewPtr_id */
  reviewPtr_id?: Maybe<Scalars['UUID']>;
  /** reviewPtr_id_isnull */
  reviewPtr_id_isnull?: Maybe<Scalars['Boolean']>;
  /** student_id */
  student_id?: Maybe<Scalars['UUID']>;
  /** student_id_isnull */
  student_id_isnull?: Maybe<Scalars['Boolean']>;
  /** stint_id */
  stint_id?: Maybe<Scalars['UUID']>;
  /** stint_id_isnull */
  stint_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  reviewType?: Maybe<Scalars['String']>;
  /** reviewType_search */
  reviewType_search?: Maybe<Scalars['String']>;
  /** reviewType_gte */
  reviewType_gte?: Maybe<Scalars['String']>;
  /** reviewType_lte */
  reviewType_lte?: Maybe<Scalars['String']>;
  /** reviewType_istartswith */
  reviewType_istartswith?: Maybe<Scalars['String']>;
  /** reviewType_lt */
  reviewType_lt?: Maybe<Scalars['String']>;
  /** reviewType_gt */
  reviewType_gt?: Maybe<Scalars['String']>;
  /** reviewType_isnull */
  reviewType_isnull?: Maybe<Scalars['Boolean']>;
  /** reviewType_iendswith */
  reviewType_iendswith?: Maybe<Scalars['String']>;
  reviewDate?: Maybe<Scalars['DateTime']>;
  /** reviewDate_gte */
  reviewDate_gte?: Maybe<Scalars['DateTime']>;
  /** reviewDate_lte */
  reviewDate_lte?: Maybe<Scalars['DateTime']>;
  /** reviewDate_istartswith */
  reviewDate_istartswith?: Maybe<Scalars['DateTime']>;
  /** reviewDate_lt */
  reviewDate_lt?: Maybe<Scalars['DateTime']>;
  /** reviewDate_gt */
  reviewDate_gt?: Maybe<Scalars['DateTime']>;
  /** reviewDate_isnull */
  reviewDate_isnull?: Maybe<Scalars['Boolean']>;
  /** reviewDate_iendswith */
  reviewDate_iendswith?: Maybe<Scalars['DateTime']>;
  /** rating_gte */
  rating_gte?: Maybe<Scalars['Float']>;
  /** rating_lte */
  rating_lte?: Maybe<Scalars['Float']>;
  /** rating_istartswith */
  rating_istartswith?: Maybe<Scalars['Float']>;
  /** rating_lt */
  rating_lt?: Maybe<Scalars['Float']>;
  /** rating_gt */
  rating_gt?: Maybe<Scalars['Float']>;
  /** rating_isnull */
  rating_isnull?: Maybe<Scalars['Boolean']>;
  /** rating_iendswith */
  rating_iendswith?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
  /** feedback_search */
  feedback_search?: Maybe<Scalars['String']>;
  /** feedback_gte */
  feedback_gte?: Maybe<Scalars['String']>;
  /** feedback_lte */
  feedback_lte?: Maybe<Scalars['String']>;
  /** feedback_istartswith */
  feedback_istartswith?: Maybe<Scalars['String']>;
  /** feedback_lt */
  feedback_lt?: Maybe<Scalars['String']>;
  /** feedback_gt */
  feedback_gt?: Maybe<Scalars['String']>;
  /** feedback_isnull */
  feedback_isnull?: Maybe<Scalars['Boolean']>;
  /** feedback_iendswith */
  feedback_iendswith?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  /** hidden_gte */
  hidden_gte?: Maybe<Scalars['Boolean']>;
  /** hidden_lte */
  hidden_lte?: Maybe<Scalars['Boolean']>;
  /** hidden_istartswith */
  hidden_istartswith?: Maybe<Scalars['Boolean']>;
  /** hidden_lt */
  hidden_lt?: Maybe<Scalars['Boolean']>;
  /** hidden_gt */
  hidden_gt?: Maybe<Scalars['Boolean']>;
  /** hidden_isnull */
  hidden_isnull?: Maybe<Scalars['Boolean']>;
  /** hidden_iendswith */
  hidden_iendswith?: Maybe<Scalars['Boolean']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  business_id_in?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use tags ids to filter StudentReview by tags. */
  tags_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Use endorsements ids to filter StudentReview by endorsements. */
  endorsements_ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  reviewType_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  reviewDate_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  rating_in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Multiple values may be separated by commas. */
  feedback_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  hidden_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type StudentSavedPlace = {
  __typename?: 'StudentSavedPlace';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  student: StintUser;
  name: Scalars['String'];
  address: Address;
  city?: Maybe<City>;
  /**
   * Name of the section saved place should be displayed.
   * Usually name of city it is related to or "Other" for inactive cities.
   */
  sectionName?: Maybe<Scalars['String']>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
  /** Id of related Address (auto-generated). */
  address_id?: Maybe<Scalars['UUID']>;
};

export type StudentSavedPlaceListType = {
  __typename?: 'StudentSavedPlaceListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StudentSavedPlace>>>;
};

export type StudentUnassignedEvent = {
  __typename?: 'StudentUnassignedEvent';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  createdBy?: Maybe<StintUser>;
  /** The associated Stint. */
  stint: StintNode;
  student?: Maybe<StintUser>;
  unassignedReasons: Array<Maybe<Scalars['String']>>;
  studentFault: Scalars['Boolean'];
  /** Id of related StintUser (auto-generated). */
  created_by_id?: Maybe<Scalars['UUID']>;
  /** Id of related Stint (auto-generated). */
  stint_id?: Maybe<Scalars['UUID']>;
  /** Id of related StintUser (auto-generated). */
  student_id?: Maybe<Scalars['UUID']>;
};

export type StudentUnassignedEventListType = {
  __typename?: 'StudentUnassignedEventListType';
  /** Pagination data for this connection. */
  pageInfo: PageInfoType;
  /** Contains the nodes in this connection. */
  objects?: Maybe<Array<Maybe<StudentUnassignedEvent>>>;
};

/** StudentUnassignedReasons */
export enum StudentUnassignedReasons {
  CRITERIA = 'CRITERIA',
  BAD_RATING = 'BAD_RATING',
  NOT_RATED = 'NOT_RATED',
  BUSINESS_UNHAPPY = 'BUSINESS_UNHAPPY',
  NEW_IMPORTANT_BUSINESS = 'NEW_IMPORTANT_BUSINESS',
  OTHER = 'OTHER',
  WORKING_CAP = 'WORKING_CAP',
  OVERLAPPING_STINTS = 'OVERLAPPING_STINTS',
  ACCEPTED_BY_MISTAKE = 'ACCEPTED_BY_MISTAKE',
  EARLIER_REPLACEMENT_FOUND = 'EARLIER_REPLACEMENT_FOUND',
  EXCEPTIONS = 'EXCEPTIONS',
  STANDBY_ASSIGNED_TO_STINT = 'STANDBY_ASSIGNED_TO_STINT',
  LOCATION = 'LOCATION',
  LEAVE = 'LEAVE',
  ARRIVE = 'ARRIVE',
  PULLED_OUT = 'PULLED_OUT',
  EXPECTED_TOO_LATE = 'EXPECTED_TOO_LATE',
  EXTENUATING = 'EXTENUATING',
  DISCIPLINARY = 'DISCIPLINARY',
  NO_CONFIRM_NIGHT_BEFORE = 'NO_CONFIRM_NIGHT_BEFORE',
  NO_CONFIRM_ON_THE_DAY = 'NO_CONFIRM_ON_THE_DAY',
  GRANULAR_NOT_ENABLED = 'GRANULAR_NOT_ENABLED',
  NO_ASAP_CONFIRMATION = 'NO_ASAP_CONFIRMATION',
  COVID_HOLD = 'COVID_HOLD',
  TEAMS_SWAP = 'TEAMS_SWAP',
  TEAMS_SICK = 'TEAMS_SICK',
  TEAMS_EXTENUATING = 'TEAMS_EXTENUATING',
  TEAMS_CHANGE_OF_SCHEDULE = 'TEAMS_CHANGE_OF_SCHEDULE',
  TEAMS_STINTER_LEFT_TEAM = 'TEAMS_STINTER_LEFT_TEAM',
  TEAMS_STINTER_REMOVED_FROM_TEAM = 'TEAMS_STINTER_REMOVED_FROM_TEAM',
  TEAMS_BRAND_REPEAT_CANCELLATION = 'TEAMS_BRAND_REPEAT_CANCELLATION',
  TEAMS_NO_COMPLIANCE = 'TEAMS_NO_COMPLIANCE',
  TEAMS_OTHER = 'TEAMS_OTHER',
}

/** The input values required to submit a shift review. Either a non-empty comment or at least one tag must be provided in addition to the rating. */
export type SubmitEmployeeShiftReviewInput = {
  /** The ID of the shift being reviewed. */
  shiftId: Scalars['UUID'];
  /** Optional comment about the shift. At least one tag or a comment must be provided. */
  comment?: Maybe<Scalars['String']>;
  /** The numeric rating for the shift. */
  rating: Scalars['Float'];
  /** Optional category tags for the review. At least one tag or a comment must be provided. */
  tags?: Maybe<Array<EmployeeShiftReviewTag>>;
};

/** The output values returned to the client from the SubmitEmployeeShiftReviewOutput mutation. */
export type SubmitEmployeeShiftReviewOutput = {
  __typename?: 'SubmitEmployeeShiftReviewOutput';
  /** The persisted shift review, when the operation succeeds. */
  employeeShiftReview?: Maybe<EmployeeShiftReview>;
};

/** The input values required to submit a SiteSchedule for review. */
export type SubmitSiteScheduleForReviewInput = {
  /** The ID of the Site for which the SiteSchedule is being submitted for review. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule being submitted for review. */
  siteScheduleId: Scalars['UUID'];
  /** The last modified at timestamp of the SiteSchedule used to determine if the schedule has been updated since the schedule being submitted for review was loaded to prevent it from being submitted for review if it is out of date. */
  lastModifiedAt: Scalars['String'];
};

/** The output values available to the client after submitting a SiteSchedule for review. */
export type SubmitSiteScheduleForReviewOutput = {
  __typename?: 'SubmitSiteScheduleForReviewOutput';
  /** The review data for the SiteSchedule. */
  review: SiteScheduleReview;
};

/** Allows filtering of dates when requesting all holidays for the subordinates of an employer. */
export type SubordinatesHolidaysInput = {
  /** Only holidays with an end date of the holiday request greater than or equal to this date will be returned. If omitted, all holiday before the lte filter will be returned. */
  gte?: Maybe<Scalars['Date']>;
  /** Only holidays with a start date of the holiday request less than or equal to this date will be returned. If omitted, all holiday after the gte filter will be returned. */
  lte?: Maybe<Scalars['Date']>;
  /** Only holidays with statuses in this list will be returned. If omitted, only PENDING and APPROVED holidays will be returned. */
  statusIn?: Maybe<Array<Maybe<CoreTeamMemberHolidayRequestStatus>>>;
};

export type SuccessType = {
  __typename?: 'SuccessType';
  /** Indicate if the action was successful */
  success: Scalars['Boolean'];
  /** Message about success */
  message?: Maybe<Scalars['String']>;
};

/** The input values required from a client to swap Shifts in the SiteSchedule. */
export type SwapSiteScheduleShiftsInput = {
  /** The ID of the first shift to swap. */
  shift1Id: Scalars['UUID'];
  /** The ID of the second shift to swap. */
  shift2Id: Scalars['UUID'];
  /** The ID of the Site associated with the shifts. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule to associate with the shifts. */
  siteScheduleId: Scalars['UUID'];
  /** String timestamp of when the first Shift was last modified. */
  shift1LastModifiedAt: Scalars['String'];
  /** String timestamp of when the second Shift was last modified. */
  shift2LastModifiedAt: Scalars['String'];
  /** String timestamp of when the SiteSchedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** The output values returned to the client from the SwapSiteScheduleShifts mutation. */
export type SwapSiteScheduleShiftsOutput = {
  __typename?: 'SwapSiteScheduleShiftsOutput';
  /** The updated day schedule for the day the first Shift is on. */
  shift1DaySchedule: Schedule;
  /** The updated day schedule for the day the second Shift is on. Null if the second Shift is on the same day as the first Shift. */
  shift2DaySchedule?: Maybe<Schedule>;
  /** String timestamp of when the SiteSchedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** Represents the system sales forecast attributes information for the given forecast date. */
export type SystemSalesForecastAttributes = {
  __typename?: 'SystemSalesForecastAttributes';
  /** The UUID7 identifier for the system sales forecast. */
  id: Scalars['UUID'];
  /** The forecasted sales amount for the given forecast date. */
  amount: Scalars['Int'];
  /** Where the data for the forecast came from. */
  forecastSource: SystemSalesForecastSource;
  /** Overview of the weather used within the system sales forecasted sales amount.Is null when no weather data is available for the forecast day. */
  weather?: Maybe<SystemSalesForecastWeather>;
  /** The public holidays that the forecasting system took into consideration for the day.Will be an empty list if there are no holidays. */
  holidays: Array<SystemSalesForecastHoliday>;
  /** The local events that the forecasting system took into consideration for the day.Will be an empty list if there are no events. */
  events: Array<SystemSalesForecastEvent>;
  /** The bookings that the forecasting system took into consideration for the day.Is null when no booking info is available for the forecast day. */
  bookingInfo?: Maybe<SystemSalesForecastBookingInfo>;
  /** The timestamp (with tz) that the forecasted sales amount was generated by our system. */
  generatedAt: Scalars['DateTime'];
};

/** Represents the booking info on the forecast day. */
export type SystemSalesForecastBookingInfo = {
  __typename?: 'SystemSalesForecastBookingInfo';
  /** The total number of bookings from open until time. */
  tillTimeCount: Scalars['Int'];
  /** The total number of covers from open up until time. */
  tillTimeCovers: Scalars['Int'];
  /** The total number of bookings from time until close. */
  tillCloseCount: Scalars['Int'];
  /** The total number of covers from time until close. */
  tillCloseCovers: Scalars['Int'];
  /** The time at which we split the bookings to show a morning/afternoon type split. */
  time: Scalars['DateTime'];
};

/** Represents the event info that occurs on the forecast day. */
export type SystemSalesForecastEvent = {
  __typename?: 'SystemSalesForecastEvent';
  /** The end time of the event that occurs on the forecast date. Null if the end time is not known, or if the event is for an all day event (where the begin time is expected to be null too) */
  end?: Maybe<Scalars['DateTime']>;
  /** The start time of the event that occurs on the forecast date. Null if the begin time is not known, or if the event is for an all day event (where the end time is expected to be null too) */
  begin?: Maybe<Scalars['DateTime']>;
  /** The name of event that occurs on the forecast date. */
  name: Scalars['String'];
  /** If the event is expected to run all day. When true, begin and end can be safely ignored. */
  allDay: Scalars['Boolean'];
  /** The type of real life event that this entity represents. */
  type: SystemSalesForecastEventType;
};

export enum SystemSalesForecastEventType {
  /** The default DemandForecast event type, used when no other event type is applicable. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** The DemandForecast is affected by a travel disruption. */
  TRAVEL_DISRUPTION = 'TRAVEL_DISRUPTION',
  /** The DemandForecast is affected by a broadcast. */
  BROADCAST = 'BROADCAST',
  /** The DemandForecast is affected by a promotion. */
  PROMOTION = 'PROMOTION',
  /** The DemandForecast is affected by a competitor promotion. */
  COMPETITOR_PROMOTION = 'COMPETITOR_PROMOTION',
}

/** Represents the holiday info that occurs on the forecast day. */
export type SystemSalesForecastHoliday = {
  __typename?: 'SystemSalesForecastHoliday';
  /** The name of holiday that occurs on the forecast date. */
  name: Scalars['String'];
};

/** The type of SystemSalesForecastSource. */
export enum SystemSalesForecastSource {
  /** The forecast data came from Stint scheduling and is based off data such as bookings, local holidays and events. */
  STINT = 'STINT',
  /** The forecast data was manual user input from an external system. */
  MANAGER = 'MANAGER',
  /** The attributes are derived from actual demand data rather than a forecast. */
  ACTUAL = 'ACTUAL',
}

/** Represents the weather info on the forecast day. */
export type SystemSalesForecastWeather = {
  __typename?: 'SystemSalesForecastWeather';
  /** Summary status of the overall weather for the day. */
  daySummary: SystemSalesForecastWeatherStatus;
  /** The average temperature for the day (relative to the time of the forecast).Is null when no weather data is available for the forecast day. */
  averageTemperature?: Maybe<Scalars['Float']>;
  /** The minimum temperature for the day (relative to the time of the forecast).Is null when no weather data is available for the forecast day. */
  minimumTemperature?: Maybe<Scalars['Float']>;
  /** The maximum temperature for the day (relative to the time of the forecast).Is null when no weather data is available for the forecast day. */
  maximumTemperature?: Maybe<Scalars['Float']>;
};

/** Enum that contains the weather statuses. */
export enum SystemSalesForecastWeatherStatus {
  UNSPECIFIED = 'UNSPECIFIED',
  SUNNY = 'SUNNY',
  SUNNY_INTERVALS = 'SUNNY_INTERVALS',
  MIST = 'MIST',
  FOG = 'FOG',
  CLOUDY = 'CLOUDY',
  OVERCAST = 'OVERCAST',
  LIGHT_RAIN_SHOWER = 'LIGHT_RAIN_SHOWER',
  DRIZZLE = 'DRIZZLE',
  LIGHT_RAIN = 'LIGHT_RAIN',
  HEAVY_RAIN_SHOWER = 'HEAVY_RAIN_SHOWER',
  HEAVY_RAIN = 'HEAVY_RAIN',
  SLEET_SHOWER = 'SLEET_SHOWER',
  SLEET = 'SLEET',
  HAIL_SHOWER = 'HAIL_SHOWER',
  HAIL = 'HAIL',
  LIGHT_SNOW_SHOWER = 'LIGHT_SNOW_SHOWER',
  LIGHT_SNOW = 'LIGHT_SNOW',
  HEAVY_SNOW_SHOWER = 'HEAVY_SNOW_SHOWER',
  HEAVY_SNOW = 'HEAVY_SNOW',
  THUNDER_SHOWER = 'THUNDER_SHOWER',
  THUNDER = 'THUNDER',
}

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** Id of related TagGroup (auto-generated). */
  group_id?: Maybe<Scalars['UUID']>;
};

export type TagFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** group_id */
  group_id?: Maybe<Scalars['UUID']>;
  /** group_id_isnull */
  group_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** description_search */
  description_search?: Maybe<Scalars['String']>;
  /** description_gte */
  description_gte?: Maybe<Scalars['String']>;
  /** description_lte */
  description_lte?: Maybe<Scalars['String']>;
  /** description_istartswith */
  description_istartswith?: Maybe<Scalars['String']>;
  /** description_lt */
  description_lt?: Maybe<Scalars['String']>;
  /** description_gt */
  description_gt?: Maybe<Scalars['String']>;
  /** description_isnull */
  description_isnull?: Maybe<Scalars['Boolean']>;
  /** description_iendswith */
  description_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  description_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TaskTopTipInput = {
  /** The name of the area. */
  name: Scalars['String'];
  /** The UUID of top tip. */
  id?: Maybe<Scalars['UUID']>;
};

/** Represents the start and end times of a DemandForecastUpdate which has been applied to a portion of a day. If TimeRange is not null, both start and end times must be set. */
export type TimeRange = {
  __typename?: 'TimeRange';
  /** The start time of an interval. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The end time of an interval. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
};

/** The input values required from a client if applying the DemandForecastUpdate to a portion of a day. If TimeRangeInput is not null, both start and end times must be set. */
export type TimeRangeInput = {
  /** The start time of an interval. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  startTime: Scalars['DateTime'];
  /** The end time of an interval. This is a timezone aware DateTime that represents the time in the Site's timezone converted to UTC. */
  endTime: Scalars['DateTime'];
};

/** The titles available for a PartnerMemberProfile. Used to determine the title of the member. */
export enum Title {
  /** The PartnerMemberProfile is a Mr. */
  MR = 'MR',
  /** The PartnerMemberProfile is a Mrs. */
  MRS = 'MRS',
  /** The PartnerMemberProfile is a Ms. */
  MS = 'MS',
  /** The PartnerMemberProfile is a Miss. */
  MISS = 'MISS',
  /** The PartnerMemberProfile is a non-binary title. */
  OTHER = 'OTHER',
}

export type TopTip = {
  __typename?: 'TopTip';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  /** Task that top tip is associated with. */
  task?: Maybe<StintTask>;
  name: Scalars['String'];
  isDefault: Scalars['Boolean'];
  /** Business that top tip is associated with. */
  business?: Maybe<Business>;
  /** Task id that top tip is associated with. */
  task_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessRole (auto-generated). */
  role_id?: Maybe<Scalars['UUID']>;
  /** Id of related BusinessCategory (auto-generated). */
  business_category_id?: Maybe<Scalars['UUID']>;
};

export type TopTipFilter = {
  name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** role_id */
  role_id?: Maybe<Scalars['UUID']>;
  /** role_id_isnull */
  role_id_isnull?: Maybe<Scalars['Boolean']>;
  /** task_id */
  task_id?: Maybe<Scalars['UUID']>;
  /** task_id_isnull */
  task_id_isnull?: Maybe<Scalars['Boolean']>;
  /** businessCategory_id */
  businessCategory_id?: Maybe<Scalars['UUID']>;
  /** businessCategory_id_isnull */
  businessCategory_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  /** isDefault_gte */
  isDefault_gte?: Maybe<Scalars['Boolean']>;
  /** isDefault_lte */
  isDefault_lte?: Maybe<Scalars['Boolean']>;
  /** isDefault_istartswith */
  isDefault_istartswith?: Maybe<Scalars['Boolean']>;
  /** isDefault_lt */
  isDefault_lt?: Maybe<Scalars['Boolean']>;
  /** isDefault_gt */
  isDefault_gt?: Maybe<Scalars['Boolean']>;
  /** isDefault_isnull */
  isDefault_isnull?: Maybe<Scalars['Boolean']>;
  /** isDefault_iendswith */
  isDefault_iendswith?: Maybe<Scalars['Boolean']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  isDefault_in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

/**
 * The TopTipInput class defines the Graphene ObjectType class used to set the related TopTip objects
 * on a StintTemplate or Stint.
 *
 * It provides the means to get or create TopTip data while creating or updating a StintTemplate or updating a
 * Stint.
 */
export type TopTipInput = {
  /** The name of the TopTip. Used to create if no ID is provided. */
  name: Scalars['String'];
  /** The ID of the TopTip if it already exists. If null then a TopTip will be created. */
  id?: Maybe<Scalars['UUID']>;
};

/** Represents a reason for approving a Trial Stinter from a Pool. */
export type TrialMemberApprovedReason = {
  __typename?: 'TrialMemberApprovedReason';
  id: Scalars['UUID'];
  /** The name of the approval reason displayed to users when confirming the Trial Stinter to a Pool. */
  name: Scalars['String'];
  /** Additional context for why the Trial Stinter was approved for a Pool. */
  description?: Maybe<Scalars['String']>;
  /** Whether the approval reason can be selected by users when approving the Trial Stinter for a Pool. */
  isVisible: Scalars['Boolean'];
};

/** The input values required to trigger the AutoScheduler BI service. */
export type TriggerAutoschedulerInput = {
  /** The ID of the Site that the SiteSchedule is for which the schedule should be generated. */
  siteId: Scalars['UUID'];
  /** The week commencing date for the SiteSchedule. Required if the SiteSchedule does not exist. */
  weekCommencing: Scalars['Date'];
  /** The ID of the SiteSchedule if it exists for which to trigger the auto-scheduler. */
  siteScheduleId?: Maybe<Scalars['UUID']>;
  /** A list of PartnerMemberOverrideInput objects that represent the partner member overrides used when generating the SiteSchedule. Each override provides adjustments to the default values for the partner members. */
  partnerMemberOverrides: Array<PartnerMemberOverrideInput>;
  /** The last modified at timestamp of the SiteSchedule if it exists used to determine if the schedule has been updated since the schedule was loaded to prevent the auto-scheduler from being triggered if the schedule is out of date. */
  lastModifiedAt?: Maybe<Scalars['String']>;
};

/** The input values required to trigger the AutoScheduler (v2).  */
export type TriggerAutoschedulerV2Input = {
  /** The ID of the Site to generate the SiteSchedule for. */
  siteId: Scalars['UUID'];
  /** The week commencing date for the SiteSchedule. */
  weekCommencing: Scalars['Date'];
  /** The ID of the SiteSchedule if it exists for which to trigger the auto-scheduler. */
  siteScheduleId?: Maybe<Scalars['UUID']>;
  /** The last modified at timestamp of the SiteSchedule if it exists used to determine if the schedule has been updated since the schedule was loaded to prevent the auto-scheduler from being triggered if the schedule is out of date. */
  lastModifiedAt?: Maybe<Scalars['String']>;
  /** When set, applies a bulk acceptance action to headcount opportunities before the auto-scheduler runs. Absent means no bulk action is applied. */
  opportunitiesAccepted?: Maybe<OpportunitiesAccepted>;
};

/** The result of triggering the AutoScheduler (v2). */
export type TriggerAutoschedulerV2Output = {
  __typename?: 'TriggerAutoschedulerV2Output';
  /** The SiteSchedule after the AutoScheduler run. */
  siteSchedule: SiteSchedule;
};

/** Input for un-approving a site schedule. */
export type UnapproveSiteScheduleInput = {
  /** The ID of the Site the SiteSchedule belongs to. */
  siteId: Scalars['UUID'];
  /** The week commencing date for the SiteSchedule. Must match the partner's configured scheduleWeekStartDay and be strictly in the future. */
  weekCommencing: Scalars['Date'];
};

/** Output for un-approving a site schedule. */
export type UnapproveSiteScheduleOutput = {
  __typename?: 'UnapproveSiteScheduleOutput';
  /** Whether the operation was successful. */
  success: Scalars['Boolean'];
};

/**
 * The PartnerPoolInviteType class defines the Graphene input values used to resolve a filtered and ordered list
 * of University objects.
 */
export type UniversitiesInput = {
  /**
   * Allow specifying the order of the results.
   * If not specified, the results will be ordered by name ascending.
   */
  orderBy?: Maybe<UniversityOrderInput>;
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filter?: Maybe<UniversityFilterInput>;
};

/**
 * The UniversityType class defines the Graphene ObjectType class used to resolve the University model data for
 * GraphQL queries.
 */
export type University = Node & {
  __typename?: 'University';
  /** The ID (ref) of the University. */
  id: Scalars['UUID'];
  /** The name of the University. */
  name: Scalars['String'];
  /** The logo url of the University. */
  logo?: Maybe<Scalars['ImageField']>;
  /** Deprecated: The domain of the University. */
  domain: Scalars['String'];
};

export type UniversityFilter = {
  name?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  idIcontains?: Maybe<Scalars['String']>;
  /** city_id */
  city_id?: Maybe<Scalars['UUID']>;
  /** city_id_isnull */
  city_id_isnull?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gte */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  /** createdAt_lte */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** createdAt_istartswith */
  createdAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** createdAt_lt */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** createdAt_gt */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** createdAt_isnull */
  createdAt_isnull?: Maybe<Scalars['Boolean']>;
  /** createdAt_iendswith */
  createdAt_iendswith?: Maybe<Scalars['DateTime']>;
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gte */
  modifiedAt_gte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lte */
  modifiedAt_lte?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_istartswith */
  modifiedAt_istartswith?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_lt */
  modifiedAt_lt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_gt */
  modifiedAt_gt?: Maybe<Scalars['DateTime']>;
  /** modifiedAt_isnull */
  modifiedAt_isnull?: Maybe<Scalars['Boolean']>;
  /** modifiedAt_iendswith */
  modifiedAt_iendswith?: Maybe<Scalars['DateTime']>;
  /** name_search */
  name_search?: Maybe<Scalars['String']>;
  /** name_gte */
  name_gte?: Maybe<Scalars['String']>;
  /** name_lte */
  name_lte?: Maybe<Scalars['String']>;
  /** name_istartswith */
  name_istartswith?: Maybe<Scalars['String']>;
  /** name_lt */
  name_lt?: Maybe<Scalars['String']>;
  /** name_gt */
  name_gt?: Maybe<Scalars['String']>;
  /** name_isnull */
  name_isnull?: Maybe<Scalars['Boolean']>;
  /** name_iendswith */
  name_iendswith?: Maybe<Scalars['String']>;
  /** domain_search */
  domain_search?: Maybe<Scalars['String']>;
  /** domain_gte */
  domain_gte?: Maybe<Scalars['String']>;
  /** domain_lte */
  domain_lte?: Maybe<Scalars['String']>;
  /** domain_istartswith */
  domain_istartswith?: Maybe<Scalars['String']>;
  /** domain_lt */
  domain_lt?: Maybe<Scalars['String']>;
  /** domain_gt */
  domain_gt?: Maybe<Scalars['String']>;
  /** domain_isnull */
  domain_isnull?: Maybe<Scalars['Boolean']>;
  /** domain_iendswith */
  domain_iendswith?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  /** group_search */
  group_search?: Maybe<Scalars['String']>;
  /** group_gte */
  group_gte?: Maybe<Scalars['String']>;
  /** group_lte */
  group_lte?: Maybe<Scalars['String']>;
  /** group_istartswith */
  group_istartswith?: Maybe<Scalars['String']>;
  /** group_lt */
  group_lt?: Maybe<Scalars['String']>;
  /** group_gt */
  group_gt?: Maybe<Scalars['String']>;
  /** group_isnull */
  group_isnull?: Maybe<Scalars['Boolean']>;
  /** group_iendswith */
  group_iendswith?: Maybe<Scalars['String']>;
  firebaseRef?: Maybe<Scalars['String']>;
  /** firebaseRef_search */
  firebaseRef_search?: Maybe<Scalars['String']>;
  /** firebaseRef_gte */
  firebaseRef_gte?: Maybe<Scalars['String']>;
  /** firebaseRef_lte */
  firebaseRef_lte?: Maybe<Scalars['String']>;
  /** firebaseRef_istartswith */
  firebaseRef_istartswith?: Maybe<Scalars['String']>;
  /** firebaseRef_lt */
  firebaseRef_lt?: Maybe<Scalars['String']>;
  /** firebaseRef_gt */
  firebaseRef_gt?: Maybe<Scalars['String']>;
  /** firebaseRef_isnull */
  firebaseRef_isnull?: Maybe<Scalars['Boolean']>;
  /** firebaseRef_iendswith */
  firebaseRef_iendswith?: Maybe<Scalars['String']>;
  imageOneX?: Maybe<Scalars['String']>;
  /** imageOneX_search */
  imageOneX_search?: Maybe<Scalars['String']>;
  /** imageOneX_gte */
  imageOneX_gte?: Maybe<Scalars['String']>;
  /** imageOneX_lte */
  imageOneX_lte?: Maybe<Scalars['String']>;
  /** imageOneX_istartswith */
  imageOneX_istartswith?: Maybe<Scalars['String']>;
  /** imageOneX_lt */
  imageOneX_lt?: Maybe<Scalars['String']>;
  /** imageOneX_gt */
  imageOneX_gt?: Maybe<Scalars['String']>;
  /** imageOneX_isnull */
  imageOneX_isnull?: Maybe<Scalars['Boolean']>;
  /** imageOneX_iendswith */
  imageOneX_iendswith?: Maybe<Scalars['String']>;
  imageTwoX?: Maybe<Scalars['String']>;
  /** imageTwoX_search */
  imageTwoX_search?: Maybe<Scalars['String']>;
  /** imageTwoX_gte */
  imageTwoX_gte?: Maybe<Scalars['String']>;
  /** imageTwoX_lte */
  imageTwoX_lte?: Maybe<Scalars['String']>;
  /** imageTwoX_istartswith */
  imageTwoX_istartswith?: Maybe<Scalars['String']>;
  /** imageTwoX_lt */
  imageTwoX_lt?: Maybe<Scalars['String']>;
  /** imageTwoX_gt */
  imageTwoX_gt?: Maybe<Scalars['String']>;
  /** imageTwoX_isnull */
  imageTwoX_isnull?: Maybe<Scalars['Boolean']>;
  /** imageTwoX_iendswith */
  imageTwoX_iendswith?: Maybe<Scalars['String']>;
  imageThreeX?: Maybe<Scalars['String']>;
  /** imageThreeX_search */
  imageThreeX_search?: Maybe<Scalars['String']>;
  /** imageThreeX_gte */
  imageThreeX_gte?: Maybe<Scalars['String']>;
  /** imageThreeX_lte */
  imageThreeX_lte?: Maybe<Scalars['String']>;
  /** imageThreeX_istartswith */
  imageThreeX_istartswith?: Maybe<Scalars['String']>;
  /** imageThreeX_lt */
  imageThreeX_lt?: Maybe<Scalars['String']>;
  /** imageThreeX_gt */
  imageThreeX_gt?: Maybe<Scalars['String']>;
  /** imageThreeX_isnull */
  imageThreeX_isnull?: Maybe<Scalars['Boolean']>;
  /** imageThreeX_iendswith */
  imageThreeX_iendswith?: Maybe<Scalars['String']>;
  /** Multiple values may be separated by commas. */
  ids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Multiple values may be separated by commas. */
  createdAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  modifiedAt_in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  /** Multiple values may be separated by commas. */
  name_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  domain_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  group_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  firebaseRef_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  imageOneX_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  imageTwoX_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Multiple values may be separated by commas. */
  imageThreeX_in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * The UniversityFilterInput class defines the Graphene input values used to provide the requested filter
 * values from the client for a list of University objects.
 */
export type UniversityFilterInput = {
  /**
   * Limit results to only the one that has the ID of the specified University.
   * This can be used to quickly retrieve a single University.
   * If omitted, then all results will be returned.
   */
  id?: Maybe<Scalars['UUID']>;
  /**
   * Limit results to only those that fuzzy match the name.
   * If omitted, then all results will be returned.
   */
  name?: Maybe<Scalars['String']>;
};

/** Enum that contains the allowed field values that can be used to order a QuerySet of University objects. */
export enum UniversityOrderField {
  NAME = 'NAME',
}

/**
 * The UniversityOrderInput class defines the Graphene input values used to provide the requested order by
 * values from the client for a list of University objects.
 *
 * It contains the allowed fields to order by and the ascending or descending order that is requested.
 */
export type UniversityOrderInput = {
  /** The field to order the list of University objects by. */
  field: UniversityOrderField;
  /** The requested order to be used when ordering the list of University objects. */
  order: SortOrder;
};

export type UniversityTypeConnection = {
  __typename?: 'UniversityTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  edges: Array<UniversityTypeEdge>;
};

export type UniversityTypeEdge = {
  __typename?: 'UniversityTypeEdge';
  /** The item at the end of the edge */
  node: University;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** The upcoming shift metrics for a partner member profile within a date range. */
export type UpcomingShiftMetrics = {
  __typename?: 'UpcomingShiftMetrics';
  /** The total number of upcoming shifts in the date range. */
  shiftCount: Scalars['Int'];
  /** The total number of unique days with scheduled shifts in the date range. */
  scheduledDays: Scalars['Int'];
  /** The total number of scheduled hours in the date range. */
  scheduledHours: Scalars['Decimal'];
};

/** Allows filtering of dates when requesting upcoming shift metrics. */
export type UpcomingShiftMetricsInput = {
  /** Only upcoming shifts with a start date greater than or equal to this date will be returned.  */
  startDateFrom: Scalars['Date'];
  /** Only upcoming shifts with a start date less than or equal to this date will be returned. */
  startDateTo: Scalars['Date'];
};

/**
 * The UpdateAccountNodeInput class defines the input values that are required from the client in order to update a
 * NodeType.ACCOUNT PartnerNode object.
 */
export type UpdateAccountNodeInput = {
  /** The ID of the NodeType.ACCOUNT PartnerNode object to update. */
  id: Scalars['UUID'];
  /** The name of the NodeType.ACCOUNT PartnerNode. */
  name: Scalars['String'];
  /** The CompaniesHouseInformation input values to be used to update the related CompaniesHouseInformation object. Please be aware that providing no input or using a null value will result in no action or change. */
  companiesHouseInformation?: Maybe<CompaniesHouseInformationInput>;
};

/**
 * The UpdateActualLeaveTimeInput class defines the input values that are required from
 * the client in order for a Staff user to update the actual leave time of a Stint object.
 */
export type UpdateActualLeaveTimeInput = {
  /** ID (ref) of the Stint object to update. */
  id: Scalars['UUID'];
  /** The actual leave datetime value for the Stint. */
  actualLeaveTime: Scalars['DateTime'];
};

/**
 * The UpdateAgreementInput class defines the input values that are required from the client in order to update an
 * Agreement object.
 */
export type UpdateAgreementInput = {
  /** The ID of the Agreement object to be updated. */
  id: Scalars['UUID'];
  /** The ID of the primary PartnerNode that the Agreement belongs to. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** Boolean to dictate whether or not to surface this Agreement to the relevant parties. */
  enabled: Scalars['Boolean'];
};

/** Input for updating a break rule. */
export type UpdateBreakRuleInput = {
  /** The ID of the break rule to update. */
  id: Scalars['UUID'];
  /** Whether this rule applies to young workers (under 18) rather than adults. */
  isYoungWorker: Scalars['Boolean'];
  /** The minimum shift duration, in minutes, at which the rule applies. Must be >= 0. */
  minimumShiftDurationMinutes: Scalars['Int'];
  /** The minimum break duration, in minutes, required for matching shifts. */
  minimumBreakDurationMinutes: Scalars['Int'];
};

/** Output for updating a break rule. */
export type UpdateBreakRuleOutput = {
  __typename?: 'UpdateBreakRuleOutput';
  /** The updated break rule. */
  breakRule: BreakRule;
};

/**
 * The UpdateCompaniesHouseInformationInput class defines the input values that are required from
 * the client in order to update a CompaniesHouseInformation object.
 */
export type UpdateCompaniesHouseInformationInput = {
  /** ID of the CompaniesHouseInformation object to update. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the CompaniesHouseInformation belongs to. Used to determine if the user has the required permission to update the CompaniesHouseInformation. */
  partnerNodeId: Scalars['UUID'];
  /** The Companies House number. */
  number: Scalars['String'];
  /** The address registered with Companies House. */
  address: Scalars['String'];
  /** The name registered with Companies House. */
  name: Scalars['String'];
};

/** Input for updateDemandForecastHeadcount. Same validation rules as CreateDemandForecastHeadcountInput. Returns an error if the entry with the given ID is not found. */
export type UpdateDemandForecastHeadcountInput = {
  /** Site the demand forecast belongs to. */
  siteId: Scalars['UUID'];
  /** Date of the demand forecast being modified. */
  forecastDate: Scalars['Date'];
  /** ID of the headcount entry to update. Returns an error if the entry is not found. */
  id: Scalars['UUID'];
  /** True for a Stint-staffed headcount; false for a partner-staffed headcount. */
  isStint: Scalars['Boolean'];
  /** Scheduled start time. Must be before endTime. */
  startTime: Scalars['DateTime'];
  /** Scheduled end time. Must be after startTime. */
  endTime: Scalars['DateTime'];
  /** Role configuration for partner-staffed headcounts. Must be null when isStint is true. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** Optional display name. Must not exceed the short char field maximum length. */
  name?: Maybe<Scalars['String']>;
  /** Non-service type. Null for service headcounts. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** Optional partner member profile for non-service headcounts only. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** Optional reference to the recurring shift template this headcount was generated from. Must be null when isStint is true. If provided, must reference a template belonging to this site. */
  recurringShiftTemplateId?: Maybe<Scalars['UUID']>;
};

/** Response for updateDemandForecastHeadcount. Returns the full updated headcount list so the client can refresh the shape of day graph. */
export type UpdateDemandForecastHeadcountOutput = {
  __typename?: 'UpdateDemandForecastHeadcountOutput';
  /** Full current list of headcounts for the forecast day after the update operation. */
  headcounts: Array<Headcount>;
};

/** The input values required from a client to update a DemandForecast. */
export type UpdateDemandForecastInput = {
  /** The ID of the Site to update the DemandForecast for. */
  siteId: Scalars['UUID'];
  /** The date of the forecast being updated. */
  forecastDate: Scalars['Date'];
  /** The original forecast value before any updates. */
  expectedForecast: Scalars['Int'];
  /** The list of all updates set by users. */
  updates: Array<DemandForecastUpdateInput>;
  /** The last modified at timestamp of the DemandForecast used to determine if the forecast has been updated since it was loaded to prevent it from being updated if it is out of date. */
  lastModifiedAt: Scalars['String'];
  /** The ID of the SiteSchedule for the week if it exists. Used to determine if the schedule has been updated since the forecast was loaded to prevent data from being updated if the schedule is out of date. */
  siteScheduleId?: Maybe<Scalars['UUID']>;
  /** The last modified at timestamp of the SiteSchedule if it exists. Used to determine if the schedule has been updated since it was loaded to prevent it from being updated if it is out of date. */
  siteScheduleLastModifiedAt?: Maybe<Scalars['String']>;
};

/** Output for updating a DemandForecast. */
export type UpdateDemandForecastOutput = {
  __typename?: 'UpdateDemandForecastOutput';
  /** The updated DemandForecast. */
  demandForecast: DemandForecast;
};

/** The input values required from a client to update a DemandForecast's recommended forecast. */
export type UpdateDemandForecastRecommendedInput = {
  /** The ID of the Site to update the DemandForecast recommended forecast for. */
  siteId: Scalars['UUID'];
  /** The date of the forecast being updated. */
  forecastDate: Scalars['Date'];
  /** The ID of the system sales forecast to update the DemandForecast with. This is required to ensure the user is updating to the expected SystemSalesForecast. */
  systemSalesForecastId: Scalars['UUID'];
  /** Whether to keep the adjustments already on the DemandForecast. If false, all previous updates will be deleted. */
  retainAdjustments: Scalars['Boolean'];
  /** The string date and time the DemandForecast was last modified. */
  modifiedAt: Scalars['String'];
};

/** Deprecated: To be replaced by new mutations - createDemandForecastHeadcount, updateDemandForecastHeadcount, deleteDemandForecastHeadcount. (See sc-87939) */
export type UpdateDemandForecastShiftsInput = {
  /** The ID of the Site to update the DemandForecast Shifts for. */
  siteId: Scalars['UUID'];
  /** The date of the forecast being updated. */
  forecastDate: Scalars['Date'];
  /** The reason for the updating the DemandForecast's Shifts. */
  reason?: Maybe<UpdateDemandForecastShiftsReasonInput>;
  /** The updated Shifts for the DemandForecast. */
  shifts: Array<ShiftInput>;
  /** The string date and time the DemandForecast was last modified. */
  modifiedAt: Scalars['String'];
};

/** The input reason values required from a client to update a DemandForecast's Shifts. */
export type UpdateDemandForecastShiftsReasonInput = {
  /** The selected reasons for the updating the DemandForecast's Shifts. */
  selectedReasons: Array<DemandForecastShiftsUpdateReason>;
  /** An explanation for the selected reasons for the updating the DemandForecast's Shifts. */
  explanation?: Maybe<Scalars['String']>;
};

/** The input values required to update an absence request for an employee. */
export type UpdateEmployeeAbsenceRequestInput = {
  /** The ID of the absence to update. */
  absenceId: Scalars['UUID'];
  /** The partner member profile ID of the member that the absence is for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The start date of the absence to be updated. */
  startDate: Scalars['Date'];
  /** The end date of the absence to be updated. */
  endDate: Scalars['Date'];
  /** The type of absence to be updated. */
  type: CoreTeamAbsenceType;
  /** Optional note about the absence to be updated. */
  note?: Maybe<Scalars['String']>;
  /** The number of effective days for this absence to be updated. */
  effectiveDays?: Maybe<Scalars['Decimal']>;
  /** The number of effective hours for this absence to be updated. */
  effectiveHours?: Maybe<Scalars['Decimal']>;
  /** Optional IDs of supporting documents to add to this absence request, alongside any already attached. */
  supportingDocumentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

/** The output values from updating an absence record. */
export type UpdateEmployeeAbsenceRequestOutput = {
  __typename?: 'UpdateEmployeeAbsenceRequestOutput';
  /** The updated absence. */
  absence: CoreTeamMemberAbsence;
};

/** The input values required to update the contact details of an employee. */
export type UpdateEmployeeContactDetailsInput = {
  /** The ID of the PartnerMemberProfile to update. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The updated phone number of the employee. Phone number is not a required field in the PartnerMemberProfile model and this is therefore optional. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The updated email address of the employee. This is optional to remain backward compatible. Email is a required field in the PartnerMemberProfile model and if one is not provided here no update will be made to the current email. */
  email?: Maybe<Scalars['String']>;
};

/** The output values from updating an employee's contact details */
export type UpdateEmployeeContactDetailsOutput = {
  __typename?: 'UpdateEmployeeContactDetailsOutput';
  /** If the contact details were updated successfully. */
  success: Scalars['Boolean'];
};

/** The input values required from a client to update an employee document. */
export type UpdateEmployeeDocumentInput = {
  /** The ID of the PartnerMemberProfile for the employee. */
  profileId: Scalars['UUID'];
  /** The ID of the EmployeeDocument that is being updated. */
  employeeDocumentId: Scalars['UUID'];
  /** The updated display name of the employee document. */
  name: Scalars['String'];
  /** The updated category of the employee document. */
  category: EmployeeDocumentCategory;
  /** Whether the employee document is visible to the employee. */
  isVisibleToEmployee?: Maybe<Scalars['Boolean']>;
  /** Whether the employee document is visible only to managers. */
  visibleOnlyToManagers?: Maybe<Scalars['Boolean']>;
};

/** The output values returned to the client from the UpdateEmployeeDocument mutation. */
export type UpdateEmployeeDocumentOutput = {
  __typename?: 'UpdateEmployeeDocumentOutput';
  /** The updated employee document. */
  employeeDocument: EmployeeDocument;
};

/** The input values required to update the isEmployee flag on a PartnerMemberProfile. */
export type UpdateEmployeeFlagInput = {
  /** The ID of the PartnerMemberProfile whose isEmployee flag is being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** Sets the employee flag on the PartnerMemberProfile to the given value. */
  isEmployee: Scalars['Boolean'];
};

/** The output values returned to the client from the UpdateEmployeeFlag mutation. */
export type UpdateEmployeeFlagOutput = {
  __typename?: 'UpdateEmployeeFlagOutput';
  /** Indicates whether the isEmployee flag was successfully updated. */
  success: Scalars['Boolean'];
};

/** The input values for updating an employee's holiday policy. */
export type UpdateEmployeeHolidayPolicyInput = {
  /** The partner member profile ID of the employee. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The current holiday policy ID of the employee. */
  currentHolidayPolicyId: Scalars['UUID'];
  /** The new holiday policy ID to associate with the employee. */
  newHolidayPolicyId: Scalars['UUID'];
  /** The number of hours per day the employee works. */
  hoursPerDay: Scalars['Decimal'];
  /** The number of days per week the employee works. */
  daysPerWeek: Scalars['Decimal'];
  /** The date from which the employee is on the new holiday policy. */
  onPolicyFrom: Scalars['Date'];
};

/** The output values from updating an employee's holiday policy. */
export type UpdateEmployeeHolidayPolicyOutput = {
  __typename?: 'UpdateEmployeeHolidayPolicyOutput';
  /** The holiday information for the PartnerMemberProfile. */
  holidayInfo: CoreTeamMemberHolidayInfo;
};

/** The input values required to update the holiday request. */
export type UpdateEmployeeHolidayRequestInput = {
  /** The ID of the holiday request to update. */
  holidayRequestId: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile the holiday request belongs to. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The week breakdown of the holiday's effective days. */
  weekBreakdown: Array<HolidayRequestWeekBreakdownInput>;
};

/** The output values from updating a holiday request. */
export type UpdateEmployeeHolidayRequestOutput = {
  __typename?: 'UpdateEmployeeHolidayRequestOutput';
  /** Core team member holiday information. */
  holidayInfo: CoreTeamMemberHolidayInfo;
};

/** Input for updating employee information. */
export type UpdateEmployeeInfoInput = {
  /** The ID of the partner member profile (the employee at the partner) that is being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The optional title of the employee. */
  title?: Maybe<Title>;
  /** The full name of the employee. */
  fullname?: Maybe<Scalars['String']>;
  /** The given name of the employee. */
  givenName?: Maybe<Scalars['String']>;
  /** The middle names of the employee. */
  middleNames?: Maybe<Scalars['String']>;
  /** The family name of the employee. */
  familyName?: Maybe<Scalars['String']>;
  /** The optional name that the employee prefers to go by. */
  preferredName?: Maybe<Scalars['String']>;
  /** The optional pronoun that the employee uses. */
  pronoun?: Maybe<Pronoun>;
  /** The date of birth of the employee. */
  dateOfBirth: Scalars['Date'];
  /** The optional gender of the employee. */
  gender?: Maybe<Gender>;
  /** The legal status of the employee. It is required that the client provides a value. This field will remain nullable, because it will be quickly deprecated and removed. */
  legalStatus?: Maybe<LegalStatus>;
};

/** Output for updating employee information. */
export type UpdateEmployeeInfoOutput = {
  __typename?: 'UpdateEmployeeInfoOutput';
  /** Indicates whether the employee information was successfully updated. */
  success: Scalars['Boolean'];
};

/** The input values required to update the minimum weekly hours for an employee at a site. */
export type UpdateEmployeeMinHoursInput = {
  /** The site for which the minimum hours value is being set. */
  siteId: Scalars['UUID'];
  /** The employee site scheduling configuration record being updated. */
  employeeSiteSchedulingConfigurationId: Scalars['UUID'];
  /** Minimum weekly hours floor to store. Must be > 0 and <= 168 (max hours in a week) if provided. Pass null to clear the value. */
  minHours?: Maybe<Scalars['Decimal']>;
};

/** The output values available to the client after updating the minimum weekly hours for an employee at a site. */
export type UpdateEmployeeMinHoursOutput = {
  __typename?: 'UpdateEmployeeMinHoursOutput';
  /** The updated scheduling configuration record for this employee at this site. */
  schedulingConfiguration: EmployeeSiteSchedulingConfigurationType;
};

/** The input values required to update an employee's notification settings. */
export type UpdateEmployeeNotificationSettingsInput = {
  /** The ID of the PartnerMemberProfile whose notification settings are being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** Whether to enable notifications for site schedules and shifts. */
  siteSchedulesAndShiftsEnabled: Scalars['Boolean'];
  /** Whether to enable notifications for holiday requests. */
  holidayRequestsEnabled: Scalars['Boolean'];
};

/** The output values returned after updating an employee's notification settings. */
export type UpdateEmployeeNotificationSettingsOutput = {
  __typename?: 'UpdateEmployeeNotificationSettingsOutput';
  /** The updated notification settings for the employee. */
  settings: EmployeeNotificationSettings;
};

/** The input values required from a client to update an employee's primary site. */
export type UpdateEmployeePrimarySiteInput = {
  /** The ID of the PartnerMemberProfile for the employee. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the primary site to assign to the employee. Can be null to clear the primary site. */
  primarySiteId?: Maybe<Scalars['UUID']>;
};

/** The output values returned to the client from the UpdateEmployeePrimarySite mutation. */
export type UpdateEmployeePrimarySiteOutput = {
  __typename?: 'UpdateEmployeePrimarySiteOutput';
  /** Whether the primary site update was successful. */
  success: Scalars['Boolean'];
};

/** The input values required to update an Employee's secondary roles. */
export type UpdateEmployeeSecondaryRolesInput = {
  /** The ID of the PartnerMemberProfile whose secondary roles are being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** List of role configuration IDs for secondary roles. Only core team roles should have role configuration relationships. */
  secondaryRoleConfigurationIds: Array<Scalars['UUID']>;
};

/** The output values returned after updating an Employee's secondary roles. */
export type UpdateEmployeeSecondaryRolesOutput = {
  __typename?: 'UpdateEmployeeSecondaryRolesOutput';
  /** Indicates whether the secondary roles were successfully updated. */
  success: Scalars['Boolean'];
};

/** The input values required to update the current user's per-site notification settings. */
export type UpdateEmployeeSiteNotificationSettingsInput = {
  /** The ID of the site settings record to update for the employee. */
  id: Scalars['UUID'];
  /** If the employee has opted to receive site schedule and shift notifications for this site. */
  siteSchedulesAndShiftsEnabled: Scalars['Boolean'];
};

/** The output values returned after updating the current user's per-site notification settings. */
export type UpdateEmployeeSiteNotificationSettingsOutput = {
  __typename?: 'UpdateEmployeeSiteNotificationSettingsOutput';
  /** The updated site notification settings. */
  siteNotificationSettings: EmployeeSiteNotificationSettings;
};

/** The input values required to update an Employee working contract. */
export type UpdateEmployeeWorkingContractInput = {
  /** The PartnerMemberProfile ID of the Employee the contract belongs to. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the working contract to update. */
  workingContractId: Scalars['UUID'];
  /** The expected hours per week. Null if it should be derived from contracted_hours. */
  expectedHours?: Maybe<Scalars['Decimal']>;
  /** The ID of the job title for the working contract. */
  jobTitleId: Scalars['UUID'];
  /** The pay rate for the working contract. */
  payRate: Scalars['Decimal'];
  /** The contract type for the working contract. */
  contractType: ContractType;
  /** The constraint type for contracted hours. Null when no contracted hours arrangement is required. */
  contractedHoursConstraint?: Maybe<ContractedHoursConstraint>;
  /** The contracted hours value. Required when a contracted hours constraint is specified. */
  contractedHours?: Maybe<Scalars['Decimal']>;
  /** The contracted days per week. */
  contractedDays?: Maybe<Scalars['Decimal']>;
};

/** The output values returned after updating an Employee working contract. */
export type UpdateEmployeeWorkingContractOutput = {
  __typename?: 'UpdateEmployeeWorkingContractOutput';
  /** The updated Employee working contract. */
  workingContract: EmployeeWorkingContract;
  /** The Employee the contract was updated for. */
  employee: PartnerMemberProfile;
};

/**
 * The UpdateGroupNodeInput class defines the input values that are required from the client in order to update a
 * NodeType.GROUP PartnerNode object.
 */
export type UpdateGroupNodeInput = {
  /** The ID of the NodeType.GROUP PartnerNode object to update. */
  id: Scalars['UUID'];
  /** The name of the NodeType.GROUP PartnerNode. */
  name: Scalars['String'];
};

/** Input values required to update a headcount opportunity's review status */
export type UpdateHeadcountOpportunityReviewStatusInput = {
  /** The ID of the site the opportunity belongs to. */
  siteId: Scalars['UUID'];
  /** The ID of the opportunity to update. */
  opportunityId: Scalars['UUID'];
  /** The new review status. */
  reviewStatus: HeadcountOpportunityStatus;
  /** Required only when the opportunity is being rejected, otherwise must be null. */
  rejectionReason?: Maybe<Scalars['String']>;
  /** Start of the partner-adjusted acceptance window. Must be set together with `modifiedEnd` (both or neither) and only when `reviewStatus` is ACCEPTED, otherwise must be null. The authoritative validation of these semantics lives in the business intelligence service. */
  modifiedStart?: Maybe<Scalars['DateTime']>;
  /** End of the partner-adjusted acceptance window. Must be set together with `modifiedStart` (both or neither) and only when `reviewStatus` is ACCEPTED, otherwise must be null. The authoritative validation of these semantics lives in the business intelligence service. */
  modifiedEnd?: Maybe<Scalars['DateTime']>;
};

/** The output type after updating a headcount opportunity review status. */
export type UpdateHeadcountOpportunityReviewStatusOutput = {
  __typename?: 'UpdateHeadcountOpportunityReviewStatusOutput';
  /** The updated headcount opportunity. */
  opportunity: HeadcountOpportunity;
};

/** Mutation to update the logged in user's profile data on the StintUser. */
export type UpdateMyProfile = {
  __typename?: 'UpdateMyProfile';
  /** The updated user. */
  userProfile?: Maybe<StintUser>;
};

export type UpdateMyProfilePicture = {
  __typename?: 'UpdateMyProfilePicture';
  userProfile?: Maybe<StintUser>;
};

/** The input values required from a client to update a OperationalEvent. */
export type UpdateOperationalEventInput = {
  /** The Site ID of the OperationalEvent that should be updated. */
  siteId: Scalars['UUID'];
  /** The ID of the OperationalEvent that should be updated. */
  id: Scalars['UUID'];
  /** The name of the operational event. */
  name?: Maybe<Scalars['String']>;
  /** The day of the week for the OpearionalEvent being updated. */
  dayOfWeek?: Maybe<WeekDay>;
  /** The start time for the OperationalEvent being updated. */
  startTime?: Maybe<Scalars['Time']>;
  /** The end time for the OperationalEvent being updated. */
  endTime?: Maybe<Scalars['Time']>;
};

/** The input values required for partner employees to update their own working availability. */
export type UpdateOwnWorkingAvailabilityInput = {
  /** The ID of the PartnerMemberProfile for which the working availability is being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the Site for which the working availability is being updated. */
  siteId: Scalars['UUID'];
  /** The working availability to set for the partner employee at the Site. */
  workingAvailability: WorkingAvailabilityInput;
};

/** The output values returned after a partner employee updates their own working availability. */
export type UpdateOwnWorkingAvailabilityOutput = {
  __typename?: 'UpdateOwnWorkingAvailabilityOutput';
  /** The updated working availability for the partner employee. */
  workingAvailability: WorkingAvailabilityType;
};

/** The input values required for partner employees to update their own working preferences. */
export type UpdateOwnWorkingPreferencesInput = {
  /** The ID of the PartnerMemberProfile for which the working preferences are being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the Site for which the working preferences are being updated. */
  siteId: Scalars['UUID'];
  /** The day of the week for which the working preference is being updated. */
  dayOfWeek: WeekDay;
  /** The working preference values to be updated for the provided day. */
  workingPreference: WorkingPreference;
};

/** The output values returned after a partner employee updates their own working preferences. */
export type UpdateOwnWorkingPreferencesOutput = {
  __typename?: 'UpdateOwnWorkingPreferencesOutput';
  /** The updated working preferences for the partner employee. */
  workingPreferences: WorkingPreferences;
};

/** The input values required to update a partner account API token. */
export type UpdatePartnerAccountAPITokenInput = {
  /** The ID of the token to update. */
  tokenId: Scalars['UUID'];
  /** A new human-readable label for the token. */
  name?: Maybe<Scalars['String']>;
  /** The new list of scopes to grant to this token. */
  scopes?: Maybe<Array<PartnerAccountAPITokenScope>>;
};

/** The output values returned from the updatePartnerAccountAPIToken mutation. */
export type UpdatePartnerAccountAPITokenOutput = {
  __typename?: 'UpdatePartnerAccountAPITokenOutput';
  /** The updated token record. */
  token: PartnerAccountAPIToken;
};

/** Input for updating non-service shift types for a partner account. */
export type UpdatePartnerAccountNonServiceShiftTypesInput = {
  /** The ID of the partner account to update non-service shift types for. */
  partnerAccountId: Scalars['UUID'];
  /** The list of non-service shift types to enable for the partner account. */
  nonServiceShiftTypes: Array<NonServiceShiftType>;
};

/** Output for updating non-service shift types for a partner account. */
export type UpdatePartnerAccountNonServiceShiftTypesOutput = {
  __typename?: 'UpdatePartnerAccountNonServiceShiftTypesOutput';
  /** The updated list of non-service shift types enabled for the partner account. */
  nonServiceShiftTypes: Array<NonServiceShiftType>;
};

/** Input for updating partner account settings. */
export type UpdatePartnerAccountSettingsInput = {
  /** The ID of the PartnerAccountSettings to update. */
  id: Scalars['UUID'];
  /** Indicates whether payroll functionality is enabled for this account. */
  payrollEnabled: Scalars['Boolean'];
  /** The labour settings values for a Partner. */
  labourSettings: LabourSettingsInput;
  /** The HR partner account settings values for a Partner. If not provided, no change will be made to the HR partner account settings. */
  hrPartnerAccountSettings?: Maybe<HRPartnerAccountSettingsInput>;
  /** The payment provider configuration settings (optional). If not provided, the payment provider settings will be removed. */
  paymentProviderSettings?: Maybe<PaymentProviderSettingsInput>;
  /** The on-demand pay configuration settings (optional). If not provided, the on-demand pay settings will be removed. */
  onDemandPaySettings?: Maybe<OnDemandPaySettingsInput>;
  /** The right-to-work settings for the partner account. If not provided, the right-to-work settings will be left unchanged. */
  rightToWorkSettings?: Maybe<RightToWorkSettingsInput>;
  /** Whether or not the account has core team management as read only. */
  coreTeamManagementReadOnly: Scalars['Boolean'];
  /** Whether or not the cleaner role is an available role for this partner account. If not provided, the current value is left unchanged. */
  displayCleanerRole?: Maybe<Scalars['Boolean']>;
  /** Enable/disable webhooks feature. If not provided, no change will be made to the setting. */
  webhooksEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether or not the partner account has the performance notes feature enabled.  */
  performanceNotesEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether or not managers outside of an employee's reporting line can view their profile. */
  restrictProfileVisibilityToReports?: Maybe<Scalars['Boolean']>;
  /** Whether managers can view the Employment tab for employees in their management line. */
  managerCanSeeEmploymentTabInformation?: Maybe<Scalars['Boolean']>;
  /** Whether or not the partner account has the employee shift reviews feature enabled. */
  employeeShiftReviewsEnabled?: Maybe<Scalars['Boolean']>;
};

/** Output for updating partner account settings. */
export type UpdatePartnerAccountSettingsOutput = {
  __typename?: 'UpdatePartnerAccountSettingsOutput';
  /** The updated PartnerAccountSettings. */
  partnerAccountSettings: PartnerAccountSettings;
};

/**
 * The UpdatePartnerBrandInput class defines the input values that are required from
 * the client in order to update a PartnerBrand object.
 */
export type UpdatePartnerBrandInput = {
  /** ID of the PartnerBrand object to update. */
  id: Scalars['UUID'];
  /** The ID of the primary PartnerNode that the PartnerBrand belongs to. Used to determine if the user has the required permission to update the PartnerBrand. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** The PartnerBrand logo image base64 value. */
  logoBase64: Scalars['String'];
};

/**
 * The PartnerContactInput class defines the input values that are required from
 * the client in order to update a PartnerContact object.
 */
export type UpdatePartnerContactInput = {
  /** ID of the PartnerContact object to update. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the PartnerContact belongs to. Used to determine if the user has the required permission to update the PartnerContact. */
  partnerNodeId: Scalars['UUID'];
  /** The primary phone number to be used for contacting the PartnerNode. */
  primaryPhoneNumber: Scalars['String'];
  /** An optional list of secondary phone numbers to be used for contacting the PartnerNode. */
  secondaryPhoneNumbers: Array<Scalars['String']>;
  /** An optional list of email addresses to be used for contacting the PartnerNode. */
  emailAddresses: Array<Scalars['String']>;
};

/** The input values required to update a partner department. */
export type UpdatePartnerDepartmentInput = {
  /** The ID of the account the department belongs to. */
  accountId: Scalars['UUID'];
  /** The ID of the department to update. */
  departmentId: Scalars['UUID'];
  /** The updated name of the department. */
  name: Scalars['String'];
};

/** The output values returned after updating a partner department. */
export type UpdatePartnerDepartmentOutput = {
  __typename?: 'UpdatePartnerDepartmentOutput';
  /** The updated partner department. */
  department: PartnerDepartmentType;
};

/** Input values for updating an existing partner integration. */
export type UpdatePartnerIntegrationInput = {
  /** The ID of the integration to update. */
  id: Scalars['UUID'];
  /** The ID of the partner account that owns this integration. */
  accountId: Scalars['UUID'];
  /** New active state. Null leaves it unchanged. */
  active?: Maybe<Scalars['Boolean']>;
  /** New SSO URL. Null leaves it unchanged. */
  ssoUrl?: Maybe<Scalars['String']>;
  /** Provide at most one auth* input to replace the stored auth. All null leaves auth unchanged. */
  authOAuth?: Maybe<PartnerIntegrationAuthOAuthInput>;
  /** Provide at most one auth* input to replace the stored auth. All null leaves auth unchanged. When provided, Stint generates a public/private keypair — the public key is returned on read for installation on the SFTP server; the private key is stored securely and never returned. */
  authSftp?: Maybe<PartnerIntegrationAuthSftpInput>;
  /** Provide at most one auth* input to replace the stored auth. All null leaves auth unchanged. */
  authApiKey?: Maybe<PartnerIntegrationAuthApiKeyInput>;
  /** Provide at most one auth* input to replace the stored auth. All null leaves auth unchanged. */
  authBasic?: Maybe<PartnerIntegrationAuthBasicInput>;
  /** Provide at most one auth* input to replace the stored auth. All null leaves auth unchanged. */
  authPasswordExchange?: Maybe<PartnerIntegrationAuthPasswordExchangeInput>;
};

/** Input values required to update a job title mapping. */
export type UpdatePartnerIntegrationJobTitleMappingInput = {
  /** The partner account that owns the job title mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The job title mapping to update. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the job title. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint job title to map to. Null clears the job title, reverting the mapping to unresolved. */
  jobTitleId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully updating a job title mapping. */
export type UpdatePartnerIntegrationJobTitleMappingOutput = {
  __typename?: 'UpdatePartnerIntegrationJobTitleMappingOutput';
  /** The updated job title mapping. */
  jobTitleMapping: PartnerIntegrationJobTitleMapping;
};

/** Output returned after successfully updating a partner integration. */
export type UpdatePartnerIntegrationOutput = {
  __typename?: 'UpdatePartnerIntegrationOutput';
  /** The updated integration. */
  integration: PartnerIntegration;
};

/** Input values required to update a profile mapping. */
export type UpdatePartnerIntegrationProfileMappingInput = {
  /** The partner account that owns the profile mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The profile mapping to update. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the profile. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint profile to map to. Null clears the profile, reverting the mapping to unresolved. */
  profileId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully updating a profile mapping. */
export type UpdatePartnerIntegrationProfileMappingOutput = {
  __typename?: 'UpdatePartnerIntegrationProfileMappingOutput';
  /** The updated profile mapping. */
  profileMapping: PartnerIntegrationProfileMapping;
};

/** Input values required to update a role mapping. */
export type UpdatePartnerIntegrationRoleMappingInput = {
  /** The partner account that owns the role mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The role mapping to update. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the role. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint role configuration to map to. Null clears the role, reverting the mapping to unresolved. */
  roleId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully updating a role mapping. */
export type UpdatePartnerIntegrationRoleMappingOutput = {
  __typename?: 'UpdatePartnerIntegrationRoleMappingOutput';
  /** The updated role mapping. */
  roleMapping: PartnerIntegrationRoleMapping;
};

/** Input values required to update a site mapping. */
export type UpdatePartnerIntegrationSiteMappingInput = {
  /** The partner account that owns the site mapping. */
  partnerAccountId: Scalars['UUID'];
  /** The site mapping to update. */
  id: Scalars['UUID'];
  /** The identifier the provider uses to identify the site. Must not be empty or whitespace-only. */
  externalId: Scalars['String'];
  /** The Stint site to map to. Null clears the site, reverting the mapping to unresolved. */
  siteId?: Maybe<Scalars['UUID']>;
};

/** Output returned after successfully updating a site mapping. */
export type UpdatePartnerIntegrationSiteMappingOutput = {
  __typename?: 'UpdatePartnerIntegrationSiteMappingOutput';
  /** The updated site mapping. */
  siteMapping: PartnerIntegrationSiteMapping;
};

/** The input values required to update a partner job title. */
export type UpdatePartnerJobTitleInput = {
  /** The ID of the job title to update. */
  jobTitleId: Scalars['UUID'];
  /** The ID of the partner account the job title belongs to. */
  accountId: Scalars['UUID'];
  /** The updated name of the job title. */
  name: Scalars['String'];
  /** Whether the job title should be archived. */
  isArchived: Scalars['Boolean'];
  /** The ID of the department to update the job title under. */
  departmentId?: Maybe<Scalars['UUID']>;
  /** The ID of the job title The ID of the job title to assign as this job title's default manager. */
  managerJobTitleId?: Maybe<Scalars['UUID']>;
};

/** The output values returned after updating a partner job title. */
export type UpdatePartnerJobTitleOutput = {
  __typename?: 'UpdatePartnerJobTitleOutput';
  /** The updated partner job title. */
  jobTitle: PartnerJobTitleType;
};

/** The input values required to update a PartnerMember and related data. */
export type UpdatePartnerMemberInput = {
  /** The ID of the PartnerMember to update. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the user is trying to update the PartnerMember through. Used to check permissions. */
  partnerNodeId: Scalars['UUID'];
  /** The PartnerRole to update for the PartnerMember. */
  role?: Maybe<PartnerRole>;
  /** The ID of the role configuration in the BI service for scheduling purposes. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** The site working preferences to update for the PartnerMember. DEPRECATED: Use UpdatePartnerMemberSiteWorkingPreferences mutation instead. This field will be removed in a future release. */
  siteWorkingPreferences?: Maybe<WorkingPreferencesInput>;
};

/** The input values required to update a PartnerMember's site working availability. */
export type UpdatePartnerMemberSiteWorkingAvailabilityInput = {
  /** The ID of the Site that the user is trying to update the working availability through. Used to check permissions. */
  siteId: Scalars['UUID'];
  /** The ID of the PartnerMember whose working availability is being updated. */
  partnerMemberId: Scalars['UUID'];
  /** The working availability to set for the PartnerMember at the Site. */
  workingAvailability: WorkingAvailabilityInput;
};

/** Output for updating a PartnerMember's site working availability. */
export type UpdatePartnerMemberSiteWorkingAvailabilityOutput = {
  __typename?: 'UpdatePartnerMemberSiteWorkingAvailabilityOutput';
  /** The updated working availability for the site. */
  workingAvailability: WorkingAvailabilityType;
};

/** The input values required to update a PartnerMember's site working preferences. */
export type UpdatePartnerMemberSiteWorkingPreferencesInput = {
  /** The ID of the Site that the user is trying to update the working preferences through. Used to check permissions. */
  siteId: Scalars['UUID'];
  /** The ID of the PartnerMember whose working preferences are being updated. */
  partnerMemberId: Scalars['UUID'];
  /** The working preferences to set for the PartnerMember at the Site. */
  siteWorkingPreferences: WorkingPreferencesInput;
};

/** Output for updating a PartnerMember's site working preferences. */
export type UpdatePartnerMemberSiteWorkingPreferencesOutput = {
  __typename?: 'UpdatePartnerMemberSiteWorkingPreferencesOutput';
  /** The updated working preferences for the site. */
  workingPreferences: WorkingPreferences;
};

/**
 * The UpdatePartnerNodeParentInput class defines the input values that are required from the client in order to
 * update the parent for a PartnerNode object.
 */
export type UpdatePartnerNodeParentInput = {
  /** The ID of the PartnerNode object to update. */
  id: Scalars['UUID'];
  /** The ID of the new parent PartnerNode object. */
  parentNodeId: Scalars['UUID'];
};

/**
 * The UpdatePartnerPoolInput class defines the input values that are required from the client in order to
 * update a PartnerPool object.
 */
export type UpdatePartnerPoolInput = {
  /** The ID of the PartnerPool to update. */
  id: Scalars['UUID'];
  /** The ID of the PartnerNode that the PartnerPool belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The URL of the form. */
  formUrl: Scalars['String'];
  /** The perks of the PartnerPool. */
  perks?: Maybe<Scalars['String']>;
};

/** The required values in order to update a PartnerSettings. */
export type UpdatePartnerSettingsInput = {
  /** The ID of the Site that the PartnerSettings belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** Whether or not Stint Workforce is enabled. */
  workforceEnabled: Scalars['Boolean'];
  /** Whether or not the Site has the integrated workforce feature enabled where they see Stints in their rota. */
  workforceIntegrated: Scalars['Boolean'];
  /** Whether or not the Site has leave management enabled. */
  leaveManagementEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether or not the Site has rota approval enabled. */
  rotaApprovalEnabled?: Maybe<Scalars['Boolean']>;
  /** The availability of Business Intelligence features. */
  businessIntelligenceSetting: BusinessIntelligenceSetting;
  /** Whether or not the Site has control check enabled. */
  controlCheckEnabled: Scalars['Boolean'];
  /** Whether or not the Site has repeat stinters enabled. */
  repeatStintersEnabled: Scalars['Boolean'];
  /** The locale of the PartnerSettings. */
  locale: Locale;
  /** The group that the waterfall (matching) algorithm uses to decide how to match Stinters with Stints. */
  waterfallBotGroup: WaterfallBotGroup;
  /** Whether or not the Site has hour approval enabled. */
  hourApprovalEnabled: Scalars['Boolean'];
  /** The type of venue of the PartnerSettings. */
  venueType: VenueType;
  /** Whether or not the Site has skill level enabled. */
  skillLevelEnabled: Scalars['Boolean'];
  /** The percentage used to calculate the non-service shift budget for the Site. This is a range between 0 and 100. */
  nonServiceBudgetPercentage?: Maybe<Scalars['Decimal']>;
  /** Applies an adjustment to the pay rate for all FLEXIBLE employees at the site when. The change is applied at the point of triggering the autoscheduler. Changing this value will have NO effect on shifts that have already been generated. Must be between 0 and 10. */
  payModifier?: Maybe<Scalars['Decimal']>;
  /** The hourly pay rate adjustment applied to FLEXIBLE contract employees at the site. The change is applied at the point of triggering the autoscheduler. Changing this value will have NO effect on shifts that have already been generated. Must be between 0 and 10. Defaults to 0. */
  hourlyPayRateAdjustment?: Maybe<Scalars['Decimal']>;
  /** The minimum number of minutes before a Stint start time that external users must post. Internal users can override this restriction. Must be between 30 and 40320 minutes (672 hours). */
  stintPostingCutoffMinutes: Scalars['Int'];
  /** The BI service site-level feature flag settings for this site. */
  siteBiSettings: SiteBISettingsInput;
};

/** The input values required to update a RecurringShiftOccurrence. */
export type UpdateRecurringShiftOccurrenceInput = {
  /** The ID of the Site that owns the RecurringShiftTemplate. */
  siteId: Scalars['UUID'];
  /** The ID of the RecurringShiftTemplate this occurrence belongs to. */
  id: Scalars['UUID'];
  /** The date of the occurrence to override. */
  occurrenceDate: Scalars['Date'];
  /** The overridden display name for this occurrence. */
  name?: Maybe<Scalars['String']>;
  /** The overridden type of non-service shift. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The overridden ID of the role configuration associated with this occurrence. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** The overridden ID of the member assigned to this occurrence. */
  assignedMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The overridden time the shift starts (local site time). */
  startTime: Scalars['Time'];
  /** The overridden time the shift ends (local site time). */
  endTime: Scalars['Time'];
};

/** The resolved RecurringShiftOccurrence reflecting the applied per-date override. */
export type UpdateRecurringShiftOccurrenceOutput = {
  __typename?: 'UpdateRecurringShiftOccurrenceOutput';
  /** The resolved occurrence reflecting the applied override. */
  occurrence: RecurringEventOccurrence;
};

/** The input values required to update a RecurringShiftTemplate from a given date onwards. */
export type UpdateRecurringShiftTemplateFromDateInput = {
  /** The ID of the Site that owns the RecurringShiftTemplate. */
  siteId: Scalars['UUID'];
  /** The ID of the RecurringShiftTemplate to update. */
  id: Scalars['UUID'];
  /** The date from which the update should take effect. */
  fromDate: Scalars['Date'];
  /** The optional updated name of the recurring shift template. */
  name?: Maybe<Scalars['String']>;
  /** The updated non-service shift type for the recurring shift template. */
  nonServiceType?: Maybe<NonServiceShiftType>;
  /** The updated ID of the RoleConfiguration for the recurring shift template. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** The updated start time for the recurring shift template. */
  startTime: Scalars['Time'];
  /** The updated end time for the recurring shift template. */
  endTime: Scalars['Time'];
  /** The updated recurrence pattern for the recurring shift template. */
  recurrenceRule?: Maybe<RecurrenceRuleInput>;
};

/** The output returned after updating a RecurringShiftTemplate from a given date onwards. */
export type UpdateRecurringShiftTemplateFromDateOutput = {
  __typename?: 'UpdateRecurringShiftTemplateFromDateOutput';
  /** The updated RecurringShiftTemplate. */
  recurringShiftTemplate: RecurringShiftTemplate;
};

/** The input values required to update a RecurringShiftTemplate. */
export type UpdateRecurringShiftTemplateInput = {
  /** The ID of the Site that owns the RecurringShiftTemplate. */
  siteId: Scalars['UUID'];
  /** The ID of the RecurringShiftTemplate to update. */
  id: Scalars['UUID'];
  /** The optional updated name of the recurring shift template. */
  name?: Maybe<Scalars['String']>;
  /** The updated non-service shift type for the recurring shift template. */
  nonServiceType: NonServiceShiftType;
  /** The updated ID of the RoleConfiguration for the recurring shift template. */
  roleConfigurationId: Scalars['UUID'];
  /** The updated day of the week the shift recurs on. */
  dayOfWeek: WeekDay;
  /** The updated start time for the recurring shift template. */
  startTime: Scalars['Time'];
  /** The updated end time for the recurring shift template. */
  endTime: Scalars['Time'];
};

/** The output returned after updating a RecurringShiftTemplate. */
export type UpdateRecurringShiftTemplateOutput = {
  __typename?: 'UpdateRecurringShiftTemplateOutput';
  /** The updated RecurringShiftTemplate. */
  recurringShiftTemplate: RecurringShiftTemplate;
};

/** Input for updating a role configuration. */
export type UpdateRoleConfigurationInput = {
  /** The ID of the role configuration to update. */
  id: Scalars['UUID'];
  /** The auto schedule role that this role configuration maps to. */
  autoScheduleRole: AutoScheduleRole;
  /** The new name for the role configuration. */
  name: Scalars['String'];
  /** The operational area for the role configuration. */
  operationalArea: OperationalArea;
  /** The order index for sorting role configurations. */
  orderIdx: Scalars['Int'];
  /** The minimum headcount duration in minutes. */
  minHeadcountDurationMinutes: Scalars['Int'];
  /** The maximum headcount duration in minutes. */
  maxHeadcountDurationMinutes: Scalars['Int'];
  /** The minimum shift duration in minutes. */
  minShiftDurationMinutes: Scalars['Int'];
  /** The maximum shift duration in minutes. */
  maxShiftDurationMinutes: Scalars['Int'];
  /** The maximum headcount count. Null if unlimited. */
  maxHeadcountCount?: Maybe<Scalars['Int']>;
  /** Whether the role configuration can be a shift or headcount. */
  canBeShiftOrHeadcount: Scalars['Boolean'];
  /** The item covers behaviour for the role configuration. */
  itemCoversBehaviour: ItemCoversBehaviour;
  /** The contract type for open shifts. */
  openShiftContractType: ContractType;
  /** The hourly pay rate for open shifts with this role configuration. */
  openShiftHourlyPayRate: Scalars['Decimal'];
  /** Whether to enforce expected hours for the role configuration. */
  enforceExpectedHours: Scalars['Boolean'];
  /** Whether to hide this role configuration's headcounts in the opportunities module. */
  hideInOpportunities: Scalars['Boolean'];
  /** IDs of dependent role configurations. */
  dependentRoleConfigurationIds: Array<Scalars['UUID']>;
  /** IDs of implicit secondary role configurations. */
  implicitSecondaryRoleConfigurationIds: Array<Scalars['UUID']>;
};

/** Output for updating a role configuration. */
export type UpdateRoleConfigurationOutput = {
  __typename?: 'UpdateRoleConfigurationOutput';
  /** The updated role configuration. */
  roleConfiguration: RoleConfiguration;
};

/** The input values that can be modified for the shift attendance. */
export type UpdateShiftAttendanceInput = {
  /** The ID of the Site where the shift took place. */
  siteId: Scalars['UUID'];
  /** The ID of the shift to update attendance for. */
  shiftId: Scalars['UUID'];
  /** The revised check-in time for a core team member. */
  checkedInAt: Scalars['DateTime'];
  /** The revised check-out time for a core team member. */
  checkedOutAt?: Maybe<Scalars['DateTime']>;
  /** The revised breaks that the core team member took during their shift. */
  shiftBreaks?: Maybe<Array<ShiftBreakInput>>;
};

/** The output values from updating a shift attendance. */
export type UpdateShiftAttendanceOutput = {
  __typename?: 'UpdateShiftAttendanceOutput';
  /** The updated shift attendance. */
  attendance: ShiftAttendance;
};

/**
 * The UpdateSiteNodeInput class defines the input values that are required from the client in order to update a
 * NodeType.SITE PartnerNode object.
 */
export type UpdateSiteNodeInput = {
  /** The ID of NodeType.SITE PartnerNode object to update. */
  id: Scalars['UUID'];
  /** The name of the NodeType.SITE PartnerNode. */
  name: Scalars['String'];
  /** An optional external ID that is used by the partner to identify the PartnerNode. */
  partnerUniqueId?: Maybe<Scalars['String']>;
  /** The PartnerContact input values to be used to update the related PartnerContact object. Please be aware that providing no input or using a null value will result in no action or change. */
  partnerContact?: Maybe<PartnerContactInput>;
  /** The Address input values to be used to update the related Address object. Please be aware that providing no input or using a null value will result in no action or change. */
  address?: Maybe<AddressInput>;
};

/** Input for updating site payment provider details. */
export type UpdateSitePaymentProviderInput = {
  /** The ID of the partner account the site belongs to. */
  accountId: Scalars['UUID'];
  /** The ID of the Partner Site to update the site payment provider mapping for. */
  siteId: Scalars['UUID'];
  /** Indicates whether this site payment provider mapping should be active. */
  isActive: Scalars['Boolean'];
  /** The external identifier used by the payment provider for this site. */
  externalSiteId?: Maybe<Scalars['String']>;
};

/** Output for updating a site payment provider. */
export type UpdateSitePaymentProviderOutput = {
  __typename?: 'UpdateSitePaymentProviderOutput';
  /** The updated site payment provider details. */
  paymentProviderConfig: SitePaymentProvider;
};

/** The input values required from a client to update a site schedule shift. */
export type UpdateSiteScheduleShiftInput = {
  /** The ID of the shift to update. */
  id: Scalars['UUID'];
  /** The ID of the Site. */
  siteId: Scalars['UUID'];
  /** The ID of the SiteSchedule. */
  siteScheduleId: Scalars['UUID'];
  /** The start time of the shift */
  startTime: Scalars['DateTime'];
  /** The end time of the shift. */
  endTime: Scalars['DateTime'];
  /** The PartnerMemberProfileId. Null if it's an open shift. */
  assignedPartnerMemberProfileId?: Maybe<Scalars['UUID']>;
  /** The optional role configuration ID for the shift. When provided, the shift will be associated with the specified role configuration. */
  roleConfigurationId?: Maybe<Scalars['UUID']>;
  /** Flag indicating if this is a stint shift. */
  isStint: Scalars['Boolean'];
  /** The breaks scheduled for this shift. */
  shiftBreaks: Array<ShiftBreakInput>;
  /** Information on why the shift was added. */
  updateInfo?: Maybe<ScheduleShiftUpdateInfo>;
  /** The data and time the shift was last modified. */
  lastModifiedAt: Scalars['String'];
  /** The data and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
  /** The ID of the stint template (role) that this shift belongs to, if STINT type. */
  stintTemplateId?: Maybe<Scalars['UUID']>;
  /** Whether the shift is being updated using AI assistance. If null, assumed to be false. */
  aiAssisted?: Maybe<Scalars['Boolean']>;
  /** The optional instructions for the shift. */
  shiftInstructions?: Maybe<Scalars['String']>;
};

/** The output values returned to the client from the UpdateSiteScheduleShift mutation. */
export type UpdateSiteScheduleShiftOutput = {
  __typename?: 'UpdateSiteScheduleShiftOutput';
  /** The updated day schedule for the day the shift is on. */
  daySchedule: Schedule;
  /** The updated day schedule for the day the shift was moved from. Null if the shift was not moved to a different day. */
  originalDaySchedule?: Maybe<Schedule>;
  /** The data and time the site schedule was last modified. */
  siteScheduleLastModifiedAt: Scalars['String'];
};

/** The input values required to update working availability for a member in a site schedule. */
export type UpdateSiteScheduleWorkingAvailabilityInput = {
  /** The Site for which the member's availability is being updated. */
  siteId: Scalars['UUID'];
  /** The SiteSchedule for which the member's availability is being updated. */
  siteScheduleId: Scalars['UUID'];
  /** The Partner member whose availability is being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The working availability for each day for that week for the member. */
  workingAvailability: WorkingAvailabilityInput;
};

/** The updated working availability of the member. */
export type UpdateSiteScheduleWorkingAvailabilityOutput = {
  __typename?: 'UpdateSiteScheduleWorkingAvailabilityOutput';
  /** The working availability for each day for that week for the member. */
  workingAvailability: WorkingAvailabilityType;
};

/** The input values required to update working preferences for a member in a site schedule. */
export type UpdateSiteScheduleWorkingPreferencesInput = {
  /** The Site for which the member's preferences are being updated. */
  siteId: Scalars['UUID'];
  /** The SiteSchedule for which the member's preferences are being updated. */
  siteScheduleId: Scalars['UUID'];
  /** The Partner member who's preferences are being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The WorkingPreferences for each day for that week for the member. */
  workingPreferences: WorkingPreferencesInput;
};

/** The updated workingPreferences of the member. */
export type UpdateSiteScheduleWorkingPreferencesOutput = {
  __typename?: 'UpdateSiteScheduleWorkingPreferencesOutput';
  /** The WorkingPreferences for each day for that week for the member. */
  workingPreferences: WorkingPreferences;
};

/** The required values in order to update a StintTemplateGroup. */
export type UpdateStintTemplateGroupInput = {
  /** The ID of the StintTemplateGroup to update. */
  id: Scalars['UUID'];
  /** The updated display name that will be given to the group. */
  name: Scalars['String'];
  /** The list of StintTemplate (Role) IDs to be included in the group. */
  stintTemplateIds: Array<Scalars['UUID']>;
};

/** The required values in order to update a StintTemplate (Role). */
export type UpdateStintTemplateInput = {
  /** The ID of the StintTemplate to update. */
  id: Scalars['UUID'];
  /** The ID of the Site PartnerNode that the StintTemplate belongs to. */
  partnerNodeId: Scalars['UUID'];
  /** The updated display name that will be given to the StintTemplate. */
  name?: Maybe<Scalars['String']>;
  /** The optional notes for the StintTemplate. Null will clear the value. */
  notes?: Maybe<Scalars['String']>;
  /** The list of StintUniform values for the StintTemplate. */
  uniform?: Maybe<Array<StintUniform>>;
  /** The YouTube URL of prep video to help the Stinter be prepared for the Stint. Null will clear the value. */
  prepVideoUrl?: Maybe<Scalars['String']>;
  /** Deprecated: Whether or not a uniform reminder should be sent to the Stinter. A value provided to this input will not result in any changes. */
  uniformReminderEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether or not the StintTemplate and related Stints are trained. */
  trained?: Maybe<Scalars['Boolean']>;
  /** The optional list of primary StintTask values to be set on the StintTemplate. This will override all values if provided. If null then nothing will happen. Best to pass null when no values are being changed as it will be more performant. */
  primaryTasks?: Maybe<Array<StintTaskInput>>;
  /** The optional list of secondary StintTask values to be set on the StintTemplate. This will override all values if provided. An empty list will clear all values. Null will result in nothing happening. Best to pass null when no values are being changed as it will be more performant. */
  secondaryTasks?: Maybe<Array<StintTaskInput>>;
  /** Deprecated: The optional list of TopTip values to be set on the StintTemplate. This will override all values if provided. An empty list will clear all values. Null will result in nothing happening. Best to pass null when no values are being changed as it will be more performant. Values provided to this input will not result in any changes. */
  topTips?: Maybe<Array<TopTipInput>>;
  /** The optional list of EmploymentException ID values to be set on the StintTemplate. This will override all values if provided. An empty list will clear all values. Null will result in nothing happening. Best to pass null when no values are being changed as it will be more performant. */
  employmentExceptions?: Maybe<Array<Scalars['UUID']>>;
  /** Whether a Role has controlled Release activated, This is used to enable/disable controlled release for Stints posted from a trained Role from a Partner. */
  controlledRelease?: Maybe<Scalars['Boolean']>;
  /** Bonus rate amount. */
  bonusRate?: Maybe<Scalars['Decimal']>;
  /** The ID of the StintTemplateGroup that the StintTemplate belongs to. */
  stintTemplateGroupId?: Maybe<Scalars['UUID']>;
  /** The day of the week that Stints posted from this StintTemplate are released when controlled_release is enabled. Passing in null or omitting this field will have no effect. */
  releaseDay?: Maybe<WeekDay>;
};

/** The required values to update a StintTemplate rate. */
export type UpdateStintTemplateRateInput = {
  /** The ID of the related StintTemplate. */
  stintTemplateId: Scalars['UUID'];
  /** Whether the bonus rate is enabled for a StintTemplate. */
  bonusEnabled?: Maybe<Scalars['Boolean']>;
  /** The bonus rate to apply to the Stint. */
  bonusRate?: Maybe<Scalars['Decimal']>;
  /** The boost adjustment to apply to the Stint. */
  boostAdjustment?: Maybe<Scalars['Decimal']>;
};

/**
 * The UpdateStintTimesInput class defines the input values that are required from
 * the client in order for an Employer to update the start and end times of a Stint object.
 */
export type UpdateStintTimesInput = {
  /** ID (ref) of the Stint object to update. */
  id: Scalars['UUID'];
  /** The ID (ref) of the Business that the Stint belongs to. Used to determine if the user has the required permission to update the Stint. */
  businessId: Scalars['UUID'];
  /** The updated start datetime value for the Stint. */
  dateFrom: Scalars['DateTime'];
  /** The updated end datetime value for the Stint. */
  dateTo: Scalars['DateTime'];
};

/** The required input values for updating a StinterCommitment. */
export type UpdateStinterCommitmentInput = {
  /** The ID of the StinterCommitment. */
  id: Scalars['UUID'];
  /**
   * The date on which this commitment starts.
   * The end date will be calculated by adding the numberOfWeeks to the startDate. This will result in a Sunday in X weeks
   * time.
   * This date must be a Monday!
   */
  startDate?: Maybe<Scalars['Date']>;
  /**
   * The number of weeks that the commitment will cover.
   * This will be validated to ensure that it is greater than the min and less than the max required number of weeks.
   */
  numberOfWeeks?: Maybe<Scalars['Int']>;
  /**
   * The number of Stints per week that the Stinter is committing to.
   * This will be validated to ensure that it is greater than the min and less than the max required number of Stints.
   */
  stintsPerWeek?: Maybe<Scalars['Int']>;
  /**
   * The additional list of StintTemplate IDs to associate to this commitment via the StintTemplate's associated
   * StintTemplatePoolMember.
   * The primary list of StintTemplate IDs for which StintTemplatePoolMember will be visible as trial/regular Pool
   * member.
   * A Stinter cannot have more than 1 commitment per StintTemplate.
   * If the StintTemplate is not trained, this will be ignored from the list.
   */
  additionalPrimaryStintTemplateIds?: Maybe<Array<Scalars['UUID']>>;
  /**
   * The additional list of StintTemplate IDs to associate to this commitment via the StintTemplate's associated
   * StintTemplatePoolMember.
   * The secondary list of StintTemplate IDs for which StintTemplatePoolMember won't be visible as trial/regular Pool
   * member but still can accept Stints for the Pool.
   * A Stinter cannot have more than 1 commitment per StintTemplate.
   * If the StintTemplate is not trained, this will be ignored from the list.
   */
  additionalSecondaryStintTemplateIds?: Maybe<Array<Scalars['UUID']>>;
};

/**
 * The UpdateStinterMarketingChannelInput class defines the input values required from the client to update
 * the Stinter marketing channel for a given Stinter.
 */
export type UpdateStinterMarketingChannelInput = {
  /** The ID of the Stinter that will have its marketing channel updated. */
  stinterId: Scalars['UUID'];
  /** The marketing channel the Stinter has selected. */
  marketingChannel: MarketingChannel;
};

/**
 * The UpdateStinterMarketingConsentMutation class defines the input values required from the client to update
 * the Stinter marketing-consent preference for a given Stinter.
 */
export type UpdateStinterMarketingConsentInput = {
  /** The ID of the StudentProfile that will have its marketing consent preference updated. */
  stinterProfileId: Scalars['UUID'];
  /** Whether or not the Stinter has accepted the marketing consent. */
  marketingConsentAccepted: Scalars['Boolean'];
};

/** Input type for the updateStinterPartnerExclusions mutation. */
export type UpdateStinterPartnerExclusionsInput = {
  /** The ID of the stinter to update. */
  stinterId: Scalars['UUID'];
  /** The list of partner account IDs to set as exclusions for this stinter. */
  partnerExclusions: Array<Scalars['UUID']>;
};

/** Output type for the updateStinterPartnerExclusions mutation. */
export type UpdateStinterPartnerExclusionsOutput = {
  __typename?: 'UpdateStinterPartnerExclusionsOutput';
  /** The updated list of partner account IDs the stinter has been excluded from. */
  partnerExclusions: Array<Scalars['UUID']>;
};

/** The input values required to update a user's username (email). */
export type UpdateUsernameInput = {
  /** The ID of the user whose username is to be updated. */
  userId: Scalars['UUID'];
  /** The new email to set for the user's username. */
  email: Scalars['String'];
};

/** The output values returned to the client from the UpdateUsername mutation. */
export type UpdateUsernameOutput = {
  __typename?: 'UpdateUsernameOutput';
  /** The updated user object after changing the username. */
  user: StintUser;
};

/** The input values required to upload a supporting document to an employee absence request. */
export type UploadEmployeeAbsenceRequestDocumentInput = {
  /** The partner member profile ID of the employee. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the absence request to attach the document to. */
  absenceId: Scalars['UUID'];
  /** The ID of the supporting document to attach to the existing documents in the absence request. */
  supportingDocumentId: Scalars['UUID'];
};

/** The output values from uploading a supporting document to an absence request. */
export type UploadEmployeeAbsenceRequestDocumentOutput = {
  __typename?: 'UploadEmployeeAbsenceRequestDocumentOutput';
  /** The EmployeeDocument created and attached as a supporting document alongside any existing documents for this absence request.  */
  supportingDocument: EmployeeDocument;
};

/** Mutation to update or create DeviceInfo for given unique device id. */
export type UpsertDeviceInfo = {
  __typename?: 'UpsertDeviceInfo';
  /** The updated or created device info. */
  deviceInfo?: Maybe<DeviceInfo>;
};

/**
 * This class defines the input values that are required to upsert a dynamic working preference for an
 * employee on a specific site and date.
 */
export type UpsertDynamicWorkingPreferenceInput = {
  /** The ID of the PartnerMemberProfile for which the dynamic working preference is being upserted. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the Site for which the dynamic working preference is being upserted for. */
  siteId: Scalars['UUID'];
  /** The date for which the dynamic working preference is being upserted for. */
  date: Scalars['Date'];
  /** The working preference to be upserted. */
  preference: WorkingPreference;
  /** The reason for the dynamic working preference */
  reason?: Maybe<Scalars['String']>;
  /** Optional start of the custom unavailability window. Only valid with NO_SHIFTS or PREFER_NO_SHIFTS. */
  startTime?: Maybe<Scalars['Time']>;
  /** Optional end of the custom unavailability window. Only valid with NO_SHIFTS or PREFER_NO_SHIFTS. */
  endTime?: Maybe<Scalars['Time']>;
  /** The ID of an existing dynamic working preference to update. When provided, bypasses the duplicate one-off preference check. */
  dynamicWorkingPreferenceId?: Maybe<Scalars['UUID']>;
};

/**
 * This class defines the output values that are returned after a partner employee upserts a dynamic
 * working preference.
 */
export type UpsertDynamicWorkingPreferenceOutput = {
  __typename?: 'UpsertDynamicWorkingPreferenceOutput';
  /** The dynamic working preference for a specific date. */
  preference: DynamicWorkingPreference;
  /** The partner member record for the core team member at the site. */
  partnerMember: PartnerMember;
};

/** The input parameters for upserting Employee bank details. */
export type UpsertEmployeeBankDetailsInput = {
  /** The ID of the PartnerMemberProfile for which bank details are being updated. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The name of the Employee's bank. */
  bankName: Scalars['String'];
  /** The name of the Employee as it appears on their bank account. */
  accountHolderName: Scalars['String'];
  /** The number of the Employee's bank account. */
  accountNumber: Scalars['String'];
  /** The sort code of the Employee's bank account without any hyphens. e.g. '608371'. */
  sortCode: Scalars['String'];
};

/** The output values from updating Employee bank details. */
export type UpsertEmployeeBankDetailsOutput = {
  __typename?: 'UpsertEmployeeBankDetailsOutput';
  /** Whether the bank details were successfully updated. */
  success: Scalars['Boolean'];
};

/** The input values required to upsert an Employee's diversity and inclusion info. */
export type UpsertEmployeeDiversityAndInclusionInfoInput = {
  /** The ID of the PartnerMemberProfile whose diversity and inclusion info is being upserted. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The gender identity of the employee. */
  genderIdentity?: Maybe<EmployeeDiversityGenderIdentity>;
  /** Free-text gender identity when OTHER is selected. */
  genderIdentityOther?: Maybe<Scalars['String']>;
  /** The sexual orientation of the employee. */
  sexuality?: Maybe<EmployeeDiversitySexuality>;
  /** Free-text sexual orientation when OTHER is selected. */
  sexualityOther?: Maybe<Scalars['String']>;
  /** The nationality of the employee. */
  nationality?: Maybe<EmployeeDiversityNationality>;
  /** The ethnicity of the employee. */
  ethnicity?: Maybe<EmployeeDiversityEthnicity>;
  /** Free-text ethnicity when OTHER is selected. */
  ethnicityOther?: Maybe<Scalars['String']>;
  /** The religion or belief system of the employee. */
  religiousBeliefs?: Maybe<EmployeeDiversityReligiousBelief>;
  /** Free-text religion when OTHER is selected. */
  religiousBeliefsOther?: Maybe<Scalars['String']>;
  /** The age range of the employee. */
  ageRange?: Maybe<EmployeeDiversityAgeRange>;
  /** The disability status of the employee. */
  disabilityStatus?: Maybe<EmployeeDiversityDisabilityStatus>;
  /** The specific disability types when disability_status is YES. */
  disabilityTypes?: Maybe<Array<EmployeeDiversityDisabilityType>>;
  /** Free-text disability type when OTHER is selected. */
  disabilityTypesOther?: Maybe<Scalars['String']>;
  /** The neurodiversity status of the employee. */
  neurodiversity?: Maybe<EmployeeDiversityNeurodiversityStatus>;
  /** The specific neurodiversity types when neurodiversity is YES. */
  neurodiversityTypes?: Maybe<Array<EmployeeDiversityNeurodiversityType>>;
  /** Free-text neurodiversity type when OTHER is selected. */
  neurodiversityTypesOther?: Maybe<Scalars['String']>;
};

/** The output values returned after upserting an Employee's diversity and inclusion info. */
export type UpsertEmployeeDiversityAndInclusionInfoOutput = {
  __typename?: 'UpsertEmployeeDiversityAndInclusionInfoOutput';
  /** Indicates whether the diversity and inclusion info was successfully upserted. */
  success: Scalars['Boolean'];
};

/** The input values required to upsert an Employee's emergency contact. */
export type UpsertEmployeeEmergencyContactInput = {
  /** The ID of the PartnerMemberProfile whose emergency contact is being upserted. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The first name of the Employee's emergency contact. */
  firstName: Scalars['String'];
  /** The last name of the Employee's emergency contact. */
  lastName: Scalars['String'];
  /** The phone number of the Employee's emergency contact. */
  phoneNumber: Scalars['String'];
  /** The email address of the Employee's emergency contact. */
  email: Scalars['String'];
};

/** The output values returned after upserting an Employee's emergency contact. */
export type UpsertEmployeeEmergencyContactOutput = {
  __typename?: 'UpsertEmployeeEmergencyContactOutput';
  /** Indicates whether the emergency contact was successfully upserted. */
  success: Scalars['Boolean'];
};

/** The input values required to upsert the experience level for an Employee. */
export type UpsertEmployeeExperienceLevelInput = {
  /** The ID of the PartnerMemberProfile of the Employee for which to upsert the experience level. */
  partnerMemberProfileId: Scalars['UUID'];
  /** Whether the Employee is currently in training. */
  training?: Maybe<Scalars['Boolean']>;
  /** The skill level of the Employee ranging from 0 to 5, where 0 is the lowest skill level (in training) and 5 is the highest skill level. If None, the existing value is retained unless training is True, in which case it is set to 0. */
  skillLevel?: Maybe<Scalars['Int']>;
  /** List of role configuration IDs for secondary roles. If None, the existing value is retained. */
  secondaryRoleConfigurationIds?: Maybe<Array<Scalars['UUID']>>;
};

/** The output values returned after upserting the experience level for an Employee. */
export type UpsertEmployeeExperienceLevelOutput = {
  __typename?: 'UpsertEmployeeExperienceLevelOutput';
  /** The updated employment information for the Employee. */
  employmentInfo: EmploymentInfo;
};

/** The input values required to upsert an Employee's home address. */
export type UpsertEmployeeHomeAddressInput = {
  /** The ID of the PartnerMemberProfile whose home address is being upserted. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The first line of the Employee's home address. */
  addressLineOne: Scalars['String'];
  /** The town or city of the Employee's home address. */
  town: Scalars['String'];
  /** The postcode of the Employee's home address. */
  postcode: Scalars['String'];
};

/** The output values returned after upserting an Employee's home address. */
export type UpsertEmployeeHomeAddressOutput = {
  __typename?: 'UpsertEmployeeHomeAddressOutput';
  /** Indicates whether the home address was successfully upserted. */
  success: Scalars['Boolean'];
};

/** The input values required to upsert an Employee's manager. */
export type UpsertEmployeeManagerInput = {
  /** The ID of the PartnerMemberProfile (the employee) whose manager is being inserted or updated. */
  employeeId: Scalars['UUID'];
  /** The ID of the PartnerMemberProfile of the manager to assign to this employee. */
  managerId: Scalars['UUID'];
};

/** The output values returned to the client from the UpsertEmployeeManager mutation. */
export type UpsertEmployeeManagerOutput = {
  __typename?: 'UpsertEmployeeManagerOutput';
  /** The PartnerMemberProfile of the employee whose manager was inserted or updated. */
  employee: PartnerMemberProfile;
};

/** The input values required to insert or update an Employee's managers. */
export type UpsertEmployeeManagersInput = {
  /** The ID of the PartnerMemberProfile (the employee) whose managers are being inserted or updated. */
  employeeId: Scalars['UUID'];
  /** The IDs of the PartnerMemberProfile of the managers to assign to this employee. */
  managerIds: Array<Scalars['UUID']>;
};

/** The output values returned to the client from the UpsertEmployeeManagers mutation. */
export type UpsertEmployeeManagersOutput = {
  __typename?: 'UpsertEmployeeManagersOutput';
  /** The PartnerMemberProfile of the employee whose managers were inserted or updated. */
  employee: PartnerMemberProfile;
};

/** The input parameters for upserting Employee payroll information. */
export type UpsertEmployeePayrollInformationInput = {
  /** The ID of the PartnerMemberProfile for which payroll information is being upserted. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The ID of the Employee in the external payroll system. */
  externalPayrollId?: Maybe<Scalars['String']>;
  /** The Employee's National Insurance number. */
  nationalInsuranceNumber?: Maybe<Scalars['String']>;
  /** The Employee's student loan plan. */
  studentLoanPlan?: Maybe<StudentLoanPlan>;
  /** The Employee's statement type. */
  employeeStatement?: Maybe<EmployeeStatement>;
};

/** The output values from upserting Employee payroll information. */
export type UpsertEmployeePayrollInformationOutput = {
  __typename?: 'UpsertEmployeePayrollInformationOutput';
  /** Whether the payroll information was successfully upserted. */
  success: Scalars['Boolean'];
};

/** The input values required to upsert a core team member in the HR service. */
export type UpsertHRCoreTeamMemberInput = {
  /** The ID of the partner member profile to upsert a core team member for. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The number of working days per week. */
  workingDaysPerWeek?: Maybe<Scalars['Decimal']>;
  /** The number of hours per day. */
  hoursPerDay?: Maybe<Scalars['Decimal']>;
  /** The start date at partner. */
  startDateAtPartner: Scalars['Date'];
};

/** The output values from upserting a core team member in the HR service. */
export type UpsertHRCoreTeamMemberOutput = {
  __typename?: 'UpsertHRCoreTeamMemberOutput';
  /** The working summary for the upserted core team member. */
  workingSummary: CoreTeamMemberWorkingSummary;
};

/** Input type for upserting partner operational areas. */
export type UpsertPartnerOperationalAreasInput = {
  /** The ID of the primary partner node that these areas will be set on. The areas will be inherited by all partner nodes below this node. */
  primaryPartnerNodeId: Scalars['UUID'];
  /** The list of operational areas to set for the partner node. */
  areas: Array<OperationalArea>;
};

/** Output type for upserting partner operational areas. */
export type UpsertPartnerOperationalAreasOutput = {
  __typename?: 'UpsertPartnerOperationalAreasOutput';
  /** The list of operational areas that were set in the order to display. */
  operationalAreas: Array<OperationalArea>;
};

/** The input parameters for upserting a profile photo. */
export type UpsertProfilePhotoInput = {
  /** The profile photo base64 value. */
  photoBase64: Scalars['String'];
};

/** The output values returned to the client by UpsertProfilePhotoOutput.  */
export type UpsertProfilePhotoOutput = {
  __typename?: 'UpsertProfilePhotoOutput';
  /** The URL to retrieve the upserted profile photo. */
  profilePhotoUrl: Scalars['String'];
};

/**
 * UpsertVideoAssessmentInfoInput contains the required input fields for updating or creating a
 * VideoAssessmentInfo.
 */
export type UpsertVideoAssessmentInfoInput = {
  /** The UUID of the Stinter being assessed. */
  stinterId: Scalars['UUID'];
  /** The outcome of the assessment. */
  assessmentOutcome: VideoAssessmentOutcome;
  /** The UUID of the VideoAssessmentInfo. Provide this to update the object. */
  assessmentId?: Maybe<Scalars['UUID']>;
};

/**
 * Respresent a Keycloak Attribute's value. Keeycloak attributes are always array of value, so for:
 *    MyKeyAttr: [MyValAttr, MyOtherValAttr]
 * You should get:
 * [
 *    UserAttributeType(name=MyKeyAttr, value=MyValAttr),
 *    UserAttributeType(name=MyKeyAttr, value=MyOtherValAttr),
 * ]
 */
export type UserAttributeType = {
  __typename?: 'UserAttributeType';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** The user's user profile */
export type UserProfile = {
  __typename?: 'UserProfile';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  modifiedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['UUID'];
  user: StintUser;
  enablePushNotifications: Scalars['Boolean'];
  enableSmsNotifications: Scalars['Boolean'];
  enableEmailNotifications: Scalars['Boolean'];
};

/** Respresent a Keycloak user object, joined with a mono user details */
export type UserRepresentationType = {
  __typename?: 'UserRepresentationType';
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<Maybe<UserAttributeType>>>;
  user?: Maybe<StintUser>;
};

/**
 * Represents the three main user types for the Stint API.
 *
 *     This replaces the old UserTypes class which has old terminology and user types that are not used.
 */
export enum UserType {
  STINTER = 'STINTER',
  EMPLOYER = 'EMPLOYER',
  STAFF = 'STAFF',
  UNKNOWN = 'UNKNOWN',
}

/**
 * The UsersFilterInput class defines the Graphene input values used to provide the requested filter
 * values from the client for a list of StintUser objects.
 */
export type UsersFilterInput = {
  /**
   * Limit results to only those that fuzzy match the email (username).
   * If omitted, then all results will be returned.
   */
  email?: Maybe<Scalars['String']>;
  /**
   * Limit results to only those that fuzzy match the fullname.
   * If omitted, then all results will be returned.
   */
  fullname?: Maybe<Scalars['String']>;
  /**
   * Limit results to only those that fuzzy match the phone number.
   * If omitted, then all results will be returned.
   */
  phoneNumber?: Maybe<Scalars['String']>;
  /**
   * Limit results to only the one that has the ID of the specified StintUser.
   * This can be used to quickly retrieve a single StintUser.
   * If omitted, then all results will be returned.
   */
  userId?: Maybe<Scalars['UUID']>;
  /**
   * Limit results to only those that match the specified UserType value.
   * If omitted, then all results will be returned.
   */
  userType?: Maybe<UserType>;
};

/**
 * The UsersInput class defines the Graphene input values used to resolve a filtered and ordered list
 * of StintUser objects.
 */
export type UsersInput = {
  /**
   * Allow specifying the order of the results.
   * If not specified, the results will be ordered by fullname ascending.
   */
  orderBy?: Maybe<UsersOrderInput>;
  /**
   * Filter the results by the specified criteria.
   * If not specified, all results will be returned.
   */
  filter?: Maybe<UsersFilterInput>;
};

/** Enum that contains the allowed field values that can be used to order a QuerySet of StintUser objects. */
export enum UsersOrderField {
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

/**
 * The UsersOrderInput class defines the Graphene input values used to provide the requested order by
 * values from the client for a list of StintUser objects.
 *
 * It contains the allowed fields to order by and the ascending or descending order that is requested.
 */
export type UsersOrderInput = {
  /** The field to order the list of StintUser objects by. */
  field: UsersOrderField;
  /** The requested order to be used when ordering the list of StintUser objects. */
  order: SortOrder;
};

/**
 * The TextChoices for the Offence.reason field that only includes the valid OffenceReason choices for newly created
 *     Offence objects.
 */
export enum ValidOffenceReason {
  LEAVING_EARLY = 'LEAVING_EARLY',
  LATENESS = 'LATENESS',
  UNIFORM = 'UNIFORM',
  CANCELLATION_THRESHOLD_1_V2 = 'CANCELLATION_THRESHOLD_1_V2',
  CANCELLATION_THRESHOLD_2_V2 = 'CANCELLATION_THRESHOLD_2_V2',
  CANCELLATION_THRESHOLD_3_V2 = 'CANCELLATION_THRESHOLD_3_V2',
  TEAM_CANCELATION_THREE_STRIKES = 'TEAM_CANCELATION_THREE_STRIKES',
  NO_SHOW = 'NO_SHOW',
  NO_CONFIRMATION = 'NO_CONFIRMATION',
  UNRESPONSIVE_STANDBY = 'UNRESPONSIVE_STANDBY',
  GROSS_MISCONDUCT = 'GROSS_MISCONDUCT',
  PERFORMANCE = 'PERFORMANCE',
  PERFORMANCE_SENT_HOME = 'PERFORMANCE_SENT_HOME',
  UNAUTHORISED_DEPARTURE = 'UNAUTHORISED_DEPARTURE',
  ONE_STRIKE_REDEEMED = 'ONE_STRIKE_REDEEMED',
  TWO_STRIKE_REDEEMED = 'TWO_STRIKE_REDEEMED',
  THREE_STRIKE_REDEEMED = 'THREE_STRIKE_REDEEMED',
}

/** Enum representing types of venue available */
export enum VenueType {
  QSR = 'QSR',
  CASUAL_DINING = 'CASUAL_DINING',
}

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type VerifyEmail = {
  __typename?: 'VerifyEmail';
  /** User obtain a JWT access and refresh token */
  token?: Maybe<Scalars['String']>;
  /** User obtain a JWT access and refresh token */
  refreshToken?: Maybe<Scalars['String']>;
};

export type VerifyPhonenumber = {
  __typename?: 'VerifyPhonenumber';
  /** User obtain a JWT access and refresh token */
  token?: Maybe<Scalars['String']>;
  /** User obtain a JWT access and refresh token */
  refreshToken?: Maybe<Scalars['String']>;
};

/** A VideoAssessmentInfo contains all the information about the assessment of a Stinter's video that was provided to assess their quality for Stint teams. */
export type VideoAssessmentInfo = {
  __typename?: 'VideoAssessmentInfo';
  /** The ID of the VideoAssessmentInfo. */
  id: Scalars['UUID'];
  /** The timestamp of when the assessment was made. */
  assessedAt: Scalars['DateTime'];
  /** The VideoAssessmentOutcome value that represents the assessment given to the Stinter. */
  outcome: VideoAssessmentOutcome;
  /** The name of the Staff user that made the assessment of the Stinter. */
  assessorName: Scalars['String'];
};

/** The available values that can be used when making an assessment of a Stinter's video for teams. */
export enum VideoAssessmentOutcome {
  CUSTOMER_FACING_GREAT = 'CUSTOMER_FACING_GREAT',
  CUSTOMER_FACING_GOOD = 'CUSTOMER_FACING_GOOD',
  BACK_OF_HOUSE = 'BACK_OF_HOUSE',
  NOT_FIT_FOR_STINT = 'NOT_FIT_FOR_STINT',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
}

/** The TextChoices for the PartnerSettings.waterfall_bot_group field. */
export enum WaterfallBotGroup {
  UNSPECIFIED = 'UNSPECIFIED',
  GROUP_ONE = 'GROUP_ONE',
  GROUP_TWO = 'GROUP_TWO',
  GROUP_THREE = 'GROUP_THREE',
  GROUP_FOUR = 'GROUP_FOUR',
  GROUP_FIVE = 'GROUP_FIVE',
  GROUP_SIX = 'GROUP_SIX',
  GROUP_SEVEN = 'GROUP_SEVEN',
  GROUP_EIGHT = 'GROUP_EIGHT',
  GROUP_NINE = 'GROUP_NINE',
  GROUP_TEN = 'GROUP_TEN',
  GROUP_ELEVEN = 'GROUP_ELEVEN',
  GROUP_TWELVE = 'GROUP_TWELVE',
  GROUP_THIRTEEN = 'GROUP_THIRTEEN',
  GROUP_FOURTEEN = 'GROUP_FOURTEEN',
  GROUP_FIFTEEN = 'GROUP_FIFTEEN',
}

/** Enum that contains the days of the week. */
export enum WeekDay {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

/** A WeekSchedule represents the week for a SiteSchedule which contains the Schedule for each day of the week. */
export type WeekSchedule = {
  __typename?: 'WeekSchedule';
  /** The Schedule for Monday. */
  monday: Schedule;
  /** The Schedule for Tuesday. */
  tuesday: Schedule;
  /** The Schedule for Wednesday. */
  wednesday: Schedule;
  /** The Schedule for Thursday. */
  thursday: Schedule;
  /** The Schedule for Friday. */
  friday: Schedule;
  /** The Schedule for Saturday. */
  saturday: Schedule;
  /** The Schedule for Sunday. */
  sunday: Schedule;
};

/** Per-day counts of Schedule Labour Suggestions for the week, keyed by weekday. */
export type WeeklyScheduleLabourSuggestionCounts = {
  __typename?: 'WeeklyScheduleLabourSuggestionCounts';
  /** The count of Schedule Labour Suggestions for Monday. */
  monday: Scalars['Int'];
  /** The count of Schedule Labour Suggestions for Tuesday. */
  tuesday: Scalars['Int'];
  /** The count of Schedule Labour Suggestions for Wednesday. */
  wednesday: Scalars['Int'];
  /** The count of Schedule Labour Suggestions for Thursday. */
  thursday: Scalars['Int'];
  /** The count of Schedule Labour Suggestions for Friday. */
  friday: Scalars['Int'];
  /** The count of Schedule Labour Suggestions for Saturday. */
  saturday: Scalars['Int'];
  /** The count of Schedule Labour Suggestions for Sunday. */
  sunday: Scalars['Int'];
};

/** Willow labour optimisation data for a site. */
export type Willow = {
  __typename?: 'Willow';
  /** The ID of the site. */
  siteId: Scalars['UUID'];
  /** Unblocked headcount opportunities for the site and week. */
  headcountOpportunities: Array<HeadcountOpportunity>;
};

/** Willow labour optimisation data for a site. */
export type WillowheadcountOpportunitiesArgs = {
  input: HeadcountOpportunitiesInput;
};

/** The Willow labour model for the site. */
export enum WillowLabourModel {
  /** The default labour model. Disables Budgets comparison and Opportunities. */
  OPTIMAL = 'OPTIMAL',
  /** Enables Budgets comparison and Opportunities toggles. */
  REPLICA = 'REPLICA',
}

/**
 * The WorkExperienceType class defines the Graphene ObjectType class used to resolve
 * the WorkExperience model data for GraphQL queries.
 *
 * It has a UUIDNode interface so that list queries can use relay pagination.
 *
 * The id field is configured to return the WorkExperience.id value due to the fact that a UUIDNode
 * by default automatically generates it's own id value.
 */
export type WorkExperience = Node & {
  __typename?: 'WorkExperience';
  /** The ID of the WorkExperience. */
  id: Scalars['UUID'];
  /** The HospitalityWorkExperience value that the Stinter has provided as an answer to how much work experience they have in the hospitality industry. */
  hospitalityWorkExperience: HospitalityWorkExperience;
};

/** A full week of working availability preferences for a PartnerMemberProfile at a Site. */
export type WorkingAvailabilityInput = {
  /** The working availability preferences for Monday. */
  monday: Array<DayWorkingAvailabilityInput>;
  /** The working availability preferences for Tuesday. */
  tuesday: Array<DayWorkingAvailabilityInput>;
  /** The working availability preferences for Wednesday. */
  wednesday: Array<DayWorkingAvailabilityInput>;
  /** The working availability preferences for Thursday. */
  thursday: Array<DayWorkingAvailabilityInput>;
  /** The working availability preferences for Friday. */
  friday: Array<DayWorkingAvailabilityInput>;
  /** The working availability preferences for Saturday. */
  saturday: Array<DayWorkingAvailabilityInput>;
  /** The working availability preferences for Sunday. */
  sunday: Array<DayWorkingAvailabilityInput>;
};

/** A full week of working availability preferences for a PartnerMemberProfile at a Site. */
export type WorkingAvailabilityType = {
  __typename?: 'WorkingAvailabilityType';
  /** The working availability preferences for Monday. */
  monday: Array<DayWorkingAvailabilityType>;
  /** The working availability preferences for Tuesday. */
  tuesday: Array<DayWorkingAvailabilityType>;
  /** The working availability preferences for Wednesday. */
  wednesday: Array<DayWorkingAvailabilityType>;
  /** The working availability preferences for Thursday. */
  thursday: Array<DayWorkingAvailabilityType>;
  /** The working availability preferences for Friday. */
  friday: Array<DayWorkingAvailabilityType>;
  /** The working availability preferences for Saturday. */
  saturday: Array<DayWorkingAvailabilityType>;
  /** The working availability preferences for Sunday. */
  sunday: Array<DayWorkingAvailabilityType>;
};

/** The Working Preference of a Staff Member for a specific day. */
export enum WorkingPreference {
  /** The Staff Member has no preference for shifts on the specified day. */
  NO_PREFERENCE = 'NO_PREFERENCE',
  /** The Staff Member is on holiday all day on the specified day. */
  HOLIDAY = 'HOLIDAY',
  /** The Staff Member is on holiday early on the specified day. */
  HOLIDAY_EARLY = 'HOLIDAY_EARLY',
  /** The Staff Member is on holiday late on the specified day. */
  HOLIDAY_LATE = 'HOLIDAY_LATE',
  /** The Staff Member is absent on the specified day. */
  ABSENT = 'ABSENT',
  /** The Staff Member is not available for shifts on the specified day. */
  NO_SHIFTS = 'NO_SHIFTS',
  /** The Staff Member is not available for early shifts on the specified day. */
  NO_EARLY_SHIFTS = 'NO_EARLY_SHIFTS',
  /** The Staff Member is not available for late shifts on the specified day. */
  NO_LATE_SHIFTS = 'NO_LATE_SHIFTS',
  /** The Staff Member prefers no shifts on the specified day. */
  PREFER_NO_SHIFTS = 'PREFER_NO_SHIFTS',
  /** The Staff Member prefers no early shifts on the specified day. */
  PREFER_NO_EARLY_SHIFTS = 'PREFER_NO_EARLY_SHIFTS',
  /** The Staff Member prefers no late shifts on the specified day. */
  PREFER_NO_LATE_SHIFTS = 'PREFER_NO_LATE_SHIFTS',
}

/** A WorkingPreferenceRequest represents a request for a working preference for an employee. */
export type WorkingPreferenceRequest = {
  __typename?: 'WorkingPreferenceRequest';
  /** The ID of the WorkingPreferenceRequest. */
  id: Scalars['UUID'];
  /** The name of the Site for which the working preference is being requested. */
  siteName: Scalars['String'];
  /** The date for which the working preference is being requested. */
  date: Scalars['Date'];
  /** The working preference that was requested. */
  preference: WorkingPreference;
  /** The status of the working preference request. */
  status: WorkingPreferenceRequestStatus;
  /** The reason for the working preference request. */
  reason?: Maybe<Scalars['String']>;
  /** The ID of the partner member profile for which the working preference is being requested. */
  partnerMemberProfileId: Scalars['UUID'];
  /** The date and time the working preference request was created. */
  createdAt: Scalars['DateTime'];
  /** The name of the user who requested the working preference. */
  requestedByName: Scalars['String'];
  /** The start time of the working preference request window. */
  startTime?: Maybe<Scalars['Time']>;
  /** The end time of the working preference request window. */
  endTime?: Maybe<Scalars['Time']>;
};

/** Contains the working preference request for an employee at a site along with their partner member. */
export type WorkingPreferenceRequestAtSite = {
  __typename?: 'WorkingPreferenceRequestAtSite';
  /** The working preference request. */
  workingPreferenceRequest: WorkingPreferenceRequest;
  /** The partner member. */
  partnerMember: PartnerMember;
};

/** The status of a working preference request. */
export enum WorkingPreferenceRequestStatus {
  /** The working preference request is awaiting approval. */
  PENDING = 'PENDING',
  /** The working preference request has been approved. */
  APPROVED = 'APPROVED',
  /** The working preference request has been rejected. */
  REJECTED = 'REJECTED',
}

/** A week of working preference values for a PartnerMemberProfile and Site. */
export type WorkingPreferences = {
  __typename?: 'WorkingPreferences';
  /** The WorkingPreference for Monday. */
  monday: WorkingPreference;
  /** The WorkingPreference for Tuesday. */
  tuesday: WorkingPreference;
  /** The WorkingPreference for Wednesday. */
  wednesday: WorkingPreference;
  /** The WorkingPreference for Thursday. */
  thursday: WorkingPreference;
  /** The WorkingPreference for Friday. */
  friday: WorkingPreference;
  /** The WorkingPreference for Saturday. */
  saturday: WorkingPreference;
  /** The WorkingPreference for Sunday. */
  sunday: WorkingPreference;
};

/** The selected working preferences of a PartnerMemberProfile for a Site. */
export type WorkingPreferencesInput = {
  /** The WorkingPreference for Monday. */
  monday: WorkingPreference;
  /** The WorkingPreference for Tuesday. */
  tuesday: WorkingPreference;
  /** The WorkingPreference for Wednesday. */
  wednesday: WorkingPreference;
  /** The WorkingPreference for Thursday. */
  thursday: WorkingPreference;
  /** The WorkingPreference for Friday. */
  friday: WorkingPreference;
  /** The WorkingPreference for Saturday. */
  saturday: WorkingPreference;
  /** The WorkingPreference for Sunday. */
  sunday: WorkingPreference;
};

/** A WorkingTimeRule represents a rule for the working hours of a CoreTeamMemberbased on their shifts. */
export type WorkingTimeRule = {
  __typename?: 'WorkingTimeRule';
  /** The type of the working time rule. */
  type: WorkingTimeRuleType;
  /** The severity of the working time rule. */
  severity: WorkingTimeRuleSeverity;
  /** The description of the working time rule. */
  description: Scalars['String'];
  /** A numerical value which is limit of the working time rule. */
  limit: Scalars['Decimal'];
  /** A numerical value for the working time rule. */
  value: Scalars['Decimal'];
};

/** A warning severity level for the WorkingTimeRule. */
export enum WorkingTimeRuleSeverity {
  /** A hard WorkingTimeRule. */
  HARD = 'HARD',
  /** A soft WorkingTimeRule. */
  SOFT = 'SOFT',
}

/** The type values for a WorkingTimeRule. */
export enum WorkingTimeRuleType {
  /** A rule for if the CoreTeamMember who is ayoung worker has worked more than the maximum hours per day. */
  MAX_HOURS_PER_DAY_YOUNG_WORKER = 'MAX_HOURS_PER_DAY_YOUNG_WORKER',
  /** A rule for if the CoreTeamMember has worked more than the maximum hours per week. */
  MAX_HOURS_PER_WEEK = 'MAX_HOURS_PER_WEEK',
  /** A rule for if the CoreTeamMember who is ayoung worker has worked more than the maximum hours per week. */
  MAX_HOURS_PER_WEEK_YOUNG_WORKER = 'MAX_HOURS_PER_WEEK_YOUNG_WORKER',
  /** A rule for if the CoreTeamMember who is aninternational worker has worked more than the maximum hours per week. */
  MAX_HOURS_PER_WEEK_INTERNATIONAL_WORKER = 'MAX_HOURS_PER_WEEK_INTERNATIONAL_WORKER',
  /** A rule for if the CoreTeamMember has not had the minimum rest between shifts. */
  MIN_REST_BETWEEN_SHIFTS = 'MIN_REST_BETWEEN_SHIFTS',
  /** A rule for if the CoreTeamMember who is ayoung worker has not had the minimum rest between shifts. */
  MIN_REST_BETWEEN_SHIFTS_YOUNG_WORKER = 'MIN_REST_BETWEEN_SHIFTS_YOUNG_WORKER',
  /** A rule for if the CoreTeamMember has not had the minimum weekly rest. */
  MIN_WEEKLY_REST = 'MIN_WEEKLY_REST',
  /** A rule for if the CoreTeamMember who is ayoung worker has not had the minimum weekly rest. */
  MIN_WEEKLY_REST_YOUNG_WORKER = 'MIN_WEEKLY_REST_YOUNG_WORKER',
}

export type BulkUpdateCanSeeSurgeMutationVariables = Exact<{
  canSeeSurge: Scalars['Boolean'];
  userFile: Scalars['String'];
}>;

export type BulkUpdateCanSeeSurgeMutation = { __typename?: 'Mutation' } & {
  bulkUpdateCanSeeSurge?: Maybe<
    { __typename?: 'SuccessType' } & Pick<SuccessType, 'message' | 'success'>
  >;
};

export type ManualGeotrackingStatusUpdateMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type ManualGeotrackingStatusUpdateMutation = {
  __typename?: 'Mutation';
} & {
  manualGeotrackingStatusUpdate?: Maybe<
    { __typename?: 'StintJourney' } & Pick<StintJourney, 'id'>
  >;
};

export type SearchGooglePlacesMutationVariables = Exact<{
  searchTerm: Scalars['String'];
  returnType?: Maybe<GooglePlacesReturnType>;
}>;

export type SearchGooglePlacesMutation = { __typename?: 'Mutation' } & {
  searchGooglePlaces?: Maybe<
    { __typename?: 'GooglePlacesPredictionsType' } & {
      predictions?: Maybe<
        Array<
          Maybe<
            { __typename?: 'GooglePlaceType' } & Pick<
              GooglePlaceType,
              'placeId' | 'displayAddress'
            >
          >
        >
      >;
    }
  >;
};

export type sendOtpEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type sendOtpEmailMutation = { __typename?: 'Mutation' } & {
  sendOtpEmail?: Maybe<
    { __typename: 'SendOTPEmail' } & Pick<SendOTPEmail, 'success'>
  >;
};

export type SendOtpSmsV2MutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type SendOtpSmsV2Mutation = { __typename?: 'Mutation' } & {
  sendOtpSmsV2?: Maybe<
    { __typename?: 'SendOTPSMSV2' } & Pick<SendOTPSMSV2, 'success'>
  >;
};

export type verifyStudentUserMutationVariables = Exact<{
  studentUserIds: Array<Maybe<Scalars['UUID']>>;
}>;

export type verifyStudentUserMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'SuccessType' } & Pick<SuccessType, 'success'>>;
};

export type CountStudentsCanSeeSurgeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CountStudentsCanSeeSurgeQuery = { __typename?: 'Query' } & Pick<
  Query,
  'countStudentsCanSeeSurge'
>;

export type UpdateActualLeaveTimeMutationVariables = Exact<{
  updateInputs: UpdateActualLeaveTimeInput;
}>;

export type UpdateActualLeaveTimeMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'Stint' } & Pick<Stint, 'id' | 'actualLeaveTime'>
  >;
};

export type AdminAddressFieldsFragment = { __typename?: 'Address' } & Pick<
  Address,
  'id' | 'name' | 'placeId'
>;

export type allAddressesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<AddressFilter>;
}>;

export type allAddressesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'Address' } & AdminAddressFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type AddressQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type AddressQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Address' } & AdminAddressFieldsFragment>;
};

export type AdminCreateAppealMutationVariables = Exact<{
  createInputs: AdminCreateAppealInput;
}>;

export type AdminCreateAppealMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'Appeal' } & Pick<Appeal, 'id' | 'decisionAt' | 'status'>
  >;
};

export type AdminBusinessFieldsFragment = { __typename?: 'Business' } & Pick<
  Business,
  | 'id'
  | 'averageRating'
  | 'createdAt'
  | 'ltdName'
  | 'displayAddress'
  | 'exemptFromPaymentDetails'
  | 'integrated'
  | 'name'
  | 'logo'
  | 'repeatStintersEnabled'
  | 'phoneNumber'
  | 'placeId'
  | 'qrCodeId'
  | 'status'
  | 'unlockedLastMinuteStints'
  | 'controlCheck'
  | 'isBlockedByFinance'
> & {
    address?: Maybe<
      { __typename?: 'Address' } & Pick<Address, 'postalCode'> & {
          cityFk?: Maybe<{ __typename?: 'City' } & Pick<City, 'id' | 'name'>>;
        }
    >;
    city?: Maybe<
      { __typename?: 'City' } & Pick<City, 'id' | 'name' | 'baseFee'>
    >;
    rateOverride?: Maybe<
      { __typename?: 'RateOverride' } & Pick<RateOverride, 'rate'>
    >;
    salesRepresentitive?: Maybe<
      { __typename?: 'StintUser' } & Pick<
        StintUser,
        'id' | 'email' | 'firstName' | 'lastName'
      >
    >;
    stintopedia?: Maybe<
      { __typename?: 'Stintopedia' } & Pick<
        Stintopedia,
        'id' | 'bookedOnboardingMeeting' | 'usingStintCorrectly'
      >
    >;
  };

export type allBusinessesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<BusinessFilter>;
}>;

export type allBusinessesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'Business' } & AdminBusinessFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type BusinessQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type BusinessQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Business' } & AdminBusinessFieldsFragment>;
};

export type updateBusinessMutationVariables = Exact<{
  id: Scalars['UUID'];
  businessLogo?: Maybe<Scalars['String']>;
  displayAddress?: Maybe<Scalars['String']>;
  exemptFromPaymentDetails?: Maybe<Scalars['Boolean']>;
  ltdName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  rateOverride?: Maybe<BusinessRateOverrideInput>;
  status?: Maybe<BusinessStatusChoices>;
  integrated?: Maybe<Scalars['Boolean']>;
  unlockedLastMinuteStints?: Maybe<Scalars['Boolean']>;
  controlCheck?: Maybe<Scalars['Boolean']>;
  isBlockedByFinance?: Maybe<Scalars['Boolean']>;
  stintopedia?: Maybe<StintopediaInput>;
  repeatStintersEnabled?: Maybe<Scalars['Boolean']>;
}>;

export type updateBusinessMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Business' } & AdminBusinessFieldsFragment>;
};

export type AdminCharacteristicFieldsFragment = {
  __typename?: 'Characteristic';
} & Pick<Characteristic, 'id' | 'name'>;

export type allCharacteristicsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CharacteristicFilter>;
}>;

export type allCharacteristicsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: 'Characteristic' } & AdminCharacteristicFieldsFragment
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type CharacteristicQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type CharacteristicQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'Characteristic' } & AdminCharacteristicFieldsFragment
  >;
};

export type AdminCityFieldsFragment = { __typename?: 'City' } & Pick<
  City,
  | 'baseFee'
  | 'baseFeeStudent'
  | 'name'
  | 'id'
  | 'isActive'
  | 'isAvailabilityEnabled'
  | 'sessionUrl'
  | 'shortCode'
  | 'state'
  | 'postalCodeIds'
  | 'regionId'
> & {
    region?: Maybe<
      { __typename?: 'Region' } & Pick<Region, 'name' | 'id'> & {
          country?: Maybe<
            { __typename?: 'Country' } & Pick<Country, 'name' | 'id'>
          >;
        }
    >;
  };

export type allCitiesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CityFilter>;
}>;

export type allCitiesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'City' } & AdminCityFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type CityQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type CityQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'City' } & AdminCityFieldsFragment>;
};

export type createCityMutationVariables = Exact<{
  baseFee: Scalars['Float'];
  baseFeeStudent: Scalars['Float'];
  name: Scalars['String'];
  regionId: Scalars['UUID'];
  sessionUrl?: Maybe<Scalars['URL']>;
  shortCode: Scalars['String'];
}>;

export type createCityMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'City' } & AdminCityFieldsFragment>;
};

export type updateCityMutationVariables = Exact<{
  baseFee: Scalars['Float'];
  baseFeeStudent: Scalars['Float'];
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailabilityEnabled?: Maybe<Scalars['Boolean']>;
  sessionUrl?: Maybe<Scalars['URL']>;
  name?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['UUID']>;
  shortCode?: Maybe<Scalars['String']>;
  postalCodeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
}>;

export type updateCityMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'City' } & AdminCityFieldsFragment>;
};

export type AdminCountryFieldsFragment = { __typename?: 'Country' } & Pick<
  Country,
  'id' | 'name' | 'shortCode' | 'regions'
>;

export type allCountriesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<CountryFilter>;
}>;

export type allCountriesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'Country' } & AdminCountryFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type CountryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type CountryQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Country' } & AdminCountryFieldsFragment>;
};

export type updateCountryMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  regions?: Maybe<Scalars['String']>;
}>;

export type updateCountryMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Country' } & AdminCountryFieldsFragment>;
};

export type createCountryMutationVariables = Exact<{
  name: Scalars['String'];
  shortCode: Scalars['String'];
  regions: Scalars['String'];
}>;

export type createCountryMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Country' } & AdminCountryFieldsFragment>;
};

export type AdminDeviceLocationFieldsFragment = {
  __typename?: 'DeviceLocation';
} & Pick<
  DeviceLocation,
  | 'id'
  | 'accuracy'
  | 'batteryLevel'
  | 'recordedAt'
  | 'longitude'
  | 'latitude'
  | 'heading'
  | 'speed'
>;

export type allDeviceLocationsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<DeviceLocationFilter>;
}>;

export type allDeviceLocationsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: 'DeviceLocation' } & AdminDeviceLocationFieldsFragment
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type DeviceLocationQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type DeviceLocationQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'DeviceLocation' } & AdminDeviceLocationFieldsFragment
  >;
};

export type AdminEditableSettingFieldsFragment = {
  __typename?: 'EditableSetting';
} & Pick<
  EditableSetting,
  | 'id'
  | 'predictionLeadDays'
  | 'notificationBlockerWindowHours'
  | 'geoTrackingBufferTime'
  | 'advancedOperationalWindowStartTime'
  | 'advancedOperationalWindowEndTime'
  | 'automatedTestingEnabled'
  | 'isTimeManipulationEnabled'
  | 'serverDatetime'
  | 'featureFlagStudentGoingToBeLateSmsEnabled'
  | 'featureFlagStintSecondStartReminderEnabled'
  | 'availabilityMatchingBufferHours'
  | 'availabilityMatchingMaxOffersMonday'
  | 'availabilityMatchingMaxOffersTuesday'
  | 'availabilityMatchingMaxOffersWednesday'
  | 'availabilityMatchingMaxOffersThursday'
  | 'availabilityMatchingMaxOffersFriday'
  | 'availabilityMatchingMaxOffersSaturday'
  | 'availabilityMatchingMaxOffersSunday'
  | 'availabilityMatchingNotificationForNoOffersEnabled'
  | 'matchingAlgoNoOfferMaxCountPerTimeWindow'
  | 'matchingAlgoNoOfferTimeWindowSpan'
  | 'matchingAlgoNoOfferTitle'
  | 'matchingAlgoNoOfferMessage'
  | 'matchingAlgoNotificationDelayInMinutes'
  | 'featureFlagEtdNotificationsEnabled'
  | 'sendingStudentLeaveReminderAtRouteTimeEnabled'
  | 'studentCancellationOnHoldEmailEnabled'
  | 'etdCalculationBeforeMiddayOffsetInMinutes'
  | 'etdCalculationAfterMiddayOffsetInMinutes'
  | 'stintOfferExpiryThresholdInHours'
  | 'notificationTopUpThresholdInHours'
>;

export type allEditableSettingsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
}>;

export type allEditableSettingsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: 'EditableSetting' } & AdminEditableSettingFieldsFragment
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type EditableSettingQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type EditableSettingQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'EditableSetting' } & AdminEditableSettingFieldsFragment
  >;
};

export type updateEditableSettingMutationVariables = Exact<{
  predictionLeadDays?: Maybe<Scalars['Int']>;
  notificationBlockerWindowHours?: Maybe<Scalars['Float']>;
  geoTrackingBufferTime?: Maybe<Scalars['Int']>;
  advancedOperationalWindowStartTime?: Maybe<Scalars['Time']>;
  advancedOperationalWindowEndTime?: Maybe<Scalars['Time']>;
  automatedTestingEnabled?: Maybe<Scalars['Boolean']>;
  serverDatetime?: Maybe<Scalars['DateTime']>;
  featureFlagStudentGoingToBeLateSmsEnabled?: Maybe<Scalars['Boolean']>;
  featureFlagStintSecondStartReminderEnabled?: Maybe<Scalars['Boolean']>;
  availabilityMatchingBufferHours?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersMonday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersTuesday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersWednesday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersThursday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersFriday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersSaturday?: Maybe<Scalars['Int']>;
  availabilityMatchingMaxOffersSunday?: Maybe<Scalars['Int']>;
  availabilityMatchingNotificationForNoOffersEnabled?: Maybe<
    Scalars['Boolean']
  >;
  matchingAlgoNoOfferMaxCountPerTimeWindow?: Maybe<Scalars['Int']>;
  matchingAlgoNoOfferTimeWindowSpan?: Maybe<Scalars['Int']>;
  matchingAlgoNoOfferTitle?: Maybe<Scalars['String']>;
  matchingAlgoNoOfferMessage?: Maybe<Scalars['String']>;
  matchingAlgoNotificationDelayInMinutes?: Maybe<Scalars['Int']>;
  featureFlagEtdNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  sendingStudentLeaveReminderAtRouteTimeEnabled?: Maybe<Scalars['Boolean']>;
  studentCancellationOnHoldEmailEnabled?: Maybe<Scalars['Boolean']>;
  etdCalculationBeforeMiddayOffsetInMinutes?: Maybe<Scalars['Int']>;
  etdCalculationAfterMiddayOffsetInMinutes?: Maybe<Scalars['Int']>;
  stintOfferExpiryThresholdInHours?: Maybe<Scalars['Int']>;
  notificationTopUpThresholdInHours?: Maybe<Scalars['Int']>;
}>;

export type updateEditableSettingMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'EditableSetting' } & AdminEditableSettingFieldsFragment
  >;
};

export type EmployerUserFieldsFragment = {
  __typename?: 'UserRepresentationType';
} & Pick<
  UserRepresentationType,
  'id' | 'firstName' | 'lastName' | 'email' | 'emailVerified' | 'enabled'
> & {
    user?: Maybe<
      { __typename: 'StintUser' } & Pick<
        StintUser,
        | 'id'
        | 'profilePhotoUrl'
        | 'phoneNumber'
        | 'deactivated'
        | 'permanentDeactivated'
        | 'appVersion'
      >
    >;
  };

export type EmployerUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type EmployerUserQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'UserRepresentationType' } & EmployerUserFieldsFragment
  >;
};

export type allEmployerUsersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
}>;

export type allEmployerUsersQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: 'UserRepresentationType' } & EmployerUserFieldsFragment
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type AdminEmploymentExceptionFieldsFragment = {
  __typename?: 'EmploymentException';
} & Pick<EmploymentException, 'id' | 'name' | 'category'>;

export type allEmploymentExceptionsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<EmploymentExceptionFilter>;
}>;

export type allEmploymentExceptionsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        {
          __typename?: 'EmploymentException';
        } & AdminEmploymentExceptionFieldsFragment
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type EmploymentExceptionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type EmploymentExceptionQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    {
      __typename?: 'EmploymentException';
    } & AdminEmploymentExceptionFieldsFragment
  >;
};

export type createEmploymentExceptionMutationVariables = Exact<{
  name: Scalars['String'];
  category?: Maybe<EmploymentExceptionCategoryInputType>;
}>;

export type createEmploymentExceptionMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    {
      __typename?: 'EmploymentException';
    } & AdminEmploymentExceptionFieldsFragment
  >;
};

export type updateEmploymentExceptionMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  category?: Maybe<EmploymentExceptionCategoryInputType>;
}>;

export type updateEmploymentExceptionMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    {
      __typename?: 'EmploymentException';
    } & AdminEmploymentExceptionFieldsFragment
  >;
};

export type deleteEmploymentExceptionMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type deleteEmploymentExceptionMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    {
      __typename?: 'EmploymentException';
    } & AdminEmploymentExceptionFieldsFragment
  >;
};

export type AdminLanguageFieldsFragment = { __typename?: 'Language' } & Pick<
  Language,
  'id' | 'name'
>;

export type allLanguagesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<LanguageFilter>;
}>;

export type allLanguagesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'Language' } & AdminLanguageFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type LanguageQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type LanguageQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Language' } & AdminLanguageFieldsFragment>;
};

export type allNotificationStudentOrEmployerUsersQueryVariables = Exact<{
  filter?: Maybe<StintUserFilter>;
}>;

export type allNotificationStudentOrEmployerUsersQuery = {
  __typename?: 'Query';
} & {
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type AdminNotificationFieldsFragment = {
  __typename?: 'Notification';
} & Pick<
  Notification,
  | 'id'
  | 'createdAt'
  | 'status'
  | 'errorMessage'
  | 'title'
  | 'message'
  | 'sendTextMessage'
  | 'sendPushNotification'
  | 'recipientsCount'
  | 'openedCount'
  | 'notificationType'
> & {
    stint?: Maybe<{ __typename?: 'Stint' } & Pick<Stint, 'id' | 'name'>>;
    business?: Maybe<
      { __typename?: 'Business' } & Pick<Business, 'id' | 'name'>
    >;
  };

export type allNotificationsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<NotificationFilter>;
}>;

export type allNotificationsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename?: 'Notification' } & AdminNotificationFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type NotificationQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type NotificationQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'Notification' } & AdminNotificationFieldsFragment
  >;
};

export type createNotificationMutationVariables = Exact<{
  title: Scalars['String'];
  message: Scalars['String'];
  stint_id?: Maybe<Scalars['UUID']>;
  student_ids: Array<Maybe<Scalars['String']>>;
  sendPushNotification?: Maybe<Scalars['Boolean']>;
}>;

export type createNotificationMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'Notification' } & AdminNotificationFieldsFragment
  >;
};

export type OffenceBasicFieldsFragment = { __typename?: 'Offence' } & Pick<
  Offence,
  'id' | 'appealStatus' | 'reason' | 'strikesAwarded'
> & {
    business?: Maybe<
      { __typename?: 'Business' } & Pick<Business, 'id' | 'name'>
    >;
    stint?: Maybe<
      { __typename?: 'Stint' } & Pick<Stint, 'id' | 'stintTimesDisplay'>
    >;
  };

export type CreateOffenceMutationVariables = Exact<{
  createInputs: CreateOffenceInput;
}>;

export type CreateOffenceMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'Offence' } & Pick<
      Offence,
      'id' | 'appealStatus' | 'createdAt' | 'reason' | 'strikesAwarded'
    > & {
        business?: Maybe<
          { __typename?: 'Business' } & Pick<Business, 'id' | 'name'>
        >;
        stint?: Maybe<
          { __typename?: 'Stint' } & Pick<Stint, 'id' | 'stintTimesDisplay'>
        >;
        createdBy?: Maybe<
          { __typename?: 'StintUser' } & Pick<StintUser, 'id' | 'fullname'>
        >;
      }
  >;
};

export type OffenceQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type OffenceQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'Offence' } & Pick<Offence, 'createdAt' | 'reason'> & {
        createdBy?: Maybe<
          { __typename?: 'StintUser' } & Pick<StintUser, 'id' | 'fullname'>
        >;
        appeals: Array<
          { __typename?: 'Appeal' } & Pick<
            Appeal,
            'id' | 'status' | 'date' | 'notes' | 'decisionAt'
          > & {
              decisionBy?: Maybe<
                { __typename?: 'StintUser' } & Pick<
                  StintUser,
                  'id' | 'fullname'
                >
              >;
            }
        >;
      } & OffenceBasicFieldsFragment
  >;
};

export type stinterOffencesQueryVariables = Exact<{
  id: Scalars['UUID'];
  perPage: Scalars['Int'];
}>;

export type stinterOffencesQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'OffenceTypeConnection' } & {
      pageInfo: { __typename?: 'PageInfo' } & Pick<
        PageInfo,
        'hasNextPage' | 'endCursor'
      >;
      edges: Array<
        { __typename?: 'OffenceTypeEdge' } & {
          node: { __typename?: 'Offence' } & OffenceBasicFieldsFragment;
        }
      >;
    }
  >;
};

export type AdminPeriodicTaskFieldsFragment = {
  __typename?: 'PeriodicTask';
} & Pick<
  PeriodicTask,
  | 'id'
  | 'name'
  | 'lastRunAt'
  | 'enabled'
  | 'priority'
  | 'startTime'
  | 'totalRunCount'
  | 'dateChanged'
>;

export type allPeriodicTasksQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
}>;

export type allPeriodicTasksQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename?: 'PeriodicTask' } & AdminPeriodicTaskFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type PeriodicTaskQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type PeriodicTaskQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'PeriodicTask' } & AdminPeriodicTaskFieldsFragment
  >;
};

export type AdminPostalCodeFieldsFragment = {
  __typename?: 'PostalCode';
} & Pick<PostalCode, 'postalCode' | 'id' | 'city_id'>;

export type allPostalCodesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<PostalCodeFilter>;
}>;

export type allPostalCodesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'PostalCode' } & AdminPostalCodeFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type PostalCodeQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type PostalCodeQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'PostalCode' } & AdminPostalCodeFieldsFragment>;
};

export type createPostalCodeMutationVariables = Exact<{
  postalCode: Scalars['String'];
  city_id: Scalars['UUID'];
}>;

export type createPostalCodeMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'PostalCode' } & AdminPostalCodeFieldsFragment>;
};

export type updatePostalCodeMutationVariables = Exact<{
  id: Scalars['UUID'];
  postalCode?: Maybe<Scalars['String']>;
  city_id?: Maybe<Scalars['UUID']>;
}>;

export type updatePostalCodeMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'PostalCode' } & AdminPostalCodeFieldsFragment>;
};

export type AdminRegionFieldsFragment = { __typename?: 'Region' } & Pick<
  Region,
  'id' | 'name' | 'countryId'
> & {
    country?: Maybe<{ __typename?: 'Country' } & Pick<Country, 'name' | 'id'>>;
  };

export type allRegionsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<RegionFilter>;
}>;

export type allRegionsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'Region' } & AdminRegionFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type RegionQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type RegionQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Region' } & AdminRegionFieldsFragment>;
};

export type createRegionMutationVariables = Exact<{
  name: Scalars['String'];
  countryId: Scalars['UUID'];
}>;

export type createRegionMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Region' } & AdminRegionFieldsFragment>;
};

export type updateRegionMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  countryId?: Maybe<Scalars['UUID']>;
}>;

export type updateRegionMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Region' } & AdminRegionFieldsFragment>;
};

export type ListStintTemplatesQueryVariables = Exact<{
  businessId: Scalars['UUID'];
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
}>;

export type ListStintTemplatesQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'StintTemplateTypeListType' } & {
      objects?: Maybe<
        Array<
          Maybe<
            { __typename?: 'StintTemplate' } & Pick<
              StintTemplate,
              'id' | 'name'
            >
          >
        >
      >;
    }
  >;
};

export type StaffUserFieldsFragment = {
  __typename?: 'UserRepresentationType';
} & Pick<
  UserRepresentationType,
  'id' | 'username' | 'firstName' | 'lastName' | 'email' | 'enabled'
>;

export type AdminUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type AdminUserQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'UserRepresentationType' } & StaffUserFieldsFragment
  >;
};

export type allAdminUsersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
}>;

export type allAdminUsersQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename?: 'UserRepresentationType' } & StaffUserFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type AdminStintFieldsFragment = { __typename?: 'Stint' } & Pick<
  Stint,
  | 'id'
  | 'name'
  | 'status'
  | 'createdAt'
  | 'dateFrom'
  | 'dateTo'
  | 'checkInDate'
  | 'actualLeaveTime'
  | 'trained'
  | 'controlCheck'
  | 'isBestEffort'
  | 'notes'
  | 'uniform'
  | 'business_id'
  | 'displayAddress'
  | 'student_id'
  | 'cancelledTimeAhead'
  | 'cancelledAt'
  | 'cancelled_by_id'
> & {
    primaryTasks?: Maybe<
      Array<
        Maybe<{ __typename?: 'StintTask' } & Pick<StintTask, 'id' | 'name'>>
      >
    >;
    exceptions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'EmploymentException' } & Pick<
            EmploymentException,
            'id' | 'name'
          >
        >
      >
    >;
    stintRates: { __typename?: 'StintRates' } & Pick<
      StintRates,
      | 'baseFeeOverride'
      | 'totalFeeWithVat'
      | 'cancellationFee'
      | 'cancellationFeeApplied'
      | 'baseRateOverride'
      | 'basePay'
      | 'surgeRate'
      | 'surgePay'
      | 'surgeApplied'
      | 'bonusRate'
      | 'bonusPay'
      | 'bonusApplied'
    >;
  };

export type AdminStintListFieldsFragment = { __typename?: 'Stint' } & Pick<
  Stint,
  | 'id'
  | 'business_id'
  | 'createdAt'
  | 'dateFrom'
  | 'dateTo'
  | 'student_id'
  | 'status'
  | 'isBestEffort'
  | 'controlCheck'
  | 'city_id'
>;

export type allStintsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintFilter>;
}>;

export type allStintsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'Stint' } & AdminStintListFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StintQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StintQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Stint' } & AdminStintFieldsFragment>;
};

export type updateStintMutationVariables = Exact<{
  cancellationFee?: Maybe<Scalars['Float']>;
  cancellationFeeApplied?: Maybe<Scalars['Boolean']>;
  controlCheck?: Maybe<Scalars['Boolean']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  displayAddress?: Maybe<Scalars['String']>;
  exceptions?: Maybe<Array<Maybe<StintTemplateExceptionInput>>>;
  isBestEffort?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  primaryTasks?: Maybe<Array<Maybe<StintTemplateTaskInput>>>;
  student_id?: Maybe<Scalars['UUID']>;
  studentUnassignedReasons?: Maybe<Array<Maybe<StudentUnassignedReasons>>>;
  topTips?: Maybe<Array<Maybe<StintTemplateTopTipInput>>>;
  uniform?: Maybe<Array<Maybe<StintUniform>>>;
  baseFeeOverride?: Maybe<Scalars['Float']>;
  baseRateOverride?: Maybe<Scalars['Float']>;
  surgeRate?: Maybe<Scalars['Float']>;
}>;

export type updateStintMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Stint' } & AdminStintFieldsFragment>;
};

export type cancelStintsMutationVariables = Exact<{
  stintRefs: Array<Maybe<Scalars['UUID']>>;
}>;

export type cancelStintsMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'CancelStints' } & {
      entries?: Maybe<
        Array<Maybe<{ __typename?: 'Stint' } & Pick<Stint, 'id'>>>
      >;
    }
  >;
};

export type CreateStintsMutationVariables = Exact<{
  createInputs: CreateStintsInput;
}>;

export type CreateStintsMutation = { __typename?: 'Mutation' } & {
  createStints?: Maybe<
    Array<Maybe<{ __typename?: 'Stint' } & Pick<Stint, 'id'>>>
  >;
};

export type AdminStintJourneyFieldsFragment = {
  __typename?: 'StintJourney';
} & Pick<
  StintJourney,
  | 'estimatedTimeOfArrival'
  | 'estimatedTimeOfDeparture'
  | 'id'
  | 'internalNotes'
  | 'lateNote'
  | 'status'
  | 'statusResolved'
  | 'confirmationScreenAccepted'
  | 'isEtaBasedOnLatestLocation'
  | 'isGranularLocationTrackingEnabled'
  | 'usingNewLocationMicroservices'
  | 'student_id'
> & {
    business?: Maybe<
      { __typename?: 'Business' } & Pick<Business, 'id' | 'name'>
    >;
    studentInitialLocation?: Maybe<
      { __typename?: 'DeviceLocation' } & Pick<
        DeviceLocation,
        'longitude' | 'latitude'
      >
    >;
    stint?: Maybe<
      { __typename?: 'Stint' } & Pick<
        Stint,
        | 'longitude'
        | 'latitude'
        | 'business_id'
        | 'checkInDate'
        | 'dateFrom'
        | 'differentStartTimeReasons'
        | 'id'
      > & {
          address?: Maybe<
            { __typename?: 'Address' } & Pick<Address, 'id' | 'name'>
          >;
        }
    >;
  };

export type allStintJourneysQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintJourneyFilter>;
}>;

export type allStintJourneysQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename?: 'StintJourney' } & AdminStintJourneyFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StintJourneyQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StintJourneyQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'StintJourney' } & AdminStintJourneyFieldsFragment
  >;
};

export type updateStintJourneyMutationVariables = Exact<{
  id: Scalars['UUID'];
  estimatedTimeOfArrival?: Maybe<Scalars['DateTime']>;
  estimatedTimeOfDeparture?: Maybe<Scalars['DateTime']>;
  checkInDate?: Maybe<Scalars['DateTime']>;
  differentStartTimeReasons?: Maybe<Array<Maybe<DifferentStartTimeReason>>>;
  lateNote?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  statusResolved?: Maybe<Scalars['Boolean']>;
}>;

export type updateStintJourneyMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    { __typename?: 'StintJourney' } & AdminStintJourneyFieldsFragment
  >;
};

export type resolveStintJourneysMutationVariables = Exact<{
  ids: Array<Scalars['UUID']>;
}>;

export type resolveStintJourneysMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<
    Array<
      Maybe<{ __typename?: 'StintJourney' } & AdminStintJourneyFieldsFragment>
    >
  >;
};

export type AdminSingleStintTemplateFieldsFragment = {
  __typename?: 'StintTemplate';
} & Pick<
  StintTemplate,
  | 'id'
  | 'name'
  | 'business_id'
  | 'notes'
  | 'uniform'
  | 'prepVideoUrl'
  | 'trained'
> & {
    primaryTasks?: Maybe<
      Array<
        Maybe<{ __typename?: 'StintTask' } & Pick<StintTask, 'id' | 'name'>>
      >
    >;
    secondaryTasks?: Maybe<
      Array<
        Maybe<{ __typename?: 'StintTask' } & Pick<StintTask, 'id' | 'name'>>
      >
    >;
    exceptions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'EmploymentException' } & Pick<
            EmploymentException,
            'id' | 'name'
          >
        >
      >
    >;
  };

export type AdminStintTemplateFieldsFragment = {
  __typename?: 'StintTemplate';
} & Pick<
  StintTemplate,
  | 'id'
  | 'name'
  | 'business_id'
  | 'notes'
  | 'uniform'
  | 'prepVideoUrl'
  | 'trained'
> & {
    primaryTasks?: Maybe<
      Array<
        Maybe<{ __typename?: 'StintTask' } & Pick<StintTask, 'id' | 'name'>>
      >
    >;
    secondaryTasks?: Maybe<
      Array<
        Maybe<{ __typename?: 'StintTask' } & Pick<StintTask, 'id' | 'name'>>
      >
    >;
    exceptions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'EmploymentException' } & Pick<
            EmploymentException,
            'id' | 'name'
          >
        >
      >
    >;
  };

export type allStintTemplatesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintTemplateFilter>;
}>;

export type allStintTemplatesQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename?: 'StintTemplate' } & AdminStintTemplateFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StintTemplateQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StintTemplateQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename?: 'StintTemplate' } & AdminSingleStintTemplateFieldsFragment
  >;
};

export type updateStintTemplateMutationVariables = Exact<{
  input: UpdateStintTemplateInput;
}>;

export type updateStintTemplateMutation = { __typename?: 'Mutation' } & {
  data: {
    __typename?: 'StintTemplate';
  } & AdminSingleStintTemplateFieldsFragment;
};

export type AdminStintopediaFieldsFragment = {
  __typename?: 'Stintopedia';
} & Pick<
  Stintopedia,
  | 'aboutUs'
  | 'bookedOnboardingMeeting'
  | 'businessLogo'
  | 'characteristicIds'
  | 'donts'
  | 'dos'
  | 'emoji'
  | 'exceptionIds'
  | 'facebook'
  | 'generalPhoto1'
  | 'generalPhoto2'
  | 'generalPhoto3'
  | 'generalPhoto4'
  | 'id'
  | 'instagram'
  | 'internalNotes'
  | 'preferredLanguageIds'
  | 'lastEditTime'
  | 'linkedin'
  | 'photoOfEntrance'
  | 'prepVideoUrl'
  | 'qrCodeLocation'
  | 'teamStructure'
  | 'usingStintCorrectly'
  | 'website'
  | 'agreedTakePartInMarketingInitiatives'
  | 'agreedToReferFriendsIfFinancialMetricsImproved'
  | 'agreedToOperateStaffingRota'
  | 'accessToTransactionSalesData'
  | 'accessToRotaExamples'
  | 'accessToAnnualPlAccounts'
  | 'agreedToContinuePostingIfWeSeeDesireResults'
  | 'onboardingComplete'
> & {
    business?: Maybe<
      { __typename?: 'Business' } & Pick<Business, 'id' | 'logo' | 'name'>
    >;
    lastEditBy?: Maybe<
      { __typename?: 'StintUser' } & Pick<
        StintUser,
        'id' | 'email' | 'firstName' | 'lastName'
      >
    >;
  };

export type allStintopediasQueryVariables = Exact<{
  filter?: Maybe<StintopediaFilter>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
}>;

export type allStintopediasQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename?: 'Stintopedia' } & AdminStintopediaFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StintopediaQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StintopediaQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Stintopedia' } & AdminStintopediaFieldsFragment>;
};

export type updateStintopediaMutationVariables = Exact<{
  businessId: Scalars['UUID'];
  aboutUs?: Maybe<Scalars['String']>;
  accessToAnnualPlAccounts?: Maybe<Scalars['Boolean']>;
  accessToRotaExamples?: Maybe<Scalars['Boolean']>;
  accessToTransactionSalesData?: Maybe<Scalars['Boolean']>;
  agreedTakePartInMarketingInitiatives?: Maybe<Scalars['Boolean']>;
  agreedToContinuePostingIfWeSeeDesireResults?: Maybe<Scalars['Boolean']>;
  agreedToOperateStaffingRota?: Maybe<Scalars['Boolean']>;
  agreedToReferFriendsIfFinancialMetricsImproved?: Maybe<Scalars['Boolean']>;
  businessLogo?: Maybe<Scalars['String']>;
  characteristicIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  donts?: Maybe<Array<Maybe<Scalars['String']>>>;
  dos?: Maybe<Array<Maybe<Scalars['String']>>>;
  emoji?: Maybe<Scalars['String']>;
  exceptionIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  facebook?: Maybe<Scalars['String']>;
  generalPhoto1?: Maybe<Scalars['String']>;
  generalPhoto2?: Maybe<Scalars['String']>;
  generalPhoto3?: Maybe<Scalars['String']>;
  generalPhoto4?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  onboardingComplete?: Maybe<Scalars['Boolean']>;
  photoOfEntrance?: Maybe<Scalars['String']>;
  preferredLanguageIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  prepVideoUrl?: Maybe<Scalars['String']>;
  qrCodeLocation?: Maybe<Scalars['String']>;
  teamStructure?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
}>;

export type updateStintopediaMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Stintopedia' } & AdminStintopediaFieldsFragment>;
};

export type StudentUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StudentUserQuery = { __typename?: 'Query' } & {
  mono?: Maybe<
    { __typename?: 'UserRepresentationType' } & Pick<
      UserRepresentationType,
      'id' | 'firstName' | 'lastName' | 'email' | 'emailVerified' | 'enabled'
    > & {
        attributes?: Maybe<
          Array<
            Maybe<
              { __typename?: 'UserAttributeType' } & Pick<
                UserAttributeType,
                'name' | 'value'
              >
            >
          >
        >;
        user?: Maybe<
          { __typename: 'StintUser' } & Pick<
            StintUser,
            | 'id'
            | 'email'
            | 'secondaryEmail'
            | 'locationSetting'
            | 'profilePhotoUrl'
            | 'phoneNumber'
            | 'deactivated'
            | 'isVerifiedByStint'
            | 'permanentDeactivated'
            | 'appVersion'
            | 'dateOfBirth'
            | 'publicRating'
            | 'canSeeSurge'
          > & {
              exceptions?: Maybe<
                Array<
                  Maybe<
                    { __typename?: 'EmploymentException' } & Pick<
                      EmploymentException,
                      'id' | 'name'
                    >
                  >
                >
              >;
              studentProfile?: Maybe<
                { __typename: 'StudentProfile' } & Pick<
                  StudentProfile,
                  | 'id'
                  | 'university_id'
                  | 'emergencyContactName'
                  | 'emergencyContactNumber'
                  | 'emergencyContactRelation'
                  | 'employeeStatement'
                  | 'studentLoanPlan'
                  | 'strikesAwarded'
                > & {
                    paymentMethods?: Maybe<
                      Array<
                        Maybe<
                          { __typename: 'DirectDebitPaymentMethod' } & Pick<
                            DirectDebitPaymentMethod,
                            'accountName' | 'accountNumber' | 'sortCode'
                          >
                        >
                      >
                    >;
                  }
              >;
            }
        >;
      }
  >;
};

export type allStudentUsersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
}>;

export type allStudentUsersQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: 'UserRepresentationType' } & Pick<
          UserRepresentationType,
          'id' | 'firstName' | 'lastName' | 'email'
        > & {
            attributes?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'UserAttributeType' } & Pick<
                    UserAttributeType,
                    'name' | 'value'
                  >
                >
              >
            >;
            user?: Maybe<
              { __typename: 'StintUser' } & Pick<
                StintUser,
                'id' | 'dateOfBirth' | 'profilePhotoUrl' | 'appVersion'
              >
            >;
          }
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type AdminStudentReviewFieldsFragment = {
  __typename?: 'StudentReview';
} & Pick<StudentReview, 'id' | 'student_id' | 'rating' | 'isInternalReview'> & {
    stint?: Maybe<
      { __typename?: 'Stint' } & Pick<
        Stint,
        'name' | 'status' | 'dateFrom' | 'dateTo' | 'business_id'
      >
    >;
  };

export type allStudentReviewsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StudentReviewFilter>;
}>;

export type allStudentReviewsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<{ __typename: 'StudentReview' } & AdminStudentReviewFieldsFragment>
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StudentReviewQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StudentReviewQuery = { __typename?: 'Query' } & {
  data?: Maybe<
    { __typename: 'StudentReview' } & AdminStudentReviewFieldsFragment
  >;
};

export type AdminTagFieldsFragment = { __typename?: 'Tag' } & Pick<
  Tag,
  'id' | 'name' | 'description' | 'createdAt'
>;

export type allTagsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
}>;

export type allTagsQuery = { __typename?: 'Query' } & {
  items?: Maybe<Array<Maybe<{ __typename?: 'Tag' } & AdminTagFieldsFragment>>>;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type TagQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type TagQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'Tag' } & AdminTagFieldsFragment>;
};

export type createTagMutationVariables = Exact<{
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;

export type createTagMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Tag' } & AdminTagFieldsFragment>;
};

export type updateTagMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
}>;

export type updateTagMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'Tag' } & AdminTagFieldsFragment>;
};

export type AdminStintTaskFieldsFragment = { __typename?: 'StintTask' } & Pick<
  StintTask,
  | 'id'
  | 'name'
  | 'taskType'
  | 'totalNumberBusinessesPosted'
  | 'totalNumberPostedTask'
  | 'averageStudentRatingPosted'
  | 'averageBusinessRatingPosted'
> & {
    topTips?: Maybe<
      Array<Maybe<{ __typename?: 'TopTip' } & Pick<TopTip, 'name' | 'id'>>>
    >;
  };

export type allStintTasksQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintTaskFilter>;
}>;

export type allStintTasksQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'StintTask' } & AdminStintTaskFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StintTaskQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StintTaskQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'StintTask' } & AdminStintTaskFieldsFragment>;
};

export type updateStintTaskMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  taskType?: Maybe<Scalars['String']>;
  topTips?: Maybe<Array<Maybe<TaskTopTipInput>>>;
}>;

export type updateStintTaskMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'StintTask' } & AdminStintTaskFieldsFragment>;
};

export type createStintTaskMutationVariables = Exact<{
  name: Scalars['String'];
  taskType?: Maybe<Scalars['String']>;
}>;

export type createStintTaskMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'StintTask' } & AdminStintTaskFieldsFragment>;
};

export type AdminTopTipFieldsFragment = { __typename?: 'TopTip' } & Pick<
  TopTip,
  'id' | 'name' | 'task_id'
>;

export type allTopTipsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<TopTipFilter>;
}>;

export type allTopTipsQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<Maybe<{ __typename?: 'TopTip' } & AdminTopTipFieldsFragment>>
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type TopTipQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type TopTipQuery = { __typename?: 'Query' } & {
  data?: Maybe<{ __typename?: 'TopTip' } & AdminTopTipFieldsFragment>;
};

export type updateTopTipMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
}>;

export type updateTopTipMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'TopTip' } & AdminTopTipFieldsFragment>;
};

export type createTopTipMutationVariables = Exact<{
  name: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  taskId?: Maybe<Scalars['UUID']>;
}>;

export type createTopTipMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'TopTip' } & AdminTopTipFieldsFragment>;
};

export type AdminStintUserFieldsFragment = { __typename?: 'StintUser' } & Pick<
  StintUser,
  | 'id'
  | 'firstName'
  | 'lastName'
  | 'locationSetting'
  | 'userType'
  | 'fullname'
  | 'profilePhotoUrl'
  | 'phoneNumber'
  | 'deactivated'
  | 'isVerifiedByStint'
  | 'isEmailVerified'
  | 'otp'
  | 'permanentDeactivated'
  | 'email'
  | 'secondaryEmail'
  | 'appVersion'
  | 'dateOfBirth'
  | 'isStudent'
  | 'isEmployer'
  | 'publicRating'
  | 'canSeeSurge'
> & {
    city?: Maybe<{ __typename?: 'City' } & Pick<City, 'name'>>;
    currentCity?: Maybe<{ __typename?: 'City' } & Pick<City, 'name' | 'id'>>;
    exceptions?: Maybe<
      Array<
        Maybe<
          { __typename?: 'EmploymentException' } & Pick<
            EmploymentException,
            'id' | 'name'
          >
        >
      >
    >;
    studentProfile?: Maybe<
      { __typename?: 'StudentProfile' } & Pick<
        StudentProfile,
        | 'id'
        | 'university_id'
        | 'emergencyContactName'
        | 'emergencyContactNumber'
        | 'emergencyContactRelation'
        | 'employeeStatement'
        | 'studentLoanPlan'
        | 'strikesAwarded'
      > & {
          paymentMethods?: Maybe<
            Array<
              Maybe<
                { __typename?: 'DirectDebitPaymentMethod' } & Pick<
                  DirectDebitPaymentMethod,
                  'accountName' | 'accountNumber' | 'sortCode'
                >
              >
            >
          >;
        }
    >;
  };

export type allStudentOrEmployerUsersQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  sortField?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['String']>;
  filter?: Maybe<StintUserFilter>;
}>;

export type allStudentOrEmployerUsersQuery = { __typename?: 'Query' } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: 'StintUser' } & Pick<
          StintUser,
          'id' | 'firstName' | 'lastName' | 'fullname' | 'email'
        >
      >
    >
  >;
  total?: Maybe<{ __typename: 'ListMetadata' } & Pick<ListMetadata, 'count'>>;
};

export type StintUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type StintUserQuery = { __typename?: 'Query' } & {
  mono?: Maybe<{ __typename?: 'StintUser' } & AdminStintUserFieldsFragment>;
};

export type updateStintUserMutationVariables = Exact<{
  id: Scalars['UUID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  exceptions?: Maybe<Array<Maybe<StintTemplateExceptionInput>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  permanentDeactivated?: Maybe<Scalars['Boolean']>;
  studentProfile?: Maybe<StudentProfileInput>;
  paymentMethod?: Maybe<PaymentMethodInput>;
}>;

export type updateStintUserMutation = { __typename?: 'Mutation' } & {
  data?: Maybe<{ __typename?: 'StintUser' } & AdminStintUserFieldsFragment>;
};

export const AdminAddressFieldsFragmentDoc = gql`
  fragment AdminAddressFields on Address {
    id
    name
    placeId
  }
`;
export const AdminBusinessFieldsFragmentDoc = gql`
  fragment AdminBusinessFields on Business {
    id
    address {
      cityFk {
        id
        name
      }
      postalCode
    }
    city {
      id
      name
      baseFee
    }
    averageRating
    createdAt
    ltdName
    displayAddress
    exemptFromPaymentDetails
    integrated
    name
    logo
    repeatStintersEnabled
    phoneNumber
    placeId
    qrCodeId
    rateOverride {
      rate
    }
    salesRepresentitive {
      id
      email
      firstName
      lastName
    }
    status
    unlockedLastMinuteStints
    controlCheck
    isBlockedByFinance
    stintopedia {
      id
      bookedOnboardingMeeting
      usingStintCorrectly
    }
  }
`;
export const AdminCharacteristicFieldsFragmentDoc = gql`
  fragment AdminCharacteristicFields on Characteristic {
    id
    name
  }
`;
export const AdminCityFieldsFragmentDoc = gql`
  fragment AdminCityFields on City {
    baseFee
    baseFeeStudent
    name
    id
    isActive
    isAvailabilityEnabled
    sessionUrl
    shortCode
    state
    postalCodeIds
    region {
      name
      id
      country {
        name
        id
      }
    }
    regionId
  }
`;
export const AdminCountryFieldsFragmentDoc = gql`
  fragment AdminCountryFields on Country {
    id
    name
    shortCode
    regions
  }
`;
export const AdminDeviceLocationFieldsFragmentDoc = gql`
  fragment AdminDeviceLocationFields on DeviceLocation {
    id
    accuracy
    batteryLevel
    recordedAt
    longitude
    latitude
    heading
    speed
  }
`;
export const AdminEditableSettingFieldsFragmentDoc = gql`
  fragment AdminEditableSettingFields on EditableSetting {
    id
    predictionLeadDays
    notificationBlockerWindowHours
    geoTrackingBufferTime
    advancedOperationalWindowStartTime
    advancedOperationalWindowEndTime
    automatedTestingEnabled
    isTimeManipulationEnabled
    serverDatetime
    featureFlagStudentGoingToBeLateSmsEnabled
    featureFlagStintSecondStartReminderEnabled
    availabilityMatchingBufferHours
    availabilityMatchingMaxOffersMonday
    availabilityMatchingMaxOffersTuesday
    availabilityMatchingMaxOffersWednesday
    availabilityMatchingMaxOffersThursday
    availabilityMatchingMaxOffersFriday
    availabilityMatchingMaxOffersSaturday
    availabilityMatchingMaxOffersSunday
    availabilityMatchingNotificationForNoOffersEnabled
    matchingAlgoNoOfferMaxCountPerTimeWindow
    matchingAlgoNoOfferTimeWindowSpan
    matchingAlgoNoOfferTitle
    matchingAlgoNoOfferMessage
    matchingAlgoNotificationDelayInMinutes
    featureFlagEtdNotificationsEnabled
    sendingStudentLeaveReminderAtRouteTimeEnabled
    studentCancellationOnHoldEmailEnabled
    etdCalculationBeforeMiddayOffsetInMinutes
    etdCalculationAfterMiddayOffsetInMinutes
    stintOfferExpiryThresholdInHours
    notificationTopUpThresholdInHours
  }
`;
export const EmployerUserFieldsFragmentDoc = gql`
  fragment EmployerUserFields on UserRepresentationType {
    id
    firstName
    lastName
    email
    emailVerified
    enabled
    user {
      id
      profilePhotoUrl
      phoneNumber
      deactivated
      permanentDeactivated
      appVersion
      __typename
    }
  }
`;
export const AdminEmploymentExceptionFieldsFragmentDoc = gql`
  fragment AdminEmploymentExceptionFields on EmploymentException {
    id
    name
    category
  }
`;
export const AdminLanguageFieldsFragmentDoc = gql`
  fragment AdminLanguageFields on Language {
    id
    name
  }
`;
export const AdminNotificationFieldsFragmentDoc = gql`
  fragment AdminNotificationFields on Notification {
    id
    createdAt
    status
    errorMessage
    title
    message
    stint {
      id
      name
    }
    business {
      id
      name
    }
    sendTextMessage
    sendPushNotification
    recipientsCount
    openedCount
    notificationType
  }
`;
export const OffenceBasicFieldsFragmentDoc = gql`
  fragment OffenceBasicFields on Offence {
    id
    appealStatus
    business {
      id
      name
    }
    reason
    stint {
      id
      stintTimesDisplay
    }
    strikesAwarded
  }
`;
export const AdminPeriodicTaskFieldsFragmentDoc = gql`
  fragment AdminPeriodicTaskFields on PeriodicTask {
    id
    name
    lastRunAt
    enabled
    priority
    startTime
    totalRunCount
    dateChanged
  }
`;
export const AdminPostalCodeFieldsFragmentDoc = gql`
  fragment AdminPostalCodeFields on PostalCode {
    postalCode
    id
    city_id
  }
`;
export const AdminRegionFieldsFragmentDoc = gql`
  fragment AdminRegionFields on Region {
    id
    name
    country {
      name
      id
    }
    countryId
  }
`;
export const StaffUserFieldsFragmentDoc = gql`
  fragment StaffUserFields on UserRepresentationType {
    id
    username
    firstName
    lastName
    email
    enabled
  }
`;
export const AdminStintFieldsFragmentDoc = gql`
  fragment AdminStintFields on Stint {
    id
    name
    status
    createdAt
    dateFrom
    dateTo
    checkInDate
    actualLeaveTime
    trained
    controlCheck
    isBestEffort
    notes
    primaryTasks {
      id
      name
    }
    exceptions {
      id
      name
    }
    uniform
    business_id
    displayAddress
    student_id
    stintRates {
      baseFeeOverride
      totalFeeWithVat
      cancellationFee
      cancellationFeeApplied
      baseRateOverride
      basePay
      surgeRate
      surgePay
      surgeApplied
      bonusRate
      bonusPay
      bonusApplied
    }
    cancelledTimeAhead
    cancelledAt
    cancelled_by_id
  }
`;
export const AdminStintListFieldsFragmentDoc = gql`
  fragment AdminStintListFields on Stint {
    id
    business_id
    createdAt
    dateFrom
    dateTo
    student_id
    status
    isBestEffort
    controlCheck
    city_id
  }
`;
export const AdminStintJourneyFieldsFragmentDoc = gql`
  fragment AdminStintJourneyFields on StintJourney {
    estimatedTimeOfArrival
    estimatedTimeOfDeparture
    id
    internalNotes
    business {
      id
      name
    }
    lateNote
    status
    statusResolved
    confirmationScreenAccepted
    studentInitialLocation {
      longitude
      latitude
    }
    isEtaBasedOnLatestLocation
    isGranularLocationTrackingEnabled
    usingNewLocationMicroservices
    stint {
      longitude
      latitude
      business_id
      checkInDate
      dateFrom
      differentStartTimeReasons
      id
      address {
        id
        name
      }
    }
    student_id
  }
`;
export const AdminSingleStintTemplateFieldsFragmentDoc = gql`
  fragment AdminSingleStintTemplateFields on StintTemplate {
    id
    name
    business_id
    notes
    uniform
    primaryTasks {
      id
      name
    }
    secondaryTasks {
      id
      name
    }
    exceptions {
      id
      name
    }
    prepVideoUrl
    trained
  }
`;
export const AdminStintTemplateFieldsFragmentDoc = gql`
  fragment AdminStintTemplateFields on StintTemplate {
    id
    name
    business_id
    notes
    uniform
    primaryTasks {
      id
      name
    }
    secondaryTasks {
      id
      name
    }
    exceptions {
      id
      name
    }
    prepVideoUrl
    trained
  }
`;
export const AdminStintopediaFieldsFragmentDoc = gql`
  fragment AdminStintopediaFields on Stintopedia {
    aboutUs
    bookedOnboardingMeeting
    business {
      id
      logo
      name
    }
    businessLogo
    characteristicIds
    donts
    dos
    emoji
    exceptionIds
    facebook
    generalPhoto1
    generalPhoto2
    generalPhoto3
    generalPhoto4
    id
    instagram
    internalNotes
    preferredLanguageIds
    lastEditBy {
      id
      email
      firstName
      lastName
    }
    lastEditTime
    linkedin
    photoOfEntrance
    prepVideoUrl
    qrCodeLocation
    teamStructure
    usingStintCorrectly
    website
    agreedTakePartInMarketingInitiatives
    agreedToReferFriendsIfFinancialMetricsImproved
    agreedToOperateStaffingRota
    accessToTransactionSalesData
    accessToRotaExamples
    accessToAnnualPlAccounts
    agreedToContinuePostingIfWeSeeDesireResults
    onboardingComplete
  }
`;
export const AdminStudentReviewFieldsFragmentDoc = gql`
  fragment AdminStudentReviewFields on StudentReview {
    id
    stint {
      name
      status
      dateFrom
      dateTo
      business_id
    }
    student_id
    rating
    isInternalReview
  }
`;
export const AdminTagFieldsFragmentDoc = gql`
  fragment AdminTagFields on Tag {
    id
    name
    description
    createdAt
  }
`;
export const AdminStintTaskFieldsFragmentDoc = gql`
  fragment AdminStintTaskFields on StintTask {
    id
    name
    taskType
    totalNumberBusinessesPosted
    totalNumberPostedTask
    averageStudentRatingPosted
    averageBusinessRatingPosted
    topTips {
      name
      id
    }
  }
`;
export const AdminTopTipFieldsFragmentDoc = gql`
  fragment AdminTopTipFields on TopTip {
    id
    name
    task_id
  }
`;
export const AdminStintUserFieldsFragmentDoc = gql`
  fragment AdminStintUserFields on StintUser {
    id
    firstName
    lastName
    locationSetting
    userType
    fullname
    profilePhotoUrl
    phoneNumber
    deactivated
    isVerifiedByStint
    isEmailVerified
    otp
    city {
      name
    }
    currentCity {
      name
      id
    }
    permanentDeactivated
    email
    secondaryEmail
    appVersion
    dateOfBirth
    isStudent
    exceptions {
      id
      name
    }
    isEmployer
    studentProfile {
      id
      university_id
      emergencyContactName
      emergencyContactNumber
      emergencyContactRelation
      employeeStatement
      studentLoanPlan
      strikesAwarded
      paymentMethods {
        accountName
        accountNumber
        sortCode
      }
    }
    publicRating
    canSeeSurge
  }
`;
export const BulkUpdateCanSeeSurgeDocument = gql`
  mutation BulkUpdateCanSeeSurge($canSeeSurge: Boolean!, $userFile: String!) {
    bulkUpdateCanSeeSurge(canSeeSurge: $canSeeSurge, userFile: $userFile) {
      message
      success
    }
  }
`;
export type BulkUpdateCanSeeSurgeMutationFn = ApolloReactCommon.MutationFunction<
  BulkUpdateCanSeeSurgeMutation,
  BulkUpdateCanSeeSurgeMutationVariables
>;
export type BulkUpdateCanSeeSurgeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables
  >,
  'mutation'
>;

export const BulkUpdateCanSeeSurgeComponent = (
  props: BulkUpdateCanSeeSurgeComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables
  >
    mutation={BulkUpdateCanSeeSurgeDocument}
    {...props}
  />
);

export type BulkUpdateCanSeeSurgeProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables
  >;
} &
  TChildProps;
export function withBulkUpdateCanSeeSurge<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables,
    BulkUpdateCanSeeSurgeProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables,
    BulkUpdateCanSeeSurgeProps<TChildProps, TDataName>
  >(BulkUpdateCanSeeSurgeDocument, {
    alias: 'bulkUpdateCanSeeSurge',
    ...operationOptions,
  });
}

/**
 * __useBulkUpdateCanSeeSurgeMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCanSeeSurgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCanSeeSurgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCanSeeSurgeMutation, { data, loading, error }] = useBulkUpdateCanSeeSurgeMutation({
 *   variables: {
 *      canSeeSurge: // value for 'canSeeSurge'
 *      userFile: // value for 'userFile'
 *   },
 * });
 */
export function useBulkUpdateCanSeeSurgeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    BulkUpdateCanSeeSurgeMutation,
    BulkUpdateCanSeeSurgeMutationVariables
  >(BulkUpdateCanSeeSurgeDocument, baseOptions);
}
export type BulkUpdateCanSeeSurgeMutationHookResult = ReturnType<
  typeof useBulkUpdateCanSeeSurgeMutation
>;
export type BulkUpdateCanSeeSurgeMutationResult = ApolloReactCommon.MutationResult<BulkUpdateCanSeeSurgeMutation>;
export type BulkUpdateCanSeeSurgeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  BulkUpdateCanSeeSurgeMutation,
  BulkUpdateCanSeeSurgeMutationVariables
>;
export const ManualGeotrackingStatusUpdateDocument = gql`
  mutation ManualGeotrackingStatusUpdate($id: UUID!) {
    manualGeotrackingStatusUpdate(id: $id) {
      id
    }
  }
`;
export type ManualGeotrackingStatusUpdateMutationFn = ApolloReactCommon.MutationFunction<
  ManualGeotrackingStatusUpdateMutation,
  ManualGeotrackingStatusUpdateMutationVariables
>;
export type ManualGeotrackingStatusUpdateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables
  >,
  'mutation'
>;

export const ManualGeotrackingStatusUpdateComponent = (
  props: ManualGeotrackingStatusUpdateComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables
  >
    mutation={ManualGeotrackingStatusUpdateDocument}
    {...props}
  />
);

export type ManualGeotrackingStatusUpdateProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables
  >;
} &
  TChildProps;
export function withManualGeotrackingStatusUpdate<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables,
    ManualGeotrackingStatusUpdateProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables,
    ManualGeotrackingStatusUpdateProps<TChildProps, TDataName>
  >(ManualGeotrackingStatusUpdateDocument, {
    alias: 'manualGeotrackingStatusUpdate',
    ...operationOptions,
  });
}

/**
 * __useManualGeotrackingStatusUpdateMutation__
 *
 * To run a mutation, you first call `useManualGeotrackingStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualGeotrackingStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualGeotrackingStatusUpdateMutation, { data, loading, error }] = useManualGeotrackingStatusUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManualGeotrackingStatusUpdateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    ManualGeotrackingStatusUpdateMutation,
    ManualGeotrackingStatusUpdateMutationVariables
  >(ManualGeotrackingStatusUpdateDocument, baseOptions);
}
export type ManualGeotrackingStatusUpdateMutationHookResult = ReturnType<
  typeof useManualGeotrackingStatusUpdateMutation
>;
export type ManualGeotrackingStatusUpdateMutationResult = ApolloReactCommon.MutationResult<ManualGeotrackingStatusUpdateMutation>;
export type ManualGeotrackingStatusUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  ManualGeotrackingStatusUpdateMutation,
  ManualGeotrackingStatusUpdateMutationVariables
>;
export const SearchGooglePlacesDocument = gql`
  mutation SearchGooglePlaces(
    $searchTerm: String!
    $returnType: GooglePlacesReturnType
  ) {
    searchGooglePlaces(searchTerm: $searchTerm, returnType: $returnType) {
      predictions {
        placeId
        displayAddress
      }
    }
  }
`;
export type SearchGooglePlacesMutationFn = ApolloReactCommon.MutationFunction<
  SearchGooglePlacesMutation,
  SearchGooglePlacesMutationVariables
>;
export type SearchGooglePlacesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables
  >,
  'mutation'
>;

export const SearchGooglePlacesComponent = (
  props: SearchGooglePlacesComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables
  >
    mutation={SearchGooglePlacesDocument}
    {...props}
  />
);

export type SearchGooglePlacesProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables
  >;
} &
  TChildProps;
export function withSearchGooglePlaces<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables,
    SearchGooglePlacesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables,
    SearchGooglePlacesProps<TChildProps, TDataName>
  >(SearchGooglePlacesDocument, {
    alias: 'searchGooglePlaces',
    ...operationOptions,
  });
}

/**
 * __useSearchGooglePlacesMutation__
 *
 * To run a mutation, you first call `useSearchGooglePlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchGooglePlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchGooglePlacesMutation, { data, loading, error }] = useSearchGooglePlacesMutation({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      returnType: // value for 'returnType'
 *   },
 * });
 */
export function useSearchGooglePlacesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    SearchGooglePlacesMutation,
    SearchGooglePlacesMutationVariables
  >(SearchGooglePlacesDocument, baseOptions);
}
export type SearchGooglePlacesMutationHookResult = ReturnType<
  typeof useSearchGooglePlacesMutation
>;
export type SearchGooglePlacesMutationResult = ApolloReactCommon.MutationResult<SearchGooglePlacesMutation>;
export type SearchGooglePlacesMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SearchGooglePlacesMutation,
  SearchGooglePlacesMutationVariables
>;
export const sendOtpEmailDocument = gql`
  mutation sendOtpEmail($email: String!) {
    sendOtpEmail(email: $email) {
      success
      __typename
    }
  }
`;
export type sendOtpEmailMutationFn = ApolloReactCommon.MutationFunction<
  sendOtpEmailMutation,
  sendOtpEmailMutationVariables
>;
export type sendOtpEmailComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables
  >,
  'mutation'
>;

export const sendOtpEmailComponent = (props: sendOtpEmailComponentProps) => (
  <ApolloReactComponents.Mutation<
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables
  >
    mutation={sendOtpEmailDocument}
    {...props}
  />
);

export type sendOtpEmailProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables
  >;
} &
  TChildProps;
export function withsendOtpEmail<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables,
    sendOtpEmailProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables,
    sendOtpEmailProps<TChildProps, TDataName>
  >(sendOtpEmailDocument, {
    alias: 'sendOtpEmail',
    ...operationOptions,
  });
}

/**
 * __usesendOtpEmailMutation__
 *
 * To run a mutation, you first call `usesendOtpEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usesendOtpEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpEmailMutation, { data, loading, error }] = usesendOtpEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usesendOtpEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    sendOtpEmailMutation,
    sendOtpEmailMutationVariables
  >(sendOtpEmailDocument, baseOptions);
}
export type sendOtpEmailMutationHookResult = ReturnType<
  typeof usesendOtpEmailMutation
>;
export type sendOtpEmailMutationResult = ApolloReactCommon.MutationResult<sendOtpEmailMutation>;
export type sendOtpEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<
  sendOtpEmailMutation,
  sendOtpEmailMutationVariables
>;
export const SendOtpSmsV2Document = gql`
  mutation SendOtpSmsV2($userId: String!) {
    sendOtpSmsV2(userId: $userId) {
      success
    }
  }
`;
export type SendOtpSmsV2MutationFn = ApolloReactCommon.MutationFunction<
  SendOtpSmsV2Mutation,
  SendOtpSmsV2MutationVariables
>;
export type SendOtpSmsV2ComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables
  >,
  'mutation'
>;

export const SendOtpSmsV2Component = (props: SendOtpSmsV2ComponentProps) => (
  <ApolloReactComponents.Mutation<
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables
  >
    mutation={SendOtpSmsV2Document}
    {...props}
  />
);

export type SendOtpSmsV2Props<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables
  >;
} &
  TChildProps;
export function withSendOtpSmsV2<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables,
    SendOtpSmsV2Props<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables,
    SendOtpSmsV2Props<TChildProps, TDataName>
  >(SendOtpSmsV2Document, {
    alias: 'sendOtpSmsV2',
    ...operationOptions,
  });
}

/**
 * __useSendOtpSmsV2Mutation__
 *
 * To run a mutation, you first call `useSendOtpSmsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpSmsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpSmsV2Mutation, { data, loading, error }] = useSendOtpSmsV2Mutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSendOtpSmsV2Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    SendOtpSmsV2Mutation,
    SendOtpSmsV2MutationVariables
  >(SendOtpSmsV2Document, baseOptions);
}
export type SendOtpSmsV2MutationHookResult = ReturnType<
  typeof useSendOtpSmsV2Mutation
>;
export type SendOtpSmsV2MutationResult = ApolloReactCommon.MutationResult<SendOtpSmsV2Mutation>;
export type SendOtpSmsV2MutationOptions = ApolloReactCommon.BaseMutationOptions<
  SendOtpSmsV2Mutation,
  SendOtpSmsV2MutationVariables
>;
export const verifyStudentUserDocument = gql`
  mutation verifyStudentUser($studentUserIds: [UUID]!) {
    data: verifyStudentUser(studentUserIds: $studentUserIds) {
      success
    }
  }
`;
export type verifyStudentUserMutationFn = ApolloReactCommon.MutationFunction<
  verifyStudentUserMutation,
  verifyStudentUserMutationVariables
>;
export type verifyStudentUserComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables
  >,
  'mutation'
>;

export const verifyStudentUserComponent = (
  props: verifyStudentUserComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables
  >
    mutation={verifyStudentUserDocument}
    {...props}
  />
);

export type verifyStudentUserProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables
  >;
} &
  TChildProps;
export function withverifyStudentUser<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables,
    verifyStudentUserProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables,
    verifyStudentUserProps<TChildProps, TDataName>
  >(verifyStudentUserDocument, {
    alias: 'verifyStudentUser',
    ...operationOptions,
  });
}

/**
 * __useverifyStudentUserMutation__
 *
 * To run a mutation, you first call `useverifyStudentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useverifyStudentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyStudentUserMutation, { data, loading, error }] = useverifyStudentUserMutation({
 *   variables: {
 *      studentUserIds: // value for 'studentUserIds'
 *   },
 * });
 */
export function useverifyStudentUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    verifyStudentUserMutation,
    verifyStudentUserMutationVariables
  >(verifyStudentUserDocument, baseOptions);
}
export type verifyStudentUserMutationHookResult = ReturnType<
  typeof useverifyStudentUserMutation
>;
export type verifyStudentUserMutationResult = ApolloReactCommon.MutationResult<verifyStudentUserMutation>;
export type verifyStudentUserMutationOptions = ApolloReactCommon.BaseMutationOptions<
  verifyStudentUserMutation,
  verifyStudentUserMutationVariables
>;
export const CountStudentsCanSeeSurgeDocument = gql`
  query CountStudentsCanSeeSurge {
    countStudentsCanSeeSurge
  }
`;
export type CountStudentsCanSeeSurgeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >,
  'query'
>;

export const CountStudentsCanSeeSurgeComponent = (
  props: CountStudentsCanSeeSurgeComponentProps,
) => (
  <ApolloReactComponents.Query<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >
    query={CountStudentsCanSeeSurgeDocument}
    {...props}
  />
);

export type CountStudentsCanSeeSurgeProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >;
} &
  TChildProps;
export function withCountStudentsCanSeeSurge<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables,
    CountStudentsCanSeeSurgeProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables,
    CountStudentsCanSeeSurgeProps<TChildProps, TDataName>
  >(CountStudentsCanSeeSurgeDocument, {
    alias: 'countStudentsCanSeeSurge',
    ...operationOptions,
  });
}

/**
 * __useCountStudentsCanSeeSurgeQuery__
 *
 * To run a query within a React component, call `useCountStudentsCanSeeSurgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountStudentsCanSeeSurgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountStudentsCanSeeSurgeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountStudentsCanSeeSurgeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >(CountStudentsCanSeeSurgeDocument, baseOptions);
}
export function useCountStudentsCanSeeSurgeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    CountStudentsCanSeeSurgeQuery,
    CountStudentsCanSeeSurgeQueryVariables
  >(CountStudentsCanSeeSurgeDocument, baseOptions);
}
export type CountStudentsCanSeeSurgeQueryHookResult = ReturnType<
  typeof useCountStudentsCanSeeSurgeQuery
>;
export type CountStudentsCanSeeSurgeLazyQueryHookResult = ReturnType<
  typeof useCountStudentsCanSeeSurgeLazyQuery
>;
export type CountStudentsCanSeeSurgeQueryResult = ApolloReactCommon.QueryResult<
  CountStudentsCanSeeSurgeQuery,
  CountStudentsCanSeeSurgeQueryVariables
>;
export const UpdateActualLeaveTimeDocument = gql`
  mutation UpdateActualLeaveTime($updateInputs: UpdateActualLeaveTimeInput!) {
    data: updateActualLeaveTime(updateInputs: $updateInputs) {
      id
      actualLeaveTime
    }
  }
`;
export type UpdateActualLeaveTimeMutationFn = ApolloReactCommon.MutationFunction<
  UpdateActualLeaveTimeMutation,
  UpdateActualLeaveTimeMutationVariables
>;
export type UpdateActualLeaveTimeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables
  >,
  'mutation'
>;

export const UpdateActualLeaveTimeComponent = (
  props: UpdateActualLeaveTimeComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables
  >
    mutation={UpdateActualLeaveTimeDocument}
    {...props}
  />
);

export type UpdateActualLeaveTimeProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables
  >;
} &
  TChildProps;
export function withUpdateActualLeaveTime<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables,
    UpdateActualLeaveTimeProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables,
    UpdateActualLeaveTimeProps<TChildProps, TDataName>
  >(UpdateActualLeaveTimeDocument, {
    alias: 'updateActualLeaveTime',
    ...operationOptions,
  });
}

/**
 * __useUpdateActualLeaveTimeMutation__
 *
 * To run a mutation, you first call `useUpdateActualLeaveTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActualLeaveTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActualLeaveTimeMutation, { data, loading, error }] = useUpdateActualLeaveTimeMutation({
 *   variables: {
 *      updateInputs: // value for 'updateInputs'
 *   },
 * });
 */
export function useUpdateActualLeaveTimeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateActualLeaveTimeMutation,
    UpdateActualLeaveTimeMutationVariables
  >(UpdateActualLeaveTimeDocument, baseOptions);
}
export type UpdateActualLeaveTimeMutationHookResult = ReturnType<
  typeof useUpdateActualLeaveTimeMutation
>;
export type UpdateActualLeaveTimeMutationResult = ApolloReactCommon.MutationResult<UpdateActualLeaveTimeMutation>;
export type UpdateActualLeaveTimeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateActualLeaveTimeMutation,
  UpdateActualLeaveTimeMutationVariables
>;
export const allAddressesDocument = gql`
  query allAddresses(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: AddressFilter
  ) {
    items: allAddresses(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminAddressFields
    }
    total: _allAddressesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminAddressFieldsFragmentDoc}
`;
export type allAddressesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allAddressesQuery,
    allAddressesQueryVariables
  >,
  'query'
>;

export const allAddressesComponent = (props: allAddressesComponentProps) => (
  <ApolloReactComponents.Query<allAddressesQuery, allAddressesQueryVariables>
    query={allAddressesDocument}
    {...props}
  />
);

export type allAddressesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allAddressesQuery,
    allAddressesQueryVariables
  >;
} &
  TChildProps;
export function withallAddresses<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allAddressesQuery,
    allAddressesQueryVariables,
    allAddressesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allAddressesQuery,
    allAddressesQueryVariables,
    allAddressesProps<TChildProps, TDataName>
  >(allAddressesDocument, {
    alias: 'allAddresses',
    ...operationOptions,
  });
}

/**
 * __useallAddressesQuery__
 *
 * To run a query within a React component, call `useallAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallAddressesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallAddressesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allAddressesQuery,
    allAddressesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allAddressesQuery,
    allAddressesQueryVariables
  >(allAddressesDocument, baseOptions);
}
export function useallAddressesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allAddressesQuery,
    allAddressesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allAddressesQuery,
    allAddressesQueryVariables
  >(allAddressesDocument, baseOptions);
}
export type allAddressesQueryHookResult = ReturnType<
  typeof useallAddressesQuery
>;
export type allAddressesLazyQueryHookResult = ReturnType<
  typeof useallAddressesLazyQuery
>;
export type allAddressesQueryResult = ApolloReactCommon.QueryResult<
  allAddressesQuery,
  allAddressesQueryVariables
>;
export const AddressDocument = gql`
  query Address($id: UUID!) {
    data: Address(id: $id) {
      ...AdminAddressFields
    }
  }
  ${AdminAddressFieldsFragmentDoc}
`;
export type AddressComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AddressQuery,
    AddressQueryVariables
  >,
  'query'
> &
  ({ variables: AddressQueryVariables; skip?: boolean } | { skip: boolean });

export const AddressComponent = (props: AddressComponentProps) => (
  <ApolloReactComponents.Query<AddressQuery, AddressQueryVariables>
    query={AddressDocument}
    {...props}
  />
);

export type AddressProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    AddressQuery,
    AddressQueryVariables
  >;
} &
  TChildProps;
export function withAddress<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    AddressQuery,
    AddressQueryVariables,
    AddressProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    AddressQuery,
    AddressQueryVariables,
    AddressProps<TChildProps, TDataName>
  >(AddressDocument, {
    alias: 'address',
    ...operationOptions,
  });
}

/**
 * __useAddressQuery__
 *
 * To run a query within a React component, call `useAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AddressQuery,
    AddressQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<AddressQuery, AddressQueryVariables>(
    AddressDocument,
    baseOptions,
  );
}
export function useAddressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AddressQuery,
    AddressQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<AddressQuery, AddressQueryVariables>(
    AddressDocument,
    baseOptions,
  );
}
export type AddressQueryHookResult = ReturnType<typeof useAddressQuery>;
export type AddressLazyQueryHookResult = ReturnType<typeof useAddressLazyQuery>;
export type AddressQueryResult = ApolloReactCommon.QueryResult<
  AddressQuery,
  AddressQueryVariables
>;
export const AdminCreateAppealDocument = gql`
  mutation AdminCreateAppeal($createInputs: AdminCreateAppealInput!) {
    data: adminCreateAppeal(createInputs: $createInputs) {
      id
      decisionAt
      status
    }
  }
`;
export type AdminCreateAppealMutationFn = ApolloReactCommon.MutationFunction<
  AdminCreateAppealMutation,
  AdminCreateAppealMutationVariables
>;
export type AdminCreateAppealComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables
  >,
  'mutation'
>;

export const AdminCreateAppealComponent = (
  props: AdminCreateAppealComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables
  >
    mutation={AdminCreateAppealDocument}
    {...props}
  />
);

export type AdminCreateAppealProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables
  >;
} &
  TChildProps;
export function withAdminCreateAppeal<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables,
    AdminCreateAppealProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables,
    AdminCreateAppealProps<TChildProps, TDataName>
  >(AdminCreateAppealDocument, {
    alias: 'adminCreateAppeal',
    ...operationOptions,
  });
}

/**
 * __useAdminCreateAppealMutation__
 *
 * To run a mutation, you first call `useAdminCreateAppealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAppealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAppealMutation, { data, loading, error }] = useAdminCreateAppealMutation({
 *   variables: {
 *      createInputs: // value for 'createInputs'
 *   },
 * });
 */
export function useAdminCreateAppealMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    AdminCreateAppealMutation,
    AdminCreateAppealMutationVariables
  >(AdminCreateAppealDocument, baseOptions);
}
export type AdminCreateAppealMutationHookResult = ReturnType<
  typeof useAdminCreateAppealMutation
>;
export type AdminCreateAppealMutationResult = ApolloReactCommon.MutationResult<AdminCreateAppealMutation>;
export type AdminCreateAppealMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AdminCreateAppealMutation,
  AdminCreateAppealMutationVariables
>;
export const allBusinessesDocument = gql`
  query allBusinesses(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: BusinessFilter
  ) {
    items: allBusinesses(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminBusinessFields
    }
    total: _allBusinessesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminBusinessFieldsFragmentDoc}
`;
export type allBusinessesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allBusinessesQuery,
    allBusinessesQueryVariables
  >,
  'query'
>;

export const allBusinessesComponent = (props: allBusinessesComponentProps) => (
  <ApolloReactComponents.Query<allBusinessesQuery, allBusinessesQueryVariables>
    query={allBusinessesDocument}
    {...props}
  />
);

export type allBusinessesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allBusinessesQuery,
    allBusinessesQueryVariables
  >;
} &
  TChildProps;
export function withallBusinesses<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allBusinessesQuery,
    allBusinessesQueryVariables,
    allBusinessesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allBusinessesQuery,
    allBusinessesQueryVariables,
    allBusinessesProps<TChildProps, TDataName>
  >(allBusinessesDocument, {
    alias: 'allBusinesses',
    ...operationOptions,
  });
}

/**
 * __useallBusinessesQuery__
 *
 * To run a query within a React component, call `useallBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallBusinessesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallBusinessesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allBusinessesQuery,
    allBusinessesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allBusinessesQuery,
    allBusinessesQueryVariables
  >(allBusinessesDocument, baseOptions);
}
export function useallBusinessesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allBusinessesQuery,
    allBusinessesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allBusinessesQuery,
    allBusinessesQueryVariables
  >(allBusinessesDocument, baseOptions);
}
export type allBusinessesQueryHookResult = ReturnType<
  typeof useallBusinessesQuery
>;
export type allBusinessesLazyQueryHookResult = ReturnType<
  typeof useallBusinessesLazyQuery
>;
export type allBusinessesQueryResult = ApolloReactCommon.QueryResult<
  allBusinessesQuery,
  allBusinessesQueryVariables
>;
export const BusinessDocument = gql`
  query Business($id: UUID!) {
    data: Business(id: $id) {
      ...AdminBusinessFields
    }
  }
  ${AdminBusinessFieldsFragmentDoc}
`;
export type BusinessComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    BusinessQuery,
    BusinessQueryVariables
  >,
  'query'
> &
  ({ variables: BusinessQueryVariables; skip?: boolean } | { skip: boolean });

export const BusinessComponent = (props: BusinessComponentProps) => (
  <ApolloReactComponents.Query<BusinessQuery, BusinessQueryVariables>
    query={BusinessDocument}
    {...props}
  />
);

export type BusinessProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    BusinessQuery,
    BusinessQueryVariables
  >;
} &
  TChildProps;
export function withBusiness<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    BusinessQuery,
    BusinessQueryVariables,
    BusinessProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    BusinessQuery,
    BusinessQueryVariables,
    BusinessProps<TChildProps, TDataName>
  >(BusinessDocument, {
    alias: 'business',
    ...operationOptions,
  });
}

/**
 * __useBusinessQuery__
 *
 * To run a query within a React component, call `useBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    BusinessQuery,
    BusinessQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<BusinessQuery, BusinessQueryVariables>(
    BusinessDocument,
    baseOptions,
  );
}
export function useBusinessLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    BusinessQuery,
    BusinessQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<BusinessQuery, BusinessQueryVariables>(
    BusinessDocument,
    baseOptions,
  );
}
export type BusinessQueryHookResult = ReturnType<typeof useBusinessQuery>;
export type BusinessLazyQueryHookResult = ReturnType<
  typeof useBusinessLazyQuery
>;
export type BusinessQueryResult = ApolloReactCommon.QueryResult<
  BusinessQuery,
  BusinessQueryVariables
>;
export const updateBusinessDocument = gql`
  mutation updateBusiness(
    $id: UUID!
    $businessLogo: String
    $displayAddress: String
    $exemptFromPaymentDetails: Boolean
    $ltdName: String
    $name: String
    $phoneNumber: String
    $placeId: String
    $rateOverride: BusinessRateOverrideInput
    $status: BusinessStatusChoices
    $integrated: Boolean
    $unlockedLastMinuteStints: Boolean
    $controlCheck: Boolean
    $isBlockedByFinance: Boolean
    $stintopedia: StintopediaInput
    $repeatStintersEnabled: Boolean
  ) {
    data: updateBusiness(
      id: $id
      businessLogo: $businessLogo
      displayAddress: $displayAddress
      exemptFromPaymentDetails: $exemptFromPaymentDetails
      ltdName: $ltdName
      name: $name
      phoneNumber: $phoneNumber
      placeId: $placeId
      rateOverride: $rateOverride
      status: $status
      integrated: $integrated
      unlockedLastMinuteStints: $unlockedLastMinuteStints
      controlCheck: $controlCheck
      isBlockedByFinance: $isBlockedByFinance
      stintopedia: $stintopedia
      repeatStintersEnabled: $repeatStintersEnabled
    ) {
      ...AdminBusinessFields
    }
  }
  ${AdminBusinessFieldsFragmentDoc}
`;
export type updateBusinessMutationFn = ApolloReactCommon.MutationFunction<
  updateBusinessMutation,
  updateBusinessMutationVariables
>;
export type updateBusinessComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateBusinessMutation,
    updateBusinessMutationVariables
  >,
  'mutation'
>;

export const updateBusinessComponent = (
  props: updateBusinessComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateBusinessMutation,
    updateBusinessMutationVariables
  >
    mutation={updateBusinessDocument}
    {...props}
  />
);

export type updateBusinessProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateBusinessMutation,
    updateBusinessMutationVariables
  >;
} &
  TChildProps;
export function withupdateBusiness<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateBusinessMutation,
    updateBusinessMutationVariables,
    updateBusinessProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateBusinessMutation,
    updateBusinessMutationVariables,
    updateBusinessProps<TChildProps, TDataName>
  >(updateBusinessDocument, {
    alias: 'updateBusiness',
    ...operationOptions,
  });
}

/**
 * __useupdateBusinessMutation__
 *
 * To run a mutation, you first call `useupdateBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessMutation, { data, loading, error }] = useupdateBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      businessLogo: // value for 'businessLogo'
 *      displayAddress: // value for 'displayAddress'
 *      exemptFromPaymentDetails: // value for 'exemptFromPaymentDetails'
 *      ltdName: // value for 'ltdName'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *      placeId: // value for 'placeId'
 *      rateOverride: // value for 'rateOverride'
 *      status: // value for 'status'
 *      integrated: // value for 'integrated'
 *      unlockedLastMinuteStints: // value for 'unlockedLastMinuteStints'
 *      controlCheck: // value for 'controlCheck'
 *      isBlockedByFinance: // value for 'isBlockedByFinance'
 *      stintopedia: // value for 'stintopedia'
 *      repeatStintersEnabled: // value for 'repeatStintersEnabled'
 *   },
 * });
 */
export function useupdateBusinessMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateBusinessMutation,
    updateBusinessMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateBusinessMutation,
    updateBusinessMutationVariables
  >(updateBusinessDocument, baseOptions);
}
export type updateBusinessMutationHookResult = ReturnType<
  typeof useupdateBusinessMutation
>;
export type updateBusinessMutationResult = ApolloReactCommon.MutationResult<updateBusinessMutation>;
export type updateBusinessMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateBusinessMutation,
  updateBusinessMutationVariables
>;
export const allCharacteristicsDocument = gql`
  query allCharacteristics(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: CharacteristicFilter
  ) {
    items: allCharacteristics(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminCharacteristicFields
    }
    total: _allCharacteristicsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminCharacteristicFieldsFragmentDoc}
`;
export type allCharacteristicsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >,
  'query'
>;

export const allCharacteristicsComponent = (
  props: allCharacteristicsComponentProps,
) => (
  <ApolloReactComponents.Query<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >
    query={allCharacteristicsDocument}
    {...props}
  />
);

export type allCharacteristicsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >;
} &
  TChildProps;
export function withallCharacteristics<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables,
    allCharacteristicsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables,
    allCharacteristicsProps<TChildProps, TDataName>
  >(allCharacteristicsDocument, {
    alias: 'allCharacteristics',
    ...operationOptions,
  });
}

/**
 * __useallCharacteristicsQuery__
 *
 * To run a query within a React component, call `useallCharacteristicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallCharacteristicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallCharacteristicsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallCharacteristicsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >(allCharacteristicsDocument, baseOptions);
}
export function useallCharacteristicsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allCharacteristicsQuery,
    allCharacteristicsQueryVariables
  >(allCharacteristicsDocument, baseOptions);
}
export type allCharacteristicsQueryHookResult = ReturnType<
  typeof useallCharacteristicsQuery
>;
export type allCharacteristicsLazyQueryHookResult = ReturnType<
  typeof useallCharacteristicsLazyQuery
>;
export type allCharacteristicsQueryResult = ApolloReactCommon.QueryResult<
  allCharacteristicsQuery,
  allCharacteristicsQueryVariables
>;
export const CharacteristicDocument = gql`
  query Characteristic($id: UUID!) {
    data: Characteristic(id: $id) {
      ...AdminCharacteristicFields
    }
  }
  ${AdminCharacteristicFieldsFragmentDoc}
`;
export type CharacteristicComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >,
  'query'
> &
  (
    | { variables: CharacteristicQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const CharacteristicComponent = (
  props: CharacteristicComponentProps,
) => (
  <ApolloReactComponents.Query<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >
    query={CharacteristicDocument}
    {...props}
  />
);

export type CharacteristicProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >;
} &
  TChildProps;
export function withCharacteristic<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CharacteristicQuery,
    CharacteristicQueryVariables,
    CharacteristicProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    CharacteristicQuery,
    CharacteristicQueryVariables,
    CharacteristicProps<TChildProps, TDataName>
  >(CharacteristicDocument, {
    alias: 'characteristic',
    ...operationOptions,
  });
}

/**
 * __useCharacteristicQuery__
 *
 * To run a query within a React component, call `useCharacteristicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharacteristicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharacteristicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCharacteristicQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >(CharacteristicDocument, baseOptions);
}
export function useCharacteristicLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    CharacteristicQuery,
    CharacteristicQueryVariables
  >(CharacteristicDocument, baseOptions);
}
export type CharacteristicQueryHookResult = ReturnType<
  typeof useCharacteristicQuery
>;
export type CharacteristicLazyQueryHookResult = ReturnType<
  typeof useCharacteristicLazyQuery
>;
export type CharacteristicQueryResult = ApolloReactCommon.QueryResult<
  CharacteristicQuery,
  CharacteristicQueryVariables
>;
export const allCitiesDocument = gql`
  query allCities(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: CityFilter
  ) {
    items: allCities(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminCityFields
    }
    total: _allCitiesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminCityFieldsFragmentDoc}
`;
export type allCitiesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allCitiesQuery,
    allCitiesQueryVariables
  >,
  'query'
>;

export const allCitiesComponent = (props: allCitiesComponentProps) => (
  <ApolloReactComponents.Query<allCitiesQuery, allCitiesQueryVariables>
    query={allCitiesDocument}
    {...props}
  />
);

export type allCitiesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allCitiesQuery,
    allCitiesQueryVariables
  >;
} &
  TChildProps;
export function withallCities<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allCitiesQuery,
    allCitiesQueryVariables,
    allCitiesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allCitiesQuery,
    allCitiesQueryVariables,
    allCitiesProps<TChildProps, TDataName>
  >(allCitiesDocument, {
    alias: 'allCities',
    ...operationOptions,
  });
}

/**
 * __useallCitiesQuery__
 *
 * To run a query within a React component, call `useallCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallCitiesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallCitiesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allCitiesQuery,
    allCitiesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<allCitiesQuery, allCitiesQueryVariables>(
    allCitiesDocument,
    baseOptions,
  );
}
export function useallCitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allCitiesQuery,
    allCitiesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<allCitiesQuery, allCitiesQueryVariables>(
    allCitiesDocument,
    baseOptions,
  );
}
export type allCitiesQueryHookResult = ReturnType<typeof useallCitiesQuery>;
export type allCitiesLazyQueryHookResult = ReturnType<
  typeof useallCitiesLazyQuery
>;
export type allCitiesQueryResult = ApolloReactCommon.QueryResult<
  allCitiesQuery,
  allCitiesQueryVariables
>;
export const CityDocument = gql`
  query City($id: UUID!) {
    data: City(id: $id) {
      ...AdminCityFields
    }
  }
  ${AdminCityFieldsFragmentDoc}
`;
export type CityComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<CityQuery, CityQueryVariables>,
  'query'
> &
  ({ variables: CityQueryVariables; skip?: boolean } | { skip: boolean });

export const CityComponent = (props: CityComponentProps) => (
  <ApolloReactComponents.Query<CityQuery, CityQueryVariables>
    query={CityDocument}
    {...props}
  />
);

export type CityProps<TChildProps = {}, TDataName extends string = 'data'> = {
  [key in TDataName]: ApolloReactHoc.DataValue<CityQuery, CityQueryVariables>;
} &
  TChildProps;
export function withCity<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CityQuery,
    CityQueryVariables,
    CityProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    CityQuery,
    CityQueryVariables,
    CityProps<TChildProps, TDataName>
  >(CityDocument, {
    alias: 'city',
    ...operationOptions,
  });
}

/**
 * __useCityQuery__
 *
 * To run a query within a React component, call `useCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CityQuery,
    CityQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<CityQuery, CityQueryVariables>(
    CityDocument,
    baseOptions,
  );
}
export function useCityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CityQuery,
    CityQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<CityQuery, CityQueryVariables>(
    CityDocument,
    baseOptions,
  );
}
export type CityQueryHookResult = ReturnType<typeof useCityQuery>;
export type CityLazyQueryHookResult = ReturnType<typeof useCityLazyQuery>;
export type CityQueryResult = ApolloReactCommon.QueryResult<
  CityQuery,
  CityQueryVariables
>;
export const createCityDocument = gql`
  mutation createCity(
    $baseFee: Float!
    $baseFeeStudent: Float!
    $name: String!
    $regionId: UUID!
    $sessionUrl: URL
    $shortCode: String!
  ) {
    data: createCity(
      baseFee: $baseFee
      baseFeeStudent: $baseFeeStudent
      name: $name
      regionId: $regionId
      sessionUrl: $sessionUrl
      shortCode: $shortCode
    ) {
      ...AdminCityFields
    }
  }
  ${AdminCityFieldsFragmentDoc}
`;
export type createCityMutationFn = ApolloReactCommon.MutationFunction<
  createCityMutation,
  createCityMutationVariables
>;
export type createCityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createCityMutation,
    createCityMutationVariables
  >,
  'mutation'
>;

export const createCityComponent = (props: createCityComponentProps) => (
  <ApolloReactComponents.Mutation<
    createCityMutation,
    createCityMutationVariables
  >
    mutation={createCityDocument}
    {...props}
  />
);

export type createCityProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createCityMutation,
    createCityMutationVariables
  >;
} &
  TChildProps;
export function withcreateCity<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createCityMutation,
    createCityMutationVariables,
    createCityProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createCityMutation,
    createCityMutationVariables,
    createCityProps<TChildProps, TDataName>
  >(createCityDocument, {
    alias: 'createCity',
    ...operationOptions,
  });
}

/**
 * __usecreateCityMutation__
 *
 * To run a mutation, you first call `usecreateCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCityMutation, { data, loading, error }] = usecreateCityMutation({
 *   variables: {
 *      baseFee: // value for 'baseFee'
 *      baseFeeStudent: // value for 'baseFeeStudent'
 *      name: // value for 'name'
 *      regionId: // value for 'regionId'
 *      sessionUrl: // value for 'sessionUrl'
 *      shortCode: // value for 'shortCode'
 *   },
 * });
 */
export function usecreateCityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createCityMutation,
    createCityMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createCityMutation,
    createCityMutationVariables
  >(createCityDocument, baseOptions);
}
export type createCityMutationHookResult = ReturnType<
  typeof usecreateCityMutation
>;
export type createCityMutationResult = ApolloReactCommon.MutationResult<createCityMutation>;
export type createCityMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createCityMutation,
  createCityMutationVariables
>;
export const updateCityDocument = gql`
  mutation updateCity(
    $baseFee: Float!
    $baseFeeStudent: Float!
    $id: UUID!
    $isActive: Boolean
    $isAvailabilityEnabled: Boolean
    $sessionUrl: URL
    $name: String
    $regionId: UUID
    $shortCode: String
    $postalCodeIds: [UUID]
  ) {
    data: updateCity(
      baseFee: $baseFee
      baseFeeStudent: $baseFeeStudent
      id: $id
      isActive: $isActive
      isAvailabilityEnabled: $isAvailabilityEnabled
      sessionUrl: $sessionUrl
      shortCode: $shortCode
      name: $name
      regionId: $regionId
      postalCodeIds: $postalCodeIds
    ) {
      ...AdminCityFields
    }
  }
  ${AdminCityFieldsFragmentDoc}
`;
export type updateCityMutationFn = ApolloReactCommon.MutationFunction<
  updateCityMutation,
  updateCityMutationVariables
>;
export type updateCityComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateCityMutation,
    updateCityMutationVariables
  >,
  'mutation'
>;

export const updateCityComponent = (props: updateCityComponentProps) => (
  <ApolloReactComponents.Mutation<
    updateCityMutation,
    updateCityMutationVariables
  >
    mutation={updateCityDocument}
    {...props}
  />
);

export type updateCityProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateCityMutation,
    updateCityMutationVariables
  >;
} &
  TChildProps;
export function withupdateCity<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateCityMutation,
    updateCityMutationVariables,
    updateCityProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateCityMutation,
    updateCityMutationVariables,
    updateCityProps<TChildProps, TDataName>
  >(updateCityDocument, {
    alias: 'updateCity',
    ...operationOptions,
  });
}

/**
 * __useupdateCityMutation__
 *
 * To run a mutation, you first call `useupdateCityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateCityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCityMutation, { data, loading, error }] = useupdateCityMutation({
 *   variables: {
 *      baseFee: // value for 'baseFee'
 *      baseFeeStudent: // value for 'baseFeeStudent'
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *      isAvailabilityEnabled: // value for 'isAvailabilityEnabled'
 *      sessionUrl: // value for 'sessionUrl'
 *      name: // value for 'name'
 *      regionId: // value for 'regionId'
 *      shortCode: // value for 'shortCode'
 *      postalCodeIds: // value for 'postalCodeIds'
 *   },
 * });
 */
export function useupdateCityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateCityMutation,
    updateCityMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateCityMutation,
    updateCityMutationVariables
  >(updateCityDocument, baseOptions);
}
export type updateCityMutationHookResult = ReturnType<
  typeof useupdateCityMutation
>;
export type updateCityMutationResult = ApolloReactCommon.MutationResult<updateCityMutation>;
export type updateCityMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateCityMutation,
  updateCityMutationVariables
>;
export const allCountriesDocument = gql`
  query allCountries(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: CountryFilter
  ) {
    items: allCountries(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminCountryFields
    }
    total: _allCountriesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminCountryFieldsFragmentDoc}
`;
export type allCountriesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allCountriesQuery,
    allCountriesQueryVariables
  >,
  'query'
>;

export const allCountriesComponent = (props: allCountriesComponentProps) => (
  <ApolloReactComponents.Query<allCountriesQuery, allCountriesQueryVariables>
    query={allCountriesDocument}
    {...props}
  />
);

export type allCountriesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allCountriesQuery,
    allCountriesQueryVariables
  >;
} &
  TChildProps;
export function withallCountries<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allCountriesQuery,
    allCountriesQueryVariables,
    allCountriesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allCountriesQuery,
    allCountriesQueryVariables,
    allCountriesProps<TChildProps, TDataName>
  >(allCountriesDocument, {
    alias: 'allCountries',
    ...operationOptions,
  });
}

/**
 * __useallCountriesQuery__
 *
 * To run a query within a React component, call `useallCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallCountriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallCountriesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allCountriesQuery,
    allCountriesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allCountriesQuery,
    allCountriesQueryVariables
  >(allCountriesDocument, baseOptions);
}
export function useallCountriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allCountriesQuery,
    allCountriesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allCountriesQuery,
    allCountriesQueryVariables
  >(allCountriesDocument, baseOptions);
}
export type allCountriesQueryHookResult = ReturnType<
  typeof useallCountriesQuery
>;
export type allCountriesLazyQueryHookResult = ReturnType<
  typeof useallCountriesLazyQuery
>;
export type allCountriesQueryResult = ApolloReactCommon.QueryResult<
  allCountriesQuery,
  allCountriesQueryVariables
>;
export const CountryDocument = gql`
  query Country($id: UUID!) {
    data: Country(id: $id) {
      ...AdminCountryFields
    }
  }
  ${AdminCountryFieldsFragmentDoc}
`;
export type CountryComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CountryQuery,
    CountryQueryVariables
  >,
  'query'
> &
  ({ variables: CountryQueryVariables; skip?: boolean } | { skip: boolean });

export const CountryComponent = (props: CountryComponentProps) => (
  <ApolloReactComponents.Query<CountryQuery, CountryQueryVariables>
    query={CountryDocument}
    {...props}
  />
);

export type CountryProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    CountryQuery,
    CountryQueryVariables
  >;
} &
  TChildProps;
export function withCountry<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CountryQuery,
    CountryQueryVariables,
    CountryProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    CountryQuery,
    CountryQueryVariables,
    CountryProps<TChildProps, TDataName>
  >(CountryDocument, {
    alias: 'country',
    ...operationOptions,
  });
}

/**
 * __useCountryQuery__
 *
 * To run a query within a React component, call `useCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CountryQuery,
    CountryQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<CountryQuery, CountryQueryVariables>(
    CountryDocument,
    baseOptions,
  );
}
export function useCountryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CountryQuery,
    CountryQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<CountryQuery, CountryQueryVariables>(
    CountryDocument,
    baseOptions,
  );
}
export type CountryQueryHookResult = ReturnType<typeof useCountryQuery>;
export type CountryLazyQueryHookResult = ReturnType<typeof useCountryLazyQuery>;
export type CountryQueryResult = ApolloReactCommon.QueryResult<
  CountryQuery,
  CountryQueryVariables
>;
export const updateCountryDocument = gql`
  mutation updateCountry(
    $id: UUID!
    $name: String
    $shortCode: String
    $regions: String
  ) {
    data: updateCountry(
      id: $id
      name: $name
      shortCode: $shortCode
      regions: $regions
    ) {
      ...AdminCountryFields
    }
  }
  ${AdminCountryFieldsFragmentDoc}
`;
export type updateCountryMutationFn = ApolloReactCommon.MutationFunction<
  updateCountryMutation,
  updateCountryMutationVariables
>;
export type updateCountryComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateCountryMutation,
    updateCountryMutationVariables
  >,
  'mutation'
>;

export const updateCountryComponent = (props: updateCountryComponentProps) => (
  <ApolloReactComponents.Mutation<
    updateCountryMutation,
    updateCountryMutationVariables
  >
    mutation={updateCountryDocument}
    {...props}
  />
);

export type updateCountryProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateCountryMutation,
    updateCountryMutationVariables
  >;
} &
  TChildProps;
export function withupdateCountry<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateCountryMutation,
    updateCountryMutationVariables,
    updateCountryProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateCountryMutation,
    updateCountryMutationVariables,
    updateCountryProps<TChildProps, TDataName>
  >(updateCountryDocument, {
    alias: 'updateCountry',
    ...operationOptions,
  });
}

/**
 * __useupdateCountryMutation__
 *
 * To run a mutation, you first call `useupdateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryMutation, { data, loading, error }] = useupdateCountryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *      regions: // value for 'regions'
 *   },
 * });
 */
export function useupdateCountryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateCountryMutation,
    updateCountryMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateCountryMutation,
    updateCountryMutationVariables
  >(updateCountryDocument, baseOptions);
}
export type updateCountryMutationHookResult = ReturnType<
  typeof useupdateCountryMutation
>;
export type updateCountryMutationResult = ApolloReactCommon.MutationResult<updateCountryMutation>;
export type updateCountryMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateCountryMutation,
  updateCountryMutationVariables
>;
export const createCountryDocument = gql`
  mutation createCountry(
    $name: String!
    $shortCode: String!
    $regions: String!
  ) {
    data: createCountry(name: $name, shortCode: $shortCode, regions: $regions) {
      ...AdminCountryFields
    }
  }
  ${AdminCountryFieldsFragmentDoc}
`;
export type createCountryMutationFn = ApolloReactCommon.MutationFunction<
  createCountryMutation,
  createCountryMutationVariables
>;
export type createCountryComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createCountryMutation,
    createCountryMutationVariables
  >,
  'mutation'
>;

export const createCountryComponent = (props: createCountryComponentProps) => (
  <ApolloReactComponents.Mutation<
    createCountryMutation,
    createCountryMutationVariables
  >
    mutation={createCountryDocument}
    {...props}
  />
);

export type createCountryProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createCountryMutation,
    createCountryMutationVariables
  >;
} &
  TChildProps;
export function withcreateCountry<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createCountryMutation,
    createCountryMutationVariables,
    createCountryProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createCountryMutation,
    createCountryMutationVariables,
    createCountryProps<TChildProps, TDataName>
  >(createCountryDocument, {
    alias: 'createCountry',
    ...operationOptions,
  });
}

/**
 * __usecreateCountryMutation__
 *
 * To run a mutation, you first call `usecreateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCountryMutation, { data, loading, error }] = usecreateCountryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      shortCode: // value for 'shortCode'
 *      regions: // value for 'regions'
 *   },
 * });
 */
export function usecreateCountryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createCountryMutation,
    createCountryMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createCountryMutation,
    createCountryMutationVariables
  >(createCountryDocument, baseOptions);
}
export type createCountryMutationHookResult = ReturnType<
  typeof usecreateCountryMutation
>;
export type createCountryMutationResult = ApolloReactCommon.MutationResult<createCountryMutation>;
export type createCountryMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createCountryMutation,
  createCountryMutationVariables
>;
export const allDeviceLocationsDocument = gql`
  query allDeviceLocations(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: DeviceLocationFilter
  ) {
    items: allDeviceLocations(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminDeviceLocationFields
    }
    total: _allDeviceLocationsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminDeviceLocationFieldsFragmentDoc}
`;
export type allDeviceLocationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >,
  'query'
>;

export const allDeviceLocationsComponent = (
  props: allDeviceLocationsComponentProps,
) => (
  <ApolloReactComponents.Query<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >
    query={allDeviceLocationsDocument}
    {...props}
  />
);

export type allDeviceLocationsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >;
} &
  TChildProps;
export function withallDeviceLocations<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables,
    allDeviceLocationsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables,
    allDeviceLocationsProps<TChildProps, TDataName>
  >(allDeviceLocationsDocument, {
    alias: 'allDeviceLocations',
    ...operationOptions,
  });
}

/**
 * __useallDeviceLocationsQuery__
 *
 * To run a query within a React component, call `useallDeviceLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallDeviceLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallDeviceLocationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallDeviceLocationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >(allDeviceLocationsDocument, baseOptions);
}
export function useallDeviceLocationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allDeviceLocationsQuery,
    allDeviceLocationsQueryVariables
  >(allDeviceLocationsDocument, baseOptions);
}
export type allDeviceLocationsQueryHookResult = ReturnType<
  typeof useallDeviceLocationsQuery
>;
export type allDeviceLocationsLazyQueryHookResult = ReturnType<
  typeof useallDeviceLocationsLazyQuery
>;
export type allDeviceLocationsQueryResult = ApolloReactCommon.QueryResult<
  allDeviceLocationsQuery,
  allDeviceLocationsQueryVariables
>;
export const DeviceLocationDocument = gql`
  query DeviceLocation($id: UUID!) {
    data: DeviceLocation(id: $id) {
      ...AdminDeviceLocationFields
    }
  }
  ${AdminDeviceLocationFieldsFragmentDoc}
`;
export type DeviceLocationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >,
  'query'
> &
  (
    | { variables: DeviceLocationQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const DeviceLocationComponent = (
  props: DeviceLocationComponentProps,
) => (
  <ApolloReactComponents.Query<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >
    query={DeviceLocationDocument}
    {...props}
  />
);

export type DeviceLocationProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >;
} &
  TChildProps;
export function withDeviceLocation<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    DeviceLocationQuery,
    DeviceLocationQueryVariables,
    DeviceLocationProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    DeviceLocationQuery,
    DeviceLocationQueryVariables,
    DeviceLocationProps<TChildProps, TDataName>
  >(DeviceLocationDocument, {
    alias: 'deviceLocation',
    ...operationOptions,
  });
}

/**
 * __useDeviceLocationQuery__
 *
 * To run a query within a React component, call `useDeviceLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceLocationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >(DeviceLocationDocument, baseOptions);
}
export function useDeviceLocationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    DeviceLocationQuery,
    DeviceLocationQueryVariables
  >(DeviceLocationDocument, baseOptions);
}
export type DeviceLocationQueryHookResult = ReturnType<
  typeof useDeviceLocationQuery
>;
export type DeviceLocationLazyQueryHookResult = ReturnType<
  typeof useDeviceLocationLazyQuery
>;
export type DeviceLocationQueryResult = ApolloReactCommon.QueryResult<
  DeviceLocationQuery,
  DeviceLocationQueryVariables
>;
export const allEditableSettingsDocument = gql`
  query allEditableSettings(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allEditableSettings(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      ...AdminEditableSettingFields
    }
    total: _allEditableSettingsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      count
      __typename
    }
  }
  ${AdminEditableSettingFieldsFragmentDoc}
`;
export type allEditableSettingsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >,
  'query'
>;

export const allEditableSettingsComponent = (
  props: allEditableSettingsComponentProps,
) => (
  <ApolloReactComponents.Query<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >
    query={allEditableSettingsDocument}
    {...props}
  />
);

export type allEditableSettingsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >;
} &
  TChildProps;
export function withallEditableSettings<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables,
    allEditableSettingsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables,
    allEditableSettingsProps<TChildProps, TDataName>
  >(allEditableSettingsDocument, {
    alias: 'allEditableSettings',
    ...operationOptions,
  });
}

/**
 * __useallEditableSettingsQuery__
 *
 * To run a query within a React component, call `useallEditableSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallEditableSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallEditableSettingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useallEditableSettingsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >(allEditableSettingsDocument, baseOptions);
}
export function useallEditableSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allEditableSettingsQuery,
    allEditableSettingsQueryVariables
  >(allEditableSettingsDocument, baseOptions);
}
export type allEditableSettingsQueryHookResult = ReturnType<
  typeof useallEditableSettingsQuery
>;
export type allEditableSettingsLazyQueryHookResult = ReturnType<
  typeof useallEditableSettingsLazyQuery
>;
export type allEditableSettingsQueryResult = ApolloReactCommon.QueryResult<
  allEditableSettingsQuery,
  allEditableSettingsQueryVariables
>;
export const EditableSettingDocument = gql`
  query EditableSetting($id: UUID!) {
    data: EditableSetting(id: $id) {
      ...AdminEditableSettingFields
    }
  }
  ${AdminEditableSettingFieldsFragmentDoc}
`;
export type EditableSettingComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >,
  'query'
> &
  (
    | { variables: EditableSettingQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const EditableSettingComponent = (
  props: EditableSettingComponentProps,
) => (
  <ApolloReactComponents.Query<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >
    query={EditableSettingDocument}
    {...props}
  />
);

export type EditableSettingProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >;
} &
  TChildProps;
export function withEditableSetting<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    EditableSettingQuery,
    EditableSettingQueryVariables,
    EditableSettingProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    EditableSettingQuery,
    EditableSettingQueryVariables,
    EditableSettingProps<TChildProps, TDataName>
  >(EditableSettingDocument, {
    alias: 'editableSetting',
    ...operationOptions,
  });
}

/**
 * __useEditableSettingQuery__
 *
 * To run a query within a React component, call `useEditableSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditableSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditableSettingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditableSettingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >(EditableSettingDocument, baseOptions);
}
export function useEditableSettingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    EditableSettingQuery,
    EditableSettingQueryVariables
  >(EditableSettingDocument, baseOptions);
}
export type EditableSettingQueryHookResult = ReturnType<
  typeof useEditableSettingQuery
>;
export type EditableSettingLazyQueryHookResult = ReturnType<
  typeof useEditableSettingLazyQuery
>;
export type EditableSettingQueryResult = ApolloReactCommon.QueryResult<
  EditableSettingQuery,
  EditableSettingQueryVariables
>;
export const updateEditableSettingDocument = gql`
  mutation updateEditableSetting(
    $predictionLeadDays: Int
    $notificationBlockerWindowHours: Float
    $geoTrackingBufferTime: Int
    $advancedOperationalWindowStartTime: Time
    $advancedOperationalWindowEndTime: Time
    $automatedTestingEnabled: Boolean
    $serverDatetime: DateTime
    $featureFlagStudentGoingToBeLateSmsEnabled: Boolean
    $featureFlagStintSecondStartReminderEnabled: Boolean
    $availabilityMatchingBufferHours: Int
    $availabilityMatchingMaxOffersMonday: Int
    $availabilityMatchingMaxOffersTuesday: Int
    $availabilityMatchingMaxOffersWednesday: Int
    $availabilityMatchingMaxOffersThursday: Int
    $availabilityMatchingMaxOffersFriday: Int
    $availabilityMatchingMaxOffersSaturday: Int
    $availabilityMatchingMaxOffersSunday: Int
    $availabilityMatchingNotificationForNoOffersEnabled: Boolean
    $matchingAlgoNoOfferMaxCountPerTimeWindow: Int
    $matchingAlgoNoOfferTimeWindowSpan: Int
    $matchingAlgoNoOfferTitle: String
    $matchingAlgoNoOfferMessage: String
    $matchingAlgoNotificationDelayInMinutes: Int
    $featureFlagEtdNotificationsEnabled: Boolean
    $sendingStudentLeaveReminderAtRouteTimeEnabled: Boolean
    $studentCancellationOnHoldEmailEnabled: Boolean
    $etdCalculationBeforeMiddayOffsetInMinutes: Int
    $etdCalculationAfterMiddayOffsetInMinutes: Int
    $stintOfferExpiryThresholdInHours: Int
    $notificationTopUpThresholdInHours: Int
  ) {
    data: updateEditableSetting(
      predictionLeadDays: $predictionLeadDays
      notificationBlockerWindowHours: $notificationBlockerWindowHours
      geoTrackingBufferTime: $geoTrackingBufferTime
      advancedOperationalWindowStartTime: $advancedOperationalWindowStartTime
      advancedOperationalWindowEndTime: $advancedOperationalWindowEndTime
      automatedTestingEnabled: $automatedTestingEnabled
      featureFlagStintSecondStartReminderEnabled: $featureFlagStintSecondStartReminderEnabled
      serverDatetime: $serverDatetime
      featureFlagStudentGoingToBeLateSmsEnabled: $featureFlagStudentGoingToBeLateSmsEnabled
      availabilityMatchingBufferHours: $availabilityMatchingBufferHours
      availabilityMatchingMaxOffersMonday: $availabilityMatchingMaxOffersMonday
      availabilityMatchingMaxOffersTuesday: $availabilityMatchingMaxOffersTuesday
      availabilityMatchingMaxOffersWednesday: $availabilityMatchingMaxOffersWednesday
      availabilityMatchingMaxOffersThursday: $availabilityMatchingMaxOffersThursday
      availabilityMatchingMaxOffersFriday: $availabilityMatchingMaxOffersFriday
      availabilityMatchingMaxOffersSaturday: $availabilityMatchingMaxOffersSaturday
      availabilityMatchingMaxOffersSunday: $availabilityMatchingMaxOffersSunday
      availabilityMatchingNotificationForNoOffersEnabled: $availabilityMatchingNotificationForNoOffersEnabled
      matchingAlgoNoOfferMaxCountPerTimeWindow: $matchingAlgoNoOfferMaxCountPerTimeWindow
      matchingAlgoNoOfferTimeWindowSpan: $matchingAlgoNoOfferTimeWindowSpan
      matchingAlgoNoOfferTitle: $matchingAlgoNoOfferTitle
      matchingAlgoNoOfferMessage: $matchingAlgoNoOfferMessage
      matchingAlgoNotificationDelayInMinutes: $matchingAlgoNotificationDelayInMinutes
      featureFlagEtdNotificationsEnabled: $featureFlagEtdNotificationsEnabled
      sendingStudentLeaveReminderAtRouteTimeEnabled: $sendingStudentLeaveReminderAtRouteTimeEnabled
      studentCancellationOnHoldEmailEnabled: $studentCancellationOnHoldEmailEnabled
      etdCalculationBeforeMiddayOffsetInMinutes: $etdCalculationBeforeMiddayOffsetInMinutes
      etdCalculationAfterMiddayOffsetInMinutes: $etdCalculationAfterMiddayOffsetInMinutes
      stintOfferExpiryThresholdInHours: $stintOfferExpiryThresholdInHours
      notificationTopUpThresholdInHours: $notificationTopUpThresholdInHours
    ) {
      ...AdminEditableSettingFields
    }
  }
  ${AdminEditableSettingFieldsFragmentDoc}
`;
export type updateEditableSettingMutationFn = ApolloReactCommon.MutationFunction<
  updateEditableSettingMutation,
  updateEditableSettingMutationVariables
>;
export type updateEditableSettingComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables
  >,
  'mutation'
>;

export const updateEditableSettingComponent = (
  props: updateEditableSettingComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables
  >
    mutation={updateEditableSettingDocument}
    {...props}
  />
);

export type updateEditableSettingProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables
  >;
} &
  TChildProps;
export function withupdateEditableSetting<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables,
    updateEditableSettingProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables,
    updateEditableSettingProps<TChildProps, TDataName>
  >(updateEditableSettingDocument, {
    alias: 'updateEditableSetting',
    ...operationOptions,
  });
}

/**
 * __useupdateEditableSettingMutation__
 *
 * To run a mutation, you first call `useupdateEditableSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateEditableSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEditableSettingMutation, { data, loading, error }] = useupdateEditableSettingMutation({
 *   variables: {
 *      predictionLeadDays: // value for 'predictionLeadDays'
 *      notificationBlockerWindowHours: // value for 'notificationBlockerWindowHours'
 *      geoTrackingBufferTime: // value for 'geoTrackingBufferTime'
 *      advancedOperationalWindowStartTime: // value for 'advancedOperationalWindowStartTime'
 *      advancedOperationalWindowEndTime: // value for 'advancedOperationalWindowEndTime'
 *      automatedTestingEnabled: // value for 'automatedTestingEnabled'
 *      serverDatetime: // value for 'serverDatetime'
 *      featureFlagStudentGoingToBeLateSmsEnabled: // value for 'featureFlagStudentGoingToBeLateSmsEnabled'
 *      featureFlagStintSecondStartReminderEnabled: // value for 'featureFlagStintSecondStartReminderEnabled'
 *      availabilityMatchingBufferHours: // value for 'availabilityMatchingBufferHours'
 *      availabilityMatchingMaxOffersMonday: // value for 'availabilityMatchingMaxOffersMonday'
 *      availabilityMatchingMaxOffersTuesday: // value for 'availabilityMatchingMaxOffersTuesday'
 *      availabilityMatchingMaxOffersWednesday: // value for 'availabilityMatchingMaxOffersWednesday'
 *      availabilityMatchingMaxOffersThursday: // value for 'availabilityMatchingMaxOffersThursday'
 *      availabilityMatchingMaxOffersFriday: // value for 'availabilityMatchingMaxOffersFriday'
 *      availabilityMatchingMaxOffersSaturday: // value for 'availabilityMatchingMaxOffersSaturday'
 *      availabilityMatchingMaxOffersSunday: // value for 'availabilityMatchingMaxOffersSunday'
 *      availabilityMatchingNotificationForNoOffersEnabled: // value for 'availabilityMatchingNotificationForNoOffersEnabled'
 *      matchingAlgoNoOfferMaxCountPerTimeWindow: // value for 'matchingAlgoNoOfferMaxCountPerTimeWindow'
 *      matchingAlgoNoOfferTimeWindowSpan: // value for 'matchingAlgoNoOfferTimeWindowSpan'
 *      matchingAlgoNoOfferTitle: // value for 'matchingAlgoNoOfferTitle'
 *      matchingAlgoNoOfferMessage: // value for 'matchingAlgoNoOfferMessage'
 *      matchingAlgoNotificationDelayInMinutes: // value for 'matchingAlgoNotificationDelayInMinutes'
 *      featureFlagEtdNotificationsEnabled: // value for 'featureFlagEtdNotificationsEnabled'
 *      sendingStudentLeaveReminderAtRouteTimeEnabled: // value for 'sendingStudentLeaveReminderAtRouteTimeEnabled'
 *      studentCancellationOnHoldEmailEnabled: // value for 'studentCancellationOnHoldEmailEnabled'
 *      etdCalculationBeforeMiddayOffsetInMinutes: // value for 'etdCalculationBeforeMiddayOffsetInMinutes'
 *      etdCalculationAfterMiddayOffsetInMinutes: // value for 'etdCalculationAfterMiddayOffsetInMinutes'
 *      stintOfferExpiryThresholdInHours: // value for 'stintOfferExpiryThresholdInHours'
 *      notificationTopUpThresholdInHours: // value for 'notificationTopUpThresholdInHours'
 *   },
 * });
 */
export function useupdateEditableSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateEditableSettingMutation,
    updateEditableSettingMutationVariables
  >(updateEditableSettingDocument, baseOptions);
}
export type updateEditableSettingMutationHookResult = ReturnType<
  typeof useupdateEditableSettingMutation
>;
export type updateEditableSettingMutationResult = ApolloReactCommon.MutationResult<updateEditableSettingMutation>;
export type updateEditableSettingMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateEditableSettingMutation,
  updateEditableSettingMutationVariables
>;
export const EmployerUserDocument = gql`
  query EmployerUser($id: UUID!) {
    data: employerUser(userId: $id) {
      ...EmployerUserFields
    }
  }
  ${EmployerUserFieldsFragmentDoc}
`;
export type EmployerUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    EmployerUserQuery,
    EmployerUserQueryVariables
  >,
  'query'
> &
  (
    | { variables: EmployerUserQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const EmployerUserComponent = (props: EmployerUserComponentProps) => (
  <ApolloReactComponents.Query<EmployerUserQuery, EmployerUserQueryVariables>
    query={EmployerUserDocument}
    {...props}
  />
);

export type EmployerUserProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    EmployerUserQuery,
    EmployerUserQueryVariables
  >;
} &
  TChildProps;
export function withEmployerUser<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    EmployerUserQuery,
    EmployerUserQueryVariables,
    EmployerUserProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    EmployerUserQuery,
    EmployerUserQueryVariables,
    EmployerUserProps<TChildProps, TDataName>
  >(EmployerUserDocument, {
    alias: 'employerUser',
    ...operationOptions,
  });
}

/**
 * __useEmployerUserQuery__
 *
 * To run a query within a React component, call `useEmployerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployerUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EmployerUserQuery,
    EmployerUserQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    EmployerUserQuery,
    EmployerUserQueryVariables
  >(EmployerUserDocument, baseOptions);
}
export function useEmployerUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmployerUserQuery,
    EmployerUserQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    EmployerUserQuery,
    EmployerUserQueryVariables
  >(EmployerUserDocument, baseOptions);
}
export type EmployerUserQueryHookResult = ReturnType<
  typeof useEmployerUserQuery
>;
export type EmployerUserLazyQueryHookResult = ReturnType<
  typeof useEmployerUserLazyQuery
>;
export type EmployerUserQueryResult = ApolloReactCommon.QueryResult<
  EmployerUserQuery,
  EmployerUserQueryVariables
>;
export const allEmployerUsersDocument = gql`
  query allEmployerUsers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: String
  ) {
    items: allEmployerUsers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...EmployerUserFields
    }
    total: _allEmployerUserMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${EmployerUserFieldsFragmentDoc}
`;
export type allEmployerUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >,
  'query'
>;

export const allEmployerUsersComponent = (
  props: allEmployerUsersComponentProps,
) => (
  <ApolloReactComponents.Query<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >
    query={allEmployerUsersDocument}
    {...props}
  />
);

export type allEmployerUsersProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >;
} &
  TChildProps;
export function withallEmployerUsers<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables,
    allEmployerUsersProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables,
    allEmployerUsersProps<TChildProps, TDataName>
  >(allEmployerUsersDocument, {
    alias: 'allEmployerUsers',
    ...operationOptions,
  });
}

/**
 * __useallEmployerUsersQuery__
 *
 * To run a query within a React component, call `useallEmployerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useallEmployerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallEmployerUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallEmployerUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >(allEmployerUsersDocument, baseOptions);
}
export function useallEmployerUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allEmployerUsersQuery,
    allEmployerUsersQueryVariables
  >(allEmployerUsersDocument, baseOptions);
}
export type allEmployerUsersQueryHookResult = ReturnType<
  typeof useallEmployerUsersQuery
>;
export type allEmployerUsersLazyQueryHookResult = ReturnType<
  typeof useallEmployerUsersLazyQuery
>;
export type allEmployerUsersQueryResult = ApolloReactCommon.QueryResult<
  allEmployerUsersQuery,
  allEmployerUsersQueryVariables
>;
export const allEmploymentExceptionsDocument = gql`
  query allEmploymentExceptions(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: EmploymentExceptionFilter
  ) {
    items: allEmploymentExceptions(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminEmploymentExceptionFields
    }
    total: _allEmploymentExceptionsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminEmploymentExceptionFieldsFragmentDoc}
`;
export type allEmploymentExceptionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >,
  'query'
>;

export const allEmploymentExceptionsComponent = (
  props: allEmploymentExceptionsComponentProps,
) => (
  <ApolloReactComponents.Query<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >
    query={allEmploymentExceptionsDocument}
    {...props}
  />
);

export type allEmploymentExceptionsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >;
} &
  TChildProps;
export function withallEmploymentExceptions<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables,
    allEmploymentExceptionsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables,
    allEmploymentExceptionsProps<TChildProps, TDataName>
  >(allEmploymentExceptionsDocument, {
    alias: 'allEmploymentExceptions',
    ...operationOptions,
  });
}

/**
 * __useallEmploymentExceptionsQuery__
 *
 * To run a query within a React component, call `useallEmploymentExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallEmploymentExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallEmploymentExceptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallEmploymentExceptionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >(allEmploymentExceptionsDocument, baseOptions);
}
export function useallEmploymentExceptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allEmploymentExceptionsQuery,
    allEmploymentExceptionsQueryVariables
  >(allEmploymentExceptionsDocument, baseOptions);
}
export type allEmploymentExceptionsQueryHookResult = ReturnType<
  typeof useallEmploymentExceptionsQuery
>;
export type allEmploymentExceptionsLazyQueryHookResult = ReturnType<
  typeof useallEmploymentExceptionsLazyQuery
>;
export type allEmploymentExceptionsQueryResult = ApolloReactCommon.QueryResult<
  allEmploymentExceptionsQuery,
  allEmploymentExceptionsQueryVariables
>;
export const EmploymentExceptionDocument = gql`
  query EmploymentException($id: UUID!) {
    data: EmploymentException(id: $id) {
      ...AdminEmploymentExceptionFields
    }
  }
  ${AdminEmploymentExceptionFieldsFragmentDoc}
`;
export type EmploymentExceptionComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >,
  'query'
> &
  (
    | { variables: EmploymentExceptionQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const EmploymentExceptionComponent = (
  props: EmploymentExceptionComponentProps,
) => (
  <ApolloReactComponents.Query<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >
    query={EmploymentExceptionDocument}
    {...props}
  />
);

export type EmploymentExceptionProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >;
} &
  TChildProps;
export function withEmploymentException<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables,
    EmploymentExceptionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables,
    EmploymentExceptionProps<TChildProps, TDataName>
  >(EmploymentExceptionDocument, {
    alias: 'employmentException',
    ...operationOptions,
  });
}

/**
 * __useEmploymentExceptionQuery__
 *
 * To run a query within a React component, call `useEmploymentExceptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmploymentExceptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmploymentExceptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmploymentExceptionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >(EmploymentExceptionDocument, baseOptions);
}
export function useEmploymentExceptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    EmploymentExceptionQuery,
    EmploymentExceptionQueryVariables
  >(EmploymentExceptionDocument, baseOptions);
}
export type EmploymentExceptionQueryHookResult = ReturnType<
  typeof useEmploymentExceptionQuery
>;
export type EmploymentExceptionLazyQueryHookResult = ReturnType<
  typeof useEmploymentExceptionLazyQuery
>;
export type EmploymentExceptionQueryResult = ApolloReactCommon.QueryResult<
  EmploymentExceptionQuery,
  EmploymentExceptionQueryVariables
>;
export const createEmploymentExceptionDocument = gql`
  mutation createEmploymentException(
    $name: String!
    $category: EmploymentExceptionCategoryInputType
  ) {
    data: createEmploymentException(name: $name, category: $category) {
      ...AdminEmploymentExceptionFields
    }
  }
  ${AdminEmploymentExceptionFieldsFragmentDoc}
`;
export type createEmploymentExceptionMutationFn = ApolloReactCommon.MutationFunction<
  createEmploymentExceptionMutation,
  createEmploymentExceptionMutationVariables
>;
export type createEmploymentExceptionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables
  >,
  'mutation'
>;

export const createEmploymentExceptionComponent = (
  props: createEmploymentExceptionComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables
  >
    mutation={createEmploymentExceptionDocument}
    {...props}
  />
);

export type createEmploymentExceptionProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables
  >;
} &
  TChildProps;
export function withcreateEmploymentException<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables,
    createEmploymentExceptionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables,
    createEmploymentExceptionProps<TChildProps, TDataName>
  >(createEmploymentExceptionDocument, {
    alias: 'createEmploymentException',
    ...operationOptions,
  });
}

/**
 * __usecreateEmploymentExceptionMutation__
 *
 * To run a mutation, you first call `usecreateEmploymentExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateEmploymentExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmploymentExceptionMutation, { data, loading, error }] = usecreateEmploymentExceptionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      category: // value for 'category'
 *   },
 * });
 */
export function usecreateEmploymentExceptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createEmploymentExceptionMutation,
    createEmploymentExceptionMutationVariables
  >(createEmploymentExceptionDocument, baseOptions);
}
export type createEmploymentExceptionMutationHookResult = ReturnType<
  typeof usecreateEmploymentExceptionMutation
>;
export type createEmploymentExceptionMutationResult = ApolloReactCommon.MutationResult<createEmploymentExceptionMutation>;
export type createEmploymentExceptionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createEmploymentExceptionMutation,
  createEmploymentExceptionMutationVariables
>;
export const updateEmploymentExceptionDocument = gql`
  mutation updateEmploymentException(
    $id: UUID!
    $name: String!
    $category: EmploymentExceptionCategoryInputType
  ) {
    data: updateEmploymentException(id: $id, name: $name, category: $category) {
      ...AdminEmploymentExceptionFields
    }
  }
  ${AdminEmploymentExceptionFieldsFragmentDoc}
`;
export type updateEmploymentExceptionMutationFn = ApolloReactCommon.MutationFunction<
  updateEmploymentExceptionMutation,
  updateEmploymentExceptionMutationVariables
>;
export type updateEmploymentExceptionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables
  >,
  'mutation'
>;

export const updateEmploymentExceptionComponent = (
  props: updateEmploymentExceptionComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables
  >
    mutation={updateEmploymentExceptionDocument}
    {...props}
  />
);

export type updateEmploymentExceptionProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables
  >;
} &
  TChildProps;
export function withupdateEmploymentException<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables,
    updateEmploymentExceptionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables,
    updateEmploymentExceptionProps<TChildProps, TDataName>
  >(updateEmploymentExceptionDocument, {
    alias: 'updateEmploymentException',
    ...operationOptions,
  });
}

/**
 * __useupdateEmploymentExceptionMutation__
 *
 * To run a mutation, you first call `useupdateEmploymentExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateEmploymentExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmploymentExceptionMutation, { data, loading, error }] = useupdateEmploymentExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useupdateEmploymentExceptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateEmploymentExceptionMutation,
    updateEmploymentExceptionMutationVariables
  >(updateEmploymentExceptionDocument, baseOptions);
}
export type updateEmploymentExceptionMutationHookResult = ReturnType<
  typeof useupdateEmploymentExceptionMutation
>;
export type updateEmploymentExceptionMutationResult = ApolloReactCommon.MutationResult<updateEmploymentExceptionMutation>;
export type updateEmploymentExceptionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateEmploymentExceptionMutation,
  updateEmploymentExceptionMutationVariables
>;
export const deleteEmploymentExceptionDocument = gql`
  mutation deleteEmploymentException($id: UUID!) {
    data: deleteEmploymentException(id: $id) {
      ...AdminEmploymentExceptionFields
    }
  }
  ${AdminEmploymentExceptionFieldsFragmentDoc}
`;
export type deleteEmploymentExceptionMutationFn = ApolloReactCommon.MutationFunction<
  deleteEmploymentExceptionMutation,
  deleteEmploymentExceptionMutationVariables
>;
export type deleteEmploymentExceptionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables
  >,
  'mutation'
>;

export const deleteEmploymentExceptionComponent = (
  props: deleteEmploymentExceptionComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables
  >
    mutation={deleteEmploymentExceptionDocument}
    {...props}
  />
);

export type deleteEmploymentExceptionProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables
  >;
} &
  TChildProps;
export function withdeleteEmploymentException<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables,
    deleteEmploymentExceptionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables,
    deleteEmploymentExceptionProps<TChildProps, TDataName>
  >(deleteEmploymentExceptionDocument, {
    alias: 'deleteEmploymentException',
    ...operationOptions,
  });
}

/**
 * __usedeleteEmploymentExceptionMutation__
 *
 * To run a mutation, you first call `usedeleteEmploymentExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usedeleteEmploymentExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmploymentExceptionMutation, { data, loading, error }] = usedeleteEmploymentExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usedeleteEmploymentExceptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    deleteEmploymentExceptionMutation,
    deleteEmploymentExceptionMutationVariables
  >(deleteEmploymentExceptionDocument, baseOptions);
}
export type deleteEmploymentExceptionMutationHookResult = ReturnType<
  typeof usedeleteEmploymentExceptionMutation
>;
export type deleteEmploymentExceptionMutationResult = ApolloReactCommon.MutationResult<deleteEmploymentExceptionMutation>;
export type deleteEmploymentExceptionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  deleteEmploymentExceptionMutation,
  deleteEmploymentExceptionMutationVariables
>;
export const allLanguagesDocument = gql`
  query allLanguages(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: LanguageFilter
  ) {
    items: allLanguages(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminLanguageFields
    }
    total: _allLanguagesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminLanguageFieldsFragmentDoc}
`;
export type allLanguagesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allLanguagesQuery,
    allLanguagesQueryVariables
  >,
  'query'
>;

export const allLanguagesComponent = (props: allLanguagesComponentProps) => (
  <ApolloReactComponents.Query<allLanguagesQuery, allLanguagesQueryVariables>
    query={allLanguagesDocument}
    {...props}
  />
);

export type allLanguagesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allLanguagesQuery,
    allLanguagesQueryVariables
  >;
} &
  TChildProps;
export function withallLanguages<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allLanguagesQuery,
    allLanguagesQueryVariables,
    allLanguagesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allLanguagesQuery,
    allLanguagesQueryVariables,
    allLanguagesProps<TChildProps, TDataName>
  >(allLanguagesDocument, {
    alias: 'allLanguages',
    ...operationOptions,
  });
}

/**
 * __useallLanguagesQuery__
 *
 * To run a query within a React component, call `useallLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallLanguagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallLanguagesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allLanguagesQuery,
    allLanguagesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allLanguagesQuery,
    allLanguagesQueryVariables
  >(allLanguagesDocument, baseOptions);
}
export function useallLanguagesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allLanguagesQuery,
    allLanguagesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allLanguagesQuery,
    allLanguagesQueryVariables
  >(allLanguagesDocument, baseOptions);
}
export type allLanguagesQueryHookResult = ReturnType<
  typeof useallLanguagesQuery
>;
export type allLanguagesLazyQueryHookResult = ReturnType<
  typeof useallLanguagesLazyQuery
>;
export type allLanguagesQueryResult = ApolloReactCommon.QueryResult<
  allLanguagesQuery,
  allLanguagesQueryVariables
>;
export const LanguageDocument = gql`
  query Language($id: UUID!) {
    data: Language(id: $id) {
      ...AdminLanguageFields
    }
  }
  ${AdminLanguageFieldsFragmentDoc}
`;
export type LanguageComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    LanguageQuery,
    LanguageQueryVariables
  >,
  'query'
> &
  ({ variables: LanguageQueryVariables; skip?: boolean } | { skip: boolean });

export const LanguageComponent = (props: LanguageComponentProps) => (
  <ApolloReactComponents.Query<LanguageQuery, LanguageQueryVariables>
    query={LanguageDocument}
    {...props}
  />
);

export type LanguageProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    LanguageQuery,
    LanguageQueryVariables
  >;
} &
  TChildProps;
export function withLanguage<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    LanguageQuery,
    LanguageQueryVariables,
    LanguageProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    LanguageQuery,
    LanguageQueryVariables,
    LanguageProps<TChildProps, TDataName>
  >(LanguageDocument, {
    alias: 'language',
    ...operationOptions,
  });
}

/**
 * __useLanguageQuery__
 *
 * To run a query within a React component, call `useLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLanguageQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LanguageQuery,
    LanguageQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<LanguageQuery, LanguageQueryVariables>(
    LanguageDocument,
    baseOptions,
  );
}
export function useLanguageLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LanguageQuery,
    LanguageQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<LanguageQuery, LanguageQueryVariables>(
    LanguageDocument,
    baseOptions,
  );
}
export type LanguageQueryHookResult = ReturnType<typeof useLanguageQuery>;
export type LanguageLazyQueryHookResult = ReturnType<
  typeof useLanguageLazyQuery
>;
export type LanguageQueryResult = ApolloReactCommon.QueryResult<
  LanguageQuery,
  LanguageQueryVariables
>;
export const allNotificationStudentOrEmployerUsersDocument = gql`
  query allNotificationStudentOrEmployerUsers($filter: StintUserFilter) {
    total: _allStudentOrEmployerUsersMeta(filter: $filter) {
      count
      __typename
    }
  }
`;
export type allNotificationStudentOrEmployerUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >,
  'query'
>;

export const allNotificationStudentOrEmployerUsersComponent = (
  props: allNotificationStudentOrEmployerUsersComponentProps,
) => (
  <ApolloReactComponents.Query<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >
    query={allNotificationStudentOrEmployerUsersDocument}
    {...props}
  />
);

export type allNotificationStudentOrEmployerUsersProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >;
} &
  TChildProps;
export function withallNotificationStudentOrEmployerUsers<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables,
    allNotificationStudentOrEmployerUsersProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables,
    allNotificationStudentOrEmployerUsersProps<TChildProps, TDataName>
  >(allNotificationStudentOrEmployerUsersDocument, {
    alias: 'allNotificationStudentOrEmployerUsers',
    ...operationOptions,
  });
}

/**
 * __useallNotificationStudentOrEmployerUsersQuery__
 *
 * To run a query within a React component, call `useallNotificationStudentOrEmployerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useallNotificationStudentOrEmployerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallNotificationStudentOrEmployerUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallNotificationStudentOrEmployerUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >(allNotificationStudentOrEmployerUsersDocument, baseOptions);
}
export function useallNotificationStudentOrEmployerUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allNotificationStudentOrEmployerUsersQuery,
    allNotificationStudentOrEmployerUsersQueryVariables
  >(allNotificationStudentOrEmployerUsersDocument, baseOptions);
}
export type allNotificationStudentOrEmployerUsersQueryHookResult = ReturnType<
  typeof useallNotificationStudentOrEmployerUsersQuery
>;
export type allNotificationStudentOrEmployerUsersLazyQueryHookResult = ReturnType<
  typeof useallNotificationStudentOrEmployerUsersLazyQuery
>;
export type allNotificationStudentOrEmployerUsersQueryResult = ApolloReactCommon.QueryResult<
  allNotificationStudentOrEmployerUsersQuery,
  allNotificationStudentOrEmployerUsersQueryVariables
>;
export const allNotificationsDocument = gql`
  query allNotifications(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: NotificationFilter
  ) {
    items: allNotifications(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminNotificationFields
    }
    total: _allNotificationsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminNotificationFieldsFragmentDoc}
`;
export type allNotificationsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >,
  'query'
>;

export const allNotificationsComponent = (
  props: allNotificationsComponentProps,
) => (
  <ApolloReactComponents.Query<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >
    query={allNotificationsDocument}
    {...props}
  />
);

export type allNotificationsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >;
} &
  TChildProps;
export function withallNotifications<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allNotificationsQuery,
    allNotificationsQueryVariables,
    allNotificationsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allNotificationsQuery,
    allNotificationsQueryVariables,
    allNotificationsProps<TChildProps, TDataName>
  >(allNotificationsDocument, {
    alias: 'allNotifications',
    ...operationOptions,
  });
}

/**
 * __useallNotificationsQuery__
 *
 * To run a query within a React component, call `useallNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallNotificationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >(allNotificationsDocument, baseOptions);
}
export function useallNotificationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allNotificationsQuery,
    allNotificationsQueryVariables
  >(allNotificationsDocument, baseOptions);
}
export type allNotificationsQueryHookResult = ReturnType<
  typeof useallNotificationsQuery
>;
export type allNotificationsLazyQueryHookResult = ReturnType<
  typeof useallNotificationsLazyQuery
>;
export type allNotificationsQueryResult = ApolloReactCommon.QueryResult<
  allNotificationsQuery,
  allNotificationsQueryVariables
>;
export const NotificationDocument = gql`
  query Notification($id: UUID!) {
    data: Notification(id: $id) {
      ...AdminNotificationFields
    }
  }
  ${AdminNotificationFieldsFragmentDoc}
`;
export type NotificationComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    NotificationQuery,
    NotificationQueryVariables
  >,
  'query'
> &
  (
    | { variables: NotificationQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const NotificationComponent = (props: NotificationComponentProps) => (
  <ApolloReactComponents.Query<NotificationQuery, NotificationQueryVariables>
    query={NotificationDocument}
    {...props}
  />
);

export type NotificationProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    NotificationQuery,
    NotificationQueryVariables
  >;
} &
  TChildProps;
export function withNotification<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    NotificationQuery,
    NotificationQueryVariables,
    NotificationProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    NotificationQuery,
    NotificationQueryVariables,
    NotificationProps<TChildProps, TDataName>
  >(NotificationDocument, {
    alias: 'notification',
    ...operationOptions,
  });
}

/**
 * __useNotificationQuery__
 *
 * To run a query within a React component, call `useNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    NotificationQuery,
    NotificationQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    NotificationQuery,
    NotificationQueryVariables
  >(NotificationDocument, baseOptions);
}
export function useNotificationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    NotificationQuery,
    NotificationQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    NotificationQuery,
    NotificationQueryVariables
  >(NotificationDocument, baseOptions);
}
export type NotificationQueryHookResult = ReturnType<
  typeof useNotificationQuery
>;
export type NotificationLazyQueryHookResult = ReturnType<
  typeof useNotificationLazyQuery
>;
export type NotificationQueryResult = ApolloReactCommon.QueryResult<
  NotificationQuery,
  NotificationQueryVariables
>;
export const createNotificationDocument = gql`
  mutation createNotification(
    $title: String!
    $message: String!
    $stint_id: UUID
    $student_ids: [String]!
    $sendPushNotification: Boolean
  ) {
    data: createNotification(
      title: $title
      message: $message
      sendPushNotification: $sendPushNotification
      student_ids: $student_ids
      stint_id: $stint_id
    ) {
      ...AdminNotificationFields
    }
  }
  ${AdminNotificationFieldsFragmentDoc}
`;
export type createNotificationMutationFn = ApolloReactCommon.MutationFunction<
  createNotificationMutation,
  createNotificationMutationVariables
>;
export type createNotificationComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createNotificationMutation,
    createNotificationMutationVariables
  >,
  'mutation'
>;

export const createNotificationComponent = (
  props: createNotificationComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    createNotificationMutation,
    createNotificationMutationVariables
  >
    mutation={createNotificationDocument}
    {...props}
  />
);

export type createNotificationProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createNotificationMutation,
    createNotificationMutationVariables
  >;
} &
  TChildProps;
export function withcreateNotification<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createNotificationMutation,
    createNotificationMutationVariables,
    createNotificationProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createNotificationMutation,
    createNotificationMutationVariables,
    createNotificationProps<TChildProps, TDataName>
  >(createNotificationDocument, {
    alias: 'createNotification',
    ...operationOptions,
  });
}

/**
 * __usecreateNotificationMutation__
 *
 * To run a mutation, you first call `usecreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = usecreateNotificationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      message: // value for 'message'
 *      stint_id: // value for 'stint_id'
 *      student_ids: // value for 'student_ids'
 *      sendPushNotification: // value for 'sendPushNotification'
 *   },
 * });
 */
export function usecreateNotificationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createNotificationMutation,
    createNotificationMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createNotificationMutation,
    createNotificationMutationVariables
  >(createNotificationDocument, baseOptions);
}
export type createNotificationMutationHookResult = ReturnType<
  typeof usecreateNotificationMutation
>;
export type createNotificationMutationResult = ApolloReactCommon.MutationResult<createNotificationMutation>;
export type createNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createNotificationMutation,
  createNotificationMutationVariables
>;
export const CreateOffenceDocument = gql`
  mutation CreateOffence($createInputs: CreateOffenceInput!) {
    data: createOffence(createInputs: $createInputs) {
      id
      appealStatus
      business {
        id
        name
      }
      createdAt
      reason
      stint {
        id
        stintTimesDisplay
      }
      strikesAwarded
      createdBy {
        id
        fullname
      }
    }
  }
`;
export type CreateOffenceMutationFn = ApolloReactCommon.MutationFunction<
  CreateOffenceMutation,
  CreateOffenceMutationVariables
>;
export type CreateOffenceComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateOffenceMutation,
    CreateOffenceMutationVariables
  >,
  'mutation'
>;

export const CreateOffenceComponent = (props: CreateOffenceComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateOffenceMutation,
    CreateOffenceMutationVariables
  >
    mutation={CreateOffenceDocument}
    {...props}
  />
);

export type CreateOffenceProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    CreateOffenceMutation,
    CreateOffenceMutationVariables
  >;
} &
  TChildProps;
export function withCreateOffence<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateOffenceMutation,
    CreateOffenceMutationVariables,
    CreateOffenceProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateOffenceMutation,
    CreateOffenceMutationVariables,
    CreateOffenceProps<TChildProps, TDataName>
  >(CreateOffenceDocument, {
    alias: 'createOffence',
    ...operationOptions,
  });
}

/**
 * __useCreateOffenceMutation__
 *
 * To run a mutation, you first call `useCreateOffenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOffenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOffenceMutation, { data, loading, error }] = useCreateOffenceMutation({
 *   variables: {
 *      createInputs: // value for 'createInputs'
 *   },
 * });
 */
export function useCreateOffenceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateOffenceMutation,
    CreateOffenceMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateOffenceMutation,
    CreateOffenceMutationVariables
  >(CreateOffenceDocument, baseOptions);
}
export type CreateOffenceMutationHookResult = ReturnType<
  typeof useCreateOffenceMutation
>;
export type CreateOffenceMutationResult = ApolloReactCommon.MutationResult<CreateOffenceMutation>;
export type CreateOffenceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateOffenceMutation,
  CreateOffenceMutationVariables
>;
export const OffenceDocument = gql`
  query Offence($id: UUID!) {
    data: offence(offenceId: $id) {
      ...OffenceBasicFields
      createdAt
      reason
      createdBy {
        id
        fullname
      }
      appeals {
        id
        status
        date
        notes
        decisionAt
        decisionBy {
          id
          fullname
        }
      }
    }
  }
  ${OffenceBasicFieldsFragmentDoc}
`;
export type OffenceComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    OffenceQuery,
    OffenceQueryVariables
  >,
  'query'
> &
  ({ variables: OffenceQueryVariables; skip?: boolean } | { skip: boolean });

export const OffenceComponent = (props: OffenceComponentProps) => (
  <ApolloReactComponents.Query<OffenceQuery, OffenceQueryVariables>
    query={OffenceDocument}
    {...props}
  />
);

export type OffenceProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    OffenceQuery,
    OffenceQueryVariables
  >;
} &
  TChildProps;
export function withOffence<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    OffenceQuery,
    OffenceQueryVariables,
    OffenceProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    OffenceQuery,
    OffenceQueryVariables,
    OffenceProps<TChildProps, TDataName>
  >(OffenceDocument, {
    alias: 'offence',
    ...operationOptions,
  });
}

/**
 * __useOffenceQuery__
 *
 * To run a query within a React component, call `useOffenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOffenceQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    OffenceQuery,
    OffenceQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<OffenceQuery, OffenceQueryVariables>(
    OffenceDocument,
    baseOptions,
  );
}
export function useOffenceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    OffenceQuery,
    OffenceQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<OffenceQuery, OffenceQueryVariables>(
    OffenceDocument,
    baseOptions,
  );
}
export type OffenceQueryHookResult = ReturnType<typeof useOffenceQuery>;
export type OffenceLazyQueryHookResult = ReturnType<typeof useOffenceLazyQuery>;
export type OffenceQueryResult = ApolloReactCommon.QueryResult<
  OffenceQuery,
  OffenceQueryVariables
>;
export const stinterOffencesDocument = gql`
  query stinterOffences($id: UUID!, $perPage: Int!) {
    data: stinterOffences(stinterProfileId: $id, first: $perPage) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...OffenceBasicFields
        }
      }
    }
  }
  ${OffenceBasicFieldsFragmentDoc}
`;
export type stinterOffencesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >,
  'query'
> &
  (
    | { variables: stinterOffencesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const stinterOffencesComponent = (
  props: stinterOffencesComponentProps,
) => (
  <ApolloReactComponents.Query<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >
    query={stinterOffencesDocument}
    {...props}
  />
);

export type stinterOffencesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >;
} &
  TChildProps;
export function withstinterOffences<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    stinterOffencesQuery,
    stinterOffencesQueryVariables,
    stinterOffencesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    stinterOffencesQuery,
    stinterOffencesQueryVariables,
    stinterOffencesProps<TChildProps, TDataName>
  >(stinterOffencesDocument, {
    alias: 'stinterOffences',
    ...operationOptions,
  });
}

/**
 * __usestinterOffencesQuery__
 *
 * To run a query within a React component, call `usestinterOffencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usestinterOffencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usestinterOffencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usestinterOffencesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >(stinterOffencesDocument, baseOptions);
}
export function usestinterOffencesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    stinterOffencesQuery,
    stinterOffencesQueryVariables
  >(stinterOffencesDocument, baseOptions);
}
export type stinterOffencesQueryHookResult = ReturnType<
  typeof usestinterOffencesQuery
>;
export type stinterOffencesLazyQueryHookResult = ReturnType<
  typeof usestinterOffencesLazyQuery
>;
export type stinterOffencesQueryResult = ApolloReactCommon.QueryResult<
  stinterOffencesQuery,
  stinterOffencesQueryVariables
>;
export const allPeriodicTasksDocument = gql`
  query allPeriodicTasks($page: Int, $perPage: Int) {
    items: allPeriodicTasks(page: $page, perPage: $perPage) {
      ...AdminPeriodicTaskFields
    }
    total: _allPeriodicTasksMeta(page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
  ${AdminPeriodicTaskFieldsFragmentDoc}
`;
export type allPeriodicTasksComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >,
  'query'
>;

export const allPeriodicTasksComponent = (
  props: allPeriodicTasksComponentProps,
) => (
  <ApolloReactComponents.Query<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >
    query={allPeriodicTasksDocument}
    {...props}
  />
);

export type allPeriodicTasksProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >;
} &
  TChildProps;
export function withallPeriodicTasks<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables,
    allPeriodicTasksProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables,
    allPeriodicTasksProps<TChildProps, TDataName>
  >(allPeriodicTasksDocument, {
    alias: 'allPeriodicTasks',
    ...operationOptions,
  });
}

/**
 * __useallPeriodicTasksQuery__
 *
 * To run a query within a React component, call `useallPeriodicTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useallPeriodicTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallPeriodicTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useallPeriodicTasksQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >(allPeriodicTasksDocument, baseOptions);
}
export function useallPeriodicTasksLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allPeriodicTasksQuery,
    allPeriodicTasksQueryVariables
  >(allPeriodicTasksDocument, baseOptions);
}
export type allPeriodicTasksQueryHookResult = ReturnType<
  typeof useallPeriodicTasksQuery
>;
export type allPeriodicTasksLazyQueryHookResult = ReturnType<
  typeof useallPeriodicTasksLazyQuery
>;
export type allPeriodicTasksQueryResult = ApolloReactCommon.QueryResult<
  allPeriodicTasksQuery,
  allPeriodicTasksQueryVariables
>;
export const PeriodicTaskDocument = gql`
  query PeriodicTask($id: UUID!) {
    data: PeriodicTask(id: $id) {
      ...AdminPeriodicTaskFields
    }
  }
  ${AdminPeriodicTaskFieldsFragmentDoc}
`;
export type PeriodicTaskComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables
  >,
  'query'
> &
  (
    | { variables: PeriodicTaskQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const PeriodicTaskComponent = (props: PeriodicTaskComponentProps) => (
  <ApolloReactComponents.Query<PeriodicTaskQuery, PeriodicTaskQueryVariables>
    query={PeriodicTaskDocument}
    {...props}
  />
);

export type PeriodicTaskProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables
  >;
} &
  TChildProps;
export function withPeriodicTask<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables,
    PeriodicTaskProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables,
    PeriodicTaskProps<TChildProps, TDataName>
  >(PeriodicTaskDocument, {
    alias: 'periodicTask',
    ...operationOptions,
  });
}

/**
 * __usePeriodicTaskQuery__
 *
 * To run a query within a React component, call `usePeriodicTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeriodicTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeriodicTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePeriodicTaskQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables
  >(PeriodicTaskDocument, baseOptions);
}
export function usePeriodicTaskLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    PeriodicTaskQuery,
    PeriodicTaskQueryVariables
  >(PeriodicTaskDocument, baseOptions);
}
export type PeriodicTaskQueryHookResult = ReturnType<
  typeof usePeriodicTaskQuery
>;
export type PeriodicTaskLazyQueryHookResult = ReturnType<
  typeof usePeriodicTaskLazyQuery
>;
export type PeriodicTaskQueryResult = ApolloReactCommon.QueryResult<
  PeriodicTaskQuery,
  PeriodicTaskQueryVariables
>;
export const allPostalCodesDocument = gql`
  query allPostalCodes(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: PostalCodeFilter
  ) {
    items: allPostalCodes(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminPostalCodeFields
    }
    total: _allPostalCodesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminPostalCodeFieldsFragmentDoc}
`;
export type allPostalCodesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >,
  'query'
>;

export const allPostalCodesComponent = (
  props: allPostalCodesComponentProps,
) => (
  <ApolloReactComponents.Query<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >
    query={allPostalCodesDocument}
    {...props}
  />
);

export type allPostalCodesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >;
} &
  TChildProps;
export function withallPostalCodes<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allPostalCodesQuery,
    allPostalCodesQueryVariables,
    allPostalCodesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allPostalCodesQuery,
    allPostalCodesQueryVariables,
    allPostalCodesProps<TChildProps, TDataName>
  >(allPostalCodesDocument, {
    alias: 'allPostalCodes',
    ...operationOptions,
  });
}

/**
 * __useallPostalCodesQuery__
 *
 * To run a query within a React component, call `useallPostalCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallPostalCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallPostalCodesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallPostalCodesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >(allPostalCodesDocument, baseOptions);
}
export function useallPostalCodesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allPostalCodesQuery,
    allPostalCodesQueryVariables
  >(allPostalCodesDocument, baseOptions);
}
export type allPostalCodesQueryHookResult = ReturnType<
  typeof useallPostalCodesQuery
>;
export type allPostalCodesLazyQueryHookResult = ReturnType<
  typeof useallPostalCodesLazyQuery
>;
export type allPostalCodesQueryResult = ApolloReactCommon.QueryResult<
  allPostalCodesQuery,
  allPostalCodesQueryVariables
>;
export const PostalCodeDocument = gql`
  query PostalCode($id: UUID!) {
    data: PostalCode(id: $id) {
      ...AdminPostalCodeFields
    }
  }
  ${AdminPostalCodeFieldsFragmentDoc}
`;
export type PostalCodeComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    PostalCodeQuery,
    PostalCodeQueryVariables
  >,
  'query'
> &
  ({ variables: PostalCodeQueryVariables; skip?: boolean } | { skip: boolean });

export const PostalCodeComponent = (props: PostalCodeComponentProps) => (
  <ApolloReactComponents.Query<PostalCodeQuery, PostalCodeQueryVariables>
    query={PostalCodeDocument}
    {...props}
  />
);

export type PostalCodeProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    PostalCodeQuery,
    PostalCodeQueryVariables
  >;
} &
  TChildProps;
export function withPostalCode<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    PostalCodeQuery,
    PostalCodeQueryVariables,
    PostalCodeProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    PostalCodeQuery,
    PostalCodeQueryVariables,
    PostalCodeProps<TChildProps, TDataName>
  >(PostalCodeDocument, {
    alias: 'postalCode',
    ...operationOptions,
  });
}

/**
 * __usePostalCodeQuery__
 *
 * To run a query within a React component, call `usePostalCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostalCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostalCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostalCodeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PostalCodeQuery,
    PostalCodeQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<PostalCodeQuery, PostalCodeQueryVariables>(
    PostalCodeDocument,
    baseOptions,
  );
}
export function usePostalCodeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PostalCodeQuery,
    PostalCodeQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    PostalCodeQuery,
    PostalCodeQueryVariables
  >(PostalCodeDocument, baseOptions);
}
export type PostalCodeQueryHookResult = ReturnType<typeof usePostalCodeQuery>;
export type PostalCodeLazyQueryHookResult = ReturnType<
  typeof usePostalCodeLazyQuery
>;
export type PostalCodeQueryResult = ApolloReactCommon.QueryResult<
  PostalCodeQuery,
  PostalCodeQueryVariables
>;
export const createPostalCodeDocument = gql`
  mutation createPostalCode($postalCode: String!, $city_id: UUID!) {
    data: createPostalCode(postalCode: $postalCode, city_id: $city_id) {
      ...AdminPostalCodeFields
    }
  }
  ${AdminPostalCodeFieldsFragmentDoc}
`;
export type createPostalCodeMutationFn = ApolloReactCommon.MutationFunction<
  createPostalCodeMutation,
  createPostalCodeMutationVariables
>;
export type createPostalCodeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createPostalCodeMutation,
    createPostalCodeMutationVariables
  >,
  'mutation'
>;

export const createPostalCodeComponent = (
  props: createPostalCodeComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    createPostalCodeMutation,
    createPostalCodeMutationVariables
  >
    mutation={createPostalCodeDocument}
    {...props}
  />
);

export type createPostalCodeProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createPostalCodeMutation,
    createPostalCodeMutationVariables
  >;
} &
  TChildProps;
export function withcreatePostalCode<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createPostalCodeMutation,
    createPostalCodeMutationVariables,
    createPostalCodeProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createPostalCodeMutation,
    createPostalCodeMutationVariables,
    createPostalCodeProps<TChildProps, TDataName>
  >(createPostalCodeDocument, {
    alias: 'createPostalCode',
    ...operationOptions,
  });
}

/**
 * __usecreatePostalCodeMutation__
 *
 * To run a mutation, you first call `usecreatePostalCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreatePostalCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostalCodeMutation, { data, loading, error }] = usecreatePostalCodeMutation({
 *   variables: {
 *      postalCode: // value for 'postalCode'
 *      city_id: // value for 'city_id'
 *   },
 * });
 */
export function usecreatePostalCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createPostalCodeMutation,
    createPostalCodeMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createPostalCodeMutation,
    createPostalCodeMutationVariables
  >(createPostalCodeDocument, baseOptions);
}
export type createPostalCodeMutationHookResult = ReturnType<
  typeof usecreatePostalCodeMutation
>;
export type createPostalCodeMutationResult = ApolloReactCommon.MutationResult<createPostalCodeMutation>;
export type createPostalCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createPostalCodeMutation,
  createPostalCodeMutationVariables
>;
export const updatePostalCodeDocument = gql`
  mutation updatePostalCode($id: UUID!, $postalCode: String, $city_id: UUID) {
    data: updatePostalCode(
      id: $id
      postalCode: $postalCode
      city_id: $city_id
    ) {
      ...AdminPostalCodeFields
    }
  }
  ${AdminPostalCodeFieldsFragmentDoc}
`;
export type updatePostalCodeMutationFn = ApolloReactCommon.MutationFunction<
  updatePostalCodeMutation,
  updatePostalCodeMutationVariables
>;
export type updatePostalCodeComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables
  >,
  'mutation'
>;

export const updatePostalCodeComponent = (
  props: updatePostalCodeComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables
  >
    mutation={updatePostalCodeDocument}
    {...props}
  />
);

export type updatePostalCodeProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables
  >;
} &
  TChildProps;
export function withupdatePostalCode<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables,
    updatePostalCodeProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables,
    updatePostalCodeProps<TChildProps, TDataName>
  >(updatePostalCodeDocument, {
    alias: 'updatePostalCode',
    ...operationOptions,
  });
}

/**
 * __useupdatePostalCodeMutation__
 *
 * To run a mutation, you first call `useupdatePostalCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdatePostalCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostalCodeMutation, { data, loading, error }] = useupdatePostalCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      postalCode: // value for 'postalCode'
 *      city_id: // value for 'city_id'
 *   },
 * });
 */
export function useupdatePostalCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updatePostalCodeMutation,
    updatePostalCodeMutationVariables
  >(updatePostalCodeDocument, baseOptions);
}
export type updatePostalCodeMutationHookResult = ReturnType<
  typeof useupdatePostalCodeMutation
>;
export type updatePostalCodeMutationResult = ApolloReactCommon.MutationResult<updatePostalCodeMutation>;
export type updatePostalCodeMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updatePostalCodeMutation,
  updatePostalCodeMutationVariables
>;
export const allRegionsDocument = gql`
  query allRegions(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: RegionFilter
  ) {
    items: allRegions(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminRegionFields
    }
    total: _allRegionsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminRegionFieldsFragmentDoc}
`;
export type allRegionsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allRegionsQuery,
    allRegionsQueryVariables
  >,
  'query'
>;

export const allRegionsComponent = (props: allRegionsComponentProps) => (
  <ApolloReactComponents.Query<allRegionsQuery, allRegionsQueryVariables>
    query={allRegionsDocument}
    {...props}
  />
);

export type allRegionsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allRegionsQuery,
    allRegionsQueryVariables
  >;
} &
  TChildProps;
export function withallRegions<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allRegionsQuery,
    allRegionsQueryVariables,
    allRegionsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allRegionsQuery,
    allRegionsQueryVariables,
    allRegionsProps<TChildProps, TDataName>
  >(allRegionsDocument, {
    alias: 'allRegions',
    ...operationOptions,
  });
}

/**
 * __useallRegionsQuery__
 *
 * To run a query within a React component, call `useallRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallRegionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallRegionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allRegionsQuery,
    allRegionsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<allRegionsQuery, allRegionsQueryVariables>(
    allRegionsDocument,
    baseOptions,
  );
}
export function useallRegionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allRegionsQuery,
    allRegionsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allRegionsQuery,
    allRegionsQueryVariables
  >(allRegionsDocument, baseOptions);
}
export type allRegionsQueryHookResult = ReturnType<typeof useallRegionsQuery>;
export type allRegionsLazyQueryHookResult = ReturnType<
  typeof useallRegionsLazyQuery
>;
export type allRegionsQueryResult = ApolloReactCommon.QueryResult<
  allRegionsQuery,
  allRegionsQueryVariables
>;
export const RegionDocument = gql`
  query Region($id: UUID!) {
    data: Region(id: $id) {
      ...AdminRegionFields
    }
  }
  ${AdminRegionFieldsFragmentDoc}
`;
export type RegionComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    RegionQuery,
    RegionQueryVariables
  >,
  'query'
> &
  ({ variables: RegionQueryVariables; skip?: boolean } | { skip: boolean });

export const RegionComponent = (props: RegionComponentProps) => (
  <ApolloReactComponents.Query<RegionQuery, RegionQueryVariables>
    query={RegionDocument}
    {...props}
  />
);

export type RegionProps<TChildProps = {}, TDataName extends string = 'data'> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    RegionQuery,
    RegionQueryVariables
  >;
} &
  TChildProps;
export function withRegion<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    RegionQuery,
    RegionQueryVariables,
    RegionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    RegionQuery,
    RegionQueryVariables,
    RegionProps<TChildProps, TDataName>
  >(RegionDocument, {
    alias: 'region',
    ...operationOptions,
  });
}

/**
 * __useRegionQuery__
 *
 * To run a query within a React component, call `useRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    RegionQuery,
    RegionQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<RegionQuery, RegionQueryVariables>(
    RegionDocument,
    baseOptions,
  );
}
export function useRegionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    RegionQuery,
    RegionQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<RegionQuery, RegionQueryVariables>(
    RegionDocument,
    baseOptions,
  );
}
export type RegionQueryHookResult = ReturnType<typeof useRegionQuery>;
export type RegionLazyQueryHookResult = ReturnType<typeof useRegionLazyQuery>;
export type RegionQueryResult = ApolloReactCommon.QueryResult<
  RegionQuery,
  RegionQueryVariables
>;
export const createRegionDocument = gql`
  mutation createRegion($name: String!, $countryId: UUID!) {
    data: createRegion(name: $name, countryId: $countryId) {
      ...AdminRegionFields
    }
  }
  ${AdminRegionFieldsFragmentDoc}
`;
export type createRegionMutationFn = ApolloReactCommon.MutationFunction<
  createRegionMutation,
  createRegionMutationVariables
>;
export type createRegionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createRegionMutation,
    createRegionMutationVariables
  >,
  'mutation'
>;

export const createRegionComponent = (props: createRegionComponentProps) => (
  <ApolloReactComponents.Mutation<
    createRegionMutation,
    createRegionMutationVariables
  >
    mutation={createRegionDocument}
    {...props}
  />
);

export type createRegionProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createRegionMutation,
    createRegionMutationVariables
  >;
} &
  TChildProps;
export function withcreateRegion<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createRegionMutation,
    createRegionMutationVariables,
    createRegionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createRegionMutation,
    createRegionMutationVariables,
    createRegionProps<TChildProps, TDataName>
  >(createRegionDocument, {
    alias: 'createRegion',
    ...operationOptions,
  });
}

/**
 * __usecreateRegionMutation__
 *
 * To run a mutation, you first call `usecreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = usecreateRegionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function usecreateRegionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createRegionMutation,
    createRegionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createRegionMutation,
    createRegionMutationVariables
  >(createRegionDocument, baseOptions);
}
export type createRegionMutationHookResult = ReturnType<
  typeof usecreateRegionMutation
>;
export type createRegionMutationResult = ApolloReactCommon.MutationResult<createRegionMutation>;
export type createRegionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createRegionMutation,
  createRegionMutationVariables
>;
export const updateRegionDocument = gql`
  mutation updateRegion($id: UUID!, $name: String!, $countryId: UUID) {
    data: updateRegion(id: $id, name: $name, countryId: $countryId) {
      ...AdminRegionFields
    }
  }
  ${AdminRegionFieldsFragmentDoc}
`;
export type updateRegionMutationFn = ApolloReactCommon.MutationFunction<
  updateRegionMutation,
  updateRegionMutationVariables
>;
export type updateRegionComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateRegionMutation,
    updateRegionMutationVariables
  >,
  'mutation'
>;

export const updateRegionComponent = (props: updateRegionComponentProps) => (
  <ApolloReactComponents.Mutation<
    updateRegionMutation,
    updateRegionMutationVariables
  >
    mutation={updateRegionDocument}
    {...props}
  />
);

export type updateRegionProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateRegionMutation,
    updateRegionMutationVariables
  >;
} &
  TChildProps;
export function withupdateRegion<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateRegionMutation,
    updateRegionMutationVariables,
    updateRegionProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateRegionMutation,
    updateRegionMutationVariables,
    updateRegionProps<TChildProps, TDataName>
  >(updateRegionDocument, {
    alias: 'updateRegion',
    ...operationOptions,
  });
}

/**
 * __useupdateRegionMutation__
 *
 * To run a mutation, you first call `useupdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useupdateRegionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useupdateRegionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateRegionMutation,
    updateRegionMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateRegionMutation,
    updateRegionMutationVariables
  >(updateRegionDocument, baseOptions);
}
export type updateRegionMutationHookResult = ReturnType<
  typeof useupdateRegionMutation
>;
export type updateRegionMutationResult = ApolloReactCommon.MutationResult<updateRegionMutation>;
export type updateRegionMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateRegionMutation,
  updateRegionMutationVariables
>;
export const ListStintTemplatesDocument = gql`
  query ListStintTemplates($businessId: UUID!, $page: Int, $pageSize: Int) {
    data: stintTemplates(
      businessId: $businessId
      page: $page
      pageSize: $pageSize
    ) {
      objects {
        id
        name
      }
    }
  }
`;
export type ListStintTemplatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >,
  'query'
> &
  (
    | { variables: ListStintTemplatesQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const ListStintTemplatesComponent = (
  props: ListStintTemplatesComponentProps,
) => (
  <ApolloReactComponents.Query<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >
    query={ListStintTemplatesDocument}
    {...props}
  />
);

export type ListStintTemplatesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >;
} &
  TChildProps;
export function withListStintTemplates<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables,
    ListStintTemplatesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables,
    ListStintTemplatesProps<TChildProps, TDataName>
  >(ListStintTemplatesDocument, {
    alias: 'listStintTemplates',
    ...operationOptions,
  });
}

/**
 * __useListStintTemplatesQuery__
 *
 * To run a query within a React component, call `useListStintTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStintTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStintTemplatesQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useListStintTemplatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >(ListStintTemplatesDocument, baseOptions);
}
export function useListStintTemplatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    ListStintTemplatesQuery,
    ListStintTemplatesQueryVariables
  >(ListStintTemplatesDocument, baseOptions);
}
export type ListStintTemplatesQueryHookResult = ReturnType<
  typeof useListStintTemplatesQuery
>;
export type ListStintTemplatesLazyQueryHookResult = ReturnType<
  typeof useListStintTemplatesLazyQuery
>;
export type ListStintTemplatesQueryResult = ApolloReactCommon.QueryResult<
  ListStintTemplatesQuery,
  ListStintTemplatesQueryVariables
>;
export const AdminUserDocument = gql`
  query AdminUser($id: UUID!) {
    data: adminUser(userId: $id) {
      ...StaffUserFields
    }
  }
  ${StaffUserFieldsFragmentDoc}
`;
export type AdminUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AdminUserQuery,
    AdminUserQueryVariables
  >,
  'query'
> &
  ({ variables: AdminUserQueryVariables; skip?: boolean } | { skip: boolean });

export const AdminUserComponent = (props: AdminUserComponentProps) => (
  <ApolloReactComponents.Query<AdminUserQuery, AdminUserQueryVariables>
    query={AdminUserDocument}
    {...props}
  />
);

export type AdminUserProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    AdminUserQuery,
    AdminUserQueryVariables
  >;
} &
  TChildProps;
export function withAdminUser<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    AdminUserQuery,
    AdminUserQueryVariables,
    AdminUserProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    AdminUserQuery,
    AdminUserQueryVariables,
    AdminUserProps<TChildProps, TDataName>
  >(AdminUserDocument, {
    alias: 'adminUser',
    ...operationOptions,
  });
}

/**
 * __useAdminUserQuery__
 *
 * To run a query within a React component, call `useAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminUserQuery,
    AdminUserQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<AdminUserQuery, AdminUserQueryVariables>(
    AdminUserDocument,
    baseOptions,
  );
}
export function useAdminUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminUserQuery,
    AdminUserQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<AdminUserQuery, AdminUserQueryVariables>(
    AdminUserDocument,
    baseOptions,
  );
}
export type AdminUserQueryHookResult = ReturnType<typeof useAdminUserQuery>;
export type AdminUserLazyQueryHookResult = ReturnType<
  typeof useAdminUserLazyQuery
>;
export type AdminUserQueryResult = ApolloReactCommon.QueryResult<
  AdminUserQuery,
  AdminUserQueryVariables
>;
export const allAdminUsersDocument = gql`
  query allAdminUsers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: String
  ) {
    items: allAdminUsers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...StaffUserFields
    }
    total: _allAdminUserMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${StaffUserFieldsFragmentDoc}
`;
export type allAdminUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allAdminUsersQuery,
    allAdminUsersQueryVariables
  >,
  'query'
>;

export const allAdminUsersComponent = (props: allAdminUsersComponentProps) => (
  <ApolloReactComponents.Query<allAdminUsersQuery, allAdminUsersQueryVariables>
    query={allAdminUsersDocument}
    {...props}
  />
);

export type allAdminUsersProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allAdminUsersQuery,
    allAdminUsersQueryVariables
  >;
} &
  TChildProps;
export function withallAdminUsers<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allAdminUsersQuery,
    allAdminUsersQueryVariables,
    allAdminUsersProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allAdminUsersQuery,
    allAdminUsersQueryVariables,
    allAdminUsersProps<TChildProps, TDataName>
  >(allAdminUsersDocument, {
    alias: 'allAdminUsers',
    ...operationOptions,
  });
}

/**
 * __useallAdminUsersQuery__
 *
 * To run a query within a React component, call `useallAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useallAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallAdminUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallAdminUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allAdminUsersQuery,
    allAdminUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allAdminUsersQuery,
    allAdminUsersQueryVariables
  >(allAdminUsersDocument, baseOptions);
}
export function useallAdminUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allAdminUsersQuery,
    allAdminUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allAdminUsersQuery,
    allAdminUsersQueryVariables
  >(allAdminUsersDocument, baseOptions);
}
export type allAdminUsersQueryHookResult = ReturnType<
  typeof useallAdminUsersQuery
>;
export type allAdminUsersLazyQueryHookResult = ReturnType<
  typeof useallAdminUsersLazyQuery
>;
export type allAdminUsersQueryResult = ApolloReactCommon.QueryResult<
  allAdminUsersQuery,
  allAdminUsersQueryVariables
>;
export const allStintsDocument = gql`
  query allStints(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: StintFilter
  ) {
    items: allStints(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminStintListFields
    }
    total: _allStintsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminStintListFieldsFragmentDoc}
`;
export type allStintsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStintsQuery,
    allStintsQueryVariables
  >,
  'query'
>;

export const allStintsComponent = (props: allStintsComponentProps) => (
  <ApolloReactComponents.Query<allStintsQuery, allStintsQueryVariables>
    query={allStintsDocument}
    {...props}
  />
);

export type allStintsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStintsQuery,
    allStintsQueryVariables
  >;
} &
  TChildProps;
export function withallStints<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStintsQuery,
    allStintsQueryVariables,
    allStintsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStintsQuery,
    allStintsQueryVariables,
    allStintsProps<TChildProps, TDataName>
  >(allStintsDocument, {
    alias: 'allStints',
    ...operationOptions,
  });
}

/**
 * __useallStintsQuery__
 *
 * To run a query within a React component, call `useallStintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStintsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStintsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStintsQuery,
    allStintsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<allStintsQuery, allStintsQueryVariables>(
    allStintsDocument,
    baseOptions,
  );
}
export function useallStintsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStintsQuery,
    allStintsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<allStintsQuery, allStintsQueryVariables>(
    allStintsDocument,
    baseOptions,
  );
}
export type allStintsQueryHookResult = ReturnType<typeof useallStintsQuery>;
export type allStintsLazyQueryHookResult = ReturnType<
  typeof useallStintsLazyQuery
>;
export type allStintsQueryResult = ApolloReactCommon.QueryResult<
  allStintsQuery,
  allStintsQueryVariables
>;
export const StintDocument = gql`
  query Stint($id: UUID!) {
    data: Stint(id: $id) {
      ...AdminStintFields
    }
  }
  ${AdminStintFieldsFragmentDoc}
`;
export type StintComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<StintQuery, StintQueryVariables>,
  'query'
> &
  ({ variables: StintQueryVariables; skip?: boolean } | { skip: boolean });

export const StintComponent = (props: StintComponentProps) => (
  <ApolloReactComponents.Query<StintQuery, StintQueryVariables>
    query={StintDocument}
    {...props}
  />
);

export type StintProps<TChildProps = {}, TDataName extends string = 'data'> = {
  [key in TDataName]: ApolloReactHoc.DataValue<StintQuery, StintQueryVariables>;
} &
  TChildProps;
export function withStint<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StintQuery,
    StintQueryVariables,
    StintProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StintQuery,
    StintQueryVariables,
    StintProps<TChildProps, TDataName>
  >(StintDocument, {
    alias: 'stint',
    ...operationOptions,
  });
}

/**
 * __useStintQuery__
 *
 * To run a query within a React component, call `useStintQuery` and pass it any options that fit your needs.
 * When your component renders, `useStintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStintQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StintQuery,
    StintQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<StintQuery, StintQueryVariables>(
    StintDocument,
    baseOptions,
  );
}
export function useStintLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StintQuery,
    StintQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<StintQuery, StintQueryVariables>(
    StintDocument,
    baseOptions,
  );
}
export type StintQueryHookResult = ReturnType<typeof useStintQuery>;
export type StintLazyQueryHookResult = ReturnType<typeof useStintLazyQuery>;
export type StintQueryResult = ApolloReactCommon.QueryResult<
  StintQuery,
  StintQueryVariables
>;
export const updateStintDocument = gql`
  mutation updateStint(
    $cancellationFee: Float
    $cancellationFeeApplied: Boolean
    $controlCheck: Boolean
    $dateFrom: DateTime
    $dateTo: DateTime
    $checkInDate: DateTime
    $displayAddress: String
    $exceptions: [StintTemplateExceptionInput]
    $isBestEffort: Boolean
    $id: UUID!
    $name: String
    $status: Int
    $notes: String
    $placeId: String
    $primaryTasks: [StintTemplateTaskInput]
    $student_id: UUID
    $studentUnassignedReasons: [StudentUnassignedReasons]
    $topTips: [StintTemplateTopTipInput]
    $uniform: [StintUniform]
    $baseFeeOverride: Float
    $baseRateOverride: Float
    $surgeRate: Float
  ) {
    data: updateStint(
      cancellationFee: $cancellationFee
      cancellationFeeOverride: $cancellationFeeApplied
      controlCheck: $controlCheck
      dateFrom: $dateFrom
      dateTo: $dateTo
      checkInDate: $checkInDate
      displayAddress: $displayAddress
      exceptions: $exceptions
      id: $id
      isBestEffort: $isBestEffort
      name: $name
      status: $status
      notes: $notes
      placeId: $placeId
      primaryTasks: $primaryTasks
      student_id: $student_id
      studentUnassignedReasons: $studentUnassignedReasons
      topTips: $topTips
      uniform: $uniform
      overrideBaseFee: $baseFeeOverride
      studentBaseFeeOverrideGrossAmount: $baseRateOverride
      studentSurgeBaseFeeGrossAmount: $surgeRate
    ) {
      ...AdminStintFields
    }
  }
  ${AdminStintFieldsFragmentDoc}
`;
export type updateStintMutationFn = ApolloReactCommon.MutationFunction<
  updateStintMutation,
  updateStintMutationVariables
>;
export type updateStintComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateStintMutation,
    updateStintMutationVariables
  >,
  'mutation'
>;

export const updateStintComponent = (props: updateStintComponentProps) => (
  <ApolloReactComponents.Mutation<
    updateStintMutation,
    updateStintMutationVariables
  >
    mutation={updateStintDocument}
    {...props}
  />
);

export type updateStintProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateStintMutation,
    updateStintMutationVariables
  >;
} &
  TChildProps;
export function withupdateStint<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateStintMutation,
    updateStintMutationVariables,
    updateStintProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateStintMutation,
    updateStintMutationVariables,
    updateStintProps<TChildProps, TDataName>
  >(updateStintDocument, {
    alias: 'updateStint',
    ...operationOptions,
  });
}

/**
 * __useupdateStintMutation__
 *
 * To run a mutation, you first call `useupdateStintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateStintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStintMutation, { data, loading, error }] = useupdateStintMutation({
 *   variables: {
 *      cancellationFee: // value for 'cancellationFee'
 *      cancellationFeeApplied: // value for 'cancellationFeeApplied'
 *      controlCheck: // value for 'controlCheck'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      checkInDate: // value for 'checkInDate'
 *      displayAddress: // value for 'displayAddress'
 *      exceptions: // value for 'exceptions'
 *      isBestEffort: // value for 'isBestEffort'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *      placeId: // value for 'placeId'
 *      primaryTasks: // value for 'primaryTasks'
 *      student_id: // value for 'student_id'
 *      studentUnassignedReasons: // value for 'studentUnassignedReasons'
 *      topTips: // value for 'topTips'
 *      uniform: // value for 'uniform'
 *      baseFeeOverride: // value for 'baseFeeOverride'
 *      baseRateOverride: // value for 'baseRateOverride'
 *      surgeRate: // value for 'surgeRate'
 *   },
 * });
 */
export function useupdateStintMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateStintMutation,
    updateStintMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateStintMutation,
    updateStintMutationVariables
  >(updateStintDocument, baseOptions);
}
export type updateStintMutationHookResult = ReturnType<
  typeof useupdateStintMutation
>;
export type updateStintMutationResult = ApolloReactCommon.MutationResult<updateStintMutation>;
export type updateStintMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateStintMutation,
  updateStintMutationVariables
>;
export const cancelStintsDocument = gql`
  mutation cancelStints($stintRefs: [UUID]!) {
    data: cancelStints(stintRefs: $stintRefs) {
      entries {
        id
      }
    }
  }
`;
export type cancelStintsMutationFn = ApolloReactCommon.MutationFunction<
  cancelStintsMutation,
  cancelStintsMutationVariables
>;
export type cancelStintsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    cancelStintsMutation,
    cancelStintsMutationVariables
  >,
  'mutation'
>;

export const cancelStintsComponent = (props: cancelStintsComponentProps) => (
  <ApolloReactComponents.Mutation<
    cancelStintsMutation,
    cancelStintsMutationVariables
  >
    mutation={cancelStintsDocument}
    {...props}
  />
);

export type cancelStintsProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    cancelStintsMutation,
    cancelStintsMutationVariables
  >;
} &
  TChildProps;
export function withcancelStints<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    cancelStintsMutation,
    cancelStintsMutationVariables,
    cancelStintsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    cancelStintsMutation,
    cancelStintsMutationVariables,
    cancelStintsProps<TChildProps, TDataName>
  >(cancelStintsDocument, {
    alias: 'cancelStints',
    ...operationOptions,
  });
}

/**
 * __usecancelStintsMutation__
 *
 * To run a mutation, you first call `usecancelStintsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecancelStintsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelStintsMutation, { data, loading, error }] = usecancelStintsMutation({
 *   variables: {
 *      stintRefs: // value for 'stintRefs'
 *   },
 * });
 */
export function usecancelStintsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    cancelStintsMutation,
    cancelStintsMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    cancelStintsMutation,
    cancelStintsMutationVariables
  >(cancelStintsDocument, baseOptions);
}
export type cancelStintsMutationHookResult = ReturnType<
  typeof usecancelStintsMutation
>;
export type cancelStintsMutationResult = ApolloReactCommon.MutationResult<cancelStintsMutation>;
export type cancelStintsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  cancelStintsMutation,
  cancelStintsMutationVariables
>;
export const CreateStintsDocument = gql`
  mutation CreateStints($createInputs: CreateStintsInput!) {
    createStints(createInputs: $createInputs) {
      id
    }
  }
`;
export type CreateStintsMutationFn = ApolloReactCommon.MutationFunction<
  CreateStintsMutation,
  CreateStintsMutationVariables
>;
export type CreateStintsComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateStintsMutation,
    CreateStintsMutationVariables
  >,
  'mutation'
>;

export const CreateStintsComponent = (props: CreateStintsComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreateStintsMutation,
    CreateStintsMutationVariables
  >
    mutation={CreateStintsDocument}
    {...props}
  />
);

export type CreateStintsProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    CreateStintsMutation,
    CreateStintsMutationVariables
  >;
} &
  TChildProps;
export function withCreateStints<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    CreateStintsMutation,
    CreateStintsMutationVariables,
    CreateStintsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    CreateStintsMutation,
    CreateStintsMutationVariables,
    CreateStintsProps<TChildProps, TDataName>
  >(CreateStintsDocument, {
    alias: 'createStints',
    ...operationOptions,
  });
}

/**
 * __useCreateStintsMutation__
 *
 * To run a mutation, you first call `useCreateStintsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStintsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStintsMutation, { data, loading, error }] = useCreateStintsMutation({
 *   variables: {
 *      createInputs: // value for 'createInputs'
 *   },
 * });
 */
export function useCreateStintsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateStintsMutation,
    CreateStintsMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateStintsMutation,
    CreateStintsMutationVariables
  >(CreateStintsDocument, baseOptions);
}
export type CreateStintsMutationHookResult = ReturnType<
  typeof useCreateStintsMutation
>;
export type CreateStintsMutationResult = ApolloReactCommon.MutationResult<CreateStintsMutation>;
export type CreateStintsMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateStintsMutation,
  CreateStintsMutationVariables
>;
export const allStintJourneysDocument = gql`
  query allStintJourneys(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: StintJourneyFilter
  ) {
    items: allStintJourneys(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminStintJourneyFields
    }
    total: _allStintJourneysMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminStintJourneyFieldsFragmentDoc}
`;
export type allStintJourneysComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >,
  'query'
>;

export const allStintJourneysComponent = (
  props: allStintJourneysComponentProps,
) => (
  <ApolloReactComponents.Query<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >
    query={allStintJourneysDocument}
    {...props}
  />
);

export type allStintJourneysProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >;
} &
  TChildProps;
export function withallStintJourneys<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStintJourneysQuery,
    allStintJourneysQueryVariables,
    allStintJourneysProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStintJourneysQuery,
    allStintJourneysQueryVariables,
    allStintJourneysProps<TChildProps, TDataName>
  >(allStintJourneysDocument, {
    alias: 'allStintJourneys',
    ...operationOptions,
  });
}

/**
 * __useallStintJourneysQuery__
 *
 * To run a query within a React component, call `useallStintJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStintJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStintJourneysQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStintJourneysQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >(allStintJourneysDocument, baseOptions);
}
export function useallStintJourneysLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStintJourneysQuery,
    allStintJourneysQueryVariables
  >(allStintJourneysDocument, baseOptions);
}
export type allStintJourneysQueryHookResult = ReturnType<
  typeof useallStintJourneysQuery
>;
export type allStintJourneysLazyQueryHookResult = ReturnType<
  typeof useallStintJourneysLazyQuery
>;
export type allStintJourneysQueryResult = ApolloReactCommon.QueryResult<
  allStintJourneysQuery,
  allStintJourneysQueryVariables
>;
export const StintJourneyDocument = gql`
  query StintJourney($id: UUID!) {
    data: StintJourney(id: $id) {
      ...AdminStintJourneyFields
    }
  }
  ${AdminStintJourneyFieldsFragmentDoc}
`;
export type StintJourneyComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StintJourneyQuery,
    StintJourneyQueryVariables
  >,
  'query'
> &
  (
    | { variables: StintJourneyQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const StintJourneyComponent = (props: StintJourneyComponentProps) => (
  <ApolloReactComponents.Query<StintJourneyQuery, StintJourneyQueryVariables>
    query={StintJourneyDocument}
    {...props}
  />
);

export type StintJourneyProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StintJourneyQuery,
    StintJourneyQueryVariables
  >;
} &
  TChildProps;
export function withStintJourney<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StintJourneyQuery,
    StintJourneyQueryVariables,
    StintJourneyProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StintJourneyQuery,
    StintJourneyQueryVariables,
    StintJourneyProps<TChildProps, TDataName>
  >(StintJourneyDocument, {
    alias: 'stintJourney',
    ...operationOptions,
  });
}

/**
 * __useStintJourneyQuery__
 *
 * To run a query within a React component, call `useStintJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStintJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStintJourneyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStintJourneyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StintJourneyQuery,
    StintJourneyQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    StintJourneyQuery,
    StintJourneyQueryVariables
  >(StintJourneyDocument, baseOptions);
}
export function useStintJourneyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StintJourneyQuery,
    StintJourneyQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    StintJourneyQuery,
    StintJourneyQueryVariables
  >(StintJourneyDocument, baseOptions);
}
export type StintJourneyQueryHookResult = ReturnType<
  typeof useStintJourneyQuery
>;
export type StintJourneyLazyQueryHookResult = ReturnType<
  typeof useStintJourneyLazyQuery
>;
export type StintJourneyQueryResult = ApolloReactCommon.QueryResult<
  StintJourneyQuery,
  StintJourneyQueryVariables
>;
export const updateStintJourneyDocument = gql`
  mutation updateStintJourney(
    $id: UUID!
    $estimatedTimeOfArrival: DateTime
    $estimatedTimeOfDeparture: DateTime
    $checkInDate: DateTime
    $differentStartTimeReasons: [DifferentStartTimeReason]
    $lateNote: String
    $internalNotes: String
    $statusResolved: Boolean
  ) {
    data: updateStintJourney(
      id: $id
      estimatedTimeOfArrival: $estimatedTimeOfArrival
      estimatedTimeOfDeparture: $estimatedTimeOfDeparture
      checkInDate: $checkInDate
      differentStartTimeReasons: $differentStartTimeReasons
      lateNote: $lateNote
      internalNotes: $internalNotes
      statusResolved: $statusResolved
    ) {
      ...AdminStintJourneyFields
    }
  }
  ${AdminStintJourneyFieldsFragmentDoc}
`;
export type updateStintJourneyMutationFn = ApolloReactCommon.MutationFunction<
  updateStintJourneyMutation,
  updateStintJourneyMutationVariables
>;
export type updateStintJourneyComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables
  >,
  'mutation'
>;

export const updateStintJourneyComponent = (
  props: updateStintJourneyComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables
  >
    mutation={updateStintJourneyDocument}
    {...props}
  />
);

export type updateStintJourneyProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables
  >;
} &
  TChildProps;
export function withupdateStintJourney<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables,
    updateStintJourneyProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables,
    updateStintJourneyProps<TChildProps, TDataName>
  >(updateStintJourneyDocument, {
    alias: 'updateStintJourney',
    ...operationOptions,
  });
}

/**
 * __useupdateStintJourneyMutation__
 *
 * To run a mutation, you first call `useupdateStintJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateStintJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStintJourneyMutation, { data, loading, error }] = useupdateStintJourneyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      estimatedTimeOfArrival: // value for 'estimatedTimeOfArrival'
 *      estimatedTimeOfDeparture: // value for 'estimatedTimeOfDeparture'
 *      checkInDate: // value for 'checkInDate'
 *      differentStartTimeReasons: // value for 'differentStartTimeReasons'
 *      lateNote: // value for 'lateNote'
 *      internalNotes: // value for 'internalNotes'
 *      statusResolved: // value for 'statusResolved'
 *   },
 * });
 */
export function useupdateStintJourneyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateStintJourneyMutation,
    updateStintJourneyMutationVariables
  >(updateStintJourneyDocument, baseOptions);
}
export type updateStintJourneyMutationHookResult = ReturnType<
  typeof useupdateStintJourneyMutation
>;
export type updateStintJourneyMutationResult = ApolloReactCommon.MutationResult<updateStintJourneyMutation>;
export type updateStintJourneyMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateStintJourneyMutation,
  updateStintJourneyMutationVariables
>;
export const resolveStintJourneysDocument = gql`
  mutation resolveStintJourneys($ids: [UUID!]!) {
    data: resolveStintJourneys(stintJourneyIds: $ids) {
      ...AdminStintJourneyFields
    }
  }
  ${AdminStintJourneyFieldsFragmentDoc}
`;
export type resolveStintJourneysMutationFn = ApolloReactCommon.MutationFunction<
  resolveStintJourneysMutation,
  resolveStintJourneysMutationVariables
>;
export type resolveStintJourneysComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables
  >,
  'mutation'
>;

export const resolveStintJourneysComponent = (
  props: resolveStintJourneysComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables
  >
    mutation={resolveStintJourneysDocument}
    {...props}
  />
);

export type resolveStintJourneysProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables
  >;
} &
  TChildProps;
export function withresolveStintJourneys<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables,
    resolveStintJourneysProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables,
    resolveStintJourneysProps<TChildProps, TDataName>
  >(resolveStintJourneysDocument, {
    alias: 'resolveStintJourneys',
    ...operationOptions,
  });
}

/**
 * __useresolveStintJourneysMutation__
 *
 * To run a mutation, you first call `useresolveStintJourneysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useresolveStintJourneysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveStintJourneysMutation, { data, loading, error }] = useresolveStintJourneysMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useresolveStintJourneysMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    resolveStintJourneysMutation,
    resolveStintJourneysMutationVariables
  >(resolveStintJourneysDocument, baseOptions);
}
export type resolveStintJourneysMutationHookResult = ReturnType<
  typeof useresolveStintJourneysMutation
>;
export type resolveStintJourneysMutationResult = ApolloReactCommon.MutationResult<resolveStintJourneysMutation>;
export type resolveStintJourneysMutationOptions = ApolloReactCommon.BaseMutationOptions<
  resolveStintJourneysMutation,
  resolveStintJourneysMutationVariables
>;
export const allStintTemplatesDocument = gql`
  query allStintTemplates(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: StintTemplateFilter
  ) {
    items: allStintTemplates(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminStintTemplateFields
    }
    total: _allStintTemplatesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminStintTemplateFieldsFragmentDoc}
`;
export type allStintTemplatesComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >,
  'query'
>;

export const allStintTemplatesComponent = (
  props: allStintTemplatesComponentProps,
) => (
  <ApolloReactComponents.Query<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >
    query={allStintTemplatesDocument}
    {...props}
  />
);

export type allStintTemplatesProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >;
} &
  TChildProps;
export function withallStintTemplates<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables,
    allStintTemplatesProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables,
    allStintTemplatesProps<TChildProps, TDataName>
  >(allStintTemplatesDocument, {
    alias: 'allStintTemplates',
    ...operationOptions,
  });
}

/**
 * __useallStintTemplatesQuery__
 *
 * To run a query within a React component, call `useallStintTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStintTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStintTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStintTemplatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >(allStintTemplatesDocument, baseOptions);
}
export function useallStintTemplatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStintTemplatesQuery,
    allStintTemplatesQueryVariables
  >(allStintTemplatesDocument, baseOptions);
}
export type allStintTemplatesQueryHookResult = ReturnType<
  typeof useallStintTemplatesQuery
>;
export type allStintTemplatesLazyQueryHookResult = ReturnType<
  typeof useallStintTemplatesLazyQuery
>;
export type allStintTemplatesQueryResult = ApolloReactCommon.QueryResult<
  allStintTemplatesQuery,
  allStintTemplatesQueryVariables
>;
export const StintTemplateDocument = gql`
  query StintTemplate($id: UUID!) {
    data: StintTemplate(id: $id) {
      ...AdminSingleStintTemplateFields
    }
  }
  ${AdminSingleStintTemplateFieldsFragmentDoc}
`;
export type StintTemplateComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StintTemplateQuery,
    StintTemplateQueryVariables
  >,
  'query'
> &
  (
    | { variables: StintTemplateQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const StintTemplateComponent = (props: StintTemplateComponentProps) => (
  <ApolloReactComponents.Query<StintTemplateQuery, StintTemplateQueryVariables>
    query={StintTemplateDocument}
    {...props}
  />
);

export type StintTemplateProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StintTemplateQuery,
    StintTemplateQueryVariables
  >;
} &
  TChildProps;
export function withStintTemplate<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StintTemplateQuery,
    StintTemplateQueryVariables,
    StintTemplateProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StintTemplateQuery,
    StintTemplateQueryVariables,
    StintTemplateProps<TChildProps, TDataName>
  >(StintTemplateDocument, {
    alias: 'stintTemplate',
    ...operationOptions,
  });
}

/**
 * __useStintTemplateQuery__
 *
 * To run a query within a React component, call `useStintTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useStintTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStintTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStintTemplateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StintTemplateQuery,
    StintTemplateQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    StintTemplateQuery,
    StintTemplateQueryVariables
  >(StintTemplateDocument, baseOptions);
}
export function useStintTemplateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StintTemplateQuery,
    StintTemplateQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    StintTemplateQuery,
    StintTemplateQueryVariables
  >(StintTemplateDocument, baseOptions);
}
export type StintTemplateQueryHookResult = ReturnType<
  typeof useStintTemplateQuery
>;
export type StintTemplateLazyQueryHookResult = ReturnType<
  typeof useStintTemplateLazyQuery
>;
export type StintTemplateQueryResult = ApolloReactCommon.QueryResult<
  StintTemplateQuery,
  StintTemplateQueryVariables
>;
export const updateStintTemplateDocument = gql`
  mutation updateStintTemplate($input: UpdateStintTemplateInput!) {
    data: updateStintTemplate(input: $input) {
      ...AdminSingleStintTemplateFields
    }
  }
  ${AdminSingleStintTemplateFieldsFragmentDoc}
`;
export type updateStintTemplateMutationFn = ApolloReactCommon.MutationFunction<
  updateStintTemplateMutation,
  updateStintTemplateMutationVariables
>;
export type updateStintTemplateComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables
  >,
  'mutation'
>;

export const updateStintTemplateComponent = (
  props: updateStintTemplateComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables
  >
    mutation={updateStintTemplateDocument}
    {...props}
  />
);

export type updateStintTemplateProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables
  >;
} &
  TChildProps;
export function withupdateStintTemplate<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables,
    updateStintTemplateProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables,
    updateStintTemplateProps<TChildProps, TDataName>
  >(updateStintTemplateDocument, {
    alias: 'updateStintTemplate',
    ...operationOptions,
  });
}

/**
 * __useupdateStintTemplateMutation__
 *
 * To run a mutation, you first call `useupdateStintTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateStintTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStintTemplateMutation, { data, loading, error }] = useupdateStintTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useupdateStintTemplateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateStintTemplateMutation,
    updateStintTemplateMutationVariables
  >(updateStintTemplateDocument, baseOptions);
}
export type updateStintTemplateMutationHookResult = ReturnType<
  typeof useupdateStintTemplateMutation
>;
export type updateStintTemplateMutationResult = ApolloReactCommon.MutationResult<updateStintTemplateMutation>;
export type updateStintTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateStintTemplateMutation,
  updateStintTemplateMutationVariables
>;
export const allStintopediasDocument = gql`
  query allStintopedias(
    $filter: StintopediaFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allStintopedias(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      ...AdminStintopediaFields
    }
    total: _allStintopediasMeta(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      count
      __typename
    }
  }
  ${AdminStintopediaFieldsFragmentDoc}
`;
export type allStintopediasComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >,
  'query'
>;

export const allStintopediasComponent = (
  props: allStintopediasComponentProps,
) => (
  <ApolloReactComponents.Query<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >
    query={allStintopediasDocument}
    {...props}
  />
);

export type allStintopediasProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >;
} &
  TChildProps;
export function withallStintopedias<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStintopediasQuery,
    allStintopediasQueryVariables,
    allStintopediasProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStintopediasQuery,
    allStintopediasQueryVariables,
    allStintopediasProps<TChildProps, TDataName>
  >(allStintopediasDocument, {
    alias: 'allStintopedias',
    ...operationOptions,
  });
}

/**
 * __useallStintopediasQuery__
 *
 * To run a query within a React component, call `useallStintopediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStintopediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStintopediasQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useallStintopediasQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >(allStintopediasDocument, baseOptions);
}
export function useallStintopediasLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStintopediasQuery,
    allStintopediasQueryVariables
  >(allStintopediasDocument, baseOptions);
}
export type allStintopediasQueryHookResult = ReturnType<
  typeof useallStintopediasQuery
>;
export type allStintopediasLazyQueryHookResult = ReturnType<
  typeof useallStintopediasLazyQuery
>;
export type allStintopediasQueryResult = ApolloReactCommon.QueryResult<
  allStintopediasQuery,
  allStintopediasQueryVariables
>;
export const StintopediaDocument = gql`
  query Stintopedia($id: UUID!) {
    data: Stintopedia(id: $id) {
      ...AdminStintopediaFields
    }
  }
  ${AdminStintopediaFieldsFragmentDoc}
`;
export type StintopediaComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StintopediaQuery,
    StintopediaQueryVariables
  >,
  'query'
> &
  (
    | { variables: StintopediaQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const StintopediaComponent = (props: StintopediaComponentProps) => (
  <ApolloReactComponents.Query<StintopediaQuery, StintopediaQueryVariables>
    query={StintopediaDocument}
    {...props}
  />
);

export type StintopediaProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StintopediaQuery,
    StintopediaQueryVariables
  >;
} &
  TChildProps;
export function withStintopedia<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StintopediaQuery,
    StintopediaQueryVariables,
    StintopediaProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StintopediaQuery,
    StintopediaQueryVariables,
    StintopediaProps<TChildProps, TDataName>
  >(StintopediaDocument, {
    alias: 'stintopedia',
    ...operationOptions,
  });
}

/**
 * __useStintopediaQuery__
 *
 * To run a query within a React component, call `useStintopediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useStintopediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStintopediaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStintopediaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StintopediaQuery,
    StintopediaQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<StintopediaQuery, StintopediaQueryVariables>(
    StintopediaDocument,
    baseOptions,
  );
}
export function useStintopediaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StintopediaQuery,
    StintopediaQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    StintopediaQuery,
    StintopediaQueryVariables
  >(StintopediaDocument, baseOptions);
}
export type StintopediaQueryHookResult = ReturnType<typeof useStintopediaQuery>;
export type StintopediaLazyQueryHookResult = ReturnType<
  typeof useStintopediaLazyQuery
>;
export type StintopediaQueryResult = ApolloReactCommon.QueryResult<
  StintopediaQuery,
  StintopediaQueryVariables
>;
export const updateStintopediaDocument = gql`
  mutation updateStintopedia(
    $businessId: UUID!
    $aboutUs: String
    $accessToAnnualPlAccounts: Boolean
    $accessToRotaExamples: Boolean
    $accessToTransactionSalesData: Boolean
    $agreedTakePartInMarketingInitiatives: Boolean
    $agreedToContinuePostingIfWeSeeDesireResults: Boolean
    $agreedToOperateStaffingRota: Boolean
    $agreedToReferFriendsIfFinancialMetricsImproved: Boolean
    $businessLogo: String
    $characteristicIds: [UUID]
    $donts: [String]
    $dos: [String]
    $emoji: String
    $exceptionIds: [UUID]
    $facebook: String
    $generalPhoto1: String
    $generalPhoto2: String
    $generalPhoto3: String
    $generalPhoto4: String
    $instagram: String
    $internalNotes: String
    $linkedin: String
    $onboardingComplete: Boolean
    $photoOfEntrance: String
    $preferredLanguageIds: [UUID]
    $prepVideoUrl: String
    $qrCodeLocation: String
    $teamStructure: String
    $website: String
  ) {
    data: updateStintopedia(
      businessId: $businessId
      aboutUs: $aboutUs
      accessToAnnualPlAccounts: $accessToAnnualPlAccounts
      accessToRotaExamples: $accessToRotaExamples
      accessToTransactionSalesData: $accessToTransactionSalesData
      agreedTakePartInMarketingInitiatives: $agreedTakePartInMarketingInitiatives
      agreedToContinuePostingIfWeSeeDesireResults: $agreedToContinuePostingIfWeSeeDesireResults
      agreedToOperateStaffingRota: $agreedToOperateStaffingRota
      agreedToReferFriendsIfFinancialMetricsImproved: $agreedToReferFriendsIfFinancialMetricsImproved
      businessLogo: $businessLogo
      characteristicIds: $characteristicIds
      donts: $donts
      dos: $dos
      emoji: $emoji
      exceptionIds: $exceptionIds
      facebook: $facebook
      generalPhoto1: $generalPhoto1
      generalPhoto2: $generalPhoto2
      generalPhoto3: $generalPhoto3
      generalPhoto4: $generalPhoto4
      instagram: $instagram
      internalNotes: $internalNotes
      linkedin: $linkedin
      onboardingComplete: $onboardingComplete
      photoOfEntrance: $photoOfEntrance
      preferredLanguageIds: $preferredLanguageIds
      prepVideoUrl: $prepVideoUrl
      qrCodeLocation: $qrCodeLocation
      teamStructure: $teamStructure
      website: $website
    ) {
      ...AdminStintopediaFields
    }
  }
  ${AdminStintopediaFieldsFragmentDoc}
`;
export type updateStintopediaMutationFn = ApolloReactCommon.MutationFunction<
  updateStintopediaMutation,
  updateStintopediaMutationVariables
>;
export type updateStintopediaComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateStintopediaMutation,
    updateStintopediaMutationVariables
  >,
  'mutation'
>;

export const updateStintopediaComponent = (
  props: updateStintopediaComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateStintopediaMutation,
    updateStintopediaMutationVariables
  >
    mutation={updateStintopediaDocument}
    {...props}
  />
);

export type updateStintopediaProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateStintopediaMutation,
    updateStintopediaMutationVariables
  >;
} &
  TChildProps;
export function withupdateStintopedia<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateStintopediaMutation,
    updateStintopediaMutationVariables,
    updateStintopediaProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateStintopediaMutation,
    updateStintopediaMutationVariables,
    updateStintopediaProps<TChildProps, TDataName>
  >(updateStintopediaDocument, {
    alias: 'updateStintopedia',
    ...operationOptions,
  });
}

/**
 * __useupdateStintopediaMutation__
 *
 * To run a mutation, you first call `useupdateStintopediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateStintopediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStintopediaMutation, { data, loading, error }] = useupdateStintopediaMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      aboutUs: // value for 'aboutUs'
 *      accessToAnnualPlAccounts: // value for 'accessToAnnualPlAccounts'
 *      accessToRotaExamples: // value for 'accessToRotaExamples'
 *      accessToTransactionSalesData: // value for 'accessToTransactionSalesData'
 *      agreedTakePartInMarketingInitiatives: // value for 'agreedTakePartInMarketingInitiatives'
 *      agreedToContinuePostingIfWeSeeDesireResults: // value for 'agreedToContinuePostingIfWeSeeDesireResults'
 *      agreedToOperateStaffingRota: // value for 'agreedToOperateStaffingRota'
 *      agreedToReferFriendsIfFinancialMetricsImproved: // value for 'agreedToReferFriendsIfFinancialMetricsImproved'
 *      businessLogo: // value for 'businessLogo'
 *      characteristicIds: // value for 'characteristicIds'
 *      donts: // value for 'donts'
 *      dos: // value for 'dos'
 *      emoji: // value for 'emoji'
 *      exceptionIds: // value for 'exceptionIds'
 *      facebook: // value for 'facebook'
 *      generalPhoto1: // value for 'generalPhoto1'
 *      generalPhoto2: // value for 'generalPhoto2'
 *      generalPhoto3: // value for 'generalPhoto3'
 *      generalPhoto4: // value for 'generalPhoto4'
 *      instagram: // value for 'instagram'
 *      internalNotes: // value for 'internalNotes'
 *      linkedin: // value for 'linkedin'
 *      onboardingComplete: // value for 'onboardingComplete'
 *      photoOfEntrance: // value for 'photoOfEntrance'
 *      preferredLanguageIds: // value for 'preferredLanguageIds'
 *      prepVideoUrl: // value for 'prepVideoUrl'
 *      qrCodeLocation: // value for 'qrCodeLocation'
 *      teamStructure: // value for 'teamStructure'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useupdateStintopediaMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateStintopediaMutation,
    updateStintopediaMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateStintopediaMutation,
    updateStintopediaMutationVariables
  >(updateStintopediaDocument, baseOptions);
}
export type updateStintopediaMutationHookResult = ReturnType<
  typeof useupdateStintopediaMutation
>;
export type updateStintopediaMutationResult = ApolloReactCommon.MutationResult<updateStintopediaMutation>;
export type updateStintopediaMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateStintopediaMutation,
  updateStintopediaMutationVariables
>;
export const StudentUserDocument = gql`
  query StudentUser($id: UUID!) {
    mono: studentUser(userId: $id) {
      id
      firstName
      lastName
      email
      emailVerified
      enabled
      attributes {
        name
        value
      }
      user {
        id
        email
        secondaryEmail
        locationSetting
        profilePhotoUrl
        phoneNumber
        deactivated
        isVerifiedByStint
        permanentDeactivated
        appVersion
        dateOfBirth
        exceptions {
          id
          name
        }
        studentProfile {
          id
          university_id
          emergencyContactName
          emergencyContactNumber
          emergencyContactRelation
          employeeStatement
          studentLoanPlan
          strikesAwarded
          paymentMethods {
            accountName
            accountNumber
            sortCode
            __typename
          }
          __typename
        }
        publicRating
        canSeeSurge
        __typename
      }
    }
  }
`;
export type StudentUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StudentUserQuery,
    StudentUserQueryVariables
  >,
  'query'
> &
  (
    | { variables: StudentUserQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const StudentUserComponent = (props: StudentUserComponentProps) => (
  <ApolloReactComponents.Query<StudentUserQuery, StudentUserQueryVariables>
    query={StudentUserDocument}
    {...props}
  />
);

export type StudentUserProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StudentUserQuery,
    StudentUserQueryVariables
  >;
} &
  TChildProps;
export function withStudentUser<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StudentUserQuery,
    StudentUserQueryVariables,
    StudentUserProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StudentUserQuery,
    StudentUserQueryVariables,
    StudentUserProps<TChildProps, TDataName>
  >(StudentUserDocument, {
    alias: 'studentUser',
    ...operationOptions,
  });
}

/**
 * __useStudentUserQuery__
 *
 * To run a query within a React component, call `useStudentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StudentUserQuery,
    StudentUserQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<StudentUserQuery, StudentUserQueryVariables>(
    StudentUserDocument,
    baseOptions,
  );
}
export function useStudentUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StudentUserQuery,
    StudentUserQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    StudentUserQuery,
    StudentUserQueryVariables
  >(StudentUserDocument, baseOptions);
}
export type StudentUserQueryHookResult = ReturnType<typeof useStudentUserQuery>;
export type StudentUserLazyQueryHookResult = ReturnType<
  typeof useStudentUserLazyQuery
>;
export type StudentUserQueryResult = ApolloReactCommon.QueryResult<
  StudentUserQuery,
  StudentUserQueryVariables
>;
export const allStudentUsersDocument = gql`
  query allStudentUsers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: String
  ) {
    items: allStudentUsers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      firstName
      lastName
      email
      attributes {
        name
        value
      }
      user {
        id
        dateOfBirth
        profilePhotoUrl
        appVersion
        __typename
      }
    }
    total: _allStudentUserMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;
export type allStudentUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >,
  'query'
>;

export const allStudentUsersComponent = (
  props: allStudentUsersComponentProps,
) => (
  <ApolloReactComponents.Query<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >
    query={allStudentUsersDocument}
    {...props}
  />
);

export type allStudentUsersProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >;
} &
  TChildProps;
export function withallStudentUsers<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStudentUsersQuery,
    allStudentUsersQueryVariables,
    allStudentUsersProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStudentUsersQuery,
    allStudentUsersQueryVariables,
    allStudentUsersProps<TChildProps, TDataName>
  >(allStudentUsersDocument, {
    alias: 'allStudentUsers',
    ...operationOptions,
  });
}

/**
 * __useallStudentUsersQuery__
 *
 * To run a query within a React component, call `useallStudentUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStudentUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStudentUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStudentUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >(allStudentUsersDocument, baseOptions);
}
export function useallStudentUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStudentUsersQuery,
    allStudentUsersQueryVariables
  >(allStudentUsersDocument, baseOptions);
}
export type allStudentUsersQueryHookResult = ReturnType<
  typeof useallStudentUsersQuery
>;
export type allStudentUsersLazyQueryHookResult = ReturnType<
  typeof useallStudentUsersLazyQuery
>;
export type allStudentUsersQueryResult = ApolloReactCommon.QueryResult<
  allStudentUsersQuery,
  allStudentUsersQueryVariables
>;
export const allStudentReviewsDocument = gql`
  query allStudentReviews(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: StudentReviewFilter
  ) {
    items: allStudentReviews(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      __typename
      ...AdminStudentReviewFields
    }
    total: _allStudentReviewsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminStudentReviewFieldsFragmentDoc}
`;
export type allStudentReviewsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >,
  'query'
>;

export const allStudentReviewsComponent = (
  props: allStudentReviewsComponentProps,
) => (
  <ApolloReactComponents.Query<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >
    query={allStudentReviewsDocument}
    {...props}
  />
);

export type allStudentReviewsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >;
} &
  TChildProps;
export function withallStudentReviews<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables,
    allStudentReviewsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables,
    allStudentReviewsProps<TChildProps, TDataName>
  >(allStudentReviewsDocument, {
    alias: 'allStudentReviews',
    ...operationOptions,
  });
}

/**
 * __useallStudentReviewsQuery__
 *
 * To run a query within a React component, call `useallStudentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStudentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStudentReviewsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStudentReviewsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >(allStudentReviewsDocument, baseOptions);
}
export function useallStudentReviewsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStudentReviewsQuery,
    allStudentReviewsQueryVariables
  >(allStudentReviewsDocument, baseOptions);
}
export type allStudentReviewsQueryHookResult = ReturnType<
  typeof useallStudentReviewsQuery
>;
export type allStudentReviewsLazyQueryHookResult = ReturnType<
  typeof useallStudentReviewsLazyQuery
>;
export type allStudentReviewsQueryResult = ApolloReactCommon.QueryResult<
  allStudentReviewsQuery,
  allStudentReviewsQueryVariables
>;
export const StudentReviewDocument = gql`
  query StudentReview($id: UUID!) {
    data: StudentReview(id: $id) {
      __typename
      ...AdminStudentReviewFields
    }
  }
  ${AdminStudentReviewFieldsFragmentDoc}
`;
export type StudentReviewComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StudentReviewQuery,
    StudentReviewQueryVariables
  >,
  'query'
> &
  (
    | { variables: StudentReviewQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const StudentReviewComponent = (props: StudentReviewComponentProps) => (
  <ApolloReactComponents.Query<StudentReviewQuery, StudentReviewQueryVariables>
    query={StudentReviewDocument}
    {...props}
  />
);

export type StudentReviewProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StudentReviewQuery,
    StudentReviewQueryVariables
  >;
} &
  TChildProps;
export function withStudentReview<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StudentReviewQuery,
    StudentReviewQueryVariables,
    StudentReviewProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StudentReviewQuery,
    StudentReviewQueryVariables,
    StudentReviewProps<TChildProps, TDataName>
  >(StudentReviewDocument, {
    alias: 'studentReview',
    ...operationOptions,
  });
}

/**
 * __useStudentReviewQuery__
 *
 * To run a query within a React component, call `useStudentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentReviewQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StudentReviewQuery,
    StudentReviewQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    StudentReviewQuery,
    StudentReviewQueryVariables
  >(StudentReviewDocument, baseOptions);
}
export function useStudentReviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StudentReviewQuery,
    StudentReviewQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    StudentReviewQuery,
    StudentReviewQueryVariables
  >(StudentReviewDocument, baseOptions);
}
export type StudentReviewQueryHookResult = ReturnType<
  typeof useStudentReviewQuery
>;
export type StudentReviewLazyQueryHookResult = ReturnType<
  typeof useStudentReviewLazyQuery
>;
export type StudentReviewQueryResult = ApolloReactCommon.QueryResult<
  StudentReviewQuery,
  StudentReviewQueryVariables
>;
export const allTagsDocument = gql`
  query allTags(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allTags(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      ...AdminTagFields
    }
    total: _allTagsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      count
      __typename
    }
  }
  ${AdminTagFieldsFragmentDoc}
`;
export type allTagsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allTagsQuery,
    allTagsQueryVariables
  >,
  'query'
>;

export const allTagsComponent = (props: allTagsComponentProps) => (
  <ApolloReactComponents.Query<allTagsQuery, allTagsQueryVariables>
    query={allTagsDocument}
    {...props}
  />
);

export type allTagsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allTagsQuery,
    allTagsQueryVariables
  >;
} &
  TChildProps;
export function withallTags<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allTagsQuery,
    allTagsQueryVariables,
    allTagsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allTagsQuery,
    allTagsQueryVariables,
    allTagsProps<TChildProps, TDataName>
  >(allTagsDocument, {
    alias: 'allTags',
    ...operationOptions,
  });
}

/**
 * __useallTagsQuery__
 *
 * To run a query within a React component, call `useallTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useallTagsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allTagsQuery,
    allTagsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<allTagsQuery, allTagsQueryVariables>(
    allTagsDocument,
    baseOptions,
  );
}
export function useallTagsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allTagsQuery,
    allTagsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<allTagsQuery, allTagsQueryVariables>(
    allTagsDocument,
    baseOptions,
  );
}
export type allTagsQueryHookResult = ReturnType<typeof useallTagsQuery>;
export type allTagsLazyQueryHookResult = ReturnType<typeof useallTagsLazyQuery>;
export type allTagsQueryResult = ApolloReactCommon.QueryResult<
  allTagsQuery,
  allTagsQueryVariables
>;
export const TagDocument = gql`
  query Tag($id: UUID!) {
    data: Tag(id: $id) {
      ...AdminTagFields
    }
  }
  ${AdminTagFieldsFragmentDoc}
`;
export type TagComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<TagQuery, TagQueryVariables>,
  'query'
> &
  ({ variables: TagQueryVariables; skip?: boolean } | { skip: boolean });

export const TagComponent = (props: TagComponentProps) => (
  <ApolloReactComponents.Query<TagQuery, TagQueryVariables>
    query={TagDocument}
    {...props}
  />
);

export type TagProps<TChildProps = {}, TDataName extends string = 'data'> = {
  [key in TDataName]: ApolloReactHoc.DataValue<TagQuery, TagQueryVariables>;
} &
  TChildProps;
export function withTag<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    TagQuery,
    TagQueryVariables,
    TagProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    TagQuery,
    TagQueryVariables,
    TagProps<TChildProps, TDataName>
  >(TagDocument, {
    alias: 'tag',
    ...operationOptions,
  });
}

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<TagQuery, TagQueryVariables>,
) {
  return ApolloReactHooks.useQuery<TagQuery, TagQueryVariables>(
    TagDocument,
    baseOptions,
  );
}
export function useTagLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TagQuery,
    TagQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<TagQuery, TagQueryVariables>(
    TagDocument,
    baseOptions,
  );
}
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagQueryResult = ApolloReactCommon.QueryResult<
  TagQuery,
  TagQueryVariables
>;
export const createTagDocument = gql`
  mutation createTag($name: String!, $description: String) {
    data: createTag(name: $name, description: $description) {
      ...AdminTagFields
    }
  }
  ${AdminTagFieldsFragmentDoc}
`;
export type createTagMutationFn = ApolloReactCommon.MutationFunction<
  createTagMutation,
  createTagMutationVariables
>;
export type createTagComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createTagMutation,
    createTagMutationVariables
  >,
  'mutation'
>;

export const createTagComponent = (props: createTagComponentProps) => (
  <ApolloReactComponents.Mutation<createTagMutation, createTagMutationVariables>
    mutation={createTagDocument}
    {...props}
  />
);

export type createTagProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createTagMutation,
    createTagMutationVariables
  >;
} &
  TChildProps;
export function withcreateTag<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createTagMutation,
    createTagMutationVariables,
    createTagProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createTagMutation,
    createTagMutationVariables,
    createTagProps<TChildProps, TDataName>
  >(createTagDocument, {
    alias: 'createTag',
    ...operationOptions,
  });
}

/**
 * __usecreateTagMutation__
 *
 * To run a mutation, you first call `usecreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = usecreateTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function usecreateTagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createTagMutation,
    createTagMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createTagMutation,
    createTagMutationVariables
  >(createTagDocument, baseOptions);
}
export type createTagMutationHookResult = ReturnType<
  typeof usecreateTagMutation
>;
export type createTagMutationResult = ApolloReactCommon.MutationResult<createTagMutation>;
export type createTagMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createTagMutation,
  createTagMutationVariables
>;
export const updateTagDocument = gql`
  mutation updateTag($id: UUID!, $name: String!, $description: String) {
    data: updateTag(id: $id, name: $name, description: $description) {
      ...AdminTagFields
    }
  }
  ${AdminTagFieldsFragmentDoc}
`;
export type updateTagMutationFn = ApolloReactCommon.MutationFunction<
  updateTagMutation,
  updateTagMutationVariables
>;
export type updateTagComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateTagMutation,
    updateTagMutationVariables
  >,
  'mutation'
>;

export const updateTagComponent = (props: updateTagComponentProps) => (
  <ApolloReactComponents.Mutation<updateTagMutation, updateTagMutationVariables>
    mutation={updateTagDocument}
    {...props}
  />
);

export type updateTagProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateTagMutation,
    updateTagMutationVariables
  >;
} &
  TChildProps;
export function withupdateTag<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateTagMutation,
    updateTagMutationVariables,
    updateTagProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateTagMutation,
    updateTagMutationVariables,
    updateTagProps<TChildProps, TDataName>
  >(updateTagDocument, {
    alias: 'updateTag',
    ...operationOptions,
  });
}

/**
 * __useupdateTagMutation__
 *
 * To run a mutation, you first call `useupdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useupdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useupdateTagMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateTagMutation,
    updateTagMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateTagMutation,
    updateTagMutationVariables
  >(updateTagDocument, baseOptions);
}
export type updateTagMutationHookResult = ReturnType<
  typeof useupdateTagMutation
>;
export type updateTagMutationResult = ApolloReactCommon.MutationResult<updateTagMutation>;
export type updateTagMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateTagMutation,
  updateTagMutationVariables
>;
export const allStintTasksDocument = gql`
  query allStintTasks(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: StintTaskFilter
  ) {
    items: allStintTasks(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminStintTaskFields
    }
    total: _allStintTasksMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminStintTaskFieldsFragmentDoc}
`;
export type allStintTasksComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStintTasksQuery,
    allStintTasksQueryVariables
  >,
  'query'
>;

export const allStintTasksComponent = (props: allStintTasksComponentProps) => (
  <ApolloReactComponents.Query<allStintTasksQuery, allStintTasksQueryVariables>
    query={allStintTasksDocument}
    {...props}
  />
);

export type allStintTasksProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStintTasksQuery,
    allStintTasksQueryVariables
  >;
} &
  TChildProps;
export function withallStintTasks<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStintTasksQuery,
    allStintTasksQueryVariables,
    allStintTasksProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStintTasksQuery,
    allStintTasksQueryVariables,
    allStintTasksProps<TChildProps, TDataName>
  >(allStintTasksDocument, {
    alias: 'allStintTasks',
    ...operationOptions,
  });
}

/**
 * __useallStintTasksQuery__
 *
 * To run a query within a React component, call `useallStintTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStintTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStintTasksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStintTasksQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStintTasksQuery,
    allStintTasksQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStintTasksQuery,
    allStintTasksQueryVariables
  >(allStintTasksDocument, baseOptions);
}
export function useallStintTasksLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStintTasksQuery,
    allStintTasksQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStintTasksQuery,
    allStintTasksQueryVariables
  >(allStintTasksDocument, baseOptions);
}
export type allStintTasksQueryHookResult = ReturnType<
  typeof useallStintTasksQuery
>;
export type allStintTasksLazyQueryHookResult = ReturnType<
  typeof useallStintTasksLazyQuery
>;
export type allStintTasksQueryResult = ApolloReactCommon.QueryResult<
  allStintTasksQuery,
  allStintTasksQueryVariables
>;
export const StintTaskDocument = gql`
  query StintTask($id: UUID!) {
    data: StintTask(id: $id) {
      ...AdminStintTaskFields
    }
  }
  ${AdminStintTaskFieldsFragmentDoc}
`;
export type StintTaskComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StintTaskQuery,
    StintTaskQueryVariables
  >,
  'query'
> &
  ({ variables: StintTaskQueryVariables; skip?: boolean } | { skip: boolean });

export const StintTaskComponent = (props: StintTaskComponentProps) => (
  <ApolloReactComponents.Query<StintTaskQuery, StintTaskQueryVariables>
    query={StintTaskDocument}
    {...props}
  />
);

export type StintTaskProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StintTaskQuery,
    StintTaskQueryVariables
  >;
} &
  TChildProps;
export function withStintTask<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StintTaskQuery,
    StintTaskQueryVariables,
    StintTaskProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StintTaskQuery,
    StintTaskQueryVariables,
    StintTaskProps<TChildProps, TDataName>
  >(StintTaskDocument, {
    alias: 'stintTask',
    ...operationOptions,
  });
}

/**
 * __useStintTaskQuery__
 *
 * To run a query within a React component, call `useStintTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useStintTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStintTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStintTaskQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StintTaskQuery,
    StintTaskQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<StintTaskQuery, StintTaskQueryVariables>(
    StintTaskDocument,
    baseOptions,
  );
}
export function useStintTaskLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StintTaskQuery,
    StintTaskQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<StintTaskQuery, StintTaskQueryVariables>(
    StintTaskDocument,
    baseOptions,
  );
}
export type StintTaskQueryHookResult = ReturnType<typeof useStintTaskQuery>;
export type StintTaskLazyQueryHookResult = ReturnType<
  typeof useStintTaskLazyQuery
>;
export type StintTaskQueryResult = ApolloReactCommon.QueryResult<
  StintTaskQuery,
  StintTaskQueryVariables
>;
export const updateStintTaskDocument = gql`
  mutation updateStintTask(
    $id: UUID!
    $name: String
    $taskType: String
    $topTips: [TaskTopTipInput]
  ) {
    data: updateStintTask(
      id: $id
      name: $name
      taskType: $taskType
      topTips: $topTips
    ) {
      ...AdminStintTaskFields
    }
  }
  ${AdminStintTaskFieldsFragmentDoc}
`;
export type updateStintTaskMutationFn = ApolloReactCommon.MutationFunction<
  updateStintTaskMutation,
  updateStintTaskMutationVariables
>;
export type updateStintTaskComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateStintTaskMutation,
    updateStintTaskMutationVariables
  >,
  'mutation'
>;

export const updateStintTaskComponent = (
  props: updateStintTaskComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateStintTaskMutation,
    updateStintTaskMutationVariables
  >
    mutation={updateStintTaskDocument}
    {...props}
  />
);

export type updateStintTaskProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateStintTaskMutation,
    updateStintTaskMutationVariables
  >;
} &
  TChildProps;
export function withupdateStintTask<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateStintTaskMutation,
    updateStintTaskMutationVariables,
    updateStintTaskProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateStintTaskMutation,
    updateStintTaskMutationVariables,
    updateStintTaskProps<TChildProps, TDataName>
  >(updateStintTaskDocument, {
    alias: 'updateStintTask',
    ...operationOptions,
  });
}

/**
 * __useupdateStintTaskMutation__
 *
 * To run a mutation, you first call `useupdateStintTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateStintTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStintTaskMutation, { data, loading, error }] = useupdateStintTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      taskType: // value for 'taskType'
 *      topTips: // value for 'topTips'
 *   },
 * });
 */
export function useupdateStintTaskMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateStintTaskMutation,
    updateStintTaskMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateStintTaskMutation,
    updateStintTaskMutationVariables
  >(updateStintTaskDocument, baseOptions);
}
export type updateStintTaskMutationHookResult = ReturnType<
  typeof useupdateStintTaskMutation
>;
export type updateStintTaskMutationResult = ApolloReactCommon.MutationResult<updateStintTaskMutation>;
export type updateStintTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateStintTaskMutation,
  updateStintTaskMutationVariables
>;
export const createStintTaskDocument = gql`
  mutation createStintTask($name: String!, $taskType: String) {
    data: createStintTask(name: $name, taskType: $taskType) {
      ...AdminStintTaskFields
    }
  }
  ${AdminStintTaskFieldsFragmentDoc}
`;
export type createStintTaskMutationFn = ApolloReactCommon.MutationFunction<
  createStintTaskMutation,
  createStintTaskMutationVariables
>;
export type createStintTaskComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createStintTaskMutation,
    createStintTaskMutationVariables
  >,
  'mutation'
>;

export const createStintTaskComponent = (
  props: createStintTaskComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    createStintTaskMutation,
    createStintTaskMutationVariables
  >
    mutation={createStintTaskDocument}
    {...props}
  />
);

export type createStintTaskProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createStintTaskMutation,
    createStintTaskMutationVariables
  >;
} &
  TChildProps;
export function withcreateStintTask<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createStintTaskMutation,
    createStintTaskMutationVariables,
    createStintTaskProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createStintTaskMutation,
    createStintTaskMutationVariables,
    createStintTaskProps<TChildProps, TDataName>
  >(createStintTaskDocument, {
    alias: 'createStintTask',
    ...operationOptions,
  });
}

/**
 * __usecreateStintTaskMutation__
 *
 * To run a mutation, you first call `usecreateStintTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateStintTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStintTaskMutation, { data, loading, error }] = usecreateStintTaskMutation({
 *   variables: {
 *      name: // value for 'name'
 *      taskType: // value for 'taskType'
 *   },
 * });
 */
export function usecreateStintTaskMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createStintTaskMutation,
    createStintTaskMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createStintTaskMutation,
    createStintTaskMutationVariables
  >(createStintTaskDocument, baseOptions);
}
export type createStintTaskMutationHookResult = ReturnType<
  typeof usecreateStintTaskMutation
>;
export type createStintTaskMutationResult = ApolloReactCommon.MutationResult<createStintTaskMutation>;
export type createStintTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createStintTaskMutation,
  createStintTaskMutationVariables
>;
export const allTopTipsDocument = gql`
  query allTopTips(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: TopTipFilter
  ) {
    items: allTopTips(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AdminTopTipFields
    }
    total: _allTopTipsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
  ${AdminTopTipFieldsFragmentDoc}
`;
export type allTopTipsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allTopTipsQuery,
    allTopTipsQueryVariables
  >,
  'query'
>;

export const allTopTipsComponent = (props: allTopTipsComponentProps) => (
  <ApolloReactComponents.Query<allTopTipsQuery, allTopTipsQueryVariables>
    query={allTopTipsDocument}
    {...props}
  />
);

export type allTopTipsProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allTopTipsQuery,
    allTopTipsQueryVariables
  >;
} &
  TChildProps;
export function withallTopTips<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allTopTipsQuery,
    allTopTipsQueryVariables,
    allTopTipsProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allTopTipsQuery,
    allTopTipsQueryVariables,
    allTopTipsProps<TChildProps, TDataName>
  >(allTopTipsDocument, {
    alias: 'allTopTips',
    ...operationOptions,
  });
}

/**
 * __useallTopTipsQuery__
 *
 * To run a query within a React component, call `useallTopTipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useallTopTipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallTopTipsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallTopTipsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allTopTipsQuery,
    allTopTipsQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<allTopTipsQuery, allTopTipsQueryVariables>(
    allTopTipsDocument,
    baseOptions,
  );
}
export function useallTopTipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allTopTipsQuery,
    allTopTipsQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allTopTipsQuery,
    allTopTipsQueryVariables
  >(allTopTipsDocument, baseOptions);
}
export type allTopTipsQueryHookResult = ReturnType<typeof useallTopTipsQuery>;
export type allTopTipsLazyQueryHookResult = ReturnType<
  typeof useallTopTipsLazyQuery
>;
export type allTopTipsQueryResult = ApolloReactCommon.QueryResult<
  allTopTipsQuery,
  allTopTipsQueryVariables
>;
export const TopTipDocument = gql`
  query TopTip($id: UUID!) {
    data: TopTip(id: $id) {
      ...AdminTopTipFields
    }
  }
  ${AdminTopTipFieldsFragmentDoc}
`;
export type TopTipComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    TopTipQuery,
    TopTipQueryVariables
  >,
  'query'
> &
  ({ variables: TopTipQueryVariables; skip?: boolean } | { skip: boolean });

export const TopTipComponent = (props: TopTipComponentProps) => (
  <ApolloReactComponents.Query<TopTipQuery, TopTipQueryVariables>
    query={TopTipDocument}
    {...props}
  />
);

export type TopTipProps<TChildProps = {}, TDataName extends string = 'data'> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    TopTipQuery,
    TopTipQueryVariables
  >;
} &
  TChildProps;
export function withTopTip<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    TopTipQuery,
    TopTipQueryVariables,
    TopTipProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    TopTipQuery,
    TopTipQueryVariables,
    TopTipProps<TChildProps, TDataName>
  >(TopTipDocument, {
    alias: 'topTip',
    ...operationOptions,
  });
}

/**
 * __useTopTipQuery__
 *
 * To run a query within a React component, call `useTopTipQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopTipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopTipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTopTipQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TopTipQuery,
    TopTipQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<TopTipQuery, TopTipQueryVariables>(
    TopTipDocument,
    baseOptions,
  );
}
export function useTopTipLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TopTipQuery,
    TopTipQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<TopTipQuery, TopTipQueryVariables>(
    TopTipDocument,
    baseOptions,
  );
}
export type TopTipQueryHookResult = ReturnType<typeof useTopTipQuery>;
export type TopTipLazyQueryHookResult = ReturnType<typeof useTopTipLazyQuery>;
export type TopTipQueryResult = ApolloReactCommon.QueryResult<
  TopTipQuery,
  TopTipQueryVariables
>;
export const updateTopTipDocument = gql`
  mutation updateTopTip($id: UUID!, $name: String) {
    data: updateTopTip(id: $id, name: $name) {
      ...AdminTopTipFields
    }
  }
  ${AdminTopTipFieldsFragmentDoc}
`;
export type updateTopTipMutationFn = ApolloReactCommon.MutationFunction<
  updateTopTipMutation,
  updateTopTipMutationVariables
>;
export type updateTopTipComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateTopTipMutation,
    updateTopTipMutationVariables
  >,
  'mutation'
>;

export const updateTopTipComponent = (props: updateTopTipComponentProps) => (
  <ApolloReactComponents.Mutation<
    updateTopTipMutation,
    updateTopTipMutationVariables
  >
    mutation={updateTopTipDocument}
    {...props}
  />
);

export type updateTopTipProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateTopTipMutation,
    updateTopTipMutationVariables
  >;
} &
  TChildProps;
export function withupdateTopTip<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateTopTipMutation,
    updateTopTipMutationVariables,
    updateTopTipProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateTopTipMutation,
    updateTopTipMutationVariables,
    updateTopTipProps<TChildProps, TDataName>
  >(updateTopTipDocument, {
    alias: 'updateTopTip',
    ...operationOptions,
  });
}

/**
 * __useupdateTopTipMutation__
 *
 * To run a mutation, you first call `useupdateTopTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateTopTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopTipMutation, { data, loading, error }] = useupdateTopTipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useupdateTopTipMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateTopTipMutation,
    updateTopTipMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateTopTipMutation,
    updateTopTipMutationVariables
  >(updateTopTipDocument, baseOptions);
}
export type updateTopTipMutationHookResult = ReturnType<
  typeof useupdateTopTipMutation
>;
export type updateTopTipMutationResult = ApolloReactCommon.MutationResult<updateTopTipMutation>;
export type updateTopTipMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateTopTipMutation,
  updateTopTipMutationVariables
>;
export const createTopTipDocument = gql`
  mutation createTopTip($name: String!, $isDefault: Boolean, $taskId: UUID) {
    data: createTopTip(name: $name, isDefault: $isDefault, taskId: $taskId) {
      ...AdminTopTipFields
    }
  }
  ${AdminTopTipFieldsFragmentDoc}
`;
export type createTopTipMutationFn = ApolloReactCommon.MutationFunction<
  createTopTipMutation,
  createTopTipMutationVariables
>;
export type createTopTipComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    createTopTipMutation,
    createTopTipMutationVariables
  >,
  'mutation'
>;

export const createTopTipComponent = (props: createTopTipComponentProps) => (
  <ApolloReactComponents.Mutation<
    createTopTipMutation,
    createTopTipMutationVariables
  >
    mutation={createTopTipDocument}
    {...props}
  />
);

export type createTopTipProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    createTopTipMutation,
    createTopTipMutationVariables
  >;
} &
  TChildProps;
export function withcreateTopTip<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    createTopTipMutation,
    createTopTipMutationVariables,
    createTopTipProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    createTopTipMutation,
    createTopTipMutationVariables,
    createTopTipProps<TChildProps, TDataName>
  >(createTopTipDocument, {
    alias: 'createTopTip',
    ...operationOptions,
  });
}

/**
 * __usecreateTopTipMutation__
 *
 * To run a mutation, you first call `usecreateTopTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateTopTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopTipMutation, { data, loading, error }] = usecreateTopTipMutation({
 *   variables: {
 *      name: // value for 'name'
 *      isDefault: // value for 'isDefault'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function usecreateTopTipMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    createTopTipMutation,
    createTopTipMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    createTopTipMutation,
    createTopTipMutationVariables
  >(createTopTipDocument, baseOptions);
}
export type createTopTipMutationHookResult = ReturnType<
  typeof usecreateTopTipMutation
>;
export type createTopTipMutationResult = ApolloReactCommon.MutationResult<createTopTipMutation>;
export type createTopTipMutationOptions = ApolloReactCommon.BaseMutationOptions<
  createTopTipMutation,
  createTopTipMutationVariables
>;
export const allStudentOrEmployerUsersDocument = gql`
  query allStudentOrEmployerUsers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: StintUserFilter
  ) {
    items: allStudentOrEmployerUsers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      firstName
      lastName
      fullname
      email
    }
    total: _allStudentOrEmployerUsersMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;
export type allStudentOrEmployerUsersComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >,
  'query'
>;

export const allStudentOrEmployerUsersComponent = (
  props: allStudentOrEmployerUsersComponentProps,
) => (
  <ApolloReactComponents.Query<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >
    query={allStudentOrEmployerUsersDocument}
    {...props}
  />
);

export type allStudentOrEmployerUsersProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >;
} &
  TChildProps;
export function withallStudentOrEmployerUsers<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables,
    allStudentOrEmployerUsersProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables,
    allStudentOrEmployerUsersProps<TChildProps, TDataName>
  >(allStudentOrEmployerUsersDocument, {
    alias: 'allStudentOrEmployerUsers',
    ...operationOptions,
  });
}

/**
 * __useallStudentOrEmployerUsersQuery__
 *
 * To run a query within a React component, call `useallStudentOrEmployerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useallStudentOrEmployerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useallStudentOrEmployerUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useallStudentOrEmployerUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >(allStudentOrEmployerUsersDocument, baseOptions);
}
export function useallStudentOrEmployerUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<
    allStudentOrEmployerUsersQuery,
    allStudentOrEmployerUsersQueryVariables
  >(allStudentOrEmployerUsersDocument, baseOptions);
}
export type allStudentOrEmployerUsersQueryHookResult = ReturnType<
  typeof useallStudentOrEmployerUsersQuery
>;
export type allStudentOrEmployerUsersLazyQueryHookResult = ReturnType<
  typeof useallStudentOrEmployerUsersLazyQuery
>;
export type allStudentOrEmployerUsersQueryResult = ApolloReactCommon.QueryResult<
  allStudentOrEmployerUsersQuery,
  allStudentOrEmployerUsersQueryVariables
>;
export const StintUserDocument = gql`
  query StintUser($id: UUID!) {
    mono: StintUser(id: $id) {
      ...AdminStintUserFields
    }
  }
  ${AdminStintUserFieldsFragmentDoc}
`;
export type StintUserComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    StintUserQuery,
    StintUserQueryVariables
  >,
  'query'
> &
  ({ variables: StintUserQueryVariables; skip?: boolean } | { skip: boolean });

export const StintUserComponent = (props: StintUserComponentProps) => (
  <ApolloReactComponents.Query<StintUserQuery, StintUserQueryVariables>
    query={StintUserDocument}
    {...props}
  />
);

export type StintUserProps<
  TChildProps = {},
  TDataName extends string = 'data'
> = {
  [key in TDataName]: ApolloReactHoc.DataValue<
    StintUserQuery,
    StintUserQueryVariables
  >;
} &
  TChildProps;
export function withStintUser<
  TProps,
  TChildProps = {},
  TDataName extends string = 'data'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    StintUserQuery,
    StintUserQueryVariables,
    StintUserProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withQuery<
    TProps,
    StintUserQuery,
    StintUserQueryVariables,
    StintUserProps<TChildProps, TDataName>
  >(StintUserDocument, {
    alias: 'stintUser',
    ...operationOptions,
  });
}

/**
 * __useStintUserQuery__
 *
 * To run a query within a React component, call `useStintUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useStintUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStintUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStintUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    StintUserQuery,
    StintUserQueryVariables
  >,
) {
  return ApolloReactHooks.useQuery<StintUserQuery, StintUserQueryVariables>(
    StintUserDocument,
    baseOptions,
  );
}
export function useStintUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    StintUserQuery,
    StintUserQueryVariables
  >,
) {
  return ApolloReactHooks.useLazyQuery<StintUserQuery, StintUserQueryVariables>(
    StintUserDocument,
    baseOptions,
  );
}
export type StintUserQueryHookResult = ReturnType<typeof useStintUserQuery>;
export type StintUserLazyQueryHookResult = ReturnType<
  typeof useStintUserLazyQuery
>;
export type StintUserQueryResult = ApolloReactCommon.QueryResult<
  StintUserQuery,
  StintUserQueryVariables
>;
export const updateStintUserDocument = gql`
  mutation updateStintUser(
    $id: UUID!
    $firstName: String
    $lastName: String
    $dateOfBirth: Date
    $email: String
    $secondaryEmail: String
    $exceptions: [StintTemplateExceptionInput]
    $phoneNumber: String
    $deactivated: Boolean
    $permanentDeactivated: Boolean
    $studentProfile: StudentProfileInput
    $paymentMethod: PaymentMethodInput
  ) {
    data: updateStintUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      dateOfBirth: $dateOfBirth
      email: $email
      secondaryEmail: $secondaryEmail
      exceptions: $exceptions
      phoneNumber: $phoneNumber
      deactivated: $deactivated
      permanentDeactivated: $permanentDeactivated
      studentProfile: $studentProfile
      paymentMethod: $paymentMethod
    ) {
      ...AdminStintUserFields
    }
  }
  ${AdminStintUserFieldsFragmentDoc}
`;
export type updateStintUserMutationFn = ApolloReactCommon.MutationFunction<
  updateStintUserMutation,
  updateStintUserMutationVariables
>;
export type updateStintUserComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    updateStintUserMutation,
    updateStintUserMutationVariables
  >,
  'mutation'
>;

export const updateStintUserComponent = (
  props: updateStintUserComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    updateStintUserMutation,
    updateStintUserMutationVariables
  >
    mutation={updateStintUserDocument}
    {...props}
  />
);

export type updateStintUserProps<
  TChildProps = {},
  TDataName extends string = 'mutate'
> = {
  [key in TDataName]: ApolloReactCommon.MutationFunction<
    updateStintUserMutation,
    updateStintUserMutationVariables
  >;
} &
  TChildProps;
export function withupdateStintUser<
  TProps,
  TChildProps = {},
  TDataName extends string = 'mutate'
>(
  operationOptions?: ApolloReactHoc.OperationOption<
    TProps,
    updateStintUserMutation,
    updateStintUserMutationVariables,
    updateStintUserProps<TChildProps, TDataName>
  >,
) {
  return ApolloReactHoc.withMutation<
    TProps,
    updateStintUserMutation,
    updateStintUserMutationVariables,
    updateStintUserProps<TChildProps, TDataName>
  >(updateStintUserDocument, {
    alias: 'updateStintUser',
    ...operationOptions,
  });
}

/**
 * __useupdateStintUserMutation__
 *
 * To run a mutation, you first call `useupdateStintUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateStintUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStintUserMutation, { data, loading, error }] = useupdateStintUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      email: // value for 'email'
 *      secondaryEmail: // value for 'secondaryEmail'
 *      exceptions: // value for 'exceptions'
 *      phoneNumber: // value for 'phoneNumber'
 *      deactivated: // value for 'deactivated'
 *      permanentDeactivated: // value for 'permanentDeactivated'
 *      studentProfile: // value for 'studentProfile'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useupdateStintUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    updateStintUserMutation,
    updateStintUserMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    updateStintUserMutation,
    updateStintUserMutationVariables
  >(updateStintUserDocument, baseOptions);
}
export type updateStintUserMutationHookResult = ReturnType<
  typeof useupdateStintUserMutation
>;
export type updateStintUserMutationResult = ApolloReactCommon.MutationResult<updateStintUserMutation>;
export type updateStintUserMutationOptions = ApolloReactCommon.BaseMutationOptions<
  updateStintUserMutation,
  updateStintUserMutationVariables
>;
